// import geopandas as gpd
// import json
// import numpy as np
// from shapely.geometry import LineString, MultiLineString

// def calculate_angle(p1, p2, p3):
//     # calculate the angle at point p2 formed by points p1, p2, p3 in degrees
//     v1 = np.array(p1) - np.array(p2)
//     v2 = np.array(p3) - np.array(p2)

//     dot_product = np.dot(v1, v2)
//     magnitude1 = np.linalg.norm(v1)
//     magnitude2 = np.linalg.norm(v2)

//     # avoid division by zero
//     if magnitude1 == 0 or magnitude2 == 0:
//         return 180

//     cos_angle = dot_product / (magnitude1 * magnitude2)
//     cos_angle = np.clip(cos_angle, -1.0, 1.0)
//     angle_rad = np.arccos(cos_angle)
//     angle_deg = np.degrees(angle_rad)

//     return angle_deg

// def smooth_sharp_corners(coords, min_angle_deg=1.0):
//     if len(coords) < 3:
//         return coords

//     smoothed = [coords[0]]

//     for i in range(1, len(coords) - 1):
//         prev_point = smoothed[-1]
//         current_point = coords[i]
//         next_point = coords[i + 1]

//         angle = calculate_angle(prev_point, current_point, next_point)

//         # if angle is too sharp, skip this point (effectively smoothing)
//         if angle >= min_angle_deg:
//             smoothed.append(current_point)
//         # could implement more sophisticated smoothing here
//         # such as averaging with neighboring points

//     smoothed.append(coords[-1])  # always keep last point
//     return smoothed

// def shp_to_coastline_coords(shp_file_path, output_file_path=None, simplify_tolerance=0.01, min_angle_deg=1.0):
//     # read the shapefile
//     print(f"Reading shapefile: {shp_file_path}")
//     gdf = gpd.read_file(shp_file_path)

//     print(f"Found {len(gdf)} features in the shapefile")
//     print(f"CRS: {gdf.crs}")

//     # ensure we're working in WGS84 (EPSG:4326) for longitude/latitude
//     if gdf.crs != 'EPSG:4326':
//         print("Converting to WGS84 (EPSG:4326)...")
//         gdf = gdf.to_crs('EPSG:4326')

//     coastline_coords = []
//     total_points_before = 0
//     total_points_after = 0

//     for idx, row in gdf.iterrows():
//         geometry = row.geometry

//         # simplify geometry to reduce number of points
//         if simplify_tolerance > 0:
//             geometry = geometry.simplify(simplify_tolerance)

//         if isinstance(geometry, LineString):
//             coords = list(geometry.coords)
//             if len(coords) > 1:
//                 total_points_before += len(coords)
//                 # corner smoothing
//                 smoothed_coords = smooth_sharp_corners(coords, min_angle_deg)
//                 total_points_after += len(smoothed_coords)
//                 coastline_coords.append(smoothed_coords)

//         elif isinstance(geometry, MultiLineString):
//             for line in geometry.geoms:
//                 coords = list(line.coords)
//                 if len(coords) > 1:  # Only add if we have at least 2 points
//                     total_points_before += len(coords)
//                     # Apply corner smoothing
//                     smoothed_coords = smooth_sharp_corners(coords, min_angle_deg)
//                     total_points_after += len(smoothed_coords)
//                     coastline_coords.append(smoothed_coords)
//         else:
//             print(f"Skipping geometry type: {type(geometry)}")

//     print(f"Extracted {len(coastline_coords)} coastline segments")
//     print(f"Points before smoothing: {total_points_before}")
//     print(f"Points after smoothing: {total_points_after}")
//     print(f"Reduction: {((total_points_before - total_points_after) / total_points_before * 100):.1f}%")

//     # save to file if requested
//     if output_file_path:
//         print(f"Saving to: {output_file_path}")
//         with open(output_file_path, 'w') as f:
//             json.dump(coastline_coords, f, indent=2)

//     return coastline_coords

// def format_for_jsx(coastline_coords, variable_name="coastlineData"):
//     jsx_output = f"export const {variable_name} = [\n"

//     for i, segment in enumerate(coastline_coords):
//         jsx_output += "    [\n"
//         for j, (lon, lat) in enumerate(segment):
//             jsx_output += f"        [{lon:.6f}, {lat:.6f}]"
//             if j < len(segment) - 1:
//                 jsx_output += ","
//             jsx_output += "\n"
//         jsx_output += "    ]"
//         if i < len(coastline_coords) - 1:
//             jsx_output += ","
//         jsx_output += "\n"

//     jsx_output += "];\n"
//     return jsx_output


// if __name__ == "__main__":
//     # path to your shapefile
//     # retrieved from https://www.naturalearthdata.com/downloads/
//     # currently using 1:10,000,000
//     shp_file = "ne_10m_coastline.shp"

//     try:
//         # Convert shapefile to coordinate lists
//         # - simplify_tolerance: 0.01 = moderate simplification, 0.001 = minimal, 0.1 = heavy
//         # - min_angle_deg: minimum angle in degrees (1.0 = very smooth, 10.0 = less smooth)
//         coastlines = shp_to_coastline_coords(
//             shp_file, 
//             output_file_path="coastline_coords.json",
//             # simplify_tolerance=0.1,
//             simplify_tolerance=0.1,
//             min_angle_deg=10.0 
//             # min_angle_deg=5.0  # Minimum 5 degree angles
//             # min_angle_deg=1.0  # Minimum 1 degree angles
//         )

//         # generate JSX format
//         jsx_code = format_for_jsx(coastlines, "detailedCoastlines")

//         # save JSX format
//         with open("coastlines.jsx", "w") as f:
//             f.write("// Generated coastline data from ne_10m_coastline.shp\n")
//             f.write("// Corner smoothing applied - minimum angle: 1.0 degrees\n")
//             f.write(jsx_code)

//         print("\nFiles created:")
//         print("- coastline_coords.json (JSON format)")
//         print("- coastlines.jsx (JSX format with corner smoothing)")
//         print("\nYou can now import detailedCoastlines in your React component!")

//     except FileNotFoundError:
//         print(f"Error: Could not find {shp_file}")
//         print("Make sure the shapefile is in the current directory")
//     except Exception as e:
//         print(f"Error processing shapefile: {e}")
//         print("Make sure you have geopandas and numpy installed:")
//         print("pip install geopandas numpy")

// Generated coastline data from ne_10m_coastline.shp
// Corner smoothing applied - minimum angle: 1.0 degrees
export const detailedCoastlines = [
    [
        [59.916026, -67.400486],
        [59.657481, -67.397231],
        [59.512950, -67.606378],
        [58.548839, -67.230239],
        [59.093761, -67.244724],
        [58.915863, -67.177504],
        [58.046886, -67.225030],
        [58.136485, -67.098403],
        [57.593516, -66.989923],
        [56.558442, -67.109796],
        [56.170665, -67.408949],
        [56.153494, -67.196059],
        [55.732188, -67.263604],
        [56.367198, -67.010186],
        [56.154063, -66.951837],
        [56.271658, -66.875665],
        [56.706798, -66.899672],
        [55.991873, -66.585707],
        [57.014659, -66.729262],
        [57.281423, -66.708754],
        [57.276052, -66.581231],
        [56.807791, -66.405450],
        [56.399099, -66.462660],
        [55.183442, -65.930922],
        [53.734548, -65.845880],
        [52.221690, -65.972914],
        [50.322032, -66.393813],
        [50.239513, -66.743097],
        [50.829845, -66.774672],
        [50.445811, -66.940118],
        [50.459321, -67.068780],
        [50.955414, -67.114028],
        [50.881196, -67.216241],
        [50.147716, -67.115330],
        [49.697520, -67.288507],
        [49.882823, -67.078220],
        [49.159923, -67.000909],
        [49.347504, -66.954685],
        [49.216482, -66.818943],
        [48.361095, -67.016371],
        [48.475841, -67.188084],
        [49.405284, -67.223321],
        [48.582042, -67.474786],
        [48.718110, -67.729262],
        [48.382660, -68.023370],
        [48.171153, -67.888849],
        [48.454600, -67.730157],
        [47.911306, -67.649021],
        [47.634451, -67.660333],
        [47.093761, -67.705173],
        [47.327159, -67.566502],
        [46.919607, -67.506524],
        [47.441091, -67.409438],
        [46.479991, -67.275323],
        [46.234548, -67.448663],
        [46.622732, -67.590020],
        [46.406016, -67.619399],
        [46.401622, -67.745375],
        [44.973155, -67.731134],
        [44.618012, -67.860447],
        [44.803233, -67.976332],
        [42.828624, -68.096449],
        [42.536143, -68.379571],
        [39.857921, -68.829522],
        [39.708995, -69.021173],
        [39.778656, -69.611423],
        [39.208832, -69.706638],
        [39.192638, -69.892511],
        [38.803559, -69.987726],
        [39.015880, -70.198337],
        [38.219737, -70.024021],
        [38.020193, -69.849379],
        [38.240733, -69.766534],
        [37.786306, -69.681899],
        [37.036306, -69.886651],
        [36.705740, -69.629815],
        [35.243988, -69.735610],
        [35.079356, -69.670587],
        [35.228770, -69.536716],
        [35.125499, -69.259535],
        [34.619965, -69.070733],
        [33.603689, -69.052423],
        [34.371267, -68.806329],
        [34.300629, -68.688165],
        [33.215994, -68.669610],
        [32.505707, -68.903090],
        [32.487641, -69.081638],
        [33.000499, -69.504815],
        [32.745291, -70.013442],
        [29.841156, -70.311293],
        [27.159353, -70.870701],
        [27.275076, -70.989679],
        [26.445649, -71.032403],
        [24.555186, -70.846775],
        [24.265310, -70.678643],
        [24.408865, -70.533949],
        [24.108897, -70.409438],
        [23.752452, -70.402602],
        [23.292654, -70.821222],
        [22.326915, -70.759454],
        [21.826427, -70.655043],
        [22.579275, -70.540216],
        [21.745616, -70.226170],
        [21.208507, -70.576430],
        [21.201182, -70.812188],
        [19.567393, -70.946059],
        [18.930919, -70.736017],
        [19.296641, -70.368097],
        [19.173513, -70.273858],
        [19.290538, -70.248142],
        [18.941661, -70.170994],
        [18.252778, -70.325942],
        [18.498220, -70.502537],
        [18.093761, -70.542413],
        [16.505138, -70.454197],
        [16.577322, -70.131443],
        [15.962576, -70.189630],
        [15.826915, -70.377618],
        [13.848806, -70.347833],
        [12.969249, -70.046157],
        [12.444591, -70.070245],
        [13.041026, -70.234470],
        [12.322032, -70.370294],
        [11.853526, -70.781508],
        [9.979259, -70.453546],
        [9.294281, -70.078790],
        [8.898448, -70.185479],
        [9.136729, -70.375421],
        [8.443126, -70.482354],
        [7.930431, -70.472345],
        [7.893565, -70.177423],
        [7.479015, -70.189874],
        [7.439220, -70.337498],
        [7.668305, -70.518162],
        [2.519705, -70.900567],
        [0.232188, -71.349867],
        [-0.518463, -71.765232],
        [-0.952138, -71.623630],
        [-0.812815, -71.377537],
        [-1.137563, -71.255304],
        [-1.395375, -71.443455],
        [-2.106801, -71.485447],
        [-2.677480, -71.257420],
        [-3.290151, -71.287205],
        [-3.492177, -71.522719],
        [-3.937164, -71.294122],
        [-6.149770, -71.366306],
        [-6.281117, -71.310642],
        [-5.566640, -70.841729],
        [-6.013580, -70.679783],
        [-6.429758, -70.737888],
        [-6.618276, -70.924005],
        [-7.912221, -70.843683],
        [-7.564198, -71.150567],
        [-7.779164, -71.494073],
        [-7.588694, -71.611993],
        [-8.162587, -71.576593],
        [-8.428619, -71.730401],
        [-8.746490, -71.700779],
        [-8.824208, -71.427504],
        [-9.126820, -71.415623],
        [-9.054514, -71.206720],
        [-10.266835, -70.931410],
        [-10.450063, -70.990981],
        [-9.988759, -71.119317],
        [-10.653472, -71.324965],
        [-10.600331, -71.527032],
        [-10.758127, -71.577407],
        [-11.806508, -71.259861],
        [-12.380727, -71.395440],
        [-11.987904, -71.679457],
        [-10.847157, -71.780857],
        [-11.032297, -72.048923],
        [-11.382965, -72.172133],
        [-11.239980, -72.176528],
        [-11.387522, -72.418064],
        [-13.379384, -72.836114],
        [-14.390736, -72.713149],
        [-13.895253, -72.986749],
        [-14.014638, -73.066339],
        [-13.916819, -73.105890],
        [-15.566558, -73.079278],
        [-16.543568, -73.468683],
        [-16.583241, -73.686293],
        [-15.825754, -73.788670],
        [-14.361806, -73.857680],
        [-15.302113, -74.221449],
        [-15.195546, -74.360528],
        [-17.570790, -74.369561],
        [-17.623158, -74.585219],
        [-17.965688, -74.637872],
        [-17.802154, -74.776544],
        [-18.873525, -75.249444],
        [-18.251373, -75.460219],
        [-20.399485, -75.472101],
        [-21.269643, -75.714288],
        [-24.213735, -75.756443],
        [-28.859120, -76.353285],
        [-31.696116, -76.976658],
        [-31.915028, -77.150811],
        [-32.500640, -77.126153],
        [-34.320546, -77.466404],
        [-34.773915, -77.687433],
        [-34.499664, -77.851983],
        [-35.312856, -77.844415],
        [-35.580963, -78.150486],
        [-36.021799, -78.215916],
        [-36.443756, -78.634047],
        [-36.251332, -78.851658],
        [-34.218129, -79.138116],
        [-32.820180, -79.243910],
        [-30.239166, -79.034275],
        [-29.941762, -79.111423],
        [-30.541493, -79.275079],
        [-29.541371, -79.280043],
        [-30.673248, -79.588067],
        [-24.256215, -79.715102],
        [-24.262034, -79.822361],
        [-31.319488, -80.308852],
        [-32.030507, -80.435235],
        [-33.464752, -80.497654],
        [-33.177561, -80.554620],
        [-33.476186, -80.615411],
        [-35.358388, -80.615330],
        [-35.466786, -80.648126],
        [-35.214955, -80.695408],
        [-37.230295, -81.089288],
        [-38.791127, -80.859552],
        [-41.587880, -81.340102],
        [-41.941396, -81.611423],
        [-43.165639, -81.886000],
        [-43.159779, -82.124688],
        [-44.011098, -82.391209],
        [-44.152984, -82.389337],
        [-44.013539, -82.262953],
        [-44.137074, -82.244724],
        [-45.520416, -82.526625],
        [-46.688791, -82.405450],
        [-45.948842, -82.125746],
        [-46.279205, -81.909763],
        [-47.255523, -82.072198],
        [-47.584584, -82.020440],
        [-47.263783, -81.969985],
        [-47.380442, -81.923517],
        [-48.380360, -81.890313],
        [-51.730621, -82.062595]
    ],
    [
        [-51.730621, -82.062595],
        [-53.924672, -82.206150],
        [-55.015492, -82.352309],
        [-55.224843, -82.517755],
        [-55.916127, -82.476983],
        [-59.469960, -83.460138],
        [-60.952260, -83.476251],
        [-61.113637, -83.447931],
        [-60.899648, -83.387953],
        [-61.851471, -83.367608],
        [-61.112538, -83.164809],
        [-60.974924, -83.005466],
        [-61.065745, -82.909763],
        [-61.932485, -82.972345],
        [-62.795033, -82.519708],
        [-65.072581, -82.406020],
        [-65.233469, -82.256931],
        [-66.030263, -82.311619],
        [-65.862701, -82.244806],
        [-66.062408, -82.195408],
        [-65.943715, -82.095798],
        [-65.629791, -81.986586],
        [-65.691721, -81.710545],
        [-63.878163, -81.600844],
        [-64.084381, -81.688897],
        [-62.207346, -81.692560],
        [-62.083608, -81.645685],
        [-62.211334, -81.592055],
        [-65.174306, -81.512302],
        [-68.371653, -81.110284],
        [-68.057118, -81.038263],
        [-68.448720, -80.977146],
        [-69.975819, -80.976007],
        [-70.397125, -80.823337],
        [-70.401519, -80.668064],
        [-70.820627, -80.610121],
        [-72.462310, -80.750421],
        [-72.588857, -80.961358],
        [-74.104237, -80.796157],
        [-75.554067, -80.891371],
        [-75.770904, -80.837579],
        [-74.949452, -80.770196],
        [-75.711985, -80.638116],
        [-75.414052, -80.488539],
        [-76.095082, -80.294122],
        [-76.274485, -80.081150],
        [-78.273183, -80.178155],
        [-76.632192, -79.939223],
        [-76.097646, -79.733575],
        [-75.924469, -79.542250],
        [-76.066274, -79.435317],
        [-76.532582, -79.312921],
        [-80.429351, -79.258477],
        [-80.492340, -79.577895],
        [-81.168528, -79.448175],
        [-81.319325, -79.298517],
        [-81.105702, -79.203383],
        [-83.253529, -78.772719],
        [-83.886138, -78.419366],
        [-83.681264, -78.327244],
        [-83.105336, -78.505141],
        [-82.944936, -78.473321],
        [-83.591298, -78.226251],
        [-83.767649, -77.968032],
        [-82.487050, -78.465753],
        [-80.295237, -78.846775],
        [-77.754018, -78.735772],
        [-77.329416, -78.597833],
        [-77.412506, -78.419610],
        [-81.667470, -77.841485],
        [-80.656890, -77.724867],
        [-80.769358, -77.669854],
        [-75.047353, -78.231622],
        [-74.055653, -78.137140],
        [-74.269439, -78.129164],
        [-73.465647, -78.014744],
        [-72.722279, -77.575616],
        [-75.080393, -77.437107],
        [-75.526601, -77.541192],
        [-76.999867, -77.036391],
        [-76.822336, -77.005466],
        [-77.523590, -76.729750],
        [-77.693471, -76.487563],
        [-76.708323, -76.674412],
        [-76.770497, -76.578709],
        [-76.541615, -76.516778],
        [-73.766591, -76.719008],
        [-73.936838, -76.653009],
        [-70.014027, -76.693617],
        [-69.827382, -76.613946],
        [-70.099517, -76.565199],
        [-69.816151, -76.522231],
        [-70.049916, -76.498712],
        [-70.180898, -76.450616],
        [-66.218617, -76.010837],
        [-63.161610, -75.409438],
        [-64.434438, -75.317560],
        [-63.040924, -75.147231],
        [-64.085601, -74.998630],
        [-63.076894, -74.908461],
        [-63.265696, -74.668145],
        [-62.701283, -74.677992],
        [-62.525990, -74.997247],
        [-61.792226, -74.778985],
        [-62.363881, -74.403497],
        [-60.977895, -74.497166],
        [-60.650014, -74.254002],
        [-61.856597, -74.328709],
        [-61.978098, -74.244236],
        [-61.133453, -74.164158],
        [-61.055776, -74.073175],
        [-61.859283, -74.029880],
        [-61.581939, -73.969903],
        [-61.791005, -73.906671],
        [-61.691965, -73.886163],
        [-60.986562, -73.955336],
        [-60.734731, -73.715753],
        [-61.145619, -73.737888],
        [-60.799550, -73.577895],
        [-61.687815, -73.535903],
        [-61.934804, -73.372166],
        [-61.568471, -73.353123],
        [-62.001820, -73.230564],
        [-61.646067, -73.252048],
        [-62.065094, -73.130466],
        [-61.229644, -73.201837],
        [-61.082753, -73.347426],
        [-60.877919, -73.241957],
        [-60.734446, -73.398045],
        [-60.598622, -73.184828],
        [-60.026601, -73.278985],
        [-59.949371, -72.895196],
        [-60.763539, -73.074477],
        [-60.491689, -72.791192],
        [-60.552398, -72.655857],
        [-61.136586, -72.783298],
        [-61.420277, -72.645766],
        [-61.215443, -72.638116],
        [-61.464670, -72.407322],
        [-60.642568, -72.429946],
        [-60.998036, -72.356215],
        [-60.687245, -72.230890],
        [-61.071889, -72.191339],
        [-60.688629, -72.120212],
        [-60.693837, -71.997817],
        [-61.166982, -72.169854],
        [-61.674306, -72.046563],
        [-62.254303, -72.135186],
        [-62.349110, -72.097589],
        [-62.112213, -72.009535],
        [-62.440907, -71.919610],
        [-60.797841, -71.781508],
        [-61.141265, -71.532892],
        [-61.557240, -71.690606],
        [-62.112213, -71.639825],
        [-61.129303, -71.414809],
        [-61.417388, -71.322524],
        [-60.983754, -71.366795],
        [-61.277415, -71.224379],
        [-60.934560, -71.182224],
        [-61.371205, -71.015720],
        [-61.305002, -70.856052],
        [-62.032582, -70.903009],
        [-62.129262, -70.723403],
        [-61.354237, -70.561130],
        [-62.144887, -70.552504],
        [-62.170277, -70.421563],
        [-62.407216, -70.405450],
        [-62.393463, -70.218845],
        [-61.868723, -70.208266],
        [-62.529652, -69.863946],
        [-62.397288, -69.515232],
        [-63.435536, -69.157973],
        [-63.303538, -69.055597],
        [-63.897084, -68.982599],
        [-63.212310, -68.838637],
        [-63.812896, -68.717950],
        [-63.760610, -68.580987],
        [-64.325836, -68.642185],
        [-64.033030, -68.831313],
        [-65.243804, -68.629490],
        [-65.347401, -68.533787],
        [-64.975697, -68.407810],
        [-65.493886, -68.317071],
        [-64.755849, -68.108087],
        [-65.760732, -68.165704],
        [-65.329172, -67.983819],
        [-65.706695, -67.859470],
        [-65.337473, -67.657973],
        [-65.588735, -67.554376],
        [-65.615956, -67.368910],
        [-64.749135, -67.307306],
        [-65.065907, -67.202081],
        [-64.690094, -67.148370],
        [-64.966298, -67.033868],
        [-64.963775, -66.896661],
        [-64.710520, -66.987074],
        [-64.773793, -66.845636],
        [-64.617909, -66.767836],
        [-64.515981, -66.904962],
        [-63.755523, -66.897638],
        [-64.134918, -66.643162],
        [-63.797027, -66.588474],
        [-63.911977, -66.502618],
        [-63.761301, -66.434991],
        [-63.903310, -66.381606],
        [-63.573354, -66.391209],
        [-63.874135, -66.272638],
        [-63.712148, -66.250421],
        [-63.811594, -66.188897],
        [-63.210846, -66.248712],
        [-62.643870, -66.724542],
        [-62.457916, -66.643324],
        [-62.703725, -66.580743],
        [-62.514475, -66.478204],
        [-62.760894, -66.316095],
        [-62.668284, -66.227472],
        [-61.970204, -66.198419],
        [-61.750885, -66.477716],
        [-61.780385, -66.212986],
        [-61.493520, -66.259861],
        [-61.468658, -66.114353],
        [-60.994740, -66.341485],
        [-60.875885, -66.187595],
        [-61.024078, -66.082778],
        [-60.708363, -66.130792],
        [-60.547109, -65.958266],
        [-61.006703, -65.912774],
        [-61.031239, -66.035903],
        [-61.275502, -65.912530],
        [-61.309071, -66.086602],
        [-61.647125, -66.033624],
        [-61.596018, -66.165623],
        [-62.022776, -66.111505],
        [-62.361887, -65.814223],
        [-61.700999, -65.545668],
        [-62.198313, -65.304457],
        [-61.627553, -65.241388],
        [-61.728749, -64.968683],
        [-61.051747, -65.010919],
        [-60.360911, -64.643650],
        [-60.421986, -64.524835],
        [-60.007314, -64.398370],
        [-59.591054, -64.587986],
        [-59.662180, -64.391534],
        [-59.463938, -64.310642],
        [-58.815785, -64.542739],
        [-58.949452, -64.357354],
        [-58.754547, -64.293390],
        [-59.107900, -64.227309],
        [-58.819895, -64.218683],
        [-58.704701, -63.994806],
        [-58.097727, -63.663995],
        [-57.420725, -63.561944],
        [-57.445383, -63.444431],
        [-57.126780, -63.503513],
        [-57.124420, -63.654474],
        [-56.775787, -63.603774],
        [-57.029408, -63.281020],
        [-57.286610, -63.214776],
        [-58.898549, -63.540216],
        [-58.936147, -63.669203],
        [-59.352284, -63.708591],
        [-59.429107, -63.909926],
        [-59.807444, -63.771661],
        [-59.969960, -63.958103],
        [-60.985666, -64.064548],
        [-60.840810, -64.164239],
        [-60.941721, -64.281915],
        [-61.582875, -64.442641],
        [-61.432281, -64.545587],
        [-61.605784, -64.532159],
        [-61.578847, -64.662042],
        [-61.805735, -64.492852],
        [-62.141835, -64.784845],
        [-62.495513, -64.598565],
        [-62.673818, -64.777276],
        [-62.407216, -64.876642],
        [-62.794097, -64.812677],
        [-63.233754, -64.965265],
        [-63.005442, -65.035414],
        [-63.083608, -65.166111],
        [-63.873891, -65.045994],
        [-64.079701, -65.165297],
        [-63.984486, -65.369887],
        [-64.089955, -65.413344],
        [-63.682281, -65.523858],
        [-63.795155, -65.605727],
        [-64.081899, -65.514825],
        [-64.226877, -65.553318],
        [-64.045074, -65.693129],
        [-64.478668, -65.631443],
        [-64.335276, -65.716567],
        [-64.671376, -65.752618],
        [-64.487701, -65.950453],
        [-64.584096, -66.033461],
        [-65.259755, -65.957452],
        [-65.090932, -66.150079],
        [-65.705474, -66.149998],
        [-65.872426, -66.298923],
        [-65.550364, -66.400160],
        [-65.766713, -66.601821],
        [-65.689361, -66.683689],
        [-66.547922, -66.650160],
        [-66.420318, -66.881931],
        [-66.614166, -67.038018],
        [-66.444163, -67.085382],
        [-66.462799, -67.336602],
        [-66.708852, -67.190525],
        [-66.980865, -67.276300],
        [-66.950673, -66.938897],
        [-67.476186, -67.054132],
        [-67.610748, -67.546970],
        [-66.510243, -67.527927],
        [-67.080312, -67.779880],
        [-66.767079, -67.775160],
        [-66.850575, -67.913670],
        [-67.268707, -67.968683],
        [-66.945872, -68.222833],
        [-66.625071, -68.246677],
        [-67.157094, -68.302179],
        [-66.860666, -68.367608],
        [-67.174713, -68.525323],
        [-66.959218, -68.748142],
        [-67.480702, -68.841892],
        [-66.759145, -69.071222],
        [-67.253041, -69.273045],
        [-67.392323, -69.502699],
        [-68.278879, -69.281345],
        [-68.308827, -69.403985],
        [-68.824859, -69.431329],
        [-68.361887, -69.683364],
        [-68.483754, -70.052667],
        [-67.949371, -70.311782],
        [-67.411122, -70.992852],
        [-67.622629, -71.433364],
        [-66.750844, -72.113051],
        [-67.511098, -72.834080],
        [-68.779693, -73.108005],
        [-73.073110, -73.444431],
        [-74.025299, -73.723891],
        [-75.268137, -73.621189],
        [-77.080800, -73.879327],
        [-77.242421, -73.812433],
        [-76.718251, -73.523533],
        [-78.844960, -73.608819],
        [-78.781890, -73.337986],
        [-79.647450, -73.038670],
        [-80.492543, -72.953302],
        [-80.650990, -73.084405],
        [-80.196848, -73.401951],
        [-81.234690, -73.247979],
        [-81.355458, -73.323826],
        [-81.086252, -73.594496],
        [-81.184682, -73.704197],
        [-82.137074, -73.889744],
        [-82.933705, -73.710382],
        [-83.809316, -73.741306],
        [-83.751698, -73.560235],
        [-85.101471, -73.487074],
        [-85.531606, -73.385349],
        [-85.678619, -73.177504],
        [-86.946523, -73.383559],
        [-87.349517, -73.169610],
        [-88.406890, -73.270603],
        [-88.714019, -73.119806],
        [-88.108754, -72.843357],
        [-88.173492, -72.732110],
        [-89.348500, -72.634535],
        [-89.054067, -72.929132],
        [-89.230295, -73.111261],
        [-91.077382, -73.336602],
        [-92.801381, -73.142755],
        [-95.842681, -73.331476],
        [-97.981191, -73.169366],
        [-97.717437, -73.025323],
        [-101.960317, -73.055597],
        [-102.716908, -72.997735],
        [-102.093984, -72.771742],
        [-102.328603, -72.738051],
        [-103.041412, -72.707615],
        [-103.429921, -72.849379],
        [-103.306711, -73.147149],
        [-102.873647, -73.308201],
        [-99.768056, -73.364190],
        [-99.405588, -73.486586],
        [-99.587717, -73.522638],
        [-98.814361, -73.632257],
        [-100.632069, -73.782159],
        [-102.998647, -73.609633],
        [-102.803944, -73.716974],
        [-102.848622, -73.921563],
        [-101.589223, -74.000177],
        [-101.295033, -74.274835],
        [-101.395904, -74.502699],
        [-99.800852, -74.536716],
        [-100.113433, -74.631036],
        [-99.919301, -74.769789],
        [-100.522288, -74.890883],
        [-99.438466, -74.913263],
        [-99.379709, -75.112726],
        [-98.402211, -75.236423],
        [-101.112701, -75.432061],
        [-101.656850, -75.305352],
        [-101.564198, -75.146742],
        [-101.760732, -75.082940],
        [-105.026479, -75.107843],
        [-106.591298, -75.378595],
        [-109.692860, -75.146091],
        [-111.364125, -75.234308],
        [-111.618723, -75.197361],
        [-110.294423, -74.781915],
        [-110.103139, -74.548598],
        [-110.554921, -74.244073],
        [-111.592641, -74.172459],
        [-111.904775, -74.282403],
        [-111.325551, -74.475518],
        [-111.926137, -74.551202],
        [-111.542633, -74.801528],
        [-114.238637, -75.053399],
        [-113.826731, -74.712986],
        [-114.357004, -74.695896],
        [-113.801259, -74.451837],
        [-113.685170, -74.296563],
        [-113.947825, -74.256443],
        [-113.439605, -74.099705],
        [-114.242340, -74.078302],
        [-113.951772, -73.914646],
        [-114.210032, -73.863458],
        [-115.124867, -74.094903],
        [-114.874338, -74.481622],
        [-115.649322, -74.530938],
        [-115.906728, -74.385431],
        [-116.693471, -74.557875],
        [-117.785756, -74.517511],
        [-117.970815, -74.258071],
        [-119.138254, -74.503351],
        [-118.616526, -74.522231],
        [-118.867055, -74.602472],
        [-121.772532, -74.786065],
        [-127.244740, -74.680108],
        [-129.975087, -74.913263],
        [-132.093129, -74.763279],
        [-133.865549, -74.928318],
        [-134.414703, -74.858982],
        [-134.586252, -74.736261],
        [-134.518625, -74.643243],
        [-135.419993, -74.565118],
        [-135.701812, -74.747328],
        [-136.834299, -74.760431],
        [-137.009877, -75.009861],
        [-137.742340, -75.060642],
        [-139.566640, -75.148045],
        [-140.277008, -75.432550],
        [-141.326527, -75.526788],
        [-140.646474, -75.807224],
        [-141.527170, -75.767511],
        [-141.861399, -75.521173],
        [-142.467030, -75.431736],
        [-142.679433, -75.561782],
        [-144.357249, -75.623956],
        [-143.971832, -75.696059],
        [-144.221303, -75.821222],
        [-146.209218, -75.915460],
        [-146.499623, -76.087009],
        [-148.197092, -76.087091],
        [-149.708974, -76.376723],
        [-148.452830, -76.506036],
        [-147.081695, -76.432794],
        [-145.462636, -76.751642],
        [-145.963612, -76.857517],
        [-145.309967, -77.058689],
        [-145.245961, -77.232354],
        [-145.953440, -77.233087],
        [-145.809804, -77.347914],
        [-145.955068, -77.363377],
        [-145.462799, -77.523207],
        [-146.375111, -77.503106],
        [-146.976186, -77.235935],
        [-147.661448, -77.423028],
        [-147.846832, -77.263767],
        [-148.769724, -77.104750],
        [-149.055531, -77.320245],
        [-147.758209, -77.461684],
        [-148.814687, -77.561456],
        [-148.673695, -77.674900],
        [-148.884511, -77.707208],
        [-149.245310, -77.757501],
        [-149.856801, -77.820082],
        [-152.350697, -77.302667],
        [-152.575429, -77.502048],
        [-153.862416, -77.442560],
        [-153.317209, -77.338149],
        [-155.865549, -77.059747],
        [-156.590281, -77.112400],
        [-156.833567, -77.187677],
        [-156.467112, -77.260675],
        [-157.021840, -77.358657],
        [-157.925404, -77.056329],
        [-158.300893, -77.105645],
        [-158.177480, -77.205824],
        [-158.329457, -77.342869],
        [-158.140207, -77.427911],
        [-158.286326, -77.513930],
        [-158.118113, -77.555841],
        [-158.639963, -77.848565],
        [-158.343861, -77.974379],
        [-157.199574, -78.252699],
        [-156.625234, -78.142836],
        [-153.815053, -78.233168],
        [-156.528269, -78.663670],
        [-154.969797, -79.034763],
        [-152.935007, -79.170099],
        [-151.720082, -79.083754],
        [-152.414174, -79.263930],
        [-148.999745, -79.860772],
        [-148.949900, -79.972589],
        [-150.369700, -80.074640],
        [-150.133738, -80.185724],
        [-150.803212, -80.245538],
        [-149.968251, -80.393731],
        [-148.257680, -80.636326],
        [-149.461659, -80.719171],
        [-156.450144, -81.148696],
        [-157.143300, -81.308689],
        [-153.816396, -81.681248],
        [-153.692372, -81.747003],
        [-154.838938, -81.944757],
        [-152.542917, -82.548110],
        [-155.058787, -82.801935],
        [-155.592234, -83.046075],
        [-156.917673, -83.230157],
        [-159.193430, -83.544366],
        [-162.169057, -83.524672],
        [-163.133982, -83.315525],
        [-164.617258, -83.506931],
        [-165.086293, -83.202081],
        [-169.734568, -83.244399],
        [-169.599680, -83.310479],
        [-170.719472, -83.196954],
        [-171.408315, -82.953790],
        [-170.956654, -83.261895],
        [-169.075673, -83.489190],
        [-167.677195, -83.744236],
        [-168.259511, -83.743585],
        [-168.082590, -83.779555],
        [-164.979604, -83.796482],
        [-163.702830, -84.049900],
        [-163.001088, -84.362970],
        [-157.637196, -84.897231],
        [-156.927480, -85.195245],
        [-158.163319, -85.164727],
        [-158.565053, -85.099298],
        [-158.465769, -85.155206],
        [-162.848948, -84.883071],
        [-167.441762, -84.867446],
        [-168.254709, -84.648207],
        [-180.000000, -84.352796]
    ],
    [
        [166.136974, -50.864353],
        [165.985688, -50.874607],
        [165.924083, -50.851251],
        [165.985525, -50.904392],
        [166.226329, -50.885431],
        [166.136974, -50.864353]
    ],
    [
        [-56.668324, -36.736423],
        [-57.558420, -38.120864],
        [-58.155670, -38.430108],
        [-61.143381, -39.001072],
        [-62.379750, -38.798435],
        [-62.325592, -39.254653],
        [-62.283925, -39.310724],
        [-62.050608, -39.474705],
        [-62.119456, -39.838311],
        [-62.305043, -39.811130],
        [-62.490061, -40.307875],
        [-62.264150, -40.551528],
        [-62.329742, -40.669122],
        [-62.181549, -40.626642],
        [-62.337799, -40.872735],
        [-63.053578, -41.147149],
        [-63.621816, -41.160903],
        [-64.911204, -40.823826],
        [-64.796213, -40.723321],
        [-65.131703, -40.842380],
        [-65.004994, -42.093194],
        [-64.480865, -42.254653],
        [-64.602284, -42.422052],
        [-64.445058, -42.446710],
        [-64.103586, -42.427830],
        [-64.068430, -42.269627],
        [-64.339711, -42.237400],
        [-63.768648, -42.077723],
        [-63.597971, -42.299981],
        [-63.620269, -42.751235],
        [-64.107900, -42.883722],
        [-64.437734, -42.506931],
        [-64.946034, -42.654229],
        [-64.997141, -42.784845],
        [-64.302113, -42.980890],
        [-64.943918, -43.239435],
        [-65.330800, -43.663344],
        [-65.216885, -44.366410],
        [-65.727100, -44.809605],
        [-65.521400, -44.931898],
        [-66.929266, -45.256534],
        [-67.624420, -46.130060],
        [-67.423220, -46.567419],
        [-66.786448, -47.006606],
        [-65.744902, -47.204164],
        [-65.845626, -47.742206],
        [-66.032064, -47.739525],
        [-65.901824, -47.769950],
        [-65.761952, -47.948552],
        [-67.556549, -49.015817],
        [-67.830881, -49.379571],
        [-67.607655, -49.265069],
        [-67.894927, -49.996875],
        [-68.341868, -50.117608],
        [-68.654042, -49.757908],
        [-68.739735, -49.727716],
        [-68.577272, -49.927616],
        [-68.583470, -49.970337],
        [-68.349873, -50.148810],
        [-68.876429, -50.330572],
        [-69.136800, -50.903481],
        [-69.167778, -50.978225],
        [-68.962554, -51.560154],
        [-69.377187, -51.556899],
        [-69.616811, -51.625177],
        [-68.973511, -51.619952],
        [-68.362472, -52.339072],
        [-69.234708, -52.203143],
        [-69.672351, -52.530857],
        [-70.863759, -52.721368],
        [-70.738840, -52.783868],
        [-70.889215, -52.913626],
        [-70.973622, -53.756036],
        [-71.285024, -53.886000],
        [-72.103871, -53.689060],
        [-72.453277, -53.407322],
        [-72.282297, -53.242771],
        [-72.080434, -53.329034],
        [-72.241689, -53.434503],
        [-72.092519, -53.422621],
        [-71.855621, -53.225356],
        [-71.789174, -53.441339],
        [-72.007965, -53.554295],
        [-71.814198, -53.520685],
        [-71.754465, -53.462498],
        [-71.742421, -53.223403],
        [-71.118764, -52.919636],
        [-71.398793, -52.728204],
        [-72.021962, -53.125421],
        [-72.286000, -53.029880],
        [-72.563140, -53.078871],
        [-72.191396, -53.180597],
        [-72.645131, -53.317804],
        [-72.364573, -53.536879],
        [-72.719553, -53.292576],
        [-72.795969, -53.173272],
        [-72.652577, -53.153416],
        [-72.933746, -53.104750],
        [-72.876088, -53.036391],
        [-72.960357, -52.824965],
        [-72.762441, -52.769789],
        [-72.703481, -52.707696],
        [-72.714833, -52.869399],
        [-72.431264, -52.856622],
        [-72.160874, -52.652118],
        [-71.478103, -52.646138],
        [-71.571611, -52.561278],
        [-72.309926, -52.516534],
        [-72.419260, -52.653009],
        [-72.549143, -52.591567],
        [-72.389638, -52.507582],
        [-72.858022, -52.502211],
        [-72.988352, -52.704278],
        [-72.673899, -52.652520],
        [-73.015614, -52.841729],
        [-72.979563, -53.054783],
        [-73.452870, -52.996677],
        [-73.204742, -52.896905],
        [-73.563710, -52.797052],
        [-73.233062, -52.790623],
        [-73.306630, -52.715427],
        [-73.003977, -52.558282],
        [-73.091624, -52.493829],
        [-73.194976, -52.429864],
        [-73.268910, -52.673598],
        [-73.393625, -52.544122],
        [-73.397328, -52.636489],
        [-73.699534, -52.714532],
        [-73.494862, -52.475518],
        [-73.666168, -52.424005],
        [-73.580556, -52.208429],
        [-73.735015, -52.029962],
        [-73.303049, -52.221775],
        [-72.997792, -52.064874],
        [-73.079254, -52.237074],
        [-72.866444, -52.256768],
        [-72.754872, -52.056817],
        [-72.883697, -52.198337],
        [-72.947377, -52.049737],
        [-72.802805, -51.937433],
        [-72.535878, -52.221775],
        [-72.930531, -52.448175],
        [-72.522206, -52.448337],
        [-72.637563, -52.397638],
        [-72.466949, -52.204278],
        [-72.669667, -51.961033],
        [-72.468984, -51.929295],
        [-72.466949, -51.789727],
        [-72.689036, -51.593438],
        [-73.090972, -51.420831],
        [-73.267649, -51.480564],
        [-73.280019, -51.606215],
        [-72.994537, -51.789727],
        [-73.207428, -51.879083],
        [-72.919423, -51.858575],
        [-73.223704, -52.091485],
        [-73.326772, -51.726983],
        [-73.386220, -51.652520],
        [-73.292836, -52.165704],
        [-73.563547, -52.039972],
        [-73.620920, -51.812188],
        [-73.399810, -52.015720],
        [-73.589182, -51.749607],
        [-73.718902, -51.775811],
        [-73.934316, -51.406020],
        [-73.611887, -51.625421],
        [-73.782826, -51.234796],
        [-73.682729, -51.275974],
        [-73.694081, -51.139255],
        [-74.129506, -51.187677],
        [-74.071441, -50.953709],
        [-73.803334, -50.960545],
        [-73.772939, -50.670668],
        [-73.474355, -50.672459],
        [-73.725087, -50.559503],
        [-74.042714, -50.822035],
        [-74.297353, -50.480645],
        [-73.879709, -50.542739],
        [-74.128896, -50.422947],
        [-74.252553, -50.440525],
        [-74.282704, -50.264907],
        [-74.439320, -50.357110],
        [-74.694651, -50.183038],
        [-74.347646, -50.086114],
        [-74.194407, -50.259698],
        [-73.857900, -50.289483],
        [-74.364858, -49.990330],
        [-73.885894, -50.076593],
        [-74.007680, -49.991388],
        [-73.906361, -49.856866],
        [-74.035959, -49.964776],
        [-74.324696, -49.871189],
        [-74.064036, -49.713556],
        [-74.322255, -49.632501],
        [-74.053822, -49.539321],
        [-73.727854, -49.781671],
        [-73.687856, -49.720310],
        [-74.123525, -49.422621],
        [-74.074452, -49.261651],
        [-73.963531, -49.329767],
        [-73.844879, -49.349786],
        [-74.043528, -49.082940],
        [-73.832875, -49.032159],
        [-74.057485, -49.012465],
        [-74.214915, -49.523126],
        [-74.422760, -49.384698],
        [-74.447906, -48.807794],
        [-74.057200, -48.740330],
        [-74.399770, -48.610528],
        [-74.197133, -48.473321],
        [-73.993479, -48.597263],
        [-74.028554, -48.448012],
        [-73.892690, -48.411310],
        [-74.270090, -48.335626],
        [-74.625409, -48.004227],
        [-74.344553, -48.020929],
        [-74.330922, -48.000421],
        [-73.769846, -48.027765],
        [-73.556264, -48.246840],
        [-73.351430, -48.219496],
        [-73.276682, -48.138360],
        [-73.281809, -48.079278],
        [-73.481801, -48.123305],
        [-73.653147, -47.898045],
        [-73.498525, -47.979913],
        [-73.235341, -47.986749],
        [-73.619008, -47.863865],
        [-73.721425, -47.527439],
        [-73.923695, -47.842706],
        [-74.735585, -47.718683],
        [-74.556711, -47.550063],
        [-74.344553, -47.636651],
        [-74.481760, -47.698826],
        [-74.205068, -47.756606],
        [-74.303578, -47.678318],
        [-74.043528, -47.609470],
        [-74.528554, -47.431736],
        [-74.324696, -47.218927],
        [-73.973500, -47.254978],
        [-73.941274, -47.027927],
        [-74.153228, -46.967218],
        [-74.126088, -46.828546],
        [-74.477651, -46.772393],
        [-74.673492, -46.849054],
        [-74.479156, -46.902276],
        [-74.680979, -46.883884],
        [-74.815256, -46.768487],
        [-75.006500, -46.753513],
        [-75.083363, -46.640883],
        [-74.934193, -46.437595],
        [-75.201731, -46.629978],
        [-75.414866, -46.632745],
        [-75.575063, -46.687921],
        [-75.661041, -46.767185],
        [-75.422475, -46.713962],
        [-75.410553, -46.931573],
        [-75.711415, -46.744399],
        [-75.201731, -46.300958],
        [-75.105784, -46.347101],
        [-75.029775, -46.341974],
        [-75.090688, -46.216078],
        [-74.777211, -46.212172],
        [-74.665598, -45.823337],
        [-74.464711, -46.022149],
        [-74.359609, -45.790297],
        [-74.103139, -45.836847],
        [-74.167063, -46.136407],
        [-74.061350, -45.980890],
        [-73.970570, -46.084161],
        [-74.313222, -46.249933],
        [-74.049713, -46.191095],
        [-74.077707, -46.322035],
        [-73.844879, -46.341974],
        [-74.019276, -46.204360],
        [-73.881825, -46.141778],
        [-73.773061, -46.320896],
        [-73.989166, -46.559747],
        [-73.851715, -46.595147],
        [-73.687856, -46.322035],
        [-73.560211, -45.829767],
        [-73.591664, -45.780206],
        [-73.510854, -45.451755],
        [-73.226430, -45.300877],
        [-73.014312, -45.444757],
        [-72.830637, -45.418064],
        [-73.216298, -45.258884],
        [-73.462636, -45.246189],
        [-73.304433, -45.144789],
        [-73.385813, -44.973728],
        [-72.727651, -44.758559],
        [-72.597971, -44.505304],
        [-72.591135, -44.340753],
        [-72.721913, -44.501397],
        [-73.290028, -44.152439],
        [-73.116119, -44.085707],
        [-73.012685, -43.772149],
        [-72.824615, -43.807875],
        [-72.847157, -43.679457],
        [-73.055247, -43.715590],
        [-72.905832, -43.607680],
        [-73.084584, -43.316339],
        [-72.864858, -43.018731],
        [-72.734486, -43.079685],
        [-72.840321, -42.524835],
        [-72.539418, -42.558282],
        [-72.843739, -42.278253],
        [-72.594553, -42.182061],
        [-72.419789, -42.439630],
        [-72.464345, -41.976170],
        [-72.888580, -41.910821],
        [-72.303090, -41.648207],
        [-72.303090, -41.380792],
        [-72.584299, -41.709731],
        [-72.947377, -41.483168],
        [-73.201405, -41.784763],
        [-73.759946, -41.748841],
        [-73.696632, -41.637125],
        [-73.554758, -41.608494],
        [-73.494862, -41.510431],
        [-73.806803, -41.556233],
        [-73.946904, -40.972841],
        [-73.728498, -40.544180],
        [-73.711171, -39.968683],
        [-73.378774, -39.900486],
        [-73.224477, -39.417250],
        [-73.543284, -38.420668],
        [-73.462961, -38.051202],
        [-73.668080, -37.719415],
        [-73.644643, -37.201430],
        [-73.209055, -37.160252],
        [-73.207428, -36.775323],
        [-73.118642, -36.597101],
        [-72.988026, -36.702569],
        [-72.505238, -35.448012]
    ],
    [
        [-51.079385, 3.492087],
        [-50.679270, 2.171698],
        [-50.779693, 2.070950],
        [-50.619555, 2.105238],
        [-50.466542, 1.815416],
        [-49.950597, 1.721326],
        [-49.883026, 1.307714],
        [-50.149741, 1.221209],
        [-49.890045, 1.165229],
        [-50.790639, 0.169501],
        [-51.326975, -0.079522],
        [-51.934560, -1.339532],
        [-52.279124, -1.518243],
        [-52.203969, -1.690199],
        [-50.839589, -0.912774],
        [-50.956410, -1.128513],
        [-50.654693, -1.737970],
        [-50.879803, -1.851951],
        [-50.844215, -1.955301],
        [-50.610581, -1.814203],
        [-50.415761, -2.073175],
        [-49.976918, -1.826104],
        [-49.812489, -2.108005],
        [-49.846588, -1.901788],
        [-49.592763, -2.011651],
        [-49.654775, -1.895115],
        [-49.422027, -1.778985],
        [-49.619862, -2.670180],
        [-48.965589, -1.599719],
        [-48.856369, -1.559031],
        [-48.656946, -1.383380],
        [-48.428334, -1.662286],
        [-48.482900, -1.511407],
        [-48.325307, -1.470473],
        [-48.496571, -1.461358],
        [-48.482753, -1.281300],
        [-48.250152, -1.189386],
        [-48.111562, -0.724542],
        [-47.962148, -0.781834],
        [-47.809071, -0.565167],
        [-47.728668, -0.756524],
        [-47.584514, -0.578247],
        [-47.496693, -0.764744],
        [-47.393056, -0.812595],
        [-47.461903, -0.592869],
        [-47.294016, -0.592869],
        [-47.139760, -0.798923],
        [-47.077545, -0.665704],
        [-47.057200, -0.867120],
        [-46.969106, -0.695896],
        [-46.922231, -0.834568],
        [-46.963002, -0.865004],
        [-46.947377, -0.901300],
        [-46.831288, -0.709568],
        [-46.749379, -0.942966],
        [-46.613796, -0.813236],
        [-46.611318, -0.924005],
        [-46.667388, -0.922459],
        [-46.737457, -0.984308],
        [-46.749379, -1.018650],
        [-46.427629, -0.868550],
        [-46.475006, -1.045343],
        [-46.248443, -1.093683],
        [-46.262115, -1.183201],
        [-46.101674, -1.073337],
        [-46.050445, -1.210382],
        [-45.979454, -1.055084],
        [-45.948069, -1.251397],
        [-45.867487, -1.063471],
        [-45.899648, -1.257582],
        [-45.810902, -1.326430],
        [-45.701039, -1.134698],
        [-45.675535, -1.366316],
        [-45.408518, -1.296808],
        [-45.542714, -1.490981],
        [-45.460805, -1.546157],
        [-45.326161, -1.312921],
        [-45.323638, -1.744806],
        [-45.163197, -1.482843],
        [-44.967356, -1.594008],
        [-44.861195, -1.426935],
        [-44.933827, -1.655450],
        [-44.822906, -1.575860],
        [-44.821929, -1.759210],
        [-44.707875, -1.717462],
        [-44.810374, -1.813165],
        [-44.598012, -1.744806],
        [-44.488149, -1.987481],
        [-44.824045, -2.279229],
        [-44.665639, -2.270929],
        [-44.720937, -2.402114],
        [-44.652699, -2.429457],
        [-44.461659, -2.144627],
        [-44.362457, -2.310317],
        [-44.655995, -2.593194],
        [-44.540395, -2.538263],
        [-44.796010, -3.300226],
        [-44.432973, -2.950291],
        [-44.292633, -2.481052],
        [-44.034413, -2.415216],
        [-44.348500, -2.810235],
        [-44.186513, -2.759047],
        [-44.200185, -2.868910],
        [-43.923248, -2.546808],
        [-43.537343, -2.435968],
        [-43.452870, -2.552911],
        [-43.426298, -2.337850],
        [-42.239410, -2.834161],
        [-41.838565, -2.729480],
        [-41.244537, -3.015232],
        [-41.256907, -2.875177],
        [-39.985707, -2.848403],
        [-38.477406, -3.697442],
        [-37.182932, -4.910903],
        [-36.544423, -5.127618],
        [-35.997182, -5.047540],
        [-35.403798, -5.226495],
        [-34.982289, -6.391371],
        [-34.914662, -7.130548],
        [-34.825795, -6.984470],
        [-34.804799, -7.514093],
        [-34.928944, -7.555759],
        [-34.811635, -7.932550],
        [-35.305084, -9.193048],
        [-35.696156, -9.672947],
        [-35.963043, -9.610772],
        [-35.810618, -9.744806],
        [-36.408070, -10.502130],
        [-36.903066, -10.772882],
        [-37.138295, -11.125909],
        [-37.275136, -11.022719],
        [-37.149159, -11.187433],
        [-37.330068, -11.420668],
        [-37.402455, -11.399672],
        [-37.272084, -11.249444],
        [-37.299387, -11.194757],
        [-37.470082, -11.358657],
        [-37.491851, -11.516290],
        [-37.368235, -11.473810],
        [-38.050893, -12.641046],
        [-38.509674, -13.021417],
        [-38.508901, -12.722914],
        [-38.690989, -12.571466],
        [-38.806630, -12.835138],
        [-38.861684, -12.654067],
        [-38.923695, -12.736586],
        [-38.853993, -12.851251],
        [-38.724477, -12.873224],
        [-39.039784, -13.332452],
        [-39.115549, -13.599379],
        [-39.011830, -13.497003],
        [-38.979970, -13.835870],
        [-39.091624, -13.712660],
        [-39.148752, -13.736912],
        [-38.994456, -13.863458],
        [-39.074534, -13.894220],
        [-38.979563, -14.061130],
        [-39.071034, -14.076349],
        [-39.074534, -14.140558],
        [-39.039784, -14.175388],
        [-39.063385, -14.109959],
        [-38.957265, -14.066095],
        [-38.929921, -13.897638],
        [-38.923695, -14.004083],
        [-39.067128, -14.674981],
        [-38.861684, -15.854262],
        [-39.208608, -17.162205],
        [-39.137115, -17.679620],
        [-39.659413, -18.273614],
        [-39.786204, -19.601983],
        [-40.026845, -19.764418],
        [-40.232777, -20.266778],
        [-40.369293, -20.232680],
        [-40.259511, -20.321466],
        [-40.348744, -20.500095],
        [-40.758463, -20.864194],
        [-41.057240, -21.483819],
        [-40.995269, -22.014255],
        [-41.966298, -22.535414],
        [-41.869781, -22.752130],
        [-42.013539, -22.981703],
        [-43.031402, -22.974298],
        [-43.075551, -22.665704],
        [-43.270172, -22.747003],
        [-43.170766, -22.969822],
        [-43.560374, -23.067478],
        [-43.603749, -23.007745],
        [-43.850168, -22.892267],
        [-44.186391, -23.049005],
        [-44.411366, -22.937433],
        [-44.700510, -23.107680],
        [-44.501210, -23.296482],
        [-45.412994, -23.617852],
        [-45.426666, -23.830743],
        [-45.864369, -23.756443],
        [-46.287668, -24.021173],
        [-46.385406, -23.873468],
        [-46.376047, -24.024509],
        [-48.051584, -25.036798],
        [-47.887074, -25.057306],
        [-48.209055, -25.457615],
        [-48.127309, -25.279962],
        [-48.332753, -25.358331],
        [-48.325307, -25.228611],
        [-48.455678, -25.248468],
        [-48.472727, -25.475681],
        [-48.743031, -25.352146],
        [-48.710846, -25.496352],
        [-48.361195, -25.570977],
        [-48.541005, -25.845473],
        [-48.563466, -25.865818],
        [-48.592519, -26.183852],
        [-48.733795, -26.224705],
        [-48.796457, -26.068455],
        [-48.798248, -26.304864],
        [-48.607900, -26.436700],
        [-48.607167, -27.104425],
        [-48.476145, -27.153985],
        [-48.619985, -27.246677],
        [-48.635894, -28.230157],
        [-48.761220, -28.487400],
        [-48.756093, -28.528416],
        [-49.810658, -29.443129],
        [-50.721425, -31.044529],
        [-52.077382, -32.167250],
        [-52.087270, -31.827813],
        [-51.836334, -31.854913],
        [-51.244985, -31.464044],
        [-51.161855, -31.077732],
        [-50.975942, -31.130955],
        [-50.978424, -30.893324],
        [-50.692616, -30.726495],
        [-50.725657, -30.363051],
        [-50.565012, -30.450128],
        [-50.614817, -30.186212],
        [-50.936391, -30.431573],
        [-51.283518, -30.007420],
        [-51.326975, -30.224542],
        [-51.090647, -30.351983],
        [-51.250478, -30.462335],
        [-51.269683, -30.781834],
        [-51.377105, -30.642267],
        [-51.443023, -31.080987],
        [-51.963531, -31.332289],
        [-52.007924, -31.646173],
        [-52.083323, -31.558689],
        [-52.218617, -31.740655],
        [-52.133860, -31.930841],
        [-52.258616, -32.053643],
        [-52.081410, -32.031996],
        [-52.091176, -32.166111],
        [-52.621693, -33.101983],
        [-53.450917, -33.801528],
        [-53.764882, -34.390395],
        [-54.145904, -34.667576],
        [-54.259674, -34.685968],
        [-54.238596, -34.589776],
        [-54.328603, -34.561782],
        [-54.306467, -34.707696],
        [-54.958608, -34.973403],
        [-55.693448, -34.764741],
        [-56.156088, -34.941188],
        [-57.151964, -34.450932],
        [-57.855354, -34.470967],
        [-58.434641, -33.784926],
        [-58.366933, -33.153741],
        [-58.137766, -33.095147],
        [-58.048492, -32.911716],
        [-58.200429, -32.444594],
        [-58.146799, -33.049981],
        [-58.430165, -33.102634],
        [-58.549224, -33.705336],
        [-58.378570, -34.188246],
        [-58.570424, -34.288181],
        [-58.315031, -34.657195],
        [-57.248769, -35.248793],
        [-57.128144, -35.441321],
        [-57.366444, -35.987888],
        [-56.939198, -36.384861],
        [-56.740590, -36.316583],
        [-56.668324, -36.736423]
    ],
    [
        [-80.759348, -33.766778],
        [-80.704701, -33.766778],
        [-80.740834, -33.685154],
        [-80.777333, -33.734470],
        [-80.759348, -33.766778]
    ],
    [
        [-78.788971, -33.609063],
        [-78.884877, -33.575616],
        [-78.991689, -33.656915],
        [-78.757639, -33.643243],
        [-78.788971, -33.609063]
    ],
    [
        [-109.231597, -27.092462],
        [-109.379628, -27.059503],
        [-109.451324, -27.195489],
        [-109.243560, -27.129164],
        [-109.231597, -27.092462]
    ],
    [
        [163.985118, -20.047621],
        [163.967133, -20.008071],
        [163.949718, -20.002211],
        [163.947113, -20.066013],
        [163.985118, -20.047621]
    ],
    [
        [128.158865, -15.090265],
        [128.186778, -15.190199],
        [128.194509, -15.126886],
        [128.158865, -15.090265]
    ],
    [
        [128.416189, -14.956231],
        [128.384939, -14.891697],
        [128.353770, -14.869236],
        [128.440684, -15.038751],
        [128.416189, -14.956231]
    ],
    [
        [129.632498, -14.846938],
        [129.616466, -14.824884],
        [129.583018, -14.803806],
        [129.611827, -14.867364],
        [129.632498, -14.846938]
    ],
    [
        [129.533458, -14.798517],
        [129.501964, -14.798517],
        [129.591482, -14.963637],
        [129.587087, -14.883477],
        [129.533458, -14.798517]
    ],
    [
        [126.500987, -13.873712],
        [126.515147, -13.904880],
        [126.610850, -13.901056],
        [126.553966, -13.875258],
        [126.500987, -13.873712]
    ],
    [
        [-38.944203, -13.394627],
        [-39.045888, -13.458185],
        [-38.902013, -13.671812],
        [-38.896352, -13.453546],
        [-38.944203, -13.394627]
    ],
    [
        [-38.614613, -12.924981],
        [-38.697133, -12.880548],
        [-38.786529, -13.133884],
        [-38.587473, -12.986912],
        [-38.614613, -12.924981]
    ],
    [
        [134.885265, -12.057550],
        [134.854259, -12.037774],
        [134.907970, -12.117852],
        [134.926280, -12.068129],
        [134.885265, -12.057550]
    ],
    [
        [134.965256, -12.026465],
        [134.956246, -12.016469],
        [134.908472, -12.022625],
        [134.948729, -12.054669],
        [134.965256, -12.026465]
    ],
    [
        [44.254731, -20.376072],
        [44.473888, -19.986261],
        [44.370860, -19.774021],
        [44.479747, -19.483982],
        [44.234386, -19.088800],
        [43.924001, -17.546482],
        [44.430675, -16.700372],
        [44.444672, -16.195733],
        [44.868337, -16.220880],
        [45.266368, -15.923923],
        [45.297862, -16.111993],
        [45.379405, -15.973810],
        [45.604747, -16.051853],
        [45.660899, -15.803806],
        [46.066091, -15.861912],
        [46.144216, -15.703709],
        [46.331065, -15.977227],
        [46.468761, -15.956720],
        [46.299001, -15.815688],
        [46.332693, -15.630141],
        [46.949474, -15.198419],
        [47.074718, -15.323989],
        [46.958263, -15.549574],
        [47.232107, -15.433282],
        [47.055919, -15.193617],
        [47.444835, -14.671563],
        [47.427745, -15.107599],
        [47.797130, -14.566339],
        [48.000255, -14.762302],
        [48.013031, -14.630060],
        [47.803884, -14.545587],
        [47.752940, -14.600518],
        [47.701508, -14.446384],
        [47.920095, -14.086033],
        [48.033946, -14.262384],
        [47.904307, -13.603204],
        [48.068370, -13.517348],
        [48.298676, -13.798272],
        [48.333344, -13.546319],
        [48.534190, -13.520766],
        [48.482270, -13.360447],
        [48.780121, -13.383884],
        [48.955333, -12.811700],
        [48.729991, -12.434991],
        [48.945811, -12.479913],
        [49.278087, -11.947686],
        [49.373057, -12.198175],
        [49.229666, -12.222101],
        [49.539399, -12.378188],
        [49.654796, -12.804864],
        [49.744151, -12.743422],
        [49.942149, -13.033868],
        [50.209727, -14.750665],
        [50.483409, -15.443455],
        [50.168142, -15.984633],
        [49.901134, -15.422296],
        [49.638438, -15.544610],
        [49.689789, -16.086847],
        [49.849864, -16.240818],
        [49.724946, -16.754002],
        [49.840343, -16.827569],
        [49.608409, -16.896580],
        [49.431326, -17.283868],
        [49.509613, -17.727716],
        [49.359223, -18.424005],
        [47.900645, -22.481134],
        [47.568696, -23.852634],
        [46.964692, -25.065688],
        [45.162608, -25.598565],
        [44.028819, -24.998956],
        [43.672862, -24.334893],
        [43.624766, -23.761895],
        [43.761241, -23.463800],
        [43.361176, -22.843194],
        [43.222911, -22.254815],
        [43.507498, -21.309503],
        [43.812755, -21.224298],
        [44.254731, -20.376072]
    ],
    [
        [135.121962, -11.929696],
        [135.053888, -11.919437],
        [135.046072, -11.941502],
        [135.057697, -11.953185],
        [135.121962, -11.929696]
    ],
    [
        [133.408702, -11.592055],
        [133.359548, -11.617364],
        [133.360199, -11.660333],
        [133.484386, -11.601983],
        [133.408702, -11.592055]
    ],
    [
        [133.476899, -11.454848],
        [133.395030, -11.489028],
        [133.395030, -11.544203],
        [133.510997, -11.503188],
        [133.476899, -11.454848]
    ],
    [
        [134.195649, -32.495864],
        [133.864431, -32.546808],
        [133.949962, -32.389418],
        [133.649181, -32.101658],
        [133.270844, -32.218845],
        [132.776215, -31.950860],
        [132.233735, -32.032973],
        [131.177501, -31.477634],
        [129.200450, -31.656427],
        [127.288748, -32.273370],
        [125.977449, -32.284340],
        [124.201182, -33.038018],
        [123.952485, -33.567315],
        [123.526622, -33.938653],
        [123.154633, -34.009454],
        [123.023123, -33.860610],
        [122.094737, -34.019138],
        [122.005707, -33.820733],
        [121.333751, -33.815199],
        [120.002208, -33.926039],
        [119.572032, -34.142022],
        [119.559255, -34.383722],
        [119.229991, -34.532159],
        [118.839854, -34.452569],
        [118.199392, -35.016778],
        [117.835460, -35.031427],
        [117.932872, -35.120375],
        [116.637869, -35.050226],
        [116.387543, -34.857517],
        [115.978526, -34.835626],
        [115.612315, -34.445896],
        [115.010427, -34.245050],
        [114.988536, -33.521091],
        [115.367198, -33.631280],
        [115.710134, -33.270685],
        [115.600922, -32.661716],
        [115.700938, -32.512953],
        [115.639659, -32.656915],
        [115.714122, -32.780450],
        [115.721528, -31.772638],
        [115.060802, -30.522393],
        [114.842459, -29.108575],
        [114.166026, -28.106703],
        [114.012543, -27.315362],
        [113.156980, -26.151926],
        [113.275971, -26.234857],
        [113.306224, -25.996651],
        [113.327998, -26.274896],
        [113.384270, -26.382755],
        [113.362674, -26.012815],
        [113.565507, -26.565081],
        [113.625147, -26.439997],
        [113.669586, -26.652893],
        [113.870286, -26.522130],
        [113.884773, -26.342673],
        [113.577239, -26.089343],
        [113.420781, -25.728215],
        [113.515250, -25.509337],
        [113.756951, -25.885217],
        [113.728004, -26.197035],
        [113.854503, -25.944268],
        [114.021534, -26.390888],
        [114.234371, -26.316584],
        [114.258556, -25.841892],
        [113.692149, -25.105239],
        [113.391449, -24.413670],
        [113.459727, -23.910333],
        [113.768809, -23.457696],
        [113.807384, -22.930597],
        [113.646658, -22.577732],
        [114.035818, -21.837823],
        [114.176036, -21.822198],
        [114.122406, -22.504164],
        [114.356944, -22.486017],
        [114.646739, -21.843357],
        [115.478526, -21.501153],
        [116.196300, -20.846856],
        [116.790863, -20.534926],
        [116.855479, -20.712091],
        [117.736339, -20.658461],
        [118.150890, -20.356134],
        [118.805675, -20.281020],
        [119.095470, -19.966729],
        [119.589854, -20.065851],
        [121.128266, -19.520685],
        [121.811046, -18.462579],
        [122.347016, -18.121189],
        [122.344086, -17.983005],
        [122.169770, -17.978285],
        [122.172048, -17.261163],
        [122.472911, -16.920180],
        [122.594981, -16.970961],
        [122.582367, -16.779555],
        [122.820974, -16.779718],
        [122.758800, -16.604425],
        [122.916189, -16.415948],
        [123.020274, -16.382582],
        [122.959809, -16.580336],
        [123.570811, -17.595147],
        [123.594981, -16.985121],
        [123.913341, -17.215590],
        [123.794607, -17.000095],
        [123.953298, -16.828546],
        [123.792491, -16.890720],
        [123.509939, -16.653904],
        [123.609223, -16.546319],
        [123.424164, -16.491143],
        [123.711681, -16.429783],
        [123.570160, -16.176935],
        [123.806895, -16.191095],
        [123.863048, -16.429783],
        [123.992849, -16.377862],
        [123.910899, -16.217462],
        [124.222667, -16.395603],
        [124.386078, -16.351170],
        [124.473643, -16.393324],
        [124.839692, -16.425714],
        [124.903982, -16.402439],
        [124.401541, -16.329278],
        [124.434337, -16.057794],
        [124.596202, -16.115004],
        [124.732677, -15.806573],
        [124.486339, -15.998305],
        [124.376475, -15.525323],
        [124.682628, -15.473891],
        [124.663748, -15.250421],
        [125.185232, -15.517836],
        [125.144298, -15.313084],
        [124.885265, -15.296808],
        [125.055431, -15.162286],
        [124.869884, -15.250421],
        [124.841970, -15.141209],
        [125.072276, -14.968520],
        [125.165294, -15.162286],
        [125.145763, -15.028009],
        [125.165294, -15.011407],
        [125.288259, -15.140558],
        [125.432140, -15.137953],
        [125.135997, -14.735935],
        [125.347667, -14.498712],
        [125.439464, -14.638849],
        [125.589203, -14.545343],
        [125.618175, -14.223728],
        [125.733165, -14.270929],
        [125.732921, -14.398533],
        [125.918142, -14.637791],
        [126.144786, -14.195245],
        [125.972830, -14.021417],
        [126.086436, -13.889418],
        [126.288829, -14.230076],
        [126.527517, -13.928969],
        [126.453298, -14.077569],
        [126.603526, -14.230076],
        [126.863536, -13.743341],
        [127.129731, -13.967706],
        [127.418468, -13.941990],
        [128.231293, -14.718194],
        [128.125173, -15.182061],
        [128.289317, -15.401788],
        [128.195811, -15.056817],
        [128.313487, -14.904962],
        [128.450206, -15.042657],
        [128.388438, -14.803399],
        [128.532400, -14.752862],
        [129.102306, -14.905369],
        [129.152599, -15.223728],
        [129.228770, -14.836602],
        [129.727061, -15.193617],
        [129.649181, -14.832696],
        [129.982432, -14.805922],
        [129.993337, -14.725030],
        [129.762706, -14.819594],
        [129.588064, -14.613458],
        [129.717621, -14.595880],
        [129.789399, -14.531671],
        [129.535330, -14.545343],
        [129.372895, -14.329278],
        [129.482188, -14.051853],
        [129.735606, -13.991795],
        [129.891287, -13.437677],
        [129.968923, -13.530450],
        [130.332286, -13.346368],
        [130.122732, -13.164646],
        [130.129893, -12.940525],
        [130.318614, -12.906020],
        [130.506847, -12.596449],
        [130.586436, -12.709242],
        [130.692882, -12.700616],
        [130.578380, -12.400811],
        [130.899913, -12.639825],
        [130.824718, -12.400811],
        [131.051280, -12.373468],
        [131.026134, -12.147149],
        [131.257335, -12.236261],
        [131.296235, -12.043878],
        [131.447765, -12.289809],
        [132.057872, -12.306736],
        [132.251313, -12.156345],
        [132.387543, -12.380304],
        [132.439626, -12.154880],
        [132.757579, -12.133396],
        [132.593028, -11.784438],
        [132.695567, -11.653497],
        [132.495372, -11.476170],
        [132.106456, -11.523126],
        [131.767589, -11.310805],
        [131.981619, -11.130060],
        [132.174653, -11.406427],
        [132.148123, -11.137302],
        [132.285167, -11.268487],
        [132.343028, -11.122003],
        [132.674164, -11.508396],
        [132.910981, -11.331801],
        [133.166759, -11.704360],
        [133.532074, -11.749119],
        [133.532074, -11.865818],
        [133.915782, -11.722345],
        [133.843761, -11.855239],
        [134.137950, -11.879490],
        [134.185802, -12.076430],
        [134.768565, -11.947686],
        [135.217590, -12.300823],
        [135.900401, -11.759210],
        [135.716907, -12.003019],
        [135.916270, -11.968194],
        [135.652138, -12.203286],
        [135.731944, -12.311456],
        [136.053477, -12.064386],
        [135.935395, -12.213637],
        [136.060232, -12.232192],
        [136.033946, -12.465916],
        [136.284516, -12.415785],
        [136.363048, -12.222914],
        [136.177013, -12.170831],
        [136.450713, -11.942333],
        [136.572215, -11.896443],
        [136.470251, -11.986425],
        [136.663585, -12.263604],
        [136.760916, -12.164483],
        [136.983653, -12.345473],
        [136.740245, -12.475763],
        [136.610688, -12.830336],
        [136.471690, -12.773858],
        [136.657494, -12.995739],
        [136.496755, -12.975193],
        [136.472341, -13.242364],
        [136.322001, -13.307989],
        [136.332856, -13.046882],
        [136.158618, -13.262878],
        [136.147634, -13.122247],
        [136.053477, -13.311944],
        [135.911111, -13.284198],
        [135.886729, -13.713637],
        [136.077891, -13.662693],
        [135.909434, -14.195245],
        [135.368175, -14.722833],
        [136.715587, -15.935968],
        [136.991873, -15.864190],
        [137.912852, -16.477634]
    ],
    [
        [137.912852, -16.477634],
        [138.294119, -16.745701],
        [139.008311, -16.895440],
        [139.239919, -17.323419],
        [139.999522, -17.706150],
        [140.845225, -17.441176],
        [141.292654, -16.495538],
        [141.658946, -15.093927],
        [141.467784, -13.865492],
        [141.693614, -13.250584],
        [141.583751, -12.985772],
        [141.809744, -12.667657],
        [141.938731, -12.908461],
        [142.008311, -12.714939],
        [141.744802, -12.454767],
        [141.590587, -12.540785],
        [141.831228, -12.005955],
        [142.032970, -12.041192],
        [141.947602, -11.896173],
        [142.151052, -10.950616],
        [142.550059, -10.690199],
        [142.501720, -10.947849],
        [142.741954, -10.975030],
        [142.872244, -11.382501],
        [142.862315, -11.836847],
        [143.249034, -11.968194],
        [143.077159, -12.328790],
        [143.433930, -12.613051],
        [143.358897, -12.880548],
        [143.543793, -12.832778],
        [143.530121, -13.750177],
        [143.782725, -14.402276],
        [143.941173, -14.511163],
        [144.486339, -14.161879],
        [144.677582, -14.555841],
        [145.345714, -14.942560],
        [145.243907, -15.428399],
        [145.462413, -16.060479],
        [145.400401, -16.443292],
        [145.774262, -16.988377],
        [145.955089, -16.873142],
        [145.881847, -17.059666],
        [146.147716, -17.632582],
        [146.010102, -18.236505],
        [146.339366, -18.527032],
        [146.333263, -18.959080],
        [146.905121, -19.304620],
        [147.024099, -19.177423],
        [147.133962, -19.410821],
        [147.421397, -19.412774],
        [147.402354, -19.303888],
        [147.684255, -19.828058],
        [147.823904, -19.714288],
        [148.402029, -20.198500],
        [148.560069, -20.052667],
        [148.781993, -20.240818],
        [148.937022, -20.534926],
        [148.701020, -20.439223],
        [148.660167, -20.572198],
        [148.827159, -20.890558],
        [149.231212, -21.089776],
        [149.292166, -21.510675],
        [149.487153, -21.535903],
        [149.663259, -22.493829],
        [149.812755, -22.378106],
        [150.046723, -22.645278],
        [149.923513, -22.298272],
        [150.053559, -22.141534],
        [150.609141, -22.610528],
        [150.543712, -22.366957],
        [150.677501, -22.358005],
        [150.826427, -22.697931],
        [150.813975, -23.509210],
        [151.550548, -24.091404],
        [151.780447, -24.022556],
        [152.123057, -24.591729],
        [152.469737, -24.805597],
        [152.567719, -25.178643],
        [152.913829, -25.287693],
        [152.884044, -25.674249],
        [153.021251, -25.969008],
        [153.061534, -25.817560],
        [153.205577, -25.934991],
        [153.074067, -26.316583],
        [153.210216, -27.077244],
        [153.038259, -27.193455],
        [153.445811, -27.791436],
        [153.605968, -28.867446],
        [153.350597, -29.281020],
        [152.987796, -30.734634],
        [153.059501, -31.077210],
        [152.546373, -32.043679],
        [152.539886, -32.442092],
        [151.799237, -32.893680],
        [151.424164, -33.527765],
        [151.230724, -33.534926],
        [151.281423, -33.952325],
        [151.095225, -34.014418],
        [151.231212, -34.040460],
        [150.800955, -34.548272],
        [150.917003, -34.603448],
        [150.727061, -34.874119],
        [150.844737, -35.077244],
        [150.695567, -35.026137],
        [150.759451, -35.178888],
        [150.553966, -35.213556],
        [150.190929, -35.726821],
        [149.876150, -37.095880],
        [150.053559, -37.268731],
        [149.985362, -37.495864],
        [149.718435, -37.515802],
        [149.491222, -37.783298],
        [147.757579, -37.985121],
        [146.847667, -38.684991],
        [146.224132, -38.714451],
        [146.286388, -38.909845],
        [146.476736, -38.810479],
        [146.410655, -39.143162],
        [146.091807, -38.819757],
        [145.921153, -38.906671],
        [145.809337, -38.650160],
        [145.373057, -38.536798],
        [145.556895, -38.385186],
        [145.464366, -38.234552],
        [144.944591, -38.510349],
        [144.676768, -38.333185],
        [144.982921, -38.341404],
        [145.119314, -38.159356],
        [144.934825, -37.867934],
        [144.373057, -38.118422],
        [144.704763, -38.146091],
        [144.652843, -38.285821],
        [144.401866, -38.301202],
        [143.536957, -38.858331],
        [142.502452, -38.374444],
        [141.761974, -38.261814],
        [141.557872, -38.439711],
        [141.134288, -38.127618],
        [140.593761, -38.033380],
        [139.741547, -37.180841],
        [139.672048, -36.953383],
        [139.857107, -36.634942],
        [139.567393, -36.075291],
        [139.565196, -36.049737],
        [139.475434, -35.896417],
        [139.041352, -35.604099],
        [139.155284, -35.503351],
        [139.338064, -35.687433],
        [139.218923, -35.507257],
        [139.362966, -35.376886],
        [139.177989, -35.315362],
        [138.961192, -35.413832],
        [139.030935, -35.517511],
        [138.993419, -35.547540],
        [138.531261, -35.645929],
        [138.107432, -35.620701],
        [138.438162, -35.342706],
        [138.550629, -34.781915],
        [138.100271, -34.144138],
        [137.749522, -35.131036],
        [136.839366, -35.256117],
        [137.019786, -34.901462],
        [137.446137, -34.917413],
        [137.452403, -34.155694],
        [137.930919, -33.616469],
        [137.810444, -33.259985],
        [138.040212, -33.081638],
        [137.773936, -32.519789],
        [137.778331, -32.982843],
        [137.452159, -33.140069],
        [137.224864, -33.653253],
        [136.607432, -33.902927],
        [136.101410, -34.534845],
        [135.936778, -34.534601],
        [135.799490, -34.805271],
        [136.016368, -34.744073],
        [135.964610, -35.007501],
        [135.108084, -34.595961],
        [135.209809, -34.431573],
        [135.370860, -34.628188],
        [135.503591, -34.611912],
        [135.189789, -33.892999],
        [134.840831, -33.631280],
        [134.706228, -33.172947],
        [134.333507, -33.205011],
        [134.068696, -32.929295],
        [134.074067, -32.713962],
        [134.214041, -32.806248],
        [134.297618, -32.678481],
        [134.195649, -32.495864]
    ],
    [
        [13.847423, -11.055434],
        [13.639822, -12.248712],
        [12.939464, -12.816664],
        [12.522146, -13.410577],
        [12.145274, -15.168634],
        [11.992035, -15.617283],
        [11.751801, -15.799086],
        [11.833640, -18.098045],
        [12.450043, -18.904555],
        [13.397634, -20.849298],
        [14.508556, -22.548028],
        [14.459239, -24.098321],
        [14.853282, -25.064223],
        [14.840343, -25.751723],
        [15.168712, -26.592218],
        [15.083018, -26.695245],
        [15.678884, -27.942804],
        [16.487071, -28.572931],
        [16.824067, -29.101007],
        [17.281993, -30.347752],
        [18.213715, -31.730645],
        [18.310802, -32.572849],
        [17.843028, -32.823337],
        [18.484386, -33.843927],
        [18.316254, -34.157485],
        [18.470063, -34.347426],
        [18.478363, -34.106866],
        [18.800059, -34.089532],
        [18.817638, -34.376886],
        [19.139903, -34.294366],
        [19.360199, -34.500421],
        [19.296886, -34.617771],
        [19.999278, -34.821954],
        [20.524425, -34.454278],
        [21.788748, -34.381280],
        [22.563975, -33.997247],
        [23.408376, -34.110040],
        [23.635509, -33.979669],
        [24.834158, -34.205662],
        [25.011485, -33.970961],
        [25.697520, -34.034926],
        [25.634044, -33.855157],
        [25.785411, -33.743585],
        [26.515147, -33.755304],
        [27.897146, -33.039972],
        [30.062755, -31.238702],
        [31.365001, -29.332615],
        [32.392100, -28.535333],
        [32.865245, -27.017348],
        [32.955089, -26.105645],
        [32.842459, -26.288670],
        [32.485199, -25.965427],
        [33.214610, -25.297296],
        [35.106456, -24.597914],
        [35.493500, -24.110528],
        [35.527354, -23.802992],
        [35.332367, -23.964532],
        [35.340343, -23.676202],
        [35.606130, -22.914727],
        [35.551443, -22.179132],
        [35.517345, -22.310154],
        [35.441417, -22.119561],
        [35.394054, -22.487726],
        [35.271007, -21.644138],
        [35.016449, -21.111098],
        [35.113292, -20.945896],
        [34.668305, -20.541111],
        [34.777599, -19.815037],
        [34.880056, -19.863377],
        [35.126801, -19.705011],
        [35.855317, -18.951349],
        [36.123790, -18.800714],
        [36.266938, -18.890883],
        [36.238129, -18.694106],
        [36.407481, -18.784845],
        [36.977224, -18.046563],
        [36.984060, -18.012384],
        [37.189464, -17.738702],
        [38.127940, -17.286310],
        [38.080821, -17.190688],
        [38.172862, -17.287530],
        [39.090505, -16.983819],
        [39.855968, -16.429783],
        [39.783376, -16.301935],
        [40.581798, -15.492120],
        [40.681651, -15.233005],
        [40.512706, -15.182061],
        [40.773936, -14.997735],
        [40.746104, -14.922052],
        [40.670909, -14.922052],
        [40.643077, -14.853774],
        [40.840099, -14.798272],
        [40.842540, -14.464451],
        [40.629405, -14.566339],
        [40.746104, -14.270929],
        [40.538585, -14.164483],
        [40.650564, -14.031915],
        [40.595225, -12.975681],
        [40.410899, -12.942071],
        [40.646821, -12.755304],
        [40.478201, -12.501072],
        [40.465099, -11.450372]
    ],
    [
        [40.465099, -11.450372],
        [40.348806, -11.317071],
        [40.620291, -10.840916],
        [40.485362, -10.762140],
        [40.654959, -10.686944],
        [40.427013, -10.300063],
        [39.690766, -10.043390],
        [39.807302, -9.852227],
        [39.567393, -9.447524],
        [39.643809, -9.189060],
        [39.498546, -9.124200],
        [39.388682, -8.898858],
        [39.553722, -8.922296],
        [39.303071, -8.505466],
        [39.457530, -7.979669],
        [39.327810, -7.726332],
        [39.305024, -7.791762],
        [39.252615, -7.823337],
        [39.292328, -7.486261],
        [39.553722, -7.000746],
        [38.915050, -6.436700],
        [38.778005, -6.030694],
        [39.190603, -4.677504],
        [39.540050, -4.430434],
        [39.669688, -4.087986],
        [39.560557, -4.039809],
        [39.708344, -4.037530],
        [39.867035, -3.694920],
        [39.860118, -3.633233],
        [39.800141, -3.634698],
        [39.808116, -3.608819],
        [39.775890, -3.600193],
        [39.780935, -3.566583],
        [40.122895, -3.267348],
        [40.232107, -2.669041],
        [40.650564, -2.539321],
        [40.863048, -2.231378],
        [40.944835, -2.309340],
        [40.861013, -1.963474],
        [40.945323, -2.073175],
        [40.970714, -1.928969],
        [41.006114, -1.901788],
        [41.028656, -2.043227],
        [41.417654, -1.847263],
        [41.952810, -0.894464],
        [41.971934, -0.999770],
        [42.712087, -0.176690]
    ],
    [
        [113.395193, -8.447035],
        [113.289073, -8.432794],
        [113.281993, -8.488214],
        [113.409190, -8.486749],
        [113.395193, -8.447035]
    ],
    [
        [123.146251, -8.425958],
        [122.999848, -8.448663],
        [122.882986, -8.582940],
        [123.163585, -8.473728],
        [123.146251, -8.425958]
    ],
    [
        [128.231212, -8.251235],
        [128.213552, -8.199395],
        [128.083263, -8.254571],
        [128.181977, -8.285089],
        [128.231212, -8.251235]
    ],
    [
        [129.029633, -8.206801],
        [128.889496, -8.177830],
        [128.834483, -8.199802],
        [129.006196, -8.263604],
        [129.029633, -8.206801]
    ],
    [
        [127.741873, -8.158949],
        [127.682953, -8.155206],
        [127.604015, -8.206801],
        [127.768809, -8.212579],
        [127.741873, -8.158949]
    ],
    [
        [117.664317, -8.148126],
        [117.486827, -8.182875],
        [117.492524, -8.361017],
        [117.566580, -8.363946],
        [117.664317, -8.148126]
    ],
    [
        [127.216319, -8.026951],
        [127.158946, -8.034926],
        [127.152110, -8.096938],
        [127.224946, -8.108575],
        [127.216319, -8.026951]
    ],
    [
        [131.104991, -7.629002],
        [130.999522, -7.657485],
        [130.971202, -7.701349],
        [131.092296, -7.692315],
        [131.104991, -7.629002]
    ],
    [
        [130.968598, -7.534601],
        [130.858653, -7.486912],
        [130.840994, -7.528741],
        [130.985850, -7.551935],
        [130.968598, -7.534601]
    ],
    [
        [131.174815, -7.404229],
        [131.018240, -7.415216],
        [130.989268, -7.473240],
        [131.080333, -7.503676],
        [131.174815, -7.404229]
    ],
    [
        [131.283946, -7.329767],
        [131.264985, -7.297133],
        [131.215831, -7.357110],
        [131.277110, -7.370782],
        [131.283946, -7.329767]
    ],
    [
        [120.960460, -7.281996],
        [120.815684, -7.257501],
        [120.792328, -7.279474],
        [120.960460, -7.281996]
    ],
    [
        [120.757823, -7.075942],
        [120.621256, -6.998245],
        [120.556253, -7.072889],
        [120.670349, -7.150960],
        [120.757823, -7.075942]
    ],
    [
        [138.753429, -6.778253],
        [138.626964, -6.720147],
        [138.618500, -6.729099],
        [138.716319, -6.864679],
        [138.753429, -6.778253]
    ],
    [
        [131.597423, -6.679132],
        [131.537364, -6.738051],
        [131.551036, -6.801528],
        [131.624522, -6.709731],
        [131.597423, -6.679132]
    ],
    [
        [134.707367, -6.589044],
        [134.628266, -6.709405],
        [134.669444, -6.772882],
        [134.737559, -6.630955],
        [134.707367, -6.589044]
    ],
    [
        [134.607758, -6.421482],
        [134.446137, -6.285414],
        [134.347179, -6.359633],
        [134.541759, -6.529474],
        [134.607758, -6.421482]
    ],
    [
        [134.840587, -6.287693],
        [134.794119, -6.401951],
        [134.826345, -6.473240],
        [134.888194, -6.314060],
        [134.840587, -6.287693]
    ],
    [
        [134.377940, -6.254083],
        [134.271495, -6.061700],
        [134.125987, -6.034275],
        [134.162283, -6.196547],
        [134.377940, -6.254083]
    ],
    [
        [109.906016, -7.837660],
        [111.017345, -8.254653],
        [112.672699, -8.447035],
        [113.240733, -8.280938],
        [114.624766, -8.740655],
        [114.376720, -8.519464],
        [114.388927, -7.758071],
        [114.045584, -7.611993],
        [113.132660, -7.727797],
        [112.761485, -7.531183],
        [112.823253, -7.262628],
        [112.603770, -7.192641],
        [112.582774, -6.870538],
        [112.083995, -6.906020],
        [111.493419, -6.623468],
        [111.144379, -6.691827],
        [111.010753, -6.420994],
        [110.671072, -6.499933],
        [110.381033, -6.975681],
        [110.177501, -6.856215],
        [108.944835, -6.849379],
        [108.605479, -6.761651],
        [108.360269, -6.246401],
        [107.678224, -6.238023],
        [107.044444, -5.914321],
        [107.005138, -6.072361],
        [106.793224, -6.104099],
        [106.052745, -5.881036],
        [105.782234, -6.512107],
        [105.643859, -6.482333],
        [105.490082, -6.809015],
        [105.363780, -6.664972],
        [105.216807, -6.772068],
        [106.510804, -6.963799],
        [106.397760, -7.378465],
        [107.411388, -7.495864],
        [107.864534, -7.745130],
        [108.453711, -7.818501],
        [108.873220, -7.610610],
        [109.906016, -7.837660]
    ],
    [
        [124.065196, -5.962498],
        [124.037446, -5.914321],
        [123.979177, -5.869887],
        [124.059337, -6.027439],
        [124.065196, -5.962498]
    ],
    [
        [132.797374, -5.609063],
        [132.811046, -5.555597],
        [132.784923, -5.527276],
        [132.763682, -5.678806],
        [132.797374, -5.609063]
    ],
    [
        [132.318614, -5.513604],
        [132.334321, -5.572931],
        [132.371430, -5.554132],
        [132.380707, -5.534112],
        [132.318614, -5.513604]
    ],
    [
        [123.777110, -5.513604],
        [123.733246, -5.475274],
        [123.691173, -5.472752],
        [123.814708, -5.595636],
        [123.777110, -5.513604]
    ],
    [
        [123.539724, -5.245538],
        [123.559255, -5.351332],
        [123.633800, -5.366876],
        [123.623790, -5.266534],
        [123.539724, -5.245538]
    ],
    [
        [129.927257, -4.530450],
        [129.874034, -4.545831],
        [129.859060, -4.554783],
        [129.933360, -4.562921],
        [129.927257, -4.530450]
    ],
    [
        [127.234630, -3.821059],
        [127.165212, -3.814142],
        [127.145086, -3.884983],
        [127.241368, -3.910817],
        [127.234630, -3.821059]
    ],
    [
        [122.321300, -3.511895],
        [122.290375, -3.541192],
        [122.293305, -3.580824],
        [122.355479, -3.556573],
        [122.321300, -3.511895]
    ],
    [
        [132.702810, -3.453302],
        [132.666515, -3.410252],
        [132.620291, -3.423761],
        [132.702891, -3.519301],
        [132.702810, -3.453302]
    ],
    [
        [122.439626, -3.419041],
        [122.412283, -3.387791],
        [122.433604, -3.485284],
        [122.464692, -3.440851],
        [122.439626, -3.419041]
    ],
    [
        [127.615489, -3.307387],
        [127.563975, -3.255792],
        [127.480479, -3.293390],
        [127.643565, -3.356052],
        [127.615489, -3.307387]
    ],
    [
        [127.772227, -3.162530],
        [127.706309, -3.156345],
        [127.643321, -3.224379],
        [127.778494, -3.244236],
        [127.772227, -3.162530]
    ],
    [
        [127.954112, -2.916681],
        [127.926036, -2.916681],
        [127.826996, -3.028985],
        [127.947276, -3.018487],
        [127.954112, -2.916681]
    ],
    [
        [-44.497792, -2.806817],
        [-44.598012, -3.060154],
        [-44.497304, -2.949314],
        [-44.497792, -2.806817]
    ],
    [
        [-42.041412, -2.704360],
        [-42.091379, -2.678399],
        [-42.186025, -2.676446],
        [-42.085194, -2.758722],
        [-42.041412, -2.704360]
    ],
    [
        [-80.059885, -2.662774],
        [-80.210683, -2.724867],
        [-80.265940, -3.018487],
        [-79.907216, -2.732354],
        [-80.059885, -2.662774]
    ],
    [
        [-43.627309, -2.252048],
        [-43.715403, -2.289239],
        [-43.732900, -2.419875],
        [-43.634805, -2.399895],
        [-43.627309, -2.252048]
    ],
    [
        [123.876720, -2.018487],
        [123.839366, -2.049086],
        [123.886974, -2.073907],
        [123.887869, -2.050877],
        [123.876720, -2.018487]
    ],
    [
        [124.348888, -1.959568],
        [124.300629, -1.987481],
        [124.370291, -2.038995],
        [124.372081, -1.992608],
        [124.348888, -1.959568]
    ],
    [
        [123.656993, -1.909356],
        [123.649587, -1.901788],
        [123.663829, -1.963311],
        [123.664399, -1.948907],
        [123.656993, -1.909356]
    ],
    [
        [123.738048, -1.907892],
        [123.712901, -1.911716],
        [123.711681, -1.957127],
        [123.745779, -1.935968],
        [123.738048, -1.907892]
    ],
    [
        [-49.287953, -1.758477],
        [-49.352162, -1.722426],
        [-49.442494, -1.867771],
        [-49.367421, -1.895115],
        [-49.287953, -1.758477]
    ],
    [
        [108.677257, -1.713800],
        [108.758800, -1.717462],
        [108.778087, -1.702732],
        [108.723155, -1.693617],
        [108.677257, -1.713800]
    ],
    [
        [127.371104, -1.367446],
        [127.330251, -1.353774],
        [127.284190, -1.425388],
        [127.378754, -1.405450],
        [127.371104, -1.367446]
    ],
    [
        [-89.661285, -1.340102],
        [-89.736399, -1.340102],
        [-89.756907, -1.360610],
        [-89.613271, -1.391697],
        [-89.661285, -1.340102]
    ],
    [
        [-44.892242, -1.271905],
        [-44.974355, -1.260349],
        [-45.018910, -1.377699],
        [-44.885365, -1.326430],
        [-44.892242, -1.271905]
    ],
    [
        [109.170177, -1.257582],
        [109.114757, -1.280206],
        [109.100759, -1.300551],
        [109.144216, -1.311456],
        [109.170177, -1.257582]
    ],
    [
        [-90.380686, -1.254490],
        [-90.471913, -1.216729],
        [-90.524037, -1.305922],
        [-90.432118, -1.345961],
        [-90.380686, -1.254490]
    ],
    [
        [109.254649, -1.169366],
        [109.219981, -1.198012],
        [109.223399, -1.227146],
        [109.259776, -1.202244],
        [109.254649, -1.169366]
    ],
    [
        [-48.338979, -1.066502],
        [-48.421498, -1.079522],
        [-48.462066, -1.164483],
        [-48.334096, -1.205011],
        [-48.338979, -1.066502]
    ],
    [
        [-48.194936, -0.819431],
        [-48.312652, -0.953302],
        [-48.307118, -1.020685],
        [-48.201894, -1.011489],
        [-48.194936, -0.819431]
    ],
    [
        [-89.308095, -0.685642],
        [-89.413238, -0.713474],
        [-89.629954, -0.925877],
        [-89.420033, -0.919366],
        [-89.308095, -0.685642]
    ],
    [
        [-47.948557, -0.641290],
        [-47.982655, -0.676039],
        [-47.962148, -0.730645],
        [-47.887074, -0.669122],
        [-47.948557, -0.641290]
    ],
    [
        [-50.819203, -0.620212],
        [-51.066274, -0.676039],
        [-51.100413, -0.826267],
        [-50.843129, -0.715997],
        [-50.819203, -0.620212]
    ],
    [
        [-47.660512, -0.579197],
        [-47.761379, -0.575771],
        [-47.701527, -0.709568],
        [-47.643422, -0.692966],
        [-47.660512, -0.579197]
    ],
    [
        [-51.186025, -0.613946],
        [-51.308339, -0.518731],
        [-51.534047, -0.634698],
        [-51.930287, -1.470798],
        [-51.275624, -1.025160],
        [-51.186025, -0.613946]
    ],
    [
        [-90.191965, -0.538263],
        [-90.460561, -0.513849],
        [-90.544545, -0.681573],
        [-90.337066, -0.776951],
        [-90.191965, -0.538263]
    ],
    [
        [139.192231, -6.972914],
        [138.966319, -6.835707],
        [138.683442, -6.714532],
        [138.829112, -6.705987],
        [138.466075, -6.402114],
        [138.262462, -5.914727],
        [138.403982, -5.835707],
        [138.157563, -5.773696],
        [138.362966, -5.678806],
        [138.071056, -5.728611],
        [138.061371, -5.403741],
        [137.278819, -4.936619],
        [136.822113, -4.928318],
        [135.950450, -4.506280],
        [135.185557, -4.448907],
        [134.648204, -4.118748],
        [134.688487, -3.947442],
        [134.916270, -3.978692],
        [134.967784, -3.936782],
        [134.675792, -3.908380],
        [134.525238, -4.026462],
        [134.333507, -3.868829],
        [134.315278, -4.020278],
        [134.127452, -3.745294],
        [133.987641, -3.855157],
        [133.838145, -3.590427],
        [133.829275, -3.721856],
        [133.703136, -3.672621],
        [133.683116, -3.232517],
        [133.929454, -3.114679],
        [133.860525, -2.922947],
        [133.668224, -3.122166],
        [133.627696, -3.416274],
        [133.514008, -3.378351],
        [133.453380, -3.865411],
        [133.250987, -4.066827],
        [132.907725, -4.088149],
        [132.730968, -3.682306],
        [132.931814, -3.554132],
        [132.811697, -3.281671],
        [132.671153, -3.328546],
        [132.325694, -2.946547],
        [131.976085, -2.929783],
        [131.958018, -2.788181],
        [132.311778, -2.676446],
        [132.728282, -2.813165],
        [133.239594, -2.416762],
        [133.380707, -2.676446],
        [133.445567, -2.494724],
        [133.450369, -2.642348],
        [133.633962, -2.539321],
        [133.682384, -2.717462],
        [133.713145, -2.511977],
        [133.816905, -2.649021],
        [133.747244, -2.437921],
        [134.005138, -2.388442],
        [133.867361, -2.341241],
        [133.949962, -2.292901],
        [133.949962, -2.203546],
        [133.792003, -2.260186],
        [133.940440, -2.107599],
        [132.305675, -2.265558],
        [131.941905, -1.895115],
        [131.982188, -1.538751],
        [130.950938, -1.433689],
        [131.254161, -1.080255],
        [131.243012, -0.819431],
        [131.876475, -0.689630],
        [132.437185, -0.347101],
        [132.975108, -0.444757],
        [133.391612, -0.723240],
        [133.994884, -0.733331],
        [134.172130, -0.863865],
        [134.036143, -0.957778],
        [134.281993, -1.350193],
        [134.087087, -1.682794],
        [134.164806, -2.320489],
        [134.463878, -2.862074],
        [134.484386, -2.539321],
        [134.638438, -2.511163],
        [134.701345, -2.958673],
        [134.851329, -2.899835],
        [134.818533, -3.136326],
        [135.111501, -3.361749],
        [135.521739, -3.335545],
        [136.266368, -2.560317],
        [136.380870, -2.234063],
        [137.178477, -2.106134],
        [137.123546, -1.797459],
        [137.883149, -1.470473],
        [139.780772, -2.354669],
        [140.607595, -2.439386],
        [140.723806, -2.633966],
        [141.193370, -2.615004],
        [142.062836, -3.060154],
        [143.522960, -3.435968],
        [144.021495, -3.802992],
        [144.513438, -3.817560],
        [145.801443, -4.842462],
        [145.759613, -5.476983],
        [147.449067, -5.961602],
        [147.826671, -6.335382],
        [147.854015, -6.691013],
        [146.977306, -6.740411],
        [146.949555, -6.931329],
        [147.188487, -7.462579],
        [147.726817, -7.932061],
        [148.146332, -8.045668],
        [148.229503, -8.554620],
        [148.445323, -8.674737],
        [148.585623, -9.064060],
        [149.309337, -9.017022],
        [149.226573, -9.486749],
        [150.048839, -9.684503],
        [149.730968, -9.809340],
        [149.854503, -10.014907],
        [150.871349, -10.236749],
        [150.399913, -10.300226],
        [150.361501, -10.399672],
        [150.692882, -10.556736],
        [150.211274, -10.701349],
        [149.854503, -10.550470],
        [150.081554, -10.461114],
        [149.748383, -10.338311],
        [148.747813, -10.234633],
        [148.689301, -10.104913],
        [147.716807, -10.098077],
        [147.310069, -9.538832],
        [146.894867, -9.268243],
        [146.975352, -9.033461],
        [146.601817, -9.006036],
        [146.606456, -8.802016],
        [146.099864, -8.083266],
        [144.879568, -7.781671],
        [144.852306, -7.569431],
        [144.604015, -7.656915],
        [144.522309, -7.496189],
        [144.513927, -7.671970],
        [144.407237, -7.514093],
        [144.507823, -7.798028],
        [144.311046, -7.610284],
        [144.214854, -7.795994],
        [143.646251, -7.438409],
        [143.956798, -7.972263],
        [143.364024, -7.896417],
        [143.612478, -8.239190],
        [142.700369, -8.261407],
        [142.494477, -8.333266],
        [142.360037, -8.167087],
        [142.224783, -8.173272],
        [142.146169, -8.217380],
        [142.354015, -8.188735],
        [142.452159, -8.373305],
        [142.728282, -8.316664],
        [143.131602, -8.486017],
        [143.395274, -8.768731],
        [143.361339, -9.007420],
        [142.612478, -9.334649],
        [142.210704, -9.158949],
        [141.152599, -9.232192],
        [139.988129, -8.192478],
        [140.151703, -7.884698],
        [139.973643, -8.096938],
        [139.395193, -8.200942],
        [139.217133, -7.951349],
        [138.914399, -8.292087],
        [138.842784, -8.117446],
        [139.093028, -7.559991],
        [138.667491, -7.197849],
        [139.157074, -7.243097],
        [139.240001, -7.151056],
        [138.842540, -7.145603],
        [138.561534, -6.918634],
        [138.931488, -6.842543],
        [139.192231, -6.972914]
    ],
    [
        [104.479991, -0.271254],
        [104.404959, -0.283380],
        [104.406505, -0.311782],
        [104.492524, -0.308770],
        [104.479991, -0.271254]
    ],
    [
        [-91.401112, -0.452895],
        [-91.455678, -0.257582],
        [-91.668568, -0.284926],
        [-91.606516, -0.456313],
        [-91.401112, -0.452895]
    ],
    [
        [-90.565012, -0.284926],
        [-90.777252, -0.147719],
        [-90.874135, -0.271254],
        [-90.604888, -0.369806],
        [-90.565012, -0.284926]
    ],
    [
        [-51.165273, -0.140313],
        [-51.264272, -0.219496],
        [-51.405100, -0.459649],
        [-51.166737, -0.305597],
        [-51.165273, -0.140313]
    ],
    [
        [-48.462514, -0.576104],
        [-48.427235, -0.259942],
        [-50.368153, -0.105645],
        [-50.696360, -0.360040],
        [-50.548451, -0.677830],
        [-50.737294, -0.551853],
        [-50.792551, -1.018650],
        [-50.476633, -1.039158],
        [-50.559722, -1.183201],
        [-50.792551, -1.086196],
        [-50.803212, -1.434991],
        [-50.405181, -1.830987],
        [-50.258168, -1.484145],
        [-50.155019, -1.778985],
        [-50.028188, -1.655450],
        [-49.776438, -1.807224],
        [-49.744211, -1.580336],
        [-49.688344, -1.769301],
        [-49.558705, -1.724216],
        [-49.531321, -1.497735],
        [-49.222768, -1.621189],
        [-49.197743, -1.388360],
        [-49.065785, -1.531915],
        [-48.839223, -1.449965],
        [-48.832997, -1.415785],
        [-48.921132, -1.141534],
        [-48.642812, -1.083591],
        [-48.462514, -0.576104]
    ],
    [
        [-50.973744, -0.291192],
        [-50.675852, -0.154555],
        [-50.655263, -0.023777],
        [-50.947266, -0.011974],
        [-50.973744, -0.291192]
    ],
    [
        [-49.832346, -0.103123],
        [-49.463368, -0.128025],
        [-49.347524, -0.009698],
        [-49.496571, 0.085598],
        [-49.832346, -0.103123]
    ],
    [
        [-90.811431, -0.730645],
        [-91.323638, 0.139309],
        [-91.497304, 0.106106],
        [-91.603383, -0.014215],
        [-91.423329, -0.028578],
        [-91.086781, -0.582452],
        [-91.465891, -0.807875],
        [-91.435862, -0.997491],
        [-90.928700, -0.970310],
        [-90.811431, -0.730645]
    ],
    [
        [-50.634267, 0.071275],
        [-50.559722, -0.003839],
        [-50.437729, -0.000033],
        [-50.490224, 0.159362],
        [-50.634267, 0.071275]
    ],
    [
        [102.839122, 0.290961],
        [102.875336, 0.284084],
        [102.927257, 0.310858],
        [102.884532, 0.315253],
        [102.839122, 0.290961]
    ],
    [
        [-50.090784, 0.305945],
        [-50.113324, 0.338182],
        [-50.220461, 0.246212],
        [-50.165648, 0.261734],
        [-50.090784, 0.305945]
    ],
    [
        [-90.513783, 0.283515],
        [-90.454579, 0.267401],
        [-90.407948, 0.310858],
        [-90.504465, 0.361029],
        [-90.513783, 0.283515]
    ],
    [
        [-50.036888, 0.299741],
        [-50.377797, 0.208319],
        [-50.345123, 0.047431],
        [-49.867055, -0.010675],
        [-49.530356, 0.353780],
        [-50.036888, 0.299741]
    ],
    [
        [-50.378021, 0.244990],
        [-50.316970, 0.308751],
        [-50.366689, 0.619940],
        [-50.516754, 0.208645],
        [-50.378021, 0.244990]
    ],
    [
        [-50.312123, 0.413967],
        [-50.042714, 0.510321],
        [-50.065663, 0.647284],
        [-50.258168, 0.585191],
        [-50.312123, 0.413967]
    ],
    [
        [-90.797760, 0.653510],
        [-90.805247, 0.571601],
        [-90.760569, 0.553697],
        [-90.756988, 0.630601],
        [-90.797760, 0.653510]
    ],
    [
        [103.079600, 0.624416],
        [103.055431, 0.658677],
        [103.036632, 0.657538],
        [103.076996, 0.574774],
        [103.079600, 0.624416]
    ],
    [
        [103.506358, 0.701890],
        [103.473888, 0.653469],
        [103.472016, 0.622992],
        [103.517914, 0.667629],
        [103.506358, 0.701890]
    ],
    [
        [103.112804, 0.792955],
        [103.077159, 0.760891],
        [103.092296, 0.722357],
        [103.116222, 0.757758],
        [103.112804, 0.792955]
    ],
    [
        [104.564626, 0.798163],
        [104.523448, 0.788398],
        [104.511241, 0.750312],
        [104.620453, 0.777045],
        [104.564626, 0.798163]
    ],
    [
        [103.667735, 0.839667],
        [103.700938, 0.765692],
        [103.724864, 0.766506],
        [103.718110, 0.798082],
        [103.667735, 0.839667]
    ],
    [
        [-50.202416, 0.749692],
        [-50.103383, 0.755683],
        [-50.015723, 0.892493],
        [-50.225476, 0.859200],
        [-50.202416, 0.749692]
    ],
    [
        [103.462169, 0.918931],
        [103.453461, 0.920559],
        [103.407074, 0.911444],
        [103.469005, 0.869615],
        [103.462169, 0.918931]
    ],
    [
        [-50.062585, 0.923252],
        [-49.964019, 0.973822],
        [-49.926380, 1.069857],
        [-50.100317, 0.959063],
        [-50.062585, 0.923252]
    ],
    [
        [120.649181, 1.072455],
        [120.607595, 1.072455],
        [120.683360, 1.044582],
        [120.668712, 1.061021],
        [120.649181, 1.072455]
    ],
    [
        [120.377615, 1.079901],
        [120.367686, 1.049221],
        [120.377940, 1.024075],
        [120.406505, 1.060981],
        [120.377615, 1.079901]
    ],
    [
        [-78.901682, 1.374172],
        [-78.995432, 1.286811],
        [-78.956899, 1.236314],
        [-78.899281, 1.271430],
        [-78.901682, 1.374172]
    ],
    [
        [119.846528, -0.874607],
        [119.799978, -0.123793],
        [119.634451, 0.010484],
        [119.832693, -0.084405],
        [119.785167, 0.239488],
        [120.045746, 0.734361],
        [120.278494, 0.994208],
        [120.568126, 0.782131],
        [120.833507, 1.325670],
        [121.451427, 1.297553],
        [121.546723, 1.072455],
        [122.454112, 1.020657],
        [122.848888, 0.818020],
        [123.186697, 0.973619],
        [123.929210, 0.831529],
        [124.593761, 1.195868],
        [124.548350, 1.359849],
        [124.835704, 1.469143],
        [124.983897, 1.731594],
        [125.175304, 1.678168],
        [125.249197, 1.484687],
        [124.321788, 0.398871],
        [123.625987, 0.266588],
        [123.238780, 0.324530],
        [123.074229, 0.516303],
        [121.800466, 0.426459],
        [121.601899, 0.551744],
        [121.107921, 0.407131],
        [120.502696, 0.528876],
        [120.158214, 0.227769],
        [119.995616, -0.209242],
        [120.073090, -0.613946],
        [120.255626, -0.899347],
        [120.500336, -0.975274],
        [120.675955, -1.394708],
        [121.105479, -1.405857],
        [121.620128, -0.800388],
        [121.714203, -0.935479],
        [122.105317, -0.926202],
        [122.207693, -0.764744],
        [122.929047, -0.758884],
        [122.734630, -0.648370],
        [123.075857, -0.556410],
        [123.454356, -0.758233],
        [123.311209, -1.051446],
        [123.096202, -0.835056],
        [122.838715, -0.899184],
        [122.368826, -1.492771],
        [121.861339, -1.669692],
        [121.692149, -1.908136],
        [121.296072, -1.816664],
        [122.472911, -3.151137],
        [122.205414, -3.593845],
        [122.656423, -3.889337],
        [122.551280, -3.970798],
        [122.688162, -4.138360],
        [122.844981, -4.057712],
        [122.900157, -4.388767],
        [122.670177, -4.314548],
        [122.758149, -4.484796],
        [122.107758, -4.519952],
        [122.077403, -4.842055],
        [121.554210, -4.743748],
        [121.627696, -4.087091],
        [120.874522, -3.498956],
        [121.066742, -3.193780],
        [121.080414, -2.759047],
        [120.584483, -2.682061],
        [120.203461, -2.957696],
        [120.425792, -3.256117],
        [120.449962, -4.646580],
        [120.264334, -5.149998],
        [120.463634, -5.620212],
        [120.323253, -5.509535],
        [119.723643, -5.703790],
        [119.433279, -5.587823],
        [119.352794, -5.355645],
        [119.626801, -4.314548],
        [119.497569, -3.495294],
        [118.926768, -3.566095],
        [118.764171, -3.090916],
        [118.885509, -2.869561],
        [118.757335, -2.775811],
        [119.135753, -2.454278],
        [119.216075, -2.009942],
        [119.347016, -1.959405],
        [119.313650, -1.245782],
        [119.525157, -0.860447],
        [119.733653, -0.633884],
        [119.846528, -0.874607]
    ],
    [
        [-50.454358, 2.110941],
        [-50.523813, 2.001482],
        [-50.419119, 1.862978],
        [-50.314027, 1.968266],
        [-50.454358, 2.110941]
    ],
    [
        [-50.543521, 2.146197],
        [-50.497932, 2.107398],
        [-50.415158, 2.126931],
        [-50.463348, 2.186938],
        [-50.543521, 2.146197]
    ],
    [
        [127.785899, 2.264228],
        [127.748220, 2.247382],
        [127.781261, 2.208930],
        [127.816173, 2.233791],
        [127.785899, 2.264228]
    ],
    [
        [128.193614, 2.367255],
        [128.128673, 2.358303],
        [128.154633, 2.286363],
        [128.169932, 2.297431],
        [128.193614, 2.367255]
    ],
    [
        [-78.131418, 2.627265],
        [-78.214868, 2.681914],
        [-78.134429, 2.504381],
        [-78.096181, 2.540025],
        [-78.131418, 2.627265]
    ],
    [
        [-77.902333, 2.696234],
        [-77.888051, 2.593817],
        [-77.785024, 2.593817],
        [-77.850494, 2.638129],
        [-77.902333, 2.696234]
    ],
    [
        [-77.806142, 2.662055],
        [-77.847076, 2.724107],
        [-77.882558, 2.724595],
        [-77.806142, 2.662055]
    ],
    [
        [-72.505238, -35.448012],
        [-72.213490, -35.081313],
        [-72.018544, -34.140802],
        [-71.624664, -33.541436],
        [-71.761871, -33.101983],
        [-71.568227, -33.001886],
        [-71.407948, -32.386326],
        [-71.542144, -32.205173],
        [-71.713450, -30.614923],
        [-71.637766, -30.241469],
        [-71.398793, -30.176690],
        [-71.282582, -29.880141],
        [-71.521962, -28.940118],
        [-70.912424, -27.621840],
        [-70.959950, -27.161391],
        [-70.629954, -26.340977],
        [-70.739985, -25.829323],
        [-70.444814, -25.344903],
        [-70.582834, -24.524835],
        [-70.390736, -23.576918],
        [-70.631612, -23.517039],
        [-70.562245, -23.059828],
        [-70.291575, -22.901951],
        [-70.058695, -21.433377],
        [-70.213844, -20.811577],
        [-70.123280, -19.999933],
        [-70.303561, -18.445439],
        [-71.384429, -17.697849],
        [-71.514516, -17.284601],
        [-75.048695, -15.460707],
        [-75.930653, -14.649347],
        [-76.393960, -13.908020],
        [-76.253985, -13.850868],
        [-76.221102, -13.357556],
        [-76.790886, -12.381047],
        [-77.174916, -12.071873],
        [-77.210927, -11.646417],
        [-77.647257, -11.292316],
        [-77.670539, -10.927520],
        [-78.095511, -10.240667]
    ],
    [
        [-78.095511, -10.240667],
        [-78.759328, -8.608327],
        [-79.465942, -7.715929],
        [-79.689086, -7.130911],
        [-80.118916, -6.650611],
        [-81.130811, -6.034561],
        [-81.150216, -5.883073],
        [-80.939931, -5.850844],
        [-80.856212, -5.650462],
        [-81.198476, -5.208103],
        [-81.063355, -5.022043],
        [-81.337558, -4.678304],
        [-81.264027, -4.252374],
        [-80.306874, -3.320733],
        [-79.968007, -3.214614],
        [-79.726430, -2.593845],
        [-79.868642, -2.160903],
        [-79.765614, -2.004978],
        [-79.891957, -2.115899],
        [-79.896108, -2.543390],
        [-80.063588, -2.577244],
        [-79.929677, -2.484145],
        [-80.012685, -2.326430],
        [-80.255483, -2.730239],
        [-81.013010, -2.166925],
        [-80.737447, -2.043497],
        [-80.855580, -1.588311],
        [-80.744256, -1.343773],
        [-80.909611, -1.044915],
        [-80.569883, -0.912243],
        [-80.448969, -0.606060],
        [-80.378798, -0.657885],
        [-80.299007, -0.662229],
        [-80.496464, -0.381374],
        [-80.051349, 0.089992],
        [-80.097279, 0.780341],
        [-79.655751, 1.003607],
        [-79.670074, 0.921617],
        [-79.614858, 0.845282],
        [-79.614858, 0.996080],
        [-78.812856, 1.277289],
        [-79.021512, 1.638310],
        [-78.846052, 1.821585],
        [-78.571230, 1.782207],
        [-78.703159, 2.189805],
        [-78.574086, 2.433173],
        [-78.346018, 2.647986],
        [-78.132476, 2.492743],
        [-78.096105, 2.651451],
        [-77.760406, 2.591620],
        [-77.812367, 2.764472],
        [-77.619700, 2.931586],
        [-77.721791, 2.982001],
        [-77.457387, 3.356147],
        [-77.318918, 3.319973],
        [-77.321767, 3.547838],
        [-77.031565, 3.915839],
        [-77.253163, 3.840806],
        [-77.189198, 4.067328],
        [-77.346181, 3.929511],
        [-77.435170, 4.029364],
        [-77.236318, 4.265326],
        [-77.387196, 4.347235],
        [-77.258046, 4.704088],
        [-77.380971, 5.403022],
        [-77.559193, 5.503079],
        [-77.245920, 5.734198],
        [-77.484364, 6.188788],
        [-77.345367, 6.566107],
        [-77.696278, 6.849189],
        [-77.652740, 6.976630],
        [-77.696278, 7.074530],
        [-78.166086, 7.512641],
        [-78.436147, 8.058295],
        [-78.132476, 8.405341],
        [-78.002553, 8.237006],
        [-77.885976, 8.234687],
        [-77.778147, 8.115790],
        [-77.737213, 8.130316],
        [-77.880686, 8.243313],
        [-78.023183, 8.290473],
        [-78.088124, 8.512763],
        [-78.134429, 8.561713],
        [-78.094146, 8.410875],
        [-78.156850, 8.466213],
        [-78.202748, 8.424506],
        [-78.223256, 8.541815],
        [-78.367258, 8.424506],
        [-78.408193, 8.548041],
        [-78.415639, 8.356269],
        [-78.614247, 8.774604],
        [-79.087229, 8.994330],
        [-78.977366, 9.145168],
        [-79.703603, 8.870185],
        [-79.826311, 8.638520],
        [-79.700607, 8.641551],
        [-80.125844, 8.348619]
    ],
    [
        [-77.353017, 4.265326],
        [-77.428131, 4.341010],
        [-77.549550, 4.204779],
        [-77.271718, 4.258490],
        [-77.353017, 4.265326]
    ],
    [
        [120.860688, 5.574368],
        [120.823741, 5.533637],
        [120.897797, 5.498521],
        [120.904552, 5.538031],
        [120.860688, 5.574368]
    ],
    [
        [100.947276, 1.825385],
        [100.799978, 2.208930],
        [101.050304, 2.291490],
        [101.427013, 1.709296],
        [102.118175, 1.386542],
        [102.425059, 0.804267],
        [102.953787, 0.675849],
        [103.074718, 0.442328],
        [102.581879, 0.181098],
        [102.502696, 0.236396],
        [102.430431, 0.246324],
        [102.545746, 0.169135],
        [102.902680, 0.267768],
        [103.362153, 0.536282],
        [103.743419, 0.277330],
        [103.801768, -0.007257],
        [103.270518, -0.257582],
        [103.489268, -0.211521],
        [103.345551, -0.366876],
        [103.598399, -0.436782],
        [103.372895, -0.449395],
        [103.345551, -0.695896],
        [103.828868, -1.073419],
        [104.377208, -1.031671],
        [104.497081, -1.935968],
        [104.882823, -2.125665],
        [104.606212, -2.402114],
        [104.709646, -2.370864],
        [104.713145, -2.557794],
        [104.569509, -2.656427],
        [104.531098, -2.772638],
        [104.731456, -2.590753],
        [104.883311, -2.284926],
        [105.623790, -2.401788],
        [105.809581, -2.899021],
        [106.028494, -2.982843],
        [106.073009, -3.255548],
        [105.819591, -3.672540],
        [105.952485, -3.833754],
        [105.812755, -4.238702],
        [105.909679, -4.943129],
        [105.729747, -5.896661],
        [105.279633, -5.444268],
        [105.163259, -5.786065],
        [104.551443, -5.508477],
        [104.716075, -5.921075],
        [104.561290, -5.928318],
        [103.891124, -5.104181],
        [102.312511, -3.991469],
        [102.222179, -3.642836],
        [101.611339, -3.224542],
        [100.923106, -2.333429],
        [100.857595, -1.891860],
        [99.747244, -0.029840],
        [99.137950, 0.263088],
        [98.709646, 1.564114],
        [98.773936, 1.748603],
        [97.744395, 2.281073],
        [97.602712, 2.866197],
        [96.883556, 3.682440],
        [96.479503, 3.778713],
        [95.565440, 4.637519],
        [95.198985, 5.292873],
        [95.212738, 5.573147],
        [95.611583, 5.626654],
        [96.406586, 5.217231],
        [97.526215, 5.242255],
        [97.909190, 4.889594],
        [97.996837, 4.546454],
        [98.275564, 4.425360],
        [98.178966, 4.108222],
        [98.263031, 4.177314],
        [99.750743, 3.180487],
        [99.979503, 2.948472],
        [99.953461, 2.696234],
        [100.007986, 2.602607],
        [100.054942, 2.727281],
        [100.125824, 2.530097],
        [100.210623, 2.706244],
        [100.434337, 2.273342],
        [100.947276, 1.825385]
    ],
    [
        [118.219493, 5.855536],
        [118.181000, 5.851264],
        [118.165538, 5.827541],
        [118.230805, 5.831936],
        [118.219493, 5.855536]
    ],
    [
        [121.902354, 6.033637],
        [121.870942, 6.033108],
        [121.776622, 6.077379],
        [121.857677, 6.002265],
        [121.902354, 6.033637]
    ],
    [
        [-58.378570, 6.972113],
        [-58.447011, 6.943061],
        [-58.460520, 6.883368],
        [-58.333608, 6.965277],
        [-58.378570, 6.972113]
    ],
    [
        [119.278087, 5.344631],
        [118.932628, 5.394110],
        [118.651052, 5.636420],
        [118.565440, 5.525946],
        [118.594005, 5.682074],
        [118.365245, 5.813788],
        [117.960297, 5.687161],
        [117.921153, 5.809027],
        [118.125173, 5.863918],
        [118.016856, 6.060981],
        [117.668956, 5.972642],
        [117.727061, 6.451158],
        [117.295909, 6.636298],
        [117.150238, 7.003119],
        [116.783946, 6.591620],
        [116.765880, 7.025092],
        [115.848643, 5.560004],
        [115.604828, 5.519721],
        [115.604828, 5.635810],
        [115.392589, 5.413275],
        [115.605235, 5.212104],
        [115.370291, 4.910875],
        [115.048106, 4.801825],
        [115.057791, 5.054104],
        [114.326671, 4.606879],
        [113.975841, 4.594713],
        [113.946788, 4.273830],
        [113.007823, 3.161689],
        [111.447032, 2.694648],
        [111.493419, 2.346137],
        [111.220958, 2.416083],
        [111.184744, 2.145087],
        [111.377940, 2.161811],
        [111.096039, 1.774482],
        [111.267426, 1.627346],
        [111.005626, 1.584459],
        [111.383556, 1.353664],
        [110.793305, 1.572414],
        [110.763438, 1.479682],
        [110.677908, 1.448635],
        [110.726736, 1.547431],
        [110.329356, 1.802558],
        [110.290782, 1.673977],
        [109.927745, 1.692288],
        [109.645274, 2.083238],
        [109.340994, 1.935533],
        [108.985850, 1.215806],
        [108.924327, 1.164008],
        [108.920909, 0.340277],
        [109.300466, 0.010484],
        [109.156505, 0.020087],
        [109.224783, -0.237237],
        [109.046235, -0.245864],
        [109.139415, -0.528578],
        [109.506521, -0.716404],
        [109.262543, -0.667413],
        [109.273204, -0.853611],
        [109.677257, -0.983819],
        [109.763520, -0.870864],
        [110.061371, -1.346368],
        [109.903819, -1.826104],
        [110.092540, -1.949640],
        [110.280528, -2.518243],
        [110.156993, -2.621270],
        [110.263194, -3.002862],
        [110.549490, -2.867608],
        [110.662446, -3.080743],
        [110.793956, -2.943536],
        [110.956065, -2.879002],
        [110.754242, -3.026056],
        [111.569835, -3.015720],
        [111.754080, -2.738539],
        [111.905284, -3.572035],
        [112.202891, -3.329522],
        [112.638031, -3.416762],
        [113.021495, -3.162530],
        [113.035167, -2.922947],
        [113.351085, -3.272393],
        [113.302745, -3.162530],
        [113.611501, -3.174249],
        [113.632498, -3.456801],
        [114.042003, -3.355564],
        [114.117686, -3.190362],
        [114.186534, -3.382257],
        [114.364757, -3.211521],
        [114.263520, -3.397556],
        [114.476817, -3.500665],
        [114.550304, -3.348077],
        [114.664317, -4.184177],
        [115.967947, -3.608819],
        [116.264903, -3.136895],
        [116.137706, -2.823419],
        [116.287608, -2.987074],
        [116.304210, -2.525649],
        [116.517914, -2.553888],
        [116.603282, -2.224216],
        [116.283214, -2.169366],
        [116.466563, -1.907485],
        [116.424815, -1.766371],
        [116.222423, -1.789646],
        [116.762380, -1.365330],
        [116.790863, -1.243910],
        [116.736095, -1.220961],
        [116.743175, -1.024835],
        [116.819835, -1.261407],
        [116.957693, -1.239923],
        [117.281505, -0.809177],
        [117.627126, -0.770929],
        [117.482921, -0.699640],
        [117.630138, -0.418715],
        [117.441417, -0.525160],
        [117.469981, 0.108791],
        [117.743175, 0.740546],
        [118.032970, 0.800238],
        [117.893891, 1.113471],
        [118.383962, 0.804918],
        [118.798188, 0.804918],
        [119.011729, 0.976264],
        [117.750011, 2.031440],
        [118.082205, 2.337470],
        [117.619640, 2.825507],
        [117.736339, 2.901597],
        [117.543793, 2.922105],
        [117.685069, 2.963080],
        [117.617198, 3.085883],
        [117.270030, 3.234320],
        [117.446544, 3.434760],
        [117.030528, 3.594387],
        [117.509776, 3.607367],
        [117.468761, 3.792304],
        [117.761078, 3.643744],
        [117.777192, 3.799140],
        [117.523448, 3.936347],
        [117.689301, 3.921454],
        [117.373057, 4.169745],
        [117.627126, 4.176500],
        [117.656016, 4.424221],
        [117.982677, 4.231147],
        [118.556895, 4.363511],
        [118.599620, 4.519192],
        [118.136485, 4.882310],
        [118.357188, 5.038804],
        [118.681488, 4.944322],
        [119.155935, 5.106187],
        [119.278087, 5.344631]
    ],
    [
        [125.791270, 6.948188],
        [125.781912, 7.135199],
        [125.715831, 7.195950],
        [125.674083, 7.070217],
        [125.791270, 6.948188]
    ],
    [
        [-81.807729, 7.287421],
        [-81.816233, 7.271308],
        [-81.800893, 7.225979],
        [-81.793446, 7.225979],
        [-81.807729, 7.287421]
    ],
    [
        [122.971690, 7.383612],
        [122.828380, 7.430813],
        [122.800548, 7.320950],
        [122.842052, 7.294257],
        [122.971690, 7.383612]
    ],
    [
        [-81.149159, 7.561184],
        [-81.174387, 7.531440],
        [-81.033070, 7.575426],
        [-81.149159, 7.561184]
    ],
    [
        [-81.664377, 7.397284],
        [-81.671783, 7.526353],
        [-81.759918, 7.644273],
        [-81.875111, 7.490424],
        [-81.664377, 7.397284]
    ],
    [
        [-82.211781, 8.199205],
        [-82.273834, 8.233344],
        [-82.315663, 8.214911],
        [-82.245961, 8.171291],
        [-82.211781, 8.199205]
    ],
    [
        [-82.342763, 8.259996],
        [-82.350006, 8.293647],
        [-82.430898, 8.259996],
        [-82.386464, 8.212877],
        [-82.342763, 8.259996]
    ],
    [
        [-79.094065, 8.308498],
        [-79.129411, 8.287243],
        [-79.122709, 8.208982],
        [-79.065741, 8.260760],
        [-79.094065, 8.308498]
    ],
    [
        [-61.016469, 8.610093],
        [-61.227610, 8.571601],
        [-61.270375, 8.514553],
        [-61.041575, 8.518541],
        [-61.016469, 8.610093]
    ],
    [
        [-60.920277, 9.028469],
        [-61.016713, 8.880316],
        [-61.091624, 8.822414],
        [-60.864980, 8.941230],
        [-60.920277, 9.028469]
    ],
    [
        [-61.085439, 8.890692],
        [-60.875640, 9.043647],
        [-60.852040, 9.096137],
        [-61.069325, 8.978827],
        [-61.085439, 8.890692]
    ],
    [
        [-60.873158, 9.116604],
        [-60.853342, 9.194037],
        [-60.961293, 9.069403],
        [-60.889719, 9.098578],
        [-60.873158, 9.116604]
    ],
    [
        [-60.817860, 9.206000],
        [-60.828969, 9.187690],
        [-60.845204, 9.116604],
        [-60.728505, 9.192939],
        [-60.817860, 9.206000]
    ],
    [
        [121.252452, 9.631171],
        [121.258637, 9.644843],
        [121.210948, 9.575873],
        [121.234630, 9.594306],
        [121.252452, 9.631171]
    ],
    [
        [106.210704, 9.620917],
        [106.155447, 9.678941],
        [106.196625, 9.571682],
        [106.284434, 9.543687],
        [106.210704, 9.620917]
    ],
    [
        [125.990245, 9.685736],
        [125.934825, 9.759914],
        [125.946951, 9.566230],
        [125.984141, 9.589504],
        [125.990245, 9.685736]
    ],
    [
        [126.569184, 7.301093],
        [126.582856, 7.719428],
        [126.383067, 7.885688],
        [126.405284, 8.492621],
        [126.110525, 8.607123],
        [126.345470, 8.853258],
        [126.219900, 9.305650],
        [126.057953, 9.245998],
        [125.972830, 9.480292],
        [125.459483, 9.822943],
        [125.516612, 9.015937],
        [125.208751, 9.086493],
        [125.105968, 8.829779],
        [124.809418, 9.009467],
        [124.753184, 8.500230],
        [124.405772, 8.607896],
        [124.232270, 8.212877],
        [123.676443, 7.963365],
        [123.882986, 8.164496],
        [123.844737, 8.452216],
        [123.397146, 8.723212],
        [123.318207, 8.533515],
        [123.042003, 8.490139],
        [122.945323, 8.161851],
        [122.251720, 7.980129],
        [121.898936, 7.057196],
        [122.154470, 6.928127],
        [122.618663, 7.774075],
        [122.814708, 7.743354],
        [122.822032, 7.459418],
        [123.006602, 7.472357],
        [123.117931, 7.741360],
        [123.140636, 7.513129],
        [123.431000, 7.368720],
        [123.444672, 7.801337],
        [123.703949, 7.809394],
        [124.246755, 7.404120],
        [123.965180, 6.832343],
        [124.201671, 6.221747],
        [124.963634, 5.858588],
        [125.250743, 6.093085],
        [125.181163, 5.798326],
        [125.371267, 5.572943],
        [125.699229, 6.040473],
        [125.589854, 6.499172],
        [125.377615, 6.674221],
        [125.668305, 7.257025],
        [125.853201, 7.336005],
        [126.200206, 6.283189],
        [126.172130, 6.903876],
        [126.339610, 6.786526],
        [126.569184, 7.301093]
    ],
    [
        [81.875987, 7.091946],
        [81.365733, 8.482164],
        [81.133962, 8.501288],
        [81.231700, 8.651068],
        [80.914887, 8.943915],
        [80.823904, 9.270494],
        [80.246755, 9.825873],
        [80.138682, 9.798733],
        [80.247813, 9.755072],
        [80.444021, 9.575873],
        [79.970714, 9.815131],
        [79.958018, 9.685736],
        [80.052989, 9.596381],
        [80.197032, 9.473456],
        [79.915538, 8.938544],
        [79.810232, 7.986518],
        [79.778575, 8.350043],
        [79.696788, 8.219062],
        [79.863048, 6.807196],
        [80.094005, 6.136054],
        [80.590831, 5.923733],
        [81.324962, 6.205390],
        [81.775645, 6.610419],
        [81.875987, 7.091946]
    ],
    [
        [125.295095, 9.970649],
        [125.229259, 10.121161],
        [125.137462, 10.165513],
        [125.273936, 9.919135],
        [125.295095, 9.970649]
    ],
    [
        [106.724132, 10.268622],
        [106.587901, 10.276923],
        [106.724132, 10.226508],
        [106.752452, 10.236070],
        [106.724132, 10.268622]
    ],
    [
        [107.172048, 10.464586],
        [107.079356, 10.391018],
        [107.087169, 10.323188],
        [107.211192, 10.425605],
        [107.172048, 10.464586]
    ],
    [
        [103.784434, 10.515041],
        [103.743419, 10.480862],
        [103.794688, 10.453559],
        [103.805919, 10.484320],
        [103.784434, 10.515041]
    ],
    [
        [106.936290, 10.439276],
        [106.927501, 10.521186],
        [106.887950, 10.370998],
        [106.977306, 10.405178],
        [106.936290, 10.439276]
    ],
    [
        [106.908946, 10.532375],
        [106.929454, 10.597561],
        [106.853770, 10.631049],
        [106.853770, 10.562812],
        [106.908946, 10.532375]
    ],
    [
        [124.379731, 10.691311],
        [124.327647, 10.704006],
        [124.284353, 10.603827],
        [124.378429, 10.628323],
        [124.379731, 10.691311]
    ],
    [
        [124.465831, 10.713609],
        [124.408458, 10.683824],
        [124.409190, 10.648261],
        [124.508800, 10.641547],
        [124.465831, 10.713609]
    ],
    [
        [103.297130, 10.731024],
        [103.245128, 10.777981],
        [103.198497, 10.762356],
        [103.277354, 10.672675],
        [103.297130, 10.731024]
    ],
    [
        [125.822032, 10.734687],
        [125.731456, 10.808051],
        [125.687266, 10.805162],
        [125.769379, 10.700385],
        [125.822032, 10.734687]
    ],
    [
        [119.632091, 11.069892],
        [119.579763, 11.097846],
        [119.613129, 11.008450],
        [119.647960, 11.015286],
        [119.632091, 11.069892]
    ],
    [
        [119.613129, 11.200263],
        [119.572927, 11.179145],
        [119.570079, 11.144355],
        [119.627696, 11.173041],
        [119.613129, 11.200263]
    ],
    [
        [124.599620, 11.563381],
        [124.523204, 11.686265],
        [124.349132, 11.680080],
        [124.472667, 11.473944],
        [124.599620, 11.563381]
    ],
    [
        [124.815196, 11.632270],
        [124.789399, 11.684882],
        [124.732677, 11.721625],
        [124.831554, 11.536322],
        [124.815196, 11.632270]
    ],
    [
        [109.328380, 12.221259],
        [109.273204, 12.235541],
        [109.245291, 12.228095],
        [109.307384, 12.187161],
        [109.328380, 12.221259]
    ],
    [
        [-68.780751, 12.097805],
        [-69.004018, 12.221666],
        [-68.977773, 12.124579],
        [-68.780751, 12.097805]
    ],
    [
        [-80.579337, 9.080687],
        [-79.792958, 9.349351],
        [-79.630335, 9.608474],
        [-78.970583, 9.573313],
        [-79.058060, 9.457931],
        [-78.452607, 9.408833],
        [-77.860097, 9.110419],
        [-76.832265, 8.136542],
        [-76.933705, 7.964586],
        [-76.767649, 7.917426],
        [-76.774810, 8.416693],
        [-76.947174, 8.545478],
        [-76.315541, 8.947740],
        [-75.943798, 9.440734],
        [-75.620633, 9.452853],
        [-75.705137, 9.700662],
        [-75.530670, 10.240668],
        [-75.703577, 10.134428],
        [-75.461822, 10.631049],
        [-74.844372, 11.109670],
        [-74.297830, 10.991499],
        [-74.596995, 10.867825],
        [-74.395090, 10.749498],
        [-74.153391, 11.343655],
        [-73.292388, 11.294013],
        [-72.263051, 11.885972],
        [-72.161977, 12.242865],
        [-71.937611, 12.166449],
        [-71.675608, 12.468329],
        [-71.261830, 12.341864],
        [-71.107493, 12.074937],
        [-71.378163, 11.758450],
        [-71.971303, 11.554836],
        [-71.576283, 10.721096],
        [-72.124379, 9.826077],
        [-71.995229, 9.459215],
        [-71.734527, 9.384711],
        [-71.816518, 9.233303],
        [-71.645904, 9.049628],
        [-71.072825, 9.313544],
        [-71.035064, 9.740383],
        [-71.583119, 10.809231],
        [-71.445912, 10.796210],
        [-71.501129, 10.960028],
        [-70.036529, 11.440904],
        [-70.161598, 11.568545],
        [-69.794911, 11.436713],
        [-69.816029, 11.693671],
        [-70.211781, 11.609076],
        [-70.301991, 11.858140],
        [-70.017730, 12.198920],
        [-69.623606, 11.467760],
        [-68.863189, 11.452867],
        [-68.403310, 11.200263],
        [-68.129547, 10.487738],
        [-66.275868, 10.652167],
        [-66.046539, 10.576483],
        [-65.923004, 10.282213],
        [-65.083974, 10.047512],
        [-64.188547, 10.477607],
        [-64.233876, 10.515041],
        [-64.270741, 10.672675],
        [-61.864817, 10.744818],
        [-62.334950, 10.530219],
        [-62.662343, 10.567043],
        [-62.923329, 10.530829],
        [-63.010813, 10.453559],
        [-62.857004, 10.531562],
        [-62.831125, 10.406806],
        [-62.995188, 10.407864],
        [-63.003977, 10.275377],
        [-62.764475, 10.395331],
        [-62.626576, 10.130805],
        [-63.017649, 10.103461],
        [-62.801096, 9.995998],
        [-62.618520, 10.091620],
        [-62.579945, 10.224433],
        [-62.318715, 9.706244],
        [-62.221995, 9.938381],
        [-62.195180, 9.932807],
        [-62.027333, 9.874416],
        [-61.831451, 9.791938],
        [-61.845774, 9.651028],
        [-61.780100, 9.759223],
        [-61.743316, 9.596381],
        [-61.731028, 9.694037],
        [-61.828172, 9.827158],
        [-61.592519, 9.781968],
        [-61.636735, 9.898771],
        [-60.862294, 9.456122],
        [-60.785390, 9.313544],
        [-60.959137, 9.182522],
        [-61.209462, 8.609036],
        [-61.598744, 8.555487],
        [-61.284047, 8.397203],
        [-61.026601, 8.500922],
        [-61.077992, 8.466457],
        [-61.071889, 8.403306],
        [-60.975575, 8.575995],
        [-60.197825, 8.623847],
        [-59.104807, 8.013617],
        [-58.471588, 7.345404],
        [-58.679596, 6.376207],
        [-58.398427, 6.883368],
        [-58.005675, 6.791758],
        [-57.528913, 6.265709],
        [-57.186660, 6.121188],
        [-57.247670, 5.484931],
        [-56.956537, 6.011574],
        [-55.936006, 5.804661],
        [-55.897694, 5.676703],
        [-55.867990, 5.969813],
        [-55.129872, 5.820746],
        [-54.863026, 5.855536],
        [-55.144500, 5.974248],
        [-54.773590, 5.985256],
        [-54.020462, 5.830250],
        [-54.170969, 5.348375],
        [-53.944350, 5.744641],
        [-52.994581, 5.457624],
        [-52.279124, 4.931220],
        [-52.340484, 4.724595],
        [-52.231923, 4.875434],
        [-52.024526, 4.693549],
        [-52.046295, 4.333564],
        [-51.909169, 4.655707],
        [-51.801503, 4.612698],
        [-51.683217, 4.039374],
        [-51.571604, 4.235419],
        [-51.560048, 4.369371],
        [-51.389230, 4.358902],
        [-51.186930, 4.078849],
        [-51.176137, 3.648342],
        [-51.079905, 3.882270],
        [-51.079385, 3.492087]
    ],
    [
        [-69.996938, 12.577582],
        [-70.061106, 12.625393],
        [-69.888092, 12.417670],
        [-69.924672, 12.519232],
        [-69.996938, 12.577582]
    ],
    [
        [80.968272, 15.795233],
        [80.888357, 15.846747],
        [80.868500, 15.811957],
        [80.942638, 15.741034],
        [80.968272, 15.795233]
    ],
    [
        [-71.524485, 17.545559],
        [-71.467112, 17.580268],
        [-71.521067, 17.621283],
        [-71.541371, 17.576158],
        [-71.524485, 17.545559]
    ],
    [
        [-73.628896, 18.094224],
        [-73.699941, 18.108303],
        [-73.707672, 18.094224],
        [-73.577992, 18.066962],
        [-73.628896, 18.094224]
    ],
    [
        [4.641856, 6.210883],
        [5.044688, 5.767483],
        [5.102712, 5.793199],
        [5.129161, 5.628119],
        [5.337576, 5.724555],
        [5.326020, 5.605414],
        [5.447439, 5.656236],
        [5.509613, 5.590644],
        [5.222830, 5.581204],
        [5.263194, 5.436510],
        [5.639903, 5.540188],
        [5.577891, 5.381985],
        [5.345714, 5.357164],
        [5.365571, 5.163479],
        [5.450857, 5.190131],
        [5.495860, 5.142320],
        [5.385997, 5.125556],
        [5.566905, 4.675238],
        [5.946300, 4.335191],
        [6.061778, 4.295233],
        [6.055431, 4.419867],
        [6.096690, 4.278144],
        [6.217052, 4.290595],
        [6.242524, 4.498033],
        [6.270518, 4.292629],
        [6.569591, 4.334906],
        [6.580821, 4.507880],
        [6.687673, 4.336575],
        [6.654063, 4.511705],
        [6.736095, 4.607896],
        [6.715587, 4.354682],
        [6.870779, 4.360785],
        [6.880056, 4.388170],
        [7.022146, 4.388495],
        [7.043956, 4.436591],
        [7.178233, 4.501451],
        [7.071788, 4.758124],
        [7.281016, 4.504869],
        [7.544770, 4.711005],
        [7.558442, 4.525336],
        [8.288585, 4.548570],
        [8.181651, 4.991441],
        [8.469005, 4.711656],
        [8.592459, 4.820217],
        [8.525564, 4.511705],
        [8.722667, 4.513129],
        [8.645356, 4.684068],
        [8.655121, 4.738267],
        [8.901622, 4.587388],
        [8.971202, 4.100775],
        [9.210704, 3.964260],
        [9.464041, 3.909980],
        [9.478526, 4.111396],
        [9.579356, 4.013007],
        [9.754568, 4.135688],
        [9.618907, 3.960354],
        [9.764415, 3.957465],
        [9.744477, 3.819648],
        [9.545909, 3.819648],
        [9.626231, 3.600002],
        [9.787608, 3.637112],
        [9.819591, 3.627875],
        [9.642100, 3.539049],
        [9.958018, 3.082221],
        [9.809744, 1.934963],
        [9.607270, 1.644436],
        [9.744477, 1.600043],
        [9.346690, 1.181708],
        [9.847504, 1.072455],
        [9.566417, 0.983100],
        [9.607921, 0.469184],
        [9.539073, 0.681464],
        [9.305675, 0.544257],
        [9.498057, 0.290961],
        [10.025645, 0.187974],
        [9.758556, 0.125556],
        [9.812185, 0.023505],
        [9.488048, 0.098334],
        [9.345388, 0.355780],
        [9.306488, -0.332289],
        [9.011485, -0.874607],
        [8.695567, -0.586602],
        [9.030040, -1.299086],
        [9.185720, -1.410577],
        [9.335460, -1.283380],
        [9.286632, -1.566095],
        [9.456554, -1.470473],
        [9.559581, -1.607599],
        [9.280284, -1.675063],
        [9.264659, -1.535333],
        [9.159190, -1.468032],
        [9.019379, -1.304783],
        [9.255382, -1.835219],
        [9.517751, -1.926446],
        [9.543224, -2.070896],
        [9.467296, -1.922459],
        [9.271251, -1.876642],
        [9.619802, -2.381768],
        [10.137462, -2.527439],
        [9.977306, -2.628676],
        [9.703461, -2.443048],
        [11.806409, -4.577118],
        [11.994314, -5.005792],
        [12.132476, -5.005899],
        [12.023123, -5.045994],
        [12.232188, -5.479587],
        [12.161794, -5.681248],
        [12.396563, -6.005963],
        [12.275060, -6.114769],
        [12.833507, -6.912286],
        [12.849963, -7.265919],
        [13.378917, -8.347101],
        [13.380138, -8.755060],
        [12.996349, -9.093845],
        [13.847423, -11.055434]
    ],
    [
        [19.291677, 30.287055],
        [18.925955, 30.293362],
        [17.365896, 31.086615],
        [15.761485, 31.388129],
        [15.181977, 32.395494],
        [13.351736, 32.904242],
        [12.303884, 32.843085],
        [11.179535, 33.211086],
        [11.133637, 33.311428],
        [11.293712, 33.286811],
        [11.102074, 33.364081],
        [11.042817, 33.617865],
        [10.738129, 33.478013],
        [10.716645, 33.706936],
        [10.446056, 33.655422],
        [10.172699, 33.828070],
        [10.005219, 34.170640],
        [10.597023, 34.544713],
        [11.159160, 35.218757],
        [11.040998, 35.637730],
        [10.622081, 35.842597],
        [10.474695, 36.112486],
        [10.550928, 36.377256],
        [10.799929, 36.451885],
        [11.130545, 36.854039],
        [11.033376, 37.087470],
        [10.403005, 36.726711],
        [10.188487, 36.797593],
        [10.347179, 36.880276],
        [10.128103, 37.158677],
        [10.272146, 37.178534],
        [9.882498, 37.263577],
        [9.815929, 37.151842],
        [9.858897, 37.328803],
        [9.744640, 37.345201],
        [8.802013, 36.973090],
        [7.908458, 36.849555],
        [7.383474, 37.082994],
        [6.948578, 36.890041],
        [6.415782, 37.092963],
        [5.304373, 36.643012],
        [4.769054, 36.898017],
        [2.977061, 36.815863],
        [2.600759, 36.596340],
        [0.945567, 36.452338],
        [0.342296, 36.205959],
        [-0.038482, 35.813300],
        [-0.348541, 35.907050],
        [-0.825022, 35.768541],
        [-1.364003, 35.318345],
        [-1.956451, 35.075019],
        [-2.878407, 35.246324],
        [-2.748118, 35.115953],
        [-2.856068, 35.131293],
        [-2.968577, 35.446438],
        [-3.362050, 35.194525],
        [-4.628285, 35.205390],
        [-5.249420, 35.584621],
        [-5.283070, 35.911689],
        [-5.405490, 35.926519],
        [-5.927235, 35.780748],
        [-6.292104, 34.880805],
        [-6.927358, 33.944159],
        [-8.529164, 33.268704],
        [-9.259918, 32.576890],
        [-9.277740, 32.196601],
        [-9.847524, 31.402411],
        [-9.888539, 30.648261],
        [-9.607330, 30.377631],
        [-9.820221, 29.838935],
        [-10.450917, 29.092190],
        [-11.485585, 28.325629],
        [-12.968088, 27.914618],
        [-13.561106, 26.749091],
        [-14.466135, 26.194241],
        [-14.907826, 24.685492],
        [-15.840932, 23.902655],
        [-15.775136, 23.911933],
        [-16.466624, 22.377387],
        [-16.921010, 21.931301],
        [-17.104644, 20.862494],
        [-17.056874, 20.766913],
        [-16.917592, 21.159166],
        [-16.672678, 20.677558],
        [-16.542348, 20.560858],
        [-16.529286, 20.738959],
        [-16.408681, 20.675035],
        [-16.202260, 20.233303],
        [-16.233795, 19.793647],
        [-16.422515, 19.543850],
        [-16.465077, 19.412543],
        [-16.284901, 19.529283],
        [-16.359202, 19.415839],
        [-16.535471, 19.380805],
        [-16.204579, 18.982733],
        [-16.048980, 17.667182],
        [-16.459218, 16.643948],
        [-16.538930, 15.774359],
        [-17.138661, 14.927720],
        [-17.536041, 14.757392],
        [-17.224110, 14.690416],
        [-16.956532, 14.390123],
        [-16.775054, 13.838813],
        [-16.727895, 14.064683],
        [-16.654164, 14.002753],
        [-16.468739, 14.193834],
        [-16.364735, 14.167792],
        [-16.576405, 13.988959],
        [-16.746816, 13.951361],
        [-16.700063, 13.769029],
        [-16.487050, 14.002631],
        [-16.640004, 13.696479],
        [-16.508901, 13.740220],
        [-16.521840, 13.359036],
        [-16.321889, 13.342841],
        [-16.160390, 13.450588],
        [-15.556142, 13.528306],
        [-15.294749, 13.496161],
        [-16.161204, 13.428697],
        [-16.151275, 13.276435],
        [-16.419423, 13.208197],
        [-16.678822, 13.496161],
        [-16.829701, 13.338528],
        [-16.754628, 12.572211],
        [-16.596913, 12.797309],
        [-16.634674, 12.669379],
        [-16.370961, 12.564521],
        [-16.323842, 12.609565],
        [-16.076812, 12.638983],
        [-16.022125, 12.728990],
        [-15.641021, 12.559475],
        [-15.549469, 12.794338],
        [-15.453033, 12.831448],
        [-15.407053, 12.822333],
        [-15.391591, 12.838202],
        [-15.394032, 12.810248],
        [-15.633412, 12.539537],
        [-16.533315, 12.565334],
        [-16.579742, 12.632799],
        [-16.798736, 12.430894],
        [-16.457631, 12.171942],
        [-16.316396, 12.282701],
        [-16.063140, 12.351020],
        [-16.355133, 12.087348],
        [-16.124582, 11.885443],
        [-15.863881, 12.029486],
        [-15.713694, 12.015815],
        [-15.865346, 11.972235],
        [-15.958974, 11.734809],
        [-15.795562, 11.885443],
        [-15.830393, 11.748358],
        [-15.404408, 11.967231],
        [-14.994008, 11.963690],
        [-15.070221, 11.860745],
        [-14.935902, 11.752997],
        [-15.069447, 11.803616],
        [-15.087148, 11.870347],
        [-15.066965, 11.940131],
        [-15.517893, 11.792670],
        [-15.438710, 11.557115],
        [-15.226471, 11.755113],
        [-15.007314, 11.611762],
        [-15.281117, 11.624823],
        [-15.502675, 11.336656],
        [-15.268056, 11.433010],
        [-15.426137, 11.286526],
        [-15.358225, 11.144232],
        [-15.206614, 11.233791],
        [-15.230133, 10.994818],
        [-15.000885, 11.216783],
        [-15.117177, 10.984280],
        [-15.013905, 10.782620],
        [-14.918568, 11.028957],
        [-14.685170, 11.063666],
        [-14.792836, 10.745022],
        [-14.651357, 10.809963],
        [-14.686106, 10.648179],
        [-14.500234, 10.891099],
        [-14.664703, 10.511623],
        [-14.535024, 10.508205],
        [-14.462636, 10.225165],
        [-14.137766, 10.179185],
        [-14.130279, 10.048896],
        [-14.089345, 10.138251],
        [-13.999908, 10.199693],
        [-14.058339, 10.025295],
        [-13.827707, 9.855373],
        [-13.685292, 9.946479],
        [-13.728912, 9.744086],
        [-13.561106, 9.788235],
        [-13.726226, 9.511054],
        [-13.486684, 9.569078],
        [-13.407786, 9.287014],
        [-13.301096, 9.356838],
        [-13.315297, 9.182074],
        [-13.157704, 9.185492],
        [-13.288442, 8.969468],
        [-12.985707, 8.857123],
        [-13.240224, 8.825832],
        [-13.168528, 8.525214],
        [-13.157704, 8.670966],
        [-12.875885, 8.685207],
        [-13.116119, 8.472968],
        [-13.033559, 8.376695],
        [-13.286773, 8.500230],
        [-13.163930, 8.171291],
        [-12.972076, 8.253852],
        [-12.821278, 7.917426],
        [-12.959096, 7.911200],
        [-12.701243, 7.708075],
        [-12.601877, 7.683783],
        [-12.472157, 7.787665],
        [-12.451975, 7.774075],
        [-12.463735, 7.561998],
        [-12.183827, 7.602729],
        [-12.506581, 7.389838],
        [-11.567494, 6.992621],
        [-9.104970, 5.031562],
        [-7.593251, 4.347235],
        [-5.851308, 5.029975],
        [-5.002431, 5.128648],
        [-5.228424, 5.204413],
        [-5.186920, 5.164252],
        [-5.308827, 5.118150],
        [-5.357900, 5.123521],
        [-5.398997, 5.141995],
        [-5.321523, 5.230211],
        [-4.892649, 5.128648],
        [-4.808583, 5.180487],
        [-4.673451, 5.313625],
        [-4.687164, 5.231676],
        [-3.906321, 5.348375],
        [-3.743967, 5.273993],
        [-3.767242, 5.371527],
        [-3.715688, 5.282294],
        [-3.775380, 5.244778],
        [-3.312164, 5.119940],
        [-3.134429, 5.366767],
        [-3.139150, 5.142320],
        [-2.879384, 5.181342],
        [-2.843658, 5.149115],
        [-3.276357, 5.118109],
        [-1.981435, 4.752427],
        [0.243337, 5.756171],
        [0.954845, 5.791083],
        [1.271007, 6.133734],
        [3.384532, 6.397691],
        [3.369802, 6.450019],
        [3.402354, 6.552151],
        [3.481212, 6.602200],
        [3.857921, 6.602200],
        [3.421153, 6.414008],
        [4.125824, 6.410346],
        [4.641856, 6.210883]
    ],
    [
        [-114.775543, 18.354926],
        [-114.798573, 18.330878],
        [-114.720855, 18.345689],
        [-114.724029, 18.354926],
        [-114.775543, 18.354926]
    ],
    [
        [-73.796498, 18.628648],
        [-73.769521, 18.588365],
        [-73.714589, 18.601304],
        [-73.739980, 18.636868],
        [-73.796498, 18.628648]
    ],
    [
        [122.297211, 18.403876],
        [122.135753, 17.737291],
        [122.529063, 17.090522],
        [122.203868, 16.236518],
        [121.567393, 15.915717],
        [121.629161, 15.661119],
        [121.391124, 15.266262],
        [121.724946, 14.730780],
        [121.608165, 14.630194],
        [121.731619, 14.188218],
        [121.936290, 13.995185],
        [122.231944, 13.906440],
        [122.313731, 14.016303],
        [122.208669, 14.087633],
        [122.162934, 14.167792],
        [122.263682, 14.247382],
        [122.300141, 14.092027],
        [122.416270, 14.324774],
        [122.679861, 14.350531],
        [123.042247, 14.098049],
        [123.108246, 13.722113],
        [123.301768, 13.789455],
        [123.335460, 13.982164],
        [123.218110, 13.992743],
        [123.331798, 14.099514],
        [123.417328, 13.906440],
        [123.937755, 13.784003],
        [123.526622, 13.606024],
        [123.855642, 13.228664],
        [123.745779, 13.064154],
        [124.184581, 13.057318],
        [124.054942, 12.537258],
        [123.793630, 12.831448],
        [123.725352, 12.845120],
        [123.310069, 13.012356],
        [123.168793, 13.449205],
        [122.536876, 13.961127],
        [122.413097, 13.948065],
        [122.672699, 13.379299],
        [122.588145, 13.174018],
        [122.369477, 13.549791],
        [121.724864, 13.969143],
        [121.278819, 13.595038],
        [121.038910, 13.632758],
        [121.003754, 13.780911],
        [120.887462, 13.693508],
        [120.876720, 13.912258],
        [120.649669, 13.784247],
        [120.573497, 14.174547],
        [120.970388, 14.501899],
        [120.943126, 14.653510],
        [120.585704, 14.902818],
        [120.588390, 14.466986],
        [120.402110, 14.455756],
        [120.292247, 14.825670],
        [120.079926, 14.803941],
        [119.888194, 15.429023],
        [119.801931, 16.357856],
        [120.138845, 16.046129],
        [120.402110, 16.165473],
        [120.276134, 16.611884],
        [120.436290, 17.008002],
        [120.333832, 17.556383],
        [120.570160, 18.501776],
        [121.106781, 18.642727],
        [121.649669, 18.313951],
        [121.986827, 18.290432],
        [122.152843, 18.518785],
        [122.297211, 18.403876]
    ],
    [
        [-110.945912, 18.799994],
        [-111.000559, 18.868232],
        [-111.067250, 18.768744],
        [-110.924306, 18.727362],
        [-110.945912, 18.799994]
    ],
    [
        [-110.814320, 19.348049],
        [-110.836049, 19.293402],
        [-110.830230, 19.273342],
        [-110.787668, 19.313910],
        [-110.814320, 19.348049]
    ],
    [
        [-72.850575, 20.088528],
        [-72.960357, 20.061225],
        [-72.627553, 20.008246],
        [-72.802398, 20.087226],
        [-72.850575, 20.088528]
    ],
    [
        [111.010509, 19.683783],
        [110.934581, 19.995063],
        [110.677908, 20.163560],
        [110.605805, 19.923163],
        [110.382986, 20.081041],
        [110.417735, 19.923407],
        [110.156993, 20.067369],
        [109.990082, 19.905951],
        [109.719005, 20.010647],
        [109.527029, 19.951361],
        [109.581716, 19.855699],
        [109.255138, 19.898342],
        [109.163341, 19.724799],
        [109.273204, 19.793647],
        [109.307384, 19.711127],
        [108.626964, 19.274970],
        [108.684906, 18.515204],
        [109.708751, 18.207221],
        [109.746104, 18.395901],
        [110.040294, 18.382270],
        [110.034190, 18.511949],
        [110.534434, 18.785631],
        [110.479177, 19.169257],
        [111.010509, 19.683783]
    ],
    [
        [-106.224038, 21.328736],
        [-106.260005, 21.334097],
        [-106.279363, 21.314659],
        [-106.227506, 21.291166],
        [-106.224038, 21.328736]
    ],
    [
        [-106.404218, 21.483886],
        [-106.459587, 21.494885],
        [-106.492614, 21.469005],
        [-106.387098, 21.420636],
        [-106.404218, 21.483886]
    ],
    [
        [-72.999572, 21.451708],
        [-72.910438, 21.504850],
        [-72.991526, 21.561998],
        [-73.076234, 21.506796],
        [-72.999572, 21.451708]
    ],
    [
        [111.962657, 21.657620],
        [111.835297, 21.643948],
        [111.809337, 21.565497],
        [111.999848, 21.621161],
        [111.962657, 21.657620]
    ],
    [
        [-106.512353, 21.597034],
        [-106.548004, 21.668546],
        [-106.660848, 21.693064],
        [-106.631156, 21.600861],
        [-106.512353, 21.597034]
    ],
    [
        [-72.460764, 21.705390],
        [-72.463368, 21.664944],
        [-72.481313, 21.630316],
        [-72.433258, 21.680121],
        [-72.460764, 21.705390]
    ],
    [
        [112.645356, 21.712836],
        [112.555919, 21.678127],
        [112.525401, 21.598863],
        [112.650401, 21.640448],
        [112.645356, 21.712836]
    ],
    [
        [-71.507965, 21.705390],
        [-71.459584, 21.664455],
        [-71.480946, 21.725491],
        [-71.590566, 21.753811],
        [-71.507965, 21.705390]
    ],
    [
        [112.844005, 21.774319],
        [112.711681, 21.702541],
        [112.764903, 21.581855],
        [112.810557, 21.589301],
        [112.844005, 21.774319]
    ],
    [
        [-106.663823, 21.777246],
        [-106.688941, 21.746832],
        [-106.678963, 21.727036],
        [-106.657766, 21.739878],
        [-106.663823, 21.777246]
    ],
    [
        [-71.802846, 21.787909],
        [-71.679311, 21.822089],
        [-71.630930, 21.774319],
        [-71.678782, 21.841864],
        [-71.850657, 21.856269],
        [-71.802846, 21.787909]
    ],
    [
        [-72.337229, 21.800971],
        [-72.291860, 21.748928],
        [-72.124379, 21.815253],
        [-72.330434, 21.862454],
        [-72.337229, 21.800971]
    ],
    [
        [-72.021962, 21.904608],
        [-71.947581, 21.942450],
        [-71.954254, 21.866929],
        [-71.894643, 21.832180],
        [-71.857411, 21.843166],
        [-71.911041, 21.948432],
        [-72.017445, 21.956936],
        [-72.021962, 21.904608]
    ],
    [
        [113.391449, 22.027533],
        [113.382660, 22.089586],
        [113.309418, 22.024115],
        [113.405772, 22.007025],
        [113.391449, 22.027533]
    ],
    [
        [113.364757, 22.157904],
        [113.271739, 22.120022],
        [113.279145, 22.074693],
        [113.313650, 22.076402],
        [113.364757, 22.157904]
    ],
    [
        [-73.139150, 22.363349],
        [-72.779449, 22.288235],
        [-72.746165, 22.331285],
        [-73.131703, 22.459540],
        [-73.139150, 22.363349]
    ],
    [
        [-73.468736, 22.587662],
        [-73.501186, 22.610930],
        [-73.558853, 22.611723],
        [-73.556419, 22.606474],
        [-73.468736, 22.587662]
    ],
    [
        [113.593516, 22.784817],
        [113.475597, 22.900702],
        [113.396169, 22.898098],
        [113.558279, 22.757880],
        [113.593516, 22.784817]
    ],
    [
        [117.071544, 23.473090],
        [116.982188, 23.459459],
        [116.942989, 23.430062],
        [117.128781, 23.399369],
        [117.071544, 23.473090]
    ],
    [
        [117.468901, 23.753090],
        [117.372732, 23.766750],
        [117.320483, 23.574016],
        [117.431559, 23.582630],
        [117.468901, 23.753090]
    ],
    [
        [-109.835750, 24.224654],
        [-109.919246, 24.362029],
        [-109.933220, 24.374414],
        [-109.835750, 24.224654]
    ],
    [
        [-111.561635, 24.378079],
        [-111.657778, 24.375217],
        [-111.673254, 24.358401],
        [-111.462958, 24.329771],
        [-111.561635, 24.378079]
    ],
    [
        [-111.753489, 24.446967],
        [-111.864395, 24.520479],
        [-112.006844, 24.514400],
        [-111.708111, 24.299854],
        [-111.753489, 24.446967]
    ],
    [
        [-110.324941, 24.515855],
        [-110.415745, 24.569601],
        [-110.348040, 24.402451],
        [-110.287863, 24.469742],
        [-110.324941, 24.515855]
    ],
    [
        [-110.710792, 25.095047],
        [-110.642313, 24.914498],
        [-110.524929, 24.880001],
        [-110.574916, 25.015727],
        [-110.710792, 25.095047]
    ],
    [
        [42.712087, -0.176690],
        [44.332774, 1.389960],
        [46.047618, 2.455064],
        [47.948497, 4.457099],
        [49.036143, 6.144232],
        [49.824229, 7.933905],
        [50.830333, 9.419623],
        [50.927389, 10.327844],
        [51.397509, 10.395793],
        [51.176117, 10.562812],
        [51.220388, 10.442043],
        [51.010102, 10.434027],
        [51.160655, 10.598456],
        [51.081309, 11.341498],
        [51.292698, 11.833108],
        [50.771983, 11.985785],
        [50.072520, 11.508734],
        [48.976817, 11.251410],
        [48.521983, 11.319281],
        [48.130382, 11.136664],
        [47.405935, 11.184638],
        [46.447765, 10.693101],
        [45.769298, 10.878119],
        [44.962009, 10.415799],
        [44.586149, 10.383585],
        [43.829600, 10.802965],
        [43.489431, 11.380927],
        [43.151866, 11.611762],
        [42.538748, 11.502997],
        [43.398774, 12.029527],
        [43.329356, 12.488756],
        [43.029470, 12.878852],
        [42.781261, 12.851874],
        [42.533946, 13.232571],
        [42.379405, 13.222642],
        [42.288422, 13.574612],
        [41.676524, 13.940253],
        [41.167491, 14.636949],
        [40.766449, 14.695299],
        [40.512706, 15.017483],
        [40.159434, 14.982245],
        [40.079926, 15.340725],
        [39.875255, 15.504096],
        [39.854666, 15.173489],
        [39.715587, 15.094062],
        [38.584483, 18.077135],
        [38.217296, 18.217719],
        [38.276215, 18.242011],
        [38.306163, 18.306545],
        [38.151674, 18.249331],
        [37.925505, 18.585044],
        [37.434337, 18.861721],
        [37.104991, 21.207506],
        [37.312999, 21.057685],
        [36.887869, 21.650133],
        [36.895383, 22.066133],
        [35.695305, 22.932126],
        [35.483871, 23.917787],
        [35.792535, 23.902291],
        [35.144556, 24.500206],
        [34.853201, 25.138821]
    ],
    [
        [34.853201, 25.138821],
        [33.941417, 26.653510],
        [33.996104, 26.896552],
        [33.496349, 27.646633],
        [33.554373, 27.896470],
        [32.625499, 28.972724],
        [32.591482, 29.349514],
        [32.337657, 29.592475],
        [32.571544, 30.011420],
        [32.715017, 29.455959],
        [33.177908, 28.989569],
        [33.228689, 28.569403],
        [34.249848, 27.728583],
        [34.434906, 27.975572],
        [34.406912, 28.308010],
        [34.736583, 29.311265],
        [34.996837, 29.533881],
        [34.574392, 28.094062],
        [35.216319, 28.054389],
        [37.242198, 25.175279],
        [37.148611, 24.851020],
        [37.429403, 24.367307],
        [37.947950, 24.207047],
        [38.452647, 23.784003],
        [39.142751, 22.403225],
        [38.931254, 22.006073],
        [39.109060, 21.747789],
        [39.174327, 21.108873],
        [39.760102, 20.350816],
        [40.083832, 20.279242],
        [40.744884, 19.777004],
        [41.493337, 18.223944],
        [42.301524, 17.453599],
        [42.356700, 17.182440],
        [42.712413, 16.730618],
        [42.809093, 15.267768],
        [42.712413, 15.366278],
        [42.610118, 15.243598],
        [42.937266, 14.948472],
        [43.462250, 12.693345],
        [43.946300, 12.598049],
        [44.610606, 12.819566],
        [45.058604, 12.762030],
        [45.118175, 12.961737],
        [45.665782, 13.341986],
        [46.700694, 13.430325],
        [48.016856, 14.057278],
        [48.695811, 14.043606],
        [49.372406, 14.649807],
        [51.676443, 15.340277],
        [52.233572, 15.621772],
        [52.221446, 16.160875],
        [52.597667, 16.476711],
        [54.084972, 17.011135],
        [55.026866, 17.011135],
        [55.260265, 17.234280],
        [55.228201, 17.538764],
        [55.445160, 17.841010],
        [56.356293, 17.940009],
        [56.807791, 18.745592],
        [57.840099, 19.015326],
        [57.689220, 19.728176],
        [57.856130, 20.260647],
        [58.205740, 20.613349],
        [58.202891, 20.404731],
        [58.518565, 20.416815],
        [58.680349, 20.828355],
        [59.344249, 21.444729],
        [59.824880, 22.281399],
        [59.803233, 22.534735],
        [59.515798, 22.561510],
        [58.762055, 23.542060],
        [57.184255, 23.934272],
        [56.611176, 24.496324],
        [56.266612, 25.672593],
        [56.472992, 26.098619],
        [56.328787, 26.172838],
        [56.479828, 26.145819],
        [56.500987, 26.358710],
        [56.363780, 26.385972],
        [56.404145, 26.214748],
        [56.181814, 26.245998],
        [55.952322, 25.772121],
        [55.551036, 25.578599],
        [55.328868, 25.201483],
        [54.643321, 24.748684],
        [54.581798, 24.508450],
        [54.417328, 24.535102],
        [54.571300, 24.473334],
        [54.574392, 24.446967],
        [54.427257, 24.292141],
        [54.122569, 24.144721],
        [53.589610, 24.047065],
        [52.600271, 24.209540],
        [52.341075, 24.007514],
        [51.928722, 23.964748],
        [51.593761, 24.384914],
        [51.569347, 24.256171],
        [51.282237, 24.302965],
        [51.498302, 24.583564],
        [51.302419, 24.517157],
        [51.212576, 24.633694],
        [51.340587, 24.569892],
        [51.611013, 25.022366],
        [51.471934, 25.521389],
        [51.570323, 25.898383],
        [51.251231, 26.160102],
        [50.984223, 25.981350],
        [50.977550, 25.646145],
        [50.750987, 25.494696],
        [50.771332, 24.726955],
        [50.471528, 25.437201],
        [49.990001, 26.001776],
        [50.032400, 26.201077],
        [50.141368, 26.035956],
        [50.216563, 26.323920],
        [49.988455, 26.724433],
        [50.158458, 26.664862],
        [49.572113, 27.194159],
        [49.374848, 27.149075],
        [49.119802, 27.441148],
        [49.312755, 27.448635],
        [49.239757, 27.545111],
        [48.831798, 27.612494],
        [48.882660, 27.826728],
        [48.468761, 28.387112],
        [48.100266, 29.349954],
        [47.704717, 29.363633],
        [47.965531, 29.576298]
    ],
    [
        [-112.103485, 24.617166],
        [-112.136464, 24.632882],
        [-112.115623, 24.689301],
        [-112.213715, 24.847527],
        [-112.304596, 24.792182],
        [-112.059907, 24.540603],
        [-112.103485, 24.617166]
    ],
    [
        [121.905772, 24.950100],
        [122.005382, 25.001899],
        [121.580821, 25.283026],
        [121.059337, 25.050238],
        [120.184418, 23.764390],
        [120.055186, 23.043687],
        [120.621267, 22.295071],
        [120.714366, 21.937486],
        [120.840343, 21.904608],
        [120.948253, 22.526801],
        [121.400076, 23.145494],
        [121.905772, 24.950100]
    ],
    [
        [-108.831614, 25.426418],
        [-108.900990, 25.446519],
        [-109.013092, 25.446926],
        [-108.786529, 25.385443],
        [-108.831614, 25.426418]
    ],
    [
        [-97.224965, 25.584418],
        [-97.143178, 26.047756],
        [-97.255605, 25.998928],
        [-97.562001, 26.837877],
        [-97.426096, 27.263658],
        [-97.760569, 27.279120],
        [-97.774281, 27.468492],
        [-97.630238, 27.300238],
        [-97.411204, 27.335028],
        [-97.259592, 27.695054],
        [-97.521067, 27.873196],
        [-97.184071, 27.836615],
        [-97.021067, 28.100328],
        [-97.149078, 28.005520],
        [-97.173248, 28.159003],
        [-96.910308, 28.263617],
        [-96.880238, 28.150621],
        [-96.793324, 28.479722],
        [-96.653717, 28.319485],
        [-96.403798, 28.434882],
        [-96.493235, 28.578925],
        [-96.369700, 28.626654],
        [-96.444814, 28.763861],
        [-96.188059, 28.690863],
        [-96.226471, 28.587144],
        [-95.987782, 28.644843],
        [-95.158925, 29.045722],
        [-95.170522, 29.208930],
        [-94.821116, 29.373969],
        [-95.052280, 29.749748],
        [-94.919597, 29.655327],
        [-94.734055, 29.782241],
        [-94.779050, 29.529877],
        [-94.485951, 29.566107],
        [-94.700999, 29.462795],
        [-94.762766, 29.366523],
        [-93.875803, 29.675035],
        [-93.938112, 29.805903],
        [-93.854075, 29.986558],
        [-93.831028, 29.700135],
        [-93.199593, 29.772811],
        [-92.314307, 29.534369],
        [-92.024892, 29.627265],
        [-92.202382, 29.764390],
        [-91.847524, 29.831244],
        [-91.559316, 29.538479],
        [-91.298655, 29.483832],
        [-91.228383, 29.608059],
        [-91.113108, 29.270982],
        [-91.327992, 29.294867],
        [-90.884023, 29.133775],
        [-90.640736, 29.140611],
        [-90.434438, 29.357245],
        [-90.229237, 29.086656],
        [-90.017568, 29.298285],
        [-90.182037, 29.579495],
        [-89.816314, 29.474351],
        [-89.818146, 29.316160],
        [-89.276194, 29.160102],
        [-89.413645, 28.928371],
        [-89.010162, 29.174750],
        [-89.756907, 29.634101],
        [-89.482533, 29.634101],
        [-89.601471, 29.734849],
        [-89.345326, 29.791693],
        [-89.366038, 30.048651],
        [-89.664540, 29.875474],
        [-89.840403, 30.011420],
        [-89.717926, 30.033271],
        [-89.667388, 30.164008],
        [-90.168365, 30.024482],
        [-90.405019, 30.220160],
        [-90.189443, 30.390815],
        [-89.595937, 30.155911],
        [-88.927642, 30.442206],
        [-88.137685, 30.319770],
        [-88.030141, 30.737698],
        [-87.764231, 30.279527],
        [-87.590159, 30.275377],
        [-87.426829, 30.483140],
        [-87.529205, 30.277737],
        [-87.328847, 30.319729],
        [-87.029612, 30.607327],
        [-86.893788, 30.438910],
        [-86.207143, 30.504869],
        [-86.107777, 30.386705],
        [-86.510894, 30.407620],
        [-85.720530, 30.134345],
        [-85.854360, 30.264838],
        [-85.586781, 30.326117],
        [-85.720530, 30.195787],
        [-85.679555, 30.134345],
        [-85.356516, 29.888739],
        [-85.346099, 29.678371],
        [-84.377349, 29.887356],
        [-84.466135, 29.989691],
        [-84.209137, 30.107082],
        [-83.680572, 29.921291],
        [-82.633616, 28.887641],
        [-82.842397, 27.828518],
        [-82.815094, 27.832221],
        [-82.654042, 27.695054],
        [-82.561879, 27.886176],
        [-82.690989, 28.037665],
        [-82.541127, 27.942776],
        [-82.527089, 27.824774],
        [-82.421742, 27.917182],
        [-82.589182, 27.503241],
        [-82.729156, 27.514716],
        [-82.313832, 26.849351],
        [-82.150258, 26.803168],
        [-82.273834, 27.016018],
        [-81.978383, 26.996161],
        [-82.096995, 26.909369],
        [-82.039052, 26.527899],
        [-81.951731, 26.543647],
        [-81.906728, 26.642646],
        [-81.780385, 26.714993],
        [-82.008656, 26.484524],
        [-81.855946, 26.448879],
        [-81.732004, 25.920478],
        [-81.348459, 25.816840],
        [-80.917226, 25.245754],
        [-81.129954, 25.344468],
        [-81.101959, 25.124742],
        [-80.402496, 25.186225],
        [-80.140614, 25.900824],
        [-80.128774, 25.775295],
        [-80.038238, 26.811184],
        [-80.314320, 27.242580],
        [-80.197011, 27.180487],
        [-80.738271, 28.373481],
        [-80.848134, 28.790595],
        [-80.600413, 28.600287],
        [-80.619944, 28.206977],
        [-80.580637, 28.085435],
        [-80.450917, 27.866360],
        [-80.528228, 28.472602],
        [-81.293813, 29.894110],
        [-81.533355, 30.853705],
        [-81.454823, 31.206000],
        [-81.267690, 31.258734],
        [-81.492421, 31.367662],
        [-81.325657, 31.348929],
        [-81.273305, 31.765530],
        [-81.105540, 31.742662],
        [-81.118235, 31.907660],
        [-80.958160, 31.879340],
        [-80.677846, 32.214748],
        [-80.798940, 32.319729],
        [-80.854970, 32.539496],
        [-80.553293, 32.278795],
        [-80.429799, 32.409817],
        [-80.547109, 32.347113],
        [-80.478179, 32.478095],
        [-80.323232, 32.488430],
        [-79.887318, 32.688137],
        [-79.943756, 32.851467],
        [-79.828725, 32.762763],
        [-79.387034, 33.017320],
        [-79.183461, 33.183783],
        [-79.291412, 33.277737],
        [-79.277089, 33.359117],
        [-79.189605, 33.436998],
        [-79.183461, 33.217922],
        [-78.763336, 33.778551],
        [-78.374664, 33.950914],
        [-78.017812, 33.896308],
        [-77.962554, 34.191148],
        [-77.942047, 33.930487],
        [-77.730458, 34.315863],
        [-77.378896, 34.527167],
        [-77.449818, 34.608873],
        [-77.435618, 34.753485],
        [-77.336537, 34.561103],
        [-77.131703, 34.762397],
        [-76.632965, 34.709174],
        [-76.346262, 34.883246],
        [-76.269887, 34.972602],
        [-76.461822, 34.940579],
        [-76.453765, 35.073391],
        [-76.539866, 34.932074],
        [-76.940256, 34.979804],
        [-77.079335, 35.156968],
        [-76.764475, 34.989203],
        [-76.470367, 35.270575],
        [-76.976308, 35.438178],
        [-77.051991, 35.534369],
        [-76.599762, 35.395087],
        [-76.647328, 35.520697],
        [-76.463002, 35.541164],
        [-76.498362, 35.391343],
        [-76.150380, 35.347154],
        [-75.886342, 35.637356],
        [-75.783925, 35.575914],
        [-75.721832, 35.829169],
        [-75.852854, 35.979967],
        [-76.037180, 35.651028],
        [-76.140859, 35.698798],
        [-76.048329, 35.983710],
        [-76.729848, 35.945258],
        [-76.688873, 36.006659],
        [-76.757192, 36.127102],
        [-76.729848, 36.322659],
        [-76.577260, 36.012397],
        [-76.311513, 36.096096],
        [-76.463002, 36.205959],
        [-76.063466, 36.162014],
        [-76.219350, 36.287828],
        [-76.198842, 36.322659],
        [-75.962717, 36.205959],
        [-75.961741, 36.306952],
        [-76.037180, 36.500800],
        [-75.901112, 36.496039],
        [-75.719472, 36.009996],
        [-75.523834, 35.794379],
        [-76.004592, 36.932358],
        [-76.524403, 36.863227],
        [-76.669972, 37.185007],
        [-76.717995, 37.150014],
        [-77.274322, 37.316352],
        [-76.860219, 37.323147],
        [-76.634023, 37.220689],
        [-76.429189, 36.976304],
        [-76.274526, 37.048041],
        [-76.496029, 37.249115],
        [-76.415151, 37.442694],
        [-76.257640, 37.335510],
        [-76.393381, 37.533149],
        [-76.284169, 37.569566],
        [-76.551982, 37.626758],
        [-76.504994, 37.656928],
        [-76.468902, 37.708645],
        [-76.404652, 37.644680],
        [-76.321116, 37.624010],
        [-76.304677, 37.637885],
        [-76.247909, 37.903471],
        [-76.954171, 38.210168],
        [-77.040841, 38.395910],
        [-77.248979, 38.329885],
        [-77.343070, 38.348691],
        [-77.229888, 38.656684],
        [-77.047771, 38.715724],
        [-77.012467, 38.697355],
        [-77.255259, 38.393522],
        [-77.031565, 38.481391],
        [-76.922174, 38.291593],
        [-76.880686, 38.398871],
        [-76.323897, 38.043842],
        [-76.373382, 38.298893],
        [-76.450634, 38.293141],
        [-76.673644, 38.486058],
        [-76.681467, 38.679389],
        [-76.636475, 38.474163],
        [-76.392764, 38.353570],
        [-76.569163, 39.066392],
        [-76.394195, 39.024563],
        [-76.623199, 39.259711],
        [-76.449178, 39.194957],
        [-76.401479, 39.392524],
        [-76.284169, 39.310614],
        [-76.232493, 39.474514],
        [-76.209706, 39.364651],
        [-76.082997, 39.557807],
        [-75.934722, 39.604193],
        [-76.000713, 39.452790],
        [-76.034265, 39.392877],
        [-75.839182, 39.371487],
        [-76.174957, 39.316230],
        [-76.242618, 39.033260],
        [-76.065094, 39.146145],
        [-76.197561, 38.979340],
        [-76.315297, 39.029364],
        [-76.374748, 38.841573],
        [-76.247182, 38.951158],
        [-76.106068, 38.877997],
        [-76.304677, 38.822740],
        [-76.341293, 38.673173],
        [-76.288038, 38.775526],
        [-75.970204, 38.606594],
        [-76.277415, 38.624742],
        [-76.171986, 38.566230],
        [-76.318959, 38.473944],
        [-76.037913, 38.232489],
        [-75.843251, 38.404364],
        [-75.940500, 38.135403],
        [-75.742991, 38.110826],
        [-75.874989, 37.951117],
        [-75.633127, 37.960028],
        [-75.934722, 37.576402],
        [-75.949111, 37.124952],
        [-75.104400, 38.316230],
        [-75.179510, 38.408420],
        [-75.044749, 38.425035],
        [-75.060091, 38.612541],
        [-75.207916, 38.569525],
        [-75.084340, 38.795967],
        [-75.393790, 39.055551],
        [-75.592152, 39.649237],
        [-75.391713, 39.839586],
        [-75.023590, 40.016303],
        [-75.558217, 39.613471],
        [-75.146474, 39.187079],
        [-74.906321, 39.179633],
        [-74.954701, 38.926418],
        [-74.642079, 39.306708],
        [-74.413442, 39.357123],
        [-74.060699, 40.062161],
        [-73.979156, 40.449286],
        [-74.282687, 40.497319],
        [-73.918080, 40.931464],
        [-73.893833, 40.803853],
        [-72.909983, 41.305121],
        [-71.497711, 41.366278],
        [-71.391347, 41.818793],
        [-71.260406, 41.651109],
        [-71.110748, 41.797065],
        [-71.185902, 41.468736],
        [-70.710439, 41.748033],
        [-70.658682, 41.521349],
        [-69.938873, 41.674221],
        [-69.924672, 41.838080],
        [-70.081198, 42.058354],
        [-70.192220, 42.086062],
        [-70.246820, 42.061468],
        [-70.000111, 41.816311],
        [-70.070241, 41.773458],
        [-70.335194, 41.719224],
        [-70.714833, 42.002672],
        [-70.590810, 42.017320],
        [-70.741811, 42.235663],
        [-71.046783, 42.321519],
        [-70.597035, 42.634467],
        [-70.863759, 42.826239],
        [-70.742340, 43.087958]
    ],
    [
        [-80.579337, 9.080687],
        [-81.304463, 8.781882],
        [-81.539052, 8.812934],
        [-81.882802, 9.179511],
        [-81.775543, 8.940253],
        [-82.243031, 9.004462],
        [-82.170806, 9.199774],
        [-82.393666, 9.262112],
        [-82.342763, 9.432522],
        [-83.203725, 10.129340],
        [-83.815663, 11.090399],
        [-83.868031, 11.374905],
        [-83.651194, 11.632270],
        [-83.836090, 11.871243],
        [-83.777740, 12.177151],
        [-83.671010, 11.987942],
        [-83.617014, 12.348049],
        [-83.774648, 12.533515],
        [-83.564036, 12.812690],
        [-83.637522, 12.385728],
        [-83.481801, 12.416653],
        [-83.559153, 13.415839],
        [-83.186594, 14.347642],
        [-83.424631, 14.803941],
        [-83.130442, 14.997016],
        [-83.356313, 15.229722],
        [-83.529612, 15.301011],
        [-83.481801, 15.215562],
        [-83.759836, 15.202094],
        [-83.814076, 15.321682],
        [-84.026519, 15.408677],
        [-83.821889, 15.270697],
        [-83.921986, 15.247870],
        [-84.212880, 15.551215],
        [-83.729970, 15.401557],
        [-84.294638, 15.811010],
        [-84.660054, 15.774494],
        [-84.999949, 15.987942],
        [-85.488578, 15.869567],
        [-85.703196, 15.976467],
        [-86.007924, 16.031073],
        [-85.933258, 15.936672],
        [-86.374745, 15.770941],
        [-87.479400, 15.786038],
        [-87.722157, 15.922919],
        [-88.145253, 15.684516],
        [-88.605458, 15.969631],
        [-88.488840, 15.846747],
        [-88.609242, 15.702094],
        [-88.913971, 15.893948],
        [-88.740061, 16.230170],
        [-88.536610, 16.271308],
        [-88.386383, 16.490383],
        [-88.393178, 16.551825],
        [-88.365875, 16.551825],
        [-88.386383, 16.559272],
        [-88.337636, 16.649237],
        [-88.311269, 16.662299],
        [-88.334543, 16.635077],
        [-88.365875, 16.521430],
        [-88.348988, 16.515326],
        [-88.217437, 16.955471],
        [-88.295969, 17.238105],
        [-88.167307, 17.512030],
        [-88.287709, 17.604234],
        [-88.091542, 18.371731],
        [-88.390981, 18.370592],
        [-88.036285, 18.874986],
        [-88.077789, 18.498603],
        [-87.844553, 18.196682],
        [-87.460927, 19.320705],
        [-87.675852, 19.311184],
        [-87.412750, 19.577623],
        [-87.673818, 19.505683],
        [-87.741200, 19.671698],
        [-87.478017, 19.964830],
        [-87.430491, 20.221015],
        [-86.875315, 20.855048],
        [-86.741567, 21.164130],
        [-86.827952, 21.433295],
        [-87.111480, 21.623440],
        [-87.413157, 21.534084],
        [-87.138336, 21.563056],
        [-87.256947, 21.440619],
        [-88.129465, 21.616034],
        [-89.921539, 21.240668],
        [-90.360097, 21.000393],
        [-90.477823, 19.922101],
        [-90.683705, 19.752916],
        [-90.769358, 19.309231],
        [-91.237213, 18.957587],
        [-91.414703, 18.813625],
        [-91.181996, 18.656562],
        [-91.486480, 18.436428],
        [-91.814280, 18.388658],
        [-91.901967, 18.580797],
        [-91.866567, 18.598375],
        [-91.948060, 18.691225],
        [-92.405140, 18.671063],
        [-92.695872, 18.615627],
        [-92.716908, 18.592190],
        [-93.128489, 18.340644],
        [-93.552358, 18.429389],
        [-94.530873, 18.160631],
        [-94.786936, 18.511949],
        [-95.190053, 18.705146],
        [-95.861887, 18.723375],
        [-95.958852, 18.856391],
        [-95.752756, 18.799994],
        [-96.290354, 19.332587],
        [-96.456125, 19.868801],
        [-97.150543, 20.647040],
        [-97.672597, 21.675279],
        [-97.781117, 22.095852],
        [-97.625071, 21.794420],
        [-97.370229, 21.537502],
        [-97.472239, 21.437812],
        [-97.411204, 21.273383],
        [-97.316233, 21.560940],
        [-97.760610, 22.095852],
        [-97.893219, 22.610256],
        [-97.742340, 22.972073],
        [-97.822092, 23.788398],
        [-97.224965, 25.584418]
    ],
    [
        [-107.312978, 24.166327],
        [-105.800160, 22.638454],
        [-105.632264, 21.955737],
        [-105.200063, 21.492865],
        [-105.234327, 21.060966],
        [-105.544896, 20.768096],
        [-105.243642, 20.583564],
        [-105.698681, 20.406911],
        [-105.525624, 20.031928],
        [-104.993642, 19.342190],
        [-103.979977, 18.874938],
        [-103.498400, 18.333483],
        [-102.190629, 17.915988],
        [-101.989877, 17.974751],
        [-101.059029, 17.264237],
        [-99.663289, 16.698164],
        [-98.776898, 16.555135],
        [-97.772719, 15.979454],
        [-96.556038, 15.659025],
        [-94.766957, 16.198676],
        [-95.063832, 16.268256],
        [-94.878651, 16.424628],
        [-94.793121, 16.257636],
        [-94.580841, 16.326483],
        [-94.722401, 16.199652],
        [-93.963897, 15.997504],
        [-94.436513, 16.245551],
        [-94.142445, 16.226752],
        [-92.768422, 15.171454],
        [-92.246246, 14.546291],
        [-91.316461, 13.955679],
        [-90.500209, 13.894700],
        [-89.808048, 13.526858],
        [-88.722768, 13.269599],
        [-87.928212, 13.158637],
        [-87.838287, 13.440945],
        [-87.400624, 13.411160],
        [-87.512237, 13.286689],
        [-87.289581, 12.919582],
        [-87.583852, 13.084662],
        [-87.670929, 12.893500],
        [-85.670196, 11.054389],
        [-85.946441, 10.891140],
        [-85.665273, 10.778835],
        [-85.874989, 10.355048],
        [-85.663808, 9.900092],
        [-85.299306, 9.808010],
        [-85.110463, 9.555447],
        [-84.864613, 9.829169],
        [-85.186147, 10.035834],
        [-85.289174, 10.282253],
        [-84.733632, 9.966946],
        [-84.616567, 9.578070],
        [-83.634755, 9.044094],
        [-83.575429, 8.788275],
        [-83.739898, 8.623806],
        [-83.575592, 8.444973],
        [-83.276357, 8.401557],
        [-83.481720, 8.712592],
        [-83.171376, 8.637478],
        [-82.876943, 8.023871],
        [-82.738026, 8.317450],
        [-81.746246, 8.191799],
        [-81.574941, 7.760403],
        [-81.225494, 7.608954],
        [-81.218048, 7.897528],
        [-81.053578, 7.911200],
        [-80.861806, 7.205715],
        [-80.010040, 7.465237],
        [-80.484405, 8.082546],
        [-80.385772, 8.311347],
        [-80.125844, 8.348619]
    ],
    [
        [-110.765292, 25.593939],
        [-110.753187, 25.598096],
        [-110.773414, 25.712795],
        [-110.805532, 25.644418],
        [-110.765292, 25.593939]
    ],
    [
        [-111.081194, 25.998658],
        [-111.176027, 26.043342],
        [-111.233355, 25.842899],
        [-111.204991, 25.803754],
        [-111.081194, 25.998658]
    ],
    [
        [119.305431, 26.035956],
        [119.209239, 26.098578],
        [119.257579, 26.001451],
        [119.404959, 25.977932],
        [119.305431, 26.035956]
    ],
    [
        [33.955089, 26.790025],
        [33.989594, 26.720282],
        [34.003591, 26.708197],
        [33.975597, 26.790025],
        [33.955089, 26.790025]
    ],
    [
        [-110.044442, 27.087000],
        [-109.991444, 27.064195],
        [-109.985245, 27.069568],
        [-110.044442, 27.087000]
    ],
    [
        [-110.604176, 27.318024],
        [-110.534342, 27.284357],
        [-110.593090, 27.416986],
        [-110.604563, 27.382514],
        [-110.604176, 27.318024]
    ],
    [
        [34.006602, 27.509467],
        [33.964122, 27.534125],
        [33.913585, 27.523749],
        [34.051280, 27.448635],
        [34.006602, 27.509467]
    ],
    [
        [34.585134, 27.955146],
        [34.517345, 28.016547],
        [34.489513, 27.996039],
        [34.620453, 27.920356],
        [34.585134, 27.955146]
    ],
    [
        [121.255531, 28.140001],
        [121.120372, 28.135688],
        [121.151573, 28.041232],
        [121.279145, 28.085435],
        [121.255531, 28.140001]
    ],
    [
        [-115.194980, 28.341358],
        [-115.358052, 28.082579],
        [-115.228143, 28.028323],
        [-115.155829, 28.140780],
        [-115.194980, 28.341358]
    ],
    [
        [-112.893769, 28.677696],
        [-112.773919, 28.575782],
        [-112.752401, 28.591081],
        [-112.860757, 28.671860],
        [-112.893769, 28.677696]
    ],
    [
        [-112.613150, 28.725763],
        [-112.604349, 28.669434],
        [-112.553939, 28.672288],
        [-112.547957, 28.728549],
        [-112.613150, 28.725763]
    ],
    [
        [-112.274657, 28.768388],
        [-112.195606, 29.021330],
        [-112.264337, 29.246890],
        [-112.464711, 29.181830],
        [-112.583033, 28.875363],
        [-112.274657, 28.768388]
    ],
    [
        [-113.138173, 29.064887],
        [-113.168525, 29.276118],
        [-113.571144, 29.539950],
        [-113.496080, 29.285201],
        [-113.138173, 29.064887]
    ],
    [
        [122.238780, 30.313137],
        [122.211436, 30.346625],
        [122.073578, 30.291409],
        [122.202322, 30.241929],
        [122.238780, 30.313137]
    ],
    [
        [122.398936, 30.456488],
        [122.280040, 30.482611],
        [122.272797, 30.435981],
        [122.423106, 30.414944],
        [122.398936, 30.456488]
    ],
    [
        [32.978526, 31.081692],
        [32.978526, 31.081692]
    ],
    [
        [121.837738, 31.375149],
        [121.794200, 31.368801],
        [121.834727, 31.292548],
        [121.881847, 31.336615],
        [121.837738, 31.375149]
    ],
    [
        [129.783214, 31.799628],
        [129.655381, 31.659785],
        [129.659374, 31.641935],
        [129.729340, 31.644232],
        [129.783214, 31.799628]
    ],
    [
        [-114.786122, 31.803046],
        [-114.762563, 31.715644],
        [-114.652699, 31.689765],
        [-114.710072, 31.763739],
        [-114.786122, 31.803046]
    ],
    [
        [119.880707, 32.125190],
        [119.814301, 32.275580],
        [119.716156, 32.272650],
        [119.792003, 32.121772],
        [119.880707, 32.125190]
    ],
    [
        [47.965531, 29.576298],
        [48.180917, 29.562217],
        [47.995616, 29.827704],
        [47.934825, 30.107082],
        [48.520518, 29.928900],
        [48.897227, 30.029446],
        [48.862315, 30.345608],
        [48.934825, 30.418647],
        [49.037283, 30.432522],
        [48.952973, 30.500190],
        [49.211192, 30.506334],
        [49.202891, 30.346625],
        [48.921153, 30.380764],
        [49.532237, 30.022935],
        [50.073416, 30.195746],
        [50.144867, 29.938056],
        [50.655284, 29.449123],
        [50.643809, 29.143459],
        [50.929942, 29.054633],
        [50.804861, 28.933580],
        [51.058849, 28.735907],
        [51.399876, 27.931713],
        [52.459646, 27.632636],
        [52.670095, 27.448635],
        [52.601329, 27.352932],
        [53.716075, 26.708564],
        [54.308116, 26.714993],
        [54.791026, 26.495836],
        [56.123709, 27.160631],
        [56.808849, 27.139553],
        [56.973318, 27.002997],
        [57.326182, 25.777004],
        [58.170421, 25.544094],
        [58.813731, 25.563625],
        [59.043956, 25.399604],
        [60.467246, 25.290276],
        [60.395274, 25.377875],
        [60.549653, 25.446926],
        [60.633474, 25.274970],
        [61.411717, 25.059408],
        [61.612478, 25.200507]
    ],
    [
        [34.873220, 32.430325],
        [34.478770, 31.578274],
        [33.854340, 31.163479],
        [33.133311, 31.045559],
        [33.109386, 31.196438],
        [32.927257, 31.155422],
        [32.601573, 31.060981],
        [32.331391, 31.271430],
        [32.207042, 31.295071],
        [32.283458, 31.136542],
        [32.106456, 31.053371],
        [31.766938, 31.284654],
        [31.889496, 31.532050],
        [31.994965, 31.394965],
        [32.199555, 31.295071],
        [31.944835, 31.520941],
        [31.874360, 31.535590],
        [31.556814, 31.443345],
        [31.097423, 31.607896],
        [30.978038, 31.584296],
        [31.119151, 31.493109],
        [30.734386, 31.388129],
        [30.542654, 31.402411],
        [30.973888, 31.586737],
        [30.362153, 31.508734],
        [30.179454, 31.278266],
        [30.287608, 31.278225],
        [30.288748, 31.237942],
        [30.165212, 31.216783],
        [30.069591, 31.333482],
        [29.028087, 30.827053],
        [26.965505, 31.449652],
        [25.966807, 31.616604],
        [25.190929, 31.531480],
        [24.981700, 31.967922],
        [23.312185, 32.162746],
        [23.080577, 32.334052],
        [23.106130, 32.639838],
        [21.716319, 32.950385],
        [20.562673, 32.557847],
        [20.071544, 32.176418],
        [19.917247, 31.759223],
        [20.146658, 31.045559],
        [19.748871, 30.510932],
        [19.291677, 30.287055]
    ],
    [
        [131.659790, 32.476820],
        [132.081189, 32.943230],
        [131.809574, 33.127649],
        [131.902625, 33.266042],
        [131.510380, 33.273404],
        [131.737295, 33.484608],
        [131.667366, 33.667192],
        [131.102976, 33.624253],
        [131.007148, 33.966055],
        [130.488943, 33.855373],
        [130.289263, 33.681545],
        [130.390866, 33.604874],
        [130.208011, 33.665076],
        [130.016856, 33.445787],
        [129.853187, 33.552502],
        [129.851573, 33.280015],
        [129.580413, 33.371007],
        [129.552144, 33.225839],
        [129.945623, 33.015758],
        [130.003148, 32.845379],
        [129.794400, 32.874921],
        [129.681612, 33.094092],
        [129.638430, 32.926546],
        [129.859060, 32.724514],
        [129.740351, 32.568442],
        [130.093789, 32.794860],
        [130.165987, 32.592956],
        [130.360827, 32.687963],
        [130.339420, 32.856579],
        [130.105317, 32.875922],
        [130.241396, 33.188234],
        [130.611339, 32.785468],
        [130.448009, 32.621405],
        [130.668305, 32.648749],
        [130.512462, 32.338202],
        [130.179861, 32.093451],
        [130.334483, 31.562405],
        [130.118988, 31.408637],
        [130.586436, 31.155422],
        [130.529145, 31.513251],
        [130.644786, 31.714748],
        [130.776378, 31.710273],
        [130.758637, 31.563788],
        [130.590889, 31.585988],
        [130.795252, 31.344425],
        [130.657722, 31.003191],
        [131.132114, 31.279513],
        [131.071788, 31.449612],
        [131.338227, 31.372626],
        [131.659790, 32.476820]
    ],
    [
        [134.689789, 33.828070],
        [134.646871, 34.239252],
        [133.937022, 34.375067],
        [133.558360, 34.259467],
        [133.641287, 34.079169],
        [133.510997, 33.965237],
        [133.127011, 33.933291],
        [132.942384, 34.141262],
        [132.897500, 34.122714],
        [132.676606, 33.715644],
        [132.010539, 33.348989],
        [132.421153, 33.444485],
        [132.548364, 33.226903],
        [132.394676, 33.203895],
        [132.382402, 33.019779],
        [132.709158, 32.909410],
        [132.627661, 32.752093],
        [133.002208, 32.711656],
        [133.001702, 32.986957],
        [133.292247, 33.364691],
        [133.739397, 33.537507],
        [134.176527, 33.236128],
        [134.312348, 33.572506],
        [134.689789, 33.828070]
    ],
    [
        [133.121349, 36.109768],
        [133.081309, 36.080146],
        [133.079112, 36.020941],
        [133.123220, 36.062934],
        [133.121349, 36.109768]
    ],
    [
        [133.090587, 36.117865],
        [133.093272, 36.109768],
        [133.113617, 36.113511],
        [133.093272, 36.123358],
        [133.090587, 36.117865]
    ],
    [
        [133.074229, 36.127916],
        [133.038748, 36.130805],
        [132.949392, 36.061957],
        [133.044932, 36.055121],
        [133.074229, 36.127916]
    ],
    [
        [126.405414, 36.458836],
        [126.373546, 36.592231],
        [126.341181, 36.604134],
        [126.328143, 36.471089],
        [126.405414, 36.458836]
    ],
    [
        [126.295258, 37.802476],
        [126.246430, 37.811754],
        [126.224457, 37.760443],
        [126.335948, 37.774400],
        [126.295258, 37.802476]
    ],
    [
        [122.321300, 39.165961],
        [122.402599, 39.159125],
        [122.402599, 39.213813],
        [122.354828, 39.195624],
        [122.321300, 39.165961]
    ],
    [
        [122.635997, 39.234280],
        [122.690684, 39.193305],
        [122.741954, 39.236070],
        [122.718598, 39.241889],
        [122.635997, 39.234280]
    ],
    [
        [122.684418, 39.262193],
        [122.643891, 39.278510],
        [122.505056, 39.296942],
        [122.586192, 39.258002],
        [122.684418, 39.262193]
    ],
    [
        [121.422537, 39.474514],
        [121.340587, 39.481350],
        [121.259451, 39.391506],
        [121.421723, 39.373684],
        [121.422537, 39.474514]
    ],
    [
        [122.964366, 39.515448],
        [123.005707, 39.497301],
        [123.040050, 39.529731],
        [122.989757, 39.549506],
        [122.964366, 39.515448]
    ],
    [
        [124.926741, 39.604786],
        [124.880471, 39.612455],
        [124.818563, 39.495444],
        [124.933609, 39.550543],
        [124.926741, 39.604786]
    ],
    [
        [-73.933380, 40.797187],
        [-73.975806, 40.714013],
        [-74.016916, 40.699286],
        [-73.928049, 40.877509],
        [-73.933380, 40.797187]
    ],
    [
        [133.422211, 34.445014],
        [132.656261, 34.199286],
        [132.346039, 34.348822],
        [132.161632, 33.841702],
        [132.055919, 33.777167],
        [132.099457, 33.872260],
        [131.741466, 34.056220],
        [130.879405, 33.937934],
        [130.958751, 34.427436],
        [131.414317, 34.423977],
        [132.638679, 35.294645],
        [132.635359, 35.440955],
        [133.091261, 35.601485],
        [133.400157, 35.454291],
        [135.226846, 35.772321],
        [135.319021, 35.446967],
        [135.463222, 35.603327],
        [135.834321, 35.534369],
        [136.019705, 35.765347],
        [135.963217, 35.999923],
        [136.689685, 36.730827],
        [136.783767, 37.373892],
        [137.350874, 37.506103],
        [136.860926, 37.076775],
        [137.047130, 37.098822],
        [137.005544, 36.835924],
        [137.298673, 36.757009],
        [138.550629, 37.377916],
        [138.857677, 37.827826],
        [139.425141, 38.151272],
        [139.995310, 39.327329],
        [140.027599, 39.824530],
        [139.697731, 39.988566],
        [139.866925, 39.984297],
        [140.011152, 40.235458],
        [139.860362, 40.608791],
        [140.270763, 40.812405],
        [140.407793, 41.025698],
        [140.248095, 41.123361],
        [140.342283, 41.265731],
        [140.632702, 41.194258],
        [140.703122, 40.853292],
        [140.888675, 41.010778],
        [141.126269, 40.872919],
        [141.205911, 41.264720],
        [140.765796, 41.145019],
        [140.907093, 41.538548],
        [141.276096, 41.353196],
        [141.460579, 41.430223],
        [141.437387, 40.670141],
        [141.830414, 40.251166],
        [142.070323, 39.550198],
        [141.952973, 39.460761],
        [142.058442, 39.466295],
        [141.913341, 39.097724],
        [141.638357, 38.985419],
        [141.463064, 38.661363],
        [141.525401, 38.267808],
        [141.304454, 38.407904],
        [140.966807, 38.170478],
        [141.007823, 37.133857],
        [140.564107, 36.283096],
        [140.879405, 35.720526],
        [140.483467, 35.565991],
        [140.377630, 35.176357],
        [139.926396, 34.907357],
        [139.756994, 34.956284],
        [139.869965, 34.999335],
        [139.781003, 35.318061],
        [140.102049, 35.567087],
        [139.765272, 35.653510],
        [139.685069, 35.140448],
        [139.544178, 35.307893],
        [139.183538, 35.263267],
        [139.140880, 34.870551],
        [138.835297, 34.595893],
        [138.803332, 35.121909],
        [138.554082, 35.096069],
        [138.233290, 34.594589],
        [137.016095, 34.578785],
        [137.340819, 34.726543],
        [137.018248, 34.783289],
        [136.978852, 34.924221],
        [136.971497, 34.696411],
        [136.855968, 34.739814],
        [136.885730, 35.089195],
        [136.830118, 35.078831],
        [136.519542, 34.680854],
        [136.916026, 34.433987],
        [136.895681, 34.266913],
        [136.336681, 34.184027],
        [135.760020, 33.433336],
        [135.058860, 33.880033],
        [135.189952, 34.149604],
        [135.061044, 34.267275],
        [135.372562, 34.484513],
        [135.412934, 34.692084],
        [135.045769, 34.624967],
        [134.491222, 34.787055],
        [133.936697, 34.587226],
        [134.046153, 34.581529],
        [133.936290, 34.451239],
        [133.422211, 34.445014]
    ],
    [
        [-71.315094, 41.580797],
        [-71.303375, 41.626370],
        [-71.343739, 41.670640],
        [-71.356760, 41.631578],
        [-71.315094, 41.580797]
    ],
    [
        [131.920095, 43.019517],
        [131.826508, 43.065172],
        [131.757009, 42.990058],
        [131.883311, 42.960761],
        [131.920095, 43.019517]
    ],
    [
        [-124.492447, 42.929836],
        [-124.401324, 43.310096],
        [-124.140035, 43.375349],
        [-124.335229, 43.365316],
        [-124.070218, 43.711661],
        [-124.202945, 43.680773],
        [-123.871083, 45.697903],
        [-124.022664, 46.230842],
        [-123.798736, 46.102444],
        [-123.865419, 46.186468],
        [-123.519273, 46.235269],
        [-123.385521, 46.146183],
        [-123.256439, 46.133321],
        [-123.180095, 46.179102],
        [-123.692967, 46.305202],
        [-124.080175, 46.271688],
        [-124.062876, 46.654941],
        [-123.958119, 46.378241],
        [-123.840647, 46.415758],
        [-123.956410, 46.623114],
        [-123.763987, 46.678412],
        [-124.093379, 46.743228],
        [-124.126820, 46.898505],
        [-123.813059, 46.958970],
        [-124.116870, 47.042917],
        [-124.178461, 46.925507],
        [-124.727528, 48.387728],
        [-123.970991, 48.165598],
        [-123.108251, 48.183838],
        [-122.873280, 47.993720],
        [-122.770172, 48.141099],
        [-122.620107, 47.877631],
        [-122.800364, 47.679877],
        [-122.856435, 47.826077],
        [-123.161285, 47.356838],
        [-123.074127, 47.344631],
        [-122.839182, 47.431952],
        [-123.113515, 47.391018],
        [-122.570953, 47.819770],
        [-122.553375, 47.920844],
        [-122.468373, 47.756537],
        [-122.696929, 47.623114],
        [-122.507924, 47.520331],
        [-122.568512, 47.264065],
        [-122.633127, 47.404608],
        [-122.772776, 47.173082],
        [-122.805653, 47.397773],
        [-123.078765, 47.130276],
        [-122.685902, 47.104397],
        [-122.328481, 47.357123],
        [-122.404368, 47.797593],
        [-122.191721, 48.026313],
        [-122.375600, 48.213202],
        [-122.348012, 48.054267],
        [-122.510365, 48.147447],
        [-122.385854, 48.303778],
        [-122.683461, 48.430162],
        [-122.480824, 48.464097],
        [-122.508616, 48.755683],
        [-122.660146, 48.722561],
        [-122.867747, 49.080471],
        [-123.088490, 48.972235],
        [-123.040679, 49.151028],
        [-123.211985, 49.129950],
        [-123.246897, 49.274644],
        [-122.960846, 49.281887],
        [-122.892486, 49.333686],
        [-122.859853, 49.449856],
        [-123.270009, 49.335354],
        [-123.171010, 49.705268],
        [-123.516184, 49.391669],
        [-123.963775, 49.521145],
        [-124.006093, 49.740790],
        [-123.777089, 49.505316],
        [-123.533518, 49.705268],
        [-123.927602, 49.763617],
        [-123.883616, 49.901109],
        [-123.953603, 49.989691],
        [-123.754547, 50.093736],
        [-123.807851, 50.103176],
        [-123.993153, 50.010810],
        [-123.978179, 49.809027],
        [-124.037465, 49.924994],
        [-124.430287, 49.771552],
        [-124.764394, 49.977362],
        [-124.602935, 50.240302],
        [-124.713450, 50.331366],
        [-124.348500, 50.497260],
        [-125.081532, 50.324693],
        [-124.869862, 50.582953],
        [-124.813832, 50.927191],
        [-125.127838, 50.436998],
        [-125.577056, 50.470689],
        [-125.454579, 50.720364],
        [-125.703277, 50.437934],
        [-126.280629, 50.519436],
        [-125.959869, 50.645575],
        [-125.705637, 50.681708],
        [-125.507314, 50.939195],
        [-125.542063, 50.939195],
        [-125.647694, 50.782416],
        [-126.186635, 50.671861],
        [-126.034535, 50.795111],
        [-126.547353, 50.837388],
        [-126.173085, 50.938788],
        [-126.514719, 51.076361],
        [-126.674224, 50.878160],
        [-126.921986, 50.872260],
        [-127.042348, 50.822903],
        [-127.777008, 51.167222],
        [-127.126617, 51.338813],
        [-127.779652, 51.330552],
        [-127.551869, 51.470893],
        [-127.492014, 51.620592],
        [-126.677235, 51.645738],
        [-126.603424, 51.713813],
        [-127.423207, 51.671861],
        [-127.350087, 51.870185],
        [-127.645579, 51.700141],
        [-127.467437, 51.662299],
        [-127.713857, 51.457750],
        [-127.873687, 51.673407],
        [-127.849599, 51.920111],
        [-127.172597, 52.316474],
        [-126.672271, 51.987494],
        [-126.938547, 52.305854],
        [-126.753041, 52.393378],
        [-127.224965, 52.456122],
        [-126.931793, 52.712836],
        [-126.969553, 52.829413],
        [-127.076405, 52.885077],
        [-126.986887, 52.710883],
        [-127.616567, 52.298529],
        [-127.872426, 52.219550],
        [-127.888254, 52.515123],
        [-128.015940, 52.346747],
        [-128.053090, 52.485175],
        [-127.877675, 52.584052],
        [-128.092356, 52.513251],
        [-128.296702, 52.275580],
        [-128.392242, 52.296047],
        [-128.028798, 52.916653],
        [-128.442983, 52.827704],
        [-128.481028, 53.145738],
        [-128.849110, 53.278551],
        [-128.831044, 53.488349],
        [-128.493886, 53.344062],
        [-128.127024, 53.450873],
        [-128.111073, 53.488349],
        [-128.529408, 53.433743],
        [-128.807729, 53.615383],
        [-128.775136, 53.798285],
        [-128.473744, 53.841498],
        [-128.693918, 53.899319],
        [-128.598297, 54.030219],
        [-128.932851, 53.776353],
        [-128.906158, 53.844672],
        [-129.009185, 53.899319],
        [-129.289784, 53.385403],
        [-130.104726, 53.947089],
        [-129.961334, 54.166815],
        [-129.927235, 54.187323],
        [-129.611928, 54.183905],
        [-129.491811, 54.251451],
        [-130.124908, 54.160875],
        [-130.281484, 54.214423],
        [-130.249379, 54.406399],
        [-130.482533, 54.373684],
        [-130.431223, 54.632961],
        [-130.052968, 54.337388],
        [-129.958892, 54.322089],
        [-130.084869, 54.392076],
        [-129.981435, 54.515448],
        [-130.101145, 54.426337],
        [-130.372426, 54.664252],
        [-130.234446, 54.711412],
        [-130.011627, 54.619859],
        [-129.879547, 54.620592],
        [-130.201527, 54.728502],
        [-130.050120, 54.893012],
        [-130.173655, 54.844550],
        [-130.022043, 54.973863],
        [-130.001047, 55.022447],
        [-129.478017, 55.483466],
        [-129.712961, 55.420803],
        [-129.824818, 55.619208],
        [-129.786204, 55.356757],
        [-130.124827, 55.005276],
        [-129.949371, 55.293158],
        [-130.130605, 55.736274],
        [-129.961334, 55.920844],
        [-130.009755, 55.928290],
        [-130.173655, 55.749498],
        [-129.989247, 55.284003],
        [-130.580312, 54.806383],
        [-130.718414, 54.773017],
        [-130.752512, 54.969387],
        [-130.831899, 54.765367],
        [-130.986969, 55.043524],
        [-130.720326, 55.081000],
        [-130.759918, 55.096991],
        [-131.057037, 55.126288],
        [-130.924713, 55.294013],
        [-130.861887, 55.312161],
        [-130.920400, 55.810452],
        [-131.196401, 55.971422],
        [-131.009674, 56.112616],
        [-131.914662, 55.859442],
        [-131.763824, 55.797349],
        [-131.880523, 55.598700],
        [-132.004018, 55.667629],
        [-131.961415, 55.501044],
        [-132.171620, 55.588528],
        [-132.266184, 55.756293],
        [-132.046213, 55.817288],
        [-131.963043, 56.157375],
        [-131.579498, 56.179104],
        [-131.489491, 56.222480],
        [-131.907826, 56.232733],
        [-132.344879, 56.528998],
        [-132.305043, 56.640204],
        [-132.540191, 56.631496],
        [-132.359690, 56.818427],
        [-132.761383, 56.845771],
        [-132.922027, 56.982856],
        [-132.767690, 56.969672],
        [-132.795400, 57.092719],
        [-133.551991, 57.181464],
        [-133.471913, 57.281887],
        [-133.254791, 57.281073],
        [-133.058420, 57.331855],
        [-133.038075, 57.367092],
        [-133.419504, 57.343940],
        [-133.335927, 57.438178],
        [-133.497426, 57.531562],
        [-133.313100, 57.592963],
        [-133.591420, 57.574612],
        [-133.648264, 57.702826],
        [-133.566314, 57.716498],
        [-133.045522, 57.503607],
        [-133.003977, 57.517890],
        [-133.528920, 57.750922],
        [-133.551991, 57.915107],
        [-133.554311, 57.929429],
        [-133.686350, 57.790717],
        [-133.861155, 57.956732],
        [-133.691396, 57.942043],
        [-133.682362, 58.155341],
        [-133.864369, 57.986965],
        [-134.059722, 58.072170],
        [-134.004506, 58.408596],
        [-133.771799, 58.524644],
        [-133.976633, 58.504828],
        [-134.157867, 58.204291],
        [-134.756174, 58.381537],
        [-134.950429, 58.820054],
        [-135.149037, 58.843695],
        [-135.348297, 59.470608],
        [-135.553782, 59.319770],
        [-135.359527, 59.213772],
        [-135.307362, 59.086982],
        [-135.553782, 59.230414],
        [-135.162709, 58.634508],
        [-135.093821, 58.237250],
        [-135.350453, 58.276801],
        [-135.484934, 58.483954],
        [-135.478017, 58.373765],
        [-135.909413, 58.381293],
        [-135.820668, 58.600328],
        [-136.073883, 58.812649],
        [-136.046539, 58.861029],
        [-136.157379, 59.037584],
        [-136.209706, 58.750800],
        [-136.492258, 58.970893],
        [-136.711985, 59.025580],
        [-136.633453, 58.891791],
        [-137.059478, 59.063707],
        [-136.903717, 58.932440],
        [-137.013010, 58.922512],
        [-137.129709, 58.826321],
        [-136.587554, 58.848334],
        [-136.342600, 58.691555],
        [-136.293040, 58.669257],
        [-136.026723, 58.388129],
        [-136.272817, 58.312974],
        [-136.505930, 58.442694],
        [-136.370595, 58.299547],
        [-136.620513, 58.353909],
        [-136.664784, 58.220364],
        [-138.610015, 59.127997],
        [-138.449086, 59.191636],
        [-139.857004, 59.546291],
        [-139.480051, 59.704413],
        [-139.621083, 59.890286],
        [-139.473215, 59.993598],
        [-139.305165, 59.864691],
        [-139.280385, 59.833686],
        [-139.036366, 59.846869],
        [-138.945302, 59.807115],
        [-138.897369, 59.813178],
        [-139.520904, 60.051500],
        [-140.322743, 59.701239],
        [-141.454010, 59.882066],
        [-141.267323, 59.955552],
        [-141.377675, 60.142157],
        [-141.414215, 60.014350],
        [-141.893951, 60.007554]
    ],
    [
        [-102.572825, 67.795111],
        [-101.529449, 67.680406],
        [-100.707387, 67.851142],
        [-98.936431, 67.696845],
        [-98.363352, 67.794623],
        [-98.727040, 67.957831],
        [-98.584584, 68.096381],
        [-98.082834, 67.755479],
        [-97.557932, 67.595404],
        [-97.061147, 67.680406],
        [-97.226226, 67.714545],
        [-97.120839, 67.793036],
        [-97.249582, 67.924628],
        [-97.675771, 68.020331],
        [-98.095041, 67.836615],
        [-98.589915, 68.152777],
        [-98.315541, 68.167060],
        [-98.713368, 68.379259],
        [-97.747629, 68.368720],
        [-97.979644, 68.547065],
        [-97.260365, 68.468695],
        [-96.993479, 68.337714],
        [-97.080637, 68.265692],
        [-96.620961, 68.185655],
        [-96.592030, 68.254218],
        [-96.403798, 68.317857],
        [-96.764516, 68.017157],
        [-95.896718, 68.296739],
        [-96.081654, 68.145941],
        [-96.181874, 67.642890],
        [-96.343902, 67.689399],
        [-96.465240, 67.478013],
        [-96.095937, 67.467475],
        [-96.253000, 67.247748],
        [-96.110748, 67.221869],
        [-95.581370, 67.384833],
        [-95.835276, 67.165839],
        [-95.437408, 67.200629],
        [-95.330312, 67.010362],
        [-96.455678, 67.059760],
        [-95.852040, 66.758124],
        [-95.820953, 66.591132],
        [-95.643463, 66.669298],
        [-96.093495, 66.920233],
        [-95.218332, 66.974066],
        [-95.348134, 67.152696],
        [-95.172841, 67.278632],
        [-95.413808, 67.456610],
        [-95.338124, 67.552232],
        [-95.707672, 67.733344],
        [-95.478383, 68.063422],
        [-94.798248, 68.038072],
        [-93.374867, 68.638739],
        [-93.752268, 68.612128],
        [-93.570668, 68.844062],
        [-93.909291, 68.995673],
        [-94.080556, 68.852281],
        [-93.826243, 68.879340],
        [-94.094228, 68.762885],
        [-94.636098, 68.756049],
        [-94.601959, 68.968329],
        [-94.005483, 69.160142],
        [-94.324045, 69.155829],
        [-94.281646, 69.322130],
        [-93.525706, 69.441352],
        [-93.840321, 69.168687],
        [-93.361887, 69.372992],
        [-93.587758, 69.366197],
        [-93.450592, 69.489691],
        [-94.322174, 69.452989],
        [-94.629872, 69.687730],
        [-94.875111, 69.571641],
        [-95.975901, 69.786200],
        [-96.573720, 70.234442],
        [-96.232981, 70.571194],
        [-95.793691, 70.538072],
        [-96.053944, 70.607042],
        [-95.814809, 70.715562],
        [-96.190338, 70.624742],
        [-96.602447, 70.791327],
        [-96.376047, 71.094102],
        [-96.561513, 71.127061],
        [-96.375885, 71.160590],
        [-96.506907, 71.277899],
        [-96.133534, 71.414171],
        [-95.536448, 71.296088],
        [-95.375966, 71.510688],
        [-95.910390, 71.606879],
        [-94.608144, 71.867621],
        [-95.225168, 71.949530],
        [-94.548695, 72.002143],
        [-94.393422, 71.939317],
        [-94.649159, 71.819770],
        [-94.354888, 71.798692],
        [-94.415517, 71.665473],
        [-93.761220, 71.779283],
        [-93.820546, 71.655341],
        [-92.990631, 71.357123],
        [-92.854115, 70.859605],
        [-93.040842, 70.862372],
        [-92.215443, 70.616278],
        [-92.285553, 70.489610],
        [-91.976430, 70.366767],
        [-92.086293, 70.304674],
        [-91.723215, 70.355780],
        [-91.510976, 70.161322],
        [-92.367543, 70.236436],
        [-92.265370, 70.206529],
        [-92.587229, 70.078803],
        [-91.942942, 70.024115],
        [-92.923004, 69.674058],
        [-92.367421, 69.708726],
        [-91.798329, 69.489691],
        [-91.572377, 69.523261],
        [-90.702789, 69.454332],
        [-90.585520, 69.420844],
        [-90.805247, 69.256334],
        [-91.449534, 69.359361],
        [-90.435292, 68.878974],
        [-90.599762, 68.803900],
        [-90.442128, 68.831163],
        [-90.607045, 68.443915],
        [-90.318593, 68.379259],
        [-90.475657, 68.337714],
        [-90.119985, 68.262641],
        [-89.820953, 68.544542],
        [-89.900868, 68.660468],
        [-89.715932, 68.646186],
        [-89.705312, 69.020209],
        [-89.198720, 69.278062],
        [-88.022613, 68.808661],
        [-87.792226, 68.331244],
        [-87.943756, 68.200873],
        [-88.179555, 68.245307],
        [-88.199371, 68.383368],
        [-88.398427, 68.290798],
        [-88.283315, 68.126044],
        [-88.373647, 67.975816],
        [-88.140533, 67.670722],
        [-87.362945, 67.267198],
        [-87.516184, 67.118720],
        [-86.960683, 67.255235],
        [-87.077707, 67.357652],
        [-86.501943, 67.379381],
        [-86.529286, 67.687201],
        [-85.901723, 68.054389],
        [-85.668121, 68.726996],
        [-84.788238, 68.735582],
        [-85.192942, 68.869330],
        [-84.528188, 69.023627],
        [-85.473500, 69.276801],
        [-85.336985, 69.318427],
        [-85.508290, 69.407782],
        [-85.344390, 69.441352],
        [-85.534047, 69.463324],
        [-85.385365, 69.564195],
        [-85.514475, 69.770250],
        [-85.333160, 69.791368],
        [-85.563222, 69.858100],
        [-82.596059, 69.698676],
        [-82.253407, 69.640570],
        [-82.753651, 69.577867],
        [-82.516103, 69.493720],
        [-83.253285, 69.558051],
        [-83.293813, 69.539903],
        [-82.281565, 69.419420],
        [-82.389963, 69.400336],
        [-82.143463, 69.297919],
        [-82.269602, 69.238227],
        [-81.344716, 69.194892],
        [-81.273305, 69.091864],
        [-82.061594, 68.878974],
        [-81.378774, 68.867621],
        [-81.266510, 68.638739],
        [-81.953725, 68.430650],
        [-82.176869, 68.488105],
        [-82.650624, 68.433905],
        [-82.272694, 68.291571],
        [-82.314849, 68.146593],
        [-81.993642, 68.215033],
        [-82.177642, 68.009385],
        [-82.101552, 67.910386],
        [-81.237945, 67.460517],
        [-81.502919, 67.001044],
        [-81.954905, 66.976793],
        [-82.156565, 66.713975],
        [-83.369374, 66.350287],
        [-83.980784, 66.592353],
        [-83.856597, 66.686713],
        [-83.918080, 66.885932],
        [-84.137929, 66.712226],
        [-84.582834, 66.981513],
        [-84.637441, 66.981513],
        [-84.603342, 66.939927],
        [-84.747304, 66.899604],
        [-84.144602, 66.686713],
        [-84.211008, 66.594550],
        [-83.711537, 66.190904],
        [-84.537465, 66.405219],
        [-84.636708, 66.343858],
        [-84.378326, 66.173041],
        [-85.241567, 66.270087],
        [-85.465479, 66.574425],
        [-86.782541, 66.522203],
        [-86.620595, 66.314399],
        [-85.856662, 66.162830],
        [-87.380767, 65.329698],
        [-88.063873, 65.359483],
        [-88.831410, 65.645209],
        [-88.413686, 65.631537],
        [-89.687978, 65.946845],
        [-90.003896, 65.946845],
        [-89.770579, 65.822699],
        [-90.435292, 65.884752],
        [-90.236969, 65.926866],
        [-89.958119, 65.794298],
        [-89.039866, 65.328192],
        [-86.938222, 65.141954],
        [-88.112660, 64.140855],
        [-88.734609, 63.972357],
        [-89.290679, 64.136908],
        [-89.049306, 63.946357],
        [-89.706899, 64.031684],
        [-89.786366, 64.250230],
        [-90.127431, 64.130072],
        [-89.813344, 63.946031],
        [-90.277659, 64.007188],
        [-89.965891, 63.813341],
        [-90.220570, 63.613227],
        [-92.373769, 63.779120],
        [-92.506256, 63.831000],
        [-92.751088, 63.863145],
        [-92.786244, 63.900987],
        [-93.448150, 64.023139],
        [-93.634918, 64.164862],
        [-93.779530, 64.191514],
        [-93.555572, 64.033637],
        [-93.765940, 63.993476],
        [-93.647288, 63.881456],
        [-93.217193, 63.842719],
        [-93.400624, 63.977362],
        [-92.099965, 63.699286],
        [-92.545644, 63.554755],
        [-92.467437, 63.528388],
        [-91.778432, 63.714423],
        [-90.976471, 63.424384],
        [-90.689117, 63.356676],
        [-90.626454, 63.061265],
        [-91.394276, 62.786811],
        [-92.452748, 62.824937],
        [-91.888051, 62.620429],
        [-92.618520, 62.622545],
        [-92.531972, 62.444892],
        [-92.827382, 62.355536],
        [-92.744252, 62.294053],
        [-92.764719, 62.218370],
        [-93.115224, 62.159735],
        [-92.929799, 62.116563],
        [-93.170155, 61.985582],
        [-93.416493, 62.034003],
        [-93.279286, 61.896837],
        [-93.617014, 61.952338],
        [-93.264556, 61.744452],
        [-93.984975, 61.457994],
        [-93.822336, 61.349921],
        [-94.114735, 61.328315],
        [-93.986236, 61.100653],
        [-94.520009, 60.546820],
        [-94.800608, 60.498399],
        [-94.615590, 60.392279],
        [-94.821360, 59.948106],
        [-94.660146, 59.358751],
        [-94.793121, 59.093817],
        [-94.967275, 59.085924],
        [-94.999176, 59.052802],
        [-94.804026, 59.063056],
        [-94.745961, 58.833116],
        [-94.436879, 58.723822],
        [-94.204091, 58.806464],
        [-94.177398, 58.779120],
        [-93.155751, 58.744371],
        [-92.423573, 57.354438],
        [-92.859771, 56.907538],
        [-90.585520, 57.229926],
        [-88.879221, 56.859931],
        [-87.979563, 56.442857],
        [-87.618560, 56.002753],
        [-85.904273, 55.662049],
        [-85.127919, 55.349799],
        [-85.389027, 55.112128],
        [-85.417307, 54.999213],
        [-85.053944, 55.294135],
        [-83.929067, 55.326524],
        [-83.561147, 55.133165],
        [-83.713246, 55.276557],
        [-82.252268, 55.117906],
        [-82.201405, 54.833930],
        [-82.444488, 54.365424],
        [-82.126047, 53.812201],
        [-82.114410, 53.289008],
        [-82.301178, 52.967597],
        [-81.478749, 52.303453],
        [-81.820180, 52.259385],
        [-81.882802, 52.193590],
        [-81.512034, 52.239325],
        [-80.594879, 51.711371],
        [-80.429799, 51.357164],
        [-81.012603, 51.035386],
        [-80.951161, 51.008124],
        [-80.410024, 51.339545],
        [-80.136138, 51.301337],
        [-79.334299, 50.726915],
        [-79.747141, 51.195502],
        [-79.560170, 51.555528],
        [-79.323232, 51.666978],
        [-79.011545, 51.467393],
        [-78.953196, 51.219224],
        [-78.847035, 51.164496],
        [-78.882151, 51.403266],
        [-78.690012, 51.487291],
        [-79.038808, 51.768500],
        [-78.408193, 52.248236],
        [-78.850168, 52.757392],
        [-78.690012, 52.885077],
        [-78.984202, 53.028428],
        [-78.895416, 53.268622],
        [-79.114573, 53.508857],
        [-78.923085, 53.566718],
        [-79.156117, 53.708075],
        [-78.901682, 53.817328],
        [-79.135081, 53.961371],
        [-78.979563, 54.019232],
        [-79.292633, 54.091051],
        [-79.046254, 54.180487],
        [-79.382069, 54.194078],
        [-79.285878, 54.255561],
        [-79.463979, 54.310167],
        [-79.525461, 54.591376],
        [-79.765614, 54.659613],
        [-77.781606, 55.273505],
        [-77.112904, 55.675360],
        [-76.535756, 56.318468],
        [-76.532704, 57.115302],
        [-76.808705, 57.675523],
        [-77.470611, 58.211982],
        [-78.570953, 58.638658],
        [-78.468577, 58.706000],
        [-78.565745, 58.957750],
        [-78.316396, 58.925523],
        [-78.106557, 59.209906],
        [-77.675160, 59.402289],
        [-77.915395, 59.419053],
        [-77.730336, 59.548651],
        [-77.778188, 59.710150],
        [-77.570302, 59.693427],
        [-77.442983, 59.577582],
        [-77.312734, 59.566759],
        [-77.545481, 59.744940],
        [-77.291615, 59.799547],
        [-77.425038, 59.919298],
        [-77.189198, 60.060248],
        [-77.634185, 60.066474],
        [-77.408274, 60.135321],
        [-77.743153, 60.404242],
        [-77.415110, 60.546820],
        [-77.829254, 60.643256],
        [-77.510650, 60.841010],
        [-78.196523, 60.792670],
        [-77.692738, 61.207343],
        [-77.785268, 61.454698],
        [-77.476552, 61.539984],
        [-77.989735, 61.714830],
        [-78.154897, 62.297309],
        [-77.471791, 62.593817],
        [-75.592152, 62.273017],
        [-75.327748, 62.317450],
        [-74.558095, 62.109117],
        [-74.755035, 62.213568],
        [-73.670725, 62.482123],
        [-72.629140, 62.116889],
        [-72.795969, 61.835395],
        [-72.232330, 61.881293],
        [-71.995229, 61.677110],
        [-72.085113, 61.606269],
        [-72.243479, 61.617621],
        [-72.303090, 61.567857],
        [-71.979482, 61.603827],
        [-71.956776, 61.711249],
        [-71.580963, 61.613837],
        [-71.891591, 61.430732],
        [-71.583119, 61.410224],
        [-71.822662, 61.354967],
        [-71.572865, 61.155748],
        [-70.155344, 61.087633],
        [-70.151194, 60.882025],
        [-69.915883, 60.810004],
        [-69.536610, 61.079698],
        [-69.381337, 60.799872],
        [-69.829010, 60.525743],
        [-69.628041, 60.076728],
        [-69.561513, 59.864691],
        [-69.657704, 59.703315],
        [-69.516225, 59.649278],
        [-69.748525, 59.516099],
        [-69.632069, 59.385118],
        [-69.755116, 59.317694],
        [-69.232533, 59.241278],
        [-69.542551, 59.169542],
        [-69.342437, 59.093817],
        [-69.503529, 59.073310],
        [-69.451650, 58.895209],
        [-69.665151, 58.792182],
        [-69.863149, 59.059678],
        [-69.801747, 58.826280],
        [-69.921213, 58.779120],
        [-69.813547, 58.596503],
        [-69.378163, 58.869493],
        [-68.773427, 58.921698],
        [-68.410268, 58.823920],
        [-68.191029, 58.546373],
        [-68.354075, 58.123725],
        [-68.970123, 57.960395],
        [-68.417592, 58.038642],
        [-68.006215, 58.579535],
        [-67.862701, 58.309272],
        [-68.129547, 58.082994],
        [-67.862701, 58.237250],
        [-67.738515, 58.469184],
        [-67.713490, 57.927069],
        [-67.567860, 58.230414],
        [-66.615102, 58.497992],
        [-66.382395, 58.853583],
        [-65.944163, 58.620836],
        [-66.053375, 58.332831],
        [-65.827504, 58.579901],
        [-66.108632, 58.779120],
        [-65.795644, 58.863471],
        [-65.982249, 58.917182],
        [-65.319732, 59.046007],
        [-65.717641, 59.158311],
        [-65.739329, 59.270616],
        [-65.491689, 59.258287],
        [-65.558990, 59.376654],
        [-65.357574, 59.282172],
        [-65.559926, 59.491034],
        [-65.411855, 59.517890],
        [-65.497914, 59.792670],
        [-64.983957, 59.764757],
        [-65.229726, 59.892401],
        [-64.860463, 60.361274],
        [-64.464223, 60.291083],
        [-64.380605, 60.245185],
        [-64.636545, 60.293036],
        [-64.758656, 60.238349],
        [-64.394928, 60.217231],
        [-64.463246, 60.087510],
        [-64.632436, 60.071519],
        [-64.828277, 59.991156],
        [-64.451527, 60.066148],
        [-64.377187, 60.129747],
        [-64.518422, 59.902533],
        [-64.182607, 60.032294],
        [-64.264556, 59.764757],
        [-63.921986, 59.655504],
        [-64.031606, 59.644965],
        [-64.120595, 59.518378],
        [-64.007314, 59.624010],
        [-63.864084, 59.611314],
        [-63.980702, 59.506415],
        [-63.727691, 59.519965],
        [-64.060658, 59.387274],
        [-63.709625, 59.368150],
        [-63.825754, 59.244615],
        [-63.651682, 59.368150],
        [-63.524078, 59.323106],
        [-63.628977, 59.216986],
        [-63.380727, 59.278754],
        [-63.442209, 59.120551],
        [-63.973541, 59.078966],
        [-64.039906, 59.017930],
        [-63.339752, 59.032335],
        [-63.161610, 58.922471],
        [-63.326080, 58.861029],
        [-63.014516, 58.897406],
        [-62.914622, 58.751166],
        [-63.044911, 58.710191],
        [-62.844594, 58.685167],
        [-63.442209, 58.524644],
        [-63.339752, 58.463202],
        [-63.264027, 58.470038],
        [-63.085846, 58.456366],
        [-63.157135, 58.395006],
        [-63.161610, 58.367621],
        [-62.558258, 58.477484],
        [-62.907582, 58.214342],
        [-63.079091, 58.155341],
        [-63.339752, 57.983995],
        [-62.462066, 58.181993],
        [-62.517323, 58.058539],
        [-62.305043, 58.031195],
        [-62.534495, 58.005683],
        [-62.674957, 57.935614],
        [-62.140859, 57.978258],
        [-61.886708, 57.637641],
        [-62.533681, 57.496039],
        [-61.900380, 57.415473],
        [-61.804799, 57.367051],
        [-62.011627, 57.242987],
        [-61.359120, 57.089586],
        [-61.344838, 56.955512],
        [-61.904652, 56.793769],
        [-61.688100, 56.620347],
        [-62.503082, 56.784857],
        [-61.712026, 56.575385],
        [-62.147369, 56.455268],
        [-61.605540, 56.283922],
        [-61.344838, 56.222480],
        [-61.455312, 56.058051],
        [-61.234975, 56.043769],
        [-61.503082, 56.010199],
        [-60.728505, 55.825263],
        [-60.601959, 55.819566],
        [-60.681304, 55.564561],
        [-60.507924, 55.804023],
        [-60.334706, 55.781968],
        [-60.525380, 55.616767],
        [-60.304026, 55.530463],
        [-60.454742, 55.447862],
        [-60.482086, 55.352281],
        [-60.327707, 55.494818],
        [-60.194081, 55.427436],
        [-60.687571, 54.995429],
        [-60.022817, 55.276557],
        [-60.297109, 55.023383],
        [-59.776357, 55.331855],
        [-59.735422, 55.201483],
        [-59.974477, 55.155951],
        [-59.963979, 55.117133],
        [-59.430043, 55.142035],
        [-59.735422, 54.968085],
        [-59.921986, 54.743232],
        [-59.159779, 55.238715],
        [-59.382558, 54.978013],
        [-59.027415, 55.161973],
        [-58.913808, 54.848212],
        [-57.350413, 54.589423],
        [-57.707021, 54.475287],
        [-57.419016, 54.461005],
        [-57.633860, 54.383409],
        [-58.371165, 54.228217],
        [-59.474517, 53.828111],
        [-60.132680, 53.783149],
        [-60.016591, 53.708075],
        [-60.136098, 53.529364],
        [-60.879303, 53.831000],
        [-60.920277, 53.714301],
        [-60.049794, 53.497789],
        [-60.420644, 53.268622],
        [-59.076812, 53.686998],
        [-58.840688, 53.947089],
        [-57.795766, 54.071234],
        [-58.415517, 54.140448],
        [-58.042836, 54.240953],
        [-57.466176, 54.200303],
        [-57.158030, 53.951117],
        [-57.124135, 53.741645],
        [-57.549387, 53.590766],
        [-57.317779, 53.585191],
        [-57.377431, 53.433702],
        [-56.983469, 53.727484],
        [-56.479888, 53.790025],
        [-56.726918, 53.686998],
        [-56.036244, 53.580430],
        [-56.263499, 53.553656],
        [-55.745473, 53.255601],
        [-55.906402, 53.036322],
        [-56.165191, 53.035875],
        [-55.802113, 52.840684],
        [-56.158355, 52.804633],
        [-55.753733, 52.624986],
        [-56.500356, 52.597724],
        [-55.647572, 52.443183],
        [-55.783559, 52.338690],
        [-55.616526, 52.220323],
        [-55.772613, 52.214301],
        [-55.684804, 52.111680],
        [-55.916412, 51.935004],
        [-56.966542, 51.425238],
        [-57.685902, 51.480414],
        [-58.622670, 51.277330],
        [-58.625640, 51.151475],
        [-59.007965, 51.014960],
        [-59.007965, 50.761054],
        [-59.087758, 50.887681],
        [-59.944325, 50.261094],
        [-61.717885, 50.100043],
        [-61.576080, 50.187364],
        [-62.709137, 50.315416],
        [-66.448883, 50.273546],
        [-66.549550, 50.198310],
        [-66.434885, 50.157538],
        [-66.635610, 50.185045],
        [-67.131459, 49.831285],
        [-67.376332, 49.339219],
        [-68.054555, 49.294379],
        [-68.392323, 49.063910],
        [-68.444325, 49.061632],
        [-68.369781, 49.115587],
        [-68.403310, 49.184516],
        [-68.444325, 49.198188],
        [-69.676015, 48.149888],
        [-70.369211, 48.374132],
        [-70.987213, 48.465155],
        [-71.069814, 48.444648],
        [-69.735951, 48.122504],
        [-69.932037, 47.773057],
        [-70.486928, 47.444770],
        [-70.750640, 47.091783],
        [-71.341664, 46.742336],
        [-71.880523, 46.690660],
        [-72.994496, 46.210801],
        [-73.022043, 46.109605],
        [-73.158559, 46.074856],
        [-73.420277, 45.765123],
        [-73.979237, 45.498440],
        [-74.379465, 45.561632],
        [-73.961537, 45.354234],
        [-73.518951, 45.426256],
        [-73.156117, 46.049709],
        [-72.731028, 46.176622],
        [-72.189931, 46.526231],
        [-71.867096, 46.666653],
        [-71.714182, 46.632188],
        [-71.302480, 46.745185],
        [-71.157948, 46.840806],
        [-70.534901, 47.010565],
        [-68.824778, 48.365831],
        [-66.622060, 49.122626],
        [-65.565785, 49.266466],
        [-64.552561, 49.097357],
        [-64.221181, 48.894355],
        [-64.168813, 48.761827],
        [-64.303334, 48.830268],
        [-64.559397, 48.882880],
        [-64.188832, 48.526597],
        [-65.285553, 48.012641],
        [-65.895741, 48.225531],
        [-66.385894, 48.075141],
        [-65.817860, 47.907416],
        [-65.635732, 47.622260],
        [-64.800038, 47.809272],
        [-64.668609, 47.732123],
        [-64.908844, 47.355333],
        [-65.367543, 47.087795],
        [-64.799631, 47.081610],
        [-64.854237, 46.676337],
        [-64.713612, 46.687161],
        [-64.704010, 46.327501],
        [-64.558502, 46.369127],
        [-64.559397, 46.223782],
        [-63.813059, 46.140286],
        [-64.093251, 46.032620],
        [-63.229848, 45.806057],
        [-63.294789, 45.725653],
        [-62.674957, 45.771959],
        [-62.749745, 45.612860],
        [-61.911488, 45.888983],
        [-61.876291, 45.692694],
        [-61.492543, 45.690660],
        [-61.237213, 45.505764],
        [-61.461537, 45.354844],
        [-60.971181, 45.313870],
        [-62.830434, 44.717760],
        [-63.119374, 44.790676],
        [-63.438954, 44.596340],
        [-63.661855, 44.716783],
        [-63.523264, 44.518134],
        [-63.632802, 44.440741],
        [-63.929433, 44.511339],
        [-63.888417, 44.696357],
        [-64.075836, 44.476630],
        [-64.305531, 44.565985],
        [-64.237294, 44.299140],
        [-64.429067, 44.339993],
        [-64.838979, 43.829657],
        [-65.128570, 43.674669],
        [-65.367543, 43.743557],
        [-65.474843, 43.470933],
        [-65.719309, 43.508897],
        [-65.861643, 43.805569],
        [-65.996653, 43.854071],
        [-66.015248, 43.696397],
        [-66.170074, 43.860256],
        [-66.113678, 44.343370],
        [-65.840484, 44.573391],
        [-66.196767, 44.390937],
        [-65.998769, 44.579657],
        [-65.692291, 44.620714],
        [-65.428944, 44.778225],
        [-65.723459, 44.727444],
        [-64.477773, 45.341132],
        [-64.155344, 44.983710],
        [-64.115061, 45.216051],
        [-63.360219, 45.361070],
        [-64.576161, 45.415635],
        [-64.929311, 45.326321],
        [-64.264556, 45.765123],
        [-64.347157, 45.888658],
        [-64.480865, 45.727891],
        [-64.545766, 45.731594],
        [-64.531484, 45.902248],
        [-64.572418, 45.885606],
        [-64.703969, 46.062161],
        [-64.764882, 46.087266],
        [-64.572418, 45.860704],
        [-64.641347, 45.724189],
        [-65.752349, 45.244371],
        [-66.135976, 45.312649],
        [-66.001861, 45.398586],
        [-66.009755, 45.464342],
        [-66.196767, 45.333808],
        [-66.060211, 45.258043],
        [-66.454213, 45.077053],
        [-66.888905, 45.060696],
        [-66.943471, 45.189765],
        [-67.040069, 45.075629],
        [-67.190297, 45.233181],
        [-67.040069, 44.973171],
        [-67.203399, 44.904893],
        [-66.977325, 44.815538],
        [-67.196482, 44.644232],
        [-67.395741, 44.698839],
        [-67.714141, 44.500759],
        [-67.790517, 44.599880],
        [-68.060536, 44.328315],
        [-68.202016, 44.525092],
        [-68.478220, 44.493394],
        [-68.541371, 44.237331],
        [-68.820790, 44.314643],
        [-68.699330, 44.409695],
        [-68.816192, 44.402086],
        [-68.742624, 44.537299],
        [-68.801625, 44.560289],
        [-69.191396, 43.952175],
        [-69.364288, 44.060533],
        [-69.547637, 43.834906],
        [-69.533966, 44.021023],
        [-69.592397, 43.807725],
        [-69.629587, 44.027289],
        [-69.758005, 43.759508],
        [-69.790639, 43.733100],
        [-69.879262, 43.870551],
        [-70.182607, 43.757066],
        [-70.204945, 43.561143],
        [-70.742340, 43.087958]
    ],
    [
        [-124.492447, 42.929836],
        [-124.412465, 42.248928],
        [-124.062155, 41.435876],
        [-124.232841, 40.766643],
        [-124.151324, 40.863321],
        [-124.087398, 40.825156],
        [-124.409202, 40.443818],
        [-123.854019, 39.833514],
        [-123.726242, 38.918576],
        [-123.128729, 38.449310],
        [-122.996297, 38.242730],
        [-123.027453, 37.994489],
        [-122.962504, 37.992048],
        [-122.979070, 38.014516],
        [-122.936086, 38.030770],
        [-122.948476, 38.060736],
        [-122.920142, 38.065312],
        [-122.528426, 37.816372],
        [-122.396520, 38.153231],
        [-122.130290, 38.042142],
        [-121.682602, 38.147193],
        [-121.778709, 38.036019],
        [-121.742063, 38.029449],
        [-121.680282, 38.092691],
        [-121.604075, 38.105780],
        [-121.486562, 38.044745],
        [-121.445383, 38.003892],
        [-122.366306, 38.012336],
        [-122.032140, 37.463364],
        [-122.374109, 37.604187],
        [-122.408637, 37.810392],
        [-122.520472, 37.531421],
        [-122.339290, 37.118582],
        [-121.804246, 36.836018],
        [-121.981115, 36.583717],
        [-121.899661, 36.304400],
        [-120.644887, 35.139390],
        [-120.636627, 34.562893],
        [-119.563175, 34.414795],
        [-119.128653, 34.100547],
        [-118.544057, 34.038886],
        [-118.412041, 33.741678],
        [-118.090536, 33.730977],
        [-117.361914, 33.165943],
        [-117.024973, 32.276923],
        [-116.611819, 31.842880],
        [-116.750381, 31.752360],
        [-116.675608, 31.552639],
        [-116.341542, 31.219550],
        [-116.335446, 30.956340],
        [-116.057932, 30.802476],
        [-115.697564, 29.755826],
        [-114.972035, 29.377753],
        [-114.068227, 28.518012],
        [-114.039736, 28.027730],
        [-114.153432, 27.945014],
        [-114.140981, 27.730862],
        [-113.953277, 27.655666],
        [-114.102935, 27.601874],
        [-114.316274, 27.874701],
        [-115.083823, 27.851054],
        [-115.001726, 27.715931],
        [-114.506461, 27.406184],
        [-114.421405, 27.166457],
        [-113.816388, 26.948969],
        [-113.597675, 26.709628],
        [-113.270544, 26.752474],
        [-113.145741, 26.970120],
        [-113.215810, 26.744452],
        [-112.178942, 25.955175],
        [-112.030778, 25.473615],
        [-112.165803, 24.953935],
        [-112.078114, 24.762152],
        [-111.966705, 24.744208],
        [-112.008372, 24.874579],
        [-111.812908, 24.505880],
        [-111.679030, 24.586334],
        [-110.307362, 23.541032],
        [-109.999659, 22.894442],
        [-109.516177, 23.125283],
        [-109.426316, 23.458513],
        [-109.696321, 23.665520],
        [-109.828288, 24.062800],
        [-109.987652, 24.046319],
        [-110.246200, 24.350445],
        [-110.332470, 24.328795],
        [-110.306134, 24.176716],
        [-110.325195, 24.175709],
        [-110.681849, 24.360660],
        [-110.683868, 24.882959],
        [-111.307116, 25.779207],
        [-111.560055, 26.695653],
        [-111.851419, 26.880275],
        [-111.676793, 26.581859],
        [-111.784275, 26.571796],
        [-111.950372, 27.093276],
        [-112.773218, 27.863902],
        [-112.846304, 28.441077],
        [-113.102970, 28.504583],
        [-113.220263, 28.824843],
        [-113.524854, 28.891566],
        [-113.636331, 29.282179],
        [-114.533132, 29.967951],
        [-114.710452, 30.918416],
        [-114.884043, 31.120715],
        [-114.780629, 31.655829],
        [-114.835032, 31.801907],
        [-115.011952, 31.914740],
        [-115.029449, 31.970933],
        [-114.208888, 31.512283],
        [-114.028942, 31.491539],
        [-113.977691, 31.663072],
        [-113.622269, 31.325584],
        [-113.091744, 31.202152],
        [-113.079895, 30.670441],
        [-112.411224, 29.344728],
        [-112.239453, 29.315337],
        [-112.166508, 28.966726],
        [-111.105025, 27.935372],
        [-110.513295, 27.873196],
        [-110.627101, 27.641099],
        [-110.522329, 27.290354],
        [-109.966176, 27.108873],
        [-109.784576, 26.719428],
        [-109.483428, 26.742641],
        [-109.314154, 26.568716],
        [-109.082997, 26.277004],
        [-109.216664, 26.343980],
        [-109.433258, 26.021674],
        [-109.410308, 25.693305],
        [-109.286855, 25.710679],
        [-109.410308, 25.646145],
        [-109.156484, 25.556789],
        [-109.250152, 25.686184],
        [-109.062123, 25.590277],
        [-109.116119, 25.536322],
        [-108.768951, 25.540188],
        [-108.765736, 25.380927],
        [-108.399241, 25.145250],
        [-108.361399, 25.269355],
        [-108.106923, 25.116929],
        [-108.013173, 25.001899],
        [-108.327870, 25.111151],
        [-108.087636, 24.823147],
        [-107.996571, 24.967841],
        [-107.995188, 24.648383],
        [-107.529693, 24.521918],
        [-107.498036, 24.343940],
        [-107.312978, 24.166327]
    ],
    [
        [-69.664052, 43.789130],
        [-69.647125, 43.837307],
        [-69.673166, 43.852932],
        [-69.688791, 43.828192],
        [-69.664052, 43.789130]
    ],
    [
        [-69.669260, 43.955797],
        [-69.722646, 43.907620],
        [-69.714833, 43.859442],
        [-69.698741, 43.872542],
        [-69.669260, 43.955797]
    ],
    [
        [-68.606760, 44.088609],
        [-68.651031, 44.065172],
        [-68.656239, 44.010484],
        [-68.608062, 44.023505],
        [-68.606760, 44.088609]
    ],
    [
        [143.896495, 44.158149],
        [143.836274, 44.175930],
        [143.813731, 44.168402],
        [143.940440, 44.139146],
        [143.975841, 44.148261],
        [143.896495, 44.158149]
    ],
    [
        [-68.811187, 44.148505],
        [-68.856760, 44.181057],
        [-68.942698, 44.117255],
        [-68.863271, 44.119859],
        [-68.811187, 44.148505]
    ],
    [
        [-68.390614, 44.162828],
        [-68.459625, 44.184963],
        [-68.506500, 44.160224],
        [-68.432281, 44.128974],
        [-68.390614, 44.162828]
    ],
    [
        [-68.920562, 44.237047],
        [-68.885406, 44.299547],
        [-68.901031, 44.311265],
        [-68.942698, 44.290432],
        [-68.920562, 44.237047]
    ],
    [
        [-68.489573, 44.347724],
        [-68.511708, 44.378974],
        [-68.529937, 44.330797],
        [-68.484364, 44.313870],
        [-68.489573, 44.347724]
    ],
    [
        [-68.868479, 44.381578],
        [-68.911448, 44.365953],
        [-68.903635, 44.319078],
        [-68.859364, 44.358140],
        [-68.868479, 44.381578]
    ],
    [
        [-67.566396, 44.461005],
        [-67.582021, 44.514390],
        [-67.614573, 44.514390],
        [-67.584625, 44.444078],
        [-67.566396, 44.461005]
    ],
    [
        [-67.283844, 44.619859],
        [-67.303375, 44.625067],
        [-67.321604, 44.602932],
        [-67.276031, 44.602932],
        [-67.283844, 44.619859]
    ],
    [
        [-67.045115, 44.927151],
        [-67.012115, 44.899359],
        [-66.989573, 44.897610],
        [-67.038157, 44.954901],
        [-67.045115, 44.927151]
    ],
    [
        [-66.901031, 44.889390],
        [-66.904937, 44.955797],
        [-66.981760, 44.872463],
        [-66.919260, 44.837307],
        [-66.901031, 44.889390]
    ],
    [
        [-66.963531, 44.961005],
        [-66.947906, 44.983140],
        [-66.938791, 45.024807],
        [-67.016916, 44.979234],
        [-66.963531, 44.961005]
    ],
    [
        [145.767426, 43.387274],
        [145.582286, 43.335761],
        [145.517100, 43.228990],
        [145.258311, 43.327094],
        [145.393565, 43.305365],
        [145.071462, 43.774604],
        [145.341482, 44.345526],
        [144.740489, 43.914618],
        [144.242931, 44.119208],
        [143.728282, 44.113471],
        [141.919444, 45.515855],
        [141.647960, 45.437201],
        [141.583751, 45.251166],
        [141.796072, 44.641750],
        [141.640636, 43.937934],
        [141.337413, 43.712836],
        [141.423350, 43.317857],
        [141.169119, 43.140855],
        [140.360118, 43.325181],
        [140.521169, 42.996283],
        [140.281505, 42.757270],
        [139.876964, 42.663398],
        [139.767589, 42.310981],
        [140.145030, 41.982652],
        [139.979828, 41.581732],
        [140.208995, 41.401109],
        [140.660411, 41.827135],
        [141.199962, 41.799465],
        [140.291759, 42.259589],
        [140.500662, 42.579169],
        [140.733653, 42.564154],
        [140.977306, 42.299628],
        [141.817149, 42.599595],
        [143.241547, 41.928046],
        [143.348969, 42.319159],
        [143.886404, 42.844184],
        [144.323009, 43.002631],
        [145.014334, 42.989488],
        [145.530610, 43.168850],
        [145.767426, 43.387274]
    ],
    [
        [-56.150950, 46.793647],
        [-56.191884, 46.806627],
        [-56.240305, 46.765692],
        [-56.168080, 46.757270],
        [-56.150950, 46.793647]
    ],
    [
        [-56.273793, 46.895453],
        [-56.253326, 47.053697],
        [-56.366282, 47.140204],
        [-56.370676, 46.786200],
        [-56.273793, 46.895453]
    ],
    [
        [-55.877187, 47.266018],
        [-55.843088, 47.273424],
        [-55.888051, 47.294908],
        [-55.949941, 47.268134],
        [-55.877187, 47.266018]
    ],
    [
        [-54.122548, 47.642727],
        [-54.126047, 47.670111],
        [-54.362701, 47.409980],
        [-54.244049, 47.407701],
        [-54.122548, 47.642727]
    ],
    [
        [-55.925038, 47.677476],
        [-56.083485, 47.666164],
        [-56.109975, 47.636542],
        [-55.877187, 47.616034],
        [-55.925038, 47.677476]
    ],
    [
        [-54.095123, 47.619127],
        [-54.098500, 47.491848],
        [-54.081532, 47.478217],
        [-54.061106, 47.656399],
        [-54.081532, 47.691148],
        [-54.095123, 47.619127]
    ],
    [
        [-53.567698, 48.190823],
        [-53.677480, 48.149848],
        [-53.618804, 48.082099],
        [-53.567698, 48.190823]
    ],
    [
        [-54.656890, 49.465725],
        [-54.679596, 49.492906],
        [-54.749908, 49.424262],
        [-54.698557, 49.407660],
        [-54.656890, 49.465725]
    ],
    [
        [-55.725738, 49.561916],
        [-55.733225, 49.513495],
        [-55.657094, 49.541449],
        [-55.657460, 49.561916],
        [-55.725738, 49.561916]
    ],
    [
        [-55.578969, 49.609687],
        [-55.671742, 49.637030],
        [-55.725738, 49.581773],
        [-55.670277, 49.571112],
        [-55.578969, 49.609687]
    ],
    [
        [87.404959, 21.586656],
        [87.867198, 21.750800],
        [88.164317, 22.089789],
        [87.965343, 22.244818],
        [87.906586, 22.424750],
        [88.198009, 22.167792],
        [88.261567, 21.798651],
        [88.309744, 21.610175],
        [88.331228, 21.719062],
        [88.456309, 21.624010],
        [88.495616, 21.951809],
        [88.567068, 21.850816],
        [88.660167, 22.205024],
        [88.727875, 21.559882],
        [88.858653, 21.766832],
        [89.082693, 21.617336],
        [88.905040, 21.969428],
        [89.060883, 21.938463],
        [89.043712, 22.137397],
        [89.210460, 21.654120],
        [89.352224, 21.972317],
        [89.406423, 21.717353],
        [89.475759, 22.295071],
        [89.532888, 21.984687],
        [89.549164, 22.205268],
        [89.626475, 22.336005],
        [89.586925, 21.700832],
        [89.646983, 21.925116],
        [89.880382, 21.884182],
        [89.797211, 22.075995],
        [89.872895, 22.418606],
        [90.010102, 22.490220],
        [89.917491, 22.049872],
        [90.078380, 22.164049],
        [90.052419, 21.989000],
        [90.148285, 22.110785],
        [90.205821, 22.132961],
        [90.216156, 22.123236],
        [90.044932, 21.966132],
        [90.024425, 21.862454],
        [90.203787, 21.804592],
        [90.394298, 22.288235],
        [90.438650, 22.075995],
        [90.619314, 22.355902],
        [90.372569, 22.761420],
        [90.606619, 23.247219],
        [90.250336, 23.466946],
        [90.551931, 23.384955],
        [90.476329, 23.582953],
        [90.627126, 23.603461],
        [90.629405, 23.064399],
        [90.941742, 22.585883],
        [91.018321, 22.683092],
        [91.202743, 22.543220],
        [91.181895, 22.726467],
        [91.490489, 22.904527],
        [91.787120, 22.237942],
        [91.791352, 22.301907],
        [91.908051, 22.424750],
        [91.812999, 22.180325],
        [92.029307, 21.704901],
        [92.045421, 21.170966],
        [92.325531, 20.738715],
        [92.261485, 20.940253],
        [92.265147, 21.061103],
        [92.731212, 20.259182],
        [92.635020, 20.697984],
        [92.826915, 20.495063],
        [92.942882, 20.321234],
        [92.772146, 20.201483],
        [92.898448, 20.135688],
        [93.073253, 20.554633],
        [92.990489, 20.154934],
        [92.970225, 20.129462],
        [93.134532, 19.834052],
        [93.131521, 20.006578],
        [93.128429, 20.094672],
        [93.740001, 19.925116],
        [93.601410, 19.718573],
        [93.806814, 19.745836],
        [93.731212, 19.632554],
        [93.980968, 19.372260],
        [93.796886, 19.235175],
        [93.483246, 19.350653],
        [93.930431, 18.858629],
        [93.910411, 19.190985],
        [94.066905, 19.388983],
        [94.038097, 18.859117],
        [94.279307, 18.738511],
        [94.148936, 18.731024],
        [94.615001, 17.545559],
        [94.268321, 16.527493],
        [94.239513, 15.976304],
        [94.732270, 16.524563],
        [94.566580, 15.935492],
        [94.601329, 15.921210],
        [94.721202, 15.856676],
        [94.854666, 16.160224],
        [94.992442, 16.250800],
        [94.846853, 15.790595],
        [95.033946, 15.805732],
        [95.070567, 16.074856],
        [95.135753, 16.148383],
        [95.212738, 15.786566],
        [95.361583, 16.148383],
        [95.287934, 15.740139],
        [95.415782, 15.722968],
        [95.724864, 16.222846],
        [96.321300, 16.415269],
        [96.171153, 16.771552],
        [96.287120, 16.813137],
        [96.265961, 16.596829],
        [96.436261, 16.477768],
        [96.679473, 16.574868],
        [96.910899, 17.024807],
        [96.883067, 17.457424],
        [97.130626, 17.079413],
        [97.158051, 17.129299],
        [97.260997, 17.107327],
        [97.183279, 16.921536],
        [97.370291, 16.483547],
        [97.735525, 16.566799],
        [97.568858, 16.062405],
        [97.727061, 15.843207],
        [97.794770, 14.880316],
        [98.027599, 14.647528],
        [97.885509, 14.684068],
        [98.110118, 14.167792],
        [98.192149, 14.064683],
        [98.578461, 13.186754],
        [98.706554, 12.347886],
        [98.539073, 12.241767],
        [98.703298, 12.237779],
        [98.721446, 11.997789],
        [98.549001, 11.878648],
        [98.706554, 11.878648],
        [98.674164, 11.685248],
        [98.808930, 11.851304],
        [98.891612, 11.693671],
        [98.735606, 11.642035],
        [98.712413, 10.924384],
        [98.459321, 10.715399],
        [98.543142, 9.987454],
        [98.322276, 9.209377],
        [98.281423, 8.225898],
        [98.424978, 8.148424],
        [98.428233, 8.316962],
        [98.655447, 8.379625],
        [98.770274, 8.023668],
        [99.069591, 7.924872],
        [99.033214, 7.722805],
        [99.292735, 7.620673],
        [99.378184, 7.320950],
        [99.603526, 7.376166],
        [99.557872, 7.197455],
        [99.748057, 7.126044],
        [99.685802, 6.877346],
        [100.103526, 6.533189],
        [100.349132, 6.012681],
        [100.364513, 5.084296],
        [100.666189, 4.669908],
        [100.565440, 4.319159],
        [100.871430, 4.018866],
        [100.709483, 3.883043],
        [101.297618, 3.274604],
        [101.286388, 2.849677],
        [103.367361, 1.538398],
        [103.516368, 1.270453],
        [103.697602, 1.450629],
        [104.009776, 1.448635],
        [103.965994, 1.647854],
        [104.147634, 1.545396],
        [104.114024, 1.368476],
        [104.294688, 1.446519],
        [103.813975, 2.581488],
        [103.441173, 2.922105],
        [103.482188, 3.511786],
        [103.338715, 3.758205],
        [103.496430, 4.306220],
        [103.448009, 4.806545],
        [103.027599, 5.485500],
        [102.338145, 6.176988],
        [101.808360, 6.464545],
        [101.557384, 6.841783],
        [101.291731, 6.954572],
        [100.997573, 6.856675],
        [100.585420, 7.224402],
        [100.555869, 7.144695],
        [100.424436, 7.171206],
        [100.179210, 7.531195],
        [100.210623, 7.780911],
        [100.574600, 7.209153],
        [100.220470, 8.448717],
        [99.967133, 8.605658],
        [99.853526, 9.294664],
        [99.234141, 9.278266],
        [99.151622, 10.357367],
        [99.285004, 10.364488],
        [99.641856, 11.523261],
        [100.020030, 12.192694],
        [99.960460, 12.667914],
        [100.104340, 13.057318],
        [99.962738, 13.309882],
        [100.597830, 13.612250],
        [100.995779, 13.496161],
        [100.857921, 12.652655],
        [101.766124, 12.705878],
        [102.264822, 12.306220],
        [102.201020, 12.433539],
        [102.304047, 12.427395],
        [102.290375, 12.193996],
        [102.582367, 12.049262],
        [102.605724, 12.221259],
        [102.954600, 11.570217],
        [102.893077, 11.830268],
        [103.084972, 11.727851],
        [102.954600, 11.557115],
        [103.037120, 11.604926],
        [103.174327, 11.426174],
        [103.064464, 11.447252],
        [103.126720, 10.881293],
        [103.402110, 10.884345],
        [103.561860, 11.152248],
        [103.722423, 10.894843],
        [103.501964, 10.617133],
        [103.623871, 10.500922],
        [103.866384, 10.699368],
        [104.524913, 10.419420],
        [104.613048, 10.144477],
        [104.771983, 10.226630],
        [105.042654, 10.055080],
        [105.100434, 9.974107],
        [105.113292, 9.857082],
        [104.856558, 9.738037],
        [104.774595, 8.817867],
        [104.963145, 8.719387],
        [104.720225, 8.613756],
        [104.832774, 8.569159],
        [105.101472, 8.634275],
        [105.538748, 9.129340],
        [106.193370, 9.369330],
        [105.819021, 10.007961],
        [106.385020, 9.548285],
        [106.543712, 9.585028],
        [106.574962, 9.739081],
        [106.113292, 10.234280],
        [106.668712, 9.842841],
        [106.696300, 9.896552],
        [106.461681, 10.035712],
        [106.292003, 10.261705],
        [106.648936, 9.974351],
        [106.797618, 10.157213],
        [106.422374, 10.316962],
        [106.790782, 10.284857],
        [106.741059, 10.468004],
        [106.689789, 10.433051],
        [106.655772, 10.474066],
        [106.615408, 10.436591],
        [106.597423, 10.433051],
        [106.581879, 10.452786],
        [106.747569, 10.673651],
        [106.963634, 10.466620],
        [106.991466, 10.480862],
        [107.271983, 10.378485],
        [109.018077, 11.355902],
        [109.020274, 11.632799],
        [109.135997, 11.570217],
        [109.242931, 11.735663],
        [109.224783, 11.878648],
        [109.294200, 11.871243],
        [109.149669, 12.440375],
        [109.345958, 12.396308],
        [109.204926, 12.646430],
        [109.358897, 12.797309],
        [109.342052, 12.660102],
        [109.472423, 12.656399],
        [109.232188, 13.393134],
        [109.307384, 13.876370],
        [108.862478, 15.152493],
        [108.951671, 15.250230],
        [108.628917, 15.455715],
        [108.279145, 15.995673],
        [108.331391, 16.155341],
        [108.245372, 16.162014],
        [108.258962, 16.010565],
        [108.197520, 16.003730],
        [108.204356, 16.216702],
        [107.812266, 16.313178],
        [106.285167, 17.772121],
        [106.498057, 17.710639],
        [106.434825, 18.123521],
        [106.093435, 18.258734],
        [105.613292, 18.985541],
        [105.955577, 19.925482],
        [106.569615, 20.231994],
        [106.518565, 20.540961],
        [106.805919, 20.677558],
        [106.642100, 21.020168],
        [106.867931, 20.882717],
        [106.853770, 20.992255],
        [107.311046, 21.005276]
    ],
    [
        [114.229828, 22.555813],
        [114.408702, 22.611640],
        [114.515816, 22.452643],
        [114.617686, 22.514146],
        [114.522065, 22.705959],
        [114.784760, 22.815863],
        [114.743776, 22.609404],
        [114.895966, 22.547524],
        [114.862524, 22.763216],
        [114.985342, 22.689309],
        [115.317149, 22.904527],
        [115.233391, 22.788209],
        [115.575219, 22.668336],
        [115.612071, 22.863593],
        [115.559418, 22.836086],
        [115.468028, 22.849311],
        [115.406016, 22.925035],
        [115.730317, 22.934231],
        [115.810030, 22.746091],
        [116.213634, 22.982815],
        [116.494688, 22.939352],
        [116.508881, 23.234117],
        [116.646755, 23.162991],
        [116.804822, 23.236122],
        [116.523204, 23.418524],
        [116.773224, 23.349432],
        [116.916515, 23.662746],
        [117.257093, 23.615616],
        [117.277354, 23.782213],
        [117.490073, 23.832579],
        [117.591669, 23.737064],
        [117.667084, 24.062730],
        [117.748057, 23.907538],
        [118.126475, 24.262030],
        [117.791270, 24.467475],
        [118.021739, 24.445746],
        [118.160492, 24.693427],
        [118.219005, 24.541449],
        [118.431244, 24.699693],
        [118.620453, 24.545478],
        [118.762950, 24.762681],
        [118.572032, 24.885199],
        [118.951996, 24.870754],
        [119.017670, 24.960273],
        [118.875580, 25.243842],
        [119.027298, 25.278238],
        [118.969330, 25.226386],
        [119.099132, 25.111151],
        [119.344249, 25.242377],
        [119.102550, 25.420315],
        [119.305186, 25.604560],
        [119.483246, 25.371161],
        [119.576020, 25.467353],
        [119.579438, 25.344468],
        [119.654552, 25.358140],
        [119.449067, 25.687161],
        [119.589936, 25.687161],
        [119.695404, 26.002631],
        [119.329845, 25.944281],
        [119.093516, 26.145819],
        [119.458507, 25.982489],
        [119.654307, 26.272406],
        [119.681895, 26.317125],
        [119.566417, 26.454901],
        [119.791759, 26.413316],
        [119.784923, 26.577826],
        [119.599864, 26.570380],
        [119.552094, 26.749091],
        [119.724946, 26.697821],
        [119.685802, 26.811998],
        [119.846283, 26.852200],
        [119.879649, 26.655341],
        [120.079682, 26.796942],
        [119.847179, 26.523627],
        [120.134369, 26.646064],
        [120.128184, 26.796942],
        [120.031993, 26.899888],
        [120.421723, 27.146959],
        [120.182384, 27.216864],
        [120.195811, 27.297797],
        [120.517833, 27.201606],
        [120.681977, 27.481594],
        [120.635265, 27.763332],
        [120.868364, 27.882559],
        [120.588959, 28.026679],
        [120.559581, 28.112779],
        [120.965228, 27.987145],
        [121.168956, 28.384833],
        [121.330089, 28.147528],
        [121.408946, 28.304918],
        [121.621349, 28.285102],
        [121.510128, 28.657059],
        [121.258393, 28.675116],
        [121.142345, 28.845852],
        [121.621430, 28.735907],
        [121.491791, 28.928371],
        [121.689789, 29.017076],
        [121.408539, 29.161119],
        [121.574311, 29.305121],
        [121.724328, 29.182035],
        [121.786632, 29.374498],
        [121.785347, 29.168085],
        [121.942963, 29.195868],
        [121.971202, 29.593329],
        [121.484864, 29.390540],
        [121.443370, 29.524237],
        [122.136415, 29.884535],
        [121.721934, 29.960517],
        [121.254102, 30.348393],
        [120.646251, 30.126939],
        [120.783702, 30.089301],
        [120.792247, 30.066067],
        [120.631789, 30.122388],
        [120.734401, 30.232213],
        [120.621606, 30.372563],
        [120.450494, 30.368860],
        [120.384720, 30.249588],
        [120.147094, 30.198891],
        [120.479145, 30.403524],
        [120.698148, 30.393951],
        [120.810732, 30.296568],
        [121.020226, 30.571071],
        [121.977383, 30.914923],
        [121.725164, 31.281567],
        [120.731456, 31.813870],
        [120.750354, 31.978336],
        [120.469493, 32.025133],
        [120.229991, 31.908881],
        [120.006396, 31.950305],
        [119.606049, 32.196926],
        [119.612885, 32.354560],
        [120.131358, 31.943183],
        [120.634376, 32.077010],
        [120.977817, 31.814365],
        [121.286418, 31.890589],
        [121.930383, 31.726714],
        [121.821945, 31.952486],
        [121.443370, 32.114325],
        [121.389409, 32.384948],
        [120.830333, 32.697659],
        [120.895763, 33.013577],
        [120.257091, 34.311835],
        [119.442231, 34.746039],
        [119.192231, 34.718207],
        [119.192882, 35.000434],
        [119.647960, 35.583930],
        [120.298839, 35.973131],
        [120.097179, 36.226386],
        [120.306407, 36.274237],
        [120.353526, 36.040839],
        [120.627778, 36.116523],
        [120.714122, 36.428697],
        [120.949962, 36.459174],
        [120.750580, 36.616848],
        [121.023529, 36.583930],
        [121.459483, 36.828681],
        [121.625255, 36.740383],
        [121.926280, 36.993598],
        [122.033051, 36.898017],
        [122.166108, 37.014106],
        [122.319835, 36.822943],
        [122.507416, 36.898017],
        [122.540050, 37.027737],
        [122.402354, 37.021470],
        [122.688243, 37.409817],
        [122.183197, 37.418158],
        [122.121837, 37.562730],
        [121.988048, 37.425605],
        [121.570323, 37.428656],
        [120.738048, 37.833970],
        [120.215668, 37.684068],
        [120.322520, 37.632392],
        [119.770600, 37.151842],
        [119.145518, 37.178860],
        [118.961192, 37.295640],
        [118.969981, 37.593451],
        [119.259597, 37.715847],
        [118.950037, 38.097262],
        [118.065214, 38.143082],
        [117.716082, 38.378511],
        [117.543549, 38.621324],
        [117.715424, 39.111396],
        [118.028020, 39.219798],
        [118.326096, 39.030932],
        [118.926036, 39.130601],
        [119.279429, 39.384006],
        [119.208588, 39.569566],
        [119.535592, 39.890826],
        [120.472016, 40.214301],
        [120.981944, 40.826809],
        [121.361339, 40.939643],
        [121.739552, 40.849079],
        [121.777709, 40.934972],
        [121.867931, 40.995795],
        [121.851085, 40.832261],
        [122.301850, 40.502346],
        [121.873790, 39.991400],
        [121.470714, 39.810248],
        [121.533295, 39.622301],
        [121.223399, 39.528632],
        [121.525890, 39.364651],
        [121.942963, 39.399359],
        [121.589939, 39.264054],
        [121.674083, 39.088039],
        [121.117931, 38.943427],
        [121.153087, 38.727607],
        [121.696300, 38.862942],
        [121.587413, 38.940090],
        [121.724701, 39.030178],
        [121.859874, 38.944648],
        [122.290050, 39.350979],
        [123.223155, 39.679755],
        [123.244721, 39.814032],
        [124.118175, 39.833157],
        [124.369965, 40.098293],
        [124.499604, 40.022528],
        [124.321544, 39.912665],
        [124.564057, 39.814276],
        [124.637452, 39.590483],
        [124.746104, 39.782945],
        [125.116954, 39.565863],
        [125.444916, 39.584377],
        [125.410899, 39.213813],
        [125.137218, 38.803534],
        [125.447765, 38.777248],
        [125.657807, 38.631008],
        [125.123383, 38.666327],
        [124.879731, 38.345201],
        [124.993012, 38.226955],
        [124.677094, 38.115383],
        [125.264903, 38.077948],
        [124.979503, 37.925238],
        [125.510102, 37.894273],
        [125.347504, 37.675605],
        [125.739757, 37.925238],
        [126.110362, 37.740912],
        [126.378673, 37.889594],
        [126.699962, 37.829657],
        [126.755219, 37.637885],
        [126.531016, 37.754706],
        [126.595985, 37.439657],
        [126.870697, 37.267890],
        [126.668468, 37.161811],
        [126.870697, 37.175482],
        [126.751191, 37.070092],
        [126.890473, 37.095933],
        [126.873383, 36.947984],
        [127.039399, 36.982001],
        [126.850841, 36.753974],
        [126.796235, 36.955756],
        [126.500743, 37.054999],
        [126.582612, 36.898017],
        [126.353038, 36.999986],
        [126.356700, 36.788764],
        [126.308930, 36.966864],
        [126.128184, 36.761298],
        [126.295258, 36.582709],
        [126.479584, 36.747138],
        [126.497651, 36.448391],
        [126.617442, 36.473456],
        [126.493419, 36.130805],
        [126.870697, 36.061957],
        [126.521417, 35.970520],
        [126.837494, 35.893297],
        [126.467559, 35.639638],
        [126.670177, 35.588690],
        [126.692475, 35.534369],
        [126.492663, 35.525333],
        [126.308930, 35.233303],
        [126.452403, 35.100287],
        [126.425059, 35.019761],
        [126.343028, 35.156968],
        [126.254242, 35.123440],
        [126.315196, 34.937893],
        [126.436371, 34.981391],
        [126.373546, 34.790717],
        [126.567638, 34.901435],
        [126.665294, 34.808092],
        [126.364017, 34.749160],
        [126.378613, 34.711182],
        [126.464610, 34.584662],
        [126.290294, 34.750230],
        [126.295258, 34.589057],
        [126.539643, 34.562974],
        [126.521251, 34.294176],
        [126.777843, 34.586493],
        [126.897960, 34.417711],
        [127.248057, 34.766547],
        [127.357921, 34.698228],
        [127.124522, 34.540676],
        [127.343598, 34.445014],
        [127.349376, 34.585842],
        [127.503590, 34.591325],
        [127.365326, 34.824042],
        [127.521251, 34.889838],
        [127.640717, 34.617987],
        [127.775645, 34.849066],
        [127.575287, 34.913642],
        [127.719249, 34.990058],
        [128.069347, 35.082465],
        [128.055675, 34.931627],
        [128.412930, 34.837635],
        [128.499604, 35.009223],
        [128.389171, 35.049018],
        [128.652110, 35.061347],
        [128.577891, 35.178656],
        [128.602061, 35.213935],
        [129.123470, 35.100845],
        [129.454600, 35.513251],
        [129.587250, 36.016913],
        [129.380859, 36.041487],
        [129.430186, 37.073065],
        [128.347667, 38.696723],
        [127.393403, 39.201728],
        [127.378429, 39.378852],
        [127.562104, 39.316230],
        [127.520844, 39.746975],
        [128.006847, 40.045152],
        [128.327753, 40.028216],
        [129.233482, 40.705714],
        [129.716558, 40.834586],
        [129.806163, 41.376044],
        [129.648798, 41.549403],
        [129.774760, 41.759417],
        [130.407450, 42.324577],
        [130.703603, 42.295241],
        [130.872895, 42.527655],
        [130.693526, 42.685450],
        [131.219547, 42.554712],
        [131.815684, 43.336737],
        [132.052013, 43.314765],
        [131.929942, 43.069566],
        [132.345795, 43.297919],
        [132.311534, 42.845445],
        [132.763438, 42.908149],
        [132.815929, 42.756415],
        [132.989757, 42.826972],
        [133.157725, 42.688422],
        [133.926768, 42.882717],
        [135.139903, 43.508368],
        [135.837901, 44.362698],
        [136.165294, 44.496527],
        [138.034028, 46.155951],
        [138.562755, 47.029934],
        [138.969493, 47.317532],
        [139.261729, 47.787909],
        [140.177013, 48.461819],
        [140.397960, 48.992743],
        [140.219249, 49.013861],
        [140.444021, 49.364976]
    ],
    [
        [140.444021, 49.364976],
        [140.560802, 49.575385],
        [140.415212, 49.874579],
        [140.690929, 50.080268],
        [140.522960, 50.151068],
        [140.442149, 50.530097],
        [140.706716, 51.031684],
        [140.686290, 51.312812],
        [141.425548, 51.925482],
        [141.354991, 52.105902],
        [141.555837, 52.162299],
        [141.128184, 52.422919],
        [141.316254, 52.659125],
        [141.260590, 52.852240],
        [140.706716, 53.111029],
        [141.188813, 52.987494],
        [141.432953, 53.148871],
        [141.407481, 53.303778],
        [140.581228, 53.639309],
        [140.257335, 53.868557],
        [140.240571, 54.056952],
        [139.767589, 54.303941],
        [139.302257, 54.190619],
        [138.643565, 54.297187],
        [138.771821, 54.015570],
        [138.439220, 53.513658],
        [138.215587, 53.491767],
        [138.579926, 53.828315],
        [138.578624, 53.999335],
        [138.150076, 53.672756],
        [137.335134, 53.529364],
        [137.217621, 53.600572],
        [137.862804, 53.967597],
        [137.483897, 54.084662],
        [137.735850, 54.320990],
        [137.061371, 54.145697],
        [137.290863, 54.035712],
        [137.185720, 53.851060],
        [136.764334, 53.775295],
        [136.659190, 53.935045],
        [136.814464, 54.159329],
        [136.823497, 54.647528],
        [135.750173, 54.570950],
        [135.244151, 54.701239],
        [135.219571, 54.894121],
        [138.223477, 56.424160],
        [138.129649, 56.585639],
        [138.454448, 56.839337],
        [138.581736, 56.784509],
        [138.932957, 57.135025],
        [140.495728, 57.844774],
        [140.904307, 58.382758],
        [141.583734, 58.617749],
        [142.262380, 59.124579],
        [143.164806, 59.381008],
        [145.957006, 59.416723],
        [145.824962, 59.241278],
        [146.050292, 59.138873],
        [146.322957, 59.179952],
        [146.319141, 59.401694],
        [146.503917, 59.463121],
        [147.545999, 59.237547],
        [148.219436, 59.408870],
        [148.934522, 59.233273],
        [148.989906, 59.375377],
        [148.743429, 59.471578],
        [149.212087, 59.469143],
        [149.040701, 59.642890],
        [149.375255, 59.772203],
        [150.774348, 59.561915],
        [150.503741, 59.488666],
        [150.779912, 59.432263],
        [151.396057, 59.604163],
        [151.734298, 59.307264],
        [152.322238, 59.207409],
        [151.088050, 59.102020],
        [151.353665, 58.832562],
        [152.020298, 58.875037],
        [152.363292, 59.059719],
        [152.899913, 58.903632],
        [153.220788, 59.090295]
    ],
    [
        [-54.883453, 49.555080],
        [-54.744008, 49.493801],
        [-54.529286, 49.625067],
        [-54.884999, 49.595201],
        [-54.883453, 49.555080]
    ],
    [
        [-54.276763, 49.575588],
        [-53.987172, 49.651068],
        [-53.978505, 49.664293],
        [-54.269846, 49.727240],
        [-54.276763, 49.575588]
    ],
    [
        [61.612478, 25.200507],
        [61.783051, 25.187974],
        [61.754868, 25.013467],
        [62.145193, 25.218411],
        [62.381052, 25.087572],
        [62.477179, 25.259064],
        [63.500499, 25.193671],
        [63.572520, 25.364976],
        [64.127289, 25.453762],
        [64.094493, 25.335883],
        [64.655040, 25.165717],
        [64.744395, 25.324042],
        [66.498383, 25.398505],
        [66.336436, 25.553371],
        [66.437022, 25.597724],
        [66.737153, 25.181098],
        [66.654145, 24.839179],
        [67.255544, 24.747992],
        [67.152110, 24.615709],
        [67.362478, 24.343940],
        [67.341319, 24.086371],
        [67.533051, 24.070258],
        [67.478526, 23.891506],
        [67.650401, 23.933051],
        [67.715668, 23.791693],
        [67.855235, 23.911933],
        [68.013520, 23.768541],
        [68.013520, 23.939276],
        [68.149099, 23.694525],
        [68.157481, 23.905097],
        [68.280447, 23.685981],
        [68.143403, 23.612698],
        [68.317638, 23.586127],
        [68.427745, 23.714301],
        [68.633474, 23.833075],
        [68.821625, 23.878404],
        [68.408865, 23.621324],
        [68.406098, 23.508734],
        [68.866222, 23.019965],
        [69.715831, 22.746894],
        [70.130626, 22.993964],
        [70.392426, 22.940863],
        [70.178477, 22.561957],
        [69.212087, 22.273912],
        [69.073578, 22.481879],
        [68.944591, 22.295071],
        [70.054445, 21.153155],
        [70.740245, 20.718492],
        [72.104747, 21.205064],
        [72.298839, 21.626288],
        [71.996104, 21.799506],
        [72.307628, 22.079006],
        [72.148774, 22.277899],
        [72.917491, 22.271430],
        [72.575450, 22.194525],
        [72.501720, 21.976020],
        [72.734548, 21.994045],
        [72.550304, 21.666693],
        [73.132009, 21.757799],
        [72.564626, 21.385810],
        [72.734548, 21.198920],
        [72.615001, 21.105862],
        [72.809581, 21.130032],
        [72.946788, 20.759467],
        [72.649181, 19.851996],
        [72.722504, 19.536282],
        [72.879161, 19.532375],
        [72.763438, 19.380194],
        [72.987804, 19.300686],
        [73.049653, 19.217719],
        [72.785411, 19.313910],
        [72.770356, 18.948188],
        [72.974783, 19.163072],
        [72.995128, 18.731024],
        [72.926931, 18.826646],
        [72.851736, 18.719672],
        [73.014985, 18.469957],
        [72.891449, 18.429389],
        [73.071544, 18.273017],
        [72.926931, 18.223944],
        [73.200694, 17.586493],
        [73.447032, 16.068915],
        [73.718272, 15.627143],
        [73.838145, 15.661119],
        [73.736827, 15.571723],
        [73.967784, 15.373765],
        [73.782888, 15.407904],
        [73.913097, 15.078925],
        [74.235199, 14.876532],
        [74.096446, 14.793362],
        [74.427745, 14.476264],
        [74.735606, 13.653795],
        [74.817556, 12.861762],
        [74.940929, 12.878607],
        [74.827647, 12.824652],
        [75.193696, 12.022284],
        [75.393403, 11.974840],
        [75.735525, 11.371527],
        [76.240245, 10.238959],
        [76.182384, 10.105658],
        [76.394054, 9.842841],
        [76.406993, 9.569078],
        [76.503266, 9.534980],
        [76.357432, 9.520697],
        [76.362966, 9.325181],
        [76.528087, 8.946967],
        [76.668468, 9.007392],
        [76.543956, 8.912502],
        [76.995860, 8.368109],
        [77.510916, 8.075995],
        [78.055919, 8.363715],
        [78.182791, 8.877102],
        [78.412120, 9.099840],
        [78.988943, 9.278266],
        [79.453624, 9.159003],
        [78.913259, 9.474270],
        [79.286143, 10.252834],
        [79.856700, 10.293280],
        [79.833018, 11.341986],
        [79.676280, 11.296454],
        [79.819347, 11.381496],
        [79.785899, 11.769192],
        [80.332774, 13.198147],
        [80.326996, 13.430365],
        [80.119395, 13.500678],
        [80.052989, 13.619086],
        [80.141856, 13.728949],
        [80.313731, 13.440904],
        [80.046641, 14.206610],
        [80.196951, 14.565009],
        [80.052989, 15.092597],
        [80.279633, 15.700670],
        [80.670177, 15.907701],
        [80.807140, 15.716376],
        [80.896495, 16.031073],
        [81.012543, 15.777818],
        [81.259613, 16.332709],
        [81.762950, 16.322577],
        [82.307384, 16.579779],
        [82.280935, 16.620836],
        [82.338145, 16.678412],
        [82.365571, 16.811591],
        [82.366547, 16.908637],
        [82.252696, 16.929185],
        [82.387706, 17.126939],
        [83.238943, 17.592963],
        [83.451915, 17.922919],
        [84.113129, 18.298285],
        [84.738780, 19.147650],
        [85.330577, 19.576402],
        [85.391449, 19.690619],
        [85.247569, 19.656480],
        [85.124034, 19.478339],
        [85.246837, 19.762641],
        [85.570323, 19.875637],
        [85.456798, 19.663316],
        [86.089041, 19.844224],
        [86.372406, 19.964993],
        [86.167735, 20.072943],
        [86.152517, 20.143134],
        [86.397227, 19.982856],
        [86.754649, 20.314439],
        [86.751475, 20.489163],
        [87.003591, 20.657050],
        [87.043224, 20.697984],
        [86.878754, 20.780585],
        [86.866954, 21.256049],
        [87.404959, 21.586656]
    ],
    [
        [-59.350575, 50.603461],
        [-59.323883, 50.610256],
        [-59.341054, 50.538031],
        [-59.295969, 50.572333],
        [-59.337514, 50.644436],
        [-59.376291, 50.652330],
        [-59.350575, 50.603461]
    ],
    [
        [-55.510365, 50.805121],
        [-55.619944, 50.791815],
        [-55.642730, 50.723334],
        [-55.523590, 50.721015],
        [-55.510365, 50.805121]
    ],
    [
        [-55.527821, 50.972724],
        [-55.639150, 50.961493],
        [-55.623362, 50.911933],
        [-55.547597, 50.890815],
        [-55.527821, 50.972724]
    ],
    [
        [-58.398427, 51.254543],
        [-58.479482, 51.277981],
        [-58.562896, 51.233385],
        [-58.474192, 51.220404],
        [-58.398427, 51.254543]
    ],
    [
        [-52.628814, 47.526679],
        [-52.772532, 47.801011],
        [-53.129384, 47.416815],
        [-53.259755, 47.558539],
        [-52.836741, 48.105455],
        [-52.923329, 48.170966],
        [-53.276479, 48.016425],
        [-53.553863, 47.539252],
        [-53.928944, 47.852444],
        [-53.791615, 47.774604],
        [-53.608551, 48.054267],
        [-53.775950, 47.999416],
        [-53.908355, 48.021064],
        [-53.663197, 48.061103],
        [-53.905181, 48.085110],
        [-53.925282, 48.237006],
        [-53.639475, 48.169338],
        [-52.984771, 48.554511],
        [-53.076812, 48.703559],
        [-53.615387, 48.409898],
        [-53.656850, 48.546576],
        [-53.856028, 48.368394],
        [-53.855377, 48.475246],
        [-54.136790, 48.355292],
        [-54.164133, 48.390692],
        [-53.604115, 48.676703],
        [-53.835194, 48.750393],
        [-53.916656, 48.672756],
        [-53.793568, 48.678046],
        [-53.931386, 48.629625],
        [-54.020131, 48.746324],
        [-53.844472, 48.839057],
        [-54.197621, 48.774237],
        [-53.589915, 49.052069],
        [-53.492543, 49.287543],
        [-54.044749, 49.481757],
        [-54.483469, 49.267646],
        [-54.469309, 49.546088],
        [-54.816965, 49.275621],
        [-54.833730, 49.409613],
        [-55.034006, 49.230211],
        [-55.013173, 49.349026],
        [-55.082143, 49.362698],
        [-55.288442, 49.194566],
        [-55.184478, 49.123033],
        [-55.383127, 49.047309],
        [-55.136098, 49.540758],
        [-55.314849, 49.534613],
        [-55.236318, 49.389960],
        [-55.314849, 49.314887],
        [-55.445221, 49.355862],
        [-55.370107, 49.506659],
        [-55.569325, 49.362698],
        [-55.520904, 49.493598],
        [-56.130727, 49.429145],
        [-55.835601, 49.691636],
        [-56.165435, 49.574652],
        [-56.001943, 49.752509],
        [-55.465077, 49.962551],
        [-55.959137, 50.041083],
        [-56.191884, 49.924994],
        [-56.116811, 50.158393],
        [-56.856679, 49.548245],
        [-56.781565, 49.729438],
        [-56.905100, 49.753730],
        [-56.500356, 50.391099],
        [-56.100087, 50.668606],
        [-56.162180, 50.720852],
        [-56.161366, 50.878241],
        [-56.080637, 50.720649],
        [-55.733144, 51.083075],
        [-56.089508, 51.370551],
        [-55.596059, 51.309149],
        [-55.404205, 51.562974],
        [-55.872874, 51.495551],
        [-55.892812, 51.627753],
        [-56.720204, 51.319322],
        [-56.900706, 51.018215],
        [-57.089426, 51.021145],
        [-56.925526, 50.918158],
        [-57.396962, 50.708645],
        [-57.154775, 50.625678],
        [-57.355295, 50.606594],
        [-57.948110, 49.679511],
        [-57.700307, 49.462836],
        [-58.001210, 49.561916],
        [-58.228668, 49.370998],
        [-58.193430, 49.243069],
        [-57.926096, 49.246568],
        [-58.079986, 49.146796],
        [-58.135406, 49.126939],
        [-57.884511, 48.972235],
        [-58.398427, 49.136705],
        [-58.713735, 48.568183],
        [-58.958852, 48.616156],
        [-59.262441, 48.472602],
        [-58.272206, 48.520901],
        [-59.405832, 47.896633],
        [-59.146352, 47.560981],
        [-58.261301, 47.752590],
        [-58.354726, 47.649115],
        [-56.791493, 47.530097],
        [-56.335846, 47.616034],
        [-56.308583, 47.752590],
        [-56.180776, 47.630683],
        [-56.150950, 47.841986],
        [-56.059316, 47.699530],
        [-55.780385, 47.958075],
        [-55.914418, 47.659247],
        [-55.629547, 47.677476],
        [-55.746897, 47.588080],
        [-55.916656, 47.457343],
        [-55.917592, 47.437242],
        [-55.638417, 47.545315],
        [-55.598500, 47.399319],
        [-55.407053, 47.501451],
        [-55.427317, 47.719550],
        [-55.131174, 47.583564],
        [-55.088490, 47.601711],
        [-54.698557, 47.670640],
        [-55.979970, 46.970364],
        [-55.739410, 46.854438],
        [-55.250885, 46.918850],
        [-54.837880, 47.419257],
        [-54.664418, 47.375800],
        [-54.615956, 47.368964],
        [-54.403676, 47.450914],
        [-54.266510, 47.903469],
        [-54.081532, 47.875474],
        [-53.807851, 47.423651],
        [-53.996205, 47.317206],
        [-54.188547, 46.828437],
        [-53.560170, 47.204535],
        [-53.554677, 46.618354],
        [-53.355336, 46.739000],
        [-53.066884, 46.665595],
        [-52.628814, 47.526679]
    ],
    [
        [-127.918691, 51.522040],
        [-128.009877, 51.723700],
        [-128.156606, 51.627875],
        [-128.050282, 51.459947],
        [-127.918691, 51.522040]
    ],
    [
        [-55.352691, 51.884508],
        [-55.286041, 51.959540],
        [-55.270131, 52.005601],
        [-55.427398, 51.891343],
        [-55.352691, 51.884508]
    ],
    [
        [-128.138336, 51.864000],
        [-128.017649, 51.772162],
        [-127.953440, 52.049018],
        [-128.159250, 52.034817],
        [-128.251047, 51.875922],
        [-128.138336, 51.864000]
    ],
    [
        [-130.996653, 52.111721],
        [-131.126820, 52.111558],
        [-131.112701, 52.001858],
        [-131.023997, 51.946601],
        [-130.996653, 52.111721]
    ],
    [
        [-127.946604, 52.165717],
        [-128.076975, 52.145209],
        [-128.122955, 52.151679],
        [-127.961497, 52.082831],
        [-127.946604, 52.165717]
    ],
    [
        [-128.248199, 52.021674],
        [-128.162587, 52.073188],
        [-128.145253, 52.193590],
        [-128.290679, 52.124701],
        [-128.248199, 52.021674]
    ],
    [
        [-128.227773, 52.212836],
        [-128.447298, 52.238007],
        [-128.522442, 52.157552],
        [-128.339757, 52.079336],
        [-128.227773, 52.212836]
    ],
    [
        [-128.097401, 52.240790],
        [-128.071278, 52.182318],
        [-127.907704, 52.200873],
        [-127.985260, 52.302069],
        [-128.097401, 52.240790]
    ],
    [
        [-127.240834, 52.426418],
        [-127.751047, 52.250190],
        [-127.902170, 51.968248],
        [-127.238026, 52.312934],
        [-127.240834, 52.426418]
    ],
    [
        [-128.618235, 52.453681],
        [-128.763824, 52.449530],
        [-128.679596, 52.268134],
        [-128.623158, 52.330146],
        [-128.618235, 52.453681]
    ],
    [
        [-128.562978, 52.611396],
        [-128.732045, 52.595526],
        [-128.817454, 52.521959],
        [-128.497874, 52.436347],
        [-128.562978, 52.611396]
    ],
    [
        [-131.564565, 52.727444],
        [-131.702382, 52.721259],
        [-131.602040, 52.595160],
        [-131.452748, 52.645250],
        [-131.674428, 52.706936],
        [-131.564565, 52.727444]
    ],
    [
        [-128.310374, 52.429429],
        [-128.318593, 52.687567],
        [-128.391265, 52.796536],
        [-128.466420, 52.382717],
        [-128.310374, 52.429429]
    ],
    [
        [-128.930084, 52.614447],
        [-129.101796, 52.743394],
        [-129.275054, 52.824652],
        [-128.981272, 52.453681],
        [-128.930084, 52.614447]
    ],
    [
        [-128.310374, 52.727444],
        [-128.274973, 52.602525],
        [-128.173166, 52.823635],
        [-128.322987, 52.778754],
        [-128.310374, 52.727444]
    ],
    [
        [-128.532826, 52.727444],
        [-128.509877, 52.653876],
        [-128.502105, 52.872016],
        [-128.535959, 52.766425],
        [-128.532826, 52.727444]
    ],
    [
        [-129.557281, 53.001166],
        [-129.572092, 53.019721],
        [-129.653472, 53.022203],
        [-129.620513, 52.958197],
        [-129.557281, 53.001166]
    ],
    [
        [-129.564076, 53.056342],
        [-129.618723, 53.056342],
        [-129.519683, 53.026597],
        [-129.564076, 53.056342]
    ],
    [
        [-129.653472, 53.132066],
        [-129.693959, 53.138861],
        [-129.742909, 53.132066],
        [-129.588857, 53.071763],
        [-129.653472, 53.132066]
    ],
    [
        [-129.304067, 53.035875],
        [-129.461090, 53.186713],
        [-129.550445, 53.166205],
        [-129.394928, 53.000393],
        [-129.304067, 53.035875]
    ],
    [
        [-131.112701, 52.171942],
        [-131.009674, 52.227118],
        [-131.181020, 52.234565],
        [-131.085439, 52.275580],
        [-131.242909, 52.262152],
        [-131.359731, 52.344428],
        [-131.248443, 52.446926],
        [-131.407582, 52.358100],
        [-131.839508, 52.713772],
        [-131.660878, 52.805732],
        [-131.983551, 52.878241],
        [-131.613026, 52.926663],
        [-132.004018, 53.063870],
        [-131.595570, 53.041938],
        [-131.797963, 53.255601],
        [-132.565785, 53.145738],
        [-132.113881, 53.001166],
        [-132.342275, 52.942450],
        [-131.938791, 52.773139],
        [-132.086008, 52.734280],
        [-131.279693, 52.132392],
        [-131.277211, 52.240790],
        [-131.112701, 52.171942]
    ],
    [
        [-128.803782, 52.700670],
        [-128.664459, 52.970893],
        [-128.755360, 52.603909],
        [-128.594594, 52.614447],
        [-128.538726, 53.019721],
        [-129.078114, 53.302802],
        [-129.183746, 52.949530],
        [-128.864613, 53.035875],
        [-128.877349, 53.072008],
        [-128.837961, 53.035875],
        [-129.070668, 52.892524],
        [-129.016835, 52.859320],
        [-129.121205, 52.844550],
        [-128.803782, 52.700670]
    ],
    [
        [-129.293528, 53.107896],
        [-129.139556, 53.104804],
        [-129.197825, 53.321682],
        [-129.275746, 53.331000],
        [-129.293528, 53.107896]
    ],
    [
        [-128.913645, 53.406440],
        [-128.997222, 53.543931],
        [-129.148183, 53.363715],
        [-128.940012, 53.323920],
        [-128.913645, 53.406440]
    ],
    [
        [-129.742950, 53.235297],
        [-129.973988, 53.457994],
        [-130.515289, 53.630357],
        [-129.939443, 53.168891],
        [-129.742950, 53.235297]
    ],
    [
        [-129.166249, 53.385403],
        [-128.884267, 53.576239],
        [-128.823638, 53.708075],
        [-129.159983, 53.627021],
        [-129.166249, 53.385403]
    ],
    [
        [-130.406361, 53.686998],
        [-130.331858, 53.624010],
        [-130.091664, 53.570299],
        [-130.260894, 53.797838],
        [-130.406361, 53.686998]
    ],
    [
        [-130.252797, 53.892483],
        [-129.585032, 53.223700],
        [-129.328718, 53.263449],
        [-129.830963, 53.735419],
        [-130.252797, 53.892483]
    ],
    [
        [-130.447377, 53.981838],
        [-130.331288, 53.967597],
        [-130.478627, 53.843940],
        [-130.228871, 53.953843],
        [-130.421620, 54.100043],
        [-130.673899, 53.989244],
        [-130.723622, 53.920478],
        [-130.715484, 53.857652],
        [-130.447377, 53.981838]
    ],
    [
        [-132.579416, 53.207221],
        [-131.963043, 53.282945],
        [-131.660797, 54.166815],
        [-132.182200, 54.043891],
        [-132.078521, 53.892483],
        [-132.159169, 53.699897],
        [-132.483795, 53.577135],
        [-132.352895, 53.672756],
        [-132.657948, 53.690741],
        [-132.240631, 53.777045],
        [-132.161041, 54.008490],
        [-132.406850, 54.099351],
        [-132.661366, 53.940863],
        [-132.575673, 54.118354],
        [-133.053375, 54.183092],
        [-133.072865, 54.166815],
        [-133.144399, 53.896918],
        [-132.891103, 53.619696],
        [-132.977284, 53.556627],
        [-132.400136, 53.330308],
        [-132.538442, 53.326972],
        [-132.709788, 53.261786],
        [-132.579416, 53.207221]
    ],
    [
        [-130.229156, 54.118354],
        [-130.155873, 54.141588],
        [-130.162506, 54.160956],
        [-130.252797, 54.190660],
        [-130.229156, 54.118354]
    ],
    [
        [-130.654042, 54.118354],
        [-130.756459, 54.214545],
        [-130.804840, 54.173651],
        [-130.697621, 54.114936],
        [-130.654042, 54.118354]
    ],
    [
        [-130.353261, 54.267646],
        [-130.420644, 54.331855],
        [-130.469106, 54.303941],
        [-130.365387, 54.242499],
        [-130.353261, 54.267646]
    ],
    [
        [-130.352122, 54.267727],
        [-130.298451, 54.253648],
        [-130.253041, 54.311347],
        [-130.305043, 54.333686],
        [-130.352122, 54.267727]
    ],
    [
        [-130.760162, 54.362006],
        [-130.691070, 54.367092],
        [-130.687571, 54.399604],
        [-130.756012, 54.393866],
        [-130.760162, 54.362006]
    ],
    [
        [142.529063, 54.297187],
        [142.282563, 54.303941],
        [142.708263, 53.948228],
        [142.604177, 53.697577],
        [142.739106, 53.845689],
        [142.804454, 53.706977],
        [142.497732, 53.658271],
        [142.687266, 53.529364],
        [142.455333, 53.380276],
        [142.263927, 53.380072],
        [142.241059, 53.529364],
        [141.768809, 53.371649],
        [141.928396, 53.020657],
        [141.641856, 52.318183],
        [141.639008, 51.884508],
        [141.823009, 51.744208],
        [141.686778, 51.747301],
        [142.078949, 51.471381],
        [142.269216, 51.112413],
        [142.041352, 50.550971],
        [142.125011, 49.462307],
        [141.857432, 48.774237],
        [142.191091, 47.966742],
        [141.965831, 47.612494],
        [142.056651, 47.053697],
        [141.814220, 46.538398],
        [142.085297, 45.900824],
        [142.618419, 46.718573],
        [143.368663, 46.555487],
        [143.430512, 46.025214],
        [143.625743, 46.374701],
        [143.478201, 46.828437],
        [143.197113, 46.840806],
        [143.389659, 46.708075],
        [143.172862, 46.707831],
        [143.016368, 47.253607],
        [142.545258, 47.766669],
        [143.008800, 49.123033],
        [143.666759, 49.314887],
        [144.057872, 49.253404],
        [144.503673, 48.948717],
        [144.677257, 48.656440],
        [144.756602, 48.643256],
        [144.684744, 48.873236],
        [144.385020, 49.072699],
        [143.790294, 50.309231],
        [143.521658, 51.285102],
        [143.379405, 51.350084],
        [143.447765, 51.508368],
        [143.365082, 51.644965],
        [143.224132, 51.522162],
        [143.317882, 51.706366],
        [143.125499, 51.967027],
        [143.118663, 52.337795],
        [143.261404, 52.597602],
        [143.193696, 52.336982],
        [143.296886, 52.453681],
        [143.360525, 52.871405],
        [142.851817, 53.871975],
        [143.012950, 54.119086],
        [142.723155, 54.425605],
        [142.529063, 54.297187]
    ],
    [
        [-130.742787, 54.605618],
        [-130.931223, 54.622707],
        [-130.969106, 54.461982],
        [-130.776926, 54.550360],
        [-130.742787, 54.605618]
    ],
    [
        [-130.591949, 54.742174],
        [-130.461781, 54.712104],
        [-130.434316, 54.769477],
        [-130.483551, 54.810370],
        [-130.591949, 54.742174]
    ],
    [
        [-130.208363, 54.811103],
        [-130.340443, 54.736884],
        [-130.377675, 54.698188],
        [-130.239980, 54.730536],
        [-130.208363, 54.811103]
    ],
    [
        [-57.871449, 54.817857],
        [-57.987538, 54.803656],
        [-57.945302, 54.926581],
        [-58.227366, 54.871405],
        [-58.157094, 54.763861],
        [-57.871449, 54.817857]
    ],
    [
        [-132.647694, 54.817857],
        [-132.629303, 54.903998],
        [-132.784820, 54.927720],
        [-132.616200, 54.760199],
        [-132.647694, 54.817857]
    ],
    [
        [-131.243723, 54.934556],
        [-131.263824, 54.996894],
        [-131.482167, 54.925605],
        [-131.331166, 54.861233],
        [-131.243723, 54.934556]
    ],
    [
        [-130.431223, 54.789984],
        [-130.269846, 54.831529],
        [-130.167388, 55.016547],
        [-130.461578, 54.831529],
        [-130.431223, 54.789984]
    ],
    [
        [-132.826487, 55.054389],
        [-132.750722, 54.995429],
        [-132.668202, 55.050686],
        [-132.822662, 55.190497],
        [-132.826487, 55.054389]
    ],
    [
        [-132.702952, 54.701239],
        [-133.107004, 55.248684],
        [-133.182118, 55.235582],
        [-133.147939, 54.954413],
        [-132.702952, 54.701239]
    ],
    [
        [-131.479563, 55.006293],
        [-131.372792, 55.201483],
        [-131.551584, 55.276557],
        [-131.624501, 55.017401],
        [-131.479563, 55.006293]
    ],
    [
        [-133.291371, 55.262926],
        [-133.318105, 55.339057],
        [-133.449859, 55.250230],
        [-133.316151, 55.201483],
        [-133.209381, 55.270413],
        [-133.291371, 55.262926]
    ],
    [
        [-6.105458, 53.495185],
        [-6.062001, 53.367377],
        [-6.218170, 53.347154],
        [-5.993520, 52.957424],
        [-6.366119, 52.344428],
        [-6.372955, 52.322699],
        [-6.369862, 52.179999],
        [-6.764027, 52.261298],
        [-6.932118, 52.124661],
        [-6.903717, 52.172187],
        [-6.997385, 52.289211],
        [-7.017201, 52.138373],
        [-7.599965, 52.101020],
        [-8.020579, 51.823920],
        [-8.429351, 51.884508],
        [-8.297353, 51.766018],
        [-8.531728, 51.610785],
        [-9.349233, 51.474026],
        [-9.820221, 51.445705],
        [-9.545888, 51.610785],
        [-9.458608, 51.683987],
        [-9.560211, 51.761623],
        [-10.162831, 51.590277],
        [-9.580719, 51.877672],
        [-10.135610, 51.741156],
        [-10.388905, 51.846177],
        [-9.758168, 52.152045],
        [-10.436594, 52.097398],
        [-10.449696, 52.188910],
        [-9.737660, 52.248236],
        [-9.949941, 52.412095],
        [-9.648305, 52.570380],
        [-9.272125, 52.577216],
        [-8.751169, 52.672960],
        [-8.942616, 52.775214],
        [-9.285797, 52.590806],
        [-9.936350, 52.556708],
        [-9.498647, 52.752509],
        [-9.272206, 53.146674],
        [-8.894846, 53.220893],
        [-10.176503, 53.412665],
        [-10.012074, 53.481513],
        [-10.180287, 53.555487],
        [-9.696767, 53.598212],
        [-9.908437, 53.762112],
        [-9.560211, 53.865139],
        [-9.943756, 53.879381],
        [-9.787506, 53.916083],
        [-9.833892, 54.112128],
        [-10.010894, 54.218329],
        [-10.117421, 54.095893],
        [-10.115102, 54.235053],
        [-9.785512, 54.338080],
        [-9.268422, 54.303941],
        [-9.141225, 54.145697],
        [-9.051259, 54.289496],
        [-8.511220, 54.207750],
        [-8.663889, 54.359280],
        [-8.120839, 54.646552],
        [-8.456614, 54.564643],
        [-8.797760, 54.691962],
        [-8.325673, 54.831529],
        [-8.456614, 55.002875],
        [-8.278472, 55.160549],
        [-7.856435, 55.138983],
        [-7.798695, 55.256090],
        [-7.815745, 55.194648],
        [-7.702504, 55.099066],
        [-7.788157, 55.218573],
        [-7.643951, 55.272773],
        [-7.525787, 55.116156],
        [-7.661488, 54.957953],
        [-7.456166, 55.056138],
        [-7.524322, 55.290269],
        [-7.256744, 55.284003],
        [-7.384429, 55.386379],
        [-6.939565, 55.239081],
        [-7.256744, 55.050686],
        [-6.498118, 55.247138],
        [-6.047231, 55.178534],
        [-5.689849, 54.793118],
        [-5.907379, 54.605618],
        [-5.574696, 54.680080],
        [-5.430776, 54.485175],
        [-5.515777, 54.338080],
        [-5.558013, 54.511908],
        [-5.701975, 54.577704],
        [-5.579498, 54.275702],
        [-6.040517, 54.036444],
        [-6.263661, 54.104682],
        [-6.143544, 53.978420],
        [-6.359853, 54.016018],
        [-6.105458, 53.495185]
    ],
    [
        [-131.818471, 55.413764],
        [-131.817779, 55.197984],
        [-131.722890, 55.140082],
        [-131.636098, 55.299302],
        [-131.818471, 55.413764]
    ],
    [
        [-133.449615, 55.406928],
        [-133.580556, 55.426215],
        [-133.689198, 55.311347],
        [-133.607289, 55.235582],
        [-133.449615, 55.406928]
    ],
    [
        [-133.538401, 55.482652],
        [-133.600453, 55.447903],
        [-133.418446, 55.475572],
        [-133.505727, 55.522610],
        [-133.538401, 55.482652]
    ],
    [
        [-133.346588, 55.447903],
        [-133.272084, 55.530463],
        [-133.428538, 55.544135],
        [-133.433176, 55.527981],
        [-133.346588, 55.447903]
    ],
    [
        [-133.603871, 55.489447],
        [-133.702870, 55.557766],
        [-133.799062, 55.447903],
        [-133.651967, 55.447903],
        [-133.603871, 55.489447]
    ],
    [
        [-133.305653, 55.797349],
        [-133.614898, 55.833197],
        [-133.682362, 55.790473],
        [-133.542104, 55.694892],
        [-133.305653, 55.797349]
    ],
    [
        [-133.285146, 55.907172],
        [-133.341176, 55.837348],
        [-133.250803, 55.775946],
        [-133.216868, 55.866278],
        [-133.285146, 55.907172]
    ],
    [
        [-155.652333, 55.886664],
        [-155.749849, 55.817680],
        [-155.597264, 55.760431],
        [-155.556101, 55.914618],
        [-155.652333, 55.886664]
    ],
    [
        [-134.179270, 55.914618],
        [-134.298695, 55.926500],
        [-134.347157, 55.910956],
        [-134.258412, 55.818427],
        [-134.179270, 55.914618]
    ],
    [
        [-133.919504, 55.920844],
        [-133.912668, 55.862779],
        [-133.842519, 55.866360],
        [-133.856028, 55.942288],
        [-133.919504, 55.920844]
    ],
    [
        [-60.749013, 55.934516],
        [-60.852040, 55.961859],
        [-60.899810, 55.876776],
        [-60.687571, 55.928290],
        [-60.749013, 55.934516]
    ],
    [
        [-130.961903, 55.585110],
        [-131.280263, 55.965155],
        [-131.687734, 55.831977],
        [-131.482655, 55.783026],
        [-131.709218, 55.739651],
        [-131.517445, 55.729071],
        [-131.820221, 55.463813],
        [-131.526479, 55.299384],
        [-131.506500, 55.499416],
        [-131.462148, 55.331855],
        [-131.325429, 55.446763],
        [-131.350819, 55.645575],
        [-131.270741, 55.447333],
        [-131.463206, 55.293402],
        [-131.209950, 55.406317],
        [-131.311391, 55.235582],
        [-131.192006, 55.185736],
        [-130.961903, 55.585110]
    ],
    [
        [-133.607289, 56.078518],
        [-133.794911, 55.943590],
        [-133.311147, 55.997870],
        [-133.285308, 56.147203],
        [-133.607289, 56.078518]
    ],
    [
        [-61.009674, 56.043769],
        [-61.043813, 56.161078],
        [-61.232330, 56.099799],
        [-61.174143, 56.032416],
        [-60.940663, 56.018948],
        [-61.009674, 56.043769]
    ],
    [
        [-132.548411, 56.304429],
        [-132.702952, 56.222480],
        [-132.645416, 56.058092],
        [-132.133453, 55.929023],
        [-132.202016, 56.092190],
        [-132.092193, 56.106431],
        [-132.483795, 56.194566],
        [-132.399770, 56.350409],
        [-132.548411, 56.304429]
    ],
    [
        [-131.976715, 54.831529],
        [-131.963043, 55.030219],
        [-132.223134, 54.989203],
        [-131.994293, 55.268134],
        [-132.240224, 55.197211],
        [-132.154897, 55.365953],
        [-132.483795, 55.406928],
        [-132.276926, 55.452704],
        [-132.681793, 55.455308],
        [-132.523508, 55.625230],
        [-132.140614, 55.465277],
        [-132.508412, 55.827623],
        [-133.079091, 56.058051],
        [-133.182118, 56.332343],
        [-133.614735, 56.352851],
        [-133.573110, 56.184963],
        [-133.264638, 56.147406],
        [-133.139801, 55.876614],
        [-133.379058, 55.629788],
        [-132.908355, 55.632880],
        [-133.125844, 55.483588],
        [-132.846303, 55.352281],
        [-133.206614, 55.384467],
        [-133.212961, 55.279202],
        [-132.696116, 55.146877],
        [-132.640859, 55.256090],
        [-132.612904, 55.064276],
        [-132.464955, 55.050727],
        [-132.593414, 54.968248],
        [-132.380198, 55.023383],
        [-132.277740, 54.714830],
        [-132.004018, 54.693793],
        [-131.976715, 54.831529]
    ],
    [
        [-61.413726, 56.373358],
        [-61.462148, 56.408108],
        [-61.797353, 56.421129],
        [-61.596995, 56.333238],
        [-61.413726, 56.373358]
    ],
    [
        [-132.612904, 56.400621],
        [-132.924224, 56.451972],
        [-133.055247, 56.344794],
        [-132.819651, 56.236151],
        [-132.612904, 56.400621]
    ],
    [
        [-132.004018, 56.339179],
        [-132.151519, 56.351996],
        [-132.375356, 56.488471],
        [-132.338246, 56.257799],
        [-132.072336, 56.119452],
        [-131.928334, 56.194566],
        [-132.004018, 56.339179]
    ],
    [
        [-61.228831, 56.455268],
        [-61.462310, 56.550035],
        [-61.639638, 56.496894],
        [-61.228831, 56.455268]
    ],
    [
        [-154.055816, 56.530341],
        [-154.055816, 56.530341]
    ],
    [
        [-157.060618, 56.582221],
        [-157.259267, 56.583401],
        [-157.331248, 56.524156],
        [-156.978261, 56.536526],
        [-157.060618, 56.582221]
    ],
    [
        [-154.425160, 56.593044],
        [-154.461415, 56.605373],
        [-154.536326, 56.597602],
        [-154.700144, 56.530341],
        [-154.791249, 56.430854],
        [-154.425160, 56.593044]
    ],
    [
        [-154.082590, 56.552069],
        [-154.124094, 56.612616],
        [-154.350087, 56.544664],
        [-154.210072, 56.503648],
        [-154.082590, 56.552069]
    ],
    [
        [-61.215728, 56.585639],
        [-61.057485, 56.626532],
        [-61.057485, 56.633979],
        [-61.164906, 56.691840],
        [-61.215728, 56.585639]
    ],
    [
        [-132.959584, 56.787991],
        [-132.918609, 56.507025],
        [-132.533437, 56.580308],
        [-132.816314, 56.797349],
        [-132.959584, 56.787991]
    ],
    [
        [-133.884674, 56.490058],
        [-133.717152, 56.771186],
        [-133.993764, 56.639228],
        [-134.012685, 56.885159],
        [-134.405670, 56.852688],
        [-134.357574, 56.676581],
        [-134.086415, 56.647040],
        [-134.306142, 56.565131],
        [-134.034413, 56.485907],
        [-134.281972, 56.362779],
        [-134.190094, 56.178127],
        [-134.052317, 56.318752],
        [-133.949127, 56.092353],
        [-133.884674, 56.490058]
    ],
    [
        [-61.629750, 56.846340],
        [-61.647125, 56.736477],
        [-61.388417, 56.623236],
        [-61.384389, 56.772162],
        [-61.584706, 56.771674],
        [-61.338694, 56.935045],
        [-61.629750, 56.846340]
    ],
    [
        [-133.912668, 57.082750],
        [-134.018178, 57.017564],
        [-133.679270, 56.853705],
        [-133.621246, 56.442206],
        [-133.079091, 56.530341],
        [-133.346425, 56.837592],
        [-132.933949, 56.641588],
        [-133.052358, 56.982856],
        [-133.912668, 57.082750]
    ],
    [
        [-152.907867, 57.164740],
        [-153.244374, 57.211005],
        [-153.411610, 57.079047],
        [-153.272165, 56.998521],
        [-152.907867, 57.164740]
    ],
    [
        [-135.601552, 57.171576],
        [-135.843739, 57.324693],
        [-135.710805, 57.168443],
        [-135.841135, 56.989691],
        [-135.628245, 57.010199],
        [-135.601552, 57.171576]
    ],
    [
        [-61.612945, 57.415473],
        [-61.825266, 57.435289],
        [-61.679351, 57.537543],
        [-61.900380, 57.448961],
        [-61.848948, 57.415107],
        [-61.612945, 57.415473]
    ],
    [
        [-134.621490, 56.743842],
        [-134.994781, 57.397773],
        [-135.396067, 57.442694],
        [-135.279408, 57.511054],
        [-135.381174, 57.553616],
        [-135.608998, 57.387600],
        [-135.475331, 57.354315],
        [-135.674957, 57.358629],
        [-135.165354, 57.041734],
        [-135.367543, 56.828925],
        [-135.121734, 56.832017],
        [-135.187896, 56.676744],
        [-134.998850, 56.761664],
        [-135.109771, 56.601752],
        [-134.847401, 56.688666],
        [-135.052846, 56.537828],
        [-134.667470, 56.170396],
        [-134.621490, 56.743842]
    ],
    [
        [-61.852610, 57.586127],
        [-61.967112, 57.589423],
        [-62.017079, 57.517890],
        [-61.793935, 57.507310],
        [-61.852610, 57.586127]
    ],
    [
        [35.827159, 46.623358],
        [35.161794, 46.128241],
        [34.982107, 46.077826],
        [35.342133, 46.335761],
        [35.188324, 46.512437],
        [35.108409, 46.297756],
        [34.812266, 46.176663],
        [34.874360, 45.926093],
        [35.480724, 45.297797],
        [35.833263, 45.470893],
        [36.598806, 45.421210],
        [36.453380, 45.076483],
        [35.847992, 44.992418],
        [35.506196, 45.113511],
        [35.080821, 44.793769],
        [34.720958, 44.810981],
        [34.102550, 44.425116],
        [33.741222, 44.395901],
        [33.372325, 44.576483],
        [33.571544, 44.620551],
        [33.537446, 45.117377],
        [32.481619, 45.408881],
        [33.777029, 45.929633],
        [33.619884, 45.950751],
        [33.596528, 46.155748],
        [33.423839, 46.053290],
        [33.235118, 46.223822],
        [32.503429, 46.076117],
        [31.785899, 46.292385],
        [32.061860, 46.393785],
        [31.686534, 46.429877],
        [31.508311, 46.587592],
        [32.317556, 46.464342],
        [32.645518, 46.649604],
        [32.022797, 46.629136],
        [31.976899, 47.009345],
        [31.865245, 47.026353],
        [31.896821, 47.092719],
        [31.830577, 47.186754],
        [31.757660, 47.216213],
        [31.741710, 47.259101],
        [31.726817, 47.220526],
        [31.874278, 47.093817],
        [31.837413, 47.008450],
        [31.968272, 46.936998],
        [31.892100, 46.643622],
        [31.493012, 46.628730],
        [31.618175, 46.813463],
        [31.440684, 46.800482],
        [31.416189, 46.629136],
        [30.790701, 46.552924],
        [30.494151, 46.080471],
        [29.860118, 45.668931],
        [29.733735, 45.614325],
        [29.693858, 45.781317],
        [29.633556, 45.821357],
        [29.605724, 45.478176],
        [29.756196, 45.321234],
        [29.611176, 44.849311],
        [29.000743, 44.688910],
        [29.110606, 44.970038],
        [28.869395, 44.943345],
        [28.946137, 44.765204],
        [28.897716, 44.716783],
        [28.967459, 44.700995],
        [28.987559, 44.675279],
        [28.757823, 44.626776],
        [28.758474, 44.465277],
        [28.635102, 44.316392],
        [28.578461, 43.480780],
        [27.903982, 43.202338],
        [27.892263, 42.710517],
        [27.452891, 42.480129],
        [27.780447, 42.338935],
        [28.177745, 41.558173],
        [29.109223, 41.235297],
        [28.986501, 41.002631],
        [27.524181, 40.989203],
        [27.287934, 40.703559],
        [26.167003, 40.049872],
        [26.219086, 40.331448],
        [26.790375, 40.660590],
        [26.091319, 40.605414],
        [26.053966, 40.830959],
        [25.138438, 41.010077],
        [24.802013, 40.853461],
        [24.415538, 40.945543],
        [24.211192, 40.773179]
    ],
    [
        [-61.900380, 57.764309],
        [-61.745188, 57.713039],
        [-61.654124, 57.789984],
        [-61.800404, 57.844916],
        [-61.900380, 57.764309]
    ],
    [
        [-61.931386, 57.795356],
        [-61.931386, 57.915107],
        [-62.105784, 57.838568],
        [-62.092152, 57.815863],
        [-61.931386, 57.795356]
    ],
    [
        [-153.301747, 57.833197],
        [-153.212351, 57.812690],
        [-153.326650, 57.926581],
        [-153.541941, 57.935614],
        [-153.301747, 57.833197]
    ],
    [
        [-152.160878, 57.627143],
        [-152.551137, 57.703315],
        [-152.329091, 57.825751],
        [-152.486318, 57.910712],
        [-152.885569, 57.728705],
        [-152.808298, 57.908271],
        [-153.284250, 58.010443],
        [-153.048451, 57.833197],
        [-153.240305, 57.902086],
        [-153.178822, 57.709662],
        [-153.449167, 57.846869],
        [-153.321278, 57.730902],
        [-153.499135, 57.760891],
        [-153.507192, 57.627143],
        [-153.665476, 57.894680],
        [-153.924631, 57.810492],
        [-153.584584, 57.617092],
        [-153.884592, 57.648261],
        [-153.678456, 57.544582],
        [-153.850819, 57.577297],
        [-153.630686, 57.270901],
        [-154.220326, 57.675523],
        [-154.810007, 57.346584],
        [-154.304921, 56.855780],
        [-154.103708, 57.113837],
        [-153.959665, 57.120063],
        [-154.099558, 56.964830],
        [-153.805735, 57.154202],
        [-153.739939, 57.133694],
        [-154.149526, 56.750922],
        [-153.987253, 56.743842],
        [-153.559763, 56.986518],
        [-153.761057, 57.051744],
        [-153.498158, 57.074286],
        [-153.541860, 57.175849],
        [-152.959096, 57.257148],
        [-153.172922, 57.305080],
        [-153.174753, 57.351386],
        [-153.041697, 57.428534],
        [-152.973378, 57.517890],
        [-152.362986, 57.428534],
        [-152.160878, 57.627143]
    ],
    [
        [-136.389801, 57.963568],
        [-136.338368, 58.014635],
        [-136.542836, 58.065904],
        [-136.451283, 57.846869],
        [-136.389801, 57.963568]
    ],
    [
        [-153.418365, 58.065985],
        [-153.262644, 58.085354],
        [-153.277781, 58.146796],
        [-153.418365, 58.065985]
    ],
    [
        [-151.866078, 58.257758],
        [-151.897084, 58.192857],
        [-151.846181, 58.175198],
        [-151.793446, 58.244696],
        [-151.866078, 58.257758]
    ],
    [
        [-135.847971, 57.394355],
        [-135.546295, 57.466051],
        [-135.813222, 57.764309],
        [-134.813873, 57.497463],
        [-134.913889, 57.755845],
        [-135.363881, 57.726223],
        [-135.889556, 57.997707],
        [-135.013783, 57.785875],
        [-135.203684, 57.943061],
        [-134.915679, 57.846869],
        [-134.924794, 58.027493],
        [-135.389272, 58.141059],
        [-135.656158, 57.949286],
        [-135.783070, 58.042060],
        [-135.484853, 58.162095],
        [-136.136586, 58.223049],
        [-136.101186, 58.058539],
        [-136.355702, 58.219875],
        [-136.272532, 58.106879],
        [-136.409657, 58.079901],
        [-136.311920, 57.995510],
        [-136.416493, 57.825751],
        [-135.950347, 57.620917],
        [-136.073883, 57.607327],
        [-135.847971, 57.394355]
    ],
    [
        [-134.597279, 58.237250],
        [-134.535390, 58.224107],
        [-134.258412, 58.196275],
        [-134.563344, 58.344550],
        [-134.679840, 58.309272],
        [-134.597279, 58.237250]
    ],
    [
        [-134.353993, 57.092719],
        [-134.084788, 57.256415],
        [-134.175852, 57.387600],
        [-133.864980, 57.355129],
        [-134.072825, 57.511054],
        [-133.839996, 57.462633],
        [-134.289174, 57.836656],
        [-134.306752, 58.098090],
        [-133.962961, 57.692328],
        [-133.789296, 57.588853],
        [-134.176991, 58.163520],
        [-134.693186, 58.168402],
        [-134.961008, 58.404853],
        [-134.907623, 58.201239],
        [-134.731313, 58.178900],
        [-134.653554, 57.598212],
        [-134.353993, 57.544582],
        [-134.569163, 57.492011],
        [-134.306142, 57.394355],
        [-134.556304, 57.397773],
        [-134.457021, 57.311835],
        [-134.633290, 57.224189],
        [-134.614613, 57.010199],
        [-134.353993, 57.092719]
    ],
    [
        [-151.966013, 58.332831],
        [-152.143544, 58.233832],
        [-152.116811, 58.401109],
        [-152.419667, 58.322943],
        [-152.650624, 58.483629],
        [-152.883372, 58.408596],
        [-152.767323, 58.257758],
        [-153.109934, 58.271389],
        [-152.905100, 58.168402],
        [-153.229604, 58.168891],
        [-152.804921, 57.991523],
        [-152.576650, 58.206692],
        [-152.548207, 58.086412],
        [-152.273874, 58.134833],
        [-152.276560, 58.264228],
        [-152.116811, 58.147895],
        [-151.966013, 58.332831]
    ],
    [
        [-152.644399, 58.518459],
        [-152.502024, 58.473456],
        [-152.348988, 58.628323],
        [-152.453684, 58.628160],
        [-152.644399, 58.518459]
    ],
    [
        [-3.323476, 56.365912],
        [-3.294016, 56.352769],
        [-3.230621, 56.356024],
        [-2.884999, 56.457994],
        [-2.576812, 56.277777],
        [-3.342681, 56.027167],
        [-3.078236, 55.946845],
        [-2.635121, 56.058051],
        [-2.138010, 55.914618],
        [-1.630849, 55.585110],
        [-1.203725, 54.625718],
        [-0.562978, 54.477362],
        [-0.075510, 54.112128],
        [-0.219472, 54.022773],
        [0.133474, 53.642646],
        [0.149262, 53.609605],
        [0.131196, 53.573432],
        [-0.260365, 53.735419],
        [-0.637034, 53.732001],
        [-0.726471, 53.700629],
        [-0.279368, 53.707099],
        [0.219493, 53.419501],
        [0.356619, 53.145738],
        [0.010265, 52.886461],
        [0.384532, 52.768378],
        [0.520274, 52.955268],
        [0.966075, 52.974433],
        [1.697032, 52.731024],
        [1.771169, 52.485907],
        [1.582286, 52.081488],
        [1.332286, 51.940090],
        [1.264415, 51.994371],
        [1.157888, 52.028510],
        [1.274425, 51.960883],
        [1.069102, 51.953437],
        [1.276378, 51.844794],
        [0.979828, 51.843573],
        [0.698578, 51.720038],
        [0.930024, 51.743598],
        [0.924490, 51.588324],
        [0.456065, 51.505561],
        [0.384532, 51.453111],
        [1.423839, 51.392076],
        [1.384451, 51.151679],
        [0.271007, 50.747382],
        [-0.789947, 50.730048],
        [-1.466420, 50.918158],
        [-1.317291, 50.800238],
        [-2.038971, 50.739936],
        [-1.965199, 50.602200],
        [-2.398346, 50.645575],
        [-2.453359, 50.527655],
        [-2.864817, 50.733791],
        [-3.464426, 50.678534],
        [-3.660634, 50.221015],
        [-4.200551, 50.459418],
        [-4.193756, 50.322252],
        [-5.052968, 50.195787],
        [-5.191151, 49.959133],
        [-5.474843, 50.130439],
        [-5.705149, 50.052314],
        [-5.015614, 50.538031],
        [-4.844838, 50.514065],
        [-4.920522, 50.589179],
        [-4.577260, 50.774726],
        [-4.526438, 51.014960],
        [-4.207997, 51.076361],
        [-4.228505, 51.192450],
        [-3.021840, 51.192450],
        [-2.974680, 51.384223],
        [-3.289418, 51.384223],
        [-3.854888, 51.623847],
        [-4.289906, 51.555569],
        [-4.070546, 51.675971],
        [-4.365102, 51.789049],
        [-4.941029, 51.596503],
        [-5.119740, 51.678412],
        [-4.844838, 51.713813],
        [-4.824330, 51.795722],
        [-4.988189, 51.706855],
        [-5.249501, 51.733710],
        [-5.113393, 51.828803],
        [-5.288930, 51.916938],
        [-4.315826, 52.216295],
        [-3.947336, 52.549262],
        [-4.125478, 52.603909],
        [-3.988271, 52.734280],
        [-4.149037, 52.812079],
        [-4.077626, 52.926663],
        [-4.762847, 52.789496],
        [-4.177968, 53.217597],
        [-3.330312, 53.351793],
        [-3.087758, 53.234687],
        [-3.186350, 53.392768],
        [-3.058258, 53.434760],
        [-2.881500, 53.288398],
        [-2.699778, 53.351793],
        [-2.924957, 53.350002],
        [-3.101918, 53.558051],
        [-2.899037, 53.735419],
        [-3.056630, 53.906155],
        [-2.857981, 53.967597],
        [-2.795969, 54.248725],
        [-3.145375, 54.063788],
        [-3.207387, 54.263007],
        [-3.306793, 54.191881],
        [-3.634185, 54.512885],
        [-3.387929, 54.883368],
        [-3.021840, 54.975531],
        [-3.570546, 54.995429],
        [-4.011708, 54.768215],
        [-4.402903, 54.907294],
        [-4.382395, 54.680080],
        [-4.859120, 54.866278],
        [-4.859120, 54.632961],
        [-5.157135, 54.879096],
        [-4.617787, 55.495592],
        [-4.920522, 55.708564],
        [-4.886464, 55.919664],
        [-4.481679, 55.928290],
        [-4.851552, 55.988023],
        [-4.755523, 56.206529],
        [-4.920522, 56.167914],
        [-4.983144, 55.871039],
        [-5.123606, 56.009914],
        [-5.086537, 55.901272],
        [-5.296702, 55.852688],
        [-5.338287, 55.996568],
        [-5.444407, 56.027574],
        [-5.317779, 55.783026],
        [-5.525054, 55.358629],
        [-5.782867, 55.313544],
        [-5.680898, 55.674465],
        [-5.454986, 55.845771],
        [-5.660390, 55.797349],
        [-5.571034, 56.037543],
        [-5.531606, 56.086330],
        [-5.572581, 56.328070],
        [-5.457021, 56.440863],
        [-5.208730, 56.446845],
        [-5.118520, 56.507758],
        [-5.064565, 56.565131],
        [-5.242055, 56.565131],
        [-5.413930, 56.544664],
        [-5.317779, 56.661322],
        [-5.238271, 56.716620],
        [-5.119740, 56.818427],
        [-5.674062, 56.496894],
        [-6.008168, 56.642279],
        [-6.232533, 56.706529],
        [-5.756663, 56.784857],
        [-5.851186, 56.828925],
        [-5.733876, 56.844794],
        [-5.660390, 56.872992],
        [-5.921132, 56.894110],
        [-5.831695, 56.997138],
        [-5.755238, 57.026557],
        [-5.658559, 56.979478],
        [-5.523264, 56.997138],
        [-5.715647, 57.120063],
        [-5.558258, 57.100409],
        [-5.400380, 57.106391],
        [-5.680898, 57.157904],
        [-5.440663, 57.319281],
        [-5.729319, 57.298163],
        [-5.501291, 57.370998],
        [-5.448110, 57.421698],
        [-5.807769, 57.354926],
        [-5.839182, 57.579291],
        [-5.639963, 57.511054],
        [-5.512685, 57.541490],
        [-5.805898, 57.642646],
        [-5.674062, 57.709662],
        [-5.807362, 57.843940],
        [-5.221588, 57.846869],
        [-5.366200, 57.943061],
        [-5.070790, 57.833197],
        [-5.447011, 58.084377],
        [-5.242055, 58.147895],
        [-5.392079, 58.261379],
        [-4.933583, 58.223049],
        [-5.173207, 58.353949],
        [-5.016184, 58.388129],
        [-5.105621, 58.505561],
        [-4.988189, 58.628323],
        [-4.660024, 58.555854],
        [-4.760976, 58.447984],
        [-4.426503, 58.546373],
        [-4.495351, 58.449530],
        [-3.019114, 58.640326],
        [-3.129791, 58.369289],
        [-4.084381, 57.964179],
        [-4.009348, 57.867906],
        [-4.039906, 57.818183],
        [-3.779449, 57.855658],
        [-3.988271, 57.695990],
        [-4.294789, 57.680162],
        [-4.428456, 57.577541],
        [-1.997670, 57.702826],
        [-1.759348, 57.473578],
        [-2.514556, 56.591498],
        [-3.323476, 56.365912]
    ],
    [
        [-160.947643, 58.737648],
        [-161.171903, 58.690754],
        [-161.085979, 58.553326],
        [-160.687786, 58.818724],
        [-160.947643, 58.737648]
    ],
    [
        [-152.249664, 58.922512],
        [-152.363271, 58.915717],
        [-152.334218, 58.911933],
        [-152.249664, 58.922512]
    ],
    [
        [-69.101971, 59.131323],
        [-69.354156, 59.140570],
        [-69.363515, 58.963446],
        [-69.218902, 58.963446],
        [-69.101971, 59.131323]
    ],
    [
        [-150.704172, 59.395453],
        [-150.779856, 59.334052],
        [-150.761830, 59.316799],
        [-150.608591, 59.381171],
        [-150.704172, 59.395453]
    ],
    [
        [-153.524526, 59.330268],
        [-153.405873, 59.338568],
        [-153.357411, 59.378119],
        [-153.476755, 59.405422],
        [-153.524526, 59.330268]
    ],
    [
        [-150.334828, 59.456977],
        [-150.410512, 59.446275],
        [-150.443471, 59.402289],
        [-150.293894, 59.456977],
        [-150.334828, 59.456977]
    ],
    [
        [-64.078969, 59.799547],
        [-64.101918, 59.862982],
        [-64.203114, 59.744940],
        [-63.962880, 59.751776],
        [-64.078969, 59.799547]
    ],
    [
        [-144.341786, 59.984524],
        [-144.552358, 59.873236],
        [-144.605295, 59.813178],
        [-144.208608, 60.011786],
        [-144.341786, 59.984524]
    ],
    [
        [-148.005035, 60.046576],
        [-148.223256, 59.991360],
        [-148.244985, 59.943549],
        [-148.081166, 59.971666],
        [-148.005035, 60.046576]
    ],
    [
        [-147.826650, 60.052802],
        [-147.876576, 60.076361],
        [-148.046376, 59.957099],
        [-147.895172, 59.990424],
        [-147.826650, 60.052802]
    ],
    [
        [-147.963775, 60.073920],
        [-147.881256, 60.107367],
        [-147.966461, 60.156562],
        [-148.141306, 60.011786],
        [-147.963775, 60.073920]
    ],
    [
        [-148.159332, 60.043158],
        [-148.099233, 60.083482],
        [-148.049998, 60.195705],
        [-148.313832, 60.032294],
        [-148.159332, 60.043158]
    ],
    [
        [-147.107249, 60.286200],
        [-147.011057, 60.347602],
        [-147.189605, 60.362209],
        [-147.915395, 59.792670],
        [-147.492340, 59.861802],
        [-146.922271, 60.313463],
        [-147.107249, 60.286200]
    ],
    [
        [-147.977447, 60.375556],
        [-148.075632, 60.369371],
        [-148.135121, 60.299791],
        [-148.042226, 60.286566],
        [-147.977447, 60.375556]
    ],
    [
        [-145.174428, 60.382392],
        [-145.284291, 60.341376],
        [-145.284291, 60.333930],
        [-145.123280, 60.311754],
        [-145.174428, 60.382392]
    ],
    [
        [-146.188629, 60.402167],
        [-146.588124, 60.484036],
        [-146.722646, 60.386217],
        [-146.490305, 60.361274],
        [-146.600168, 60.245185],
        [-146.078765, 60.402167],
        [-146.188629, 60.402167]
    ],
    [
        [-147.771392, 60.409654],
        [-147.908559, 60.292955],
        [-147.798695, 60.170111],
        [-147.614369, 60.436957],
        [-147.771392, 60.409654]
    ],
    [
        [-151.869822, 60.485419],
        [-151.953196, 60.508490],
        [-152.089670, 60.359117],
        [-151.966013, 60.375556],
        [-151.869822, 60.485419]
    ],
    [
        [-145.757232, 60.628730],
        [-146.286448, 60.517320],
        [-146.332631, 60.464911],
        [-146.063100, 60.488267],
        [-145.757232, 60.628730]
    ],
    [
        [28.634613, 60.601386],
        [28.575531, 60.580390],
        [28.561046, 60.629462],
        [28.604503, 60.645006],
        [28.634613, 60.601386]
    ],
    [
        [-147.497670, 60.656684],
        [-147.339711, 60.645575],
        [-147.312734, 60.684027],
        [-147.428782, 60.711371],
        [-147.497670, 60.656684]
    ],
    [
        [-147.929067, 60.718166],
        [-147.847076, 60.693996],
        [-147.909820, 60.744818],
        [-147.929067, 60.718166]
    ],
    [
        [-148.168650, 60.662909],
        [-148.111155, 60.738105],
        [-148.217030, 60.759101],
        [-148.222239, 60.706122],
        [-148.168650, 60.662909]
    ],
    [
        [-148.087310, 60.800116],
        [-148.023793, 60.791205],
        [-147.912343, 60.825426],
        [-147.967641, 60.905585],
        [-148.107777, 60.923000],
        [-148.087310, 60.800116]
    ],
    [
        [-162.340810, 63.602484],
        [-162.428090, 63.642157],
        [-162.717600, 63.575181],
        [-162.359364, 63.546210],
        [-162.340810, 63.602484]
    ],
    [
        [-172.243096, 64.815942],
        [-172.461344, 64.827595],
        [-172.633193, 64.684439],
        [-172.043356, 64.751183],
        [-172.243096, 64.815942]
    ],
    [
        [-14.563629, 66.384508],
        [-15.179351, 66.111314],
        [-14.616933, 65.997748],
        [-14.844106, 65.735175],
        [-14.329498, 65.782375],
        [-14.274322, 65.672512],
        [-14.357818, 65.656073],
        [-14.530181, 65.545478],
        [-14.562367, 65.501166],
        [-14.247629, 65.665025],
        [-13.609609, 65.514228],
        [-13.835520, 65.364000],
        [-13.729848, 65.327094],
        [-14.006744, 65.282050],
        [-13.567983, 65.260972],
        [-14.034088, 65.200141],
        [-13.520172, 65.172187],
        [-13.585317, 65.007717],
        [-13.698313, 64.925198],
        [-14.054596, 64.932603],
        [-13.839223, 64.798570],
        [-14.270619, 64.699286],
        [-14.420562, 64.789618],
        [-14.513905, 64.802314],
        [-14.274322, 64.651435],
        [-14.493479, 64.658271],
        [-14.584381, 64.590318],
        [-14.346181, 64.605618],
        [-14.929433, 64.264838],
        [-15.226471, 64.267890],
        [-15.206614, 64.301418],
        [-15.323150, 64.303900],
        [-15.366444, 64.369330],
        [-15.408437, 64.387641],
        [-15.473500, 64.397650],
        [-15.397817, 64.274115],
        [-16.796213, 63.801703],
        [-16.966908, 63.787502],
        [-16.940297, 63.897773],
        [-16.968984, 63.920315],
        [-17.006215, 63.797838],
        [-17.714752, 63.781236],
        [-17.967356, 63.676500],
        [-17.796742, 63.671373],
        [-17.964955, 63.522528],
        [-18.732045, 63.396715],
        [-20.185699, 63.544420],
        [-20.550689, 63.712348],
        [-20.311147, 63.732856],
        [-20.411122, 63.836249],
        [-20.577504, 63.714179],
        [-20.770416, 63.774400],
        [-20.605946, 63.767564],
        [-20.685618, 63.863430],
        [-21.188791, 63.891099],
        [-21.044789, 63.945746],
        [-22.691233, 63.812201],
        [-22.702138, 64.085924],
        [-22.040679, 64.051093],
        [-21.915028, 64.123928],
        [-21.799672, 64.137274],
        [-21.702748, 64.191555],
        [-21.928619, 64.233791],
        [-21.754506, 64.345201],
        [-21.442006, 64.364081],
        [-21.631174, 64.402655],
        [-21.859731, 64.390774],
        [-22.045318, 64.405097],
        [-21.975087, 64.503730],
        [-22.164784, 64.459662],
        [-22.442535, 64.665717],
        [-22.365102, 64.642646],
        [-22.188710, 64.740220],
        [-22.402089, 64.676337],
        [-22.408437, 64.822740],
        [-23.833567, 64.725898],
        [-24.060048, 64.891059],
        [-21.826243, 65.035061],
        [-21.734120, 65.193793],
        [-22.557688, 65.168931],
        [-21.695302, 65.453355],
        [-22.253814, 65.433661],
        [-22.387196, 65.491685],
        [-22.164784, 65.541490],
        [-22.106801, 65.596747],
        [-22.478627, 65.508002],
        [-22.545888, 65.634019],
        [-23.897532, 65.404608],
        [-24.539906, 65.508002],
        [-24.303375, 65.638373],
        [-23.892812, 65.522162],
        [-23.806793, 65.535346],
        [-24.086781, 65.651353],
        [-23.806793, 65.610419],
        [-24.092844, 65.804755],
        [-23.561757, 65.613674],
        [-23.285471, 65.679348],
        [-23.539174, 65.722724],
        [-23.244537, 65.740383],
        [-23.189849, 65.782375],
        [-23.209788, 65.843207],
        [-23.813100, 66.011379],
        [-23.374867, 65.987779],
        [-23.669667, 66.117499],
        [-23.600819, 66.144843],
        [-23.461415, 66.204169],
        [-22.819325, 65.912095],
        [-22.682729, 66.055854],
        [-22.648183, 65.833686],
        [-22.538726, 65.974189],
        [-22.469879, 65.836982],
        [-22.360707, 65.912095],
        [-22.484202, 66.029446],
        [-22.381174, 66.097642],
        [-22.977610, 66.234198],
        [-23.189687, 66.355292],
        [-22.950307, 66.466986],
        [-22.431020, 66.464748],
        [-22.216664, 66.268378],
        [-21.749867, 66.185777],
        [-21.667958, 66.021918],
        [-21.330637, 66.009019],
        [-21.606516, 65.960517],
        [-21.301747, 65.935981],
        [-21.476796, 65.768704],
        [-21.777821, 65.768704],
        [-21.320912, 65.601874],
        [-21.476796, 65.446519],
        [-21.212148, 65.438178],
        [-21.089915, 65.166164],
        [-21.098866, 65.445461],
        [-20.915110, 65.343492],
        [-20.918080, 65.601386],
        [-20.675364, 65.693915],
        [-20.475657, 65.494940],
        [-20.270131, 65.665025],
        [-20.407704, 66.090766],
        [-20.092030, 66.131171],
        [-19.456166, 65.728949],
        [-19.437856, 66.066636],
        [-18.827016, 66.203437],
        [-18.063588, 65.645209],
        [-18.296986, 66.179633],
        [-17.912750, 66.152289],
        [-17.549672, 65.912095],
        [-17.611155, 65.994045],
        [-17.413197, 65.960517],
        [-17.145619, 66.221177],
        [-16.426259, 66.144843],
        [-16.543324, 66.506985],
        [-16.022939, 66.536607],
        [-15.380360, 66.149970],
        [-14.925445, 66.385321],
        [-14.563629, 66.384508]
    ],
    [
        [70.130626, 66.556342],
        [70.049815, 66.708930],
        [69.540375, 66.763658],
        [69.472992, 66.797675],
        [69.130707, 66.796576],
        [69.870616, 66.477851],
        [70.130626, 66.556342]
    ],
    [
        [-107.875356, 66.943061],
        [-107.901967, 66.892320],
        [-107.950510, 66.857978],
        [-107.830678, 66.902655],
        [-107.793446, 66.994574],
        [-107.875356, 66.943061]
    ],
    [
        [-108.046702, 66.981513],
        [-108.114980, 67.036811],
        [-107.936838, 66.953559],
        [-107.993642, 66.956000],
        [-108.046702, 66.981513]
    ],
    [
        [-107.416656, 67.118720],
        [-107.579945, 67.200629],
        [-107.624176, 67.204535],
        [-107.543568, 67.088446],
        [-107.320465, 67.104438],
        [-107.416656, 67.118720]
    ],
    [
        [-108.005727, 67.371975],
        [-107.907338, 67.316840],
        [-107.881581, 67.467475],
        [-108.149078, 67.412909],
        [-108.005727, 67.371975]
    ],
    [
        [-108.286936, 67.535793],
        [-108.458241, 67.573676],
        [-108.499176, 67.535793],
        [-108.382476, 67.467475],
        [-108.286936, 67.535793]
    ],
    [
        [-108.128651, 67.645697],
        [-108.105784, 67.468207],
        [-107.922515, 67.549506],
        [-108.003814, 67.660549],
        [-108.128651, 67.645697]
    ],
    [
        [-97.431711, 67.707709],
        [-97.562001, 67.694037],
        [-97.551178, 67.645331],
        [-97.335276, 67.679755],
        [-97.431711, 67.707709]
    ],
    [
        [-109.211741, 67.789700],
        [-109.136057, 67.768134],
        [-109.039784, 67.789700],
        [-109.070709, 67.810981],
        [-109.211741, 67.789700]
    ],
    [
        [-114.137278, 67.887641],
        [-114.296457, 67.899563],
        [-114.237782, 67.879096],
        [-114.137278, 67.887641]
    ],
    [
        [-113.446034, 67.926825],
        [-113.248036, 67.919989],
        [-113.284332, 67.938544],
        [-113.446034, 67.926825]
    ],
    [
        [-111.089345, 67.865424],
        [-110.878651, 67.892524],
        [-110.808176, 67.961005],
        [-110.844472, 67.955552],
        [-111.089345, 67.865424]
    ],
    [
        [-108.053538, 67.954779],
        [-108.177073, 67.961005],
        [-108.258941, 67.892727],
        [-108.092193, 67.884711],
        [-108.053538, 67.954779]
    ],
    [
        [-108.910715, 67.919989],
        [-108.935129, 67.970649],
        [-109.198110, 67.995103],
        [-108.941070, 67.875881],
        [-108.910715, 67.919989]
    ],
    [
        [-98.966664, 68.070868],
        [-98.991811, 68.076606],
        [-99.083363, 68.057196],
        [-98.954010, 67.985093],
        [-98.966664, 68.070868]
    ],
    [
        [-109.355702, 68.057196],
        [-109.483876, 68.099311],
        [-109.547515, 68.057196],
        [-109.317535, 67.985175],
        [-109.355702, 68.057196]
    ],
    [
        [-110.061431, 68.098131],
        [-110.164784, 68.082017],
        [-110.061431, 68.098131]
    ],
    [
        [-109.856028, 68.159613],
        [-109.781972, 68.142646],
        [-109.567983, 68.249579],
        [-109.643178, 68.242621],
        [-109.856028, 68.159613]
    ],
    [
        [14.872406, 68.222724],
        [14.953136, 68.277411],
        [14.940115, 68.302151],
        [14.795584, 68.246161],
        [14.872406, 68.222724]
    ],
    [
        [-111.657867, 68.304185],
        [-111.768707, 68.229926],
        [-111.500234, 68.304185],
        [-111.528676, 68.314032],
        [-111.657867, 68.304185]
    ],
    [
        [14.199229, 68.315172],
        [14.117198, 68.337307],
        [14.040375, 68.312567],
        [14.268240, 68.282620],
        [14.199229, 68.315172]
    ],
    [
        [14.027843, 68.262641],
        [13.636729, 68.294338],
        [13.456716, 68.070990],
        [14.158865, 68.255276],
        [14.027843, 68.262641]
    ],
    [
        [-100.090688, 68.372504],
        [-100.118642, 68.379299],
        [-100.234039, 68.324042],
        [-100.120961, 68.278632],
        [-100.090688, 68.372504]
    ],
    [
        [51.299571, 68.495429],
        [51.171723, 68.501451],
        [51.299571, 68.495429]
    ],
    [
        [-110.836049, 68.550686],
        [-111.034047, 68.509670],
        [-111.095204, 68.480048],
        [-110.698883, 68.488593],
        [-110.836049, 68.550686]
    ],
    [
        [-110.644276, 68.550686],
        [-110.644276, 68.550686]
    ],
    [
        [14.763031, 68.494859],
        [14.891938, 68.494859],
        [15.000011, 68.554755],
        [14.604177, 68.558661],
        [14.763031, 68.494859]
    ],
    [
        [-104.490142, 68.515855],
        [-104.681304, 68.578559],
        [-105.086008, 68.550686],
        [-104.655181, 68.398017],
        [-104.490142, 68.515855]
    ],
    [
        [-113.967437, 68.612128],
        [-113.795766, 68.581732],
        [-113.762034, 68.597805],
        [-113.835276, 68.614447],
        [-113.967437, 68.612128]
    ],
    [
        [-114.146230, 68.674140],
        [-114.192738, 68.680976],
        [-114.047760, 68.627183],
        [-114.071767, 68.644599],
        [-114.146230, 68.674140]
    ],
    [
        [-101.693959, 68.770331],
        [-102.024648, 68.823798],
        [-102.351918, 68.687201],
        [-101.844797, 68.571112],
        [-101.693959, 68.770331]
    ],
    [
        [-114.473948, 68.893256],
        [-114.382192, 68.869208],
        [-114.330474, 68.886176],
        [-114.438385, 68.900377],
        [-114.473948, 68.893256]
    ],
    [
        [55.369477, 68.947903],
        [55.239757, 68.927395],
        [55.225434, 68.913764],
        [55.506602, 68.913764],
        [55.369477, 68.947903]
    ],
    [
        [-180.000000, 65.066229],
        [-179.663090, 65.141263],
        [-179.260510, 65.532179],
        [-179.766672, 65.819810],
        [-179.692983, 66.183905],
        [-179.251955, 66.145170],
        [-179.424021, 66.344062],
        [-179.171457, 66.289455],
        [-179.164296, 66.414374],
        [-179.117665, 66.242662],
        [-178.785135, 66.167243],
        [-178.477124, 66.382762],
        [-178.495675, 66.140127],
        [-178.684256, 66.012572],
        [-178.978383, 66.049262],
        [-178.424235, 65.712879],
        [-178.461101, 65.472741],
        [-177.415925, 65.440748],
        [-176.976552, 65.608059],
        [-176.044057, 65.452094],
        [-175.735041, 65.146845],
        [-175.864735, 64.999213],
        [-175.411452, 64.771264],
        [-174.653223, 64.897901],
        [-174.652292, 64.725328],
        [-173.635434, 64.332231],
        [-173.385178, 64.395041],
        [-173.414540, 64.616645],
        [-173.263661, 64.445990],
        [-173.368253, 64.285478],
        [-173.106265, 64.240980],
        [-172.822171, 64.320362],
        [-172.788324, 64.437861],
        [-173.013051, 64.461575],
        [-172.883346, 64.494711],
        [-172.967193, 64.561137],
        [-172.844633, 64.648870],
        [-173.042872, 64.659685],
        [-172.805735, 64.803371],
        [-172.080093, 65.075905],
        [-172.201531, 65.216874],
        [-172.188539, 65.242450],
        [-172.093403, 65.483571],
        [-172.388609, 65.432236],
        [-172.389722, 65.581817],
        [-172.674418, 65.623518],
        [-172.859609, 65.699856],
        [-171.743619, 65.499661],
        [-171.038654, 65.466987],
        [-170.981812, 65.592054],
        [-171.463265, 65.832590],
        [-170.588166, 65.604566],
        [-170.488773, 65.670758],
        [-170.606313, 65.861314],
        [-169.641384, 66.068327],
        [-170.338368, 66.185777],
        [-170.106204, 66.193047],
        [-170.274257, 66.290404],
        [-170.510936, 66.225434],
        [-170.625681, 66.234809],
        [-170.385193, 66.316532],
        [-171.718517, 66.950777],
        [-172.362487, 66.933213],
        [-173.073963, 66.993073],
        [-173.226479, 66.910935],
        [-173.086576, 66.846747],
        [-173.302542, 66.822105],
        [-173.294955, 66.981328],
        [-173.143370, 66.999645],
        [-173.272159, 67.051951],
        [-173.646469, 67.115615],
        [-174.612000, 67.061414],
        [-174.026214, 66.961111],
        [-173.930551, 66.667627],
        [-174.263950, 66.565876],
        [-173.691130, 66.439099],
        [-173.999313, 66.219250],
        [-174.015907, 66.472171],
        [-174.463500, 66.279748],
        [-174.435663, 66.531545],
        [-174.971335, 66.665413],
        [-174.687820, 66.732417],
        [-174.907608, 67.037385],
        [-174.756436, 67.303237],
        [-174.806109, 67.364671],
        [-174.968948, 67.424748],
        [-175.366883, 67.357789],
        [-175.126770, 67.499890],
        [-175.265529, 67.658555],
        [-175.824029, 67.812960],
        [-176.011966, 67.727348],
        [-175.681789, 67.589579],
        [-176.205792, 67.645152],
        [-176.340873, 67.695902],
        [-175.920725, 67.851020],
        [-176.208795, 67.901770],
        [-176.539371, 67.895097],
        [-177.338083, 68.244574],
        [-177.634714, 68.195299],
        [-177.765574, 68.262641],
        [-177.492258, 68.291734],
        [-177.704701, 68.344550],
        [-178.073679, 68.259263],
        [-178.021352, 68.415961],
        [-178.699928, 68.543189],
        [-178.724618, 68.675686],
        [-178.844813, 68.752361],
        [-180.000000, 68.982370]
    ],
    [
        [54.643321, 69.009345],
        [54.628917, 69.005845],
        [54.570811, 68.964057],
        [54.697927, 68.982001],
        [54.643321, 69.009345]
    ],
    [
        [-100.206776, 68.803900],
        [-100.124867, 68.906928],
        [-100.323476, 69.003119],
        [-100.631337, 68.995673],
        [-100.603342, 68.755561],
        [-100.206776, 68.803900]
    ],
    [
        [-100.042307, 69.085028],
        [-100.138539, 69.147121],
        [-100.255198, 69.050279],
        [-100.021840, 68.940375],
        [-100.042307, 69.085028]
    ],
    [
        [-101.529449, 69.188056],
        [-101.689076, 69.211168],
        [-101.701405, 69.098700],
        [-101.550608, 69.112982],
        [-101.529449, 69.188056]
    ],
    [
        [-135.566762, 69.386054],
        [-135.307607, 69.309149],
        [-135.272572, 69.348822],
        [-135.353383, 69.397040],
        [-135.566762, 69.386054]
    ],
    [
        [161.487071, 69.026679],
        [161.319102, 69.242662],
        [161.374522, 69.545885],
        [161.092459, 69.464789],
        [161.134776, 69.091864],
        [161.455577, 69.000963],
        [161.487071, 69.026679]
    ],
    [
        [-100.981435, 69.482245],
        [-101.173207, 69.571682],
        [-101.381459, 69.538153],
        [-101.186838, 69.482245],
        [-101.242502, 69.374335],
        [-100.981435, 69.482245]
    ],
    [
        [-96.554921, 69.479193],
        [-96.143137, 69.352525],
        [-96.101308, 69.467271],
        [-96.740224, 69.585354],
        [-96.554921, 69.479193]
    ],
    [
        [-133.929433, 69.577867],
        [-133.830434, 69.593492],
        [-133.812734, 69.605780],
        [-133.929433, 69.577867]
    ],
    [
        [-95.944488, 69.420844],
        [-95.721750, 69.555650],
        [-95.745920, 69.338935],
        [-95.533599, 69.331448],
        [-95.371205, 69.513577],
        [-95.801137, 69.633124],
        [-95.944488, 69.420844]
    ],
    [
        [161.631114, 69.561103],
        [161.475108, 69.638007],
        [161.360688, 69.414008],
        [161.615733, 69.450385],
        [161.631114, 69.561103]
    ],
    [
        [-139.113393, 69.654202],
        [-139.335601, 69.571682],
        [-138.870107, 69.592108],
        [-138.921010, 69.617011],
        [-139.113393, 69.654202]
    ],
    [
        [-135.574208, 69.577867],
        [-135.488881, 69.579250],
        [-135.402943, 69.654202],
        [-135.510976, 69.648383],
        [-135.574208, 69.577867]
    ],
    [
        [-163.185333, 69.610256],
        [-163.191151, 69.546536],
        [-163.176259, 69.482245],
        [-163.129099, 69.681545],
        [-163.185333, 69.610256]
    ],
    [
        [-102.125966, 69.715033],
        [-102.226186, 69.726060],
        [-102.235829, 69.684638],
        [-102.159332, 69.654242],
        [-102.125966, 69.715033]
    ],
    [
        [-141.423085, 69.721869],
        [-141.528635, 69.760321],
        [-141.809234, 69.821926],
        [-141.898427, 69.824897],
        [-141.423085, 69.721869]
    ],
    [
        [19.002126, 54.344916],
        [19.734060, 54.525702],
        [19.976736, 54.964586],
        [20.634044, 55.048774],
        [21.041515, 55.416083],
        [21.085216, 55.722846],
        [21.106212, 55.421210],
        [20.530935, 54.964667],
        [21.230154, 54.938910],
        [21.291189, 55.297065],
        [21.060557, 55.789252],
        [20.992198, 56.548896],
        [21.065196, 56.846340],
        [21.382498, 57.008938],
        [21.421397, 57.288723],
        [21.729666, 57.573798],
        [22.600271, 57.758043],
        [22.656098, 57.585761],
        [23.130219, 57.370795],
        [23.260916, 57.098944],
        [23.632009, 56.970933],
        [24.379161, 57.230211],
        [24.285981, 57.832587],
        [24.551036, 58.333726],
        [23.740977, 58.343085],
        [23.497732, 58.696601],
        [23.874360, 58.771674],
        [23.429454, 58.764838],
        [23.422048, 58.928697],
        [23.627696, 58.979153],
        [23.408376, 59.025580],
        [23.470876, 59.212144],
        [24.772634, 59.450100],
        [24.803477, 59.570502],
        [25.409434, 59.491034],
        [25.543712, 59.535142],
        [25.484874, 59.669827],
        [27.873302, 59.407620],
        [28.055349, 59.527899],
        [28.086925, 59.799384],
        [28.375255, 59.666327],
        [28.476085, 59.851752],
        [28.832530, 59.786526],
        [29.161388, 60.002631],
        [30.216319, 59.907213],
        [29.848969, 60.166938],
        [29.052013, 60.184272],
        [28.616954, 60.381985],
        [28.438975, 60.559882],
        [28.702810, 60.461168],
        [28.690440, 60.738471],
        [28.137380, 60.533189],
        [26.482677, 60.468004],
        [26.753184, 60.574164],
        [26.659190, 60.651801],
        [26.342052, 60.375556],
        [25.917247, 60.485419],
        [26.108165, 60.335924],
        [25.842052, 60.402167],
        [25.930186, 60.245185],
        [25.668630, 60.364651],
        [24.554047, 60.155951],
        [24.445649, 59.992255],
        [23.429454, 59.956610],
        [23.251313, 59.841132],
        [22.905121, 59.811225],
        [23.247081, 59.922431],
        [23.326427, 60.009345],
        [23.110688, 59.923285],
        [23.257579, 60.039740],
        [22.874685, 60.149604],
        [23.080577, 60.355048],
        [22.525076, 60.204250],
        [22.624278, 60.399075],
        [21.785330, 60.477973],
        [21.840505, 60.628730],
        [21.612071, 60.488837],
        [21.408539, 60.580390],
        [21.298676, 61.060126],
        [21.482270, 61.060126],
        [21.448904, 61.402777],
        [21.572439, 61.416409],
        [21.422130, 61.485338],
        [21.716319, 61.526923],
        [21.236583, 61.985012],
        [21.389903, 62.208157],
        [21.133556, 62.403957],
        [21.113536, 62.781195],
        [21.495128, 63.071723],
        [21.688487, 63.027086],
        [21.504893, 63.217434],
        [21.894542, 63.260484],
        [21.983897, 63.143215],
        [22.373709, 63.321357],
        [22.190929, 63.458441],
        [22.401622, 63.418158],
        [22.271251, 63.513739],
        [22.435802, 63.472805],
        [22.589041, 63.703315],
        [22.773448, 63.627509],
        [23.415782, 63.924628],
        [23.396495, 64.056138],
        [23.604503, 64.027655],
        [24.538422, 64.805325],
        [25.362153, 64.833075],
        [25.190929, 64.966783],
        [25.443533, 64.966783],
        [25.211436, 65.123765],
        [25.351817, 65.484117],
        [24.675792, 65.635443],
        [24.550466, 65.763495],
        [24.710623, 65.912095],
        [24.404796, 65.769232],
        [23.195974, 65.826972],
        [23.103038, 65.704657],
        [22.653005, 65.908393],
        [22.663748, 65.757514],
        [22.405528, 65.863918],
        [22.209239, 65.761217],
        [22.387950, 65.672512],
        [22.281505, 65.701483],
        [22.189220, 65.624091],
        [22.308604, 65.669379],
        [22.405284, 65.541938],
        [22.202973, 65.548977],
        [21.448904, 65.357164],
        [21.345551, 65.372789],
        [21.277843, 65.350043],
        [21.585948, 65.069159],
        [21.037364, 64.832709],
        [21.606456, 64.452216],
        [20.966563, 64.149400],
        [20.674653, 63.789252],
        [19.687348, 63.431342],
        [19.446300, 63.560858],
        [19.516612, 63.414740],
        [19.293224, 63.466539],
        [19.052745, 63.178860],
        [18.913341, 63.212063],
        [18.241710, 62.999823],
        [18.524425, 62.991889],
        [18.576671, 62.958401],
        [18.195079, 62.777411],
        [17.935313, 62.817043],
        [17.830821, 62.999823],
        [17.693614, 62.993598],
        [18.064220, 62.595771],
        [17.707367, 62.437445],
        [17.330821, 62.487738],
        [17.652680, 62.232001],
        [17.344574, 61.936672],
        [17.496349, 61.635077],
        [17.330577, 61.718085],
        [17.138031, 61.725531],
        [17.247895, 61.608832],
        [17.056326, 61.582180],
        [17.276052, 61.314032],
        [17.097179, 61.320868],
        [17.335704, 60.766913],
        [17.186697, 60.692369],
        [17.670584, 60.504096],
        [17.974864, 60.587836],
        [18.234874, 60.327094],
        [18.427989, 60.348782],
        [18.604828, 60.238349],
        [18.316905, 60.320950],
        [18.578136, 60.073920],
        [18.796641, 60.004950],
        [18.816905, 60.117580],
        [19.071625, 59.896308],
        [18.733897, 59.768785],
        [19.085216, 59.772203],
        [18.307302, 59.396796],
        [18.646495, 59.330268],
        [18.291270, 59.322699],
        [18.424164, 59.143948],
        [18.013682, 59.044908],
        [17.892833, 58.861029],
        [17.658946, 59.168891],
        [17.590668, 58.861029],
        [17.357758, 58.751166],
        [16.179210, 58.634508],
        [16.940196, 58.491116],
        [16.412608, 58.477484],
        [16.766612, 58.368598],
        [16.631684, 58.353949],
        [16.824067, 58.192857],
        [16.617442, 58.203111],
        [16.758149, 57.877021],
        [16.515310, 57.998847],
        [16.572520, 57.893948],
        [16.460297, 57.902086],
        [16.419444, 57.894680],
        [16.714854, 57.702826],
        [16.520518, 57.627143],
        [16.688975, 57.471747],
        [16.469086, 57.275377],
        [16.583263, 57.044908],
        [16.439789, 57.051744],
        [16.471690, 56.777411],
        [15.851736, 56.086371],
        [15.586436, 56.208889],
        [14.724946, 56.167629],
        [14.767751, 56.030707],
        [14.346446, 55.953315],
        [14.194184, 55.741889],
        [14.363048, 55.523627],
        [14.181163, 55.390815],
        [12.832774, 55.382554],
        [13.054861, 55.694037],
        [12.451427, 56.304429],
        [12.814464, 56.236151],
        [12.621593, 56.419338],
        [12.934418, 56.547065],
        [12.356456, 56.923814],
        [12.059255, 57.458808],
        [11.903331, 57.394355],
        [11.923676, 57.702826],
        [11.705414, 57.698432],
        [11.882823, 58.332831],
        [11.505870, 58.243069],
        [11.669932, 58.422187],
        [11.553233, 58.463202],
        [11.522472, 58.336249],
        [11.396169, 58.264594],
        [11.424083, 58.442694],
        [11.220876, 58.346259],
        [11.286306, 58.579901],
        [11.115001, 59.008205],
        [11.437755, 58.998236],
        [11.176443, 59.196845],
        [10.738129, 59.216702],
        [10.779145, 59.312934],
        [10.591645, 59.430650],
        [10.690278, 59.480658],
        [10.560232, 59.726223],
        [10.740001, 59.895168],
        [10.475434, 59.850043],
        [10.614594, 59.607733],
        [10.483735, 59.514472],
        [10.397634, 59.688056],
        [10.224376, 59.723822],
        [10.514171, 59.302924],
        [10.306895, 59.059719],
        [9.846202, 58.955634],
        [9.723969, 58.983954],
        [9.298839, 58.881537],
        [9.450369, 58.833157],
        [9.070974, 58.741197],
        [9.216319, 58.702786],
        [8.122895, 58.102037],
        [8.004080, 58.223049],
        [7.915782, 58.081855],
        [7.006602, 57.993150],
        [7.147472, 58.100084],
        [6.530528, 58.120551],
        [6.845958, 58.271389],
        [5.646251, 58.548651],
        [5.477951, 58.754747],
        [5.626231, 58.925605],
        [5.550548, 59.038560],
        [5.715587, 58.867255],
        [5.853526, 58.965033],
        [6.092540, 58.847235],
        [6.228852, 58.839993],
        [6.057628, 58.902045],
        [6.033865, 58.905178],
        [5.875499, 59.066230],
        [6.461681, 59.319770],
        [6.041515, 59.383694],
        [6.544200, 59.559963],
        [6.236339, 59.525824],
        [6.286469, 59.649237],
        [6.153005, 59.459418],
        [6.153168, 59.477444],
        [5.807384, 59.539374],
        [5.646169, 59.408515],
        [5.859630, 59.350775],
        [5.611990, 59.293036],
        [5.586599, 59.416490],
        [5.505382, 59.277737],
        [5.201671, 59.546291],
        [5.489106, 59.738105],
        [5.416759, 59.504706],
        [5.564138, 59.676663],
        [5.754405, 59.609849],
        [6.291759, 59.840318],
        [5.646169, 59.854193],
        [6.291026, 60.121649],
        [6.074962, 60.198391],
        [6.351817, 60.368109],
        [6.640391, 60.416490],
        [6.530528, 60.262274],
        [6.510102, 60.135321],
        [6.523774, 60.080756],
        [6.654063, 60.382392],
        [7.105968, 60.505845],
        [6.177501, 60.471015],
        [6.139903, 60.254340],
        [5.739268, 59.994452],
        [5.790701, 60.211086],
        [5.543712, 60.162665],
        [5.736583, 60.392035],
        [5.409841, 60.131334],
        [5.140961, 60.351386],
        [5.305837, 60.528266],
        [5.653575, 60.430813],
        [5.749766, 60.718166],
        [5.675629, 60.757758],
        [5.526622, 60.628730],
        [5.222830, 60.574164],
        [4.926768, 60.800116],
        [5.433849, 60.628730],
        [5.235850, 60.776190],
        [5.131033, 60.812079],
        [5.016124, 61.046536],
        [6.098481, 61.122219],
        [6.355968, 61.010932],
        [6.600597, 61.175238],
        [6.955821, 61.088080],
        [6.873790, 60.937242],
        [7.105968, 60.861558],
        [7.000336, 61.092922],
        [7.435557, 61.101142],
        [7.694998, 61.232082],
        [7.312022, 61.287299],
        [7.572032, 61.485338],
        [7.263682, 61.395941],
        [7.305186, 61.163235],
        [6.557872, 61.224595],
        [6.695079, 61.344713],
        [6.701915, 61.402777],
        [6.434337, 61.114732],
        [6.037120, 61.204169],
        [5.193858, 61.105292],
        [4.954600, 61.252590],
        [5.633067, 61.361802],
        [5.804454, 61.457994],
        [5.178233, 61.509752],
        [5.427013, 61.588935],
        [4.968272, 61.636135],
        [4.988129, 61.746894],
        [5.394786, 61.911078],
        [5.742931, 61.848456],
        [5.940929, 61.845038],
        [5.899262, 61.738593],
        [6.476248, 61.825344],
        [5.729259, 61.889390],
        [5.427013, 61.937812],
        [5.155772, 61.896064],
        [5.400157, 62.020006],
        [5.461681, 62.006741],
        [5.591563, 62.068183],
        [5.454275, 62.191067],
        [5.749766, 62.088609],
        [5.667247, 62.170600],
        [5.905528, 62.190904],
        [5.845388, 62.019721],
        [5.954600, 62.139960],
        [6.050792, 62.068183],
        [6.366710, 62.061347],
        [5.926036, 62.225491],
        [6.310802, 62.372056],
        [6.530528, 62.109117],
        [6.400238, 62.387193],
        [6.708751, 62.451728],
        [6.989268, 62.273017],
        [6.955821, 62.102281],
        [7.021251, 62.090766],
        [7.139985, 62.116604],
        [7.187836, 62.102281],
        [7.149669, 62.130805],
        [6.979340, 62.112860],
        [7.028087, 62.266018],
        [7.415050, 62.239447],
        [6.790701, 62.478420],
        [6.674571, 62.492743],
        [6.249360, 62.574652],
        [7.092296, 62.650946],
        [7.127126, 62.533677],
        [7.542491, 62.503607],
        [7.778168, 62.574652],
        [7.505219, 62.566352],
        [7.418224, 62.633002],
        [7.359711, 62.698188],
        [7.312511, 62.744045],
        [6.970388, 62.725572],
        [6.948985, 62.732896],
        [7.215831, 62.814846],
        [6.880056, 62.911078],
        [7.237641, 63.014716],
        [8.075531, 62.950873],
        [8.154307, 62.814846],
        [8.545258, 62.657172],
        [8.147472, 62.951402],
        [7.877208, 63.010403],
        [8.086681, 63.109687],
        [8.329275, 62.880683],
        [8.702973, 62.822252],
        [8.415701, 62.958808],
        [8.374034, 62.973090],
        [8.470225, 63.020250],
        [8.238536, 63.025458],
        [8.165538, 63.115302],
        [8.943126, 63.212063],
        [8.476410, 63.294013],
        [8.764415, 63.349270],
        [8.672374, 63.421210],
        [9.018321, 63.466539],
        [9.093435, 63.294013],
        [9.434581, 63.380439],
        [9.169119, 63.421210],
        [9.481944, 63.473212],
        [9.480724, 63.487047],
        [9.148611, 63.485826],
        [9.699067, 63.644477],
        [9.960623, 63.427720],
        [9.833263, 63.328803],
        [10.259044, 63.267279],
        [10.040863, 63.406399],
        [10.908051, 63.456244],
        [10.758800, 63.517483],
        [10.922618, 63.602484],
        [11.457693, 63.789984],
        [11.096446, 63.889635],
        [11.497895, 64.020819],
        [11.299978, 64.107164],
        [10.573741, 63.809149],
        [11.056000, 63.861274],
        [10.910004, 63.731024],
        [9.980154, 63.493354],
        [9.799083, 63.691840],
        [9.999848, 63.723863],
        [10.101410, 63.767564],
        [9.544119, 63.665595],
        [9.778087, 63.767564],
        [9.545909, 63.774400],
        [10.197032, 63.938300],
        [9.936290, 63.959418],
        [10.013682, 64.118801],
        [10.648936, 64.356635],
        [10.483084, 64.423733],
        [10.834972, 64.369127],
        [10.656423, 64.452216],
        [10.971202, 64.602607],
        [11.341563, 64.431708],
        [11.247406, 64.325588],
        [11.779796, 64.596869],
        [11.396169, 64.706732],
        [11.260997, 64.734361],
        [11.697113, 64.912177],
        [11.245372, 64.857571],
        [11.267263, 64.869818],
        [11.978526, 65.068834],
        [12.194021, 64.994859],
        [12.193126, 65.050482],
        [12.636241, 65.131293],
        [12.931000, 65.312405],
        [12.502778, 65.144924],
        [12.355154, 65.226874],
        [12.245291, 65.233629],
        [12.691580, 65.329820],
        [12.478689, 65.446519],
        [12.780284, 65.459621],
        [12.355154, 65.604193],
        [12.495372, 65.733344],
        [12.608409, 65.651353],
        [12.787120, 65.638373],
        [12.557791, 65.753730],
        [12.717540, 65.789130],
        [12.682302, 65.926663],
        [13.176036, 65.855780],
        [12.924327, 65.994045],
        [13.040375, 66.083441],
        [13.527192, 66.240139],
        [13.535899, 66.110541],
        [13.821625, 66.147040],
        [13.609548, 66.185777],
        [13.040375, 66.179633],
        [13.534434, 66.309312],
        [13.037283, 66.319973],
        [13.163829, 66.466986],
        [12.972016, 66.522203],
        [13.102550, 66.542711],
        [13.225352, 66.453925],
        [13.362071, 66.455512],
        [13.259532, 66.522203],
        [13.239024, 66.548407],
        [13.403494, 66.625230],
        [13.170665, 66.651923],
        [13.191173, 66.666571],
        [13.225352, 66.714016],
        [13.993012, 66.789740],
        [13.543630, 66.921861],
        [14.568207, 67.018134],
        [14.267426, 67.083930],
        [14.750336, 67.123928],
        [14.603770, 67.204250],
        [15.501475, 67.070258],
        [15.376720, 67.200629],
        [15.062511, 67.247748],
        [15.165050, 67.310492],
        [14.328298, 67.241604],
        [15.049001, 67.447008],
        [14.822439, 67.447008],
        [14.726817, 67.488674],
        [15.058849, 67.577338],
        [15.158865, 67.535793],
        [15.429047, 67.482978],
        [15.658458, 67.275702],
        [15.528656, 67.467475],
        [15.897960, 67.556871],
        [15.466075, 67.577338],
        [15.178559, 67.618354],
        [15.301117, 67.720201],
        [15.596934, 67.748847],
        [15.799653, 67.679023],
        [15.836599, 67.694037],
        [15.432791, 67.860745],
        [15.181977, 67.714545],
        [14.836111, 67.642524],
        [14.726817, 67.659369],
        [15.117198, 67.741889],
        [14.772960, 67.815985],
        [15.860118, 67.899644],
        [16.063162, 68.016181],
        [15.844493, 68.096259],
        [15.979666, 68.250067],
        [16.042003, 68.029853],
        [16.192882, 67.981513],
        [16.236827, 67.883612],
        [16.484711, 67.797797],
        [16.207042, 68.002590],
        [16.466563, 67.899563],
        [16.389171, 68.059272],
        [16.289073, 68.091295],
        [16.590099, 68.167060],
        [16.802989, 68.132270],
        [16.220063, 68.351386],
        [17.127289, 68.372870],
        [17.333995, 68.167060],
        [17.419932, 68.235907],
        [17.247895, 68.405992],
        [17.467621, 68.447577],
        [17.546560, 68.530097],
        [16.464610, 68.509996],
        [16.960704, 68.704535],
        [17.234386, 68.756049],
        [17.782970, 68.748603],
        [17.467621, 68.831204],
        [17.825938, 68.893744],
        [17.426117, 68.899482],
        [17.658865, 69.116889],
        [18.152354, 69.153957],
        [17.988536, 69.235256],
        [18.158458, 69.459621],
        [18.487153, 69.382025],
        [18.502452, 69.235256],
        [18.564789, 69.364651],
        [18.454600, 69.454332],
        [18.852712, 69.552314],
        [19.014415, 69.397040],
        [19.379405, 69.321845],
        [19.177501, 69.253485],
        [19.477224, 69.220771],
        [19.429535, 69.341742],
        [18.992686, 69.483140],
        [19.229259, 69.567939],
        [18.944347, 69.615302],
        [19.784190, 69.804389],
        [19.530284, 69.400336],
        [19.743175, 69.612616],
        [20.060232, 69.579088],
        [20.112559, 69.585354],
        [19.824474, 69.711900],
        [20.292654, 69.971015],
        [20.425304, 69.877183],
        [20.382579, 69.598782],
        [20.482432, 69.577867],
        [20.492361, 69.627265],
        [20.482432, 69.763414],
        [20.893891, 69.852851],
        [21.179210, 69.819485],
        [21.289887, 70.021064],
        [22.098155, 69.749823],
        [21.913585, 69.945258],
        [22.113617, 70.030341],
        [21.798350, 70.037177],
        [22.099376, 70.120347],
        [21.209239, 70.208482],
        [21.552989, 70.321031],
        [21.874034, 70.147040],
        [21.805675, 70.257229],
        [21.986827, 70.323432],
        [22.305837, 70.287299],
        [22.274669, 70.135484],
        [22.325938, 70.167548],
        [22.400645, 70.258287],
        [22.967052, 70.207465],
        [23.018565, 70.147040],
        [23.094412, 69.955268],
        [23.329845, 69.948391],
        [23.539317, 70.024115],
        [23.175548, 70.092434],
        [23.614431, 70.304674],
        [23.513194, 70.365546],
        [24.350271, 70.456244],
        [24.102712, 70.541409],
        [24.352387, 70.690985],
        [24.245128, 70.784491],
        [24.635427, 70.779771],
        [24.666026, 70.977688],
        [25.033458, 70.971340],
        [24.916026, 70.873236],
        [25.153575, 70.919501],
        [25.245616, 70.791327],
        [25.365001, 70.976142],
        [25.535981, 70.922919],
        [25.441661, 70.841498],
        [25.925792, 70.863674],
        [25.073578, 70.503323],
        [25.287120, 70.456122],
        [24.979828, 70.229438],
        [25.004242, 70.064032],
        [26.613617, 70.949123],
        [26.691173, 70.736029],
        [26.341645, 70.647935],
        [26.656993, 70.640530],
        [26.553884, 70.353095],
        [27.102061, 70.469794],
        [26.972911, 70.565375],
        [27.266612, 70.585273],
        [27.080903, 70.702582],
        [27.310883, 70.818183],
        [27.629649, 70.804999],
        [27.122569, 70.921698],
        [27.348969, 70.942125],
        [27.221690, 71.018948],
        [28.209727, 71.083970],
        [28.548839, 70.972602],
        [28.265880, 70.794989],
        [28.130544, 70.736029],
        [28.301280, 70.702582],
        [27.849376, 70.482856],
        [28.335297, 70.517646],
        [28.160655, 70.382799],
        [28.167247, 70.135484],
        [28.183930, 70.115546],
        [28.232677, 70.399115],
        [28.507335, 70.448717],
        [28.401703, 70.558987],
        [28.794688, 70.873236],
        [29.404796, 70.784491],
        [29.306407, 70.652899],
        [30.104747, 70.710761],
        [30.347341, 70.596137],
        [30.000743, 70.538072],
        [31.063324, 70.366767],
        [30.158946, 70.071357],
        [28.653656, 70.182318],
        [28.596690, 70.161322],
        [29.685883, 69.969550],
        [29.363780, 69.859687],
        [29.741222, 69.907457],
        [29.487315, 69.661078],
        [30.186290, 69.687730],
        [30.165212, 69.879543],
        [30.289236, 69.886542],
        [30.360199, 69.667467],
        [30.450694, 69.810289],
        [30.840994, 69.805854],
        [31.409028, 69.715806],
        [31.325694, 69.614936],
        [31.810557, 69.687730],
        [31.753673, 69.854071],
        [32.098888, 69.791897],
        [31.913341, 69.936184],
        [32.054454, 69.963772],
        [33.133311, 69.728664],
        [32.871755, 69.582506],
        [32.111664, 69.752875],
        [32.016124, 69.564195],
        [32.501964, 69.517035],
        [32.193614, 69.434516],
        [33.084972, 69.476060],
        [32.823497, 69.301215],
        [33.523692, 69.428290],
        [33.235118, 69.270006],
        [33.544200, 69.208564],
        [33.060557, 69.083319],
        [33.064301, 69.057766],
        [33.426606, 69.104682],
        [33.723969, 69.336819],
        [35.873546, 69.194892],
        [37.680512, 68.713446],
        [38.388682, 68.343166],
        [39.859548, 68.046617],
        [39.793224, 68.164740],
        [40.466807, 67.761176],
        [41.039887, 67.677802],
        [41.108897, 67.253811],
        [41.390391, 67.124905],
        [41.178071, 66.809556],
        [40.084972, 66.288764],
        [38.554373, 66.054999],
        [35.557791, 66.387030],
        [34.803559, 66.613511],
        [34.480154, 66.537584],
        [34.355968, 66.629788],
        [34.503184, 66.638251],
        [34.521658, 66.657172],
        [34.092296, 66.672431],
        [34.141368, 66.773830],
        [33.947276, 66.684882],
        [33.100597, 66.858140],
        [32.804861, 67.010321],
        [32.929942, 67.100002],
        [32.382579, 67.159654],
        [32.261974, 67.124986],
        [32.549815, 67.000067],
        [32.420177, 66.885932],
        [33.324474, 66.645738],
        [33.259613, 66.618394],
        [33.192719, 66.578803],
        [32.940929, 66.528469],
        [33.735362, 66.426011],
        [33.310802, 66.316799],
        [34.102794, 66.246894],
        [34.846446, 65.905219],
        [34.968598, 65.727729],
        [34.688731, 65.809719],
        [34.681895, 65.453355],
        [34.297048, 65.385077],
        [34.773692, 65.100246],
        [34.702403, 64.980414],
        [34.942068, 64.857571],
        [34.757009, 64.774359],
        [35.009031, 64.743184],
        [34.743337, 64.555854],
        [35.348752, 64.296073],
        [35.810802, 64.342027],
        [36.365001, 64.001776]
    ],
    [
        [35.827159, 46.623358],
        [36.278331, 46.607408],
        [36.633962, 46.779975],
        [36.769298, 46.637397],
        [36.853689, 46.800482],
        [37.335216, 46.882473],
        [37.580740, 47.090399],
        [38.108084, 47.026353],
        [38.224132, 47.108344],
        [38.427908, 47.133531],
        [38.553396, 47.229804],
        [38.810395, 47.287828],
        [38.478038, 47.142483],
        [39.264008, 47.260810],
        [39.264903, 47.096625],
        [39.388682, 47.115180],
        [39.280040, 47.012763],
        [38.403005, 46.820950],
        [38.378184, 46.708157],
        [38.591645, 46.659247],
        [37.730724, 46.670111],
        [37.970958, 46.361802],
        [38.576020, 46.087348],
        [38.167491, 46.120510],
        [38.097504, 46.057807],
        [37.940115, 46.020331],
        [37.595063, 45.635321],
        [37.736013, 45.306138],
        [37.078380, 45.238959],
        [37.139415, 45.335517],
        [36.833263, 45.443020],
        [36.705089, 45.391018],
        [36.668142, 45.326361],
        [36.961681, 45.282945],
        [36.578136, 45.187079],
        [37.191905, 44.991034],
        [37.498709, 44.668402],
        [37.778494, 44.729804],
        [38.217296, 44.387193],
        [38.758311, 44.273627],
        [40.335134, 43.140855],
        [40.855968, 43.063056],
        [41.424327, 42.739895],
        [41.760265, 41.992580],
        [41.676036, 41.662177],
        [41.390391, 41.379340],
        [40.142751, 40.922797],
        [39.430186, 41.112494],
        [38.330903, 40.917873],
        [37.135509, 41.146633],
        [36.758067, 41.366278],
        [36.395030, 41.256415],
        [36.044932, 41.701483],
        [35.298188, 41.715155],
        [35.092133, 41.928046],
        [35.216319, 42.023627],
        [35.023936, 42.092515],
        [34.694184, 41.945950],
        [33.324474, 42.019029],
        [32.263357, 41.720160],
        [31.403575, 41.316474],
        [31.231212, 41.091986],
        [29.169688, 41.233100],
        [29.007579, 41.030504],
        [29.254568, 40.810777],
        [29.939301, 40.735053],
        [28.792654, 40.553290],
        [29.151541, 40.434068],
        [29.051606, 40.367336],
        [27.944672, 40.366034],
        [28.034434, 40.474433],
        [27.760020, 40.537055],
        [27.883556, 40.386298],
        [27.762706, 40.315375],
        [27.286957, 40.468207],
        [26.735606, 40.403551],
        [26.167654, 39.973578],
        [26.069998, 39.496283],
        [26.937673, 39.574774],
        [26.609223, 39.275214],
        [26.875255, 39.090888],
        [26.806488, 38.950141],
        [27.062673, 38.886868],
        [26.719086, 38.652655],
        [26.935395, 38.434882],
        [27.164236, 38.446601],
        [26.795095, 38.358629],
        [26.702403, 38.430162],
        [26.673106, 38.307196],
        [26.414073, 38.679389],
        [26.387869, 38.454250],
        [26.513031, 38.432929],
        [26.233084, 38.280260],
        [27.239106, 37.987942],
        [27.249522, 37.744330],
        [27.011485, 37.665717],
        [27.208507, 37.596869],
        [27.190766, 37.357327],
        [27.615977, 37.274726],
        [27.565115, 37.125637],
        [27.252940, 37.123969],
        [27.263194, 36.963365],
        [28.329356, 37.036770],
        [28.041840, 36.938910],
        [28.027517, 36.781317],
        [27.645356, 36.806464],
        [27.404307, 36.665229],
        [27.671153, 36.657782],
        [28.118419, 36.800605],
        [27.966075, 36.688788],
        [28.035899, 36.564765],
        [28.451996, 36.883612],
        [28.828868, 36.602525],
        [28.938975, 36.751288],
        [29.096365, 36.665229],
        [29.096365, 36.390937],
        [29.672374, 36.123358],
        [30.158539, 36.298651],
        [30.427419, 36.226386],
        [30.686534, 36.891181],
        [32.018809, 36.546536],
        [32.365489, 36.177965],
        [32.803722, 36.027167],
        [33.688243, 36.137030],
        [33.871104, 36.314887],
        [33.958995, 36.213568],
        [34.692882, 36.813870],
        [35.346039, 36.541083],
        [36.095470, 36.897121],
        [36.216156, 36.657782],
        [35.788748, 36.320258],
        [35.976736, 36.000963],
        [35.723399, 35.582099],
        [35.918956, 35.417670],
        [35.988780, 34.552720],
        [35.665212, 34.311347],
        [34.873220, 32.430325]
    ],
    [
        [63.579438, 69.638658],
        [60.736013, 69.839057],
        [60.667328, 69.678168],
        [60.138845, 69.577867],
        [60.591319, 69.132799],
        [60.902680, 69.122260],
        [60.968761, 68.906928],
        [59.811209, 68.687934],
        [59.963878, 68.466010],
        [59.674815, 68.336168],
        [59.087087, 68.416897],
        [59.056407, 68.619534],
        [59.423025, 68.757025],
        [58.891856, 68.934231],
        [59.223888, 68.999701],
        [58.878754, 69.003119],
        [58.270518, 68.893704],
        [58.424083, 68.742743],
        [58.171153, 68.889350],
        [57.329845, 68.564765],
        [55.392914, 68.564276],
        [54.936697, 68.398424],
        [54.831879, 68.173285],
        [54.504405, 68.312201],
        [53.944347, 68.405992],
        [53.720470, 68.656928],
        [54.026215, 68.845445],
        [53.594900, 68.906928],
        [53.437022, 68.918158],
        [52.634451, 68.658515],
        [52.491384, 68.591539],
        [52.731293, 68.474189],
        [52.402029, 68.337714],
        [52.135590, 68.379299],
        [52.361013, 68.474921],
        [52.051768, 68.492418],
        [52.177094, 68.582424],
        [50.778819, 68.379299],
        [49.133311, 67.862616],
        [48.585948, 67.934272],
        [49.106700, 67.639472],
        [47.845714, 67.600898],
        [47.947927, 67.444322],
        [47.581391, 66.869859],
        [46.406749, 66.746161],
        [46.597911, 66.857978],
        [46.025157, 66.833401],
        [45.593893, 67.158240],
        [44.912120, 67.371975],
        [45.350434, 67.730414],
        [46.698253, 67.816474],
        [46.534923, 68.132554],
        [45.582137, 68.514198],
        [43.273673, 68.658176],
        [44.227550, 68.296780],
        [44.180837, 68.036078],
        [44.307872, 68.065863],
        [44.411794, 68.063422],
        [44.138031, 67.995103],
        [44.268403, 67.926825],
        [44.087413, 67.885077],
        [44.144542, 67.679429],
        [43.766699, 67.277689],
        [44.377696, 67.104438],
        [44.521658, 66.919420],
        [44.364024, 66.782294],
        [44.563243, 66.666205],
        [44.096365, 66.261949],
        [44.179698, 65.864325],
        [43.836436, 66.185777],
        [43.382335, 66.071926],
        [43.500987, 66.052680],
        [43.514903, 65.974189],
        [43.352794, 66.041490],
        [43.288341, 66.090237],
        [43.692638, 66.237209],
        [43.302094, 66.426011],
        [42.548595, 66.385077],
        [42.661469, 66.443345],
        [42.155935, 66.526353],
        [41.643565, 66.172756],
        [40.710134, 65.972317],
        [39.749278, 65.552069],
        [39.740896, 65.356513],
        [40.517345, 64.774115],
        [40.410899, 64.736802],
        [40.517100, 64.541449],
        [39.850352, 64.675971],
        [39.786388, 64.596869],
        [39.902843, 64.624416],
        [39.923595, 64.603013],
        [39.566524, 64.545268],
        [38.448031, 64.817878],
        [38.472504, 64.743476],
        [38.048106, 64.645941],
        [38.066580, 64.781195],
        [38.385021, 64.844627],
        [37.007677, 65.172977],
        [36.820002, 65.147141],
        [36.807444, 64.959052],
        [36.439952, 64.917060],
        [36.559761, 64.717423],
        [37.286228, 64.352206],
        [37.956716, 64.364081],
        [38.088064, 64.034898],
        [37.437811, 63.792281],
        [36.365001, 64.001776]
    ],
    [
        [92.085216, 75.735745],
        [89.245779, 75.506741],
        [87.952647, 75.100043],
        [87.024587, 75.164211],
        [86.898611, 75.087714],
        [87.172862, 74.985297],
        [87.385753, 74.944322],
        [86.762055, 74.704088],
        [86.957530, 74.608832],
        [86.028331, 74.813951],
        [86.120616, 74.751939],
        [85.740408, 74.635891],
        [86.782481, 74.560736],
        [86.535492, 74.512356],
        [87.262380, 74.354682],
        [86.715831, 74.301825],
        [86.953868, 74.388861],
        [86.475271, 74.458197],
        [86.069509, 74.423529],
        [86.309581, 74.328030],
        [85.905528, 74.354682],
        [85.974376, 74.276190],
        [87.362315, 74.047756],
        [86.940196, 74.033149],
        [87.296397, 73.841376],
        [87.664073, 73.890855],
        [87.164806, 73.611396],
        [85.844005, 73.439846],
        [86.659679, 73.151801],
        [86.782481, 73.000881],
        [85.833181, 73.331773],
        [85.786794, 73.480780],
        [87.080089, 73.871527],
        [80.512950, 73.567043],
        [80.677419, 73.504950],
        [80.254893, 73.329739],
        [80.563487, 73.221503],
        [80.231130, 73.175971],
        [80.814301, 72.974270],
        [80.632091, 72.733791],
        [80.834483, 72.620510],
        [80.704112, 72.545356],
        [82.198090, 72.281562],
        [82.307384, 72.182847],
        [82.185069, 72.093492],
        [82.678071, 71.879462],
        [83.360525, 71.840644],
        [83.618907, 71.631171],
        [83.116059, 71.113471],
        [83.381847, 71.032660],
        [83.774669, 70.476630],
        [82.951671, 70.325141],
        [83.149425, 70.076483],
        [82.643809, 70.181220],
        [83.010509, 70.426581],
        [83.137218, 70.763983],
        [82.901622, 71.001044],
        [82.578624, 70.911119],
        [82.464610, 70.613186],
        [82.157237, 70.571601],
        [82.082042, 70.565375],
        [82.417247, 70.777045],
        [82.208344, 70.986802],
        [82.352794, 71.096259],
        [82.272634, 71.278795],
        [83.047862, 71.415107],
        [83.026541, 71.549872],
        [83.295584, 71.703111],
        [81.342296, 71.764228],
        [80.632335, 72.046088],
        [80.834646, 72.083319],
        [79.391449, 72.385565],
        [78.124522, 72.384589],
        [77.377208, 72.110175],
        [77.985606, 72.109524],
        [78.225759, 71.982571],
        [78.109548, 71.880439],
        [77.584646, 71.831122],
        [76.878184, 72.050035],
        [75.996837, 71.907904],
        [76.272309, 71.572903],
        [77.492198, 71.301337],
        [77.988292, 71.374742],
        [77.928477, 71.257473],
        [78.525401, 71.092963],
        [78.442393, 70.914252],
        [79.102794, 71.020250],
        [79.039561, 70.937323],
        [78.411388, 70.895453],
        [77.782725, 71.142483],
        [77.005138, 71.184475],
        [76.914236, 71.072455],
        [76.888927, 71.190416],
        [75.263031, 71.365546],
        [75.532888, 71.542304],
        [75.227550, 71.777411],
        [75.253673, 71.942206],
        [75.754731, 72.306383],
        [75.556488, 72.497504],
        [75.687185, 72.585395],
        [75.338227, 72.683173],
        [75.522309, 72.759833],
        [75.036632, 72.881659],
        [74.741547, 72.814399],
        [75.058849, 72.595038],
        [74.994884, 72.137844],
        [73.525890, 71.822211],
        [73.498546, 71.664944],
        [73.022472, 71.428778],
        [73.556163, 71.255113],
        [74.317882, 70.667792],
        [74.316173, 70.520331],
        [73.707693, 70.161322],
        [73.515961, 69.746405],
        [73.899587, 69.420844],
        [73.776622, 69.153957],
        [74.772797, 69.081244],
        [76.042003, 69.239081],
        [77.646983, 68.911119],
        [77.786876, 68.514594],
        [78.172618, 68.274359],
        [77.536957, 68.128607],
        [77.494151, 67.751288],
        [77.693044, 67.545315],
        [77.120291, 67.768541],
        [77.305186, 67.910102],
        [77.192556, 67.985175],
        [77.356619, 68.232896],
        [77.161876, 68.293647],
        [77.325694, 68.523342],
        [76.662608, 68.762641],
        [76.609060, 68.966010],
        [76.113129, 68.977729],
        [74.481130, 68.720526],
        [74.331554, 68.385565],
        [74.725434, 68.152411],
        [74.748871, 67.706529],
        [73.899587, 67.296210],
        [73.797130, 66.964097],
        [72.317556, 66.527533],
        [72.306326, 66.288520],
        [70.362641, 66.334418],
        [69.112641, 66.618842],
        [68.965017, 66.809556],
        [70.723399, 66.761786],
        [70.295177, 66.638251],
        [70.688650, 66.515367],
        [71.576915, 66.658759],
        [71.514903, 66.878485],
        [71.301931, 66.953559],
        [71.747569, 66.916083],
        [71.994640, 67.055976],
        [71.913259, 67.132310],
        [72.225922, 67.159491],
        [72.048350, 67.302883],
        [72.402599, 67.328070],
        [72.581309, 67.620185],
        [73.114268, 67.690375],
        [73.204438, 67.957221],
        [73.090831, 68.214260],
        [73.646251, 68.457831],
        [72.577403, 68.940375],
        [72.477875, 69.176947],
        [72.647716, 69.292222],
        [72.488048, 69.414008],
        [72.638357, 69.441352],
        [72.501720, 69.646715],
        [72.691661, 69.836859],
        [72.491954, 70.041205],
        [72.621593, 70.161689],
        [72.435557, 70.285875],
        [72.771332, 70.425238],
        [72.683279, 70.616604],
        [72.836925, 70.859605],
        [72.636485, 71.131659],
        [71.803396, 71.480292],
        [72.344981, 71.708157],
        [72.350841, 71.864203],
        [72.874278, 72.281073],
        [72.721446, 72.703030],
        [72.836925, 72.709906],
        [71.563243, 72.915961],
        [69.353770, 72.952582],
        [68.975759, 72.695990],
        [68.348806, 71.675198],
        [66.912120, 71.294745],
        [66.620453, 71.057847],
        [66.889496, 71.078681],
        [66.608246, 70.880683],
        [66.688731, 70.769843],
        [67.334483, 70.757799],
        [67.094249, 70.220893],
        [67.327647, 70.106024],
        [66.884776, 70.012885],
        [66.795746, 69.586168],
        [66.957693, 69.536851],
        [66.855235, 69.636868],
        [67.017263, 69.703070],
        [68.106619, 69.548733],
        [68.026215, 69.319403],
        [68.458018, 68.984565],
        [69.218923, 68.962144],
        [68.951427, 68.903225],
        [69.109060, 68.878974],
        [68.561046, 68.372504],
        [68.650890, 68.317857],
        [68.288097, 68.188300],
        [68.134939, 68.423407],
        [67.090099, 68.855658],
        [65.068207, 69.268052],
        [64.785899, 69.147121],
        [65.004405, 69.304145],
        [63.579438, 69.638658]
    ],
    [
        [-95.214915, 68.862209],
        [-95.828196, 68.875881],
        [-96.048207, 69.229722],
        [-96.225575, 69.054429],
        [-96.219797, 69.313951],
        [-97.284006, 69.696967],
        [-97.390736, 69.600165],
        [-97.493153, 69.674058],
        [-97.342275, 69.708808],
        [-97.925160, 69.895941],
        [-98.370188, 69.605780],
        [-98.023834, 69.434638],
        [-98.549428, 69.585110],
        [-98.418568, 69.476060],
        [-98.611318, 69.449164],
        [-98.409576, 69.307807],
        [-99.597279, 69.026679],
        [-99.192250, 68.829779],
        [-98.969960, 68.954739],
        [-98.522369, 68.750312],
        [-98.363759, 68.857571],
        [-98.119252, 68.674994],
        [-96.520497, 68.447577],
        [-95.214915, 68.862209]
    ],
    [
        [-163.055776, 69.804511],
        [-163.129099, 69.701972],
        [-162.841135, 69.934760],
        [-162.999949, 69.855780],
        [-163.055776, 69.804511]
    ],
    [
        [-97.465810, 69.900621],
        [-97.275380, 69.858873],
        [-97.226226, 69.879543],
        [-97.388417, 69.962388],
        [-97.465810, 69.900621]
    ],
    [
        [-162.701772, 70.022325],
        [-162.701772, 70.022325]
    ],
    [
        [-124.959218, 70.167548],
        [-125.084584, 70.164862],
        [-125.123687, 70.126614],
        [-125.066151, 70.120795],
        [-124.959218, 70.167548]
    ],
    [
        [-162.484527, 70.173163],
        [-162.559926, 70.106024],
        [-162.162709, 70.269924],
        [-162.308542, 70.241278],
        [-162.484527, 70.173163]
    ],
    [
        [-113.165517, 70.312161],
        [-113.207102, 70.297838],
        [-113.165517, 70.312161]
    ],
    [
        [-100.741200, 70.312161],
        [-100.826894, 70.329006],
        [-100.872182, 70.297838],
        [-100.769154, 70.256903],
        [-100.741200, 70.312161]
    ],
    [
        [-161.551137, 70.325995],
        [-161.888132, 70.353949],
        [-161.977122, 70.312161],
        [-161.837839, 70.343411],
        [-161.551137, 70.325995]
    ],
    [
        [-111.952707, 70.325141],
        [-112.094553, 70.354193],
        [-112.322621, 70.356187],
        [-112.108469, 70.300930],
        [-111.952707, 70.325141]
    ],
    [
        [-116.664052, 70.497056],
        [-116.790924, 70.510728],
        [-116.664052, 70.497056]
    ],
    [
        [-148.819692, 70.469794],
        [-148.922922, 70.501451],
        [-148.994578, 70.492906],
        [-149.236277, 70.553290],
        [-149.313181, 70.544867],
        [-149.015696, 70.484931],
        [-148.819692, 70.469794]
    ],
    [
        [-116.263417, 70.551703],
        [-116.443471, 70.543158],
        [-116.496165, 70.523830],
        [-116.263417, 70.551703]
    ],
    [
        [-116.722076, 70.558539],
        [-116.722076, 70.558539]
    ],
    [
        [-115.885976, 70.582180],
        [-115.909576, 70.574774],
        [-115.885976, 70.582180]
    ],
    [
        [-117.057240, 70.571601],
        [-117.215484, 70.592719],
        [-117.304270, 70.571601],
        [-117.057240, 70.571601]
    ],
    [
        [-137.869456, 69.091864],
        [-135.149037, 68.660468],
        [-135.505360, 68.845445],
        [-136.004994, 68.947903],
        [-135.519032, 69.029771],
        [-135.967763, 69.222154],
        [-135.415924, 69.098700],
        [-135.855377, 69.290473],
        [-135.166656, 69.263007],
        [-135.284332, 69.414537],
        [-135.155385, 69.479722],
        [-134.476308, 69.443793],
        [-134.594472, 69.512885],
        [-134.405507, 69.636868],
        [-134.480946, 69.727484],
        [-133.751291, 69.551174],
        [-134.222239, 69.272610],
        [-134.312978, 69.153957],
        [-133.045522, 69.434516],
        [-132.887278, 69.661078],
        [-132.530100, 69.631985],
        [-132.332997, 69.684638],
        [-132.627187, 69.674058],
        [-132.548411, 69.742987],
        [-132.138905, 69.687934],
        [-131.408315, 69.961493],
        [-131.188466, 69.824897],
        [-130.893625, 70.106024],
        [-129.931711, 70.076117],
        [-129.673940, 70.269924],
        [-129.406484, 70.121161],
        [-130.941151, 69.565904],
        [-131.047963, 69.643744],
        [-131.983551, 69.536851],
        [-132.434804, 69.304145],
        [-132.497467, 69.160142],
        [-132.544667, 69.290473],
        [-132.771230, 69.256334],
        [-132.907948, 69.130845],
        [-132.891998, 68.982733],
        [-133.100738, 69.072008],
        [-133.491322, 68.842515],
        [-133.209381, 68.715074],
        [-132.922027, 68.693996],
        [-133.388173, 68.845445],
        [-132.483225, 68.805406],
        [-132.393870, 68.865912],
        [-132.784535, 68.851020],
        [-132.675649, 68.927395],
        [-132.873647, 69.057766],
        [-132.483795, 69.147121],
        [-132.415273, 69.237860],
        [-132.469553, 69.112982],
        [-132.216298, 69.153957],
        [-131.715443, 69.400336],
        [-131.427561, 69.435126],
        [-131.514882, 69.335924],
        [-131.252065, 69.503852],
        [-131.347808, 69.317084],
        [-131.161122, 69.393541],
        [-131.138051, 69.369778],
        [-131.119537, 69.325263],
        [-130.947743, 69.538886],
        [-131.051259, 69.338935],
        [-130.900868, 69.385647],
        [-131.026194, 69.206000],
        [-130.927805, 69.139635],
        [-130.945139, 69.276679],
        [-130.379709, 69.694525],
        [-128.886057, 69.976264],
        [-129.173695, 69.832343],
        [-128.941518, 69.682440],
        [-128.310374, 69.962714],
        [-128.337229, 70.129828],
        [-127.515207, 70.222113],
        [-128.200510, 70.400865],
        [-127.991526, 70.592922],
        [-127.136464, 70.252875],
        [-126.701772, 69.767401],
        [-126.245229, 69.525336],
        [-125.448842, 69.319159],
        [-125.088979, 69.454332],
        [-125.116851, 69.489691],
        [-125.438385, 69.612616],
        [-125.370107, 69.694525],
        [-124.822011, 69.715033],
        [-125.281361, 69.811225],
        [-124.630238, 69.986274],
        [-124.545562, 70.018948],
        [-124.417348, 70.051459],
        [-124.753774, 70.126614],
        [-124.408111, 70.155422],
        [-124.370269, 70.041693],
        [-124.540883, 69.969550],
        [-124.403717, 69.859687],
        [-124.506744, 69.736151],
        [-124.034413, 69.681545],
        [-124.521067, 69.407782],
        [-124.422841, 69.366645],
        [-123.382680, 69.414008],
        [-122.979726, 69.834784],
        [-121.643870, 69.789049],
        [-120.085805, 69.363593],
        [-117.165395, 68.893948],
        [-115.971181, 68.809272],
        [-116.317983, 68.968329],
        [-115.567250, 68.971869],
        [-113.905385, 68.399807],
        [-114.035471, 68.241197],
        [-114.941518, 68.291327],
        [-114.755116, 68.194322],
        [-115.241689, 68.186916],
        [-115.111969, 68.016181],
        [-115.543365, 67.923407],
        [-115.118235, 67.803900],
        [-111.885487, 67.685207],
        [-110.059641, 68.005072],
        [-109.716705, 67.719184],
        [-109.067047, 67.720160],
        [-108.824127, 67.357164],
        [-108.639882, 67.629462],
        [-108.471262, 67.351467],
        [-108.370269, 67.447577],
        [-107.992543, 67.282457],
        [-107.885365, 67.048245],
        [-108.622060, 67.152818],
        [-107.799672, 66.768622],
        [-107.642974, 67.077094],
        [-107.484364, 66.919420],
        [-107.697255, 66.953559],
        [-107.562978, 66.839504],
        [-107.409250, 66.817084],
        [-107.401031, 66.974311],
        [-107.403391, 67.041164],
        [-107.203196, 67.124905],
        [-107.716420, 67.404608],
        [-107.585846, 67.501166],
        [-108.005727, 67.709662],
        [-107.659332, 67.946723],
        [-107.909535, 67.995103],
        [-107.879506, 68.093004],
        [-107.697255, 68.077623],
        [-107.774078, 67.988593],
        [-106.758168, 68.104967],
        [-106.813385, 68.207994],
        [-106.631500, 68.249579],
        [-106.443471, 68.152777],
        [-106.445668, 68.351264],
        [-105.727122, 68.426581],
        [-105.648346, 68.638739],
        [-106.422353, 68.515855],
        [-106.635243, 68.468695],
        [-106.487945, 68.407416],
        [-106.552724, 68.296780],
        [-106.786733, 68.414944],
        [-107.889027, 68.269477],
        [-107.614654, 68.167060],
        [-108.389231, 68.111029],
        [-108.416615, 68.304185],
        [-108.807037, 68.262641],
        [-108.347157, 68.600084],
        [-106.197499, 68.944403],
        [-105.469594, 68.721991],
        [-105.324127, 68.482489],
        [-105.543935, 68.413886],
        [-105.039215, 68.259101],
        [-104.894195, 68.351386],
        [-104.935170, 68.235907],
        [-104.601959, 68.235338],
        [-104.675689, 68.139716],
        [-104.483876, 68.033922],
        [-103.414866, 68.169379],
        [-103.363515, 68.011461],
        [-102.572825, 67.795111]
    ],
    [
        [-128.234609, 70.660956],
        [-128.255238, 70.647162],
        [-128.344472, 70.544867],
        [-128.083730, 70.613186],
        [-128.234609, 70.660956]
    ],
    [
        [-100.351389, 70.489651],
        [-100.229237, 70.464545],
        [-100.392405, 70.585273],
        [-100.714508, 70.681464],
        [-100.351389, 70.489651]
    ],
    [
        [24.211192, 40.773179],
        [23.697032, 40.721422],
        [23.914887, 40.538886],
        [23.868175, 40.413520],
        [24.011404, 40.449164],
        [24.393809, 40.152493],
        [23.730479, 40.358954],
        [23.991222, 39.953599],
        [23.438487, 40.279202],
        [23.363617, 40.150458],
        [23.747895, 39.930487],
        [23.360606, 39.961086],
        [23.299083, 40.235419],
        [22.888194, 40.386298],
        [22.910492, 40.644599],
        [22.579112, 40.468207],
        [22.571300, 40.054267],
        [23.343761, 39.179633],
        [23.203624, 39.104560],
        [23.052013, 39.097724],
        [23.217133, 39.179633],
        [22.935883, 39.360582],
        [22.826182, 39.221259],
        [23.073090, 39.036282],
        [22.525076, 38.858140],
        [23.951020, 38.290920],
        [24.087413, 37.785224],
        [23.949718, 37.677436],
        [23.581309, 38.046291],
        [23.015147, 37.925238],
        [23.168630, 37.614163],
        [23.398692, 37.637885],
        [23.525645, 37.459703],
        [23.168630, 37.299506],
        [23.132009, 37.448635],
        [22.726410, 37.566352],
        [23.196056, 36.432522],
        [22.685557, 36.809475],
        [22.490977, 36.390937],
        [22.153168, 37.021186],
        [21.943126, 36.993313],
        [21.882579, 36.726549],
        [21.707367, 36.818020],
        [21.569672, 37.116197],
        [21.674815, 37.395982],
        [21.133556, 37.946357],
        [21.374278, 38.220649],
        [21.622325, 38.154771],
        [21.849457, 38.341295],
        [22.867198, 37.939521],
        [23.223399, 38.159247],
        [22.401622, 38.453437],
        [22.382335, 38.342678],
        [21.957856, 38.411689],
        [21.517751, 38.295803],
        [21.322520, 38.496283],
        [21.250255, 38.336737],
        [21.085216, 38.343573],
        [21.095958, 38.531928],
        [20.729340, 38.809760],
        [20.769786, 38.958970],
        [21.085216, 38.864325],
        [21.159923, 38.997748],
        [20.822439, 39.114488],
        [20.735118, 38.950100],
        [19.989024, 39.686713],
        [19.863455, 40.045356],
        [19.476248, 40.213690],
        [19.289561, 40.420396],
        [19.474946, 40.348375],
        [19.304373, 40.653144],
        [19.381196, 40.908271],
        [19.523448, 40.920640],
        [19.393240, 41.413520],
        [19.612966, 41.605292],
        [19.591645, 41.818793],
        [19.170258, 41.937974],
        [18.545177, 42.423570],
        [18.700450, 42.392971],
        [18.687348, 42.482896],
        [18.502452, 42.455634],
        [18.510265, 42.405260],
        [17.892833, 42.790839],
        [17.741466, 42.839260],
        [16.880626, 43.405951],
        [15.959483, 43.503974],
        [15.950450, 43.688544],
        [15.144542, 44.195461],
        [15.261241, 44.332587],
        [15.424490, 44.267971],
        [15.528656, 44.271796],
        [14.901378, 44.690172],
        [14.842540, 45.105536],
        [14.329763, 45.353990],
        [13.903168, 44.772406],
        [13.501475, 45.498603],
        [13.808116, 45.614325],
        [13.574229, 45.789618],
        [13.401703, 45.675442],
        [13.119314, 45.771959],
        [13.084972, 45.641913],
        [12.423676, 45.438056],
        [12.581716, 45.552883],
        [12.396739, 45.539252],
        [12.154470, 45.313463],
        [12.533865, 44.970038],
        [12.266368, 44.826646],
        [12.389985, 44.222724],
        [13.615571, 43.560492],
        [14.075369, 42.598822],
        [14.740733, 42.084621],
        [15.165375, 41.927802],
        [16.140473, 41.919908],
        [16.192882, 41.790920],
        [15.900076, 41.614651],
        [15.933604, 41.479438],
        [18.007009, 40.650702],
        [18.516124, 40.139228],
        [18.346528, 39.798041],
        [18.071544, 39.911526],
        [17.863129, 40.285631],
        [17.200206, 40.420396],
        [17.323253, 40.498481],
        [16.912120, 40.445217],
        [16.489757, 39.775214],
        [17.158702, 39.406195],
        [17.206391, 39.029486],
        [16.585623, 38.797838],
        [16.569591, 38.429511],
        [16.063162, 37.932685],
        [15.635102, 38.009101],
        [15.632823, 38.220282],
        [15.904796, 38.473944],
        [15.836599, 38.648993],
        [16.221690, 38.856594],
        [15.624278, 40.077786],
        [15.261241, 40.029364],
        [14.911143, 40.241645],
        [14.998267, 40.397559],
        [14.781993, 40.669867],
        [14.342621, 40.570624],
        [14.474132, 40.729682],
        [14.047697, 40.789589],
        [13.721853, 41.252387],
        [13.044607, 41.227525],
        [11.658214, 42.279364],
        [11.106619, 42.391262],
        [11.158458, 42.564032],
        [10.731293, 42.804429],
        [10.763520, 42.918280],
        [10.499522, 42.940497],
        [10.528168, 43.246772],
        [10.180675, 43.955268],
        [8.762380, 44.432115],
        [8.067719, 43.896674],
        [7.151622, 43.654771],
        [6.597243, 43.284007],
        [6.679801, 43.201553],
        [6.180072, 43.035922],
        [5.034022, 43.335476],
        [5.226329, 43.480292],
        [5.029145, 43.558580],
        [4.855778, 43.341779],
        [4.757823, 43.422349],
        [4.742442, 43.524482],
        [4.694591, 43.579088],
        [4.742524, 43.422553],
        [4.820279, 43.346356],
        [3.990896, 43.550849],
        [3.244314, 43.219428],
        [3.038992, 42.942776],
        [3.051850, 42.554877],
        [3.317719, 42.322984],
        [3.118826, 42.218329],
        [3.194916, 41.888292],
        [2.130544, 41.303656],
        [1.017426, 41.051785],
        [0.714203, 40.815212],
        [0.858084, 40.686265],
        [0.563487, 40.590033],
        [-0.323354, 39.516221],
        [-0.158030, 39.002143],
        [0.234548, 38.742255],
        [-0.509836, 38.338365],
        [-0.856109, 37.742499],
        [-0.705312, 37.619534],
        [-1.323735, 37.561991],
        [-1.670888, 37.363308],
        [-2.126698, 36.736396],
        [-2.361684, 36.836778],
        [-2.718251, 36.682034],
        [-4.403188, 36.723863],
        [-4.659250, 36.507636],
        [-5.186554, 36.411200],
        [-5.342030, 36.110500],
        [-5.611765, 36.006456],
        [-6.036773, 36.189521],
        [-6.394683, 36.636908],
        [-6.194814, 36.932115],
        [-6.388010, 36.808173],
        [-6.892893, 37.166571],
        [-6.852691, 37.295233],
        [-7.819569, 36.998725],
        [-8.580149, 37.123969],
        [-8.997874, 37.021470],
        [-8.752187, 37.730780],
        [-8.894846, 37.952541],
        [-8.795071, 38.359227],
        [-8.942616, 38.481391],
        [-8.798573, 38.426093],
        [-8.606801, 38.418687],
        [-8.773346, 38.565334],
        [-9.230621, 38.418687],
        [-9.252675, 38.665484],
        [-9.107737, 38.658881],
        [-8.942616, 38.775580],
        [-9.011545, 38.913398],
        [-8.765126, 39.097724],
        [-8.935862, 39.040717],
        [-9.100250, 38.830227],
        [-9.112503, 38.714182],
        [-9.497467, 38.809760],
        [-9.409291, 39.375190],
        [-9.090434, 39.579275],
        [-8.784983, 40.118720],
        [-8.908437, 40.200670],
        [-8.753000, 40.640815],
        [-8.572662, 40.755561],
        [-8.655263, 40.844916],
        [-8.750803, 40.653144],
        [-8.648346, 41.152777],
        [-8.830511, 41.671586],
        [-8.696156, 41.721991],
        [-8.880306, 41.736862],
        [-8.750803, 41.968980],
        [-8.881256, 41.893297],
        [-8.898590, 42.101752],
        [-8.621653, 42.340806],
        [-8.867502, 42.256415],
        [-8.655263, 42.441352],
        [-8.843577, 42.403713],
        [-8.942616, 42.469306],
        [-8.826527, 42.461859],
        [-8.730946, 42.688422],
        [-9.026357, 42.543118],
        [-8.887685, 42.831122],
        [-9.100250, 42.757514],
        [-9.134511, 42.917548],
        [-9.273061, 42.893337],
        [-9.107737, 43.141140],
        [-9.217600, 43.155341],
        [-8.829986, 43.341213],
        [-8.210194, 43.313218],
        [-8.305165, 43.451077],
        [-8.168568, 43.492011],
        [-8.312652, 43.567125],
        [-7.685536, 43.793443],
        [-7.044586, 43.479193],
        [-5.852203, 43.662950],
        [-4.481679, 43.383612],
        [-3.579416, 43.518256],
        [-3.008168, 43.320909],
        [-2.768625, 43.452501],
        [-1.918691, 43.320990],
        [-1.476877, 43.580064],
        [-1.257232, 44.556057],
        [-1.044749, 44.669420],
        [-1.172231, 44.778266],
        [-1.260365, 44.627427],
        [-1.085276, 45.569037],
        [-0.534657, 44.894965],
        [-0.596181, 45.024644],
        [-0.493764, 44.997992],
        [-0.795481, 45.477118],
        [-1.247304, 45.709906],
        [-0.987172, 45.717353],
        [-1.151723, 45.868150],
        [-1.110748, 46.302680],
        [-1.795400, 46.494534],
        [-2.118764, 46.819973],
        [-1.990712, 47.035386],
        [-2.241119, 47.142483],
        [-2.160553, 47.271186],
        [-1.727040, 47.210761],
        [-2.010121, 47.319729],
        [-2.278391, 47.246405],
        [-2.541982, 47.300116],
        [-2.363922, 47.506171],
        [-2.817128, 47.499213],
        [-2.909250, 47.558417],
        [-2.741444, 47.551337],
        [-2.688629, 47.604397],
        [-2.683990, 47.622992],
        [-2.706532, 47.642727],
        [-2.974680, 47.663804],
        [-3.131703, 47.478217],
        [-3.118031, 47.732123],
        [-3.224192, 47.656399],
        [-3.358266, 47.697333],
        [-3.282623, 47.787340],
        [-3.446441, 47.704576],
        [-4.132192, 47.923896],
        [-4.371816, 47.807196],
        [-4.434641, 47.975653],
        [-4.728139, 48.040595],
        [-4.285390, 48.115383],
        [-4.557485, 48.177191],
        [-4.546702, 48.346829],
        [-4.515533, 48.295844],
        [-4.269358, 48.288398],
        [-4.187489, 48.307522],
        [-4.453725, 48.335395],
        [-4.289906, 48.431586],
        [-4.768381, 48.345404],
        [-4.739898, 48.550727],
        [-3.103749, 48.876654],
        [-3.125478, 48.759955],
        [-3.008168, 48.821438],
        [-2.682362, 48.509019],
        [-2.316070, 48.698554],
        [-1.980295, 48.513577],
        [-1.945627, 48.698554],
        [-1.356557, 48.643256],
        [-1.553619, 48.747138],
        [-1.548411, 49.225491],
        [-1.816477, 49.383734],
        [-1.935211, 49.724107],
        [-1.263051, 49.695502],
        [-1.122874, 49.345445],
        [-0.219472, 49.280097],
        [0.457286, 49.467434],
        [0.076589, 49.534980],
        [0.235850, 49.729315],
        [1.672537, 50.192532],
        [1.541515, 50.277899],
        [1.562673, 50.698961],
        [1.729828, 50.943915],
        [3.525727, 51.415595],
        [4.316417, 51.276842],
        [4.234711, 51.419013],
        [3.447032, 51.545966],
        [3.851085, 51.610785],
        [3.988129, 51.590277],
        [4.176931, 51.685858],
        [3.862315, 51.816067],
        [4.077647, 51.843573],
        [4.015636, 51.987698],
        [4.508149, 52.336371],
        [4.733897, 52.958889],
        [5.078136, 52.954006],
        [5.591563, 53.302802],
        [6.730235, 53.460639],
        [7.194591, 53.245022],
        [7.366547, 53.302802],
        [7.038259, 53.348578],
        [7.100922, 53.597886],
        [7.951427, 53.721910],
        [8.205333, 53.410712],
        [8.270681, 53.612860],
        [8.552094, 53.543606],
        [8.490001, 53.486396],
        [8.504405, 53.358059],
        [8.565766, 53.546698],
        [8.486095, 53.700426],
        [8.651866, 53.892483],
        [9.274669, 53.865139],
        [9.567068, 53.599595],
        [9.832042, 53.543606],
        [9.395193, 53.831000],
        [9.257823, 53.885565],
        [8.984630, 53.897040],
        [8.916026, 53.937405],
        [8.833344, 54.036444],
        [9.018321, 54.097886],
        [8.812836, 54.180487],
        [8.963145, 54.317613],
        [8.602712, 54.312079],
        [9.011567, 54.506334],
        [8.688731, 54.735297],
        [8.681895, 55.133205],
        [8.689464, 55.141588],
        [8.617686, 55.437934],
        [8.095225, 55.549058],
        [8.127778, 55.987616],
        [8.193614, 55.811835],
        [8.393321, 55.909166],
        [8.103363, 56.096869],
        [8.122406, 56.551663],
        [8.213878, 56.711819],
        [8.665538, 56.475898],
        [8.681895, 56.626532],
        [9.063162, 56.812567],
        [9.176036, 56.708564],
        [9.155447, 56.661322],
        [9.326182, 56.530341],
        [9.305675, 56.695461],
        [9.169119, 56.688666],
        [9.242524, 56.747056],
        [9.200206, 56.938910],
        [8.679535, 56.952541],
        [8.408214, 56.688666],
        [8.586274, 56.688666],
        [8.559581, 56.593004],
        [8.245860, 56.704006],
        [8.586274, 57.106391],
        [9.412120, 57.165432],
        [9.966970, 57.591376],
        [10.197602, 57.601223],
        [10.539073, 57.743842],
        [10.648936, 57.737006],
        [10.430431, 57.570543],
        [10.539073, 57.236721],
        [10.347179, 57.010199],
        [9.994640, 57.092719],
        [9.926931, 57.058580],
        [10.313731, 56.982856],
        [10.340587, 56.717353],
        [10.146495, 56.722357],
        [10.334239, 56.703843],
        [10.340343, 56.620347],
        [10.214366, 56.558295],
        [10.183360, 56.469550],
        [10.330333, 56.603217],
        [10.964122, 56.442206],
        [10.738617, 56.154527],
        [10.628591, 56.237535],
        [10.518565, 56.102729],
        [10.354666, 56.202053],
        [10.442638, 56.298651],
        [10.258474, 56.190253],
        [10.182140, 55.833686],
        [10.045746, 55.813951],
        [10.005219, 55.701117],
        [9.559581, 55.715399],
        [9.853770, 55.626654],
        [9.498057, 55.489447],
        [9.660167, 55.477973],
        [9.710297, 55.248684],
        [9.434337, 55.037543],
        [9.763194, 54.900458],
        [9.586762, 54.927720],
        [9.436290, 54.810452],
        [9.947520, 54.779527],
        [10.026866, 54.559963],
        [9.840099, 54.475287],
        [10.143403, 54.491848],
        [10.141775, 54.324408],
        [10.318370, 54.443305],
        [10.731293, 54.310207],
        [11.135509, 54.385891],
        [11.066580, 54.183905],
        [10.752615, 54.050116],
        [10.887380, 53.963935],
        [11.457693, 53.906155],
        [11.689708, 54.155219],
        [12.115001, 54.097886],
        [12.108897, 54.183010],
        [12.533865, 54.488267],
        [12.921153, 54.433498],
        [12.624197, 54.422919],
        [12.527029, 54.372260],
        [12.438487, 54.387519],
        [12.368826, 54.269192],
        [13.034190, 54.433661],
        [13.465099, 54.098456],
        [13.808116, 54.104682],
        [13.746104, 54.036444],
        [13.907563, 53.933539],
        [13.818533, 53.877997],
        [13.817068, 53.852932],
        [14.590587, 53.598375],
        [14.630626, 53.851508],
        [13.840099, 53.850287],
        [14.051280, 54.005072],
        [13.774099, 54.022773],
        [13.814952, 54.101264],
        [13.752940, 54.153144],
        [14.406749, 53.921820],
        [16.179210, 54.263007],
        [16.501313, 54.532416],
        [17.337413, 54.749010],
        [18.152354, 54.838324],
        [18.339529, 54.833482],
        [18.751720, 54.690090],
        [18.835297, 54.603095],
        [18.413097, 54.746527],
        [18.588064, 54.433661],
        [19.002126, 54.344916]
    ],
    [
        [-141.893951, 60.007554],
        [-144.002553, 60.039740],
        [-144.196441, 60.205634],
        [-144.941640, 60.306627],
        [-144.622792, 60.717027],
        [-145.269521, 60.357082],
        [-145.938754, 60.456066],
        [-145.629018, 60.679145],
        [-146.263173, 60.653713],
        [-146.026112, 60.744818],
        [-146.043446, 60.801011],
        [-146.482289, 60.686957],
        [-146.695709, 60.744818],
        [-146.628285, 60.827297],
        [-146.753285, 60.955024],
        [-147.364613, 60.891262],
        [-147.422597, 61.012356],
        [-147.542063, 60.913316],
        [-147.561147, 61.155911],
        [-147.599029, 60.869086],
        [-147.870188, 60.837714],
        [-148.050404, 60.950141],
        [-148.049428, 61.026597],
        [-148.145945, 61.117906],
        [-148.409495, 61.060126],
        [-148.148752, 61.060126],
        [-148.332875, 60.819403],
        [-148.523427, 60.840399],
        [-148.703684, 60.792670],
        [-148.449818, 60.800116],
        [-148.611195, 60.762885],
        [-148.667470, 60.674506],
        [-148.374705, 60.779608],
        [-148.429921, 60.628730],
        [-148.230702, 60.772773],
        [-148.196604, 60.628730],
        [-148.488474, 60.582221],
        [-148.689890, 60.457221],
        [-148.237538, 60.457465],
        [-148.083608, 60.604885],
        [-147.935902, 60.461168],
        [-148.390859, 60.277411],
        [-148.442983, 60.183743],
        [-148.333119, 60.170111],
        [-148.435374, 59.959296],
        [-149.103098, 60.058092],
        [-149.285878, 59.874661],
        [-149.408681, 60.123725],
        [-149.627878, 59.828315],
        [-149.526723, 59.717597],
        [-149.635935, 59.744940],
        [-149.724721, 59.964057],
        [-149.868113, 59.847968],
        [-149.746083, 59.667182],
        [-150.031687, 59.799262],
        [-149.916493, 59.717597],
        [-150.012685, 59.628241],
        [-150.119252, 59.700344],
        [-150.347971, 59.469957],
        [-150.224355, 59.715399],
        [-150.479482, 59.467353],
        [-150.492502, 59.600898],
        [-150.656972, 59.552476],
        [-150.609324, 59.438666],
        [-150.958608, 59.203681],
        [-151.097239, 59.232611],
        [-151.893137, 59.220649],
        [-151.894032, 59.412828],
        [-151.382192, 59.444770],
        [-151.441477, 59.532213],
        [-151.410512, 59.607733],
        [-151.871775, 59.749457],
        [-151.305979, 60.386949],
        [-151.396921, 60.738023],
        [-150.387034, 61.047268],
        [-150.067332, 61.155748],
        [-149.245554, 61.498969],
        [-149.757395, 61.453355],
        [-149.983754, 61.246324],
        [-150.563100, 61.365424],
        [-151.746938, 60.916815],
        [-151.711374, 60.725735],
        [-152.051381, 60.673163],
        [-152.415964, 60.297756],
        [-152.616160, 60.224270],
        [-152.905588, 60.308539],
        [-153.082631, 60.299791],
        [-152.578603, 60.070136],
        [-153.288075, 59.820014],
        [-153.013865, 59.832343],
        [-153.055287, 59.710150],
        [-153.425242, 59.649359],
        [-153.322214, 59.717597],
        [-153.452585, 59.792670],
        [-153.490712, 59.650092],
        [-153.706410, 59.631985],
        [-153.586415, 59.567450],
        [-153.877146, 59.546291],
        [-153.751454, 59.440253],
        [-154.145253, 59.381171],
        [-153.953440, 59.361314],
        [-154.247670, 59.168891],
        [-154.187327, 59.034980],
        [-153.711537, 59.070746],
        [-153.259470, 58.868883],
        [-154.110463, 58.477484],
        [-154.000234, 58.385565],
        [-154.364369, 58.285102],
        [-154.121327, 58.279731],
        [-154.246775, 58.126410],
        [-154.494089, 58.203111],
        [-154.566274, 58.033515],
        [-155.023142, 58.025580],
        [-155.310292, 57.740424],
        [-155.605092, 57.792222],
        [-155.741648, 57.552069],
        [-156.020457, 57.576809],
        [-156.060658, 57.430243],
        [-156.544626, 57.322699],
        [-156.339955, 57.285305],
        [-156.645375, 57.058580],
        [-156.549794, 56.982856],
        [-156.784779, 57.049140],
        [-156.809438, 56.906684],
        [-156.961293, 56.976630],
        [-157.189402, 56.776272],
        [-157.419667, 56.867377],
        [-157.605580, 56.722154],
        [-157.482655, 56.620347],
        [-157.772898, 56.684394],
        [-158.133168, 56.530341],
        [-157.877146, 56.478217],
        [-158.415720, 56.446479],
        [-158.646433, 56.270657],
        [-158.119496, 56.236151],
        [-158.409657, 56.180813],
        [-158.427561, 56.006537],
        [-158.604685, 56.052314],
        [-158.479237, 56.191474],
        [-158.639638, 56.202053],
        [-158.682932, 55.958401],
        [-159.421702, 55.790473],
        [-159.544993, 55.889635],
        [-159.626536, 55.578274],
        [-159.756907, 55.598700],
        [-159.617014, 55.635199],
        [-159.625234, 55.812690],
        [-159.845774, 55.851223],
        [-160.442128, 55.646552],
        [-160.495188, 55.486151],
        [-160.613474, 55.605536],
        [-160.768137, 55.545396],
        [-160.683420, 55.464667],
        [-161.279164, 55.354885],
        [-161.518422, 55.383368],
        [-161.388743, 55.572170],
        [-161.620798, 55.612982],
        [-161.902415, 55.217841],
        [-162.046010, 55.235582],
        [-162.001291, 55.093207],
        [-162.449330, 55.040269],
        [-162.517405, 55.114691],
        [-162.360707, 55.105292],
        [-162.645334, 55.300035],
        [-162.559926, 54.961249],
        [-162.877634, 54.938951],
        [-163.183054, 55.139146],
        [-163.049875, 54.941840],
        [-163.341379, 54.811103],
        [-163.334543, 55.119534],
        [-162.497141, 55.373969],
        [-162.621409, 55.406928],
        [-161.799998, 55.889716],
        [-161.367543, 55.955634],
        [-160.874135, 55.993150],
        [-161.023386, 55.890774],
        [-160.689565, 55.697903],
        [-160.791575, 55.886705],
        [-160.243520, 55.776842],
        [-160.579905, 55.989732],
        [-160.188710, 56.386908],
        [-158.889231, 56.889594],
        [-159.024892, 56.796576],
        [-158.639638, 56.763739],
        [-158.682118, 57.022040],
        [-158.312449, 57.314887],
        [-157.757761, 57.564276],
        [-157.656728, 57.483588],
        [-157.413808, 57.489936],
        [-157.709910, 57.652533],
        [-157.605540, 58.105211],
        [-157.139475, 58.168402],
        [-157.562082, 58.363674],
        [-156.940867, 58.737535],
        [-157.077992, 58.757392],
        [-156.783193, 59.155219],
        [-157.084462, 58.886664],
        [-158.203359, 58.612982],
        [-158.557729, 58.806464],
        [-158.497507, 58.993964],
        [-158.172800, 59.013007],
        [-158.030141, 58.879055],
        [-157.995351, 58.908271],
        [-158.140248, 59.036200],
        [-158.544057, 59.175767],
        [-158.462148, 59.052802],
        [-158.729482, 58.873603],
        [-158.746409, 58.994818],
        [-158.825266, 58.977118],
        [-158.787953, 58.769761],
        [-158.914622, 58.775377],
        [-158.708689, 58.492255],
        [-158.881734, 58.399620],
        [-159.617487, 58.931324],
        [-159.906130, 58.765406],
        [-160.352169, 59.070659],
        [-161.707509, 58.561184],
        [-162.176054, 58.644923],
        [-161.677398, 58.773527],
        [-161.855824, 59.033759],
        [-161.569163, 59.115058],
        [-161.974110, 59.131415],
        [-162.042917, 59.248358],
        [-162.051503, 59.270168],
        [-162.038686, 59.289374],
        [-161.713938, 59.501370],
        [-162.209828, 60.025458],
        [-162.149037, 60.245185],
        [-162.317243, 60.113060],
        [-162.458580, 60.295086],
        [-162.224110, 60.587836],
        [-161.881540, 60.703925],
        [-162.183176, 60.731147],
        [-162.415964, 60.382392],
        [-162.703318, 60.265692],
        [-162.450266, 60.191067],
        [-162.525828, 59.997504],
        [-164.098337, 59.833686],
        [-164.212270, 59.954983],
        [-164.114735, 60.004950],
        [-164.649159, 60.333930],
        [-165.143259, 60.450629],
        [-164.985585, 60.546820],
        [-165.431223, 60.553046],
        [-164.999216, 60.711371],
        [-164.937449, 60.936469],
        [-164.669138, 60.825751],
        [-164.270823, 60.787909],
        [-164.420359, 60.554267],
        [-163.955637, 60.779853],
        [-163.686472, 60.589748],
        [-163.409006, 60.752346],
        [-163.930409, 60.854682],
        [-163.563588, 60.913316],
        [-165.170766, 60.941596],
        [-164.766469, 61.108588],
        [-165.362742, 61.212795],
        [-165.212717, 61.265204],
        [-165.158762, 61.418647],
        [-165.076243, 61.419379],
        [-164.967722, 61.489569],
        [-164.841542, 61.498969],
        [-164.724070, 61.625556],
        [-165.085764, 61.476264],
        [-165.294057, 61.334459],
        [-165.225779, 61.273098],
        [-165.390248, 61.224595],
        [-165.373728, 61.071601],
        [-165.876780, 61.336575],
        [-165.776967, 61.515815],
        [-166.199941, 61.594550],
        [-166.144399, 61.725531],
        [-166.116444, 61.636135],
        [-165.766428, 61.690823],
        [-166.102773, 61.821112],
        [-165.588246, 61.862128],
        [-165.705556, 62.116604],
        [-165.133046, 62.515692],
        [-164.581899, 62.426174],
        [-164.857981, 62.563625],
        [-164.813222, 62.620185],
        [-164.883168, 62.841539],
        [-164.690745, 63.027086],
        [-164.313954, 63.014106],
        [-164.595164, 63.130113],
        [-164.423533, 63.208970],
        [-163.541819, 63.128811],
        [-163.791941, 63.021918],
        [-163.806874, 62.986151],
        [-163.528554, 63.116685],
        [-163.093984, 63.057359],
        [-162.309438, 63.546576],
        [-162.018056, 63.485826],
        [-162.168894, 63.431220],
        [-161.056508, 63.574408],
        [-160.766957, 63.824123],
        [-160.973459, 64.250474],
        [-161.188832, 64.418118],
        [-161.538889, 64.397650],
        [-161.413930, 64.537543],
        [-161.035024, 64.507758],
        [-160.791575, 64.725898],
        [-161.155344, 64.925198],
        [-161.085764, 64.912991],
        [-160.990834, 64.939439],
        [-161.020131, 64.947211],
        [-161.210561, 64.932603],
        [-161.545766, 64.750881],
        [-161.733591, 64.820746],
        [-161.806386, 64.822740],
        [-162.781321, 64.343695],
        [-163.148997, 64.658271],
        [-163.389760, 64.596869],
        [-163.039744, 64.521145],
        [-163.165883, 64.410590],
        [-163.678538, 64.586330],
        [-165.035512, 64.448310],
        [-166.189687, 64.585191],
        [-166.483469, 64.729641],
        [-166.390207, 64.898505],
        [-166.684529, 64.982180],
        [-166.957387, 65.178127],
        [-166.031188, 65.243104],
        [-167.398555, 65.401082],
        [-168.137441, 65.665025],
        [-167.531239, 65.726142],
        [-166.310902, 66.175360],
        [-165.500111, 66.152289],
        [-165.889963, 66.241034],
        [-164.274363, 66.602281],
        [-163.736318, 66.603461],
        [-163.628733, 66.570014],
        [-163.930124, 66.585761],
        [-163.762400, 66.525824],
        [-163.854685, 66.289455],
        [-164.191111, 66.193305],
        [-163.680491, 66.078599],
        [-161.858225, 65.977281],
        [-161.505930, 66.278876],
        [-161.017527, 66.193305],
        [-161.510691, 66.407660],
        [-161.896311, 66.270453],
        [-161.888376, 66.524400],
        [-162.625315, 66.861477],
        [-162.484812, 66.960395],
        [-161.633778, 66.457994],
        [-160.228505, 66.412055],
        [-160.274973, 66.654608],
        [-161.495432, 66.536689],
        [-161.901967, 66.735093],
        [-161.525217, 66.991441],
        [-162.456899, 66.994574],
        [-162.337839, 67.145087],
        [-162.360097, 67.167426],
        [-162.580434, 67.015041],
        [-163.724965, 67.111274],
        [-164.151479, 67.619615],
        [-166.829050, 68.351386],
        [-166.315134, 68.405992],
        [-166.222605, 68.885810],
        [-164.346425, 68.929389],
        [-163.622548, 69.119208],
        [-163.125803, 69.389960],
        [-163.018748, 69.745836],
        [-161.905710, 70.320624],
        [-161.703359, 70.263739],
        [-160.949900, 70.290432],
        [-160.201894, 70.476630],
        [-159.921986, 70.489651],
        [-160.133656, 70.325141],
        [-159.948476, 70.370429],
        [-159.771189, 70.195461],
        [-159.825795, 70.497056],
        [-159.709706, 70.469794],
        [-159.291371, 70.538072],
        [-160.127431, 70.626207],
        [-159.668162, 70.804999],
        [-159.161000, 70.886908],
        [-159.449045, 70.777045],
        [-159.222483, 70.688910],
        [-159.060414, 70.816555],
        [-157.864939, 70.866441],
        [-156.471506, 71.412502],
        [-156.371653, 71.380316],
        [-156.604441, 71.353664],
        [-155.573435, 71.150377],
        [-156.187327, 70.921698],
        [-155.981272, 70.894355],
        [-155.978098, 70.759670],
        [-155.191721, 70.995063],
        [-155.289174, 71.086127],
        [-155.089670, 71.154934],
        [-155.097401, 71.017279],
        [-154.971669, 71.120063],
        [-154.600168, 71.012885],
        [-154.810007, 70.880683],
        [-154.230336, 70.778388],
        [-153.255686, 70.932766],
        [-152.327504, 70.856879],
        [-152.219228, 70.812445],
        [-152.509145, 70.663886],
        [-152.075266, 70.579047],
        [-151.760365, 70.566718],
        [-151.979685, 70.448717],
        [-151.222279, 70.375718],
        [-149.488515, 70.523017],
        [-147.679596, 70.212226],
        [-145.880198, 70.174954],
        [-145.274892, 69.993069],
        [-143.235666, 70.118232],
        [-141.412913, 69.650377],
        [-139.143788, 69.513658],
        [-137.869456, 69.091864]
    ],
    [
        [-125.948883, 71.963202],
        [-125.996938, 71.977037],
        [-125.988433, 71.970404],
        [-125.948883, 71.963202]
    ],
    [
        [-110.507069, 72.593817],
        [-110.527577, 72.600491],
        [-110.595855, 72.600653],
        [-110.472320, 72.573310],
        [-110.507069, 72.593817]
    ],
    [
        [-110.397206, 72.620510],
        [-110.469228, 72.625393],
        [-110.493479, 72.620510],
        [-110.397206, 72.620510]
    ],
    [
        [-110.314687, 72.655219],
        [-110.364247, 72.652777],
        [-110.410878, 72.642239],
        [-110.279897, 72.648424],
        [-110.314687, 72.655219]
    ],
    [
        [-100.872182, 69.807807],
        [-101.022288, 70.186225],
        [-101.529449, 70.112860],
        [-101.594960, 70.277330],
        [-102.192209, 70.333441],
        [-103.086903, 70.677476],
        [-102.927846, 70.499091],
        [-103.571848, 70.605536],
        [-104.591176, 71.073188],
        [-104.486969, 71.347602],
        [-104.281321, 71.350246],
        [-104.365346, 71.577216],
        [-105.024566, 72.072984],
        [-104.966298, 72.193549],
        [-105.510569, 72.778754],
        [-105.367177, 72.792426],
        [-106.873443, 73.315579],
        [-107.073232, 73.178046],
        [-108.087636, 73.354153],
        [-107.867909, 73.189643],
        [-108.298329, 73.133775],
        [-107.875356, 72.573310],
        [-107.985219, 72.518052],
        [-107.786000, 72.463446],
        [-107.779164, 72.141303],
        [-107.251576, 71.901679],
        [-107.834381, 71.709906],
        [-107.740956, 71.618150],
        [-108.245961, 71.722968],
        [-108.191518, 71.962958],
        [-108.540151, 72.148749],
        [-108.633412, 72.565579],
        [-109.047231, 72.573310],
        [-108.946034, 72.673774],
        [-109.752349, 72.881171],
        [-109.622629, 72.915961],
        [-110.735707, 73.001370],
        [-110.254506, 72.738959],
        [-110.294260, 72.675727],
        [-109.780263, 72.436184],
        [-110.704091, 72.578803],
        [-111.086293, 72.408271],
        [-111.027903, 72.285305],
        [-111.376698, 72.354193],
        [-111.295237, 72.470689],
        [-111.753326, 72.207099],
        [-111.658803, 72.359524],
        [-111.887522, 72.367743],
        [-111.289296, 72.565985],
        [-111.219635, 72.724107],
        [-113.015004, 73.016018],
        [-113.390940, 72.911566],
        [-113.603993, 72.777533],
        [-113.439809, 72.685248],
        [-113.659576, 72.613105],
        [-113.508778, 72.703030],
        [-114.546132, 72.567816],
        [-113.981068, 72.809149],
        [-113.958363, 73.140123],
        [-114.584299, 73.384589],
        [-117.369252, 72.917792],
        [-118.189809, 72.635443],
        [-118.593414, 72.428697],
        [-118.127838, 72.227240],
        [-118.678212, 72.142279],
        [-119.137603, 71.774359],
        [-118.888580, 71.582953],
        [-117.969309, 71.621731],
        [-117.672109, 71.558743],
        [-118.308258, 71.469916],
        [-118.161977, 71.378974],
        [-117.551340, 71.374172],
        [-117.564931, 71.503852],
        [-117.390248, 71.387152],
        [-115.823598, 71.548163],
        [-115.056752, 71.524970],
        [-118.421498, 70.990546],
        [-117.585439, 70.606350],
        [-113.988393, 70.716213],
        [-111.486562, 70.331977],
        [-112.586252, 70.200019],
        [-114.509429, 70.315253],
        [-117.442047, 69.989407],
        [-117.235992, 69.756008],
        [-116.596099, 69.563951],
        [-116.632680, 69.461819],
        [-115.974843, 69.300198],
        [-113.693105, 69.194892],
        [-113.549713, 69.044094],
        [-113.668121, 68.815375],
        [-113.039133, 68.494940],
        [-109.028554, 68.726752],
        [-108.539459, 68.946967],
        [-107.334828, 69.025580],
        [-106.583892, 69.503607],
        [-106.317535, 69.401313],
        [-106.412099, 69.188056],
        [-104.918446, 69.075141],
        [-105.277821, 68.954739],
        [-105.123036, 68.896430],
        [-102.965891, 68.798651],
        [-101.846791, 68.988349],
        [-101.756012, 69.160142],
        [-102.221547, 69.229071],
        [-101.939076, 69.420640],
        [-102.282582, 69.503648],
        [-102.842926, 69.384711],
        [-103.198069, 69.120307],
        [-103.016672, 69.482245],
        [-103.489613, 69.694525],
        [-102.783844, 69.536851],
        [-102.509592, 69.564195],
        [-102.672597, 69.769436],
        [-102.335927, 69.767035],
        [-102.224965, 69.920478],
        [-101.673451, 69.646715],
        [-101.457387, 69.906155],
        [-101.294789, 69.670478],
        [-100.964345, 69.664455],
        [-100.872182, 69.807807]
    ],
    [
        [71.353363, 73.385199],
        [71.249522, 73.417873],
        [71.137462, 73.292670],
        [71.342540, 73.331366],
        [71.353363, 73.385199]
    ],
    [
        [51.409516, 71.806138],
        [51.610037, 72.091702],
        [52.368419, 72.075344],
        [52.416515, 72.289293],
        [52.868175, 72.346747],
        [52.680024, 72.478746],
        [53.102061, 72.600653],
        [53.218110, 72.648424],
        [52.375255, 72.730373],
        [53.382009, 72.888617],
        [53.141938, 72.962470],
        [53.382009, 73.011542],
        [53.121918, 73.100898],
        [53.322520, 73.220852],
        [54.934825, 73.425360],
        [56.435232, 73.230129],
        [56.582042, 73.129584],
        [56.466156, 73.052476],
        [56.377208, 73.006659],
        [56.251801, 72.972357],
        [56.219900, 72.826565],
        [55.480724, 72.805813],
        [55.946056, 72.668891],
        [55.616466, 72.696845],
        [55.723481, 72.638332],
        [55.618175, 72.542182],
        [55.267100, 72.586982],
        [55.536143, 72.472480],
        [55.465668, 72.436184],
        [55.376964, 72.302680],
        [55.574962, 72.199652],
        [55.225434, 71.929023],
        [55.506358, 71.898017],
        [56.105724, 71.258979],
        [57.638682, 70.729885],
        [57.432628, 70.743557],
        [57.539317, 70.704779],
        [57.452485, 70.606350],
        [57.295746, 70.564683],
        [56.654552, 70.589993],
        [56.514008, 70.544867],
        [55.404796, 70.750393],
        [55.472504, 70.654120],
        [55.162608, 70.553127],
        [54.513438, 70.825426],
        [54.767426, 70.647935],
        [53.539724, 70.804999],
        [53.300141, 70.866400],
        [53.704763, 70.845933],
        [53.501720, 71.094428],
        [54.243988, 71.122870],
        [53.450938, 71.264309],
        [53.413341, 71.311754],
        [53.251720, 71.456041],
        [52.882335, 71.393988],
        [52.547211, 71.634833],
        [52.416270, 71.476549],
        [52.268809, 71.587958],
        [52.141856, 71.545478],
        [52.279063, 71.476549],
        [51.840343, 71.456041],
        [51.532400, 71.565904],
        [51.409516, 71.806138]
    ],
    [
        [127.404796, 73.518622],
        [127.775076, 73.492580],
        [127.690929, 73.542873],
        [127.404796, 73.518622]
    ],
    [
        [86.892345, 73.696723],
        [86.509613, 73.641832],
        [86.398936, 73.594387],
        [86.783946, 73.608222],
        [86.892345, 73.696723]
    ],
    [
        [-72.948964, 66.734565],
        [-72.803456, 67.042955],
        [-72.193349, 67.275702],
        [-72.662953, 67.684801],
        [-72.608225, 67.786282],
        [-72.944040, 67.932278],
        [-72.994618, 68.235907],
        [-73.494944, 68.276923],
        [-73.213735, 68.379299],
        [-73.279124, 68.399726],
        [-73.619089, 68.249579],
        [-73.844431, 68.349595],
        [-73.947377, 68.413479],
        [-73.738637, 68.519232],
        [-73.755605, 68.687201],
        [-74.187571, 68.729397],
        [-73.885203, 68.554877],
        [-74.220041, 68.515815],
        [-74.720774, 68.735541],
        [-74.574452, 68.841864],
        [-74.684804, 68.879828],
        [-75.044138, 68.906928],
        [-74.640085, 69.023627],
        [-74.809071, 69.083319],
        [-75.116038, 68.892971],
        [-75.486399, 69.022040],
        [-76.624989, 68.682359],
        [-76.638132, 69.015937],
        [-75.989858, 69.010891],
        [-75.620961, 69.087958],
        [-75.595570, 69.229071],
        [-76.629587, 69.545966],
        [-76.181874, 69.667873],
        [-76.794789, 69.722480],
        [-76.901235, 69.777086],
        [-76.776723, 69.836086],
        [-77.312815, 69.841986],
        [-77.634267, 69.824897],
        [-77.442454, 69.790758],
        [-77.614369, 69.742987],
        [-77.682688, 69.824897],
        [-77.703928, 70.201239],
        [-78.408274, 70.215888],
        [-78.539255, 70.312161],
        [-78.388417, 70.338813],
        [-79.100942, 70.503323],
        [-78.717356, 70.551703],
        [-78.839915, 70.635688],
        [-79.591257, 70.411322],
        [-78.925364, 70.302069],
        [-78.665110, 70.013821],
        [-78.799916, 69.879543],
        [-79.680857, 69.848578],
        [-79.906077, 69.983100],
        [-81.762441, 70.122870],
        [-80.770334, 69.782294],
        [-80.951243, 69.715033],
        [-81.567576, 69.969550],
        [-81.711537, 69.934760],
        [-82.138376, 69.785956],
        [-83.051625, 70.010484],
        [-84.694773, 70.006578],
        [-84.811716, 70.118720],
        [-85.234609, 69.996243],
        [-85.782908, 69.995185],
        [-86.549875, 70.236477],
        [-86.590810, 70.366767],
        [-86.296986, 70.477444],
        [-86.370920, 70.526597],
        [-86.663767, 70.380113],
        [-86.639231, 70.325141],
        [-86.974599, 70.472724],
        [-87.248728, 70.394110],
        [-86.974436, 70.290432],
        [-87.852528, 70.237982],
        [-88.907216, 70.544867],
        [-89.449086, 70.908026],
        [-89.188425, 70.962592],
        [-89.557729, 71.092963],
        [-87.002309, 70.996772],
        [-87.864125, 71.274848],
        [-89.853139, 71.339342],
        [-90.044911, 71.596666],
        [-89.797922, 71.764594],
        [-90.118601, 71.928860],
        [-89.578196, 72.162421],
        [-89.900950, 72.189765],
        [-89.912953, 72.425971],
        [-89.468332, 72.668891],
        [-89.578196, 72.792426],
        [-89.276560, 72.758246],
        [-89.413645, 72.830878],
        [-89.360666, 72.980170],
        [-88.886708, 73.216986],
        [-89.051218, 73.251695],
        [-88.619211, 73.285834],
        [-88.859446, 73.333686],
        [-88.687489, 73.423041],
        [-87.134104, 73.802720],
        [-85.105702, 73.811998],
        [-84.836741, 73.745185],
        [-86.030344, 73.302436],
        [-86.737538, 72.730943],
        [-86.242014, 72.422512],
        [-86.432485, 72.276842],
        [-86.408193, 72.005805],
        [-84.837636, 71.286566],
        [-85.193186, 71.299302],
        [-84.972605, 71.196194],
        [-84.877675, 71.072455],
        [-84.982289, 71.107815],
        [-85.145212, 71.086127],
        [-84.799184, 70.927883],
        [-84.797109, 71.184882],
        [-84.664784, 71.223334],
        [-84.761342, 71.407660],
        [-84.528269, 71.473131],
        [-84.622385, 71.665839],
        [-85.257883, 71.668362],
        [-85.583445, 71.791815],
        [-85.437815, 71.814765],
        [-85.555531, 71.901679],
        [-86.021352, 71.984117],
        [-86.050649, 72.014553],
        [-85.497751, 72.079901],
        [-85.476430, 72.266262],
        [-84.939158, 72.292141],
        [-84.432078, 72.381537],
        [-85.514516, 72.463446],
        [-85.618235, 72.545356],
        [-85.473582, 72.579535],
        [-85.706370, 72.638495],
        [-85.682078, 72.893622],
        [-85.535634, 73.025784],
        [-85.463572, 73.111884],
        [-85.192983, 73.231269],
        [-84.797231, 73.390937],
        [-84.658030, 73.395087],
        [-84.182200, 73.477688],
        [-83.605173, 73.301500],
        [-83.665232, 73.456122],
        [-84.007517, 73.504950],
        [-82.831125, 73.736721],
        [-81.528391, 73.716213],
        [-81.229075, 73.539700],
        [-81.187571, 73.264553],
        [-80.619700, 73.160102],
        [-80.640330, 72.927924],
        [-80.245473, 72.737779],
        [-80.506215, 72.497626],
        [-80.971750, 72.203355],
        [-80.566884, 72.082261],
        [-81.026316, 72.093492],
        [-80.800404, 72.017768],
        [-80.985341, 71.888088],
        [-80.396677, 72.050116],
        [-80.482859, 72.180732],
        [-80.245229, 72.299872],
        [-80.005320, 72.182847],
        [-79.676381, 72.127631],
        [-80.169789, 72.326321],
        [-79.818837, 72.506415],
        [-79.593821, 72.340522],
        [-79.768015, 72.222357],
        [-79.450388, 72.195950],
        [-79.545969, 72.292141],
        [-79.331614, 72.402289],
        [-78.957224, 72.283108],
        [-79.230662, 71.976264],
        [-78.504465, 71.874457],
        [-78.914418, 72.014146],
        [-78.830434, 72.172675],
        [-78.875071, 72.230658],
        [-78.604319, 72.357815],
        [-78.427561, 72.179429],
        [-78.408803, 72.329047],
        [-77.691355, 72.216620],
        [-77.660959, 72.100328],
        [-76.997426, 72.134467],
        [-78.554758, 72.444810],
        [-78.427439, 72.593736],
        [-77.601023, 72.755805],
        [-76.783518, 72.729478],
        [-76.102976, 72.479682],
        [-75.939890, 72.592231],
        [-75.198354, 72.497626],
        [-74.941721, 72.257392],
        [-76.028757, 72.088690],
        [-76.414622, 71.860785],
        [-75.657704, 72.124335],
        [-75.222279, 72.069281],
        [-75.585398, 72.004096],
        [-76.099924, 71.696275],
        [-75.866444, 71.707953],
        [-75.063181, 72.128241],
        [-74.242258, 72.079901],
        [-74.118031, 71.967231],
        [-74.214955, 71.837144],
        [-75.351796, 71.700141],
        [-74.939768, 71.661689],
        [-74.649403, 71.678860],
        [-74.732249, 71.582994],
        [-75.019602, 71.542711],
        [-75.153391, 71.469713],
        [-74.843699, 71.523261],
        [-74.928090, 71.456041],
        [-74.704661, 71.394924],
        [-74.630971, 71.390204],
        [-74.742502, 71.514106],
        [-74.522654, 71.662584],
        [-74.108347, 71.737860],
        [-74.249460, 71.608791],
        [-74.145985, 71.538642],
        [-74.216786, 71.620917],
        [-73.996042, 71.754218],
        [-73.620961, 71.772528],
        [-73.996165, 71.461819],
        [-74.102366, 71.466010],
        [-74.029978, 71.442369],
        [-73.866160, 71.535346],
        [-73.563791, 71.558498],
        [-73.638905, 71.360500],
        [-73.378855, 71.387152],
        [-73.440907, 71.346829],
        [-73.049875, 71.270453],
        [-73.276438, 71.223334],
        [-73.454579, 71.031562],
        [-73.378855, 70.983100],
        [-72.549428, 71.665107],
        [-71.544301, 71.505113],
        [-71.117055, 71.270453],
        [-71.470530, 71.065660],
        [-72.045115, 71.084784],
        [-72.776112, 70.818020],
        [-72.165354, 70.839748],
        [-72.570668, 70.613186],
        [-70.621449, 71.069322],
        [-70.521189, 70.914252],
        [-70.805531, 70.724351],
        [-71.576365, 70.613186],
        [-71.967356, 70.421373],
        [-71.729848, 70.425482],
        [-71.823720, 70.293687],
        [-71.514882, 70.579047],
        [-71.168894, 70.535102],
        [-70.985341, 70.633694],
        [-69.914988, 70.879869],
        [-69.774485, 70.856187],
        [-70.448679, 70.635199],
        [-70.494496, 70.482856],
        [-69.473459, 70.791327],
        [-68.362253, 70.584296],
        [-68.280507, 70.517646],
        [-68.458608, 70.372992],
        [-68.591298, 70.466986],
        [-68.720041, 70.322333],
        [-69.808339, 70.166693],
        [-70.179921, 70.020453],
        [-70.144399, 69.969550],
        [-70.472768, 69.845404],
        [-69.758494, 69.972886],
        [-69.683176, 70.139594],
        [-68.643625, 70.147040],
        [-69.408193, 69.829250],
        [-69.788157, 69.832343],
        [-69.991160, 69.677436],
        [-69.982045, 69.617825],
        [-69.746897, 69.804389],
        [-69.390614, 69.783881],
        [-68.649159, 69.942857],
        [-68.191111, 70.126614],
        [-68.348744, 70.188666],
        [-68.156972, 70.318345],
        [-67.808542, 70.263739],
        [-67.225331, 69.948391],
        [-67.115468, 69.728664],
        [-68.013051, 69.776068],
        [-68.349192, 69.633124],
        [-68.587473, 69.591010],
        [-66.788035, 69.340033],
        [-66.649363, 69.222154],
        [-66.742258, 69.136868],
        [-67.678049, 69.177191],
        [-68.197947, 69.310981],
        [-69.013539, 69.359361],
        [-69.260569, 69.276801],
        [-68.964060, 69.223456],
        [-68.507029, 69.201117],
        [-69.069895, 69.113715],
        [-68.924753, 69.105536],
        [-69.018259, 68.968411],
        [-68.373362, 69.179592],
        [-67.704457, 69.023627],
        [-68.551218, 68.984076],
        [-68.492787, 68.899482],
        [-68.619578, 68.786200],
        [-69.302073, 68.882758],
        [-69.397776, 68.858466],
        [-68.047719, 68.687201],
        [-68.105662, 68.630194],
        [-68.643992, 68.665351],
        [-68.904286, 68.605211],
        [-67.933420, 68.560045],
        [-67.958363, 68.399807],
        [-67.664133, 68.564683],
        [-67.492258, 68.530097],
        [-67.629994, 68.493109],
        [-67.606272, 68.384101],
        [-67.548573, 68.492255],
        [-67.403147, 68.396959],
        [-67.793894, 68.337714],
        [-67.876169, 68.283393],
        [-67.032541, 68.326646],
        [-66.788157, 68.249416],
        [-66.971425, 68.036689],
        [-66.693186, 68.145453],
        [-66.738718, 67.988959],
        [-66.581410, 68.148383],
        [-66.313547, 68.129136],
        [-66.478017, 68.077623],
        [-66.183176, 68.016181],
        [-66.327830, 67.975287],
        [-66.413645, 67.869127],
        [-66.745554, 67.879096],
        [-66.388661, 67.781480],
        [-65.928171, 68.164781],
        [-66.011790, 67.636623],
        [-65.809641, 67.974921],
        [-65.451894, 67.998603],
        [-65.614451, 67.789455],
        [-65.549509, 67.793036],
        [-65.419423, 67.913764],
        [-65.066599, 67.934272],
        [-64.943064, 67.913764],
        [-65.108754, 67.866645],
        [-65.011952, 67.793036],
        [-65.164052, 67.735541],
        [-65.194814, 67.643744],
        [-64.503489, 67.806545],
        [-64.367624, 67.758938],
        [-64.312449, 67.735053],
        [-64.041982, 67.536526],
        [-64.443430, 67.481147],
        [-63.997141, 67.453843],
        [-63.908396, 67.306830],
        [-64.230540, 67.296210],
        [-64.819529, 67.206855],
        [-64.772694, 67.198310],
        [-64.609120, 67.140286],
        [-64.700388, 67.008857],
        [-63.449086, 67.227973],
        [-63.768056, 67.025946],
        [-63.800404, 66.992987],
        [-63.771189, 66.960395],
        [-63.163645, 67.337551],
        [-62.976918, 67.221869],
        [-63.280832, 67.110826],
        [-63.236765, 66.974066],
        [-63.550649, 66.906806],
        [-63.614573, 66.829820],
        [-63.528025, 66.818183],
        [-63.442454, 66.910834],
        [-63.428456, 66.707831],
        [-63.349070, 66.890692],
        [-62.865305, 66.969143],
        [-62.901601, 66.638251],
        [-62.747060, 66.943061],
        [-62.311350, 66.727688],
        [-62.425038, 66.928209],
        [-62.090037, 67.059760],
        [-62.105906, 66.919420],
        [-61.753611, 66.951239],
        [-62.008290, 66.880072],
        [-61.605580, 66.871649],
        [-61.729726, 66.830715],
        [-61.267527, 66.631578],
        [-61.438222, 66.546536],
        [-61.999257, 66.698879],
        [-62.188425, 66.632066],
        [-61.821523, 66.628648],
        [-61.582021, 66.477851],
        [-61.989817, 66.412340],
        [-61.462229, 66.371405],
        [-61.564646, 66.344062],
        [-62.626658, 66.440253],
        [-62.318796, 66.303127],
        [-62.664255, 66.219631],
        [-62.699045, 66.198147],
        [-62.105906, 66.144843],
        [-61.954213, 66.019761],
        [-62.318796, 65.980943],
        [-62.923655, 66.151190],
        [-63.065500, 66.124335],
        [-62.291493, 65.822699],
        [-62.870798, 65.908149],
        [-62.571767, 65.762600],
        [-62.846384, 65.768704],
        [-62.598012, 65.674872],
        [-62.657175, 65.588772],
        [-62.932118, 65.760565],
        [-62.959665, 65.589993],
        [-63.196156, 65.633734],
        [-63.510081, 65.936510],
        [-63.346669, 65.672512],
        [-63.366567, 65.633490],
        [-63.620351, 65.548977],
        [-63.291371, 65.432318],
        [-63.387644, 65.398139],
        [-63.524159, 65.385077],
        [-63.313303, 65.209784],
        [-63.517934, 65.192694],
        [-63.339833, 65.144924],
        [-63.535024, 64.898505],
        [-63.825795, 64.986640],
        [-63.655100, 65.041897],
        [-63.870961, 65.044501],
        [-63.809071, 65.185858],
        [-64.278269, 65.103949],
        [-64.079050, 65.200141],
        [-64.374338, 65.179267],
        [-64.237375, 65.432318],
        [-64.557118, 65.093207],
        [-64.908925, 65.302558],
        [-64.682362, 65.343492],
        [-64.458485, 65.421088],
        [-64.408640, 65.480699],
        [-65.010203, 65.369371],
        [-65.169626, 65.487494],
        [-64.929392, 65.528510],
        [-64.710317, 65.658840],
        [-64.792226, 65.727729],
        [-65.505360, 65.755072],
        [-65.335805, 65.921332],
        [-64.737620, 65.974189],
        [-64.854319, 66.035590],
        [-64.717234, 66.224555],
        [-64.710317, 66.282620],
        [-64.963572, 66.075914],
        [-65.899403, 65.953681],
        [-65.960398, 66.052680],
        [-65.639150, 66.172756],
        [-65.477488, 66.391832],
        [-66.011912, 66.117499],
        [-66.257314, 66.223578],
        [-66.149648, 66.289455],
        [-66.520823, 66.218695],
        [-66.574208, 66.371405],
        [-66.443227, 66.414252],
        [-66.765981, 66.385077],
        [-66.677235, 66.460150],
        [-66.861562, 66.542711],
        [-66.725046, 66.591132],
        [-67.060251, 66.645738],
        [-66.882680, 66.570014],
        [-67.286244, 66.526190],
        [-67.155629, 66.368476],
        [-67.410268, 66.432807],
        [-67.145985, 66.302802],
        [-67.398915, 66.296454],
        [-67.629384, 66.446479],
        [-67.992502, 66.508531],
        [-67.752919, 66.254706],
        [-67.163279, 66.042426],
        [-67.314158, 66.001451],
        [-67.187123, 65.916164],
        [-67.922800, 65.903225],
        [-67.972646, 66.083441],
        [-68.513539, 66.303127],
        [-68.849680, 66.193305],
        [-68.027292, 66.075914],
        [-68.347890, 66.039781],
        [-68.082265, 65.832831],
        [-68.205393, 65.796047],
        [-67.814320, 65.815863],
        [-68.033437, 65.487494],
        [-67.273142, 65.645209],
        [-67.458689, 65.501166],
        [-67.059885, 65.424058],
        [-67.417104, 65.351020],
        [-66.937327, 65.241156],
        [-67.108632, 65.062323],
        [-66.725046, 65.185858],
        [-66.916819, 65.049302],
        [-66.759226, 65.069159],
        [-66.705190, 64.768785],
        [-66.682200, 65.044176],
        [-66.149648, 64.870551],
        [-66.341501, 64.774359],
        [-66.217966, 64.692450],
        [-66.018666, 64.857571],
        [-66.041371, 64.719428],
        [-65.807362, 64.637437],
        [-65.952138, 64.884508],
        [-65.716786, 64.844224],
        [-65.710276, 64.692450],
        [-65.560007, 64.712877],
        [-65.706858, 64.490058],
        [-65.073435, 64.449123],
        [-65.227040, 64.300523],
        [-65.525868, 64.329332],
        [-65.656199, 64.301418],
        [-65.052927, 64.068671],
        [-65.193105, 64.021918],
        [-64.666127, 64.032620],
        [-64.991444, 63.828437],
        [-64.522328, 63.669094],
        [-64.507558, 63.422065],
        [-64.635203, 63.418158],
        [-64.536814, 63.255194],
        [-64.717112, 63.280992],
        [-64.942698, 63.632717],
        [-64.987498, 63.603095],
        [-65.149119, 63.431220],
        [-64.902089, 63.239407],
        [-65.149119, 63.287787],
        [-64.627756, 62.911078],
        [-65.272043, 63.006659],
        [-64.929392, 62.643541],
        [-65.169626, 62.568427],
        [-65.354563, 62.684516],
        [-65.327260, 62.917873],
        [-65.603831, 62.825141],
        [-65.712229, 63.051215],
        [-65.788157, 62.873196],
        [-65.963490, 62.937486],
        [-65.834340, 63.033352],
        [-66.283152, 63.136949],
        [-66.103871, 62.951606],
        [-66.396718, 62.999823],
        [-66.643666, 63.374579],
        [-66.738718, 63.294013],
        [-66.550404, 62.996283],
        [-66.806956, 63.274807],
        [-66.834299, 63.150702],
        [-67.019887, 63.239407],
        [-66.973988, 63.395901],
        [-67.201121, 63.288479],
        [-67.924184, 63.767564],
        [-67.697703, 63.369696],
        [-68.288930, 63.699123],
        [-68.993031, 63.760728],
        [-67.985666, 63.075507],
        [-67.611318, 63.097113],
        [-67.800730, 63.014106],
        [-67.773386, 62.958808],
        [-67.536936, 63.044989],
        [-67.676584, 62.928697],
        [-67.423818, 62.979438],
        [-66.910024, 62.698188],
        [-67.006215, 62.657172],
        [-66.759714, 62.683905],
        [-66.512156, 62.423814],
        [-66.352406, 62.447455],
        [-66.473866, 62.336656],
        [-65.987131, 62.242092],
        [-66.040028, 62.075263],
        [-66.178700, 62.134670],
        [-66.204294, 62.116604],
        [-65.948842, 61.908759],
        [-66.063100, 61.874945],
        [-68.553660, 62.249742],
        [-69.586781, 62.657701],
        [-69.390248, 62.767035],
        [-70.240305, 62.754096],
        [-71.158030, 62.993598],
        [-70.822825, 63.130113],
        [-70.926462, 63.172553],
        [-71.402048, 63.055569],
        [-71.713490, 63.177924],
        [-71.780873, 63.414496],
        [-72.015207, 63.397650],
        [-72.142323, 63.448310],
        [-71.614451, 63.426907],
        [-71.226918, 63.602484],
        [-71.561879, 63.581488],
        [-71.535390, 63.712348],
        [-71.922841, 63.819648],
        [-72.008372, 63.753974],
        [-71.844472, 63.760728],
        [-71.929799, 63.655015],
        [-72.200632, 63.780422],
        [-72.090321, 63.910956],
        [-72.241770, 63.959418],
        [-72.378245, 63.782538],
        [-72.666249, 63.856391],
        [-72.591176, 64.027655],
        [-72.663197, 64.083930],
        [-72.734242, 63.969875],
        [-73.104482, 64.281480],
        [-73.386301, 64.281480],
        [-73.265574, 64.370307],
        [-73.481882, 64.405097],
        [-73.167185, 64.590033],
        [-73.303090, 64.665717],
        [-73.313954, 64.538153],
        [-73.464223, 64.508002],
        [-73.646352, 64.665717],
        [-73.751902, 64.541571],
        [-73.921702, 64.609280],
        [-73.782908, 64.480170],
        [-74.077748, 64.329332],
        [-74.126169, 64.541571],
        [-74.167104, 64.569525],
        [-74.002634, 64.582587],
        [-74.049794, 64.725898],
        [-74.394480, 64.576850],
        [-74.708363, 64.740220],
        [-74.486643, 64.836656],
        [-74.646311, 64.904731],
        [-74.731435, 64.772162],
        [-74.988881, 64.802314],
        [-74.468739, 64.562079],
        [-74.681020, 64.377753],
        [-75.820017, 64.622219],
        [-75.633168, 64.459662],
        [-75.921824, 64.487006],
        [-75.736033, 64.372463],
        [-76.710927, 64.305365],
        [-76.688954, 64.191555],
        [-77.853993, 64.370307],
        [-78.299021, 64.706732],
        [-78.073110, 64.815904],
        [-78.120595, 64.974189],
        [-77.312815, 65.200141],
        [-77.514150, 65.326117],
        [-77.291697, 65.381415],
        [-77.391591, 65.473090],
        [-75.797922, 65.232327],
        [-75.418650, 65.030463],
        [-75.667917, 64.945624],
        [-75.537587, 64.781195],
        [-75.296986, 64.734076],
        [-75.345815, 64.925198],
        [-75.262563, 64.957017],
        [-75.198720, 65.105699],
        [-75.363149, 65.007636],
        [-75.949086, 65.322455],
        [-75.193186, 65.256293],
        [-75.105051, 65.396145],
        [-74.551218, 65.333401],
        [-74.118357, 65.537095],
        [-73.474436, 65.459621],
        [-73.717844, 65.774604],
        [-74.472157, 66.148586],
        [-72.948964, 66.734565]
    ],
    [
        [-115.323638, 73.508694],
        [-117.416493, 74.232489],
        [-118.725413, 74.220771],
        [-119.189320, 73.992174],
        [-119.144358, 74.209052],
        [-119.479888, 74.226142],
        [-119.518300, 74.231147],
        [-121.580800, 74.555854],
        [-124.755686, 74.348578],
        [-124.213246, 73.879218],
        [-123.773752, 73.765611],
        [-124.859934, 73.090318],
        [-124.475982, 72.933051],
        [-125.113433, 72.867499],
        [-124.945546, 72.703030],
        [-125.102610, 72.634711],
        [-124.952382, 72.569648],
        [-125.438385, 72.415676],
        [-125.877553, 71.964016],
        [-125.253407, 71.955715],
        [-124.064565, 71.700385],
        [-123.255279, 71.130439],
        [-122.797760, 71.087795],
        [-121.700551, 71.468085],
        [-120.635243, 71.491441],
        [-120.382436, 71.691718],
        [-120.433990, 71.964301],
        [-120.158070, 72.128363],
        [-120.254750, 72.260810],
        [-119.340159, 72.346747],
        [-119.163889, 72.629828],
        [-115.323638, 73.508694]
    ],
    [
        [97.158051, 76.088284],
        [96.747732, 76.030992],
        [96.698578, 75.995795],
        [97.047374, 76.006334],
        [97.334809, 76.108710],
        [97.158051, 76.088284]
    ],
    [
        [95.177419, 76.170844],
        [95.101573, 76.225409],
        [95.006033, 76.177680],
        [95.197276, 76.164008],
        [95.177419, 76.170844]
    ],
    [
        [94.999197, 76.273261],
        [94.745372, 76.259589],
        [94.778656, 76.210924],
        [94.848888, 76.186103],
        [94.999197, 76.273261]
    ],
    [
        [96.574880, 76.341498],
        [96.766938, 76.335273],
        [96.724620, 76.346381],
        [96.574880, 76.341498]
    ],
    [
        [96.896658, 76.256496],
        [96.787364, 76.212388],
        [96.859548, 76.272162],
        [97.075450, 76.308010],
        [96.854015, 76.355658],
        [96.715994, 76.208686],
        [96.760916, 76.176418],
        [97.041270, 76.239081],
        [96.896658, 76.256496]
    ],
    [
        [94.163097, 76.596015],
        [93.944102, 76.616441],
        [93.868337, 76.588568],
        [94.163097, 76.596015]
    ],
    [
        [95.266124, 76.671088],
        [95.122081, 76.718899],
        [94.817638, 76.653998],
        [95.266124, 76.671088]
    ],
    [
        [56.986990, 74.690497],
        [55.529552, 74.654853],
        [55.656912, 74.519761],
        [55.388357, 74.445054],
        [55.232921, 74.375800],
        [55.746837, 74.296332],
        [55.075857, 74.265937],
        [55.018891, 74.173000],
        [54.588634, 74.018866],
        [54.801524, 73.970445],
        [53.631114, 73.759589],
        [54.280772, 73.600531],
        [54.530040, 73.704169],
        [54.541515, 73.610989],
        [54.033051, 73.374661],
        [54.250011, 73.328274],
        [54.900076, 73.448391],
        [55.924001, 73.311998],
        [55.917491, 73.448391],
        [56.120860, 73.290025],
        [56.729828, 73.244534],
        [56.749278, 73.361518],
        [57.253917, 73.457180],
        [56.735118, 73.680243],
        [57.350108, 73.553412],
        [57.617524, 73.668850],
        [57.349864, 73.827582],
        [57.395356, 73.845526],
        [57.748709, 73.726020],
        [57.911876, 73.915839],
        [57.260753, 74.080308],
        [57.531749, 74.191840],
        [58.123302, 73.986721],
        [58.162120, 74.150377],
        [58.307953, 74.087633],
        [58.521983, 74.149237],
        [58.300629, 74.160631],
        [58.292247, 74.221625],
        [58.728038, 74.238593],
        [58.638682, 74.423570],
        [58.186778, 74.581244],
        [59.145763, 74.444037],
        [59.221446, 74.615424],
        [59.083669, 74.648871],
        [59.289806, 74.642646],
        [59.090505, 74.738267],
        [59.755219, 74.587470],
        [59.872569, 74.676825],
        [59.508800, 74.799750],
        [60.276378, 74.749661],
        [60.372325, 74.793524],
        [60.194102, 74.854967],
        [60.687511, 74.923814],
        [60.724783, 75.027655],
        [61.276622, 75.327867],
        [61.481700, 75.223456],
        [63.552013, 75.711493],
        [68.287934, 76.281317],
        [68.177745, 76.314602],
        [69.033946, 76.712063],
        [68.462901, 76.966702],
        [67.588064, 77.013373],
        [65.753429, 76.682847],
        [65.998790, 76.533352],
        [65.484874, 76.574897],
        [64.090831, 76.312812],
        [62.503673, 76.177680],
        [61.076915, 76.279975],
        [60.899750, 76.157172],
        [61.145763, 76.116116],
        [60.734711, 76.005357],
        [60.468435, 76.013129],
        [60.838390, 76.122992],
        [60.268077, 76.110093],
        [60.042735, 76.054145],
        [60.347667, 76.005683],
        [58.931000, 75.867621],
        [57.500824, 75.499213],
        [57.741059, 75.327867],
        [57.046235, 75.398139],
        [56.530447, 75.078437],
        [56.071137, 75.218940],
        [55.726329, 75.081488],
        [56.678477, 74.948676],
        [55.832693, 74.800035],
        [56.986990, 74.690497]
    ],
    [
        [152.798350, 70.834621],
        [151.681488, 70.975898],
        [152.136729, 71.017279],
        [151.492442, 71.333157],
        [150.594900, 71.277899],
        [150.656993, 71.390286],
        [150.408702, 71.284980],
        [150.046723, 71.209662],
        [150.670665, 71.490180],
        [149.868012, 71.462226],
        [150.102061, 71.594713],
        [149.953298, 71.669867],
        [148.827159, 71.675198],
        [149.039399, 71.757758],
        [148.833995, 71.812323],
        [150.074229, 71.894232],
        [149.611339, 72.148383],
        [147.195567, 72.329901],
        [146.036306, 71.786363],
        [144.893240, 71.675198],
        [145.215994, 71.843329],
        [144.970958, 71.980292],
        [145.805675, 71.929023],
        [145.613292, 72.244330],
        [145.968028, 72.070502],
        [145.993012, 72.029731],
        [145.972504, 71.856269],
        [146.929210, 72.312649],
        [145.068696, 72.264350],
        [144.415538, 72.175035],
        [144.105479, 72.277899],
        [144.520763, 72.225002],
        [144.943207, 72.438178],
        [145.352875, 72.346747],
        [140.725841, 72.898627],
        [140.583181, 72.867499],
        [141.110850, 72.586982],
        [139.541759, 72.497626],
        [139.094005, 72.248236],
        [139.191580, 72.162665],
        [139.349864, 72.134467],
        [139.256684, 72.179023],
        [140.197113, 72.213813],
        [139.336192, 71.949530],
        [139.809255, 71.860785],
        [139.734548, 71.672187],
        [140.033214, 71.472113],
        [139.192231, 71.415107],
        [138.756033, 71.643012],
        [138.098643, 71.581448],
        [137.828624, 71.387152],
        [138.362966, 71.318915],
        [137.739268, 71.229478],
        [138.074392, 71.133979],
        [137.812999, 71.119615],
        [137.526134, 71.220282],
        [137.692393, 71.220933],
        [137.704926, 71.284735],
        [136.774587, 71.523424],
        [135.621593, 71.623114],
        [134.810232, 71.481838],
        [134.696544, 71.421332],
        [134.770030, 71.366929],
        [134.668630, 71.264309],
        [134.739024, 71.367987],
        [133.151622, 71.579169],
        [132.715099, 71.810696],
        [133.031345, 71.955099],
        [133.066274, 71.971291],
        [132.717784, 71.946234],
        [131.941905, 71.267401],
        [132.188324, 71.215888],
        [131.850922, 71.208197],
        [131.546153, 70.887112],
        [131.042003, 70.738756],
        [130.768891, 70.977525],
        [130.619884, 70.866400],
        [129.626231, 71.086127],
        [129.762706, 71.147610],
        [129.248709, 71.549872],
        [128.820486, 71.658108],
        [129.543712, 71.722968],
        [129.041189, 72.018785],
        [129.183930, 71.809272],
        [128.926606, 71.738756],
        [127.665782, 72.430080],
        [128.934093, 72.072984],
        [129.241954, 72.134467],
        [129.564138, 72.230658],
        [129.258311, 72.463935],
        [129.198416, 72.655178],
        [129.358084, 72.703030],
        [128.129242, 72.786078],
        [129.443508, 73.028944],
        [128.777354, 73.070787],
        [128.969249, 73.177395],
        [127.960216, 73.347317],
        [128.076915, 73.405666],
        [127.987559, 73.470852],
        [127.050466, 73.549018],
        [126.562999, 73.381496],
        [126.658702, 73.302639],
        [126.565196, 73.233466],
        [126.419688, 73.409491],
        [126.158458, 73.381496],
        [126.391124, 73.464016],
        [126.288097, 73.557278],
        [125.562511, 73.408759],
        [125.651866, 73.525458],
        [124.383067, 73.806383],
        [123.876720, 73.772528],
        [123.973806, 73.627021],
        [123.369640, 73.662665],
        [123.246104, 73.545885],
        [123.417328, 73.443549],
        [123.218110, 73.408759],
        [123.670665, 73.203315],
        [123.400890, 73.174302],
        [123.467947, 73.079576],
        [123.234548, 72.934719],
        [122.308279, 72.941352],
        [121.791352, 72.976874],
        [119.722504, 72.958930],
        [118.394216, 73.238023],
        [118.467133, 73.478095],
        [118.997569, 73.491360],
        [118.450206, 73.588772],
        [115.413097, 73.710395],
        [113.466563, 73.504950],
        [114.035818, 73.347317],
        [113.562348, 73.253404],
        [113.542247, 72.977362],
        [113.158214, 72.822699],
        [113.177257, 72.732978],
        [113.117686, 72.860663],
        [113.487071, 72.963690],
        [113.498302, 73.335883],
        [113.131358, 73.449693],
        [113.427908, 73.633979],
        [112.846934, 73.994534],
        [112.945323, 73.790473],
        [112.371837, 73.705308],
        [111.435557, 73.812567],
        [111.198497, 73.977932],
        [111.126231, 74.030463],
        [110.958995, 73.908637],
        [110.021495, 74.014472],
        [109.531098, 73.775295],
        [109.737478, 73.661689],
        [109.713878, 73.452582],
        [109.193614, 73.551663],
        [109.434906, 73.426703],
        [108.197520, 73.279039],
        [108.316661, 73.221584],
        [106.175629, 73.094387],
        [106.254640, 72.967200],
        [106.036368, 72.952522],
        [105.482595, 72.768134],
        [105.073009, 72.765082],
        [105.833832, 73.002265],
        [106.062755, 73.273017],
        [106.785411, 73.340522],
        [107.146821, 73.617662],
        [108.066580, 73.635321],
        [109.979503, 74.296332],
        [109.561209, 74.313707],
        [111.772309, 74.668524],
        [113.720470, 75.409857],
        [113.290538, 75.550523],
        [113.267426, 75.651109],
        [112.813650, 75.557318],
        [112.747813, 75.698472],
        [112.870616, 75.711493],
        [113.617442, 75.656236],
        [113.426117, 75.540229],
        [113.555919, 75.540229],
        [113.890147, 75.853990],
        [113.480805, 75.855536],
        [113.549083, 76.020657],
        [113.259288, 76.266425],
        [112.932140, 76.259589],
        [113.289073, 76.170844],
        [113.302745, 76.115627],
        [113.059337, 76.163764],
        [112.962169, 76.065090],
        [112.569672, 76.047309],
        [112.857677, 76.143500],
        [112.500743, 76.239081],
        [112.747813, 76.335273],
        [112.256847, 76.454413],
        [112.199067, 76.471869],
        [111.090343, 76.762274],
        [107.946056, 76.737291],
        [107.845470, 76.534817],
        [106.819835, 76.468940],
        [106.367035, 76.574897],
        [107.499766, 76.924506],
        [106.829845, 77.054674],
        [105.784923, 77.041002],
        [105.928477, 77.144110],
        [106.292003, 77.370022],
        [105.873709, 77.568590],
        [104.751638, 77.706204],
        [103.196625, 77.658922],
        [102.043142, 77.380601],
        [100.857677, 76.873236],
        [101.234630, 76.767279],
        [100.878266, 76.554999],
        [101.753103, 76.470201],
        [100.851085, 76.540107],
        [98.817882, 76.494208],
        [99.865733, 76.107652],
        [99.902354, 75.927191],
        [99.570649, 75.779731],
        [99.424001, 75.793443],
        [99.754893, 76.049018],
        [98.712738, 76.204983],
        [98.816417, 76.267035],
        [97.548350, 76.054145],
        [97.823904, 75.988105],
        [97.185313, 75.930609],
        [97.396821, 76.047309],
        [97.250987, 76.043402],
        [96.461436, 75.871894],
        [96.664561, 75.965399],
        [95.575206, 75.888983],
        [96.196462, 76.087551],
        [95.872895, 76.138129],
        [93.120942, 76.095689],
        [93.230805, 76.054145],
        [92.826834, 75.965399],
        [92.085216, 75.735745]
    ],
    [
        [93.868400, 78.147090],
        [93.920874, 78.157024],
        [93.592914, 78.172398],
        [93.629080, 78.157050],
        [93.868400, 78.147090]
    ],
    [
        [92.456798, 79.110419],
        [92.213390, 79.139553],
        [92.175629, 79.130845],
        [92.456798, 79.110419]
    ],
    [
        [92.990571, 79.419501],
        [92.791270, 79.440009],
        [92.587250, 79.415107],
        [92.791840, 79.383246],
        [92.990571, 79.419501]
    ],
    [
        [92.305431, 79.453030],
        [92.070567, 79.413886],
        [92.243826, 79.382310],
        [92.470551, 79.432563],
        [92.305431, 79.453030]
    ],
    [
        [91.372244, 79.485541],
        [91.144216, 79.537340],
        [91.372244, 79.485541]
    ],
    [
        [100.199962, 79.678941],
        [99.982921, 79.697903],
        [99.905772, 79.603827],
        [100.309825, 79.665961],
        [100.199962, 79.678941]
    ],
    [
        [94.327647, 80.028998],
        [93.984386, 80.015367],
        [93.929861, 79.974433],
        [94.154145, 79.983344],
        [94.327647, 80.028998]
    ],
    [
        [-35.988637, 65.984809],
        [-35.716624, 66.090237],
        [-35.942494, 66.103909],
        [-35.765045, 66.193305],
        [-35.575307, 66.132880],
        [-35.851633, 66.437445],
        [-35.216379, 66.241034],
        [-35.038197, 66.262152],
        [-35.236806, 66.323635],
        [-35.114247, 66.421454],
        [-34.973256, 66.289537],
        [-34.715443, 66.344062],
        [-34.407582, 66.542711],
        [-34.530507, 66.638251],
        [-34.417470, 66.749945],
        [-34.270375, 66.576850],
        [-34.085439, 66.809556],
        [-33.934641, 66.768622],
        [-33.999135, 66.954495],
        [-33.858876, 66.953559],
        [-33.975657, 66.994574],
        [-33.537424, 67.077704],
        [-33.668080, 67.223212],
        [-33.365468, 67.247748],
        [-33.598215, 67.371975],
        [-33.273671, 67.400784],
        [-33.365712, 67.551418],
        [-33.056996, 67.632636],
        [-33.202260, 67.694037],
        [-32.126373, 67.858832],
        [-32.146392, 68.050360],
        [-31.995595, 68.091295],
        [-32.454254, 68.207994],
        [-32.070709, 68.194322],
        [-32.501210, 68.429023],
        [-32.487172, 68.623928],
        [-31.991282, 68.259996],
        [-31.545522, 68.246324],
        [-31.748525, 68.214260],
        [-31.581166, 68.076483],
        [-30.419667, 68.070868],
        [-30.816884, 68.255805],
        [-30.055979, 68.111802],
        [-30.302968, 68.255805],
        [-29.993398, 68.251044],
        [-30.069447, 68.320990],
        [-29.852651, 68.415595],
        [-29.473785, 68.249579],
        [-29.096995, 68.310370],
        [-29.172109, 68.399807],
        [-28.851877, 68.328559],
        [-28.010487, 68.457831],
        [-27.980336, 68.571112],
        [-27.781117, 68.468695],
        [-26.325551, 68.679145],
        [-25.449818, 68.967922],
        [-25.656484, 69.091864],
        [-25.285959, 69.023627],
        [-25.327545, 69.132799],
        [-24.991770, 69.166938],
        [-25.280914, 69.237616],
        [-25.190989, 69.283677],
        [-24.675526, 69.244615],
        [-24.735015, 69.433661],
        [-24.094228, 69.428290],
        [-24.354888, 69.599555],
        [-23.814198, 69.512274],
        [-23.579701, 69.626288],
        [-23.929799, 69.756008],
        [-22.998850, 69.765611],
        [-22.909495, 69.813422],
        [-23.278676, 69.859687],
        [-22.077138, 70.130316],
        [-23.863352, 70.133734],
        [-25.000885, 70.365627],
        [-25.324941, 70.278266],
        [-25.395823, 70.359320],
        [-25.203521, 70.398342],
        [-25.305287, 70.413235],
        [-26.326161, 70.198310],
        [-26.883616, 70.256903],
        [-27.339915, 69.971137],
        [-28.534088, 70.048163],
        [-26.321278, 70.379788],
        [-26.743316, 70.484117],
        [-28.232900, 70.372016],
        [-28.281361, 70.510728],
        [-28.310292, 70.563870],
        [-27.920888, 70.868069],
        [-28.397613, 70.981269],
        [-27.618153, 70.953803],
        [-27.925120, 71.133979],
        [-27.806386, 71.156562],
        [-27.506174, 70.942125],
        [-26.425608, 70.974555],
        [-25.601918, 71.169582],
        [-25.780019, 71.257473],
        [-25.512522, 71.215888],
        [-25.410064, 71.353664],
        [-25.805043, 71.490668],
        [-27.331370, 71.718817],
        [-28.456939, 71.939399],
        [-28.360422, 72.007148],
        [-26.785146, 71.546536],
        [-26.401479, 71.642483],
        [-25.621734, 71.538642],
        [-25.096059, 71.304836],
        [-24.638010, 71.361762],
        [-24.195627, 71.012274],
        [-24.066274, 70.689683],
        [-23.345448, 70.440579],
        [-22.632558, 70.445461],
        [-22.648590, 70.723049],
        [-22.479156, 70.855414],
        [-22.381174, 70.448717],
        [-21.940053, 70.390326],
        [-21.476796, 70.544867],
        [-21.771148, 70.590074],
        [-21.579213, 70.674628],
        [-21.764150, 70.709377],
        [-21.792104, 70.736029],
        [-21.639150, 70.800605],
        [-21.822825, 70.777045],
        [-21.928619, 70.812445],
        [-21.572418, 70.955797],
        [-21.990102, 70.968817],
        [-21.696848, 71.078925],
        [-21.715728, 71.119696],
        [-21.712799, 71.137885],
        [-21.738515, 71.254462],
        [-21.963368, 71.270453],
        [-21.606516, 71.325751],
        [-21.856191, 71.348619],
        [-21.667958, 71.401435],
        [-21.874013, 71.448635],
        [-21.764638, 71.508002],
        [-22.132395, 71.490912],
        [-22.476715, 71.264309],
        [-22.507436, 71.552232],
        [-22.595530, 71.574123],
        [-22.654856, 71.668362],
        [-22.415761, 71.796536],
        [-23.123199, 71.631903],
        [-22.503407, 71.900784],
        [-23.820546, 72.113959],
        [-23.710683, 72.217027],
        [-24.546376, 72.423407],
        [-25.180979, 72.365383],
        [-25.507314, 72.123765],
        [-25.288930, 72.390570],
        [-25.132314, 72.436184],
        [-24.601308, 72.552191],
        [-25.256215, 72.811184],
        [-26.468984, 72.576972],
        [-26.306996, 72.730373],
        [-26.082631, 72.782416],
        [-25.135610, 72.939765],
        [-25.052561, 73.083930],
        [-26.444488, 73.196682],
        [-26.651682, 73.103217],
        [-27.260121, 73.127183],
        [-27.327626, 72.968329],
        [-27.483062, 72.925686],
        [-27.403554, 73.110663],
        [-26.396962, 73.238023],
        [-27.459055, 73.443549],
        [-27.332387, 73.498114],
        [-25.965403, 73.241889],
        [-24.679596, 73.524644],
        [-25.550893, 73.811225],
        [-25.690663, 73.957465],
        [-24.456858, 73.541449],
        [-24.340566, 73.778713],
        [-24.060048, 73.820258],
        [-22.799469, 73.567613],
        [-24.032826, 73.696723],
        [-23.449941, 73.436103],
        [-22.314076, 73.250434],
        [-21.543202, 73.490424],
        [-20.543284, 73.449042],
        [-20.382476, 73.517890],
        [-20.520497, 73.728949],
        [-20.277577, 73.875474],
        [-21.784657, 74.053046],
        [-21.915028, 73.977932],
        [-21.758127, 73.866441],
        [-21.702748, 73.696723],
        [-21.827138, 73.651679],
        [-21.988678, 73.998725],
        [-22.487945, 74.080959],
        [-22.176015, 74.112616],
        [-22.339508, 74.162909],
        [-22.069081, 74.294257],
        [-22.346995, 74.286444],
        [-22.471018, 74.313666],
        [-21.768788, 74.415269],
        [-22.081776, 74.602973],
        [-19.626536, 74.238593],
        [-18.974762, 74.484361],
        [-19.386301, 74.560736],
        [-19.269602, 74.648871],
        [-19.402821, 74.689439],
        [-19.718373, 74.587470],
        [-21.119944, 74.666897],
        [-20.609731, 74.734849],
        [-20.764231, 74.840725],
        [-20.676625, 75.074408],
        [-21.769114, 74.960191],
        [-21.760732, 74.985297],
        [-20.517201, 75.142320],
        [-21.429189, 75.431830],
        [-22.461415, 75.509467],
        [-22.506500, 75.539537],
        [-22.263092, 75.669501],
        [-19.588612, 75.142320],
        [-19.341908, 75.411322],
        [-19.612294, 75.684231],
        [-19.345326, 75.732611],
        [-19.934967, 75.934027],
        [-21.844838, 75.957831],
        [-21.983876, 75.992662],
        [-20.269399, 75.992336],
        [-19.670562, 76.136054],
        [-20.421010, 76.136054],
        [-21.652089, 76.237738],
        [-21.585439, 76.443061],
        [-22.190297, 76.411444],
        [-21.699941, 76.470201],
        [-22.086293, 76.554999],
        [-21.805165, 76.588568],
        [-22.145009, 76.645819],
        [-22.322865, 76.515041],
        [-22.744211, 76.698432],
        [-22.196156, 76.856676],
        [-21.623647, 76.646430],
        [-20.777333, 76.842353],
        [-20.513417, 76.945705],
        [-18.511220, 76.740912],
        [-18.258778, 77.100165],
        [-18.536122, 77.280951],
        [-19.082509, 77.318427],
        [-19.062652, 77.186713],
        [-19.274566, 77.189276],
        [-20.468007, 77.474433],
        [-20.277333, 77.529527],
        [-20.821523, 77.653510],
        [-20.092152, 77.701361],
        [-19.357981, 77.526353],
        [-18.979156, 77.616848],
        [-19.126820, 77.683661],
        [-20.937408, 77.973700],
        [-21.446767, 77.662584],
        [-21.967275, 77.679185],
        [-20.848215, 78.592597],
        [-21.207753, 78.632880],
        [-20.842030, 78.715277],
        [-20.970815, 78.778876],
        [-19.881337, 78.836859],
        [-19.765696, 78.897650],
        [-19.878529, 79.031968],
        [-18.878774, 79.225084],
        [-19.276682, 79.391669],
        [-19.603586, 79.179918],
        [-19.207753, 79.708482],
        [-19.966949, 79.679389],
        [-20.423085, 79.839586],
        [-19.966461, 80.083238],
        [-20.171213, 80.104315],
        [-19.474355, 80.260199],
        [-16.447336, 80.219306],
        [-15.755198, 80.419420],
        [-16.896230, 80.583686],
        [-18.055084, 80.491767],
        [-19.488026, 80.634833],
        [-20.352651, 80.460598],
        [-20.845448, 80.557359],
        [-19.471669, 80.665432],
        [-18.322255, 80.558051],
        [-17.239898, 80.722317],
        [-15.420400, 80.648383],
        [-14.132192, 80.886176],
        [-14.552724, 80.990627],
        [-13.354604, 81.019924],
        [-11.376820, 81.476020],
        [-12.570058, 81.696234],
        [-15.290028, 81.838813],
        [-16.485219, 81.749457],
        [-16.461293, 81.630072],
        [-17.019887, 81.584662],
        [-16.812652, 81.536689],
        [-17.146840, 81.413398],
        [-18.523752, 81.505683],
        [-19.460561, 81.374701],
        [-18.983876, 81.610297],
        [-19.708160, 81.695502],
        [-20.951283, 81.235745],
        [-21.256825, 81.517483],
        [-21.056996, 81.913031],
        [-21.388417, 82.083441],
        [-23.195424, 82.022284],
        [-23.403920, 81.718817],
        [-26.387196, 81.427720],
        [-26.723012, 81.531480],
        [-24.706207, 81.781195],
        [-24.619862, 81.987494],
        [-27.761952, 82.062445],
        [-31.680165, 81.834784],
        [-32.147939, 81.681301],
        [-32.813303, 81.794379],
        [-29.905141, 82.098375],
        [-23.886708, 82.278876],
        [-22.437327, 82.339993],
        [-21.323110, 82.618354],
        [-23.384185, 82.852240],
        [-23.881337, 82.797919],
        [-24.025299, 82.872382],
        [-23.933095, 82.916409],
        [-25.583404, 82.769355],
        [-25.903554, 82.783637],
        [-24.753651, 82.998277],
        [-25.221425, 83.167873],
        [-30.096913, 83.126207],
        [-31.665598, 82.931708],
        [-33.602651, 82.945380],
        [-33.688222, 82.834866],
        [-33.884633, 82.794501],
        [-33.815663, 82.869615],
        [-34.024281, 82.919623],
        [-34.951039, 82.904853],
        [-35.471018, 82.746161],
        [-35.298248, 82.892890],
        [-33.439809, 83.159613],
        [-32.161733, 83.060981],
        [-32.490712, 83.634101],
        [-34.085439, 83.565090],
        [-34.362904, 83.602932],
        [-36.901479, 83.496161],
        [-37.585439, 83.508043],
        [-38.059682, 83.434760],
        [-37.813059, 83.359524],
        [-38.868479, 83.427314],
        [-38.697133, 83.318061],
        [-38.861684, 83.256659],
        [-38.683420, 83.208401],
        [-38.800893, 83.058010],
        [-39.149648, 82.982245],
        [-38.477406, 82.831448],
        [-38.615102, 82.745998],
        [-39.437611, 82.961819],
        [-41.931549, 83.092108],
        [-41.705678, 83.174018],
        [-42.665842, 83.281195],
        [-42.850209, 83.099555],
        [-43.363515, 82.920844],
        [-45.105092, 82.935085],
        [-45.970693, 83.096503],
        [-46.700917, 83.002753],
        [-46.892730, 82.961819],
        [-45.974436, 82.842841],
        [-40.317209, 82.730699],
        [-39.912099, 82.677151],
        [-40.009511, 82.563544],
        [-39.755971, 82.395941],
        [-40.524403, 82.573188]
    ],
    [
        [-40.524403, 82.573188],
        [-41.898061, 82.728990],
        [-41.615834, 82.636664],
        [-41.555491, 82.533515],
        [-41.709055, 82.482001],
        [-42.171783, 82.708564],
        [-42.048248, 82.756334],
        [-43.727203, 82.406887],
        [-43.835439, 82.341986],
        [-43.075551, 82.297024],
        [-44.562856, 82.293402],
        [-44.793853, 82.191962],
        [-44.398793, 82.105211],
        [-44.926381, 81.995347],
        [-44.172922, 81.837714],
        [-44.662831, 81.754381],
        [-49.011342, 82.454535],
        [-51.107249, 82.509914],
        [-50.581288, 82.153998],
        [-49.435699, 81.927680],
        [-51.066274, 81.933905],
        [-49.613840, 81.645941],
        [-49.921498, 81.611762],
        [-52.964263, 82.036322],
        [-52.930165, 81.865058],
        [-53.650217, 81.542914],
        [-53.682973, 81.526313],
        [-53.807851, 81.588202],
        [-53.509999, 81.910224],
        [-53.557037, 82.116116],
        [-54.440745, 82.372707],
        [-55.255360, 82.275295],
        [-55.112538, 82.157172],
        [-55.958892, 82.272773],
        [-59.467885, 82.002834],
        [-58.485951, 81.879299],
        [-58.137766, 81.666978],
        [-57.747548, 81.650946],
        [-56.452545, 81.338080],
        [-56.541249, 81.335924],
        [-58.681386, 81.684027],
        [-58.838490, 81.862250],
        [-60.067332, 81.947374],
        [-61.281077, 81.815131],
        [-61.454254, 81.745022],
        [-60.773183, 81.491645],
        [-61.311350, 81.365383],
        [-60.892974, 81.166164],
        [-63.373280, 81.159247],
        [-63.655019, 81.149075],
        [-67.485951, 80.323188],
        [-67.505849, 80.207180],
        [-67.050120, 80.061184],
        [-64.926015, 80.072659],
        [-64.222768, 80.255683],
        [-63.778554, 80.151923],
        [-65.043568, 80.023871],
        [-64.949818, 79.960150],
        [-65.128570, 79.850287],
        [-64.831410, 79.527167],
        [-65.909413, 79.151313],
        [-67.505849, 79.138332],
        [-69.171742, 78.925442],
        [-68.780751, 78.836656],
        [-72.590199, 78.521226],
        [-72.850575, 78.315334],
        [-72.460764, 78.288642],
        [-73.057240, 78.158271],
        [-71.213206, 77.870307],
        [-71.439565, 77.799994],
        [-71.312815, 77.769843],
        [-70.411936, 77.862698],
        [-69.973012, 77.836127],
        [-69.507476, 77.760443],
        [-70.287750, 77.575385],
        [-69.222564, 77.452908],
        [-68.610911, 77.517727],
        [-68.729848, 77.669135],
        [-68.356435, 77.499945],
        [-66.663482, 77.719428],
        [-66.053375, 77.493476],
        [-66.663482, 77.417792],
        [-66.226145, 77.252509],
        [-67.435943, 77.383572],
        [-66.170074, 77.198676],
        [-66.361928, 77.116156],
        [-69.733469, 77.239000],
        [-70.903310, 77.191352],
        [-70.699290, 77.150865],
        [-71.384429, 77.023993],
        [-70.678782, 76.938625],
        [-70.987213, 76.897040],
        [-70.521108, 76.787177],
        [-69.756988, 77.010647],
        [-69.541656, 77.006293],
        [-70.103383, 76.801459],
        [-67.985585, 76.684149],
        [-69.637278, 76.383124],
        [-68.432525, 76.079413],
        [-66.488433, 75.909857],
        [-67.307769, 76.164008],
        [-66.927154, 76.266506],
        [-66.413726, 76.086127],
        [-66.207265, 76.277818],
        [-65.740142, 76.278510],
        [-65.552480, 76.239081],
        [-65.888905, 76.102525],
        [-65.354482, 76.026801],
        [-65.342641, 76.175849],
        [-64.594146, 76.136054],
        [-64.689768, 76.253363],
        [-64.381215, 76.260321],
        [-64.429067, 76.349026],
        [-64.031117, 76.136054],
        [-63.367299, 76.376899],
        [-62.791656, 76.198147],
        [-62.266754, 76.289944],
        [-60.924062, 76.165676],
        [-60.745473, 76.001044],
        [-59.591420, 75.916938],
        [-59.772939, 75.801418],
        [-59.272206, 75.880113],
        [-59.041615, 75.701361],
        [-58.405914, 75.718940],
        [-58.594350, 75.679755],
        [-58.310292, 75.643256],
        [-58.426137, 75.566107],
        [-58.206654, 75.444037],
        [-58.247629, 75.403022],
        [-58.439361, 75.314276],
        [-57.922719, 75.163398],
        [-58.141591, 75.051825],
        [-57.057851, 74.921942],
        [-56.795237, 74.813951],
        [-57.158315, 74.738267],
        [-56.144765, 74.491889],
        [-56.130442, 74.388861],
        [-56.124257, 74.279608],
        [-56.411610, 74.067328],
        [-55.970530, 74.027086],
        [-56.124257, 74.012112],
        [-55.644765, 73.875474],
        [-55.945465, 73.861233],
        [-55.612660, 73.721137],
        [-56.067738, 73.653022],
        [-55.089711, 73.367906],
        [-55.459462, 73.265367],
        [-55.141591, 73.190375],
        [-55.695383, 73.069525],
        [-54.781077, 72.998481],
        [-54.602935, 72.833970],
        [-54.526601, 72.778754],
        [-55.010569, 72.521715],
        [-54.800933, 72.552191],
        [-55.459137, 72.525946],
        [-55.651275, 72.450385],
        [-54.684885, 72.367174],
        [-55.609690, 71.990465],
        [-55.267812, 71.927314],
        [-54.641591, 72.018500],
        [-54.529042, 72.177436],
        [-54.383209, 72.223212],
        [-54.555247, 72.033759],
        [-54.853342, 71.912991],
        [-55.904530, 71.682034],
        [-55.569325, 71.641059],
        [-55.676178, 71.630113],
        [-55.514475, 71.449164],
        [-53.912587, 71.450507],
        [-53.848785, 71.545478],
        [-54.102040, 71.709906],
        [-53.765859, 71.640326],
        [-53.917714, 71.737250],
        [-53.398915, 71.845893],
        [-53.835113, 72.162421],
        [-53.870229, 72.356635],
        [-53.851633, 72.330634],
        [-53.399729, 72.041978],
        [-53.364329, 71.777777],
        [-53.265981, 71.709906],
        [-52.166412, 71.613105],
        [-52.992258, 71.421332],
        [-52.257680, 71.365546],
        [-52.557729, 71.178616],
        [-51.642242, 71.367336],
        [-51.528676, 71.274237],
        [-52.242747, 71.126776],
        [-51.956899, 71.024115],
        [-50.847157, 70.873236],
        [-50.631581, 70.739081],
        [-51.250722, 70.813870],
        [-51.445139, 70.731920],
        [-50.969716, 70.638983],
        [-50.737294, 70.544867],
        [-50.885854, 70.510810],
        [-51.347401, 70.571601],
        [-50.992787, 70.424954],
        [-50.530019, 70.536566],
        [-50.682688, 70.400865],
        [-50.531850, 70.359320],
        [-51.549428, 70.431586],
        [-52.790639, 70.756781],
        [-54.155385, 70.828803],
        [-54.630238, 70.654120],
        [-52.320668, 70.051459],
        [-50.237294, 70.038398],
        [-50.593332, 69.927924],
        [-50.189198, 69.763414],
        [-50.796132, 69.719875],
        [-50.775258, 69.650295],
        [-50.880605, 69.507880],
        [-50.867665, 69.461819],
        [-50.833485, 69.345120],
        [-50.987538, 69.329820],
        [-50.867665, 69.283677],
        [-50.366689, 69.338935],
        [-50.470367, 69.208564],
        [-50.139760, 69.179755],
        [-50.689524, 69.126654],
        [-50.223378, 69.072008],
        [-50.221669, 68.959906],
        [-51.079905, 69.132799],
        [-51.189768, 68.885810],
        [-50.963857, 68.934231],
        [-51.292144, 68.748603],
        [-50.991119, 68.735582],
        [-50.862050, 68.619818],
        [-52.388987, 68.509670],
        [-52.587554, 68.351386],
        [-52.937611, 68.262641],
        [-52.445139, 68.181464],
        [-51.223297, 68.296780],
        [-51.649037, 68.413479],
        [-50.848012, 68.507148],
        [-50.772043, 68.495429],
        [-51.166982, 68.414211],
        [-51.155629, 68.294827],
        [-51.381581, 68.255805],
        [-51.436838, 68.201158],
        [-50.148264, 67.947943],
        [-50.566558, 67.906317],
        [-51.217112, 68.070868],
        [-51.931549, 68.046820],
        [-52.554067, 68.186916],
        [-52.799143, 68.175767],
        [-52.388987, 68.077623],
        [-52.446197, 68.068996],
        [-53.114817, 68.198635],
        [-53.307973, 68.186510],
        [-53.457753, 68.152777],
        [-53.176584, 68.046088],
        [-53.259145, 67.988959],
        [-52.889231, 67.981513],
        [-53.687652, 67.811835],
        [-53.541412, 67.719672],
        [-53.729726, 67.538072],
        [-52.824045, 67.796454],
        [-52.342152, 67.821723],
        [-51.629954, 67.776597],
        [-51.848297, 67.735053],
        [-51.703684, 67.700263],
        [-51.325551, 67.824368],
        [-51.573354, 67.934272],
        [-51.038930, 67.981513],
        [-50.975942, 67.886868],
        [-51.367909, 67.885891],
        [-51.168691, 67.762356],
        [-50.648549, 67.851142],
        [-50.887522, 67.858547],
        [-50.784291, 67.911282],
        [-50.264963, 67.844916],
        [-51.320139, 67.714545],
        [-50.901763, 67.659369],
        [-50.286000, 67.745429],
        [-50.105580, 67.740546],
        [-49.935943, 67.700263],
        [-50.874420, 67.604682],
        [-50.072499, 67.515937],
        [-50.196645, 67.467475],
        [-51.348012, 67.679511],
        [-51.864125, 67.635891],
        [-52.409088, 67.769232],
        [-52.532948, 67.741889],
        [-53.704213, 67.461330],
        [-53.876698, 67.234768],
        [-53.188466, 67.343166],
        [-51.521840, 67.350491],
        [-51.182281, 67.145413],
        [-50.524729, 67.227973],
        [-50.346832, 67.186957],
        [-51.176137, 67.124905],
        [-51.552846, 67.331000],
        [-52.190663, 67.371894],
        [-53.964915, 67.077704],
        [-53.828359, 66.984320],
        [-53.647043, 66.911566],
        [-52.450347, 66.981513],
        [-52.231923, 66.844957],
        [-53.002065, 66.855129],
        [-53.107655, 66.772366],
        [-53.204498, 66.748114],
        [-53.457753, 66.638251],
        [-53.622955, 66.508979],
        [-53.498687, 66.474433],
        [-53.695302, 66.358832],
        [-53.625966, 66.251614],
        [-53.121938, 66.289455],
        [-53.663197, 66.138617],
        [-53.450917, 66.103909],
        [-51.174672, 66.927883],
        [-50.895985, 66.992906],
        [-50.743398, 67.003485],
        [-50.594228, 67.042141],
        [-50.634267, 67.015041],
        [-51.011627, 66.905748],
        [-51.283355, 66.844916],
        [-53.472035, 65.980943],
        [-52.874908, 66.021918],
        [-53.265981, 65.919582],
        [-53.181020, 65.859809],
        [-52.576405, 66.008043],
        [-52.303293, 65.905219],
        [-52.210683, 65.989814],
        [-51.731028, 66.075914],
        [-51.861318, 66.021918],
        [-51.739858, 65.930609],
        [-51.977406, 66.003607],
        [-52.299184, 65.837144],
        [-52.694000, 65.939399],
        [-52.877838, 65.808783],
        [-53.239247, 65.686184],
        [-52.824045, 65.672512],
        [-52.693430, 65.807278],
        [-52.772532, 65.638373],
        [-52.546539, 65.679348],
        [-52.470855, 65.672512],
        [-52.614247, 65.489814],
        [-52.444203, 65.517890],
        [-52.491322, 65.391913],
        [-51.931223, 65.556383],
        [-51.991689, 65.672512],
        [-51.441029, 65.772528],
        [-50.943023, 65.782375],
        [-50.552358, 65.713446],
        [-51.688100, 65.704779],
        [-51.902943, 65.624091],
        [-51.716786, 65.589993],
        [-52.567047, 65.322455],
        [-52.444203, 65.275214],
        [-52.327504, 65.343492],
        [-52.195058, 65.324042],
        [-52.275990, 65.200141],
        [-52.004750, 65.316230],
        [-52.272857, 65.103949],
        [-52.012196, 64.980414],
        [-52.217681, 64.911851],
        [-52.183502, 64.802314],
        [-52.057281, 64.923733],
        [-51.943918, 64.877387],
        [-52.105336, 64.798570],
        [-51.757680, 64.863715],
        [-51.692698, 65.025946],
        [-51.552846, 64.994086],
        [-51.703684, 64.891059],
        [-52.132436, 64.712836],
        [-52.021596, 64.596747],
        [-52.194556, 64.472236],
        [-52.161477, 64.256349],
        [-51.662709, 64.308824],
        [-51.252553, 64.760199],
        [-51.038930, 64.781195],
        [-51.145090, 64.616645],
        [-50.642161, 64.759223],
        [-50.976959, 65.219672],
        [-50.689524, 65.206366],
        [-50.840932, 65.131293],
        [-50.559682, 64.774807],
        [-49.997426, 64.863715],
        [-50.217152, 64.725898],
        [-50.480336, 64.712877],
        [-50.915395, 64.603013],
        [-50.176381, 64.448188],
        [-51.528961, 64.200507],
        [-51.354848, 64.144355],
        [-51.649037, 64.130072],
        [-51.439931, 64.082261],
        [-50.363840, 64.359076],
        [-50.552358, 64.178534],
        [-50.162587, 64.244940],
        [-50.045237, 64.198961],
        [-51.656484, 64.014065],
        [-51.361073, 63.973049],
        [-51.458404, 63.817572],
        [-51.528676, 63.764146],
        [-51.347401, 63.726020],
        [-51.539215, 63.691840],
        [-51.306467, 63.630439],
        [-51.422515, 63.541002],
        [-51.130238, 63.512885],
        [-51.185170, 63.628852],
        [-51.076161, 63.664293],
        [-51.056304, 63.650865],
        [-51.093129, 63.531399],
        [-51.223297, 63.444892],
        [-51.101064, 63.328559],
        [-51.000600, 63.164740],
        [-50.778228, 63.253079],
        [-50.912343, 63.143215],
        [-50.607533, 63.096015],
        [-50.468984, 62.951158],
        [-50.148264, 63.020250],
        [-50.182362, 62.958808],
        [-50.243804, 62.852362],
        [-50.271799, 62.705634],
        [-49.873280, 62.896796],
        [-50.319569, 62.505764],
        [-49.788401, 62.297919],
        [-49.887563, 62.245673],
        [-49.291737, 62.266791],
        [-49.682729, 62.157538],
        [-49.695790, 62.116604],
        [-49.463002, 62.088609],
        [-49.638499, 61.989203],
        [-49.169097, 62.021308],
        [-49.031117, 62.212104],
        [-49.079457, 62.081244],
        [-48.839223, 62.081244],
        [-49.408437, 61.937812],
        [-49.428212, 61.821112],
        [-49.175649, 61.903022],
        [-49.353179, 61.766547],
        [-49.220082, 61.724066],
        [-49.166900, 61.856635],
        [-48.784169, 61.992255],
        [-49.148305, 61.725531],
        [-48.874013, 61.793158],
        [-49.058339, 61.622504],
        [-48.954498, 61.643134],
        [-48.983266, 61.608832],
        [-48.664377, 61.649604],
        [-48.592193, 61.636135],
        [-49.298573, 61.561021],
        [-48.989654, 61.457953],
        [-48.345815, 61.608832],
        [-48.476145, 61.533759],
        [-49.065785, 61.402777],
        [-48.340077, 61.375800],
        [-48.640614, 61.238959],
        [-48.298980, 61.227240],
        [-48.407216, 61.133979],
        [-48.215443, 61.142727],
        [-48.291127, 61.177436],
        [-48.146962, 61.321479],
        [-47.913726, 61.328315],
        [-48.216379, 61.186225],
        [-47.770375, 61.191107],
        [-47.934885, 61.088080],
        [-47.838450, 61.042304],
        [-47.688466, 61.005561],
        [-48.232777, 60.820543],
        [-47.029856, 60.974758],
        [-46.913889, 60.930406],
        [-47.043568, 60.841010],
        [-46.862294, 60.800116],
        [-46.710317, 60.886705],
        [-46.886545, 60.937242],
        [-46.578033, 60.909980],
        [-46.653147, 60.985663],
        [-46.412953, 61.088080],
        [-46.296864, 61.073798],
        [-45.836415, 61.152045],
        [-46.111928, 61.252590],
        [-45.714019, 61.328315],
        [-45.872304, 61.222724],
        [-45.618764, 61.144965],
        [-46.070302, 60.937242],
        [-45.618479, 61.019843],
        [-45.512847, 61.247626],
        [-45.364613, 61.094306],
        [-45.510243, 60.982245],
        [-45.885365, 60.930406],
        [-46.205068, 60.746649],
        [-45.713368, 60.769965],
        [-45.395416, 61.010647],
        [-45.255035, 60.907904],
        [-45.858022, 60.697699],
        [-45.577504, 60.703925],
        [-45.981597, 60.580390],
        [-45.881093, 60.518378],
        [-45.785390, 60.624945],
        [-45.624664, 60.649237],
        [-45.731435, 60.587836],
        [-45.583730, 60.471137],
        [-45.350942, 60.725002],
        [-45.121938, 60.725002],
        [-45.495595, 60.492255],
        [-45.062978, 60.662909],
        [-45.214223, 60.438951],
        [-45.000356, 60.490709],
        [-44.802602, 60.684516],
        [-44.625396, 60.737535],
        [-45.173818, 60.133612],
        [-44.466420, 60.567328],
        [-44.755116, 60.204250],
        [-45.172841, 60.087551],
        [-44.844472, 60.019273],
        [-44.926381, 60.104315],
        [-44.844472, 60.149604],
        [-44.590199, 59.989081],
        [-44.100819, 60.387397],
        [-43.994740, 60.306627],
        [-44.165883, 60.173163],
        [-43.088124, 60.099351],
        [-43.329986, 60.217231],
        [-43.099192, 60.243720],
        [-43.357289, 60.375556],
        [-43.366282, 60.391181],
        [-43.319447, 60.447211],
        [-43.804758, 60.442816],
        [-44.192738, 60.643052],
        [-43.620758, 60.559882],
        [-43.702382, 60.672349],
        [-43.689198, 60.723700],
        [-43.227447, 60.470893],
        [-43.301096, 60.557522],
        [-43.044545, 60.507880],
        [-43.144399, 60.546820],
        [-42.829091, 60.580390],
        [-42.826283, 60.611274],
        [-42.747182, 60.690172],
        [-42.905385, 60.621324],
        [-43.241322, 60.656236],
        [-42.771637, 60.734931],
        [-42.801137, 60.804836],
        [-43.027455, 60.881578],
        [-42.726674, 60.930406],
        [-42.706166, 61.060126],
        [-42.630483, 61.101142],
        [-43.179189, 61.211005],
        [-42.575836, 61.197333],
        [-42.658355, 61.259426],
        [-43.248118, 61.341295],
        [-42.418121, 61.402777],
        [-43.082916, 61.595201],
        [-42.435536, 61.561021],
        [-42.253733, 61.711249],
        [-42.593617, 61.703803],
        [-42.870025, 61.769924],
        [-42.343129, 61.759711],
        [-42.192250, 61.869574],
        [-42.415761, 61.920600],
        [-42.548492, 61.951483],
        [-42.261138, 62.314602],
        [-42.339345, 62.376695],
        [-42.164377, 62.390326],
        [-43.151235, 62.759589],
        [-42.487131, 62.698188],
        [-42.579661, 62.825873],
        [-42.415761, 62.828803],
        [-42.597157, 62.871527],
        [-42.305409, 62.945502],
        [-42.319447, 62.816962],
        [-41.750111, 62.843940],
        [-41.624094, 62.995063],
        [-42.205922, 63.109687],
        [-42.143951, 63.205878],
        [-42.020904, 63.253079],
        [-41.432729, 63.125312],
        [-41.900868, 63.469916],
        [-41.715932, 63.552965],
        [-41.530995, 63.431952],
        [-41.582753, 63.493232],
        [-41.240102, 63.403876],
        [-41.413930, 63.565904],
        [-41.129506, 63.389146],
        [-40.999338, 63.411322],
        [-41.174306, 63.452338],
        [-41.287262, 63.564927],
        [-40.750071, 63.516913],
        [-41.626820, 63.777818],
        [-41.488108, 63.860256],
        [-40.526438, 63.696357],
        [-40.621693, 63.924628],
        [-40.841664, 63.952582],
        [-40.560943, 64.106879],
        [-41.567494, 64.266181],
        [-40.358306, 64.359036],
        [-40.635121, 64.467108],
        [-40.604482, 64.683498],
        [-41.146392, 64.953518],
        [-40.983144, 64.976752],
        [-41.122792, 65.117011],
        [-40.281361, 65.001166],
        [-39.937327, 65.096503],
        [-40.122874, 65.166205],
        [-39.759145, 65.247301],
        [-39.950999, 65.360582],
        [-39.788726, 65.412177],
        [-40.218495, 65.508002],
        [-39.806996, 65.508002],
        [-39.656117, 65.686184],
        [-39.205678, 65.582465],
        [-39.366444, 65.721747],
        [-39.341420, 65.748236],
        [-39.074534, 65.555162],
        [-38.600331, 65.577867],
        [-38.752309, 65.693305],
        [-38.220570, 65.646430],
        [-38.106109, 65.810736],
        [-38.432444, 65.902167],
        [-38.484853, 66.015082],
        [-37.998931, 65.938422],
        [-37.959625, 66.075873],
        [-38.087026, 66.083441],
        [-38.106679, 66.114488],
        [-37.854237, 66.199449],
        [-37.998280, 66.241034],
        [-37.689809, 66.268378],
        [-38.140492, 66.369208],
        [-37.852366, 66.444729],
        [-37.169667, 66.316799],
        [-37.797922, 66.048733],
        [-37.854237, 65.884752],
        [-37.184560, 65.774075],
        [-37.272084, 65.830146],
        [-37.114369, 65.816881],
        [-37.237294, 65.905219],
        [-37.067250, 66.065090],
        [-37.013783, 65.839586],
        [-36.553619, 66.083808],
        [-36.339752, 66.075914],
        [-36.363922, 65.916002],
        [-35.988637, 65.984809]
    ],
    [
        [167.663748, -78.127374],
        [167.511729, -77.992446],
        [166.795665, -78.211602],
        [165.986095, -78.109552],
        [166.315115, -78.310317],
        [167.663748, -78.127374]
    ],
    [
        [163.614268, -74.843438],
        [163.626475, -74.913751],
        [163.695160, -74.892267],
        [163.673676, -74.858575],
        [163.614268, -74.843438]
    ],
    [
        [163.803477, -74.689548],
        [163.687755, -74.725518],
        [163.963390, -74.866388],
        [164.038097, -74.636326],
        [163.803477, -74.689548]
    ],
    [
        [163.340180, -70.373956],
        [163.309581, -70.386407],
        [163.566661, -70.363946],
        [163.455333, -70.339125],
        [163.340180, -70.373956]
    ],
    [
        [164.840343, -67.339288],
        [164.657237, -67.260837],
        [164.657237, -67.538344],
        [164.875011, -67.515069],
        [164.840343, -67.339288]
    ],
    [
        [163.293712, -66.838067],
        [163.260509, -66.716241],
        [163.081309, -66.706476],
        [163.190766, -66.843845],
        [163.293712, -66.838067]
    ],
    [
        [-45.053944, -60.703058],
        [-45.000234, -60.700860],
        [-45.067128, -60.631117],
        [-45.083363, -60.684666],
        [-45.053944, -60.703058]
    ],
    [
        [-105.459543, -26.464776],
        [-105.463490, -26.456964],
        [-105.470937, -26.457696],
        [-105.459543, -26.464776]
    ],
    [
        [-79.901763, -26.347426],
        [-79.909413, -26.358168],
        [-79.890207, -26.356052],
        [-79.890736, -26.351739],
        [-79.901763, -26.347426]
    ],
    [
        [-80.095693, -26.266046],
        [-80.107777, -26.274998],
        [-80.090443, -26.274509],
        [-80.095693, -26.266046]
    ],
    [
        [-130.120351, -25.068292],
        [-130.101145, -25.064386],
        [-130.086252, -25.075128],
        [-130.105336, -25.076755],
        [-130.120351, -25.068292]
    ],
    [
        [-124.786163, -24.664565],
        [-124.797109, -24.667087],
        [-124.778066, -24.672540],
        [-124.780588, -24.666599],
        [-124.786163, -24.664565]
    ],
    [
        [-136.165761, -22.024347],
        [-136.175689, -22.029880],
        [-136.185862, -22.034438],
        [-136.163564, -22.013604],
        [-136.165761, -22.024347]
    ],
    [
        [-136.377187, -21.468357],
        [-136.391469, -21.456150],
        [-136.404937, -21.460219],
        [-136.413401, -21.471368],
        [-136.377187, -21.468357]
    ],
    [
        [-136.549387, -21.336847],
        [-136.543121, -21.359796],
        [-136.529449, -21.349867],
        [-136.532216, -21.331313],
        [-136.549387, -21.336847]
    ],
    [
        [-136.636220, -21.341567],
        [-136.639882, -21.326430],
        [-136.651601, -21.322931],
        [-136.646799, -21.327244],
        [-136.636220, -21.341567]
    ],
    [
        [-136.734364, -21.312107],
        [-136.738637, -21.299493],
        [-136.745961, -21.299493],
        [-136.752187, -21.308526],
        [-136.734364, -21.312107]
    ],
    [
        [-29.338246, -20.584161],
        [-29.348256, -20.561293],
        [-29.344309, -20.550958],
        [-29.316884, -20.568780],
        [-29.338246, -20.584161]
    ],
    [
        [-28.883290, -20.518731],
        [-28.880483, -20.510837],
        [-28.877065, -20.511651],
        [-28.877838, -20.514255],
        [-28.883290, -20.518731]
    ],
    [
        [-140.413971, -19.614190],
        [-140.412424, -19.663832],
        [-140.387359, -19.656996],
        [-140.383168, -19.625421],
        [-140.413971, -19.614190]
    ],
    [
        [-139.202260, -19.350681],
        [-139.195912, -19.340916],
        [-139.207672, -19.337335],
        [-139.202260, -19.350681]
    ],
    [
        [-138.796742, -19.290297],
        [-138.794586, -19.281671],
        [-138.812123, -19.283787],
        [-138.805979, -19.288832],
        [-138.796742, -19.290297]
    ],
    [
        [-141.266184, -19.203546],
        [-141.252349, -19.189711],
        [-141.237172, -19.193617],
        [-141.230377, -19.227146],
        [-141.266184, -19.203546]
    ],
    [
        [-140.721832, -19.133722],
        [-140.696197, -19.119317],
        [-140.670155, -19.131768],
        [-140.660878, -19.152439],
        [-140.721832, -19.133722]
    ],
    [
        [-138.801584, -18.765232],
        [-138.815745, -18.761407],
        [-138.829742, -18.759942],
        [-138.793202, -18.778904],
        [-138.801584, -18.765232]
    ],
    [
        [-143.092112, -17.853285],
        [-143.072255, -17.840427],
        [-143.072825, -17.844334],
        [-143.092112, -17.853285]
    ],
    [
        [-150.655263, -17.668715],
        [-150.655263, -17.668715],
        [-150.643178, -17.655450],
        [-150.644968, -17.677992],
        [-150.655263, -17.668715]
    ],
    [
        [-141.438547, -17.368097],
        [-141.453847, -17.352309],
        [-141.481842, -17.348565],
        [-141.434967, -17.389337],
        [-141.438547, -17.368097]
    ],
    [
        [-138.441721, -17.366388],
        [-138.463735, -17.356948],
        [-138.458811, -17.356866],
        [-138.441721, -17.366388]
    ],
    [
        [42.751801, -17.076104],
        [42.724376, -17.063572],
        [42.758800, -17.060642],
        [42.751801, -17.076104]
    ],
    [
        [-143.084828, -17.004571],
        [-143.101226, -16.990167],
        [-143.062001, -17.008966],
        [-143.073150, -17.009373],
        [-143.084828, -17.004571]
    ],
    [
        [-149.583608, -16.987074],
        [-149.575917, -16.983657],
        [-149.568227, -16.982192],
        [-149.586863, -17.000421],
        [-149.583608, -16.987074]
    ],
    [
        [-153.933990, -16.797540],
        [-153.933990, -16.797540]
    ],
    [
        [-144.200673, -16.648370],
        [-144.185902, -16.659356],
        [-144.169586, -16.667250],
        [-144.188140, -16.645685],
        [-144.200673, -16.648370]
    ],
    [
        [-152.244700, -16.443780],
        [-152.261464, -16.441502],
        [-152.263621, -16.447198],
        [-152.256296, -16.451267],
        [-152.244700, -16.443780]
    ],
    [
        [-145.898915, -15.888116],
        [-145.898915, -15.888116]
    ],
    [
        [-140.888987, -15.819757],
        [-140.861440, -15.815525],
        [-140.852366, -15.815525],
        [-140.879709, -15.838311],
        [-140.888987, -15.819757]
    ],
    [
        [-148.250844, -15.867446],
        [-148.279368, -15.830499],
        [-148.262074, -15.802423],
        [-148.229929, -15.848077],
        [-148.250844, -15.867446]
    ],
    [
        [-146.486643, -15.803399],
        [-146.503041, -15.791681],
        [-146.481923, -15.826918],
        [-146.482655, -15.814874],
        [-146.486643, -15.803399]
    ],
    [
        [-154.523183, -15.819431],
        [-154.522084, -15.800470],
        [-154.536977, -15.792250],
        [-154.519114, -15.795587],
        [-154.523183, -15.819431]
    ],
    [
        [-144.649810, -15.730157],
        [-144.632802, -15.728448],
        [-144.620432, -15.747003],
        [-144.641916, -15.755141],
        [-144.649810, -15.730157]
    ],
    [
        [-145.455881, -15.479587],
        [-145.523915, -15.470473],
        [-145.549631, -15.452081],
        [-145.455881, -15.479587]
    ],
    [
        [-146.194163, -15.359470],
        [-146.196685, -15.335626],
        [-146.200551, -15.329685],
        [-146.217193, -15.323663],
        [-146.194163, -15.359470]
    ],
    [
        [-146.620839, -15.239841],
        [-146.610097, -15.256443],
        [-146.639027, -15.232599],
        [-146.620839, -15.239841]
    ],
    [
        [-147.256256, -15.232517],
        [-147.242258, -15.232354],
        [-147.237416, -15.244236],
        [-147.241811, -15.239028],
        [-147.256256, -15.232517]
    ],
    [
        [-147.778961, -15.216404],
        [-147.778961, -15.216404]
    ],
    [
        [-147.458974, -15.121352],
        [-147.492502, -15.091078],
        [-147.458974, -15.121352]
    ],
    [
        [-147.931956, -15.080824],
        [-147.937815, -15.070896],
        [-147.936594, -15.066339],
        [-147.931956, -15.080824]
    ],
    [
        [-145.922434, -14.433770],
        [-145.943715, -14.441827],
        [-145.933217, -14.437595],
        [-145.922434, -14.433770]
    ],
    [
        [-141.174550, -14.189630],
        [-141.202748, -14.170180],
        [-141.212799, -14.164972],
        [-141.189280, -14.190199],
        [-141.174550, -14.189630]
    ],
    [
        [46.509776, -9.719985],
        [46.486990, -9.730157],
        [46.479666, -9.751072],
        [46.500662, -9.746515],
        [46.509776, -9.719985]
    ],
    [
        [47.507335, -9.713067],
        [47.507335, -9.698175],
        [47.512950, -9.694431],
        [47.515798, -9.700128],
        [47.507335, -9.713067]
    ],
    [
        [53.333995, -5.420180],
        [53.341645, -5.429946],
        [53.344737, -5.441013],
        [53.337901, -5.431248],
        [53.333995, -5.420180]
    ],
    [
        [55.659679, -3.791111],
        [55.665863, -3.811782],
        [55.651866, -3.801202],
        [55.659679, -3.791111]
    ],
    [
        [173.038259, 1.341051],
        [173.011241, 1.337348],
        [173.084727, 1.366685],
        [173.160655, 1.374945],
        [173.153168, 1.386542],
        [173.171723, 1.374172],
        [173.038259, 1.341051]
    ],
    [
        [168.101085, 5.599311],
        [168.116222, 5.591376],
        [168.127940, 5.601630],
        [168.132009, 5.618557],
        [168.124522, 5.631049],
        [168.101085, 5.599311]
    ],
    [
        [171.724620, 6.101711],
        [171.722830, 6.083441],
        [171.745128, 6.079128],
        [171.743175, 6.083197],
        [171.724620, 6.101711]
    ],
    [
        [171.909679, 7.098782],
        [171.892100, 7.090806],
        [171.908946, 7.092271],
        [171.909679, 7.098782]
    ],
    [
        [-82.362050, 8.086859],
        [-82.343129, 8.123358],
        [-82.320709, 8.130316],
        [-82.318227, 8.099921],
        [-82.362050, 8.086859]
    ],
    [
        [-79.084393, 8.382491],
        [-79.130098, 8.404870],
        [-79.118238, 8.429110],
        [-79.082438, 8.415997],
        [-79.084393, 8.382491]
    ],
    [
        [-82.123036, 9.322659],
        [-82.156565, 9.349351],
        [-82.211781, 9.349351],
        [-82.138824, 9.245307],
        [-82.123036, 9.322659]
    ],
    [
        [97.871837, 9.379584],
        [97.840017, 9.404283],
        [97.843598, 9.424954],
        [97.868419, 9.420396],
        [97.871837, 9.379584]
    ],
    [
        [-82.328481, 9.412055],
        [-82.280751, 9.374701],
        [-82.245961, 9.330064],
        [-82.266428, 9.439358],
        [-82.328481, 9.412055]
    ],
    [
        [99.698741, 9.542222],
        [99.703461, 9.521308],
        [99.668142, 9.519192],
        [99.698741, 9.542222]
    ],
    [
        [99.684255, 9.620022],
        [99.680431, 9.612209],
        [99.678071, 9.610419],
        [99.675304, 9.624457],
        [99.684255, 9.620022]
    ],
    [
        [98.057465, 9.796861],
        [98.018321, 9.794908],
        [98.015391, 9.826402],
        [98.046072, 9.827948],
        [98.057465, 9.796861]
    ],
    [
        [73.646332, 10.084703],
        [73.640961, 10.069322],
        [73.632579, 10.057278],
        [73.643891, 10.094550],
        [73.646332, 10.084703]
    ],
    [
        [-85.131337, 10.098700],
        [-85.110463, 10.110297],
        [-85.199127, 10.117743],
        [-85.131337, 10.098700]
    ],
    [
        [73.662283, 10.144599],
        [73.657888, 10.139065],
        [73.654633, 10.141506],
        [73.655610, 10.144761],
        [73.662283, 10.144599]
    ],
    [
        [98.228689, 10.519965],
        [98.221853, 10.498114],
        [98.192719, 10.482408],
        [98.189708, 10.515570],
        [98.228689, 10.519965]
    ],
    [
        [72.649750, 10.566840],
        [72.638520, 10.559394],
        [72.627452, 10.554755],
        [72.648611, 10.573961],
        [72.649750, 10.566840]
    ],
    [
        [72.548839, 10.779446],
        [72.548757, 10.779324],
        [72.541189, 10.772895],
        [72.540863, 10.776516],
        [72.548839, 10.779446]
    ],
    [
        [-63.976552, 10.809231],
        [-64.004506, 10.775702],
        [-63.909169, 10.735541],
        [-63.903635, 10.777289],
        [-63.976552, 10.809231]
    ],
    [
        [73.671397, 10.829739],
        [73.681244, 10.828070],
        [73.684418, 10.827541],
        [73.672862, 10.824693],
        [73.671397, 10.829739]
    ],
    [
        [-61.002268, 10.699368],
        [-60.907297, 10.837144],
        [-61.667592, 10.706773],
        [-61.488881, 10.631049],
        [-61.462148, 10.282213],
        [-61.928700, 10.056464],
        [-60.996002, 10.138251],
        [-61.002268, 10.699368]
    ],
    [
        [-65.227610, 10.953803],
        [-65.329905, 10.977607],
        [-65.411773, 10.924750],
        [-65.244618, 10.884955],
        [-65.227610, 10.953803]
    ],
    [
        [98.429535, 10.977729],
        [98.432872, 10.993598],
        [98.451427, 11.001939],
        [98.440278, 10.965562],
        [98.429535, 10.977729]
    ],
    [
        [72.750011, 11.119086],
        [72.744965, 11.109524],
        [72.739513, 11.108832],
        [72.739513, 11.113959],
        [72.750011, 11.119086]
    ],
    [
        [-63.846832, 11.135403],
        [-64.049062, 10.990709],
        [-64.220082, 11.091539],
        [-64.408559, 10.967475],
        [-63.898061, 10.884955],
        [-63.846832, 11.135403]
    ],
    [
        [-60.530507, 11.351060],
        [-60.681304, 11.296454],
        [-60.847524, 11.163967],
        [-60.533030, 11.266506],
        [-60.530507, 11.351060]
    ],
    [
        [73.013194, 11.502183],
        [73.010916, 11.490139],
        [73.005626, 11.479641],
        [73.004405, 11.496487],
        [73.013194, 11.502183]
    ],
    [
        [72.716156, 11.694159],
        [72.705251, 11.687323],
        [72.700938, 11.686428],
        [72.705089, 11.692328],
        [72.716156, 11.694159]
    ],
    [
        [97.464529, 11.782457],
        [97.459239, 11.786200],
        [97.444347, 11.800238],
        [97.479666, 11.777981],
        [97.464529, 11.782457]
    ],
    [
        [-66.608266, 11.783108],
        [-66.615102, 11.824042],
        [-66.704498, 11.783108],
        [-66.641835, 11.761461],
        [-66.608266, 11.783108]
    ],
    [
        [-66.132192, 11.824042],
        [-66.179555, 11.823188],
        [-66.194325, 11.817694],
        [-66.114003, 11.779934],
        [-66.132192, 11.824042]
    ],
    [
        [-64.607167, 11.899115],
        [-64.648793, 11.830268],
        [-64.562856, 11.816596],
        [-64.556793, 11.857327],
        [-64.607167, 11.899115]
    ],
    [
        [-83.726226, 11.878648],
        [-83.719838, 11.870307],
        [-83.706858, 11.987047],
        [-83.736073, 11.941799],
        [-83.726226, 11.878648]
    ],
    [
        [-83.053944, 12.143866],
        [-83.055979, 12.166205],
        [-83.032541, 12.190823],
        [-83.021148, 12.181789],
        [-83.053944, 12.143866]
    ],
    [
        [-61.612945, 12.214423],
        [-61.671457, 12.236070],
        [-61.790517, 12.008368],
        [-61.631581, 12.044094],
        [-61.612945, 12.214423]
    ],
    [
        [93.872813, 12.268866],
        [93.853770, 12.260565],
        [93.851899, 12.271552],
        [93.860606, 12.281195],
        [93.872813, 12.268866]
    ],
    [
        [-68.211537, 12.228095],
        [-68.417388, 12.257025],
        [-68.254221, 12.023627],
        [-68.205312, 12.118232],
        [-68.211537, 12.228095]
    ],
    [
        [-61.428049, 12.454657],
        [-61.421620, 12.513373],
        [-61.428049, 12.529731],
        [-61.496246, 12.440375],
        [-61.428049, 12.454657]
    ],
    [
        [-81.711497, 12.522935],
        [-81.691029, 12.591254],
        [-81.716949, 12.563218],
        [-81.711497, 12.522935]
    ],
    [
        [97.836925, 12.772447],
        [97.835297, 12.792792],
        [97.852794, 12.806545],
        [97.868012, 12.774807],
        [97.836925, 12.772447]
    ],
    [
        [-61.194000, 13.036851],
        [-61.201487, 13.051174],
        [-61.277211, 12.988471],
        [-61.242421, 12.974799],
        [-61.194000, 13.036851]
    ],
    [
        [-87.615142, 13.290107],
        [-87.673818, 13.283881],
        [-87.667063, 13.256008],
        [-87.624338, 13.252916],
        [-87.615142, 13.290107]
    ],
    [
        [-59.426910, 13.160386],
        [-59.594472, 13.334784],
        [-59.645131, 13.323717],
        [-59.621571, 13.093980],
        [-59.426910, 13.160386]
    ],
    [
        [-87.622304, 13.368883],
        [-87.659006, 13.331692],
        [-87.591298, 13.304389],
        [-87.570790, 13.372016],
        [-87.622304, 13.368883]
    ],
    [
        [-81.382639, 13.319159],
        [-81.386138, 13.341457],
        [-81.365346, 13.373969],
        [-81.346303, 13.348700],
        [-81.382639, 13.319159]
    ],
    [
        [-61.167348, 13.146064],
        [-61.123931, 13.308254],
        [-61.187123, 13.380439],
        [-61.279368, 13.215888],
        [-61.167348, 13.146064]
    ],
    [
        [94.280935, 13.443549],
        [94.290782, 13.422919],
        [94.274913, 13.420315],
        [94.261892, 13.429267],
        [94.280935, 13.443549]
    ],
    [
        [-60.886790, 14.010077],
        [-60.933461, 14.111884],
        [-61.078521, 13.879788],
        [-60.955068, 13.714667],
        [-60.886790, 14.010077]
    ],
    [
        [-82.767323, 14.414130],
        [-82.784779, 14.381985],
        [-82.808258, 14.366360],
        [-82.732533, 14.369574],
        [-82.767323, 14.414130]
    ],
    [
        [-60.810414, 14.461982],
        [-60.879303, 14.777289],
        [-61.219472, 14.846503],
        [-60.996002, 14.565009],
        [-61.069569, 14.466702],
        [-60.810414, 14.461982]
    ],
    [
        [-61.362864, 15.201809],
        [-61.257680, 15.472602],
        [-61.468984, 15.633857],
        [-61.488922, 15.535712],
        [-61.362864, 15.201809]
    ],
    [
        [-61.194000, 15.932074],
        [-61.268300, 16.009263],
        [-61.332021, 15.931952],
        [-61.274892, 15.873765],
        [-61.194000, 15.932074]
    ],
    [
        [-86.878733, 16.127265],
        [-86.944251, 16.116508],
        [-86.997405, 16.083959],
        [-86.878733, 16.093166],
        [-86.878733, 16.127265]
    ],
    [
        [-60.989247, 16.346381],
        [-61.039133, 16.344468],
        [-61.091624, 16.305406],
        [-61.068593, 16.302232],
        [-60.989247, 16.346381]
    ],
    [
        [-61.551666, 16.285549],
        [-61.797353, 16.312201],
        [-61.694936, 15.949164],
        [-61.565989, 16.033515],
        [-61.551666, 16.285549]
    ],
    [
        [-86.606542, 16.285029],
        [-86.440390, 16.396545],
        [-86.332125, 16.429448],
        [-86.181751, 16.428225],
        [-86.606542, 16.285029]
    ],
    [
        [-61.544179, 16.285386],
        [-61.462148, 16.202338],
        [-61.163564, 16.252997],
        [-61.462514, 16.513088],
        [-61.544179, 16.285386]
    ],
    [
        [-85.911473, 16.462043],
        [-85.947068, 16.403190],
        [-85.816950, 16.498309],
        [-85.851131, 16.517218],
        [-85.911473, 16.462043]
    ],
    [
        [-169.530263, 16.760199],
        [-169.539174, 16.754462],
        [-169.517405, 16.762437],
        [-169.520823, 16.762600],
        [-169.530263, 16.760199]
    ],
    [
        [-62.147369, 16.744289],
        [-62.174672, 16.813137],
        [-62.202016, 16.819322],
        [-62.218861, 16.688707],
        [-62.147369, 16.744289]
    ],
    [
        [-61.883616, 17.049018],
        [-61.737131, 16.989244],
        [-61.667592, 17.079413],
        [-61.825266, 17.168769],
        [-61.883616, 17.049018]
    ],
    [
        [-62.599233, 17.202948],
        [-62.612172, 17.104153],
        [-62.547597, 17.104641],
        [-62.546498, 17.183783],
        [-62.599233, 17.202948]
    ],
    [
        [-87.838287, 17.388495],
        [-87.824615, 17.292304],
        [-87.803578, 17.292304],
        [-87.814198, 17.381293],
        [-87.838287, 17.388495]
    ],
    [
        [-62.650461, 17.265611],
        [-62.719960, 17.358547],
        [-62.853139, 17.394721],
        [-62.647043, 17.217190],
        [-62.650461, 17.265611]
    ],
    [
        [-83.941151, 17.418647],
        [-83.930328, 17.409410],
        [-83.912343, 17.411119],
        [-83.926137, 17.416327],
        [-83.941151, 17.418647]
    ],
    [
        [-62.997141, 17.525621],
        [-62.981086, 17.467724],
        [-62.958723, 17.464571],
        [-62.945065, 17.485384],
        [-62.997141, 17.525621]
    ],
    [
        [-87.827748, 17.545559],
        [-87.803944, 17.491929],
        [-87.909535, 17.426256],
        [-87.940745, 17.292304],
        [-87.926503, 17.278632],
        [-87.787180, 17.496894],
        [-87.827748, 17.545559]
    ],
    [
        [-88.077260, 17.641791],
        [-88.055653, 17.562649],
        [-88.043813, 17.552965],
        [-88.053619, 17.606269],
        [-88.077260, 17.641791]
    ],
    [
        [-61.838938, 17.593329],
        [-61.727773, 17.588446],
        [-61.837799, 17.727688],
        [-61.873850, 17.691148],
        [-61.838938, 17.593329]
    ],
    [
        [-88.160471, 17.682766],
        [-88.103668, 17.681830],
        [-88.071116, 17.734280],
        [-88.139516, 17.692043],
        [-88.160471, 17.682766]
    ],
    [
        [-64.559397, 17.751614],
        [-64.876454, 17.775865],
        [-64.895172, 17.682766],
        [-64.670522, 17.717231],
        [-64.559397, 17.751614]
    ],
    [
        [-62.838857, 17.881985],
        [-62.810129, 17.892279],
        [-62.791656, 17.915473],
        [-62.866119, 17.929145],
        [-62.838857, 17.881985]
    ],
    [
        [-67.855865, 18.114691],
        [-67.919749, 18.114488],
        [-67.937815, 18.094224],
        [-67.873158, 18.053453],
        [-67.855865, 18.114691]
    ],
    [
        [-63.017649, 18.122138],
        [-63.096099, 18.078803],
        [-63.146840, 18.070299],
        [-63.030629, 18.019110],
        [-63.017649, 18.122138]
    ],
    [
        [-65.347727, 18.114691],
        [-65.275746, 18.137152],
        [-65.580434, 18.122138],
        [-65.484242, 18.087348],
        [-65.347727, 18.114691]
    ],
    [
        [-87.913442, 18.025946],
        [-88.009023, 17.902493],
        [-87.934560, 17.942939],
        [-87.913442, 18.025946]
    ],
    [
        [-68.664052, 18.169338],
        [-68.754547, 18.197659],
        [-68.786936, 18.196682],
        [-68.571848, 18.107856],
        [-68.664052, 18.169338]
    ],
    [
        [-63.007395, 18.273017],
        [-63.038197, 18.267727],
        [-63.167836, 18.169338],
        [-63.000559, 18.227362],
        [-63.007395, 18.273017]
    ],
    [
        [-65.278798, 18.279202],
        [-65.256663, 18.323920],
        [-65.334055, 18.340644],
        [-65.292592, 18.299954],
        [-65.278798, 18.279202]
    ],
    [
        [-64.700994, 18.342976],
        [-64.660390, 18.336723],
        [-64.746955, 18.373590],
        [-64.801285, 18.328253],
        [-64.700994, 18.342976]
    ],
    [
        [-64.871637, 18.314623],
        [-64.840080, 18.317489],
        [-64.950028, 18.386599],
        [-65.041493, 18.353658],
        [-64.871637, 18.314623]
    ],
    [
        [-64.635121, 18.405504],
        [-64.613393, 18.422553],
        [-64.516845, 18.439290],
        [-64.641705, 18.451158],
        [-64.714128, 18.386203],
        [-64.635121, 18.405504]
    ],
    [
        [-64.380605, 18.480902],
        [-64.326039, 18.511949],
        [-64.415395, 18.511949],
        [-64.443349, 18.443061],
        [-64.380605, 18.480902]
    ],
    [
        [-65.628814, 18.279202],
        [-65.621409, 18.389065],
        [-66.382395, 18.491441],
        [-67.101715, 18.522773],
        [-67.270842, 18.361826],
        [-67.151858, 18.203392],
        [-67.214349, 17.994144],
        [-67.184192, 17.935072],
        [-65.939117, 17.970526],
        [-65.628814, 18.279202]
    ],
    [
        [-76.263743, 18.012356],
        [-76.894919, 18.409251],
        [-77.272613, 18.459377],
        [-77.902333, 18.518785],
        [-78.374664, 18.265570],
        [-77.178944, 17.704169],
        [-77.141652, 17.881134],
        [-76.942128, 17.833564],
        [-76.849967, 17.992276],
        [-76.363026, 17.860826],
        [-76.187978, 17.915473],
        [-76.263743, 18.012356]
    ],
    [
        [-87.331207, 18.532416],
        [-87.343617, 18.452338],
        [-87.334503, 18.454372],
        [-87.310129, 18.567206],
        [-87.331207, 18.532416]
    ],
    [
        [-87.269154, 18.738511],
        [-87.258616, 18.656968],
        [-87.248158, 18.676215],
        [-87.269154, 18.738511]
    ],
    [
        [-64.336537, 18.724270],
        [-64.270741, 18.700670],
        [-64.320302, 18.746243],
        [-64.408559, 18.744696],
        [-64.336537, 18.724270]
    ],
    [
        [-91.600331, 18.772040],
        [-91.812164, 18.679755],
        [-91.842681, 18.651190],
        [-91.524566, 18.752143],
        [-91.600331, 18.772040]
    ],
    [
        [-73.258656, 18.878485],
        [-73.037424, 18.759589],
        [-72.808746, 18.720404],
        [-73.200795, 18.968695],
        [-73.258656, 18.878485]
    ],
    [
        [-81.136098, 19.354885],
        [-81.349718, 19.302114],
        [-81.375722, 19.388983],
        [-81.416542, 19.370028],
        [-81.387486, 19.263864],
        [-81.136098, 19.354885]
    ],
    [
        [-80.037830, 19.704035],
        [-80.062088, 19.700682],
        [-80.113155, 19.658660],
        [-79.964263, 19.704901],
        [-80.037830, 19.704035]
    ],
    [
        [-79.871889, 19.704636],
        [-79.893754, 19.679673],
        [-79.726643, 19.737063],
        [-79.745900, 19.757631],
        [-79.871889, 19.704636]
    ],
    [
        [-68.356191, 18.656562],
        [-68.899810, 19.020901],
        [-69.608469, 19.093451],
        [-69.617299, 19.225246],
        [-69.253651, 19.183539],
        [-69.164296, 19.307034],
        [-69.767690, 19.299750],
        [-69.947255, 19.678656],
        [-70.280832, 19.651801],
        [-71.000885, 19.937690],
        [-71.661448, 19.893622],
        [-71.821441, 19.656684],
        [-73.167104, 19.937690],
        [-73.457834, 19.672187],
        [-72.699127, 19.445868],
        [-72.813547, 19.052924],
        [-72.330434, 18.683295],
        [-72.353831, 18.530097],
        [-72.904164, 18.434149],
        [-74.255930, 18.670315],
        [-74.489166, 18.429389],
        [-73.873280, 18.026190],
        [-73.646311, 18.258734],
        [-72.885894, 18.141425],
        [-72.071767, 18.237535],
        [-71.417226, 17.604804],
        [-71.068349, 18.310370],
        [-70.657541, 18.433783],
        [-70.483551, 18.204088],
        [-70.171783, 18.231431],
        [-69.883656, 18.471015],
        [-69.236318, 18.450507],
        [-68.658437, 18.210924],
        [-68.356191, 18.656562]
    ],
    [
        [-86.749013, 20.592231],
        [-86.968129, 20.506252],
        [-86.995269, 20.260810],
        [-86.797109, 20.477484],
        [-86.749013, 20.592231]
    ],
    [
        [-78.333119, 20.554633],
        [-78.433502, 20.609524],
        [-78.463450, 20.602444],
        [-78.338979, 20.518012],
        [-78.333119, 20.554633]
    ],
    [
        [-78.436147, 20.725979],
        [-78.483957, 20.732164],
        [-78.545400, 20.704250],
        [-78.511830, 20.691148],
        [-78.436147, 20.725979]
    ],
    [
        [-78.826568, 20.753241],
        [-78.792348, 20.719916],
        [-78.750844, 20.725979],
        [-78.807037, 20.757229],
        [-78.826568, 20.753241]
    ],
    [
        [-75.517079, 20.794257],
        [-75.577748, 20.769517],
        [-75.482167, 20.737779],
        [-75.508168, 20.786566],
        [-75.517079, 20.794257]
    ],
    [
        [-78.925852, 20.807847],
        [-78.964345, 20.814114],
        [-78.847035, 20.773139],
        [-78.876617, 20.809231],
        [-78.925852, 20.807847]
    ],
    [
        [-79.025217, 20.886664],
        [-79.079823, 20.897284],
        [-78.988881, 20.839057],
        [-78.971181, 20.873521],
        [-79.025217, 20.886664]
    ],
    [
        [-79.073598, 20.917711],
        [-79.137685, 20.982652],
        [-79.182118, 21.008002],
        [-79.224436, 21.005845],
        [-79.073598, 20.917711]
    ],
    [
        [-79.388905, 21.123236],
        [-79.340728, 21.072903],
        [-79.292633, 21.074774],
        [-79.357330, 21.127590],
        [-79.388905, 21.123236]
    ],
    [
        [-86.700592, 21.198920],
        [-86.727528, 21.242906],
        [-86.741567, 21.287665],
        [-86.739573, 21.242825],
        [-86.700592, 21.198920]
    ],
    [
        [-73.647071, 21.061555],
        [-73.651612, 20.913781],
        [-73.225564, 20.952463],
        [-73.004628, 21.314439],
        [-73.647071, 21.061555]
    ],
    [
        [-71.138092, 21.513617],
        [-71.150990, 21.472846],
        [-71.144887, 21.431627],
        [-71.128896, 21.472235],
        [-71.138092, 21.513617]
    ],
    [
        [-81.372304, 21.705390],
        [-81.551381, 21.627590],
        [-81.560658, 21.602973],
        [-81.496693, 21.618476],
        [-81.372304, 21.705390]
    ],
    [
        [-97.651438, 21.787909],
        [-97.670318, 21.848619],
        [-97.684926, 21.862454],
        [-97.663482, 21.778469],
        [-97.610463, 21.740180],
        [-97.651438, 21.787909]
    ],
    [
        [-82.568023, 21.636542],
        [-82.703725, 21.892808],
        [-82.989491, 21.948432],
        [-83.085601, 21.800279],
        [-82.946116, 21.604641],
        [-82.959096, 21.561998],
        [-83.191803, 21.630316],
        [-82.906239, 21.437486],
        [-82.568023, 21.636542]
    ],
    [
        [-77.634185, 22.054267],
        [-77.808502, 22.099555],
        [-77.949452, 22.102607],
        [-77.703114, 21.910834],
        [-77.634185, 22.054267]
    ],
    [
        [-77.847076, 22.260321],
        [-77.781728, 22.177802],
        [-77.757721, 22.178371],
        [-77.834218, 22.295885],
        [-77.880686, 22.308743],
        [-77.847076, 22.260321]
    ],
    [
        [-77.997304, 22.147366],
        [-77.863433, 22.099189],
        [-77.825999, 22.157904],
        [-78.017812, 22.314887],
        [-77.997304, 22.147366]
    ],
    [
        [-78.196523, 22.329169],
        [-78.027659, 22.266018],
        [-78.010976, 22.281399],
        [-78.144195, 22.428941],
        [-78.312611, 22.404283],
        [-78.196523, 22.329169]
    ],
    [
        [-78.426178, 22.462592],
        [-78.696197, 22.541449],
        [-78.540842, 22.458482],
        [-78.426178, 22.462592]
    ],
    [
        [-74.283762, 22.671820],
        [-74.376698, 22.584377],
        [-74.385569, 22.541449],
        [-74.317535, 22.602484],
        [-74.283762, 22.671820]
    ],
    [
        [-78.984202, 22.637681],
        [-78.960846, 22.660142],
        [-79.004506, 22.656724],
        [-78.984202, 22.637681]
    ],
    [
        [-73.995717, 22.657538],
        [-73.880198, 22.502916],
        [-74.083852, 22.390611],
        [-74.276967, 22.171536],
        [-73.865387, 22.480048],
        [-73.851715, 22.733303],
        [-73.995717, 22.657538]
    ],
    [
        [-97.815297, 22.720201],
        [-97.843170, 22.684882],
        [-97.796132, 22.723782],
        [-97.788564, 22.774848],
        [-97.815297, 22.720201]
    ],
    [
        [-79.357533, 22.637681],
        [-79.569976, 22.804104],
        [-79.635325, 22.802151],
        [-79.357533, 22.637681]
    ],
    [
        [-74.286855, 22.733303],
        [-74.090688, 22.657538],
        [-74.016225, 22.720201],
        [-74.344553, 22.836249],
        [-74.286855, 22.733303]
    ],
    [
        [-79.895375, 22.959174],
        [-79.957428, 22.953030],
        [-79.949696, 22.928412],
        [-79.898549, 22.936713],
        [-79.895375, 22.959174]
    ],
    [
        [-80.320546, 22.986518],
        [-80.347808, 22.986518],
        [-80.231801, 22.959174],
        [-80.249745, 23.010932],
        [-80.320546, 22.986518]
    ],
    [
        [-73.666168, 23.089545],
        [-73.685699, 23.102484],
        [-73.816965, 23.103827],
        [-73.797353, 23.073798],
        [-73.666168, 23.089545]
    ],
    [
        [-80.197011, 23.124254],
        [-80.224965, 23.089545],
        [-80.166493, 23.092475],
        [-80.197011, 23.124254]
    ],
    [
        [-80.828236, 23.178900],
        [-80.848134, 23.185126],
        [-80.971669, 23.110663],
        [-80.830637, 23.135647],
        [-80.828236, 23.178900]
    ],
    [
        [-80.491851, 23.192572],
        [-80.559682, 23.205064],
        [-80.580637, 23.178900],
        [-80.495229, 23.168362],
        [-80.491851, 23.192572]
    ],
    [
        [-75.653554, 23.459459],
        [-75.637318, 23.435492],
        [-75.523834, 23.404853],
        [-75.576975, 23.445868],
        [-75.653554, 23.459459]
    ],
    [
        [-75.798207, 23.538642],
        [-75.908070, 23.645006],
        [-76.031484, 23.668524],
        [-76.037180, 23.596625],
        [-75.793772, 23.470526],
        [-75.661041, 23.452623],
        [-75.798207, 23.538642]
    ],
    [
        [-74.859120, 22.980292],
        [-75.059967, 23.141669],
        [-75.094065, 23.305325],
        [-75.194895, 23.514106],
        [-75.331410, 23.685981],
        [-75.068471, 23.116645],
        [-75.229644, 23.171454],
        [-74.839955, 22.859931],
        [-74.859120, 22.980292]
    ],
    [
        [-74.900054, 23.706488],
        [-74.941640, 23.658677],
        [-74.777211, 23.699652],
        [-74.812367, 23.719672],
        [-74.900054, 23.706488]
    ],
    [
        [-76.325185, 23.974026],
        [-76.376780, 24.101386],
        [-76.401479, 24.117377],
        [-76.374989, 24.046576],
        [-76.325185, 23.974026]
    ],
    [
        [-74.468658, 24.021796],
        [-74.475494, 23.980211],
        [-74.427113, 24.083238],
        [-74.464833, 24.143948],
        [-74.558095, 23.953559],
        [-74.468658, 24.021796]
    ],
    [
        [-77.880686, 24.186265],
        [-77.853912, 24.234687],
        [-77.798695, 24.254584],
        [-77.850006, 24.251451],
        [-77.976226, 24.186835],
        [-77.880686, 24.186265]
    ],
    [
        [-77.921620, 24.262030],
        [-77.932200, 24.275702],
        [-78.016916, 24.248440],
        [-77.935862, 24.227240],
        [-77.921620, 24.262030]
    ],
    [
        [-76.463002, 24.213609],
        [-76.529530, 24.287421],
        [-76.544911, 24.295559],
        [-76.493153, 24.218817],
        [-76.463002, 24.213609]
    ],
    [
        [-77.524973, 23.933051],
        [-77.607533, 24.218248],
        [-77.709584, 24.043687],
        [-77.744049, 24.035468],
        [-77.675160, 24.302965],
        [-77.942047, 24.096869],
        [-77.798695, 23.856676],
        [-77.660878, 23.884670],
        [-77.720204, 23.784817],
        [-77.778188, 23.746812],
        [-77.565907, 23.740668],
        [-77.524973, 23.933051]
    ],
    [
        [-77.767690, 24.326606],
        [-77.737538, 24.349677],
        [-77.682444, 24.352769],
        [-77.719228, 24.371731],
        [-77.804433, 24.327216],
        [-77.767690, 24.326606]
    ],
    [
        [-81.746246, 24.576117],
        [-81.810292, 24.558173],
        [-81.814565, 24.542548],
        [-81.732004, 24.556220],
        [-81.746246, 24.576117]
    ],
    [
        [-81.705312, 24.597805],
        [-81.725738, 24.556220],
        [-81.650054, 24.576117],
        [-81.656850, 24.597805],
        [-81.705312, 24.597805]
    ],
    [
        [-81.506012, 24.638821],
        [-81.560658, 24.693427],
        [-81.636464, 24.583564],
        [-81.530832, 24.615220],
        [-81.506012, 24.638821]
    ],
    [
        [-75.314687, 24.217353],
        [-75.626332, 24.645006],
        [-75.732167, 24.698635],
        [-75.410064, 24.272895],
        [-75.509918, 24.142076],
        [-75.314687, 24.217353]
    ],
    [
        [-81.087717, 24.685940],
        [-81.076161, 24.709052],
        [-81.039906, 24.734361],
        [-81.136098, 24.707017],
        [-81.087717, 24.685940]
    ],
    [
        [-81.430287, 24.754828],
        [-81.364247, 24.661200],
        [-81.362660, 24.631334],
        [-81.355458, 24.686184],
        [-81.430287, 24.754828]
    ],
    [
        [-80.923818, 24.769110],
        [-80.955556, 24.768744],
        [-81.033070, 24.720689],
        [-80.958892, 24.749335],
        [-80.923818, 24.769110]
    ],
    [
        [-80.800364, 24.843573],
        [-80.845041, 24.814358],
        [-80.854970, 24.803290],
        [-80.802154, 24.809882],
        [-80.800364, 24.843573]
    ],
    [
        [-77.479970, 24.991360],
        [-77.379506, 25.001532],
        [-77.263824, 25.058092],
        [-77.561879, 25.018866],
        [-77.479970, 24.991360]
    ],
    [
        [-78.353586, 24.659247],
        [-78.430531, 24.601793],
        [-78.134429, 24.501614],
        [-78.027455, 24.272854],
        [-77.718739, 24.499823],
        [-78.045155, 25.183092],
        [-78.214345, 25.184638],
        [-78.304067, 24.728217],
        [-78.196523, 24.603990],
        [-78.353586, 24.659247]
    ],
    [
        [-80.320546, 25.248277],
        [-80.320546, 25.248277]
    ],
    [
        [-80.190175, 25.481024],
        [-80.188222, 25.498358],
        [-80.238026, 25.405951],
        [-80.216908, 25.415473],
        [-80.190175, 25.481024]
    ],
    [
        [-76.161285, 25.165717],
        [-76.351633, 25.338609],
        [-76.688873, 25.487860],
        [-76.675201, 25.556789],
        [-76.702301, 25.563951],
        [-76.736684, 25.563625],
        [-76.784495, 25.426418],
        [-76.164947, 25.129828],
        [-76.182444, 24.848782],
        [-76.336334, 24.814927],
        [-76.161285, 24.645006],
        [-76.161285, 25.165717]
    ],
    [
        [-80.162913, 25.672838],
        [-80.158315, 25.679267],
        [-80.156077, 25.734931],
        [-80.183339, 25.713813],
        [-80.162913, 25.672838]
    ],
    [
        [-77.819203, 25.707587],
        [-77.858266, 25.777289],
        [-77.880686, 25.789537],
        [-77.880483, 25.768988],
        [-77.819203, 25.707587]
    ],
    [
        [-77.537994, 26.306586],
        [-77.570383, 26.332709],
        [-77.579579, 26.337592],
        [-77.572743, 26.268704],
        [-77.537994, 26.306586]
    ],
    [
        [-82.129221, 26.461127],
        [-82.164133, 26.479560],
        [-82.204945, 26.550482],
        [-82.026845, 26.447455],
        [-82.129221, 26.461127]
    ],
    [
        [-82.260162, 26.701321],
        [-82.247670, 26.654364],
        [-82.225453, 26.611274],
        [-82.245961, 26.694525],
        [-82.260162, 26.701321]
    ],
    [
        [-82.136708, 26.584662],
        [-82.082021, 26.491523],
        [-82.113637, 26.654364],
        [-82.177642, 26.701321],
        [-82.136708, 26.584662]
    ],
    [
        [-82.273834, 26.803127],
        [-82.287506, 26.803127],
        [-82.266428, 26.714993],
        [-82.257965, 26.758531],
        [-82.273834, 26.803127]
    ],
    [
        [-78.590077, 26.536200],
        [-77.929067, 26.639228],
        [-77.915395, 26.776435],
        [-78.319984, 26.686527],
        [-78.593821, 26.810533],
        [-78.714289, 26.570520],
        [-78.997874, 26.701321],
        [-78.766839, 26.508104],
        [-78.590077, 26.536200]
    ],
    [
        [-77.812367, 26.906806],
        [-77.160715, 26.564195],
        [-77.223297, 26.145819],
        [-77.408274, 26.029731],
        [-77.226674, 25.885077],
        [-77.049794, 26.516343],
        [-77.606842, 26.920396],
        [-77.868153, 26.928412],
        [-77.962554, 26.893052],
        [-77.812367, 26.906806]
    ],
    [
        [-97.198313, 26.276109],
        [-97.342885, 26.756741],
        [-97.397532, 26.831000],
        [-97.198313, 26.276109]
    ],
    [
        [-82.657460, 27.396796],
        [-82.649037, 27.381334],
        [-82.657460, 27.396796]
    ],
    [
        [-97.075429, 27.814521],
        [-97.254140, 27.659654],
        [-97.397532, 27.228909],
        [-97.044016, 27.835273],
        [-97.075429, 27.814521]
    ],
    [
        [-80.388783, 27.718655],
        [-80.292592, 27.417304],
        [-80.388783, 27.718655]
    ],
    [
        [-96.880238, 28.130113],
        [-96.972564, 28.009914],
        [-96.953033, 27.994208],
        [-97.029775, 27.900580],
        [-97.034413, 27.852037],
        [-96.850087, 28.071194],
        [-96.880238, 28.130113]
    ],
    [
        [-80.636464, 28.181057],
        [-80.629018, 28.181057],
        [-80.640696, 28.204169],
        [-80.636464, 28.181057]
    ],
    [
        [-96.427724, 28.393297],
        [-96.807769, 28.187649],
        [-96.835805, 28.071194],
        [-96.416860, 28.328762],
        [-96.427724, 28.393297]
    ],
    [
        [-96.369700, 28.406928],
        [-96.283925, 28.447659],
        [-96.232533, 28.489488],
        [-96.312896, 28.458564],
        [-96.369700, 28.406928]
    ],
    [
        [-80.677480, 28.578925],
        [-80.737416, 28.484849],
        [-80.714711, 28.369778],
        [-80.649770, 28.225165],
        [-80.677480, 28.578925]
    ],
    [
        [-90.943715, 29.060777],
        [-90.915110, 29.051256],
        [-90.879628, 29.051256],
        [-90.903188, 29.057196],
        [-90.943715, 29.060777]
    ],
    [
        [-90.346547, 29.058051],
        [-90.283844, 29.078559],
        [-90.283844, 29.086005],
        [-90.310780, 29.082424],
        [-90.346547, 29.058051]
    ],
    [
        [-118.251478, 29.089444],
        [-118.365383, 29.131653],
        [-118.288782, 28.868083],
        [-118.225804, 28.915052],
        [-118.251478, 29.089444]
    ],
    [
        [-89.962961, 29.270982],
        [-90.024281, 29.238471],
        [-90.030629, 29.216376],
        [-89.955474, 29.257310],
        [-89.962961, 29.270982]
    ],
    [
        [-94.814280, 29.352932],
        [-94.834096, 29.359768],
        [-95.116544, 29.088993],
        [-94.724409, 29.333155],
        [-94.814280, 29.352932]
    ],
    [
        [-89.167836, 29.503730],
        [-89.173004, 29.489325],
        [-89.166249, 29.482367],
        [-89.167836, 29.503730]
    ],
    [
        [-91.802073, 29.490058],
        [-91.720204, 29.581732],
        [-92.035390, 29.596177],
        [-91.840484, 29.483832],
        [-91.802073, 29.490058]
    ],
    [
        [-85.141754, 29.640855],
        [-85.086090, 29.685736],
        [-85.212799, 29.688707],
        [-85.171864, 29.668850],
        [-85.141754, 29.640855]
    ],
    [
        [-84.737375, 29.736477],
        [-84.987457, 29.620429],
        [-85.097320, 29.627265],
        [-84.692698, 29.764390],
        [-84.737375, 29.736477]
    ],
    [
        [-89.455190, 29.791693],
        [-89.490590, 29.793769],
        [-89.489980, 29.736477],
        [-89.427317, 29.743964],
        [-89.455190, 29.791693]
    ],
    [
        [-89.304351, 29.805365],
        [-89.337026, 29.806627],
        [-89.290679, 29.771226],
        [-89.277170, 29.812079],
        [-89.304351, 29.805365]
    ],
    [
        [-84.617014, 29.805365],
        [-84.656850, 29.787055],
        [-84.664703, 29.778713],
        [-84.617014, 29.805365]
    ],
    [
        [-89.234364, 29.948432],
        [-89.279042, 29.937201],
        [-89.293935, 29.920071],
        [-89.235504, 29.931627],
        [-89.234364, 29.948432]
    ],
    [
        [-89.272939, 29.982082],
        [-89.278066, 29.982123],
        [-89.327870, 29.915920],
        [-89.295806, 29.942206],
        [-89.272939, 29.982082]
    ],
    [
        [-88.872426, 30.058661],
        [-88.817779, 29.935126],
        [-88.810943, 29.915229],
        [-88.817779, 29.983547],
        [-88.872426, 30.058661]
    ],
    [
        [-89.433013, 30.145697],
        [-89.439361, 30.136542],
        [-89.431264, 30.133368],
        [-89.424916, 30.142564],
        [-89.433013, 30.145697]
    ],
    [
        [-89.188344, 30.079739],
        [-89.180816, 30.168524],
        [-89.345326, 30.066067],
        [-89.222076, 30.033759],
        [-89.188344, 30.079739]
    ],
    [
        [-88.940785, 30.217515],
        [-88.967356, 30.214301],
        [-88.969309, 30.210639],
        [-88.940785, 30.217515]
    ],
    [
        [-88.503041, 30.216254],
        [-88.434193, 30.209418],
        [-88.427358, 30.216254],
        [-88.503041, 30.223782],
        [-88.503041, 30.216254]
    ],
    [
        [-89.057973, 30.257799],
        [-89.077016, 30.240790],
        [-89.153554, 30.229926],
        [-89.084625, 30.195787],
        [-89.057973, 30.257799]
    ],
    [
        [-88.643056, 30.240465],
        [-88.697825, 30.257880],
        [-88.756337, 30.250434],
        [-88.556264, 30.216742],
        [-88.537913, 30.224433],
        [-88.643056, 30.240465]
    ],
    [
        [-88.071116, 30.250434],
        [-88.109039, 30.276109],
        [-88.090972, 30.244696],
        [-88.071116, 30.250434]
    ],
    [
        [-86.693756, 30.408108],
        [-86.890696, 30.393134],
        [-86.693756, 30.408108]
    ],
    [
        [-81.478749, 30.805976],
        [-81.461659, 30.725816],
        [-81.417307, 30.970404],
        [-81.482167, 30.904364],
        [-81.478749, 30.805976]
    ],
    [
        [-64.676096, 32.388658],
        [-64.879793, 32.305440],
        [-64.876304, 32.257767],
        [-64.677862, 32.334508],
        [-64.676096, 32.388658]
    ],
    [
        [-118.358766, 32.827828],
        [-118.564367, 33.023762],
        [-118.607215, 33.030856],
        [-118.499150, 32.850628],
        [-118.358766, 32.827828]
    ],
    [
        [-79.340443, 33.060248],
        [-79.363108, 33.043036],
        [-79.368398, 33.005683],
        [-79.360951, 33.005683],
        [-79.340443, 33.060248]
    ],
    [
        [-119.488604, 33.267188],
        [-119.532103, 33.286278],
        [-119.578926, 33.276097],
        [-119.434337, 33.224012],
        [-119.488604, 33.267188]
    ],
    [
        [-118.515654, 33.423005],
        [-118.463586, 33.323514],
        [-118.304340, 33.309040],
        [-118.515654, 33.423005]
    ],
    [
        [-77.969960, 33.889553],
        [-77.995229, 33.899319],
        [-78.017812, 33.875881],
        [-77.969960, 33.847968],
        [-77.969960, 33.889553]
    ],
    [
        [-120.044139, 34.037273],
        [-120.096665, 34.017861],
        [-120.248517, 34.001127],
        [-120.109891, 33.893140],
        [-119.968830, 33.941117],
        [-120.044139, 34.037273]
    ],
    [
        [-120.344582, 34.046492],
        [-120.369068, 34.076225],
        [-120.449203, 34.035866],
        [-120.308301, 34.018200],
        [-120.344582, 34.046492]
    ],
    [
        [-119.529426, 34.025248],
        [-119.564931, 34.055325],
        [-119.933019, 34.060229],
        [-119.817205, 33.959338],
        [-119.529426, 34.025248]
    ],
    [
        [-77.874420, 34.088121],
        [-77.860178, 34.100409],
        [-77.819203, 34.177476],
        [-77.844228, 34.166653],
        [-77.874420, 34.088121]
    ],
    [
        [-77.431874, 34.499661],
        [-77.578725, 34.425360],
        [-77.634185, 34.362494],
        [-77.353017, 34.527574],
        [-77.431874, 34.499661]
    ],
    [
        [-76.565338, 34.670966],
        [-76.634267, 34.691474],
        [-76.654775, 34.691474],
        [-76.537709, 34.642157],
        [-76.565338, 34.670966]
    ],
    [
        [-76.897450, 34.698228],
        [-76.681467, 34.705146],
        [-76.733551, 34.717597],
        [-76.897450, 34.698228]
    ],
    [
        [-76.256256, 34.913642],
        [-76.407786, 34.794420],
        [-76.525054, 34.637844],
        [-76.530629, 34.589057],
        [-76.256256, 34.913642]
    ],
    [
        [-76.078114, 35.071601],
        [-76.106435, 35.030341],
        [-76.147043, 34.992499],
        [-76.037180, 35.061347],
        [-76.078114, 35.071601]
    ],
    [
        [-75.989980, 35.123440],
        [-76.017323, 35.075019],
        [-75.939849, 35.126899],
        [-75.989980, 35.123440]
    ],
    [
        [-75.476064, 35.695380],
        [-75.516347, 35.291002],
        [-75.476064, 35.695380]
    ],
    [
        [-75.715688, 35.924750],
        [-75.659291, 35.836005],
        [-75.625356, 35.830146],
        [-75.661041, 35.924750],
        [-75.715688, 35.924750]
    ],
    [
        [-75.656127, 37.461506],
        [-75.676477, 37.455073],
        [-75.719214, 37.368298],
        [-75.660430, 37.443184],
        [-75.656127, 37.461506]
    ],
    [
        [-75.621981, 37.571120],
        [-75.674375, 37.485835],
        [-75.670617, 37.477057],
        [-75.599806, 37.575131],
        [-75.621981, 37.571120]
    ],
    [
        [-76.005365, 38.026514],
        [-76.051422, 37.994086],
        [-76.026368, 37.913515],
        [-75.981291, 37.992836],
        [-76.005365, 38.026514]
    ],
    [
        [-76.033230, 38.148551],
        [-76.048608, 38.200408],
        [-76.079009, 38.182844],
        [-76.083608, 38.160666],
        [-76.033230, 38.148551]
    ],
    [
        [-75.153310, 38.207017],
        [-75.358276, 37.874212],
        [-75.392913, 37.864699],
        [-75.378535, 37.855773],
        [-75.326039, 37.892279],
        [-75.189695, 38.089780],
        [-75.153310, 38.207017]
    ],
    [
        [-74.358795, 39.447170],
        [-74.399770, 39.399359],
        [-74.393381, 39.389146],
        [-74.302113, 39.464748],
        [-74.358795, 39.447170]
    ],
    [
        [-74.132883, 39.714667],
        [-74.240072, 39.575388],
        [-74.256418, 39.522203],
        [-74.132883, 39.714667]
    ],
    [
        [-73.256144, 40.639052],
        [-73.339384, 40.644593],
        [-73.320324, 40.635056],
        [-73.256144, 40.639052]
    ],
    [
        [-74.126088, 40.633490],
        [-74.191802, 40.628264],
        [-74.250831, 40.501397],
        [-74.053569, 40.602704],
        [-74.126088, 40.633490]
    ],
    [
        [-72.881511, 40.734400],
        [-73.040343, 40.681995],
        [-72.881511, 40.734400]
    ],
    [
        [-71.918935, 41.064887],
        [-72.624623, 40.907823],
        [-72.628326, 40.983588],
        [-73.485687, 40.945626],
        [-74.039990, 40.619786],
        [-73.710925, 40.610212],
        [-71.918935, 41.064887]
    ],
    [
        [-71.559474, 41.201024],
        [-71.579200, 41.225572],
        [-71.613748, 41.155181],
        [-71.549095, 41.152042],
        [-71.559474, 41.201024]
    ],
    [
        [-71.998734, 41.251666],
        [-71.970153, 41.273622],
        [-72.038798, 41.249447],
        [-71.998734, 41.251666]
    ],
    [
        [-70.054149, 41.392686],
        [-70.081939, 41.292548],
        [-69.967149, 41.249453],
        [-70.054149, 41.392686]
    ],
    [
        [-70.500600, 41.393622],
        [-70.465484, 41.360256],
        [-70.446685, 41.367418],
        [-70.455719, 41.429633],
        [-70.500600, 41.393622]
    ],
    [
        [-70.576405, 41.427802],
        [-70.605133, 41.474026],
        [-70.846221, 41.346666],
        [-70.507436, 41.362616],
        [-70.576405, 41.427802]
    ],
    [
        [-71.357818, 41.558173],
        [-71.377675, 41.577948],
        [-71.398793, 41.461900],
        [-71.365631, 41.495347],
        [-71.357818, 41.558173]
    ],
    [
        [-69.973012, 41.653713],
        [-69.981028, 41.627672],
        [-69.959381, 41.632636],
        [-69.973012, 41.653713]
    ],
    [
        [-71.285512, 41.581732],
        [-71.308827, 41.495429],
        [-71.354563, 41.458319],
        [-71.233632, 41.489203],
        [-71.220611, 41.660549],
        [-71.285512, 41.581732]
    ],
    [
        [50.260265, 45.009914],
        [50.277110, 45.071519],
        [50.348399, 45.084906],
        [50.324555, 44.973212],
        [50.260265, 45.009914]
    ],
    [
        [-123.973997, 46.492930],
        [-123.997763, 46.453397],
        [-123.964121, 46.406791],
        [-123.948180, 46.464190],
        [-123.973997, 46.492930]
    ],
    [
        [-122.435129, 47.425727],
        [-122.471018, 47.495795],
        [-122.527252, 47.346259],
        [-122.366811, 47.383531],
        [-122.435129, 47.425727]
    ],
    [
        [-122.496938, 47.607123],
        [-122.510976, 47.695868],
        [-122.557769, 47.713813],
        [-122.577870, 47.601549],
        [-122.496938, 47.607123]
    ],
    [
        [-122.729319, 48.096747],
        [-122.730784, 48.042426],
        [-122.681508, 48.007270],
        [-122.686879, 48.073228],
        [-122.729319, 48.096747]
    ],
    [
        [-122.359364, 47.976630],
        [-122.535512, 48.005927],
        [-122.580637, 48.188463],
        [-122.723704, 48.233791],
        [-122.517568, 48.294013],
        [-122.656565, 48.385077],
        [-122.744130, 48.205878],
        [-122.539215, 47.972154],
        [-122.359364, 47.976630]
    ],
    [
        [-122.861928, 48.489325],
        [-122.887074, 48.563666],
        [-122.937611, 48.458319],
        [-122.827748, 48.417385],
        [-122.861928, 48.489325]
    ],
    [
        [-122.693715, 48.585924],
        [-122.735422, 48.590399],
        [-122.714345, 48.541938],
        [-122.674550, 48.568793],
        [-122.693715, 48.585924]
    ],
    [
        [-123.020172, 48.499335],
        [-122.977651, 48.531317],
        [-123.177561, 48.598822],
        [-123.139312, 48.495836],
        [-122.964955, 48.451483],
        [-123.020172, 48.499335]
    ],
    [
        [-123.286936, 48.612698],
        [-123.305287, 48.618801],
        [-123.337473, 48.648424],
        [-123.302887, 48.596991],
        [-123.286936, 48.612698]
    ],
    [
        [-122.745839, 48.664374],
        [-122.917958, 48.711412],
        [-123.026519, 48.626532],
        [-122.874379, 48.593736],
        [-122.896352, 48.699774],
        [-122.745839, 48.664374]
    ],
    [
        [-122.621409, 48.668524],
        [-122.698476, 48.734687],
        [-122.715159, 48.739081],
        [-122.655141, 48.664740],
        [-122.621409, 48.668524]
    ],
    [
        [-123.369008, 48.774237],
        [-123.496002, 48.845526],
        [-123.595570, 48.951809],
        [-123.531117, 48.734361],
        [-123.369008, 48.774237]
    ],
    [
        [-123.653920, 49.033677],
        [-123.394521, 48.872382],
        [-123.317128, 48.869818],
        [-123.697255, 49.109320],
        [-123.653920, 49.033677]
    ],
    [
        [-123.721262, 49.160793],
        [-123.833852, 49.201158],
        [-123.869781, 49.190497],
        [-123.776682, 49.133287],
        [-123.721262, 49.160793]
    ],
    [
        [-125.949941, 49.200751],
        [-126.006459, 49.214057],
        [-126.035024, 49.201809],
        [-125.968902, 49.148749],
        [-125.949941, 49.200751]
    ],
    [
        [-126.083323, 49.314887],
        [-126.131703, 49.396796],
        [-126.231435, 49.378607],
        [-126.223541, 49.277086],
        [-126.083323, 49.314887]
    ],
    [
        [-123.330678, 49.372870],
        [-123.349965, 49.417548],
        [-123.429433, 49.346747],
        [-123.375885, 49.337104],
        [-123.330678, 49.372870]
    ],
    [
        [-124.232167, 49.499335],
        [-124.354604, 49.522406],
        [-124.379058, 49.507270],
        [-124.171702, 49.454739],
        [-124.232167, 49.499335]
    ],
    [
        [-123.451568, 49.445217],
        [-123.342681, 49.442939],
        [-123.322499, 49.486070],
        [-123.418121, 49.530911],
        [-123.451568, 49.445217]
    ],
    [
        [-124.607411, 49.530911],
        [-124.683746, 49.549262],
        [-124.703765, 49.521186],
        [-124.662913, 49.494330],
        [-124.607411, 49.530911]
    ],
    [
        [-124.708730, 49.497016],
        [-124.792470, 49.579739],
        [-124.836049, 49.597724],
        [-124.825429, 49.540107],
        [-124.708730, 49.497016]
    ],
    [
        [-124.109486, 49.677965],
        [-124.074534, 49.741360],
        [-124.020131, 49.780992],
        [-124.205068, 49.705268],
        [-124.109486, 49.677965]
    ],
    [
        [-124.664418, 49.746894],
        [-124.438832, 49.611884],
        [-124.123158, 49.499823],
        [-124.347890, 49.704169],
        [-124.664418, 49.746894]
    ],
    [
        [-126.658681, 49.787828],
        [-126.768544, 49.883450],
        [-126.987050, 49.815131],
        [-126.679433, 49.591783],
        [-126.658681, 49.787828]
    ],
    [
        [-127.240631, 50.021715],
        [-127.286000, 50.037055],
        [-127.318593, 49.999579],
        [-127.272328, 49.977973],
        [-127.240631, 50.021715]
    ],
    [
        [-125.027496, 50.144110],
        [-125.005483, 50.017646],
        [-124.890981, 50.069037],
        [-124.995676, 50.232082],
        [-125.027496, 50.144110]
    ],
    [
        [-125.198842, 50.041083],
        [-125.171457, 50.218980],
        [-125.336008, 50.274482],
        [-125.323720, 50.143256],
        [-125.198842, 50.041083]
    ],
    [
        [-124.890981, 50.192532],
        [-124.832346, 50.117377],
        [-124.753774, 50.168280],
        [-124.917063, 50.303453],
        [-124.890981, 50.192532]
    ],
    [
        [-124.802642, 50.228583],
        [-124.723297, 50.292873],
        [-124.725087, 50.304511],
        [-124.802642, 50.228583]
    ],
    [
        [-125.336008, 50.301744],
        [-125.142201, 50.125800],
        [-125.047963, 50.205552],
        [-125.287953, 50.437405],
        [-125.336008, 50.301744]
    ],
    [
        [-125.502268, 50.413804],
        [-125.546864, 50.443427],
        [-125.783355, 50.397406],
        [-125.635813, 50.382514],
        [-125.502268, 50.413804]
    ],
    [
        [-125.367991, 50.461127],
        [-125.478017, 50.429511],
        [-125.544789, 50.377834],
        [-125.392405, 50.367418],
        [-125.367991, 50.461127]
    ],
    [
        [-125.749135, 50.421820],
        [-125.805816, 50.475043],
        [-125.965443, 50.438218],
        [-125.823638, 50.408840],
        [-125.749135, 50.421820]
    ],
    [
        [-126.537709, 50.583808],
        [-126.586903, 50.594875],
        [-126.670888, 50.589586],
        [-126.614898, 50.552680],
        [-126.537709, 50.583808]
    ],
    [
        [-126.336537, 50.603461],
        [-126.367584, 50.582953],
        [-126.226674, 50.569281],
        [-126.336537, 50.603461]
    ],
    [
        [-126.403798, 50.629828],
        [-126.471262, 50.628241],
        [-126.558502, 50.603176],
        [-126.363515, 50.618842],
        [-126.403798, 50.629828]
    ],
    [
        [-126.859283, 50.645738],
        [-127.107493, 50.671088],
        [-127.150380, 50.639960],
        [-126.833079, 50.625230],
        [-126.859283, 50.645738]
    ],
    [
        [-126.617665, 50.672309],
        [-126.288075, 50.654608],
        [-126.178863, 50.750800],
        [-126.289459, 50.828559],
        [-126.617665, 50.672309]
    ],
    [
        [-126.782135, 50.774726],
        [-126.768544, 50.788398],
        [-126.782135, 50.774726]
    ],
    [
        [-123.321197, 48.495836],
        [-123.416819, 48.691107],
        [-123.535471, 48.540107],
        [-123.579945, 48.821601],
        [-123.954945, 49.229193],
        [-124.794749, 49.472561],
        [-125.476715, 50.339016],
        [-126.864247, 50.530097],
        [-127.882476, 50.866889],
        [-128.417226, 50.771877],
        [-128.060170, 50.452582],
        [-127.592600, 50.543606],
        [-127.634836, 50.579657],
        [-127.799469, 50.589179],
        [-127.877675, 50.630113],
        [-127.419016, 50.603461],
        [-127.562489, 50.521064],
        [-127.446929, 50.376899],
        [-127.925771, 50.462104],
        [-127.968088, 50.342231],
        [-127.746978, 50.243232],
        [-127.898101, 50.114081],
        [-127.463450, 50.186957],
        [-127.362538, 50.032538],
        [-127.096913, 50.150946],
        [-127.237538, 49.961819],
        [-127.141916, 49.866645],
        [-126.843617, 49.973456],
        [-126.573110, 49.706936],
        [-126.107493, 49.683295],
        [-126.548818, 49.596015],
        [-126.572662, 49.414293],
        [-126.055084, 49.445299],
        [-126.014394, 49.322333],
        [-126.028066, 49.273871],
        [-125.774770, 49.370103],
        [-125.746693, 49.148139],
        [-125.871693, 49.090155],
        [-125.606557, 48.961859],
        [-124.907704, 49.006415],
        [-124.808420, 49.246568],
        [-124.846995, 49.020453],
        [-125.185170, 48.800971],
        [-125.093984, 48.730048],
        [-123.653920, 48.314276],
        [-123.321197, 48.495836]
    ],
    [
        [-127.845570, 50.922919],
        [-127.915395, 50.939643],
        [-127.983022, 50.916734],
        [-127.874989, 50.890367],
        [-127.845570, 50.922919]
    ],
    [
        [-127.545318, 51.089789],
        [-127.557851, 51.089301],
        [-127.611684, 51.075100],
        [-127.541982, 51.052151],
        [-127.545318, 51.089789]
    ],
    [
        [-131.681264, 52.842108],
        [-131.759429, 52.857123],
        [-131.837636, 52.840969],
        [-131.743520, 52.811347],
        [-131.681264, 52.842108]
    ],
    [
        [-132.229644, 52.995185],
        [-132.364735, 53.007310],
        [-132.382558, 53.004096],
        [-132.303090, 52.966702],
        [-132.229644, 52.995185]
    ],
    [
        [-166.094553, 53.980658],
        [-166.156565, 53.993598],
        [-166.196116, 53.981024],
        [-166.153920, 53.955308],
        [-166.094553, 53.980658]
    ],
    [
        [-132.978505, 54.245998],
        [-133.061391, 54.256252],
        [-133.081776, 54.231757],
        [-133.000478, 54.190090],
        [-132.978505, 54.245998]
    ],
    [
        [-159.521474, 54.792263],
        [-159.571278, 54.822252],
        [-159.604197, 54.812323],
        [-159.569325, 54.754584],
        [-159.521474, 54.792263]
    ],
    [
        [-161.333567, 55.191474],
        [-161.354360, 55.221503],
        [-161.439687, 55.197333],
        [-161.360463, 55.163031],
        [-161.333567, 55.191474]
    ],
    [
        [-161.559031, 55.254462],
        [-161.658884, 55.242377],
        [-161.691721, 55.211615],
        [-161.564076, 55.207913],
        [-161.559031, 55.254462]
    ],
    [
        [-160.036244, 55.326199],
        [-160.066599, 55.344713],
        [-160.109080, 55.325751],
        [-160.039988, 55.307074],
        [-160.036244, 55.326199]
    ],
    [
        [-159.312734, 55.811225],
        [-159.332834, 55.812445],
        [-159.362294, 55.786282],
        [-159.302113, 55.759223],
        [-159.312734, 55.811225]
    ],
    [
        [-156.680409, 56.039008],
        [-156.701283, 56.066148],
        [-156.746165, 56.034898],
        [-156.694936, 56.009345],
        [-156.680409, 56.039008]
    ],
    [
        [-156.779897, 56.189643],
        [-156.792063, 56.153022],
        [-156.766550, 56.167670],
        [-156.779897, 56.189643]
    ],
    [
        [-157.812327, 56.342882],
        [-157.856557, 56.362128],
        [-157.898386, 56.339057],
        [-157.833323, 56.313666],
        [-157.812327, 56.342882]
    ],
    [
        [-153.833811, 57.502021],
        [-153.887807, 57.508979],
        [-153.843577, 57.436225],
        [-153.829294, 57.451077],
        [-153.833811, 57.502021]
    ],
    [
        [-152.343902, 57.923326],
        [-152.432322, 57.969184],
        [-152.504832, 57.925727],
        [-152.369374, 57.886420],
        [-152.343902, 57.923326]
    ],
    [
        [-152.744374, 57.983832],
        [-152.833079, 57.974595],
        [-152.860707, 57.954657],
        [-152.764109, 57.930080],
        [-152.744374, 57.983832]
    ],
    [
        [-152.811350, 58.290351],
        [-152.846059, 58.337592],
        [-152.930613, 58.328559],
        [-152.902699, 58.307685],
        [-152.811350, 58.290351]
    ],
    [
        [-160.258738, 58.678616],
        [-160.275867, 58.679436],
        [-160.301242, 58.729354],
        [-160.277180, 58.636693],
        [-160.258738, 58.678616]
    ],
    [
        [-160.384592, 58.730862],
        [-160.405998, 58.751282],
        [-160.433095, 58.684638],
        [-160.393015, 58.699652],
        [-160.384592, 58.730862]
    ],
    [
        [-44.598012, 59.964057],
        [-44.542714, 59.944892],
        [-44.514882, 59.977688],
        [-44.558420, 59.986640],
        [-44.598012, 59.964057]
    ],
    [
        [-44.350982, 59.984524],
        [-44.203684, 60.053168],
        [-44.442942, 60.137885],
        [-44.494700, 60.011176],
        [-44.350982, 59.984524]
    ],
    [
        [-44.203603, 60.107367],
        [-44.138661, 60.041327],
        [-44.008412, 60.046576],
        [-44.208119, 60.175279],
        [-44.203603, 60.107367]
    ],
    [
        [-45.303782, 60.142157],
        [-45.221262, 60.149604],
        [-45.221262, 60.170111],
        [-45.269683, 60.184516],
        [-45.303782, 60.142157]
    ],
    [
        [-45.152943, 60.382392],
        [-45.349762, 60.389472],
        [-45.411366, 60.194525],
        [-45.183339, 60.272528],
        [-45.152943, 60.382392]
    ],
    [
        [-45.056142, 60.382392],
        [-45.002105, 60.450629],
        [-45.132151, 60.433783],
        [-45.116038, 60.388129],
        [-45.056142, 60.382392]
    ],
    [
        [-44.995269, 60.413072],
        [-45.004506, 60.386176],
        [-45.118235, 60.313463],
        [-45.008372, 60.347602],
        [-44.926381, 60.436957],
        [-44.995269, 60.413072]
    ],
    [
        [-45.358388, 60.477973],
        [-45.382436, 60.478095],
        [-45.440297, 60.430813],
        [-45.395334, 60.427191],
        [-45.358388, 60.477973]
    ],
    [
        [-64.477447, 60.333930],
        [-64.641347, 60.492255],
        [-64.861562, 60.465522],
        [-64.426666, 60.286200],
        [-64.477447, 60.333930]
    ],
    [
        [-67.880798, 60.496805],
        [-68.241306, 60.585606],
        [-68.419382, 60.209676],
        [-67.972847, 60.290296],
        [-67.880798, 60.496805]
    ],
    [
        [-45.974721, 60.669745],
        [-45.978505, 60.623277],
        [-45.782948, 60.662909],
        [-45.955190, 60.681952],
        [-45.974721, 60.669745]
    ],
    [
        [-64.610260, 60.690172],
        [-64.716461, 60.604926],
        [-64.713531, 60.597642],
        [-64.625559, 60.614569],
        [-64.610260, 60.690172]
    ],
    [
        [-45.892812, 60.697699],
        [-45.908355, 60.704291],
        [-46.176869, 60.688056],
        [-46.207509, 60.676581],
        [-45.892812, 60.697699]
    ],
    [
        [-46.632680, 60.752346],
        [-46.637318, 60.735500],
        [-46.509145, 60.752346],
        [-46.568349, 60.774359],
        [-46.632680, 60.752346]
    ],
    [
        [-46.276357, 60.772773],
        [-46.390859, 60.764228],
        [-46.502349, 60.703925],
        [-46.345286, 60.669745],
        [-46.276357, 60.772773]
    ],
    [
        [-47.317942, 60.813137],
        [-47.358876, 60.792670],
        [-47.312489, 60.801744],
        [-47.317942, 60.813137]
    ],
    [
        [-47.002594, 60.806952],
        [-47.030344, 60.814154],
        [-47.051015, 60.800116],
        [-46.986806, 60.776313],
        [-47.002594, 60.806952]
    ],
    [
        [-47.222320, 60.813137],
        [-47.183176, 60.799302],
        [-47.146596, 60.813137],
        [-47.195058, 60.827053],
        [-47.222320, 60.813137]
    ],
    [
        [-46.303090, 60.820543],
        [-46.357167, 60.825751],
        [-46.427235, 60.800116],
        [-46.365305, 60.784857],
        [-46.303090, 60.820543]
    ],
    [
        [-78.243723, 60.834866],
        [-78.616078, 60.776435],
        [-78.696116, 60.714097],
        [-78.278472, 60.772773],
        [-78.243723, 60.834866]
    ],
    [
        [-47.194407, 60.841010],
        [-47.117340, 60.826850],
        [-47.084543, 60.868354],
        [-47.171742, 60.852240],
        [-47.194407, 60.841010]
    ],
    [
        [-47.181386, 60.875800],
        [-47.227895, 60.879218],
        [-47.255849, 60.851264],
        [-47.220041, 60.852118],
        [-47.181386, 60.875800]
    ],
    [
        [-47.173940, 60.882025],
        [-47.098053, 60.899156],
        [-47.071523, 60.930406],
        [-47.112457, 60.930406],
        [-47.173940, 60.882025]
    ],
    [
        [-47.051015, 60.895697],
        [-46.988881, 60.911078],
        [-46.961659, 60.930406],
        [-47.011871, 60.926337],
        [-47.051015, 60.895697]
    ],
    [
        [-46.553863, 60.796332],
        [-46.391591, 60.860785],
        [-46.553863, 60.796332]
    ],
    [
        [-46.529652, 60.991889],
        [-46.516591, 60.937242],
        [-46.426259, 60.938056],
        [-46.427235, 60.978217],
        [-46.529652, 60.991889]
    ],
    [
        [-48.161122, 61.057074],
        [-48.373118, 61.081244],
        [-48.331451, 61.059556],
        [-48.161122, 61.057074]
    ],
    [
        [-150.210846, 61.173041],
        [-150.224355, 61.170396],
        [-150.276438, 61.127387],
        [-150.177724, 61.161363],
        [-150.210846, 61.173041]
    ],
    [
        [-48.934804, 61.265611],
        [-48.723134, 61.293524],
        [-48.847035, 61.304592],
        [-48.934804, 61.265611]
    ],
    [
        [-48.688710, 61.369289],
        [-48.832997, 61.341295],
        [-48.515533, 61.336575],
        [-48.558949, 61.372870],
        [-48.688710, 61.369289]
    ],
    [
        [-64.840566, 61.351549],
        [-64.717030, 61.663479],
        [-65.484242, 61.622504],
        [-64.975413, 61.349351],
        [-64.840566, 61.351549]
    ],
    [
        [-49.164784, 61.701361],
        [-49.216624, 61.656684],
        [-49.086497, 61.642890],
        [-49.085683, 61.677151],
        [-49.164784, 61.701361]
    ],
    [
        [-65.703277, 61.793158],
        [-65.791493, 61.872504],
        [-65.946401, 61.801093],
        [-65.691518, 61.750393],
        [-65.703277, 61.793158]
    ],
    [
        [-93.025461, 61.916693],
        [-93.066396, 61.937812],
        [-93.224680, 61.906440],
        [-93.058909, 61.829901],
        [-93.025461, 61.916693]
    ],
    [
        [-65.241200, 61.920396],
        [-65.147328, 61.783922],
        [-64.827870, 61.761176],
        [-64.977773, 61.896877],
        [-65.241200, 61.920396]
    ],
    [
        [-92.271881, 62.407375],
        [-92.340199, 62.417629],
        [-92.374908, 62.390326],
        [-92.271881, 62.407375]
    ],
    [
        [-79.282460, 62.269924],
        [-79.539703, 62.417629],
        [-79.934565, 62.378050],
        [-80.214973, 62.137658],
        [-80.261091, 61.856298],
        [-79.758860, 61.582180],
        [-79.325999, 61.988430],
        [-79.282460, 62.269924]
    ],
    [
        [-92.576650, 62.403957],
        [-92.402211, 62.410793],
        [-92.528920, 62.433010],
        [-92.576650, 62.403957]
    ],
    [
        [-64.380605, 62.527493],
        [-64.801340, 62.568508],
        [-64.963490, 62.464789],
        [-64.594146, 62.369818],
        [-64.380605, 62.527493]
    ],
    [
        [-77.853912, 62.588324],
        [-77.886952, 62.599189],
        [-78.113352, 62.574652],
        [-77.860585, 62.550482],
        [-77.853912, 62.588324]
    ],
    [
        [-77.722971, 62.588324],
        [-77.764556, 62.602607],
        [-77.833485, 62.602607],
        [-77.762074, 62.540025],
        [-77.620513, 62.588324],
        [-77.722971, 62.588324]
    ],
    [
        [-64.966908, 62.533677],
        [-64.840566, 62.582099],
        [-65.141591, 62.554145],
        [-65.114410, 62.538479],
        [-64.966908, 62.533677]
    ],
    [
        [-91.592885, 62.650946],
        [-91.670725, 62.671047],
        [-91.689076, 62.670844],
        [-91.575103, 62.624416],
        [-91.592885, 62.650946]
    ],
    [
        [-91.134145, 62.684516],
        [-91.134145, 62.684516]
    ],
    [
        [-74.016225, 62.670844],
        [-74.530141, 62.753363],
        [-74.653066, 62.719306],
        [-73.964711, 62.609442],
        [-74.016225, 62.670844]
    ],
    [
        [-70.240590, 62.615627],
        [-70.492493, 62.766957],
        [-70.773997, 62.771308],
        [-70.925160, 62.745917],
        [-70.727895, 62.553412],
        [-70.240590, 62.615627]
    ],
    [
        [-82.191314, 62.986151],
        [-83.418691, 62.892279],
        [-83.939809, 62.423814],
        [-83.705190, 62.143500],
        [-83.066151, 62.187161],
        [-81.939809, 62.711615],
        [-81.862375, 62.924750],
        [-82.191314, 62.986151]
    ],
    [
        [-164.586903, 63.064439],
        [-164.611562, 63.055894],
        [-164.611806, 63.046698],
        [-164.567006, 63.046291],
        [-164.586903, 63.064439]
    ],
    [
        [-50.686106, 63.099066],
        [-50.703114, 63.088324],
        [-50.758412, 63.068061],
        [-50.679270, 63.023668],
        [-50.686106, 63.099066]
    ],
    [
        [-50.682688, 63.123358],
        [-50.771962, 63.191840],
        [-50.880035, 63.138414],
        [-50.817209, 63.084052],
        [-50.682688, 63.123358]
    ],
    [
        [-50.497670, 63.174506],
        [-50.571441, 63.212836],
        [-50.679799, 63.148505],
        [-50.624338, 63.116523],
        [-50.497670, 63.174506]
    ],
    [
        [-90.620229, 63.479560],
        [-90.651112, 63.490302],
        [-90.756825, 63.500067],
        [-90.702219, 63.444892],
        [-90.620229, 63.479560]
    ],
    [
        [-77.537994, 63.287787],
        [-77.844309, 63.472480],
        [-78.544272, 63.449184],
        [-77.940764, 63.087149],
        [-77.537994, 63.287787]
    ],
    [
        [-90.674875, 63.521186],
        [-90.761301, 63.553941],
        [-90.969716, 63.554755],
        [-90.811757, 63.500067],
        [-90.674875, 63.521186]
    ],
    [
        [-91.463124, 63.616767],
        [-91.539133, 63.607001],
        [-91.298655, 63.567776],
        [-91.359486, 63.592719],
        [-91.463124, 63.616767]
    ],
    [
        [-64.086415, 63.335028],
        [-64.354888, 63.668850],
        [-64.497914, 63.616767],
        [-64.279205, 63.341132],
        [-64.086415, 63.335028]
    ],
    [
        [-76.688873, 63.485826],
        [-77.120269, 63.685045],
        [-77.446116, 63.661119],
        [-76.982086, 63.407294],
        [-76.544911, 63.466539],
        [-76.688873, 63.485826]
    ],
    [
        [-72.474436, 63.705512],
        [-72.500600, 63.712795],
        [-72.782867, 63.664537],
        [-72.599721, 63.646674],
        [-72.474436, 63.705512]
    ],
    [
        [-92.977651, 63.904202],
        [-92.996897, 63.913235],
        [-93.093658, 63.910956],
        [-92.971669, 63.874661],
        [-92.977651, 63.904202]
    ],
    [
        [-64.888336, 63.794908],
        [-64.457672, 63.677395],
        [-64.388051, 63.732856],
        [-64.613393, 63.787502],
        [-64.562571, 63.908596],
        [-64.888336, 63.794908]
    ],
    [
        [-77.973378, 63.965562],
        [-77.737213, 63.932074],
        [-77.545481, 64.027655],
        [-77.905385, 64.024482],
        [-77.973378, 63.965562]
    ],
    [
        [-52.066762, 64.164862],
        [-52.044735, 64.104883],
        [-51.881665, 64.167514],
        [-51.895497, 64.191555],
        [-52.066762, 64.164862]
    ],
    [
        [-81.468821, 64.191555],
        [-81.423085, 64.196479],
        [-81.382558, 64.213202],
        [-81.536773, 64.223212],
        [-81.468821, 64.191555]
    ],
    [
        [-73.276357, 64.219428],
        [-73.337758, 64.239936],
        [-73.399810, 64.164862],
        [-73.173329, 64.205797],
        [-73.276357, 64.219428]
    ],
    [
        [-50.805531, 64.527981],
        [-51.031728, 64.550930],
        [-51.338612, 64.245795],
        [-51.155344, 64.254218],
        [-50.805531, 64.527981]
    ],
    [
        [-73.529612, 64.504055],
        [-73.577992, 64.493150],
        [-73.654205, 64.323228],
        [-73.529612, 64.504055]
    ],
    [
        [-51.299306, 64.380805],
        [-51.176137, 64.459662],
        [-51.094146, 64.569525],
        [-51.515207, 64.394477],
        [-51.299306, 64.380805]
    ],
    [
        [-65.546254, 64.548407],
        [-65.390940, 64.562079],
        [-65.209828, 64.643988],
        [-65.411936, 64.739814],
        [-65.688140, 64.547593],
        [-65.546254, 64.548407]
    ],
    [
        [-62.257232, 65.748236],
        [-62.469635, 65.748847],
        [-62.485707, 65.723700],
        [-62.134389, 65.654527],
        [-62.257232, 65.748236]
    ],
    [
        [-83.503407, 65.809719],
        [-83.289540, 65.835191],
        [-83.291168, 65.846869],
        [-83.582509, 65.861518],
        [-83.503407, 65.809719]
    ],
    [
        [-80.183339, 63.767564],
        [-80.674631, 63.893988],
        [-80.496897, 63.917670],
        [-80.888783, 64.122626],
        [-80.930653, 63.993476],
        [-81.398834, 64.101508],
        [-81.606597, 64.134101],
        [-81.771311, 64.512030],
        [-83.208363, 64.947699],
        [-83.397694, 65.136623],
        [-84.098459, 65.209540],
        [-84.554677, 65.485907],
        [-84.931793, 65.218207],
        [-85.007639, 65.415717],
        [-85.316477, 65.541490],
        [-85.052358, 65.614163],
        [-85.171864, 65.789130],
        [-85.488271, 65.796617],
        [-85.486511, 65.924136],
        [-85.938935, 65.763198],
        [-86.151519, 65.396145],
        [-86.173004, 64.829576],
        [-86.419423, 64.596869],
        [-86.192860, 64.103420],
        [-86.895904, 63.930243],
        [-87.223785, 63.660142],
        [-86.868153, 63.561754],
        [-85.713735, 63.774400],
        [-85.635162, 63.243109],
        [-85.273915, 63.123358],
        [-84.590240, 63.315131],
        [-84.284250, 63.626776],
        [-83.633778, 63.770982],
        [-83.685292, 64.014065],
        [-83.084299, 64.189846],
        [-82.965810, 64.137030],
        [-83.084543, 63.958197],
        [-82.370920, 63.913031],
        [-82.481760, 63.685207],
        [-81.124908, 63.463813],
        [-80.183339, 63.767564]
    ],
    [
        [-85.001129, 66.007636],
        [-85.179311, 65.987779],
        [-85.112660, 65.762112],
        [-84.800893, 65.567084],
        [-84.574086, 65.635647],
        [-85.001129, 66.007636]
    ],
    [
        [-84.473541, 66.090237],
        [-84.124582, 65.906684],
        [-84.142730, 65.766750],
        [-83.685292, 65.755072],
        [-83.838857, 65.652248],
        [-83.212310, 65.706000],
        [-83.786366, 65.812812],
        [-83.692738, 65.925727],
        [-84.021352, 66.087714],
        [-84.473541, 66.090237]
    ],
    [
        [-83.273793, 66.309312],
        [-83.077626, 66.197821],
        [-82.904449, 66.268378],
        [-83.233144, 66.344062],
        [-83.273793, 66.309312]
    ],
    [
        [-62.407460, 67.186957],
        [-62.638987, 67.178412],
        [-62.901519, 67.063422],
        [-62.746897, 67.018052],
        [-62.407460, 67.186957]
    ],
    [
        [-63.517893, 67.324164],
        [-63.631581, 67.356106],
        [-63.833160, 67.289984],
        [-63.360219, 67.296210],
        [-63.517893, 67.324164]
    ],
    [
        [-63.757476, 67.522773],
        [-63.954701, 67.654975],
        [-64.037994, 67.529608],
        [-63.982411, 67.506741],
        [-63.757476, 67.522773]
    ],
    [
        [-73.358266, 67.838080],
        [-73.446156, 67.992987],
        [-74.338368, 68.180732],
        [-74.775217, 68.029364],
        [-74.402333, 67.778876],
        [-73.358266, 67.838080]
    ],
    [
        [-66.296376, 68.269477],
        [-66.327748, 68.235907],
        [-66.661122, 68.209459],
        [-66.270579, 68.161444],
        [-66.183095, 68.262641],
        [-66.296376, 68.269477]
    ],
    [
        [-86.577138, 68.290595],
        [-86.987375, 68.084296],
        [-86.680084, 67.735053],
        [-86.372467, 67.936591],
        [-86.407826, 68.207750],
        [-86.577138, 68.290595]
    ],
    [
        [-75.033518, 68.173285],
        [-75.911204, 68.344550],
        [-76.688873, 68.262641],
        [-77.322662, 67.707994],
        [-76.981557, 67.243313],
        [-75.595855, 67.311103],
        [-75.065053, 67.552436],
        [-75.161366, 67.953111],
        [-75.033518, 68.173285]
    ],
    [
        [-78.909047, 68.324042],
        [-79.156117, 68.344550],
        [-79.183461, 68.221666],
        [-78.829986, 68.252672],
        [-78.909047, 68.324042]
    ],
    [
        [-82.081410, 68.307318],
        [-82.000111, 68.351386],
        [-82.149322, 68.334418],
        [-82.081410, 68.307318]
    ],
    [
        [-74.368764, 68.389228],
        [-74.221669, 68.249579],
        [-74.080719, 68.332709],
        [-74.297760, 68.464423],
        [-74.368764, 68.389228]
    ],
    [
        [-78.614247, 68.506293],
        [-78.724192, 68.523342],
        [-78.463450, 68.619534],
        [-78.886301, 68.658881],
        [-78.668853, 68.584784],
        [-78.970570, 68.474921],
        [-78.614247, 68.506293]
    ],
    [
        [-74.844838, 68.578559],
        [-74.788197, 68.561347],
        [-74.517079, 68.564276],
        [-74.792592, 68.675686],
        [-74.844838, 68.578559]
    ],
    [
        [-74.838002, 68.420233],
        [-75.019887, 68.680976],
        [-75.400380, 68.608710],
        [-74.996246, 68.337714],
        [-74.838002, 68.420233]
    ],
    [
        [-68.006093, 68.770331],
        [-68.417592, 68.817532],
        [-68.458567, 68.793647],
        [-68.006093, 68.770331]
    ],
    [
        [-90.182037, 69.119208],
        [-90.154693, 69.139635],
        [-90.276763, 69.114000],
        [-90.127431, 69.057766],
        [-90.182037, 69.119208]
    ],
    [
        [-90.497385, 69.242662],
        [-90.618967, 69.376370],
        [-90.655995, 69.349799],
        [-90.685414, 69.229071],
        [-90.497385, 69.242662]
    ],
    [
        [-79.079823, 68.878974],
        [-78.846588, 68.907904],
        [-78.214019, 69.302883],
        [-78.710113, 69.341620],
        [-78.621693, 69.263129],
        [-79.423004, 68.927395],
        [-79.079823, 68.878974]
    ],
    [
        [-90.250356, 69.297919],
        [-90.201894, 69.448147],
        [-90.506744, 69.366645],
        [-90.327626, 69.238959],
        [-90.250356, 69.297919]
    ],
    [
        [-76.692291, 69.410875],
        [-77.250111, 69.435126],
        [-77.387196, 69.266547],
        [-76.901194, 69.105536],
        [-76.692291, 69.410875]
    ],
    [
        [-67.444325, 69.592108],
        [-67.520090, 69.605780],
        [-67.752838, 69.523261],
        [-67.307769, 69.558051],
        [-67.444325, 69.592108]
    ],
    [
        [-67.909901, 69.533759],
        [-67.731068, 69.658759],
        [-68.307729, 69.592108],
        [-67.967437, 69.529853],
        [-67.909901, 69.533759]
    ],
    [
        [-78.394521, 69.646715],
        [-78.566477, 69.646715],
        [-78.880727, 69.480658],
        [-77.942047, 69.646715],
        [-78.176096, 69.756415],
        [-78.394521, 69.646715]
    ],
    [
        [-79.971059, 69.633124],
        [-79.326812, 69.708808],
        [-79.672434, 69.820380],
        [-80.814036, 69.694525],
        [-79.998647, 69.500149],
        [-80.077504, 69.636868],
        [-79.971059, 69.633124]
    ],
    [
        [-83.836090, 69.749823],
        [-83.701039, 69.722805],
        [-83.527659, 69.790758],
        [-83.897572, 69.818671],
        [-83.836090, 69.749823]
    ],
    [
        [54.746837, 40.995673],
        [54.073985, 41.487982],
        [53.906912, 42.062934],
        [53.681814, 42.143948],
        [52.937022, 41.955390],
        [52.769216, 41.675605],
        [52.916515, 41.674221],
        [52.875499, 41.050442],
        [52.437673, 41.748847],
        [52.402029, 42.092515],
        [52.676280, 42.538479],
        [52.563813, 42.742255],
        [52.710460, 42.585395],
        [52.736339, 42.701361],
        [52.169200, 42.887030],
        [51.912446, 42.842353],
        [51.651052, 43.191392],
        [51.275727, 43.154486],
        [51.314708, 43.462470],
        [50.847179, 44.189276],
        [50.230154, 44.390937],
        [50.311209, 44.662340],
        [51.560313, 44.511379],
        [50.962413, 44.863674],
        [50.959321, 44.978827],
        [51.272960, 45.024644],
        [51.415701, 45.389960],
        [53.261241, 45.342841],
        [52.731944, 45.554145],
        [53.156749, 46.272284],
        [52.998383, 46.484565],
        [53.204600, 46.655829],
        [53.051931, 46.898424],
        [52.455903, 47.001166],
        [52.112559, 46.812730],
        [51.212576, 47.120917],
        [49.817393, 46.540432],
        [49.305349, 46.587592],
        [49.366873, 46.388983],
        [49.168224, 46.409410],
        [49.298513, 46.251776],
        [49.150157, 46.335761],
        [49.114513, 46.151272],
        [48.626964, 46.087307],
        [48.791352, 45.840888],
        [48.554942, 45.967475],
        [47.818207, 45.608100],
        [47.560069, 45.771552],
        [47.653656, 45.559068],
        [47.503429, 45.717353],
        [47.384776, 45.750190],
        [47.572113, 45.566962],
        [47.370128, 45.185614],
        [47.078298, 44.785102],
        [47.003184, 44.921576],
        [46.722016, 44.655341],
        [46.711274, 44.431830],
        [47.245942, 44.211982],
        [47.489268, 43.815579],
        [47.544444, 43.865220],
        [47.701508, 43.874498],
        [47.452810, 43.080797],
        [47.727306, 42.662787],
        [49.027599, 41.431220],
        [49.538910, 40.653998],
        [50.052013, 40.584296],
        [50.360525, 40.365180],
        [50.387869, 40.221137],
        [49.893403, 40.369045],
        [49.503591, 40.164944],
        [49.284923, 39.522203],
        [49.407074, 39.289496],
        [49.247325, 39.310696],
        [49.118826, 38.975328],
        [49.058930, 39.172797],
        [48.934825, 39.124416],
        [48.874848, 38.242743],
        [48.993663, 37.776760],
        [49.205577, 37.581692],
        [50.195649, 37.389350],
        [50.322276, 37.153266],
        [51.004731, 36.767646],
        [51.909028, 36.582709],
        [53.609141, 36.876899],
        [54.014334, 36.821112],
        [54.033539, 36.949123],
        [53.807140, 38.031968],
        [53.982758, 38.916002],
        [53.701508, 39.078518],
        [53.683767, 39.083441],
        [53.567638, 39.193305],
        [53.562022, 39.353339],
        [53.149913, 39.344143],
        [53.161469, 39.179592],
        [53.085216, 39.400458],
        [53.275890, 39.664862],
        [53.216970, 39.525051],
        [53.736176, 39.517890],
        [53.416759, 39.649970],
        [53.574474, 39.967922],
        [52.913585, 40.021674],
        [53.040050, 39.742011],
        [52.738455, 40.053616],
        [52.701996, 40.312405],
        [52.916515, 41.085150],
        [53.118907, 40.769843],
        [53.483084, 40.737047],
        [53.624685, 40.887030],
        [53.721039, 40.625678],
        [54.403575, 40.673651],
        [54.250011, 40.890611],
        [54.590668, 40.826728],
        [54.746837, 40.995673]
    ],
    [
        [-91.853586, 69.859687],
        [-91.840199, 69.824897],
        [-91.641265, 69.859687],
        [-91.747548, 69.883002],
        [-91.853586, 69.859687]
    ],
    [
        [-91.463124, 69.777086],
        [-91.408518, 69.879543],
        [-91.737457, 69.797593],
        [-91.556793, 69.729193],
        [-91.463124, 69.777086]
    ],
    [
        [-87.084218, 69.989407],
        [-86.776926, 69.971259],
        [-86.460357, 70.016750],
        [-87.379018, 70.106024],
        [-87.084218, 69.989407]
    ],
    [
        [-71.507965, 71.017279],
        [-71.859731, 71.078559],
        [-72.228017, 70.921698],
        [-72.002065, 70.811916],
        [-71.343495, 71.007636],
        [-71.507965, 71.017279]
    ],
    [
        [-72.953603, 71.517524],
        [-73.139312, 71.420844],
        [-73.100901, 71.553290],
        [-73.378774, 71.517524],
        [-73.053578, 71.296373],
        [-72.817047, 71.448635],
        [-72.953603, 71.517524]
    ],
    [
        [-72.737904, 71.661526],
        [-72.926259, 71.655341],
        [-73.043568, 71.586412],
        [-72.765289, 71.528998],
        [-72.737904, 71.661526]
    ],
    [
        [-95.327545, 71.847113],
        [-95.451731, 71.825995],
        [-95.492055, 71.743476],
        [-95.318471, 71.742499],
        [-95.327545, 71.847113]
    ],
    [
        [-95.766347, 72.874986],
        [-95.793202, 72.880561],
        [-95.855784, 72.860663],
        [-95.732289, 72.807685],
        [-95.766347, 72.874986]
    ],
    [
        [-96.917714, 72.737779],
        [-96.753285, 72.724107],
        [-96.648305, 72.800930],
        [-96.759389, 72.896186],
        [-97.013987, 72.778754],
        [-96.917714, 72.737779]
    ],
    [
        [-97.072011, 73.138129],
        [-96.973012, 72.929633],
        [-96.568267, 73.052476],
        [-96.809193, 73.192084],
        [-97.072011, 73.138129]
    ],
    [
        [-108.087636, 73.590644],
        [-107.993967, 73.546576],
        [-107.579945, 73.600531],
        [-107.848866, 73.633368],
        [-108.087636, 73.590644]
    ],
    [
        [-104.680898, 73.629828],
        [-105.381418, 73.770657],
        [-106.599599, 73.710639],
        [-107.039296, 73.484442],
        [-106.120717, 73.292670],
        [-105.284983, 72.851386],
        [-105.359731, 72.950100],
        [-104.572662, 73.332180],
        [-104.500844, 73.567206],
        [-104.680898, 73.629828]
    ],
    [
        [-80.903391, 73.607367],
        [-80.697336, 73.484442],
        [-80.849762, 73.475328],
        [-80.860097, 73.318996],
        [-80.163808, 73.233385],
        [-80.001820, 72.871243],
        [-79.568430, 72.759833],
        [-76.058258, 72.901679],
        [-77.213490, 73.510810],
        [-78.113759, 73.665717],
        [-80.560170, 73.772528],
        [-80.861806, 73.751370],
        [-80.903391, 73.607367]
    ],
    [
        [-96.321270, 72.466864],
        [-96.537578, 72.752021],
        [-97.193910, 72.615058],
        [-97.025615, 72.729478],
        [-97.418600, 72.860663],
        [-97.255962, 72.962063],
        [-97.985169, 73.044135],
        [-98.446188, 72.872504],
        [-98.494040, 73.017890],
        [-97.150493, 73.395087],
        [-97.643942, 73.539700],
        [-96.938213, 73.686835],
        [-97.773906, 73.918891],
        [-99.179546, 73.690579],
        [-99.802715, 73.936957],
        [-99.846091, 73.888332],
        [-100.023296, 73.737779],
        [-100.885845, 73.832099],
        [-101.118552, 73.724066],
        [-100.549419, 73.600531],
        [-100.604310, 73.498765],
        [-100.918560, 73.602973],
        [-101.625632, 73.491360],
        [-100.857891, 73.262844],
        [-100.362896, 73.399604],
        [-99.768617, 73.210761],
        [-100.556255, 73.231269],
        [-100.529522, 73.093451],
        [-100.314922, 73.141750],
        [-100.227886, 73.134426],
        [-100.323467, 73.100898],
        [-100.035462, 72.943834],
        [-100.304790, 72.874986],
        [-100.416566, 72.978339],
        [-100.310405, 73.032660],
        [-100.467429, 73.018988],
        [-100.316631, 72.806098],
        [-100.448345, 72.738105],
        [-101.333558, 72.724799],
        [-101.947816, 73.093451],
        [-102.484763, 73.041246],
        [-102.755962, 72.812323],
        [-101.782044, 72.308783],
        [-100.636537, 72.186469],
        [-99.385235, 71.585842],
        [-99.235088, 71.349595],
        [-98.729961, 71.271715],
        [-98.041810, 71.531195],
        [-98.500469, 71.722968],
        [-98.295025, 71.901679],
        [-98.252788, 71.669989],
        [-97.685283, 71.618394],
        [-96.588766, 71.820746],
        [-96.501323, 71.931464],
        [-96.766948, 71.922268],
        [-96.493226, 72.028022],
        [-96.869284, 72.045111],
        [-96.499981, 72.093492],
        [-96.534160, 72.244330],
        [-96.876812, 72.326321],
        [-96.321270, 72.466864]
    ],
    [
        [-99.247426, 73.855048],
        [-98.143422, 73.878404],
        [-97.643219, 74.072211],
        [-99.440256, 73.909003],
        [-99.247426, 73.855048]
    ],
    [
        [-90.291005, 73.923285],
        [-92.333974, 73.943183],
        [-93.272572, 74.177965],
        [-94.720570, 74.101386],
        [-95.330922, 73.917467],
        [-94.622426, 73.655748],
        [-95.719228, 73.690579],
        [-95.540435, 73.580715],
        [-95.704945, 73.559556],
        [-95.513254, 73.133734],
        [-95.717397, 72.997138],
        [-95.592681, 72.699449],
        [-95.135732, 72.463446],
        [-95.176747, 72.154975],
        [-95.201243, 72.110907],
        [-95.088612, 72.100328],
        [-95.211497, 71.994208],
        [-94.060129, 71.983629],
        [-94.233876, 72.032416],
        [-93.464223, 72.463446],
        [-93.787424, 72.740709],
        [-92.095815, 72.746243],
        [-91.376332, 73.203192],
        [-91.633860, 73.231269],
        [-91.257680, 73.272203],
        [-90.291005, 73.923285]
    ],
    [
        [-97.736806, 74.471381],
        [-97.377065, 74.512356],
        [-97.260365, 74.597968],
        [-97.503041, 74.623033],
        [-97.736806, 74.471381]
    ],
    [
        [-95.362294, 74.590806],
        [-95.563222, 74.642890],
        [-95.870025, 74.581244],
        [-95.255605, 74.518785],
        [-95.362294, 74.590806]
    ],
    [
        [-103.638417, 75.199530],
        [-103.820546, 75.366685],
        [-104.403228, 75.432603],
        [-104.929555, 75.141099],
        [-104.229482, 75.018866],
        [-103.638417, 75.199530]
    ],
    [
        [-93.436920, 74.944322],
        [-93.642405, 75.039944],
        [-93.491567, 75.074042],
        [-93.499379, 75.268012],
        [-93.800038, 75.307440],
        [-93.676503, 75.362047],
        [-94.899526, 75.644721],
        [-96.155507, 75.408026],
        [-95.780019, 75.382514],
        [-96.469350, 75.194403],
        [-96.616119, 74.991523],
        [-96.266672, 74.909613],
        [-96.064605, 75.023586],
        [-96.136871, 74.936916],
        [-95.897572, 74.825873],
        [-94.724192, 74.631781],
        [-93.533111, 74.670600],
        [-93.436920, 74.944322]
    ],
    [
        [-96.575103, 75.437730],
        [-96.424306, 75.581204],
        [-96.205719, 75.457994],
        [-95.910390, 75.560696],
        [-96.375111, 75.659980],
        [-97.054921, 75.499213],
        [-96.872711, 75.357367],
        [-96.575103, 75.437730]
    ],
    [
        [-120.997955, 75.930609],
        [-121.022613, 75.823472],
        [-121.293446, 75.759955],
        [-120.991119, 75.763007],
        [-120.868276, 75.916938],
        [-120.997955, 75.930609]
    ],
    [
        [-102.873280, 75.766099],
        [-102.604807, 75.772610],
        [-102.873280, 75.766099]
    ],
    [
        [-94.485260, 75.978420],
        [-94.532338, 75.998033],
        [-94.910471, 75.937445],
        [-94.743804, 75.761542],
        [-94.294586, 75.775702],
        [-94.485260, 75.978420]
    ],
    [
        [-102.571645, 75.992662],
        [-103.976226, 75.944281],
        [-103.691640, 75.888983],
        [-102.571645, 75.992662]
    ],
    [
        [-117.784739, 75.896470],
        [-117.462514, 76.088284],
        [-118.621205, 75.922065],
        [-119.409047, 75.601630],
        [-118.613922, 75.503730],
        [-117.784739, 75.896470]
    ],
    [
        [-78.895416, 76.122992],
        [-79.068186, 76.124701],
        [-79.752024, 75.882799],
        [-78.896474, 75.842597],
        [-79.176015, 75.957953],
        [-78.799875, 76.084866],
        [-78.895416, 76.122992]
    ],
    [
        [-81.327952, 76.149726],
        [-81.204416, 76.184475],
        [-81.465077, 76.164008],
        [-81.436147, 76.154731],
        [-81.327952, 76.149726]
    ],
    [
        [-103.811431, 76.033637],
        [-102.837636, 76.080634],
        [-102.530629, 76.157172],
        [-102.726633, 76.315619],
        [-104.478139, 76.147040],
        [-103.811431, 76.033637]
    ],
    [
        [-89.380116, 76.445136],
        [-89.524973, 76.480414],
        [-89.626536, 76.451361],
        [-89.407379, 76.437934],
        [-89.380116, 76.445136]
    ],
    [
        [-83.992258, 76.425360],
        [-83.911244, 76.471869],
        [-84.137807, 76.514065],
        [-84.123443, 76.451361],
        [-83.992258, 76.425360]
    ],
    [
        [-104.398020, 76.468736],
        [-104.377675, 76.324856],
        [-103.010406, 76.423489],
        [-104.058176, 76.568061],
        [-103.924713, 76.640082],
        [-104.024648, 76.670478],
        [-104.681304, 76.602200],
        [-104.398020, 76.468736]
    ],
    [
        [-97.424875, 75.519721],
        [-97.377512, 75.679836],
        [-97.939361, 75.745673],
        [-97.570221, 75.865220],
        [-97.654530, 75.982123],
        [-97.506744, 76.190660],
        [-97.788564, 76.322252],
        [-97.665110, 76.486151],
        [-98.455312, 76.682074],
        [-99.028717, 76.602200],
        [-98.850575, 76.437690],
        [-99.070302, 76.404202],
        [-99.640940, 76.637437],
        [-100.988189, 76.506578],
        [-99.843658, 76.286851],
        [-99.418528, 76.164008],
        [-100.221059, 76.136054],
        [-99.864125, 75.937445],
        [-99.491444, 75.983303],
        [-99.440256, 75.972235],
        [-99.947092, 75.875190],
        [-101.321645, 76.414537],
        [-102.035146, 76.412787],
        [-102.167551, 76.239081],
        [-101.385487, 76.253363],
        [-101.902903, 76.105902],
        [-101.303538, 76.020657],
        [-101.550608, 75.869818],
        [-102.262278, 75.869818],
        [-102.374135, 75.810492],
        [-102.009267, 75.704657],
        [-102.881663, 75.617825],
        [-102.633412, 75.498114],
        [-101.449371, 75.607652],
        [-99.823232, 75.656236],
        [-99.665517, 75.615912],
        [-100.782135, 75.355211],
        [-99.987050, 75.238593],
        [-100.549428, 75.205024],
        [-100.368764, 75.023098],
        [-99.645416, 74.976020],
        [-99.305776, 75.131293],
        [-99.405507, 74.998969],
        [-97.975819, 75.014472],
        [-98.103261, 75.225531],
        [-97.812856, 75.113105],
        [-97.568837, 75.149807],
        [-98.116689, 75.298000],
        [-97.774281, 75.424140],
        [-98.041819, 75.484931],
        [-97.724233, 75.572211],
        [-97.280873, 75.403022],
        [-97.424875, 75.519721]
    ],
    [
        [-101.159739, 76.581732],
        [-100.333485, 76.714545],
        [-100.247711, 76.739407],
        [-101.159739, 76.581732]
    ],
    [
        [-89.674957, 76.732611],
        [-89.982167, 76.842353],
        [-90.594472, 76.750881],
        [-89.977366, 76.477729],
        [-89.674957, 76.506578],
        [-89.859283, 76.616441],
        [-89.674957, 76.732611]
    ],
    [
        [-105.395131, 75.674262],
        [-105.606801, 75.937445],
        [-106.339833, 76.061591],
        [-106.874867, 75.965399],
        [-106.885894, 75.838202],
        [-106.614817, 75.800930],
        [-106.882314, 75.766099],
        [-106.880930, 75.649237],
        [-107.075999, 75.899400],
        [-108.026235, 75.787258],
        [-107.640126, 75.989244],
        [-108.499176, 76.040473],
        [-108.080881, 76.286851],
        [-108.615875, 76.423489],
        [-108.484934, 76.458808],
        [-108.731923, 76.643215],
        [-108.450795, 76.732611],
        [-108.775624, 76.864163],
        [-110.397206, 76.396715],
        [-109.323069, 76.115383],
        [-110.054596, 75.896470],
        [-108.828114, 75.691067],
        [-109.033599, 75.553900],
        [-108.909983, 75.478746],
        [-111.250844, 75.521877],
        [-111.596425, 75.814521],
        [-112.227040, 75.814521],
        [-111.726796, 75.916938],
        [-112.525746, 76.120998],
        [-112.425649, 76.170844],
        [-113.963043, 76.190619],
        [-114.159250, 76.458808],
        [-114.872426, 76.520209],
        [-115.926991, 76.286851],
        [-116.162709, 76.203843],
        [-116.630279, 76.120429],
        [-116.701568, 76.040473],
        [-116.461334, 75.978420],
        [-116.736318, 75.937445],
        [-116.885365, 75.789008],
        [-117.249013, 75.609076],
        [-117.202219, 75.480780],
        [-117.688466, 75.259670],
        [-116.767242, 75.122219],
        [-116.256500, 75.211249],
        [-116.338490, 75.115627],
        [-116.043691, 75.128730],
        [-116.255930, 75.060370],
        [-115.715443, 74.970364],
        [-115.537180, 75.039944],
        [-115.666575, 75.148505],
        [-115.262807, 75.183295],
        [-115.057688, 74.966742],
        [-114.440826, 75.067939],
        [-114.303293, 75.181789],
        [-114.615142, 75.283271],
        [-114.195790, 75.225165],
        [-114.070668, 75.474921],
        [-113.323150, 75.424140],
        [-113.812978, 75.323920],
        [-113.939524, 75.183295],
        [-113.645334, 75.190741],
        [-113.886627, 75.058173],
        [-112.857086, 75.109849],
        [-112.678863, 75.279527],
        [-112.346059, 75.121527],
        [-110.918040, 75.232367],
        [-111.585805, 75.006415],
        [-112.797841, 74.985053],
        [-114.439809, 74.683661],
        [-113.693023, 74.444485],
        [-112.437408, 74.413520],
        [-108.824208, 75.071519],
        [-108.416615, 74.917060],
        [-107.944244, 74.936916],
        [-107.771718, 75.101386],
        [-107.231028, 74.920111],
        [-106.008901, 75.056627],
        [-105.593129, 75.465074],
        [-105.750803, 75.492377],
        [-105.395131, 75.674262]
    ],
    [
        [-114.837026, 76.759833],
        [-113.673166, 76.704250],
        [-113.453481, 76.773505],
        [-113.846059, 76.898871],
        [-114.837026, 76.759833]
    ],
    [
        [-79.560170, 74.991523],
        [-80.443430, 75.039944],
        [-79.516916, 75.229234],
        [-79.614858, 75.303697],
        [-79.491322, 75.382514],
        [-79.683095, 75.437730],
        [-79.573842, 75.451483],
        [-81.286285, 75.663723],
        [-81.113149, 75.779120],
        [-84.000600, 75.828803],
        [-84.664703, 75.691067],
        [-84.576080, 75.624254],
        [-86.151682, 75.508775],
        [-85.521881, 75.403022],
        [-86.618031, 75.368883],
        [-86.364817, 75.430365],
        [-87.265736, 75.623033],
        [-87.507476, 75.561265],
        [-87.466908, 75.456000],
        [-87.750844, 75.580878],
        [-88.228139, 75.471340],
        [-88.722401, 75.686103],
        [-88.900299, 75.609076],
        [-88.763783, 75.437730],
        [-88.917388, 75.430365],
        [-89.208485, 75.586005],
        [-89.763051, 75.581204],
        [-89.162506, 75.765204],
        [-89.777333, 75.794094],
        [-89.687978, 75.903266],
        [-89.963775, 76.016018],
        [-90.518544, 75.898830],
        [-90.428456, 75.972235],
        [-90.797760, 75.998847],
        [-91.128814, 75.836127],
        [-90.942983, 76.006334],
        [-90.866689, 76.067776],
        [-90.668080, 76.115627],
        [-90.456410, 76.177680],
        [-91.565541, 76.499742],
        [-90.469390, 76.486151],
        [-90.921132, 76.643297],
        [-93.079254, 76.627631],
        [-93.560699, 76.395168],
        [-93.656077, 76.445136],
        [-93.299143, 76.554999],
        [-93.196767, 76.753079],
        [-93.700917, 76.920966],
        [-95.770741, 77.076728],
        [-96.818430, 76.983385],
        [-96.657704, 76.952297],
        [-96.819569, 76.872016],
        [-96.308217, 76.759833],
        [-95.588246, 76.609605],
        [-96.108998, 76.499742],
        [-94.800608, 76.328437],
        [-93.703725, 76.251532],
        [-93.765940, 76.286851],
        [-93.289906, 76.369208],
        [-93.060170, 76.349026],
        [-92.126820, 75.873847],
        [-92.004384, 75.601630],
        [-92.380767, 75.456122],
        [-92.504018, 75.218004],
        [-92.055898, 75.153225],
        [-92.230336, 75.074042],
        [-92.062734, 74.803412],
        [-91.513499, 74.644721],
        [-91.099436, 74.629055],
        [-91.230377, 74.738267],
        [-90.786773, 74.889635],
        [-91.024973, 74.704088],
        [-89.434438, 74.553290],
        [-89.147369, 74.607896],
        [-89.270253, 74.758734],
        [-89.060292, 74.722235],
        [-89.098948, 74.840725],
        [-88.847646, 74.664984],
        [-88.539459, 74.903754],
        [-88.296986, 74.779853],
        [-88.517812, 74.501207],
        [-86.603749, 74.471381],
        [-86.803049, 74.622219],
        [-86.380035, 74.487494],
        [-86.179270, 74.622219],
        [-86.124623, 74.484361],
        [-85.603871, 74.498033],
        [-85.533681, 74.690090],
        [-85.184926, 74.493109],
        [-85.007965, 74.704088],
        [-84.914866, 74.512356],
        [-84.258290, 74.506496],
        [-83.493520, 74.577826],
        [-83.322174, 74.762152],
        [-83.491689, 74.909491],
        [-83.078481, 74.815823],
        [-83.117258, 74.669379],
        [-82.919993, 74.551500],
        [-81.788686, 74.458401],
        [-80.217519, 74.587470],
        [-80.100819, 74.827623],
        [-80.410553, 74.901801],
        [-80.313140, 74.941555],
        [-79.909047, 74.813951],
        [-79.334299, 74.903388],
        [-79.560170, 74.991523]
    ],
    [
        [-119.317494, 76.199897],
        [-118.963531, 76.135728],
        [-118.568959, 76.345201],
        [-118.946278, 76.522854],
        [-118.305409, 76.554999],
        [-118.496653, 76.718899],
        [-117.865793, 76.823310],
        [-117.736236, 76.780341],
        [-118.058420, 76.410386],
        [-117.136342, 76.290229],
        [-116.934316, 76.355780],
        [-117.007924, 76.552151],
        [-115.892812, 76.698432],
        [-116.365793, 76.931789],
        [-115.732045, 76.948554],
        [-116.400543, 77.137274],
        [-115.392568, 77.307929],
        [-116.406728, 77.562405],
        [-117.154042, 77.458726],
        [-116.646962, 77.390448],
        [-117.181386, 77.348863],
        [-117.039215, 77.292792],
        [-119.162709, 77.324897],
        [-120.367991, 76.814521],
        [-121.187327, 76.688178],
        [-121.511871, 76.448228],
        [-122.403228, 76.404202],
        [-123.040679, 76.088284],
        [-122.605824, 76.174262],
        [-122.492584, 76.143500],
        [-122.704905, 76.115627],
        [-122.482981, 76.102362],
        [-122.731557, 75.978420],
        [-121.847076, 76.045233],
        [-121.299672, 75.910793],
        [-120.953481, 75.958197],
        [-121.011220, 76.138861],
        [-120.864980, 76.200995],
        [-120.388499, 75.972235],
        [-120.489003, 75.847073],
        [-120.387441, 75.806708],
        [-119.485951, 75.974921],
        [-119.805653, 76.115627],
        [-119.552398, 76.122992],
        [-119.716868, 76.335273],
        [-119.317494, 76.199897]
    ],
    [
        [-85.162221, 77.458726],
        [-84.816233, 77.499701],
        [-85.018381, 77.583482],
        [-85.542388, 77.540717],
        [-85.162221, 77.458726]
    ],
    [
        [-89.661285, 77.356350],
        [-90.304107, 77.629381],
        [-91.209299, 77.575385],
        [-91.179514, 77.394192],
        [-90.405019, 77.203192],
        [-89.661285, 77.356350]
    ],
    [
        [-104.394521, 77.192532],
        [-105.503041, 77.721096],
        [-106.093658, 77.729641],
        [-105.224599, 77.164496],
        [-104.394521, 77.192532]
    ],
    [
        [-93.252024, 77.644355],
        [-93.101145, 77.664211],
        [-95.506500, 77.810736],
        [-96.328725, 77.609565],
        [-95.987620, 77.479071],
        [-93.784535, 77.437730],
        [-93.252024, 77.644355]
    ],
    [
        [-77.572743, 77.856635],
        [-77.650502, 77.870917],
        [-77.956288, 77.836127],
        [-77.852610, 77.779242],
        [-77.572743, 77.856635]
    ],
    [
        [-102.448720, 77.739936],
        [-101.790598, 77.679389],
        [-100.931996, 77.744534],
        [-101.725209, 77.906480],
        [-102.448476, 77.881293],
        [-102.448720, 77.739936]
    ],
    [
        [-113.686269, 77.866604],
        [-114.327260, 78.080797],
        [-115.118235, 77.959662],
        [-114.300689, 77.713284],
        [-113.577016, 77.815009],
        [-113.686269, 77.866604]
    ],
    [
        [-109.603668, 78.073920],
        [-111.824127, 78.052639],
        [-113.323150, 77.808173],
        [-113.089752, 77.623236],
        [-113.241282, 77.582261],
        [-113.165883, 77.515082],
        [-111.990834, 77.329291],
        [-110.235422, 77.504218],
        [-110.041005, 77.644355],
        [-110.107900, 77.776190],
        [-110.903717, 77.853217],
        [-109.603668, 78.073920]
    ],
    [
        [-102.900543, 78.274359],
        [-103.065053, 78.261298],
        [-103.284169, 78.161363],
        [-102.778472, 78.214789],
        [-102.900543, 78.274359]
    ],
    [
        [-88.057444, 78.452460],
        [-88.221913, 78.432603],
        [-88.405588, 78.258979],
        [-88.208323, 78.281806],
        [-88.057444, 78.452460]
    ],
    [
        [-109.259511, 78.459296],
        [-110.740956, 78.757961],
        [-109.823232, 78.295396],
        [-109.408681, 78.309882],
        [-109.259511, 78.459296]
    ],
    [
        [-74.558095, 78.781440],
        [-74.703603, 78.726874],
        [-74.167063, 78.726793],
        [-74.315582, 78.756293],
        [-74.558095, 78.781440]
    ],
    [
        [-96.910308, 77.795152],
        [-95.060658, 77.972642],
        [-94.889312, 78.109280],
        [-95.403228, 78.233344],
        [-94.827870, 78.363715],
        [-97.451039, 78.797105],
        [-98.361887, 78.766181],
        [-98.024973, 78.552558],
        [-98.407297, 78.488186],
        [-97.766835, 78.247016],
        [-97.919545, 78.220282],
        [-96.869293, 78.137152],
        [-97.774281, 78.041571],
        [-96.993479, 77.924872],
        [-97.103342, 77.808173],
        [-96.910308, 77.795152]
    ],
    [
        [-105.606801, 79.103583],
        [-104.678538, 79.011135],
        [-104.955434, 78.798163],
        [-104.247222, 78.997056],
        [-103.832183, 78.904975],
        [-104.188059, 78.776679],
        [-103.318267, 78.737047],
        [-104.044504, 78.630601],
        [-103.379750, 78.589586],
        [-103.539540, 78.500393],
        [-105.046376, 78.504788],
        [-104.465688, 78.274644],
        [-102.744130, 78.380561],
        [-102.802235, 78.287787],
        [-102.592519, 78.244452],
        [-101.059722, 78.205512],
        [-100.610015, 77.863959],
        [-99.938588, 77.782904],
        [-99.029042, 77.882717],
        [-99.103831, 77.965888],
        [-98.946156, 78.068915],
        [-99.802724, 78.308498],
        [-99.871653, 78.438870],
        [-99.557932, 78.598700],
        [-100.063385, 78.638088],
        [-99.892079, 78.698920],
        [-100.349762, 78.823717],
        [-101.185170, 78.807440],
        [-100.988189, 78.931627],
        [-101.648427, 79.081000],
        [-102.598948, 78.877631],
        [-102.776438, 78.945950],
        [-102.618764, 79.096747],
        [-102.879465, 79.233303],
        [-103.721588, 79.363349],
        [-105.456899, 79.329291],
        [-105.606801, 79.103583]
    ],
    [
        [-100.152170, 79.997992],
        [-98.840199, 79.669867],
        [-98.651357, 79.792222],
        [-98.705963, 79.966986],
        [-99.119700, 80.133734],
        [-99.779368, 80.150784],
        [-100.152170, 79.997992]
    ],
    [
        [-95.852366, 80.652777],
        [-95.186879, 80.612942],
        [-95.852366, 80.652777]
    ],
    [
        [-96.623118, 80.044338],
        [-96.136871, 79.911689],
        [-96.588775, 79.857123],
        [-95.853749, 79.652411],
        [-95.780019, 79.480943],
        [-95.211008, 79.280951],
        [-93.840972, 79.398993],
        [-94.210927, 79.274888],
        [-93.929799, 79.259182],
        [-93.321034, 79.452053],
        [-93.388539, 79.343166],
        [-93.004954, 79.391588],
        [-93.086659, 79.487128],
        [-92.627349, 79.245429],
        [-93.330474, 79.170966],
        [-94.293528, 78.986884],
        [-93.813100, 78.767768],
        [-93.281728, 78.594713],
        [-92.991282, 78.466132],
        [-92.024526, 78.210679],
        [-90.352691, 78.144599],
        [-90.325429, 78.274359],
        [-90.332021, 78.336371],
        [-89.455190, 78.164496],
        [-89.988840, 78.448676],
        [-90.006174, 78.613756],
        [-88.811269, 78.165432],
        [-88.540028, 78.416897],
        [-88.804758, 78.610175],
        [-88.228505, 78.463568],
        [-87.909739, 78.552436],
        [-88.358469, 78.657904],
        [-88.136220, 78.686916],
        [-88.173736, 78.995592],
        [-87.728424, 79.083075],
        [-87.997548, 78.811225],
        [-87.649241, 78.643012],
        [-86.940175, 78.918606],
        [-86.968251, 79.064195],
        [-86.746653, 78.959052],
        [-84.912587, 79.270697],
        [-85.698720, 79.617987],
        [-86.067535, 79.436184],
        [-86.166168, 79.459866],
        [-86.042063, 79.569078],
        [-86.309071, 79.648098],
        [-87.460927, 79.535590],
        [-87.135813, 79.649482],
        [-86.962026, 79.908759],
        [-87.008453, 79.953315],
        [-88.063629, 80.125230],
        [-87.567698, 80.183295],
        [-87.700551, 80.412584],
        [-88.644154, 80.396674],
        [-88.708567, 80.289740],
        [-88.146148, 80.103461],
        [-88.538442, 80.099107],
        [-89.255849, 80.289740],
        [-89.057973, 80.467841],
        [-90.731068, 80.566718],
        [-90.592926, 80.652777],
        [-91.915028, 81.077379],
        [-91.798329, 81.159247],
        [-93.257680, 81.373440],
        [-93.217193, 81.214545],
        [-93.155751, 81.097846],
        [-94.302398, 81.122707],
        [-93.909291, 81.042629],
        [-94.447092, 80.967515],
        [-94.902984, 81.063707],
        [-95.533599, 80.824123],
        [-94.128774, 80.728217],
        [-94.677073, 80.665839],
        [-96.027008, 80.583930],
        [-95.903554, 80.542914],
        [-96.102162, 80.494574],
        [-95.437408, 80.343695],
        [-95.232004, 80.241278],
        [-95.698110, 80.179877],
        [-95.401519, 80.126654],
        [-94.807444, 80.097317],
        [-94.382232, 79.988023],
        [-96.801666, 80.097317],
        [-96.623118, 80.044338]
    ],
    [
        [-61.085479, 82.331163],
        [-62.352284, 82.482042],
        [-62.174713, 82.529853],
        [-63.373321, 82.441026],
        [-62.928253, 82.570787],
        [-63.853057, 82.721625],
        [-63.447092, 82.826728],
        [-64.936798, 82.872423],
        [-65.100657, 82.851996],
        [-65.354522, 82.803575],
        [-65.851593, 82.842353],
        [-66.299835, 82.934516],
        [-69.617014, 82.989936],
        [-69.451690, 83.036973],
        [-69.774444, 83.051215],
        [-69.687530, 83.116523],
        [-71.501210, 83.009630],
        [-71.796051, 83.020128],
        [-71.627594, 83.103339],
        [-73.653147, 82.927110],
        [-74.200022, 83.002143],
        [-77.134023, 83.036973],
        [-77.387237, 82.989732],
        [-75.400421, 82.619208],
        [-76.218332, 82.452094],
        [-75.893829, 82.598741],
        [-77.852203, 82.926011],
        [-80.158111, 82.939276],
        [-80.429840, 82.900377],
        [-79.984771, 82.694322],
        [-79.846954, 82.643785],
        [-81.473948, 82.830308],
        [-81.584543, 82.800523],
        [-80.580637, 82.543443],
        [-81.478790, 82.502509],
        [-82.731475, 82.404893],
        [-79.863678, 82.026923],
        [-79.230621, 81.817857],
        [-82.969879, 82.298448],
        [-82.627024, 82.103746],
        [-83.130442, 82.071153],
        [-82.951690, 82.125800],
        [-83.674875, 82.348985],
        [-84.945953, 82.427436],
        [-84.708404, 82.483018],
        [-85.919220, 82.433580],
        [-85.401031, 82.277045],
        [-84.752431, 81.991197],
        [-84.603342, 81.893012],
        [-85.734202, 81.988593],
        [-86.162139, 82.045844],
        [-87.131378, 81.975572],
        [-88.070465, 82.107286],
        [-89.413238, 81.929551],
        [-89.147450, 81.885565],
        [-89.335357, 81.809027],
        [-90.242909, 81.899848],
        [-91.956614, 81.660224],
        [-91.470001, 81.529893],
        [-90.298655, 81.704088],
        [-89.585601, 81.632310],
        [-90.859893, 81.447333],
        [-90.492340, 81.370836],
        [-88.342681, 81.590522],
        [-88.888946, 81.500474],
        [-89.955556, 81.330634],
        [-90.352773, 81.173651],
        [-89.826161, 81.013048],
        [-89.462148, 80.914781],
        [-87.706532, 80.645453],
        [-85.780995, 81.034044],
        [-85.622467, 80.980292],
        [-86.749054, 80.604478],
        [-85.121368, 80.504096],
        [-83.846018, 80.544053],
        [-83.719472, 80.631781],
        [-83.862823, 80.762071],
        [-83.273712, 80.846503],
        [-83.123606, 80.831000],
        [-83.168284, 80.587714],
        [-82.913116, 80.539415],
        [-80.875559, 80.662950],
        [-79.614491, 80.827623],
        [-79.066192, 81.091051],
        [-78.736846, 81.113634],
        [-78.191721, 81.305162],
        [-78.444163, 81.170518],
        [-78.936431, 80.878770],
        [-79.964345, 80.617499],
        [-83.205556, 80.323228],
        [-81.403717, 79.939683],
        [-81.661692, 79.907579],
        [-81.523427, 79.718004],
        [-81.787262, 79.611396],
        [-81.615956, 79.624376],
        [-83.787872, 80.250922],
        [-86.503936, 80.309068],
        [-86.653798, 80.136949],
        [-86.534657, 80.030870],
        [-86.396270, 79.962999],
        [-86.474680, 79.760972],
        [-85.021026, 79.617540],
        [-84.486602, 79.412706],
        [-84.329620, 79.192369],
        [-84.452911, 79.148301],
        [-84.752105, 79.038926],
        [-82.534576, 78.885118],
        [-81.478790, 79.049018],
        [-81.753692, 78.843004],
        [-82.219268, 78.726874],
        [-82.596018, 78.706407],
        [-82.239044, 78.594346],
        [-82.342804, 78.569200],
        [-85.031077, 78.921861],
        [-86.940460, 78.714179],
        [-87.122345, 78.582872],
        [-86.858306, 78.548774],
        [-87.529286, 78.410956],
        [-87.523020, 78.233385],
        [-87.091054, 78.206773],
        [-86.769765, 78.120429],
        [-85.860260, 78.385565],
        [-86.289377, 78.083360],
        [-85.491485, 78.106065],
        [-85.028554, 78.288682],
        [-84.857208, 78.507148],
        [-84.679596, 78.591010],
        [-84.617014, 78.589667],
        [-84.870880, 78.369981],
        [-84.575999, 78.353502],
        [-84.968332, 78.214057],
        [-84.425201, 78.212958],
        [-85.035308, 78.178819],
        [-84.288604, 78.082587],
        [-85.679596, 77.935167],
        [-85.472646, 77.872056],
        [-84.549835, 77.928087],
        [-84.315338, 77.897650],
        [-84.971425, 77.843736],
        [-85.350616, 77.739976],
        [-84.943023, 77.602729],
        [-84.868194, 77.573472],
        [-84.761016, 77.520250],
        [-83.678497, 77.534532],
        [-82.735992, 77.928331],
        [-82.764882, 78.027696],
        [-82.321075, 78.082587],
        [-82.986114, 77.678534],
        [-83.836171, 77.458808],
        [-83.466217, 77.348944],
        [-84.617014, 77.383653],
        [-84.466135, 77.301744],
        [-85.795684, 77.425279],
        [-85.974395, 77.713324],
        [-86.452179, 77.836412],
        [-88.221954, 77.862860],
        [-88.105255, 77.815050],
        [-88.211497, 77.650336],
        [-87.700592, 77.540758],
        [-87.721018, 77.370063],
        [-87.248687, 77.307969],
        [-86.603790, 77.178209],
        [-88.393219, 77.102525],
        [-89.537180, 76.856757],
        [-89.386383, 76.732652],
        [-89.681182, 76.574937],
        [-88.910634, 76.410468],
        [-88.710479, 76.600816],
        [-88.618398, 76.404405],
        [-88.496327, 76.547593],
        [-88.708567, 76.712104],
        [-88.506988, 76.823717],
        [-88.403554, 76.393663],
        [-87.406321, 76.355821],
        [-87.433095, 76.465684],
        [-86.721954, 76.348375],
        [-86.302887, 76.527696],
        [-86.207183, 76.527167],
        [-86.417551, 76.471666],
        [-86.347401, 76.388536],
        [-85.203399, 76.284288],
        [-84.388092, 76.315131],
        [-85.055816, 76.520250],
        [-84.215891, 76.450792],
        [-84.292958, 76.663804],
        [-83.712799, 76.435045],
        [-83.185089, 76.430894],
        [-83.527659, 76.708726],
        [-83.381012, 76.761339],
        [-83.001047, 76.436265],
        [-82.138173, 76.438707],
        [-82.225494, 76.520250],
        [-82.082102, 76.568101],
        [-82.511871, 76.662299],
        [-82.729766, 76.820990],
        [-82.276275, 76.634874],
        [-81.783233, 76.688463],
        [-82.055694, 76.516466],
        [-81.206858, 76.563585],
        [-80.772491, 76.419989],
        [-81.072499, 76.129136],
        [-79.293243, 76.302354],
        [-78.774241, 76.577338],
        [-78.367258, 76.465684],
        [-77.770782, 76.664293],
        [-77.716217, 76.821967],
        [-78.090850, 77.022813],
        [-78.720367, 76.827582],
        [-79.375640, 76.925645],
        [-79.006500, 77.104722],
        [-79.432403, 77.238593],
        [-80.372467, 77.074693],
        [-80.115142, 77.205552],
        [-81.103017, 77.287462],
        [-81.857696, 77.170478],
        [-82.198150, 77.301744],
        [-81.170929, 77.332506],
        [-81.737213, 77.434801],
        [-81.673004, 77.523668],
        [-81.937489, 77.685370],
        [-80.551422, 77.309801],
        [-78.689687, 77.319078],
        [-77.716217, 77.609605],
        [-78.429962, 77.911322],
        [-78.216583, 78.002550],
        [-75.933990, 77.958604],
        [-75.581939, 78.113023],
        [-75.029815, 78.336412],
        [-74.632598, 78.589667],
        [-74.872833, 78.644273],
        [-74.721954, 78.712633],
        [-74.906321, 78.788316],
        [-74.773752, 78.834825],
        [-76.459218, 78.849351],
        [-75.780751, 78.982001],
        [-77.718007, 78.969713],
        [-77.703155, 79.008043],
        [-78.257395, 79.171942],
        [-76.088775, 79.204698],
        [-74.440826, 79.062690],
        [-74.824981, 79.179307],
        [-77.325754, 79.267442],
        [-77.161895, 79.330186],
        [-77.401519, 79.453070],
        [-77.124501, 79.468940],
        [-77.188507, 79.508409],
        [-77.133778, 79.548651],
        [-75.027984, 79.373277],
        [-74.888580, 79.415635],
        [-74.996368, 79.513414],
        [-73.125315, 79.566352],
        [-73.383331, 79.775621],
        [-72.231679, 79.662584],
        [-71.142405, 79.789496],
        [-70.911610, 79.892564],
        [-71.459625, 79.898749],
        [-72.342030, 80.062567],
        [-71.898468, 80.117865],
        [-70.159088, 80.192491],
        [-69.959462, 80.261827],
        [-70.452911, 80.343736],
        [-70.370351, 80.412665],
        [-70.219512, 80.419501],
        [-70.309478, 80.358018],
        [-69.666005, 80.355211],
        [-67.563018, 80.945990],
        [-70.020253, 81.105943],
        [-69.637278, 81.179877],
        [-68.580556, 81.516099],
        [-68.356231, 81.542955],
        [-68.213206, 81.563218],
        [-64.372589, 81.724962],
        [-61.085479, 82.331163]
    ],
    [
        [73.735118, -53.112400],
        [73.564220, -53.016778],
        [73.236013, -52.982029],
        [73.473399, -53.189223],
        [73.735118, -53.112400]
    ],
    [
        [69.945649, -49.542169],
        [69.835785, -49.501153],
        [69.847830, -49.514337],
        [69.945649, -49.542169]
    ],
    [
        [68.795095, -49.343520],
        [68.691254, -49.315606],
        [68.643403, -49.343520],
        [68.773204, -49.363702],
        [68.795095, -49.343520]
    ],
    [
        [69.589529, -49.199640],
        [69.624034, -49.208266],
        [69.678071, -49.151788],
        [69.534190, -49.192804],
        [69.589529, -49.199640]
    ],
    [
        [69.192149, -48.986586],
        [69.222504, -49.094334],
        [69.411306, -48.928643],
        [69.342947, -48.884210],
        [69.192149, -48.986586]
    ],
    [
        [69.226329, -48.857029],
        [69.162771, -48.906508],
        [69.143809, -48.980564],
        [69.243907, -48.890069],
        [69.226329, -48.857029]
    ],
    [
        [69.465994, -48.884210],
        [69.519867, -48.857029],
        [69.404470, -48.829034],
        [69.428396, -48.864435],
        [69.465994, -48.884210]
    ],
    [
        [70.548839, -49.183201],
        [70.335948, -49.053969],
        [69.801768, -49.288263],
        [69.411306, -49.274672],
        [69.472179, -49.151788],
        [69.282481, -49.184259],
        [69.399913, -49.113702],
        [69.644054, -49.124444],
        [69.589529, -48.952569],
        [69.452485, -49.088962],
        [68.999766, -49.090427],
        [69.188813, -48.773045],
        [68.908214, -48.893976],
        [69.116466, -48.726658],
        [69.015636, -48.654555],
        [68.791759, -48.846287],
        [68.903087, -48.974705],
        [68.748790, -49.076755],
        [68.930919, -49.144952],
        [68.764334, -49.188897],
        [68.924083, -49.288263],
        [68.764496, -49.674981],
        [69.025645, -49.709893],
        [69.227387, -49.488458],
        [70.244314, -49.685479],
        [70.295909, -49.530369],
        [70.049083, -49.520440],
        [70.136974, -49.617852],
        [69.691905, -49.404474],
        [70.466482, -49.439142],
        [70.311534, -49.378513],
        [70.548839, -49.183201]
    ],
    [
        [68.670746, -48.624200],
        [68.625987, -48.629815],
        [68.610118, -48.637628],
        [68.667979, -48.645278],
        [68.670746, -48.624200]
    ],
    [
        [68.808604, -48.603692],
        [68.828624, -48.592706],
        [68.818614, -48.566664],
        [68.781016, -48.584568],
        [68.808604, -48.603692]
    ],
    [
        [37.662446, -46.828546],
        [37.602061, -46.948663],
        [37.895763, -46.889907],
        [37.821056, -46.844171],
        [37.662446, -46.828546]
    ],
    [
        [37.861095, -46.636163],
        [37.938650, -46.654392],
        [37.977794, -46.615655],
        [37.900401, -46.599705],
        [37.861095, -46.636163]
    ],
    [
        [51.834158, -46.376642],
        [51.736013, -46.327407],
        [51.656505, -46.378351],
        [51.823497, -46.451267],
        [51.834158, -46.376642]
    ],
    [
        [50.175548, -46.064711],
        [50.201182, -46.113458],
        [50.292247, -46.115981],
        [50.268077, -46.043715],
        [50.175548, -46.064711]
    ],
    [
        [-9.926381, -40.348810],
        [-9.962758, -40.301853],
        [-10.039377, -40.331801],
        [-9.925160, -40.397882],
        [-9.926381, -40.348810]
    ],
    [
        [-12.307362, -37.070082],
        [-12.276601, -37.149184],
        [-12.191274, -37.090509],
        [-12.244985, -37.059177],
        [-12.307362, -37.070082]
    ],
    [
        [-48.434560, -27.404718],
        [-48.537506, -27.476170],
        [-48.563791, -27.817315],
        [-48.407216, -27.579197],
        [-48.434560, -27.404718]
    ],
    [
        [-48.544423, -26.341892],
        [-48.489125, -26.236017],
        [-48.547597, -26.167250],
        [-48.703277, -26.311944],
        [-48.544423, -26.341892]
    ],
    [
        [32.906749, -26.057794],
        [32.961274, -26.044122],
        [32.982595, -25.969008],
        [32.918305, -26.001397],
        [32.906749, -26.057794]
    ],
    [
        [-47.517161, -24.700942],
        [-47.831858, -24.913263],
        [-47.900136, -25.036798],
        [-47.448313, -24.686700],
        [-47.517161, -24.700942]
    ],
    [
        [-46.327952, -23.926446],
        [-46.393666, -23.920180],
        [-46.420400, -23.947442],
        [-46.291860, -23.990899],
        [-46.327952, -23.926446]
    ],
    [
        [-45.213735, -23.906508],
        [-45.308461, -23.721368],
        [-45.452952, -23.891371],
        [-45.241689, -23.967950],
        [-45.213735, -23.906508]
    ],
    [
        [-44.100901, -23.149021],
        [-44.235097, -23.068780],
        [-44.367096, -23.165216],
        [-44.327707, -23.221287],
        [-44.100901, -23.149021]
    ],
    [
        [35.469574, -21.549086],
        [35.437511, -21.672947],
        [35.434906, -21.782892],
        [35.490733, -21.641860],
        [35.469574, -21.549086]
    ],
    [
        [55.787852, -21.103448],
        [55.578380, -20.874770],
        [55.225434, -21.029718],
        [55.575043, -21.367934],
        [55.812022, -21.342543],
        [55.787852, -21.103448]
    ],
    [
        [57.795746, -20.222752],
        [57.596528, -19.982599],
        [57.307872, -20.444268],
        [57.672211, -20.479669],
        [57.795746, -20.222752]
    ],
    [
        [49.955821, -16.779718],
        [49.857270, -16.919692],
        [49.826182, -17.094415],
        [50.024099, -16.690362],
        [49.955821, -16.779718]
    ],
    [
        [11.725759, -16.618422],
        [11.719746, -16.506083],
        [11.701977, -16.500393],
        [11.669394, -16.557210],
        [11.738507, -16.705822],
        [11.725759, -16.618422]
    ],
    [
        [-5.721832, -15.908949],
        [-5.770131, -15.945245],
        [-5.780181, -16.008233],
        [-5.662750, -15.979587],
        [-5.721832, -15.908949]
    ],
    [
        [48.332042, -13.360447],
        [48.318370, -13.200291],
        [48.188731, -13.264255],
        [48.224620, -13.400486],
        [48.332042, -13.360447]
    ],
    [
        [45.262218, -12.763360],
        [45.275727, -12.804864],
        [45.282563, -12.804864],
        [45.282563, -12.743422],
        [45.262218, -12.763360]
    ],
    [
        [45.200694, -12.722914],
        [45.042491, -12.698419],
        [45.097179, -12.982354],
        [45.186371, -12.968845],
        [45.200694, -12.722914]
    ],
    [
        [43.788748, -12.308038],
        [43.727224, -12.263604],
        [43.635753, -12.236912],
        [43.858165, -12.371352],
        [43.788748, -12.308038]
    ],
    [
        [44.529063, -12.232843],
        [44.467052, -12.064386],
        [44.206391, -12.160577],
        [44.511485, -12.380304],
        [44.529063, -12.232843]
    ],
    [
        [43.466563, -11.821710],
        [43.394867, -11.400160],
        [43.276541, -11.379571],
        [43.217784, -11.750258],
        [43.437673, -11.931573],
        [43.466563, -11.821710]
    ],
    [
        [56.524181, -10.330011],
        [56.529796, -10.352960],
        [56.569347, -10.406508],
        [56.535655, -10.323907],
        [56.524181, -10.330011]
    ],
    [
        [46.495453, -9.357599],
        [46.320486, -9.423761],
        [46.207367, -9.385512],
        [46.299815, -9.449314],
        [46.495453, -9.357599]
    ],
    [
        [46.283865, -9.351332],
        [46.379405, -9.357029],
        [46.427094, -9.337660],
        [46.315196, -9.326430],
        [46.283865, -9.351332]
    ],
    [
        [-14.356272, -7.884698],
        [-14.390614, -7.889337],
        [-14.406402, -7.973891],
        [-14.294789, -7.945489],
        [-14.356272, -7.884698]
    ],
    [
        [39.895681, -7.637628],
        [39.587169, -7.945489],
        [39.629731, -7.985772],
        [39.823253, -7.913995],
        [39.895681, -7.637628]
    ],
    [
        [56.247081, -7.192641],
        [56.272472, -7.153578],
        [56.287446, -7.110040],
        [56.258800, -7.140232],
        [56.247081, -7.192641]
    ],
    [
        [12.905290, -5.869488],
        [12.828161, -5.871794],
        [12.745128, -5.940199],
        [12.994590, -5.868244],
        [12.905290, -5.869488]
    ],
    [
        [39.543468, -6.321222],
        [39.498546, -6.123793],
        [39.416515, -6.192071],
        [39.313487, -5.718438],
        [39.198578, -6.220798],
        [39.508474, -6.462823],
        [39.543468, -6.321222]
    ],
    [
        [39.643077, -5.413995],
        [39.796072, -5.406834],
        [39.855968, -5.253025],
        [39.828136, -5.102146],
        [39.878184, -4.987726],
        [39.855968, -4.897231],
        [39.684093, -4.890313],
        [39.649913, -5.190851],
        [39.780935, -5.239353],
        [39.643077, -5.413995]
    ],
    [
        [55.401702, -4.660534],
        [55.478001, -4.706406],
        [55.537916, -4.803769],
        [55.454897, -4.562234],
        [55.401702, -4.660534]
    ],
    [
        [55.260265, -4.500095],
        [55.259939, -4.462986],
        [55.225434, -4.444920],
        [55.228038, -4.487481],
        [55.260265, -4.500095]
    ],
    [
        [55.717635, -4.330116],
        [55.759125, -4.358425],
        [55.787038, -4.330592],
        [55.677175, -4.296413],
        [55.717635, -4.330116]
    ],
    [
        [-32.403391, -3.837823],
        [-32.436920, -3.849867],
        [-32.462799, -3.878351],
        [-32.399729, -3.861993],
        [-32.403391, -3.837823]
    ],
    [
        [41.053966, -2.049574],
        [40.969249, -2.119806],
        [40.993663, -2.197198],
        [41.155284, -2.112074],
        [41.053966, -2.049574]
    ],
    [
        [5.626231, -1.456231],
        [5.628917, -1.475681],
        [5.633067, -1.415785],
        [5.618663, -1.433038],
        [5.626231, -1.456231]
    ],
    [
        [8.997244, -0.627618],
        [8.949474, -0.661716],
        [9.006602, -0.762140],
        [9.041515, -0.669854],
        [8.997244, -0.627618]
    ],
    [
        [6.681407, 0.407131],
        [6.470876, 0.267890],
        [6.526622, 0.024115],
        [6.756521, 0.250067],
        [6.681407, 0.407131]
    ],
    [
        [7.462738, 1.674547],
        [7.385265, 1.692328],
        [7.332530, 1.565334],
        [7.401378, 1.531195],
        [7.462738, 1.674547]
    ],
    [
        [8.922699, 3.750718],
        [8.667166, 3.726264],
        [8.450206, 3.272935],
        [8.686209, 3.197333],
        [8.922699, 3.750718]
    ],
    [
        [7.541026, 4.484442],
        [7.404552, 4.498033],
        [7.336925, 4.460150],
        [7.541026, 4.484442]
    ],
    [
        [7.274181, 4.491889],
        [7.229503, 4.532782],
        [7.138031, 4.397040],
        [7.298350, 4.414740],
        [7.274181, 4.491889]
    ],
    [
        [-12.492991, 7.568020],
        [-12.621409, 7.639716],
        [-12.951650, 7.575426],
        [-12.549672, 7.389635],
        [-12.492991, 7.568020]
    ],
    [
        [-15.946401, 11.200263],
        [-15.925933, 11.090399],
        [-15.978179, 11.048082],
        [-15.877553, 11.073635],
        [-15.946401, 11.200263]
    ],
    [
        [-15.973785, 11.159247],
        [-16.056996, 11.163560],
        [-16.017079, 11.068671],
        [-15.974477, 11.116197],
        [-15.973785, 11.159247]
    ],
    [
        [-16.048899, 11.118313],
        [-16.099965, 11.208197],
        [-16.248036, 11.104682],
        [-16.131988, 11.028957],
        [-16.048899, 11.118313]
    ],
    [
        [-15.857086, 11.302680],
        [-15.896474, 11.248725],
        [-15.871327, 11.200263],
        [-15.825836, 11.292670],
        [-15.857086, 11.302680]
    ],
    [
        [-15.658437, 11.302680],
        [-15.754018, 11.275946],
        [-15.773305, 11.173082],
        [-15.658437, 11.233791],
        [-15.658437, 11.302680]
    ],
    [
        [-16.172963, 11.220771],
        [-16.206532, 11.310126],
        [-16.281646, 11.242621],
        [-16.251454, 11.217678],
        [-16.172963, 11.220771]
    ],
    [
        [-15.665273, 11.494452],
        [-15.693186, 11.501899],
        [-15.735097, 11.449856],
        [-15.679555, 11.440416],
        [-15.665273, 11.494452]
    ],
    [
        [-16.254872, 11.447252],
        [-16.213979, 11.440416],
        [-16.165517, 11.515570],
        [-16.302113, 11.453518],
        [-16.254872, 11.447252]
    ],
    [
        [-16.275543, 11.495510],
        [-16.248036, 11.583808],
        [-16.426259, 11.529242],
        [-16.419423, 11.488227],
        [-16.275543, 11.495510]
    ],
    [
        [-16.022125, 11.512152],
        [-16.035227, 11.419989],
        [-15.898020, 11.453518],
        [-15.939605, 11.604926],
        [-16.022125, 11.512152]
    ],
    [
        [-15.473500, 11.632270],
        [-15.528717, 11.624823],
        [-15.630279, 11.528998],
        [-15.471669, 11.566148],
        [-15.473500, 11.632270]
    ],
    [
        [-16.165517, 11.871243],
        [-16.041412, 11.755113],
        [-15.985585, 11.887437],
        [-16.036977, 11.899237],
        [-16.165517, 11.871243]
    ],
    [
        [-24.704335, 14.900824],
        [-24.758941, 14.866645],
        [-24.718007, 14.803941],
        [-24.683258, 14.842475],
        [-24.704335, 14.900824]
    ],
    [
        [-24.296539, 14.917548],
        [-24.364858, 15.045396],
        [-24.526235, 14.924709],
        [-24.376536, 14.815985],
        [-24.296539, 14.917548]
    ],
    [
        [-23.456776, 15.023668],
        [-23.703236, 15.313463],
        [-23.779530, 15.311672],
        [-23.715077, 14.968451],
        [-23.456776, 15.023668]
    ],
    [
        [-23.127797, 15.311672],
        [-23.251332, 15.256415],
        [-23.195953, 15.122056],
        [-23.111928, 15.171942],
        [-23.127797, 15.311672]
    ],
    [
        [-22.682118, 16.113593],
        [-22.915598, 16.243964],
        [-22.963979, 16.052191],
        [-22.806142, 15.985907],
        [-22.682118, 16.113593]
    ],
    [
        [-24.067535, 16.613918],
        [-24.361480, 16.681586],
        [-24.430653, 16.639472],
        [-24.324696, 16.482652],
        [-24.067535, 16.613918]
    ],
    [
        [-22.929189, 16.593411],
        [-22.881337, 16.692694],
        [-22.922434, 16.860297],
        [-22.990793, 16.815660],
        [-22.929189, 16.593411]
    ],
    [
        [-24.919749, 16.895087],
        [-24.978098, 16.923000],
        [-25.094146, 16.826158],
        [-24.891103, 16.813951],
        [-24.919749, 16.895087]
    ],
    [
        [-25.046986, 17.035061],
        [-25.102610, 17.196601],
        [-25.360422, 17.055243],
        [-25.298695, 16.917385],
        [-25.046986, 17.035061]
    ],
    [
        [-16.377797, 19.813544],
        [-16.463979, 19.684638],
        [-16.432485, 19.601264],
        [-16.345937, 19.868354],
        [-16.377797, 19.813544]
    ],
    [
        [-17.933949, 27.852037],
        [-18.167226, 27.757554],
        [-18.160390, 27.722357],
        [-17.979482, 27.642524],
        [-17.933949, 27.852037]
    ],
    [
        [-15.391591, 28.030219],
        [-15.409291, 28.179755],
        [-15.706207, 28.167385],
        [-15.821197, 27.921780],
        [-15.577952, 27.734361],
        [-15.377838, 27.852281],
        [-15.391591, 28.030219]
    ],
    [
        [-17.309673, 28.207117],
        [-17.257888, 28.024570],
        [-17.098420, 28.100764],
        [-17.212721, 28.205449],
        [-17.309673, 28.207117]
    ],
    [
        [-16.427695, 28.149670],
        [-16.117747, 28.572089],
        [-16.916058, 28.354970],
        [-16.692683, 27.999847],
        [-16.427695, 28.149670]
    ],
    [
        [-13.972646, 28.735907],
        [-14.224436, 28.218573],
        [-14.507069, 28.071194],
        [-13.933705, 28.244208],
        [-13.824371, 28.681789],
        [-13.972646, 28.735907]
    ],
    [
        [-17.755767, 28.818508],
        [-17.996816, 28.780097],
        [-17.837066, 28.455390],
        [-17.721044, 28.730644],
        [-17.755767, 28.818508]
    ],
    [
        [-13.482981, 29.239936],
        [-13.798492, 29.048082],
        [-13.867299, 28.864895],
        [-13.482045, 28.999457],
        [-13.482981, 29.239936]
    ],
    [
        [-13.486684, 29.284613],
        [-13.508168, 29.289455],
        [-13.541249, 29.229397],
        [-13.492014, 29.242662],
        [-13.486684, 29.284613]
    ],
    [
        [33.375987, 31.189521],
        [33.301117, 31.215888],
        [33.269786, 31.216783],
        [33.375987, 31.189521]
    ],
    [
        [33.078624, 31.227118],
        [32.946462, 31.163275],
        [32.934744, 31.147935],
        [33.262462, 31.223619],
        [33.078624, 31.227118]
    ],
    [
        [-16.487050, 32.491685],
        [-16.506663, 32.544176],
        [-16.542348, 32.580512],
        [-16.536773, 32.558010],
        [-16.487050, 32.491685]
    ],
    [
        [-16.788686, 32.686672],
        [-16.672678, 32.758612],
        [-17.252105, 32.814521],
        [-16.976796, 32.647203],
        [-16.788686, 32.686672]
    ],
    [
        [-16.339955, 33.057196],
        [-16.275380, 33.060248],
        [-16.289133, 33.108710],
        [-16.398346, 33.039781],
        [-16.339955, 33.057196]
    ],
    [
        [10.991466, 33.841702],
        [10.736013, 33.884752],
        [10.740154, 33.715478],
        [10.887786, 33.640142],
        [10.991466, 33.841702]
    ],
    [
        [10.964122, 34.656684],
        [11.055708, 34.620962],
        [11.110842, 34.659506],
        [10.987153, 34.671780],
        [10.964122, 34.656684]
    ],
    [
        [11.265798, 34.773383],
        [11.254270, 34.825822],
        [11.130746, 34.663291],
        [11.297035, 34.728693],
        [11.265798, 34.773383]
    ],
    [
        [24.128429, 34.855292],
        [24.080577, 34.868964],
        [24.046397, 34.849066],
        [24.135265, 34.815009],
        [24.128429, 34.855292]
    ],
    [
        [26.976085, 35.431342],
        [26.900238, 35.424506],
        [26.848399, 35.372382],
        [27.007091, 35.397773],
        [26.976085, 35.431342]
    ],
    [
        [26.321137, 35.315253],
        [25.795258, 35.115139],
        [25.766368, 35.335679],
        [24.340099, 35.348334],
        [24.071951, 35.498358],
        [24.182953, 35.585598],
        [23.817149, 35.534817],
        [23.741547, 35.686957],
        [23.518240, 35.294135],
        [24.402110, 35.191107],
        [24.742849, 35.077216],
        [24.738536, 34.931627],
        [25.019054, 34.931627],
        [26.147227, 35.002265],
        [26.321137, 35.315253]
    ],
    [
        [34.544200, 35.678371],
        [33.660330, 35.359320],
        [32.920421, 35.397773],
        [32.865245, 35.156968],
        [32.276134, 35.047756],
        [32.458995, 34.721869],
        [33.030284, 34.568549],
        [33.680349, 34.966295],
        [34.099132, 34.965155],
        [33.923595, 35.278551],
        [34.544200, 35.678371]
    ],
    [
        [27.211925, 35.520697],
        [27.156749, 35.633979],
        [27.220958, 35.829250],
        [27.067882, 35.588935],
        [27.136241, 35.403998],
        [27.211925, 35.520697]
    ],
    [
        [23.278005, 35.897447],
        [23.295665, 35.859565],
        [23.333263, 35.829169],
        [23.330740, 35.864936],
        [23.278005, 35.897447]
    ],
    [
        [14.548025, 35.890041],
        [14.377289, 35.993638],
        [14.322032, 35.973131],
        [14.424490, 35.823676],
        [14.548025, 35.890041]
    ],
    [
        [14.256602, 36.075588],
        [14.184906, 36.034613],
        [14.334239, 36.034369],
        [14.314789, 36.051093],
        [14.256602, 36.075588]
    ],
    [
        [23.011729, 36.308295],
        [22.901622, 36.338324],
        [22.990733, 36.137030],
        [23.103852, 36.237209],
        [23.011729, 36.308295]
    ],
    [
        [25.735606, 36.383450],
        [25.746430, 36.357978],
        [25.855154, 36.363593],
        [25.767833, 36.401597],
        [25.735606, 36.383450]
    ],
    [
        [28.239757, 36.432522],
        [27.684255, 36.158149],
        [27.732677, 35.915107],
        [28.089610, 36.055121],
        [28.239757, 36.432522]
    ],
    [
        [25.382091, 36.479641],
        [25.361664, 36.356757],
        [25.465099, 36.342434],
        [25.479177, 36.424384],
        [25.382091, 36.479641]
    ],
    [
        [27.396821, 36.438666],
        [27.355805, 36.479641],
        [27.297048, 36.465155],
        [27.428233, 36.385199],
        [27.396821, 36.438666]
    ],
    [
        [26.362153, 36.637885],
        [26.261485, 36.587633],
        [26.300955, 36.513251],
        [26.465994, 36.582709],
        [26.362153, 36.637885]
    ],
    [
        [27.869884, 36.589504],
        [27.841970, 36.644721],
        [27.760020, 36.575873],
        [27.843028, 36.527899],
        [27.869884, 36.589504]
    ],
    [
        [24.868175, 36.665229],
        [24.840831, 36.665229],
        [24.963715, 36.596340],
        [24.947927, 36.624335],
        [24.868175, 36.665229]
    ],
    [
        [25.146251, 36.719875],
        [25.104666, 36.699368],
        [25.067393, 36.637885],
        [25.183442, 36.706204],
        [25.146251, 36.719875]
    ],
    [
        [21.764171, 36.753974],
        [21.750499, 36.712388],
        [21.777843, 36.699368],
        [21.780040, 36.747504],
        [21.764171, 36.753974]
    ],
    [
        [24.474376, 36.747138],
        [24.354259, 36.753974],
        [24.326996, 36.650946],
        [24.546072, 36.688788],
        [24.474376, 36.747138]
    ],
    [
        [24.642263, 36.788764],
        [24.608165, 36.781317],
        [24.659353, 36.750556],
        [24.665782, 36.774644],
        [24.642263, 36.788764]
    ],
    [
        [25.272960, 36.719875],
        [25.373220, 36.653713],
        [25.409434, 36.712388],
        [25.306977, 36.794989],
        [25.272960, 36.719875]
    ],
    [
        [21.695811, 36.740383],
        [21.716319, 36.781317],
        [21.729340, 36.794989],
        [21.700857, 36.791083],
        [21.695811, 36.740383]
    ],
    [
        [11.999522, 36.835924],
        [11.924978, 36.811957],
        [12.030610, 36.741360],
        [12.051524, 36.790351],
        [11.999522, 36.835924]
    ],
    [
        [24.608165, 36.835924],
        [24.561778, 36.845649],
        [24.521169, 36.817369],
        [24.572765, 36.781928],
        [24.608165, 36.835924]
    ],
    [
        [25.423106, 36.832506],
        [25.477794, 36.835150],
        [25.478363, 36.870673],
        [25.446951, 36.857408],
        [25.423106, 36.832506]
    ],
    [
        [27.280935, 36.907904],
        [27.061209, 36.839342],
        [26.917735, 36.716132],
        [27.355805, 36.863227],
        [27.280935, 36.907904]
    ],
    [
        [25.608653, 36.883734],
        [25.674001, 36.879462],
        [25.684418, 36.891181],
        [25.649669, 36.911607],
        [25.608653, 36.883734]
    ],
    [
        [26.005870, 36.938910],
        [25.845470, 36.808580],
        [25.879649, 36.794989],
        [26.074718, 36.893297],
        [26.005870, 36.938910]
    ],
    [
        [-7.955719, 36.980536],
        [-7.903879, 36.965888],
        [-7.853261, 36.986762],
        [-7.860097, 37.000434],
        [-7.955719, 36.980536]
    ],
    [
        [-25.066803, 37.021470],
        [-25.170318, 37.015530],
        [-25.201650, 36.990424],
        [-25.027089, 36.934312],
        [-25.066803, 37.021470]
    ],
    [
        [25.081065, 36.952623],
        [25.059906, 36.973090],
        [25.072765, 37.042182],
        [25.025890, 37.007880],
        [25.047048, 36.969224],
        [25.081065, 36.952623]
    ],
    [
        [24.704356, 37.035142],
        [24.642263, 37.048814],
        [24.710623, 36.904202],
        [24.765798, 36.949205],
        [24.704356, 37.035142]
    ],
    [
        [26.911632, 36.945787],
        [27.044281, 36.996243],
        [26.889822, 37.089789],
        [26.953868, 37.027899],
        [26.911632, 36.945787]
    ],
    [
        [25.807384, 37.103420],
        [25.836762, 37.102362],
        [25.834646, 37.137600],
        [25.780528, 37.123969],
        [25.807384, 37.103420]
    ],
    [
        [25.279796, 37.048814],
        [25.238780, 37.151842],
        [25.103363, 37.012885],
        [25.188487, 36.985297],
        [25.279796, 37.048814]
    ],
    [
        [25.526134, 37.196234],
        [25.341807, 37.082953],
        [25.449880, 36.918443],
        [25.580821, 37.017768],
        [25.526134, 37.196234]
    ],
    [
        [24.443696, 37.178534],
        [24.422537, 37.123969],
        [24.532400, 37.130113],
        [24.520518, 37.203925],
        [24.443696, 37.178534]
    ],
    [
        [23.128429, 37.288398],
        [23.094412, 37.274726],
        [23.162364, 37.244208],
        [23.158458, 37.271389],
        [23.128429, 37.288398]
    ],
    [
        [23.587169, 37.370917],
        [23.463634, 37.357327],
        [23.374278, 37.302680],
        [23.496837, 37.320014],
        [23.587169, 37.370917]
    ],
    [
        [24.367931, 37.411933],
        [24.367931, 37.309516],
        [24.482677, 37.412421],
        [24.436209, 37.487006],
        [24.367931, 37.411933]
    ],
    [
        [25.395193, 37.418158],
        [25.462901, 37.470038],
        [25.312673, 37.488227],
        [25.306977, 37.411933],
        [25.395193, 37.418158]
    ],
    [
        [24.943370, 37.435492],
        [24.895356, 37.510443],
        [24.881847, 37.363511],
        [24.964041, 37.401760],
        [24.943370, 37.435492]
    ],
    [
        [23.477306, 37.555894],
        [23.436290, 37.521796],
        [23.525645, 37.521796],
        [23.500824, 37.532620],
        [23.477306, 37.555894]
    ],
    [
        [25.091319, 37.582587],
        [25.215994, 37.532904],
        [25.259288, 37.590033],
        [24.984874, 37.678860],
        [25.091319, 37.582587]
    ],
    [
        [24.374766, 37.686265],
        [24.289317, 37.645331],
        [24.275401, 37.531684],
        [24.395763, 37.624661],
        [24.374766, 37.686265]
    ],
    [
        [26.362153, 37.686265],
        [26.074229, 37.637885],
        [25.976329, 37.516018],
        [26.230642, 37.571357],
        [26.362153, 37.686265]
    ],
    [
        [23.546153, 37.774400],
        [23.425629, 37.768215],
        [23.424490, 37.761786],
        [23.484141, 37.678860],
        [23.546153, 37.774400]
    ],
    [
        [-0.732737, 37.747748],
        [-0.754506, 37.774400],
        [-0.746897, 37.683783],
        [-0.726471, 37.665188],
        [-0.732737, 37.747748]
    ],
    [
        [27.047537, 37.727240],
        [26.806407, 37.814521],
        [26.580251, 37.740790],
        [26.797374, 37.644680],
        [27.047537, 37.727240]
    ],
    [
        [-25.197825, 37.864407],
        [-25.764556, 37.911566],
        [-25.859486, 37.853909],
        [-25.505686, 37.706732],
        [-25.156850, 37.754543],
        [-25.197825, 37.864407]
    ],
    [
        [20.901378, 37.792426],
        [20.708995, 37.925238],
        [20.619477, 37.864407],
        [20.815115, 37.651516],
        [20.996349, 37.699286],
        [20.901378, 37.792426]
    ],
    [
        [12.273204, 37.939521],
        [12.299653, 37.919257],
        [12.368826, 37.925238],
        [12.314220, 37.946357],
        [12.273204, 37.939521]
    ],
    [
        [24.991710, 37.768215],
        [24.953868, 37.905992],
        [24.693614, 37.965766],
        [24.957530, 37.686265],
        [24.991710, 37.768215]
    ],
    [
        [23.408376, 37.898586],
        [23.518240, 37.898586],
        [23.573497, 37.952541],
        [23.429454, 37.987942],
        [23.408376, 37.898586]
    ],
    [
        [15.528656, 38.302639],
        [13.790782, 37.973619],
        [13.318126, 38.220649],
        [12.901134, 38.028062],
        [12.731781, 38.192776],
        [12.427013, 37.797024],
        [12.659353, 37.565131],
        [13.174083, 37.487006],
        [14.278819, 37.044013],
        [14.487315, 36.793362],
        [15.093923, 36.654934],
        [15.332367, 37.011623],
        [15.091563, 37.477484],
        [15.651622, 38.275295],
        [15.528656, 38.302639]
    ],
    [
        [14.966319, 38.432929],
        [14.948253, 38.396430],
        [14.986827, 38.364081],
        [15.007335, 38.377672],
        [14.966319, 38.432929]
    ],
    [
        [20.733572, 38.062405],
        [20.797699, 38.131293],
        [20.537771, 38.473944],
        [20.345388, 38.182115],
        [20.445323, 38.276190],
        [20.733572, 38.062405]
    ],
    [
        [20.715831, 38.392035],
        [20.671886, 38.497545],
        [20.619477, 38.481391],
        [20.687836, 38.336737],
        [20.763682, 38.323065],
        [20.715831, 38.392035]
    ],
    [
        [14.907725, 38.473944],
        [14.966319, 38.453437],
        [14.979340, 38.487535],
        [14.924815, 38.522366],
        [14.907725, 38.473944]
    ],
    [
        [-28.109486, 38.446601],
        [-28.374501, 38.550482],
        [-28.548899, 38.528551],
        [-28.459543, 38.405666],
        [-28.109486, 38.446601]
    ],
    [
        [14.863292, 38.549018],
        [14.866954, 38.581122],
        [14.793793, 38.571601],
        [14.861664, 38.539293],
        [14.863292, 38.549018]
    ],
    [
        [20.941091, 38.604234],
        [20.932140, 38.603013],
        [20.893891, 38.549018],
        [20.907563, 38.549018],
        [20.941091, 38.604234]
    ],
    [
        [26.163585, 38.542792],
        [25.848888, 38.580390],
        [25.989024, 38.379299],
        [25.889822, 38.220649],
        [26.112071, 38.222602],
        [26.163585, 38.542792]
    ],
    [
        [25.588878, 38.611721],
        [25.523204, 38.597398],
        [25.560802, 38.535346],
        [25.622813, 38.579088],
        [25.588878, 38.611721]
    ],
    [
        [-28.609731, 38.597398],
        [-28.719594, 38.645209],
        [-28.842397, 38.599433],
        [-28.727040, 38.514879],
        [-28.609731, 38.597398]
    ],
    [
        [-27.890981, 38.604234],
        [-28.034332, 38.666327],
        [-27.890981, 38.604234]
    ],
    [
        [1.526383, 38.677768],
        [1.431326, 38.754869],
        [1.382950, 38.642061],
        [1.581391, 38.653062],
        [1.526383, 38.677768]
    ],
    [
        [-27.020131, 38.693671],
        [-27.144276, 38.796088],
        [-27.391713, 38.758857],
        [-27.228383, 38.641099],
        [-27.020131, 38.693671]
    ],
    [
        [20.585460, 38.617906],
        [20.715994, 38.627021],
        [20.686290, 38.850084],
        [20.544607, 38.569525],
        [20.585460, 38.617906]
    ],
    [
        [24.676524, 38.809760],
        [24.560720, 38.944159],
        [24.461111, 38.967678],
        [24.566661, 38.762519],
        [24.676524, 38.809760]
    ],
    [
        [24.587657, 38.159247],
        [24.252452, 38.227973],
        [24.155610, 38.652655],
        [23.594005, 38.770209],
        [23.299083, 39.042467],
        [22.833751, 38.845404],
        [23.202322, 38.829901],
        [23.649181, 38.405666],
        [24.042247, 38.401516],
        [24.371755, 37.971910],
        [24.566661, 37.987942],
        [24.587657, 38.159247]
    ],
    [
        [-27.983469, 39.015123],
        [-27.942209, 39.053046],
        [-28.054840, 39.097724],
        [-28.061635, 39.036282],
        [-27.983469, 39.015123]
    ],
    [
        [8.455903, 39.073554],
        [8.346039, 39.097724],
        [8.409841, 38.961819],
        [8.483897, 39.069770],
        [8.455903, 39.073554]
    ],
    [
        [1.605968, 39.091295],
        [1.356781, 39.077623],
        [1.216645, 38.885077],
        [1.403105, 38.832278],
        [1.605968, 39.091295]
    ],
    [
        [8.305837, 39.193305],
        [8.229991, 39.172797],
        [8.254731, 39.107123],
        [8.305837, 39.104560],
        [8.305837, 39.193305]
    ],
    [
        [23.436290, 39.146145],
        [23.460460, 39.131822],
        [23.512869, 39.178534],
        [23.470470, 39.213813],
        [23.436290, 39.146145]
    ],
    [
        [23.669688, 39.118150],
        [23.716807, 39.077216],
        [23.792654, 39.124416],
        [23.587169, 39.207587],
        [23.669688, 39.118150]
    ],
    [
        [20.140391, 39.241685],
        [20.138438, 39.209296],
        [20.201915, 39.179633],
        [20.190115, 39.202623],
        [20.140391, 39.241685]
    ],
    [
        [23.936534, 39.221259],
        [23.957042, 39.289496],
        [23.833507, 39.146145],
        [23.895844, 39.161770],
        [23.936534, 39.221259]
    ],
    [
        [26.612315, 39.049262],
        [26.362153, 39.378852],
        [25.842052, 39.228013],
        [26.063975, 39.090888],
        [26.280040, 39.196438],
        [26.165701, 39.022406],
        [26.612315, 39.049262]
    ],
    [
        [-31.207916, 39.508612],
        [-31.280914, 39.443101],
        [-31.254750, 39.358100],
        [-31.131581, 39.423000],
        [-31.207916, 39.508612]
    ],
    [
        [25.012218, 39.563870],
        [24.976573, 39.537665],
        [24.984874, 39.466986],
        [25.047374, 39.545356],
        [25.012218, 39.563870]
    ],
    [
        [-31.117299, 39.728339],
        [-31.152699, 39.701077],
        [-31.131581, 39.658840],
        [-31.080230, 39.693305],
        [-31.117299, 39.728339]
    ],
    [
        [20.092052, 39.433539],
        [19.844981, 39.652655],
        [19.948009, 39.790351],
        [19.626475, 39.748236],
        [19.911794, 39.430325],
        [20.092052, 39.433539]
    ],
    [
        [26.060557, 39.837592],
        [26.004242, 39.845201],
        [25.978038, 39.834174],
        [26.074962, 39.784898],
        [26.060557, 39.837592]
    ],
    [
        [3.354503, 39.784369],
        [3.136485, 39.788764],
        [3.179454, 39.968777],
        [2.350759, 39.576483],
        [2.681651, 39.558661],
        [3.060802, 39.269070],
        [3.453868, 39.659695],
        [3.354503, 39.784369]
    ],
    [
        [25.449880, 40.036200],
        [25.033376, 39.995266],
        [25.047048, 39.837592],
        [25.250662, 39.918524],
        [25.348969, 39.787665],
        [25.449880, 40.036200]
    ],
    [
        [4.302908, 39.925523],
        [4.105072, 40.079413],
        [3.803152, 40.018134],
        [4.248139, 39.816474],
        [4.302908, 39.925523]
    ],
    [
        [26.012218, 40.166571],
        [25.925955, 40.242825],
        [25.663259, 40.126166],
        [25.765961, 40.097154],
        [26.012218, 40.166571]
    ],
    [
        [25.690684, 40.447699],
        [25.575857, 40.514716],
        [25.443533, 40.481879],
        [25.567149, 40.399888],
        [25.690684, 40.447699]
    ],
    [
        [27.657563, 40.653144],
        [27.545909, 40.660346],
        [27.526378, 40.639106],
        [27.732677, 40.625190],
        [27.657563, 40.653144]
    ],
    [
        [13.944672, 40.701606],
        [13.965831, 40.735053],
        [13.862804, 40.762397],
        [13.849132, 40.715277],
        [13.944672, 40.701606]
    ],
    [
        [24.786388, 40.735053],
        [24.642263, 40.803941],
        [24.516775, 40.639106],
        [24.780121, 40.612209],
        [24.786388, 40.735053]
    ],
    [
        [8.274750, 41.057278],
        [8.326182, 41.126125],
        [8.277843, 41.105658],
        [8.209646, 40.995795],
        [8.274750, 41.057278]
    ],
    [
        [9.792247, 40.556952],
        [9.723969, 40.844916],
        [9.504242, 40.926907],
        [9.662608, 41.002631],
        [9.230642, 41.262641],
        [8.520518, 40.826972],
        [8.193044, 40.963772],
        [8.147309, 40.593207],
        [8.379893, 40.468695],
        [8.490001, 40.104478],
        [8.394542, 39.912665],
        [8.555186, 39.852688],
        [8.372813, 39.222073],
        [8.640961, 38.864325],
        [9.025727, 38.995307],
        [9.013927, 39.263902],
        [9.566417, 39.149237],
        [9.732270, 40.083930],
        [9.626150, 40.263088],
        [9.792247, 40.556952]
    ],
    [
        [10.895844, 42.386705],
        [10.861827, 42.366278],
        [10.923331, 42.318728],
        [10.939764, 42.330660],
        [10.895844, 42.386705]
    ],
    [
        [9.456554, 42.647406],
        [9.476817, 42.619086],
        [9.482107, 42.620103],
        [9.456554, 42.647406]
    ],
    [
        [16.858165, 42.784003],
        [16.820811, 42.736070],
        [16.936371, 42.755520],
        [16.921072, 42.777167],
        [16.858165, 42.784003]
    ],
    [
        [17.658946, 42.742987],
        [17.392345, 42.801703],
        [17.323741, 42.790839],
        [17.748871, 42.694566],
        [17.658946, 42.742987]
    ],
    [
        [10.443370, 42.845445],
        [10.132986, 42.811916],
        [10.106781, 42.757392],
        [10.415538, 42.708889],
        [10.443370, 42.845445]
    ],
    [
        [17.131847, 42.969550],
        [16.824067, 42.962104],
        [17.200206, 42.921780],
        [17.131847, 42.969550]
    ],
    [
        [8.565766, 42.208564],
        [8.744965, 42.056586],
        [8.614268, 41.900784],
        [8.805431, 41.906928],
        [8.655121, 41.749905],
        [8.922699, 41.694648],
        [8.791759, 41.561225],
        [9.223155, 41.372504],
        [9.559581, 42.146552],
        [9.464041, 42.990058],
        [9.346690, 43.003730],
        [9.292166, 42.674750],
        [8.709158, 42.579169],
        [8.565766, 42.208564]
    ],
    [
        [9.840099, 43.065172],
        [9.806944, 43.066408],
        [9.801498, 43.007805],
        [9.842127, 43.024956],
        [9.840099, 43.065172]
    ],
    [
        [16.241222, 43.071967],
        [16.130219, 43.088446],
        [16.048839, 43.065172],
        [16.087169, 43.011461],
        [16.241222, 43.071967]
    ],
    [
        [16.693126, 43.127265],
        [16.943248, 43.127265],
        [16.693126, 43.127265]
    ],
    [
        [16.500743, 43.284247],
        [16.813162, 43.267768],
        [16.892345, 43.312201],
        [16.426280, 43.394110],
        [16.500743, 43.284247]
    ],
    [
        [16.391449, 43.346381],
        [16.277029, 43.411933],
        [16.200450, 43.407050],
        [16.348643, 43.338690],
        [16.391449, 43.346381]
    ],
    [
        [15.678884, 43.648017],
        [15.650157, 43.673041],
        [15.603770, 43.674709],
        [15.672048, 43.637437],
        [15.740408, 43.627509],
        [15.678884, 43.648017]
    ],
    [
        [15.261241, 43.867092],
        [15.227794, 43.874457],
        [15.266368, 43.857001],
        [15.261241, 43.867092]
    ],
    [
        [15.302745, 43.966376],
        [15.358653, 43.919379],
        [15.446056, 43.887519],
        [15.261241, 44.011054],
        [15.302745, 43.966376]
    ],
    [
        [15.254405, 44.017890],
        [15.225759, 44.066230],
        [15.062511, 44.161933],
        [15.121837, 44.092231],
        [15.254405, 44.017890]
    ],
    [
        [14.842784, 44.148261],
        [14.827403, 44.157904],
        [14.822439, 44.168687],
        [14.819835, 44.153022],
        [14.835216, 44.141669],
        [14.869151, 44.140530],
        [14.842784, 44.148261]
    ],
    [
        [15.144542, 43.949652],
        [15.007335, 44.093004],
        [14.849620, 44.175605],
        [15.106619, 43.925442],
        [15.194509, 43.872626],
        [15.144542, 43.949652]
    ],
    [
        [14.876964, 44.559760],
        [15.128754, 44.311998],
        [15.254405, 44.340033],
        [14.733653, 44.703192],
        [14.876964, 44.559760]
    ],
    [
        [14.445567, 44.565985],
        [14.397472, 44.685614],
        [14.335785, 44.716783],
        [14.363048, 44.573432],
        [14.534353, 44.484076],
        [14.445567, 44.565985]
    ],
    [
        [14.740489, 44.778266],
        [14.849620, 44.703192],
        [14.859060, 44.717353],
        [14.685802, 44.847154],
        [14.740489, 44.778266]
    ],
    [
        [14.513927, 44.662177],
        [14.473481, 44.971422],
        [14.313650, 45.172431],
        [14.411388, 44.956366],
        [14.294200, 44.908637],
        [14.513927, 44.662177]
    ],
    [
        [14.723399, 44.943345],
        [14.814952, 44.977484],
        [14.548839, 45.248725],
        [14.425059, 45.087348],
        [14.723399, 44.943345]
    ],
    [
        [12.352061, 45.405463],
        [12.321462, 45.348009],
        [12.430919, 45.415676],
        [12.389171, 45.433539],
        [12.352061, 45.405463]
    ],
    [
        [-1.219390, 45.943915],
        [-1.247629, 46.001776],
        [-1.404937, 46.053168],
        [-1.209218, 45.814154],
        [-1.219390, 45.943915]
    ],
    [
        [-1.281402, 46.156195],
        [-1.308095, 46.206936],
        [-1.555816, 46.251776],
        [-1.504262, 46.207668],
        [-1.281402, 46.156195]
    ],
    [
        [-2.337229, 46.731594],
        [-2.382924, 46.722642],
        [-2.268951, 46.697414],
        [-2.298207, 46.720160],
        [-2.337229, 46.731594]
    ],
    [
        [-2.200103, 46.985419],
        [-2.200022, 47.024359],
        [-2.295644, 47.033189],
        [-2.142568, 46.909857],
        [-2.200103, 46.985419]
    ],
    [
        [-3.114654, 47.331488],
        [-3.242991, 47.395331],
        [-3.262074, 47.383246],
        [-3.114654, 47.331488]
    ],
    [
        [-5.050282, 48.478827],
        [-5.091786, 48.480780],
        [-5.132802, 48.458319],
        [-5.087961, 48.447211],
        [-5.050282, 48.478827]
    ],
    [
        [-2.082672, 49.260240],
        [-2.241119, 49.260240],
        [-2.233632, 49.184516],
        [-2.024526, 49.171332],
        [-2.082672, 49.260240]
    ],
    [
        [-2.580230, 49.493598],
        [-2.650258, 49.463690],
        [-2.673451, 49.433498],
        [-2.501698, 49.506659],
        [-2.580230, 49.493598]
    ],
    [
        [-1.082753, 50.713324],
        [-1.318512, 50.772162],
        [-1.569488, 50.658026],
        [-1.279205, 50.582506],
        [-1.082753, 50.713324]
    ],
    [
        [-0.959869, 50.808254],
        [-0.972564, 50.829779],
        [-1.020741, 50.788398],
        [-0.938832, 50.780951],
        [-0.959869, 50.808254]
    ],
    [
        [-179.143503, 51.275051],
        [-179.119008, 51.215399],
        [-179.061594, 51.247707],
        [-179.088246, 51.296088],
        [-179.143503, 51.275051]
    ],
    [
        [-178.985829, 51.384223],
        [-178.986887, 51.307522],
        [-178.904246, 51.353827],
        [-178.954416, 51.395209],
        [-178.985829, 51.384223]
    ],
    [
        [0.911469, 51.412177],
        [0.766938, 51.447943],
        [0.733897, 51.412177],
        [0.936371, 51.371039],
        [0.911469, 51.412177]
    ],
    [
        [4.036632, 51.685858],
        [3.814220, 51.748236],
        [3.686697, 51.692694],
        [4.099376, 51.654120],
        [4.036632, 51.685858]
    ],
    [
        [-178.786529, 51.829901],
        [-178.858876, 51.795722],
        [-178.808298, 51.747301],
        [-178.740183, 51.783637],
        [-178.786529, 51.829901]
    ],
    [
        [-176.264719, 51.810004],
        [-176.303212, 51.868964],
        [-176.423044, 51.851020],
        [-176.385610, 51.737128],
        [-176.264719, 51.810004]
    ],
    [
        [-176.011464, 51.829901],
        [-176.190134, 51.886705],
        [-176.223744, 51.843573],
        [-176.148671, 51.775295],
        [-176.011464, 51.829901]
    ],
    [
        [-175.990956, 51.884508],
        [-176.020945, 51.912787],
        [-176.107737, 51.884508],
        [-175.956858, 51.851020],
        [-175.990956, 51.884508]
    ],
    [
        [-177.800282, 51.795722],
        [-177.647410, 51.820502],
        [-177.622182, 51.857164],
        [-178.213816, 51.876044],
        [-177.955393, 51.763739],
        [-178.101389, 51.665432],
        [-177.933461, 51.598700],
        [-177.800282, 51.795722]
    ],
    [
        [-177.122182, 51.932929],
        [-177.292470, 51.782782],
        [-177.704701, 51.700141],
        [-177.156687, 51.700141],
        [-177.122182, 51.932929]
    ],
    [
        [-175.724110, 51.973863],
        [-175.752024, 51.939154],
        [-175.662058, 51.959621],
        [-175.662058, 51.967027],
        [-175.724110, 51.973863]
    ],
    [
        [-176.437245, 51.788275],
        [-176.641469, 51.857164],
        [-176.545888, 51.980129],
        [-176.758778, 51.953437],
        [-176.704172, 51.788275],
        [-176.904775, 51.807563],
        [-176.977895, 51.600287],
        [-176.437245, 51.788275]
    ],
    [
        [-175.867502, 51.987494],
        [-175.939158, 51.986477],
        [-175.950022, 51.973863],
        [-175.867502, 51.987494]
    ],
    [
        [-176.138702, 51.994371],
        [-176.043040, 51.963365],
        [-175.963694, 52.035346],
        [-176.143259, 52.107123],
        [-176.138702, 51.994371]
    ],
    [
        [-173.123402, 52.107978],
        [-173.592030, 52.152045],
        [-173.123402, 52.107978]
    ],
    [
        [-172.407175, 52.385443],
        [-172.557973, 52.350653],
        [-172.633046, 52.261298],
        [-172.310902, 52.316474],
        [-172.407175, 52.385443]
    ],
    [
        [-174.051910, 52.240790],
        [-174.010976, 52.358100],
        [-174.190297, 52.417873],
        [-174.435536, 52.322699],
        [-174.228261, 52.267524],
        [-174.339345, 52.186184],
        [-174.411366, 52.042792],
        [-174.051910, 52.240790]
    ],
    [
        [-171.256418, 52.529446],
        [-171.293568, 52.514106],
        [-171.311635, 52.464260],
        [-171.222157, 52.463080],
        [-171.256418, 52.529446]
    ],
    [
        [-170.604644, 52.687079],
        [-170.743723, 52.678697],
        [-170.837392, 52.549262],
        [-170.621938, 52.593899],
        [-170.604644, 52.687079]
    ],
    [
        [-170.104400, 52.782660],
        [-170.186960, 52.782660],
        [-170.194407, 52.727444],
        [-170.063425, 52.734280],
        [-170.104400, 52.782660]
    ],
    [
        [-169.686635, 52.872016],
        [-169.850290, 52.882514],
        [-170.011098, 52.823635],
        [-169.723378, 52.774482],
        [-169.686635, 52.872016]
    ],
    [
        [-170.070261, 52.919176],
        [-170.124827, 52.888617],
        [-170.014272, 52.905829],
        [-170.070261, 52.919176]
    ],
    [
        [-169.693471, 53.035875],
        [-169.753285, 53.024807],
        [-169.748118, 52.946519],
        [-169.666208, 53.001166],
        [-169.693471, 53.035875]
    ],
    [
        [4.892589, 53.111029],
        [4.854340, 53.187730],
        [4.707693, 53.028469],
        [4.795665, 53.000312],
        [4.892589, 53.111029]
    ],
    [
        [-9.662668, 53.275458],
        [-9.710357, 53.275458],
        [-9.710357, 53.238593],
        [-9.658315, 53.232652],
        [-9.662668, 53.275458]
    ],
    [
        [4.878917, 53.220893],
        [4.910167, 53.212470],
        [5.104828, 53.309638],
        [4.986501, 53.289984],
        [4.878917, 53.220893]
    ],
    [
        [-4.577260, 53.272040],
        [-4.626291, 53.320868],
        [-4.693959, 53.309638],
        [-4.563629, 53.241929],
        [-4.577260, 53.272040]
    ],
    [
        [-4.098134, 53.309638],
        [-4.324696, 53.419501],
        [-4.571034, 53.392768],
        [-4.406606, 53.130601],
        [-4.098134, 53.309638]
    ],
    [
        [5.423595, 53.430365],
        [5.250173, 53.406440],
        [5.167654, 53.368232],
        [5.423595, 53.430365]
    ],
    [
        [5.674001, 53.467922],
        [5.636078, 53.448676],
        [5.954600, 53.461086],
        [5.913829, 53.473863],
        [5.674001, 53.467922]
    ],
    [
        [6.211762, 53.508857],
        [6.127452, 53.459906],
        [6.338715, 53.502021],
        [6.310802, 53.514146],
        [6.211762, 53.508857]
    ],
    [
        [6.441173, 53.556627],
        [6.496430, 53.536200],
        [6.510102, 53.543606],
        [6.455089, 53.558092],
        [6.441173, 53.556627]
    ],
    [
        [-167.857493, 53.392768],
        [-167.806996, 53.520087],
        [-168.236806, 53.530097],
        [-168.406565, 53.409491],
        [-168.360789, 53.271308],
        [-168.623362, 53.274237],
        [-169.111277, 52.823635],
        [-167.857493, 53.392768]
    ],
    [
        [6.798106, 53.604438],
        [6.784679, 53.620063],
        [6.659516, 53.599107],
        [6.756521, 53.562893],
        [6.798106, 53.604438]
    ],
    [
        [6.873790, 53.672756],
        [7.085460, 53.686998],
        [7.047048, 53.694159],
        [6.873790, 53.672756]
    ],
    [
        [7.133149, 53.708075],
        [7.173595, 53.701402],
        [7.346690, 53.723212],
        [7.232921, 53.729438],
        [7.133149, 53.708075]
    ],
    [
        [7.366547, 53.727973],
        [7.421235, 53.721137],
        [7.435557, 53.727973],
        [7.403494, 53.736721],
        [7.366547, 53.727973]
    ],
    [
        [8.120128, 53.721137],
        [8.150890, 53.714301],
        [8.195974, 53.727973],
        [8.152354, 53.739163],
        [8.120128, 53.721137]
    ],
    [
        [7.517426, 53.762112],
        [7.472992, 53.731879],
        [7.627208, 53.750922],
        [7.606619, 53.762600],
        [7.517426, 53.762112]
    ],
    [
        [7.660899, 53.762112],
        [7.748220, 53.760932],
        [7.812836, 53.783149],
        [7.686290, 53.780992],
        [7.660899, 53.762112]
    ],
    [
        [7.873790, 53.776353],
        [7.875255, 53.788398],
        [7.854503, 53.784573],
        [7.873790, 53.776353]
    ],
    [
        [-166.136952, 53.837836],
        [-166.290517, 53.795356],
        [-166.297841, 53.760199],
        [-166.212636, 53.708075],
        [-166.136952, 53.837836]
    ],
    [
        [-166.294301, 53.727973],
        [-166.575144, 53.714301],
        [-166.224924, 53.905463],
        [-166.370351, 54.008490],
        [-166.609934, 53.831000],
        [-166.634592, 54.004584],
        [-167.021596, 53.961249],
        [-167.151112, 53.824164],
        [-166.705515, 53.721137],
        [-167.850046, 53.309638],
        [-166.752187, 53.450873],
        [-166.794871, 53.570299],
        [-166.659169, 53.490912],
        [-166.294301, 53.727973]
    ],
    [
        [-9.963612, 53.953843],
        [-9.975901, 54.021145],
        [-10.265940, 53.981838],
        [-9.957997, 53.880601],
        [-9.963612, 53.953843]
    ],
    [
        [11.375662, 53.981838],
        [11.457693, 53.961371],
        [11.497895, 54.022773],
        [11.426606, 54.022935],
        [11.375662, 53.981838]
    ],
    [
        [-165.266713, 54.091051],
        [-165.376576, 54.091051],
        [-165.485829, 54.077460],
        [-165.294057, 54.043891],
        [-165.266713, 54.091051]
    ],
    [
        [11.528494, 54.075100],
        [11.539561, 54.056952],
        [11.615896, 54.112128],
        [11.533946, 54.084866],
        [11.528494, 54.075100]
    ],
    [
        [-165.739084, 54.125190],
        [-165.945505, 54.222073],
        [-166.122670, 54.118354],
        [-165.900746, 54.033352],
        [-165.739084, 54.125190]
    ],
    [
        [-165.485829, 54.173651],
        [-165.494333, 54.296373],
        [-165.679799, 54.248928],
        [-165.609975, 54.118354],
        [-165.485829, 54.173651]
    ],
    [
        [-4.612131, 54.056952],
        [-4.311920, 54.287177],
        [-4.351308, 54.413804],
        [-4.790151, 54.071234],
        [-4.612131, 54.056952]
    ],
    [
        [8.963145, 54.523668],
        [8.844493, 54.519721],
        [8.812836, 54.482123],
        [8.887950, 54.468451],
        [8.963145, 54.523668]
    ],
    [
        [11.255626, 54.478705],
        [11.121267, 54.535956],
        [11.005707, 54.468451],
        [11.314220, 54.413804],
        [11.255626, 54.478705]
    ],
    [
        [13.143403, 54.598131],
        [13.102306, 54.596096],
        [13.118907, 54.586412],
        [13.143403, 54.598131]
    ],
    [
        [13.698253, 54.392076],
        [13.575450, 54.471869],
        [13.670665, 54.566230],
        [13.390798, 54.688178],
        [13.253266, 54.564643],
        [13.369151, 54.612128],
        [13.520763, 54.570787],
        [13.507091, 54.488267],
        [13.369395, 54.585150],
        [13.143403, 54.542914],
        [13.266856, 54.385891],
        [13.115489, 54.338080],
        [13.407237, 54.228217],
        [13.499685, 54.344916],
        [13.723155, 54.278388],
        [13.698253, 54.392076]
    ],
    [
        [8.332367, 54.693793],
        [8.291515, 54.667060],
        [8.382335, 54.639146],
        [8.332367, 54.693793]
    ],
    [
        [8.497569, 54.756415],
        [8.436778, 54.748481],
        [8.394542, 54.714830],
        [8.593761, 54.721666],
        [8.497569, 54.756415]
    ],
    [
        [-159.284535, 54.940823],
        [-159.286610, 54.871731],
        [-159.208811, 54.918524],
        [-159.212595, 54.931138],
        [-159.284535, 54.940823]
    ],
    [
        [11.845225, 54.731920],
        [11.649425, 54.913520],
        [11.594737, 54.811103],
        [11.231700, 54.961249],
        [10.999197, 54.786770],
        [11.474376, 54.626125],
        [11.845225, 54.731920]
    ],
    [
        [10.450206, 54.899807],
        [10.426036, 54.872504],
        [10.189220, 54.977484],
        [10.383474, 54.830756],
        [10.518565, 54.851996],
        [10.450206, 54.899807]
    ],
    [
        [-8.524892, 55.009711],
        [-8.552235, 55.009711],
        [-8.565826, 54.975531],
        [-8.483957, 54.975531],
        [-8.524892, 55.009711]
    ],
    [
        [-159.390085, 55.023383],
        [-159.462717, 55.064276],
        [-159.462717, 54.948188],
        [-159.339182, 54.975531],
        [-159.390085, 55.023383]
    ],
    [
        [12.417166, 55.030219],
        [12.250987, 55.060736],
        [12.115001, 54.907294],
        [12.551768, 54.957180],
        [12.417166, 55.030219]
    ],
    [
        [8.360362, 54.948188],
        [8.298025, 54.912543],
        [8.307140, 54.865383],
        [8.654470, 54.893622],
        [8.360362, 54.948188]
    ],
    [
        [10.011404, 54.975531],
        [9.793468, 55.080756],
        [9.628429, 55.058051],
        [9.953624, 54.862616],
        [10.011404, 54.975531]
    ],
    [
        [10.854991, 55.043850],
        [10.601085, 54.838324],
        [10.693858, 54.735297],
        [10.956716, 55.153713],
        [10.854991, 55.043850]
    ],
    [
        [-159.524159, 55.071112],
        [-159.507069, 55.171088],
        [-159.533640, 55.251044],
        [-159.659250, 55.065131],
        [-159.524159, 55.071112]
    ],
    [
        [-159.901479, 55.140082],
        [-159.887278, 55.297065],
        [-160.017568, 55.105292],
        [-160.194814, 55.121527],
        [-160.092722, 55.050686],
        [-160.237050, 54.888577],
        [-159.901479, 55.140082]
    ],
    [
        [15.151378, 55.133205],
        [14.760916, 55.309272],
        [14.684173, 55.101347],
        [15.072666, 54.991638],
        [15.151378, 55.133205]
    ],
    [
        [-6.236399, 55.311347],
        [-6.283559, 55.297065],
        [-6.171864, 55.293199],
        [-6.174306, 55.303900],
        [-6.236399, 55.311347]
    ],
    [
        [-163.139027, 55.403510],
        [-163.142771, 55.441067],
        [-163.195058, 55.412665],
        [-163.151682, 55.396959],
        [-163.139027, 55.403510]
    ],
    [
        [8.476410, 55.345445],
        [8.463390, 55.427436],
        [8.374360, 55.463284],
        [8.402354, 55.380032],
        [8.476410, 55.345445]
    ],
    [
        [10.666270, 55.064276],
        [10.834321, 55.290269],
        [10.554047, 55.442572],
        [10.742361, 55.487494],
        [10.627615, 55.613593],
        [10.471528, 55.443061],
        [10.307628, 55.618232],
        [9.676280, 55.495673],
        [9.985525, 55.127753],
        [10.156016, 55.140082],
        [10.065929, 55.092231],
        [10.666270, 55.064276]
    ],
    [
        [12.615733, 55.688137],
        [12.520193, 55.619208],
        [12.556326, 55.550482],
        [12.674571, 55.601264],
        [12.615733, 55.688137]
    ],
    [
        [-5.070790, 55.509345],
        [-5.198313, 55.704332],
        [-5.392893, 55.646552],
        [-5.304677, 55.462144],
        [-5.070790, 55.509345]
    ],
    [
        [-5.029775, 55.749498],
        [-5.080922, 55.879584],
        [-5.199534, 55.911078],
        [-5.115590, 55.784369],
        [-5.029775, 55.749498]
    ],
    [
        [-6.030385, 55.729071],
        [-6.140126, 55.941352],
        [-6.445221, 55.848822],
        [-6.503529, 55.681342],
        [-6.249989, 55.776842],
        [-6.287343, 55.578437],
        [-6.030385, 55.729071]
    ],
    [
        [10.559418, 55.866278],
        [10.582205, 55.759752],
        [10.669281, 55.880032],
        [10.543956, 55.997992],
        [10.559418, 55.866278]
    ],
    [
        [-6.205719, 56.102729],
        [-6.254303, 56.044623],
        [-6.269887, 56.037543],
        [-6.174306, 56.043769],
        [-6.133372, 56.112616],
        [-6.205719, 56.102729]
    ],
    [
        [12.040375, 54.893012],
        [11.897146, 54.995429],
        [12.177013, 55.105292],
        [12.014659, 55.167467],
        [12.465017, 55.290269],
        [12.198090, 55.487494],
        [12.602224, 55.708564],
        [12.512706, 55.928290],
        [12.621918, 56.043769],
        [12.245128, 56.128730],
        [11.865571, 55.972724],
        [12.026134, 55.941352],
        [12.095063, 55.729071],
        [12.060313, 55.653998],
        [11.910167, 55.660142],
        [12.051931, 55.736640],
        [11.934744, 55.933661],
        [11.953624, 55.853502],
        [11.779796, 55.660142],
        [11.607758, 55.783026],
        [11.768321, 55.970526],
        [11.272634, 55.996568],
        [11.505219, 55.868720],
        [11.192638, 55.700344],
        [10.875499, 55.742743],
        [11.087738, 55.660142],
        [10.929942, 55.667629],
        [11.145681, 55.576117],
        [11.214203, 55.403795],
        [11.087738, 55.358547],
        [11.260997, 55.200588],
        [11.806977, 55.146877],
        [11.615896, 55.092231],
        [11.882823, 54.981757],
        [11.711436, 54.940823],
        [11.949067, 54.568590],
        [12.170177, 54.838324],
        [12.040375, 54.893012]
    ],
    [
        [-5.797597, 56.112616],
        [-6.075185, 55.915961],
        [-6.062408, 55.809475],
        [-5.687978, 56.124091],
        [-5.797597, 56.112616]
    ],
    [
        [-5.688303, 56.202053],
        [-5.738352, 56.177476],
        [-5.749135, 56.161078],
        [-5.673655, 56.178941],
        [-5.688303, 56.202053]
    ],
    [
        [-5.633127, 56.263495],
        [-5.666656, 56.222480],
        [-5.637441, 56.189276],
        [-5.610585, 56.249416],
        [-5.633127, 56.263495]
    ],
    [
        [-5.633127, 56.318752],
        [-5.621693, 56.276068],
        [-5.584625, 56.325588],
        [-5.620758, 56.324205],
        [-5.633127, 56.318752]
    ],
    [
        [-5.557973, 56.414293],
        [-5.584625, 56.387030],
        [-5.536204, 56.392239],
        [-5.502756, 56.421129],
        [-5.557973, 56.414293]
    ],
    [
        [-6.160024, 56.469550],
        [-6.215321, 56.503648],
        [-6.263661, 56.483222],
        [-6.237457, 56.470038],
        [-6.160024, 56.469550]
    ],
    [
        [-6.818593, 56.537828],
        [-6.900502, 56.516669],
        [-6.818593, 56.537828]
    ],
    [
        [-5.688303, 56.434801],
        [-6.151275, 56.651801],
        [-6.338206, 56.552069],
        [-6.016672, 56.503648],
        [-6.203236, 56.380316],
        [-6.366119, 56.322170],
        [-5.688303, 56.434801]
    ],
    [
        [-6.459218, 56.678127],
        [-6.559234, 56.665269],
        [-6.701894, 56.585639],
        [-6.616322, 56.575181],
        [-6.459218, 56.678127]
    ],
    [
        [11.512218, 56.695461],
        [11.581065, 56.681220],
        [11.649425, 56.729641],
        [11.520844, 56.715399],
        [11.512218, 56.695461]
    ],
    [
        [8.825857, 56.743842],
        [8.928884, 56.976630],
        [8.514659, 56.738227],
        [8.658376, 56.678127],
        [8.825857, 56.743842]
    ],
    [
        [-7.393951, 57.010199],
        [-7.449208, 57.058580],
        [-7.556752, 56.953070],
        [-7.445302, 56.947089],
        [-7.393951, 57.010199]
    ],
    [
        [-6.325185, 57.058580],
        [-6.364247, 57.055650],
        [-6.455474, 57.003974],
        [-6.276031, 56.953111],
        [-6.325185, 57.058580]
    ],
    [
        [-6.606353, 57.051744],
        [-6.548248, 57.047593],
        [-6.489654, 57.058580],
        [-6.537465, 57.072821],
        [-6.606353, 57.051744]
    ],
    [
        [-5.958608, 57.284491],
        [-5.929351, 57.307196],
        [-6.013905, 57.317450],
        [-6.007802, 57.303616],
        [-5.958608, 57.284491]
    ],
    [
        [11.142345, 57.332343],
        [10.946601, 57.304643],
        [10.854991, 57.264635],
        [11.028835, 57.201914],
        [11.142345, 57.332343]
    ],
    [
        [17.124522, 57.319281],
        [17.054861, 57.358222],
        [16.966482, 57.304592],
        [16.419444, 56.585639],
        [16.428477, 56.217963],
        [17.124522, 57.319281]
    ],
    [
        [-7.243764, 57.325507],
        [-7.428131, 57.387600],
        [-7.353017, 57.099555],
        [-7.215891, 57.113837],
        [-7.346181, 57.147935],
        [-7.243764, 57.325507]
    ],
    [
        [-7.263580, 57.483100],
        [-7.369618, 57.489325],
        [-7.407623, 57.445624],
        [-7.205434, 57.418606],
        [-7.263580, 57.483100]
    ],
    [
        [-6.064443, 57.346584],
        [-5.989491, 57.347317],
        [-5.993316, 57.507025],
        [-6.069081, 57.436103],
        [-6.064443, 57.346584]
    ],
    [
        [-5.968251, 57.517890],
        [-5.955190, 57.572496],
        [-5.961903, 57.577297],
        [-5.989980, 57.532945],
        [-5.968251, 57.517890]
    ],
    [
        [-7.129384, 57.652899],
        [-7.312082, 57.688544],
        [-7.544830, 57.592963],
        [-7.312082, 57.552069],
        [-7.129384, 57.652899]
    ],
    [
        [-6.564117, 57.346584],
        [-6.530629, 57.415473],
        [-6.323883, 57.311428],
        [-6.482167, 57.311835],
        [-6.318349, 57.161038],
        [-5.845367, 57.188300],
        [-6.006744, 57.028388],
        [-5.647369, 57.264635],
        [-6.153879, 57.305609],
        [-6.153879, 57.589545],
        [-6.310902, 57.702826],
        [-6.415679, 57.645819],
        [-6.310902, 57.462633],
        [-6.640452, 57.607327],
        [-6.606801, 57.443915],
        [-6.783844, 57.456448],
        [-6.564117, 57.346584]
    ],
    [
        [-7.222646, 57.709662],
        [-7.198964, 57.707953],
        [-7.152008, 57.726304],
        [-7.180165, 57.734687],
        [-7.222646, 57.709662]
    ],
    [
        [-8.621002, 57.833197],
        [-8.590891, 57.804755],
        [-8.552235, 57.818915],
        [-8.605295, 57.826402],
        [-8.621002, 57.833197]
    ],
    [
        [-7.044586, 57.902086],
        [-7.009185, 57.889594],
        [-6.997385, 57.915107],
        [-7.037750, 57.916327],
        [-7.044586, 57.902086]
    ],
    [
        [19.040212, 57.867906],
        [18.677745, 57.913886],
        [18.128184, 57.548163],
        [18.099376, 57.258979],
        [18.290212, 57.092719],
        [18.138682, 56.922024],
        [18.926280, 57.392646],
        [18.764659, 57.626899],
        [19.040212, 57.867906]
    ],
    [
        [19.272960, 57.976549],
        [19.098318, 57.976549],
        [19.036794, 57.905219],
        [19.129649, 57.846869],
        [19.272960, 57.976549]
    ],
    [
        [11.738780, 58.058539],
        [11.524750, 58.050727],
        [11.497895, 58.028062],
        [11.594737, 57.935614],
        [11.738780, 58.058539]
    ],
    [
        [-6.873280, 58.216783],
        [-6.873280, 58.209947],
        [-6.791249, 58.209947],
        [-6.880035, 58.257758],
        [-6.873280, 58.216783]
    ],
    [
        [11.806977, 58.230414],
        [11.686371, 58.291205],
        [11.406586, 58.131090],
        [11.708181, 58.098212],
        [11.806977, 58.230414]
    ],
    [
        [19.331716, 58.367621],
        [19.222423, 58.394965],
        [19.187755, 58.394965],
        [19.250336, 58.342841],
        [19.331716, 58.367621]
    ],
    [
        [-6.955149, 57.743842],
        [-6.660959, 57.880316],
        [-6.764027, 58.003892],
        [-6.688303, 58.058539],
        [-6.537465, 57.921332],
        [-6.352447, 58.038642],
        [-6.619374, 58.086412],
        [-6.160024, 58.216783],
        [-6.366119, 58.237250],
        [-6.167470, 58.346503],
        [-6.223053, 58.499213],
        [-6.818593, 58.285102],
        [-6.709381, 58.189439],
        [-6.859609, 58.106879],
        [-7.112782, 58.182034],
        [-6.934641, 58.052314],
        [-7.112782, 57.990220],
        [-6.839101, 57.935614],
        [-7.125071, 57.836900],
        [-6.955149, 57.743842]
    ],
    [
        [-2.952952, 58.839993],
        [-3.035553, 58.820054],
        [-2.939931, 58.730699],
        [-2.883656, 58.832180],
        [-2.952952, 58.839993]
    ],
    [
        [-3.248402, 58.792182],
        [-3.246083, 58.896186],
        [-3.433339, 58.884955],
        [-3.299306, 58.779120],
        [-3.248402, 58.792182]
    ],
    [
        [-2.727651, 58.970893],
        [-3.116689, 58.998196],
        [-2.994496, 59.073310],
        [-3.182729, 59.147162],
        [-3.366689, 59.016099],
        [-2.823842, 58.881537],
        [-2.727651, 58.970893]
    ],
    [
        [-2.541982, 59.120551],
        [-2.665517, 59.155219],
        [-2.686106, 59.089179],
        [-2.514760, 59.093817],
        [-2.541982, 59.120551]
    ],
    [
        [-3.004791, 59.127997],
        [-2.952952, 59.183173],
        [-3.120432, 59.176581],
        [-3.091786, 59.142808],
        [-3.004791, 59.127997]
    ],
    [
        [-2.830068, 59.196845],
        [-2.789133, 59.145331],
        [-2.734486, 59.148424],
        [-2.761098, 59.252102],
        [-2.830068, 59.196845]
    ],
    [
        [18.430431, 59.258287],
        [18.551606, 59.225898],
        [18.612315, 59.258287],
        [18.344737, 59.299262],
        [18.430431, 59.258287]
    ],
    [
        [-2.446401, 59.293036],
        [-2.611562, 59.293036],
        [-2.595570, 59.264838],
        [-2.687978, 59.217963],
        [-2.692616, 59.192288],
        [-2.446401, 59.293036]
    ],
    [
        [-3.049184, 59.319770],
        [-2.885365, 59.230414],
        [-2.830068, 59.252102],
        [-2.965199, 59.360907],
        [-3.049184, 59.319770]
    ],
    [
        [5.276866, 59.299262],
        [5.185883, 59.414740],
        [5.208551, 59.142886],
        [5.297091, 59.168884],
        [5.276866, 59.299262]
    ],
    [
        [-1.651275, 59.528957],
        [-1.596750, 59.532050],
        [-1.583119, 59.559963],
        [-1.625234, 59.555813],
        [-1.651275, 59.528957]
    ],
    [
        [5.307140, 59.758612],
        [5.153982, 59.874661],
        [5.070649, 59.782782],
        [5.152843, 59.591620],
        [5.307140, 59.758612]
    ],
    [
        [-43.706695, 59.902533],
        [-43.961334, 59.978176],
        [-44.118276, 59.833686],
        [-43.644643, 59.854193],
        [-43.706695, 59.902533]
    ],
    [
        [5.489106, 59.861029],
        [5.326182, 59.976508],
        [5.250173, 59.909410],
        [5.389659, 59.758612],
        [5.489106, 59.861029]
    ],
    [
        [-43.206451, 59.970893],
        [-43.316029, 60.004950],
        [-43.370961, 59.915595],
        [-43.319447, 59.964057],
        [-43.206451, 59.970893]
    ],
    [
        [-44.008412, 59.991360],
        [-44.200103, 60.027899],
        [-44.398793, 59.909410],
        [-44.151275, 59.902899],
        [-44.008412, 59.991360]
    ],
    [
        [-43.377187, 59.991360],
        [-43.469350, 60.026801],
        [-43.514963, 59.909410],
        [-43.394602, 59.938788],
        [-43.377187, 59.991360]
    ],
    [
        [5.619151, 60.073920],
        [5.461681, 60.052802],
        [5.361827, 59.995347],
        [5.639903, 59.915595],
        [5.619151, 60.073920]
    ],
    [
        [22.408376, 60.052802],
        [22.348888, 60.063218],
        [22.382823, 59.992580],
        [22.442638, 59.997504],
        [22.408376, 60.052802]
    ],
    [
        [20.277599, 60.142157],
        [20.222423, 60.149604],
        [20.201915, 60.087551],
        [20.277599, 60.066474],
        [20.277599, 60.142157]
    ],
    [
        [21.496593, 60.135321],
        [21.613129, 60.102118],
        [21.654307, 60.155829],
        [21.571056, 60.170356],
        [21.496593, 60.135321]
    ],
    [
        [-43.171702, 60.073920],
        [-44.073313, 60.176337],
        [-44.129628, 60.142035],
        [-43.590077, 59.923041],
        [-43.576405, 60.080756],
        [-43.171702, 60.073920]
    ],
    [
        [21.743663, 60.190619],
        [21.695811, 60.121649],
        [21.887706, 60.176337],
        [21.853526, 60.196763],
        [21.743663, 60.190619]
    ],
    [
        [21.353282, 60.211086],
        [21.270681, 60.190619],
        [21.368907, 60.196601],
        [21.353282, 60.211086]
    ],
    [
        [22.058930, 60.211086],
        [22.041759, 60.211412],
        [21.935395, 60.176337],
        [22.009288, 60.137274],
        [22.058930, 60.211086]
    ],
    [
        [25.814220, 60.207668],
        [25.835623, 60.196031],
        [25.876231, 60.217231],
        [25.822032, 60.216295],
        [25.814220, 60.207668]
    ],
    [
        [22.209239, 60.204250],
        [22.269298, 60.195868],
        [22.291759, 60.245185],
        [22.245860, 60.243069],
        [22.209239, 60.204250]
    ],
    [
        [19.639496, 60.220933],
        [19.567882, 60.255113],
        [19.527029, 60.148627],
        [19.671072, 60.158108],
        [19.639496, 60.220933]
    ],
    [
        [20.427908, 60.265692],
        [20.358897, 60.265692],
        [20.345388, 60.237698],
        [20.392914, 60.196763],
        [20.427908, 60.265692]
    ],
    [
        [20.818858, 60.232164],
        [20.853038, 60.265692],
        [20.787283, 60.286322],
        [20.790538, 60.238715],
        [20.818858, 60.232164]
    ],
    [
        [25.622325, 60.238349],
        [25.684418, 60.245185],
        [25.581716, 60.296373],
        [25.570160, 60.258043],
        [25.622325, 60.238349]
    ],
    [
        [22.843516, 60.241767],
        [22.448090, 60.221381],
        [22.600271, 60.142157],
        [22.422130, 60.114814],
        [22.469900, 59.997504],
        [22.729828, 60.004950],
        [22.956391, 60.292955],
        [22.843516, 60.241767]
    ],
    [
        [22.106781, 60.313463],
        [22.080089, 60.269477],
        [22.339610, 60.286200],
        [22.249766, 60.311469],
        [22.106781, 60.313463]
    ],
    [
        [22.387950, 60.320950],
        [22.367442, 60.292955],
        [22.477306, 60.320950],
        [22.398204, 60.355048],
        [22.312836, 60.320950],
        [22.387950, 60.320950]
    ],
    [
        [20.208751, 60.224677],
        [20.277599, 60.278713],
        [19.882335, 60.405585],
        [19.814220, 60.190619],
        [19.646983, 60.265692],
        [19.948497, 60.047675],
        [20.023692, 60.313463],
        [20.208751, 60.224677]
    ],
    [
        [5.111664, 60.200507],
        [5.093761, 60.320217],
        [4.948904, 60.439154],
        [4.947927, 60.258857],
        [5.111664, 60.200507]
    ],
    [
        [21.997569, 60.333930],
        [21.931977, 60.423326],
        [21.808116, 60.466702],
        [21.794119, 60.373969],
        [21.997569, 60.333930]
    ],
    [
        [18.550141, 60.327094],
        [18.484630, 60.366400],
        [18.378754, 60.507799],
        [18.402192, 60.369818],
        [18.550141, 60.327094]
    ],
    [
        [21.725922, 60.481676],
        [21.760509, 60.512030],
        [21.764171, 60.525784],
        [21.681651, 60.464911],
        [21.725922, 60.481676]
    ],
    [
        [4.977794, 60.524319],
        [5.125011, 60.402411],
        [5.204356, 60.431830],
        [5.150157, 60.501370],
        [4.977794, 60.524319]
    ],
    [
        [21.319102, 60.481676],
        [21.278494, 60.542304],
        [21.229177, 60.559882],
        [21.250255, 60.498440],
        [21.319102, 60.481676]
    ],
    [
        [21.394216, 60.559882],
        [21.328624, 60.525336],
        [21.442638, 60.471137],
        [21.482270, 60.525784],
        [21.394216, 60.559882]
    ],
    [
        [-0.784576, 60.615139],
        [-0.822133, 60.628730],
        [-0.938832, 60.628730],
        [-0.856191, 60.567328],
        [-0.784576, 60.615139]
    ],
    [
        [-1.097035, 60.416490],
        [-1.370229, 60.402167],
        [-1.295033, 60.492255],
        [-1.301422, 60.643052],
        [-1.609364, 60.483344],
        [-1.260365, 60.355048],
        [-1.690175, 60.285142],
        [-1.455434, 60.156195],
        [-1.267730, 60.245185],
        [-1.375966, 59.908637],
        [-1.274566, 59.854193],
        [-1.097035, 60.416490]
    ],
    [
        [21.298676, 60.567328],
        [21.270681, 60.643052],
        [21.213878, 60.616360],
        [21.233165, 60.593899],
        [21.298676, 60.567328]
    ],
    [
        [5.687673, 60.676581],
        [5.608409, 60.688422],
        [5.323985, 60.546820],
        [5.608897, 60.443793],
        [5.687673, 60.676581]
    ],
    [
        [-0.987172, 60.697699],
        [-1.113922, 60.714748],
        [-1.153879, 60.508368],
        [-1.023793, 60.502997],
        [-0.987172, 60.697699]
    ],
    [
        [-47.722035, 60.759101],
        [-47.969350, 60.841010],
        [-48.235951, 60.800116],
        [-47.900461, 60.682440],
        [-47.722035, 60.759101]
    ],
    [
        [-0.904693, 60.684027],
        [-0.821889, 60.685004],
        [-0.771840, 60.833401],
        [-0.938832, 60.800116],
        [-0.904693, 60.684027]
    ],
    [
        [-42.774770, 60.902533],
        [-42.850209, 60.902533],
        [-42.952626, 60.875800],
        [-42.774770, 60.902533]
    ],
    [
        [21.264415, 60.882025],
        [21.318126, 60.880194],
        [21.374278, 60.930406],
        [21.270030, 60.967963],
        [21.264415, 60.882025]
    ],
    [
        [4.960785, 61.177436],
        [4.844737, 61.197333],
        [4.803233, 61.046536],
        [4.985362, 61.104885],
        [4.960785, 61.177436]
    ],
    [
        [-42.493886, 61.451158],
        [-42.468088, 61.438870],
        [-42.390289, 61.485338],
        [-42.412343, 61.498603],
        [-42.493886, 61.451158]
    ],
    [
        [-6.654775, 61.395941],
        [-6.715566, 61.567857],
        [-6.962554, 61.628730],
        [-6.870473, 61.501532],
        [-6.654775, 61.395941]
    ],
    [
        [-42.082387, 61.876410],
        [-42.165435, 61.857082],
        [-42.287913, 61.759711],
        [-42.117543, 61.778795],
        [-42.082387, 61.876410]
    ],
    [
        [4.865245, 61.889390],
        [4.916270, 61.780951],
        [5.222830, 61.848456],
        [4.952973, 61.896959],
        [4.865245, 61.889390]
    ],
    [
        [-6.612538, 61.821112],
        [-6.666860, 61.866034],
        [-6.907338, 61.909857],
        [-6.660959, 61.746039],
        [-6.612538, 61.821112]
    ],
    [
        [-7.383697, 62.094875],
        [-7.202138, 62.019721],
        [-7.038319, 62.088609],
        [-7.215891, 62.163764],
        [-7.383697, 62.094875]
    ],
    [
        [5.736095, 62.280463],
        [5.563243, 62.291409],
        [5.502126, 62.225816],
        [5.790701, 62.214993],
        [5.736095, 62.280463]
    ],
    [
        [-7.222646, 62.170600],
        [-7.128814, 62.162055],
        [-6.701894, 61.944037],
        [-7.072621, 62.290269],
        [-7.222646, 62.170600]
    ],
    [
        [-7.055084, 62.290351],
        [-6.654775, 62.061347],
        [-6.564117, 62.135810],
        [-6.928456, 62.335028],
        [-7.055084, 62.290351]
    ],
    [
        [-6.537465, 62.191067],
        [-6.386586, 62.259955],
        [-6.537465, 62.369818],
        [-6.582753, 62.228583],
        [-6.537465, 62.191067]
    ],
    [
        [5.988617, 62.396470],
        [5.815603, 62.385728],
        [5.811290, 62.245673],
        [6.078787, 62.341864],
        [5.988617, 62.396470]
    ],
    [
        [6.263031, 62.423814],
        [6.201671, 62.444892],
        [6.263031, 62.423814]
    ],
    [
        [-42.302113, 62.574652],
        [-42.264394, 62.511379],
        [-42.123402, 62.499579],
        [-42.160146, 62.580227],
        [-42.302113, 62.574652]
    ],
    [
        [6.852794, 62.745917],
        [6.684744, 62.730170],
        [6.646658, 62.678290],
        [6.914073, 62.698188],
        [6.852794, 62.745917]
    ],
    [
        [-42.035268, 62.767035],
        [-42.349355, 62.813300],
        [-42.445546, 62.753363],
        [-42.035268, 62.767035]
    ],
    [
        [-41.917958, 62.814846],
        [-41.955800, 62.838446],
        [-41.815541, 62.808010],
        [-41.866933, 62.803941],
        [-41.917958, 62.814846]
    ],
    [
        [6.832286, 62.841539],
        [6.770356, 62.816962],
        [6.942149, 62.825914],
        [6.924327, 62.856594],
        [6.832286, 62.841539]
    ],
    [
        [-41.585846, 63.010403],
        [-41.582509, 62.875434],
        [-41.451772, 62.973090],
        [-41.451772, 63.014106],
        [-41.585846, 63.010403]
    ],
    [
        [7.778168, 63.081732],
        [7.914724, 63.081732],
        [7.886729, 63.099758],
        [7.778168, 63.081732]
    ],
    [
        [-41.527496, 63.081732],
        [-41.385487, 63.047349],
        [-41.308420, 63.075507],
        [-41.403961, 63.116523],
        [-41.527496, 63.081732]
    ],
    [
        [7.640391, 63.055080],
        [7.585134, 63.116523],
        [7.366547, 62.996731],
        [7.526541, 62.946031],
        [7.640391, 63.055080]
    ],
    [
        [-41.212148, 63.157457],
        [-41.301991, 63.199774],
        [-41.462026, 63.195014],
        [-41.352122, 63.125922],
        [-41.212148, 63.157457]
    ],
    [
        [8.113292, 63.239407],
        [8.077810, 63.241156],
        [7.928396, 63.177924],
        [8.188487, 63.157457],
        [8.113292, 63.239407]
    ],
    [
        [8.483897, 63.246812],
        [8.428722, 63.287787],
        [8.264171, 63.232611],
        [8.565766, 63.177924],
        [8.483897, 63.246812]
    ],
    [
        [21.422130, 63.246812],
        [21.286794, 63.211371],
        [21.078949, 63.287787],
        [21.243419, 63.150702],
        [21.422130, 63.246812]
    ],
    [
        [21.318533, 63.287787],
        [21.374278, 63.349270],
        [21.229177, 63.328803],
        [21.315278, 63.304023],
        [21.318533, 63.287787]
    ],
    [
        [7.914724, 63.342475],
        [8.086681, 63.328803],
        [8.181651, 63.390204],
        [7.778168, 63.411322],
        [7.914724, 63.342475]
    ],
    [
        [-41.147043, 63.284369],
        [-41.681386, 63.496812],
        [-41.863271, 63.472805],
        [-41.414784, 63.232164],
        [-41.147043, 63.284369]
    ],
    [
        [-51.223297, 63.513739],
        [-51.316396, 63.529853],
        [-51.395863, 63.466539],
        [-51.204091, 63.500067],
        [-51.223297, 63.513739]
    ],
    [
        [-40.773346, 63.644110],
        [-40.663482, 63.644110],
        [-40.681304, 63.654486],
        [-40.773346, 63.644110]
    ],
    [
        [9.138682, 63.567776],
        [8.788259, 63.640041],
        [8.277843, 63.466539],
        [8.503591, 63.434231],
        [9.138682, 63.567776]
    ],
    [
        [20.839203, 63.767564],
        [20.873546, 63.753974],
        [20.920421, 63.773749],
        [20.864919, 63.796820],
        [20.839203, 63.767564]
    ],
    [
        [8.360362, 63.671373],
        [8.743419, 63.687934],
        [8.825531, 63.734076],
        [8.271739, 63.685045],
        [8.360362, 63.671373]
    ],
    [
        [-40.671010, 64.219428],
        [-40.827138, 64.313788],
        [-41.062001, 64.233791],
        [-41.017812, 64.201606],
        [-40.650787, 64.203803],
        [-40.622548, 64.226874],
        [-40.671010, 64.219428]
    ],
    [
        [11.286306, 64.558987],
        [11.085785, 64.652045],
        [11.037364, 64.614447],
        [11.180186, 64.507473],
        [11.451427, 64.514960],
        [11.286306, 64.558987]
    ],
    [
        [-40.143422, 64.487006],
        [-40.479115, 64.582587],
        [-40.376129, 64.616645],
        [-40.548166, 64.709621],
        [-40.499623, 64.829576],
        [-40.869537, 64.904731],
        [-40.492787, 64.494086],
        [-40.143422, 64.487006]
    ],
    [
        [11.091075, 64.901597],
        [11.266368, 64.893704],
        [11.101329, 64.953111],
        [11.091075, 64.901597]
    ],
    [
        [10.841156, 64.877387],
        [10.898936, 64.908271],
        [10.841156, 64.877387]
    ],
    [
        [24.993437, 65.055104],
        [24.834506, 65.094800],
        [24.562755, 65.037177],
        [24.734711, 64.950914],
        [24.993437, 65.055104]
    ],
    [
        [12.224864, 65.123765],
        [12.167247, 65.211127],
        [11.979015, 65.082831],
        [12.309093, 65.110582],
        [12.224864, 65.123765]
    ],
    [
        [-39.547231, 65.319322],
        [-39.803375, 65.334621],
        [-39.568837, 65.275539],
        [-39.491607, 65.288275],
        [-39.547231, 65.319322]
    ],
    [
        [12.451427, 65.426093],
        [12.258637, 65.574612],
        [12.197439, 65.473863],
        [12.328461, 65.467027],
        [12.053477, 65.219957],
        [12.451427, 65.426093]
    ],
    [
        [-37.217437, 65.583157],
        [-37.196360, 65.535346],
        [-37.025014, 65.552069],
        [-37.110097, 65.590074],
        [-37.217437, 65.583157]
    ],
    [
        [-52.937611, 65.658840],
        [-53.175364, 65.630845],
        [-53.230784, 65.602240],
        [-53.037099, 65.543280],
        [-52.937611, 65.658840]
    ],
    [
        [12.005138, 65.689602],
        [11.824474, 65.693020],
        [11.759288, 65.617906],
        [11.916840, 65.589993],
        [12.005138, 65.689602]
    ],
    [
        [-36.936269, 65.679348],
        [-37.075347, 65.734076],
        [-37.217437, 65.686184],
        [-37.004018, 65.587714],
        [-36.936269, 65.679348]
    ],
    [
        [-36.785512, 65.871080],
        [-36.812734, 65.875718],
        [-36.997711, 65.815863],
        [-36.828114, 65.742377],
        [-36.785512, 65.871080]
    ],
    [
        [-37.453969, 65.792548],
        [-37.693186, 65.905219],
        [-37.987294, 65.700588],
        [-37.737904, 65.569403],
        [-37.313059, 65.679348],
        [-37.453969, 65.792548]
    ],
    [
        [-36.229970, 65.919582],
        [-36.374013, 65.881293],
        [-36.380727, 65.836982],
        [-36.182769, 65.884752],
        [-36.229970, 65.919582]
    ],
    [
        [-36.750722, 65.905219],
        [-36.621938, 65.798570],
        [-36.504262, 65.953030],
        [-36.627838, 65.953192],
        [-36.750722, 65.905219]
    ],
    [
        [12.698009, 65.997748],
        [12.491222, 65.990627],
        [12.368826, 65.891588],
        [12.698009, 65.997748]
    ],
    [
        [12.574229, 66.075914],
        [12.656912, 66.103909],
        [12.551443, 66.220364],
        [12.294200, 66.015082],
        [12.574229, 66.075914]
    ],
    [
        [-35.551503, 66.206936],
        [-35.484486, 66.184882],
        [-35.387034, 66.248481],
        [-35.482167, 66.242133],
        [-35.551503, 66.206936]
    ],
    [
        [-33.865712, 66.823228],
        [-33.905141, 66.881008],
        [-33.975657, 66.830715],
        [-33.952260, 66.795233],
        [-33.865712, 66.823228]
    ],
    [
        [14.273692, 67.165839],
        [14.057302, 67.133043],
        [13.993012, 67.077704],
        [14.192231, 67.003567],
        [14.273692, 67.165839]
    ],
    [
        [-33.475250, 67.186957],
        [-33.449859, 67.141506],
        [-33.338124, 67.206855],
        [-33.446116, 67.197252],
        [-33.475250, 67.186957]
    ],
    [
        [-33.249379, 67.357652],
        [-33.265614, 67.375963],
        [-33.331288, 67.337836],
        [-33.256093, 67.297756],
        [-33.249379, 67.357652]
    ],
    [
        [13.054698, 68.098131],
        [13.075043, 68.085110],
        [12.787120, 67.810126],
        [13.123871, 67.943996],
        [13.156993, 68.085110],
        [13.054698, 68.098131]
    ],
    [
        [13.280528, 68.129136],
        [13.328380, 68.063422],
        [13.239268, 68.092108],
        [13.172699, 68.009019],
        [13.366222, 68.012763],
        [13.437673, 68.126044],
        [13.280528, 68.129136]
    ],
    [
        [-29.712717, 68.221666],
        [-29.874135, 68.242133],
        [-30.014394, 68.214260],
        [-29.867258, 68.142971],
        [-29.712717, 68.221666]
    ],
    [
        [15.000499, 68.365058],
        [15.172374, 68.454413],
        [14.383556, 68.372504],
        [14.495616, 68.306057],
        [14.198497, 68.152777],
        [15.000499, 68.365058]
    ],
    [
        [-53.098053, 68.454413],
        [-53.225006, 68.433905],
        [-52.854482, 68.424018],
        [-52.992258, 68.495429],
        [-53.098053, 68.454413]
    ],
    [
        [16.422862, 68.491929],
        [16.221690, 68.523749],
        [16.094900, 68.397528],
        [16.398611, 68.413479],
        [16.422862, 68.491929]
    ],
    [
        [-51.834096, 68.605211],
        [-51.863922, 68.612128],
        [-51.886342, 68.604804],
        [-51.858998, 68.606594],
        [-51.834096, 68.605211]
    ],
    [
        [-51.956899, 68.635688],
        [-52.073598, 68.584784],
        [-52.176625, 68.646186],
        [-52.423736, 68.590562],
        [-52.114898, 68.564276],
        [-51.806752, 68.625718],
        [-51.956899, 68.635688]
    ],
    [
        [-52.351064, 68.642483],
        [-52.128285, 68.707668],
        [-52.649648, 68.715074],
        [-53.121938, 68.571112],
        [-52.351064, 68.642483]
    ],
    [
        [17.052908, 68.817532],
        [17.000987, 68.858588],
        [16.816661, 68.735582],
        [17.145681, 68.770331],
        [17.052908, 68.817532]
    ],
    [
        [17.206391, 68.893256],
        [17.083507, 68.913764],
        [17.223643, 68.793036],
        [17.440440, 68.865912],
        [17.206391, 68.893256]
    ],
    [
        [16.528575, 68.721991],
        [16.555919, 68.824937],
        [16.254649, 68.903225],
        [16.083018, 68.638739],
        [15.740408, 68.530097],
        [15.989594, 68.763495],
        [15.761485, 68.735582],
        [15.907400, 68.959418],
        [15.644786, 68.954739],
        [15.455577, 68.769029],
        [15.639659, 68.743232],
        [15.713634, 68.701402],
        [15.438731, 68.707668],
        [15.630544, 68.612128],
        [15.217296, 68.556871],
        [15.356781, 68.461249],
        [15.553722, 68.511176],
        [15.322602, 68.351386],
        [15.624360, 68.300482],
        [15.870779, 68.495429],
        [15.940929, 68.380316],
        [16.105968, 68.538520],
        [16.497569, 68.554023],
        [16.528575, 68.721991]
    ],
    [
        [16.566173, 68.968329],
        [16.306326, 68.995307],
        [16.261729, 68.968329],
        [16.476248, 68.885810],
        [16.566173, 68.968329]
    ],
    [
        [14.397227, 68.660468],
        [15.151378, 68.756049],
        [14.806407, 68.615953],
        [15.062673, 68.578518],
        [15.375255, 68.669908],
        [15.274913, 68.797065],
        [15.384044, 68.852281],
        [15.084483, 69.011217],
        [15.158865, 68.817532],
        [14.628429, 68.829901],
        [14.397227, 68.660468]
    ],
    [
        [15.528656, 68.913764],
        [15.528656, 69.009345],
        [15.847911, 69.029242],
        [16.149913, 69.290839],
        [15.569672, 69.105536],
        [15.425059, 68.962144],
        [15.528656, 68.913764]
    ],
    [
        [18.070811, 69.437934],
        [17.467621, 69.599555],
        [17.645274, 69.461819],
        [17.343272, 69.537543],
        [17.186534, 69.502753],
        [17.495779, 69.428290],
        [16.926524, 69.393541],
        [17.145681, 69.256334],
        [16.898611, 69.194892],
        [17.172374, 69.201117],
        [16.773123, 69.088202],
        [17.129405, 69.011542],
        [17.472179, 69.200141],
        [17.988455, 69.187445],
        [17.878673, 69.249498],
        [18.070811, 69.437934]
    ],
    [
        [18.999034, 69.828599],
        [18.678884, 69.886054],
        [18.762462, 69.687730],
        [18.632823, 69.701972],
        [17.995372, 69.592108],
        [18.769298, 69.571682],
        [18.999034, 69.828599]
    ],
    [
        [-51.223297, 69.914252],
        [-51.361073, 69.852851],
        [-51.004750, 69.886949],
        [-51.384999, 69.711900],
        [-51.167470, 69.511949],
        [-50.661855, 69.835150],
        [-50.803944, 69.900377],
        [-51.223297, 69.914252]
    ],
    [
        [21.667979, 69.948391],
        [21.695811, 69.927924],
        [21.736176, 69.948391],
        [21.701996, 69.954779],
        [21.667979, 69.948391]
    ],
    [
        [19.900157, 70.016750],
        [19.949962, 70.009711],
        [19.995860, 70.016750],
        [19.947927, 70.026801],
        [19.900157, 70.016750]
    ],
    [
        [20.958832, 70.003079],
        [20.859874, 70.044013],
        [20.760509, 69.999661],
        [20.891938, 69.937974],
        [21.099376, 70.010484],
        [20.958832, 70.003079]
    ],
    [
        [21.041026, 70.061347],
        [20.991873, 70.051459],
        [20.955333, 70.024115],
        [21.046641, 70.039130],
        [21.041026, 70.061347]
    ],
    [
        [19.619151, 70.016750],
        [19.208181, 70.098578],
        [18.728852, 69.947821],
        [19.121593, 69.787828],
        [19.619151, 70.016750]
    ],
    [
        [20.791515, 70.092434],
        [20.733897, 70.236721],
        [20.389903, 70.102688],
        [20.602550, 70.044013],
        [20.791515, 70.092434]
    ],
    [
        [19.982188, 70.147040],
        [19.677745, 70.290432],
        [19.537120, 70.250067],
        [19.776134, 70.067328],
        [20.154063, 70.112860],
        [19.982188, 70.147040]
    ],
    [
        [-52.902903, 69.345120],
        [-51.837473, 69.643622],
        [-53.265981, 70.202297],
        [-54.329742, 70.324042],
        [-54.756907, 70.247016],
        [-54.831939, 70.085598],
        [-54.224924, 69.920478],
        [-54.931956, 69.865871],
        [-54.389394, 69.681545],
        [-53.930084, 69.603949],
        [-53.999623, 69.502753],
        [-53.732737, 69.517035],
        [-53.816640, 69.458564],
        [-53.564443, 69.568915],
        [-53.349110, 69.585354],
        [-53.581899, 69.476060],
        [-53.402984, 69.439195],
        [-54.273346, 69.400336],
        [-53.844635, 69.265041],
        [-52.902903, 69.345120]
    ],
    [
        [22.922374, 70.304674],
        [22.756358, 70.394965],
        [22.373709, 70.331977],
        [23.016287, 70.254299],
        [22.922374, 70.304674]
    ],
    [
        [-54.718984, 70.379788],
        [-54.654205, 70.382880],
        [-55.027455, 70.486274],
        [-54.926503, 70.374742],
        [-54.718984, 70.379788]
    ],
    [
        [23.656016, 70.503323],
        [23.573497, 70.613186],
        [23.390961, 70.617987],
        [23.539317, 70.544867],
        [22.854015, 70.407701],
        [23.216319, 70.282782],
        [23.656016, 70.503323]
    ],
    [
        [-51.663075, 70.723049],
        [-51.820424, 70.750393],
        [-51.861318, 70.723049],
        [-51.663075, 70.723049]
    ],
    [
        [24.066905, 70.660956],
        [23.815684, 70.751166],
        [23.635509, 70.692043],
        [23.804210, 70.513332],
        [24.066905, 70.660956]
    ],
    [
        [22.422130, 70.510728],
        [23.088878, 70.586249],
        [23.484141, 70.798774],
        [23.066254, 70.812445],
        [23.182384, 70.736029],
        [22.969086, 70.661200],
        [22.722992, 70.748481],
        [22.826182, 70.647935],
        [22.724864, 70.603583],
        [22.541026, 70.717475],
        [21.950369, 70.647935],
        [22.333344, 70.613186],
        [22.154470, 70.472317],
        [22.422130, 70.510728]
    ],
    [
        [-51.816640, 70.942125],
        [-52.064524, 70.978583],
        [-52.161366, 70.891669],
        [-51.565826, 70.879706],
        [-51.816640, 70.942125]
    ],
    [
        [24.073090, 70.962592],
        [24.224620, 70.996772],
        [23.885753, 70.996161],
        [24.043142, 70.914130],
        [24.245128, 70.955797],
        [24.073090, 70.962592]
    ],
    [
        [26.135997, 71.037746],
        [25.667328, 71.165269],
        [25.553396, 71.140774],
        [25.700938, 71.083930],
        [25.718516, 71.051988],
        [25.292491, 71.028144],
        [25.553396, 70.927883],
        [26.135997, 71.037746]
    ],
    [
        [-53.896596, 71.082465],
        [-53.512441, 71.037746],
        [-53.382069, 71.136623],
        [-53.611806, 71.321723],
        [-53.978505, 71.147610],
        [-53.896596, 71.082465]
    ],
    [
        [-52.484853, 71.264309],
        [-52.327504, 71.298407],
        [-53.177480, 71.327623],
        [-52.957428, 71.154446],
        [-52.484853, 71.264309]
    ],
    [
        [-53.293853, 71.538642],
        [-53.112457, 71.540961],
        [-52.759511, 71.661526],
        [-53.478261, 71.655341],
        [-53.293853, 71.538642]
    ],
    [
        [-55.686920, 71.917182],
        [-55.808258, 71.881252],
        [-55.411041, 71.894232],
        [-55.561025, 71.933580],
        [-55.686920, 71.917182]
    ],
    [
        [-55.047963, 72.318834],
        [-55.623931, 72.302639],
        [-55.434641, 72.267971],
        [-55.047963, 72.318834]
    ],
    [
        [-55.802113, 72.689399],
        [-55.640248, 72.775946],
        [-56.225982, 72.709906],
        [-56.062164, 72.655219],
        [-55.802113, 72.689399]
    ],
    [
        [-55.739410, 72.614244],
        [-55.367055, 72.589911],
        [-54.965443, 72.812323],
        [-55.849273, 72.614244],
        [-55.739410, 72.614244]
    ],
    [
        [-55.609690, 73.036038],
        [-55.692250, 72.998481],
        [-55.609690, 73.036038]
    ],
    [
        [-56.031117, 73.570461],
        [-56.116811, 73.559556],
        [-55.664296, 73.484442],
        [-55.753733, 73.395087],
        [-55.472524, 73.429877],
        [-55.945465, 73.573879],
        [-56.031117, 73.570461]
    ],
    [
        [-56.127065, 73.827094],
        [-56.623891, 73.923285],
        [-56.774770, 73.882310],
        [-56.127065, 73.827094]
    ],
    [
        [-56.518219, 74.494818],
        [-56.712880, 74.560736],
        [-56.518219, 74.494818]
    ],
    [
        [-69.496653, 76.592271],
        [-69.556752, 76.613959],
        [-70.034495, 76.568061],
        [-69.677724, 76.533840],
        [-69.496653, 76.592271]
    ],
    [
        [-71.576283, 77.390448],
        [-72.234242, 77.458726],
        [-71.576283, 77.390448]
    ],
    [
        [-70.356597, 77.417792],
        [-70.898671, 77.473456],
        [-70.356597, 77.417792]
    ],
    [
        [-53.274770, 82.172349],
        [-52.105214, 81.995429],
        [-51.189768, 81.995347],
        [-52.786773, 82.317532],
        [-53.244985, 82.299140],
        [-53.274770, 82.172349]
    ],
    [
        [-44.529164, 82.413764],
        [-46.324208, 82.678534],
        [-47.749867, 82.625312],
        [-45.035024, 82.059272],
        [-44.734609, 82.098375],
        [-45.070424, 82.222561],
        [-44.426137, 82.358466],
        [-44.529164, 82.413764]
    ],
    [
        [-47.852162, 82.783637],
        [-48.412750, 82.852769],
        [-48.330922, 82.791897],
        [-47.852162, 82.783637]
    ],
    [
        [-39.437611, 83.105170],
        [-39.972727, 83.159817],
        [-40.546620, 83.162421],
        [-39.666493, 82.995510],
        [-39.288889, 83.092434],
        [-39.437611, 83.105170]
    ],
    [
        [-40.103342, 83.056138],
        [-40.858062, 83.172593],
        [-40.103342, 83.056138]
    ],
    [
        [-38.834340, 83.174018],
        [-40.487416, 83.365912],
        [-40.667348, 83.302558],
        [-38.642568, 83.118801],
        [-38.834340, 83.174018]
    ],
    [
        [147.998546, -43.230401],
        [147.882823, -43.131524],
        [147.792491, -43.244073],
        [147.627208, -43.042739],
        [147.692556, -42.936212],
        [147.887055, -43.034438],
        [147.840343, -42.902032],
        [147.533539, -42.836602],
        [147.559093, -42.977227],
        [147.436209, -43.046075],
        [147.477306, -42.908868],
        [147.283702, -42.778497],
        [147.257579, -43.254327],
        [146.972911, -43.131117],
        [147.099783, -43.299412],
        [146.962657, -43.340265],
        [146.927013, -43.611749],
        [146.554698, -43.469415],
        [146.024181, -43.552504],
        [145.943207, -43.364841],
        [146.229503, -43.319757],
        [145.917166, -43.195896],
        [145.831798, -43.292576],
        [145.265473, -42.604262],
        [145.188731, -42.195733],
        [145.472016, -42.512791],
        [145.558116, -42.341567],
        [145.229015, -42.195733],
        [145.206554, -41.966567],
        [144.749848, -41.414239],
        [144.605805, -40.996515],
        [144.698578, -40.660252],
        [146.585623, -41.180108],
        [146.744151, -41.065525],
        [146.808116, -41.156671],
        [146.949555, -41.161065],
        [146.819347, -41.075372],
        [147.017589, -40.976658],
        [147.444835, -41.008396],
        [147.650564, -40.828546],
        [147.849457, -40.888767],
        [147.984223, -40.736505],
        [148.209321, -40.840753],
        [148.331391, -41.002211],
        [148.364268, -42.204360],
        [148.257986, -42.244236],
        [148.320079, -42.119399],
        [148.181000, -41.947361],
        [147.888682, -42.545099],
        [147.998546, -43.230401]
    ],
    [
        [96.863129, -12.181736],
        [96.836192, -12.182061],
        [96.830577, -12.179946],
        [96.845225, -12.197686],
        [96.863129, -12.181736]
    ],
    [
        [120.792491, -9.960870],
        [119.958751, -9.290460],
        [119.168712, -9.385512],
        [118.935395, -9.553399],
        [119.096853, -9.717543],
        [119.634451, -9.769138],
        [120.449962, -10.310317],
        [120.724620, -10.196873],
        [120.792491, -9.960870]
    ],
    [
        [115.550141, -8.666192],
        [115.468272, -8.731866],
        [115.588878, -8.807306],
        [115.624204, -8.768909],
        [115.550141, -8.666192]
    ],
    [
        [119.722992, -8.621189],
        [119.634451, -8.596612],
        [119.615245, -8.777520],
        [119.698253, -8.801528],
        [119.722992, -8.621189]
    ],
    [
        [119.559255, -8.518162],
        [119.415294, -8.443292],
        [119.381114, -8.740655],
        [119.469900, -8.740655],
        [119.559255, -8.518162]
    ],
    [
        [123.348643, -8.268813],
        [123.156505, -8.243585],
        [123.019542, -8.391778],
        [123.289317, -8.404474],
        [123.348643, -8.268813]
    ],
    [
        [116.633311, -8.275079],
        [116.286388, -8.236261],
        [116.027937, -8.445008],
        [116.087576, -8.737237],
        [115.839262, -8.816857],
        [116.565369, -8.895583],
        [116.743175, -8.391778],
        [116.633311, -8.275079]
    ],
    [
        [119.086436, -8.131524],
        [119.020274, -8.189711],
        [119.051524, -8.261407],
        [119.137462, -8.190606],
        [119.086436, -8.131524]
    ],
    [
        [119.203624, -8.610935],
        [119.052257, -8.645685],
        [118.972504, -8.302016],
        [118.753917, -8.326430],
        [118.667328, -8.547296],
        [118.647472, -8.288751],
        [118.312266, -8.371270],
        [117.917817, -8.085870],
        [117.712250, -8.240899],
        [118.281749, -8.641534],
        [117.805186, -8.719985],
        [117.623302, -8.438409],
        [117.195079, -8.357599],
        [116.838145, -8.507908],
        [116.728452, -8.963096],
        [117.009736, -9.107293],
        [117.388868, -9.053739],
        [118.157725, -8.867852],
        [118.414724, -8.582940],
        [118.414236, -8.853611],
        [118.908051, -8.850518],
        [118.701996, -8.748142],
        [119.151622, -8.742364],
        [119.203624, -8.610935]
    ],
    [
        [123.026378, -8.288751],
        [122.862559, -8.069757],
        [122.740408, -8.222426],
        [122.940440, -8.193129],
        [122.880870, -8.285740],
        [122.288422, -8.633884],
        [122.019054, -8.425958],
        [121.501720, -8.601821],
        [120.422048, -8.227309],
        [119.867198, -8.412856],
        [119.805675, -8.740655],
        [119.907400, -8.871677],
        [120.165294, -8.768650],
        [120.994884, -8.940525],
        [121.396007, -8.794122],
        [121.780447, -8.887953],
        [122.807384, -8.610935],
        [122.803559, -8.437921],
        [123.026378, -8.288751]
    ],
    [
        [115.619151, -8.288751],
        [115.193126, -8.055108],
        [114.857595, -8.193129],
        [114.447927, -8.121840],
        [114.604503, -8.386489],
        [115.156098, -8.662042],
        [115.134532, -8.850763],
        [115.700938, -8.419122],
        [115.619151, -8.288751]
    ],
    [
        [109.019298, -7.758071],
        [108.821544, -7.678643],
        [108.797048, -7.701593],
        [109.043142, -7.778904],
        [109.019298, -7.758071]
    ],
    [
        [72.467540, -7.383884],
        [72.432872, -7.425388],
        [72.438975, -7.340265],
        [72.432872, -7.316095],
        [72.357677, -7.268324],
        [72.432872, -7.432224],
        [72.467540, -7.383884]
    ],
    [
        [72.484223, -7.278253],
        [72.486501, -7.302423],
        [72.468028, -7.340590],
        [72.479015, -7.361912],
        [72.494640, -7.296157],
        [72.484223, -7.278253]
    ],
    [
        [115.570649, -6.904555],
        [115.275727, -6.835382],
        [115.214366, -6.928155],
        [115.293305, -7.007582],
        [115.570649, -6.904555]
    ],
    [
        [112.700694, -5.726007],
        [112.582774, -5.794203],
        [112.604259, -5.847426],
        [112.731456, -5.828383],
        [112.700694, -5.726007]
    ],
    [
        [102.406505, -5.403741],
        [102.172048, -5.280369],
        [102.098643, -5.334893],
        [102.283539, -5.499282],
        [102.406505, -5.403741]
    ],
    [
        [115.845876, -4.764093],
        [115.851817, -4.739028],
        [115.773448, -4.815118],
        [115.806814, -4.821873],
        [115.845876, -4.764093]
    ],
    [
        [116.399262, -3.392755],
        [116.324718, -3.532973],
        [116.385997, -3.639581],
        [116.434418, -3.409763],
        [116.399262, -3.392755]
    ],
    [
        [116.303722, -3.718032],
        [116.321056, -3.497735],
        [116.267833, -3.218845],
        [116.016368, -3.629164],
        [116.091482, -4.066827],
        [116.303722, -3.718032]
    ],
    [
        [100.508474, -3.122166],
        [100.493663, -3.160252],
        [100.528819, -3.183526],
        [100.536388, -3.176853],
        [100.508474, -3.122166]
    ],
    [
        [100.398611, -3.183526],
        [100.467540, -3.015313],
        [100.227306, -2.772638],
        [100.189464, -2.966567],
        [100.460704, -3.334405],
        [100.398611, -3.183526]
    ],
    [
        [100.206798, -2.693536],
        [100.166677, -2.627862],
        [99.974620, -2.493910],
        [100.015636, -2.834161],
        [100.206798, -2.693536]
    ],
    [
        [99.823253, -2.292901],
        [99.694347, -2.067804],
        [99.564952, -2.030857],
        [99.603526, -2.265558],
        [99.823253, -2.292901]
    ],
    [
        [108.964203, -1.573419],
        [108.900564, -1.532892],
        [108.793305, -1.580336],
        [108.858165, -1.663995],
        [108.964203, -1.573419]
    ],
    [
        [109.759776, -1.103936],
        [109.475434, -0.976983],
        [109.417247, -1.254490],
        [109.502452, -1.292169],
        [109.759776, -1.103936]
    ],
    [
        [99.274425, -1.634942],
        [98.898204, -0.915704],
        [98.658214, -0.963474],
        [98.593761, -1.198419],
        [98.884776, -1.679376],
        [99.118500, -1.802341],
        [99.274425, -1.634942]
    ],
    [
        [98.501964, -0.460545],
        [98.429210, -0.243829],
        [98.275157, -0.525160],
        [98.500499, -0.565606],
        [98.501964, -0.460545]
    ],
    [
        [98.479991, -0.158380],
        [98.406098, -0.007379],
        [98.295665, -0.007257],
        [98.549001, -0.381117],
        [98.479991, -0.158380]
    ],
    [
        [103.293630, 0.625434],
        [103.179210, 0.695502],
        [103.140473, 0.539374],
        [103.280772, 0.538031],
        [103.293630, 0.625434]
    ],
    [
        [103.518728, 0.818427],
        [103.488536, 0.845445],
        [103.421235, 0.873236],
        [103.523448, 0.777818],
        [103.518728, 0.818427]
    ],
    [
        [103.818614, 0.886217],
        [103.911388, 0.780748],
        [103.941417, 0.775702],
        [103.898204, 0.853339],
        [103.818614, 0.886217]
    ],
    [
        [103.489024, 0.777045],
        [103.400890, 0.880072],
        [103.357432, 0.872463],
        [103.434337, 0.647284],
        [103.489024, 0.777045]
    ],
    [
        [103.801768, 0.852729],
        [103.726248, 0.873236],
        [103.832286, 0.765367],
        [103.831065, 0.816352],
        [103.801768, 0.852729]
    ],
    [
        [103.942149, 0.996080],
        [103.880056, 1.031480],
        [103.838878, 1.002997],
        [103.921641, 0.934638],
        [103.942149, 0.996080]
    ],
    [
        [104.798595, 1.031480],
        [104.791189, 1.024075],
        [104.832774, 0.955146],
        [104.843516, 1.018215],
        [104.798595, 1.031480]
    ],
    [
        [107.562022, 1.037177],
        [107.529552, 1.018052],
        [107.559581, 0.970160],
        [107.601573, 1.009833],
        [107.562022, 1.037177]
    ],
    [
        [103.443126, 1.012763],
        [103.389822, 1.130276],
        [103.333832, 1.111396],
        [103.340831, 1.019517],
        [103.443126, 1.012763]
    ],
    [
        [103.048676, 0.797024],
        [102.556407, 1.125678],
        [102.467621, 1.106431],
        [102.516368, 0.791327],
        [103.007335, 0.693834],
        [103.048676, 0.797024]
    ],
    [
        [103.126475, 0.927883],
        [102.801768, 1.163275],
        [102.624766, 1.021959],
        [103.127126, 0.834418],
        [103.126475, 0.927883]
    ],
    [
        [104.146332, 1.160468],
        [104.030935, 1.187893],
        [103.906749, 1.071682],
        [104.092296, 0.989936],
        [104.146332, 1.160468]
    ],
    [
        [104.654552, 1.096381],
        [104.575694, 1.225409],
        [104.231944, 1.093329],
        [104.485199, 1.033677],
        [104.567068, 0.829535],
        [104.654552, 1.096381]
    ],
    [
        [102.473399, 1.242011],
        [102.210623, 1.398261],
        [102.369314, 0.935207],
        [102.468028, 0.972561],
        [102.473399, 1.242011]
    ],
    [
        [103.960785, 1.391099],
        [103.708344, 1.429389],
        [103.640391, 1.322252],
        [103.838878, 1.266262],
        [103.960785, 1.391099]
    ],
    [
        [102.495860, 1.363593],
        [102.462657, 1.515448],
        [102.007823, 1.615383],
        [102.478770, 1.270738],
        [102.495860, 1.363593]
    ],
    [
        [98.555186, 1.682034],
        [98.462657, 1.709296],
        [98.431651, 1.661526],
        [98.599132, 1.631985],
        [98.555186, 1.682034]
    ],
    [
        [97.151134, 2.058092],
        [97.120128, 2.113349],
        [97.069021, 2.087144],
        [97.102306, 2.016059],
        [97.151134, 2.058092]
    ],
    [
        [101.721202, 2.058092],
        [101.418142, 2.044420],
        [101.490733, 1.736762],
        [101.715099, 1.778225],
        [101.721202, 2.058092]
    ],
    [
        [96.644054, 2.127021],
        [96.613292, 2.119127],
        [96.622895, 2.070624],
        [96.671723, 2.101996],
        [96.644054, 2.127021]
    ],
    [
        [97.328624, 2.147528],
        [97.281261, 2.229071],
        [97.102794, 2.212714],
        [97.321788, 2.031440],
        [97.328624, 2.147528]
    ],
    [
        [118.599620, 2.244330],
        [118.556407, 2.312201],
        [118.578461, 2.236884],
        [118.654307, 2.182278],
        [118.599620, 2.244330]
    ],
    [
        [109.108653, 2.531684],
        [108.996430, 2.561754],
        [108.968110, 2.543647],
        [109.026703, 2.485826],
        [109.108653, 2.531684]
    ],
    [
        [111.411388, 2.391099],
        [111.381033, 2.697903],
        [111.315440, 2.784491],
        [111.312673, 2.431342],
        [111.411388, 2.391099]
    ],
    [
        [106.243175, 2.760484],
        [106.226248, 2.817043],
        [106.203298, 2.819078],
        [106.237804, 2.732856],
        [106.243175, 2.760484]
    ],
    [
        [104.222667, 2.785590],
        [104.186209, 2.885321],
        [104.170665, 2.891099],
        [104.130626, 2.745795],
        [104.222667, 2.785590]
    ],
    [
        [96.479503, 2.414984],
        [95.911876, 2.906236],
        [95.699555, 2.831773],
        [96.334972, 2.355455],
        [96.479503, 2.414984]
    ],
    [
        [108.842459, 2.973619],
        [108.775157, 2.895087],
        [108.842459, 2.846381],
        [108.898611, 2.982856],
        [108.842459, 2.973619]
    ],
    [
        [107.807140, 3.014879],
        [107.772960, 3.025295],
        [107.745128, 2.983547],
        [107.811209, 2.986802],
        [107.807140, 3.014879]
    ],
    [
        [105.802013, 2.997260],
        [105.688731, 3.059963],
        [105.712657, 2.843166],
        [105.811860, 2.904486],
        [105.802013, 2.997260]
    ],
    [
        [106.285167, 3.179104],
        [106.207774, 3.225328],
        [106.279063, 3.087226],
        [106.285167, 3.087226],
        [106.285167, 3.179104]
    ],
    [
        [117.503591, 3.333645],
        [117.433360, 3.336412],
        [117.417003, 3.288723],
        [117.527517, 3.290839],
        [117.503591, 3.333645]
    ],
    [
        [106.270844, 3.360989],
        [106.230479, 3.257961],
        [106.279063, 3.230618],
        [106.297374, 3.358303],
        [106.270844, 3.360989]
    ],
    [
        [117.625255, 3.437690],
        [117.531261, 3.403144],
        [117.648448, 3.246039],
        [117.683930, 3.399604],
        [117.625255, 3.437690]
    ],
    [
        [117.893891, 3.497504],
        [117.847911, 3.575426],
        [117.784923, 3.581977],
        [117.826182, 3.494086],
        [117.893891, 3.497504]
    ],
    [
        [117.517263, 3.477037],
        [117.393728, 3.566392],
        [117.218028, 3.560289],
        [117.270763, 3.500190],
        [117.517263, 3.477037]
    ],
    [
        [117.846202, 3.799140],
        [117.807384, 3.856147],
        [117.729503, 3.868069],
        [117.784028, 3.819648],
        [117.846202, 3.799140]
    ],
    [
        [117.698741, 4.111314],
        [117.594493, 4.063870],
        [117.665294, 3.983059],
        [117.753184, 4.051825],
        [117.698741, 4.111314]
    ],
    [
        [108.396169, 3.874823],
        [108.224864, 4.244818],
        [107.984630, 4.012030],
        [108.262380, 3.792304],
        [108.094493, 3.696194],
        [108.183849, 3.648342],
        [108.396169, 3.874823]
    ],
    [
        [117.849864, 4.196357],
        [117.720225, 4.266425],
        [117.640147, 4.227444],
        [117.887055, 4.031928],
        [117.849864, 4.196357]
    ],
    [
        [118.726248, 4.491889],
        [118.675141, 4.498358],
        [118.644054, 4.495307],
        [118.674815, 4.436591],
        [118.726248, 4.491889]
    ],
    [
        [118.510265, 4.648871],
        [118.456309, 4.697252],
        [118.346446, 4.676215],
        [118.535167, 4.601304],
        [118.599620, 4.635199],
        [118.510265, 4.648871]
    ],
    [
        [108.005138, 4.772366],
        [107.940603, 4.708645],
        [107.937348, 4.691392],
        [107.993419, 4.691311],
        [108.005138, 4.772366]
    ],
    [
        [115.248546, 5.365465],
        [115.189138, 5.344794],
        [115.159190, 5.252183],
        [115.259288, 5.291205],
        [115.248546, 5.365465]
    ],
    [
        [100.309825, 5.450751],
        [100.179454, 5.458197],
        [100.184337, 5.268541],
        [100.288748, 5.262681],
        [100.309825, 5.450751]
    ],
    [
        [95.177419, 5.628363],
        [95.141775, 5.664130],
        [95.109141, 5.622016],
        [95.156261, 5.594794],
        [95.177419, 5.628363]
    ],
    [
        [95.115245, 5.711493],
        [95.058279, 5.757310],
        [95.014659, 5.744615],
        [95.060720, 5.656236],
        [95.115245, 5.711493]
    ],
    [
        [95.341807, 5.896430],
        [95.283865, 5.857408],
        [95.213552, 5.902533],
        [95.338390, 5.779202],
        [95.341807, 5.896430]
    ],
    [
        [99.786292, 6.241822],
        [99.805596, 6.171793],
        [99.836978, 6.294227],
        [99.800442, 6.272811],
        [99.786292, 6.241822]
    ],
    [
        [99.900617, 6.364304],
        [99.842029, 6.469639],
        [99.645228, 6.435841],
        [99.728735, 6.261476],
        [99.900617, 6.364304]
    ],
    [
        [99.247813, 6.574856],
        [99.239268, 6.576809],
        [99.206309, 6.574856],
        [99.158458, 6.554389],
        [99.247813, 6.574856]
    ],
    [
        [99.672374, 6.516547],
        [99.704438, 6.558295],
        [99.656993, 6.723822],
        [99.600271, 6.583441],
        [99.672374, 6.516547]
    ],
    [
        [117.468761, 6.766669],
        [117.443858, 6.698554],
        [117.346934, 6.654975],
        [117.506602, 6.673489],
        [117.468761, 6.766669]
    ],
    [
        [93.920258, 7.024319],
        [93.830821, 7.235907],
        [93.676443, 7.181871],
        [93.834239, 6.745551],
        [93.920258, 7.024319]
    ],
    [
        [99.405447, 7.266303],
        [99.377778, 7.252346],
        [99.383311, 7.194078],
        [99.453868, 7.239000],
        [99.405447, 7.266303]
    ],
    [
        [117.002615, 7.355699],
        [116.900157, 7.287421],
        [116.851817, 7.198065],
        [117.010020, 7.279975],
        [117.002615, 7.355699]
    ],
    [
        [117.171153, 7.342678],
        [117.067719, 7.280015],
        [117.071544, 7.102484],
        [117.262380, 7.201972],
        [117.171153, 7.342678]
    ],
    [
        [93.731212, 7.369371],
        [93.696951, 7.445054],
        [93.617931, 7.259955],
        [93.728526, 7.337104],
        [93.731212, 7.369371]
    ],
    [
        [99.034923, 7.644273],
        [99.031261, 7.561916],
        [99.099946, 7.467231],
        [99.075857, 7.608954],
        [99.034923, 7.644273]
    ],
    [
        [99.124278, 7.657375],
        [99.067068, 7.675198],
        [99.044607, 7.663398],
        [99.108735, 7.594184],
        [99.124278, 7.657375]
    ],
    [
        [81.738780, 7.660468],
        [81.787364, 7.593451],
        [81.806326, 7.598578],
        [81.725108, 7.739936],
        [81.738780, 7.660468]
    ],
    [
        [93.429454, 7.955268],
        [93.370291, 8.017320],
        [93.305024, 7.949937],
        [93.454438, 7.869289],
        [93.429454, 7.955268]
    ],
    [
        [93.565929, 7.999335],
        [93.510753, 7.980170],
        [93.573985, 7.924872],
        [93.574229, 7.968817],
        [93.565929, 7.999335]
    ],
    [
        [98.540538, 8.104926],
        [98.528494, 8.123481],
        [98.603526, 7.903754],
        [98.602387, 8.063463],
        [98.540538, 8.104926]
    ],
    [
        [98.418630, 7.903754],
        [98.439138, 8.082506],
        [98.281423, 8.191799],
        [98.291840, 7.777493],
        [98.418630, 7.903754]
    ],
    [
        [98.637543, 8.171291],
        [98.624034, 8.191799],
        [98.579600, 8.106147],
        [98.620860, 8.089993],
        [98.637543, 8.171291]
    ],
    [
        [93.531912, 8.034735],
        [93.531668, 8.213202],
        [93.504649, 8.226996],
        [93.446625, 8.154364],
        [93.531912, 8.034735]
    ],
    [
        [73.077159, 8.315253],
        [73.022472, 8.274359],
        [73.024099, 8.255439],
        [73.066091, 8.270453],
        [73.077159, 8.315253]
    ],
    [
        [93.134532, 8.240180],
        [93.104015, 8.275580],
        [93.083751, 8.355902],
        [93.065766, 8.268134],
        [93.134532, 8.240180]
    ],
    [
        [93.607677, 8.548041],
        [93.601410, 8.438178],
        [93.628184, 8.486558],
        [93.607677, 8.548041]
    ],
    [
        [106.662608, 8.739814],
        [106.658376, 8.766669],
        [106.570974, 8.705959],
        [106.578380, 8.655463],
        [106.662608, 8.739814]
    ],
    [
        [79.714122, 9.075629],
        [79.799815, 9.048977],
        [79.909679, 8.973212],
        [79.841645, 9.077216],
        [79.714122, 9.075629]
    ],
    [
        [98.295665, 9.145168],
        [98.248220, 9.150092],
        [98.254242, 9.036811],
        [98.323009, 9.076239],
        [98.295665, 9.145168]
    ],
    [
        [92.811373, 9.231170],
        [92.750987, 9.261217],
        [92.731212, 9.130845],
        [92.831981, 9.145025],
        [92.811373, 9.231170]
    ],
    [
        [79.730805, 9.500190],
        [79.719249, 9.524359],
        [79.658702, 9.555365],
        [79.666026, 9.491278],
        [79.730805, 9.500190]
    ],
    [
        [100.070160, 9.586412],
        [99.926280, 9.565985],
        [99.946625, 9.418199],
        [100.060883, 9.463813],
        [100.070160, 9.586412]
    ],
    [
        [79.895844, 9.617499],
        [79.977875, 9.624335],
        [79.882335, 9.760891],
        [79.840668, 9.699408],
        [79.895844, 9.617499]
    ],
    [
        [98.411632, 9.768297],
        [98.384939, 9.727932],
        [98.398123, 9.706244],
        [98.416677, 9.733466],
        [98.411632, 9.768297]
    ],
    [
        [100.035411, 9.795600],
        [99.987641, 9.719916],
        [100.090099, 9.665269],
        [100.067231, 9.775621],
        [100.035411, 9.795600]
    ],
    [
        [106.498057, 9.891181],
        [106.442882, 9.932807],
        [106.422374, 9.939032],
        [106.535655, 9.829169],
        [106.498057, 9.891181]
    ],
    [
        [98.295665, 10.048896],
        [98.254405, 10.062690],
        [98.234630, 10.054185],
        [98.127452, 9.960110],
        [98.133474, 9.845608],
        [98.295665, 10.048896]
    ],
    [
        [98.185802, 10.121161],
        [98.185802, 10.042060],
        [98.240489, 10.172349],
        [98.185802, 10.121161]
    ],
    [
        [104.082042, 10.370998],
        [103.846039, 10.371283],
        [104.051280, 10.007961],
        [104.033458, 10.096015],
        [104.082042, 10.370998]
    ],
    [
        [97.911469, 10.494534],
        [97.896251, 10.487535],
        [97.889415, 10.419989],
        [97.910167, 10.401923],
        [97.911469, 10.494534]
    ],
    [
        [106.874278, 10.460395],
        [106.847830, 10.613837],
        [106.751964, 10.665839],
        [106.770681, 10.464301],
        [106.874278, 10.460395]
    ],
    [
        [98.493663, 10.891099],
        [98.498383, 10.793606],
        [98.527110, 10.786933],
        [98.553233, 10.832831],
        [98.493663, 10.891099]
    ],
    [
        [92.585092, 10.771269],
        [92.428966, 10.850816],
        [92.384111, 10.529328],
        [92.535423, 10.524861],
        [92.585092, 10.771269]
    ],
    [
        [97.890391, 10.884955],
        [97.883556, 10.844550],
        [97.951834, 10.919094],
        [97.911957, 10.924262],
        [97.890391, 10.884955]
    ],
    [
        [98.267751, 10.837144],
        [98.171886, 10.978664],
        [98.077403, 10.888088],
        [98.250743, 10.693101],
        [98.267751, 10.837144]
    ],
    [
        [98.528494, 10.974311],
        [98.541515, 10.953803],
        [98.524669, 11.086656],
        [98.477061, 10.973700],
        [98.528494, 10.974311]
    ],
    [
        [98.275157, 11.248033],
        [98.281423, 11.275946],
        [98.219981, 11.269110],
        [98.247325, 11.214504],
        [98.275157, 11.248033]
    ],
    [
        [103.037120, 11.357896],
        [102.989268, 11.426174],
        [103.007579, 11.255072],
        [103.043305, 11.273424],
        [103.037120, 11.357896]
    ],
    [
        [92.676524, 11.412543],
        [92.696300, 11.454413],
        [92.635590, 11.508043],
        [92.593516, 11.378363],
        [92.676524, 11.412543]
    ],
    [
        [103.030284, 11.501899],
        [102.995860, 11.513739],
        [103.030284, 11.426174],
        [103.050792, 11.460354],
        [103.030284, 11.501899]
    ],
    [
        [92.266775, 11.589545],
        [92.217296, 11.598090],
        [92.252126, 11.529242],
        [92.285004, 11.544013],
        [92.266775, 11.589545]
    ],
    [
        [102.564138, 11.707953],
        [102.530040, 11.604926],
        [102.598318, 11.563381],
        [102.605968, 11.684516],
        [102.564138, 11.707953]
    ],
    [
        [98.278331, 11.799791],
        [98.165294, 11.473944],
        [98.176524, 11.449164],
        [98.283539, 11.509426],
        [98.278331, 11.799791]
    ],
    [
        [98.535330, 11.803616],
        [98.370779, 11.789252],
        [98.535330, 11.529242],
        [98.556407, 11.758734],
        [98.535330, 11.803616]
    ],
    [
        [98.055431, 11.701117],
        [98.082286, 11.734687],
        [98.013927, 11.864976],
        [98.011729, 11.704739],
        [98.089610, 11.632270],
        [98.055431, 11.701117]
    ],
    [
        [97.664399, 11.905951],
        [97.642833, 11.867662],
        [97.671886, 11.837714],
        [97.678477, 11.887885],
        [97.664399, 11.905951]
    ],
    [
        [98.254161, 11.858140],
        [98.289073, 11.882392],
        [98.265391, 11.908515],
        [98.256521, 11.902533],
        [98.254161, 11.858140]
    ],
    [
        [98.267751, 11.933905],
        [98.260916, 11.971137],
        [98.235850, 11.968329],
        [98.246104, 11.925442],
        [98.267751, 11.933905]
    ],
    [
        [93.042491, 11.961168],
        [93.014659, 12.037177],
        [92.947032, 11.989691],
        [93.066417, 11.899115],
        [93.042491, 11.961168]
    ],
    [
        [98.603526, 11.967434],
        [98.519867, 12.007025],
        [98.439138, 12.112006],
        [98.478038, 11.890937],
        [98.603526, 11.967434]
    ],
    [
        [102.399669, 12.043158],
        [102.342784, 12.123603],
        [102.249522, 12.153022],
        [102.290375, 11.974840],
        [102.399669, 12.043158]
    ],
    [
        [93.103282, 12.190497],
        [93.059337, 12.153551],
        [93.094249, 12.090969],
        [93.103282, 12.102037],
        [93.103282, 12.190497]
    ],
    [
        [98.096446, 12.187161],
        [98.123790, 12.259467],
        [98.072520, 12.289537],
        [98.039399, 12.207343],
        [98.137462, 12.138739],
        [98.096446, 12.187161]
    ],
    [
        [98.065278, 12.365302],
        [98.075938, 12.427395],
        [97.945567, 12.310045],
        [98.000255, 12.269029],
        [98.065278, 12.365302]
    ],
    [
        [98.514171, 12.495592],
        [98.474294, 12.424994],
        [98.495616, 12.405829],
        [98.514171, 12.423651],
        [98.514171, 12.495592]
    ],
    [
        [98.254161, 12.567613],
        [98.230235, 12.516995],
        [98.260509, 12.495266],
        [98.289887, 12.526313],
        [98.254161, 12.567613]
    ],
    [
        [97.822765, 12.587470],
        [97.829438, 12.557074],
        [97.849946, 12.537258],
        [97.849946, 12.594631],
        [97.822765, 12.587470]
    ],
    [
        [98.466319, 12.583726],
        [98.315603, 12.687445],
        [98.302013, 12.337958],
        [98.455821, 12.457750],
        [98.466319, 12.583726]
    ],
    [
        [92.733084, 12.972480],
        [92.682791, 12.961737],
        [92.682791, 12.797309],
        [92.724376, 12.872382],
        [92.733084, 12.972480]
    ],
    [
        [98.295665, 13.084662],
        [98.247325, 13.215033],
        [98.302013, 12.913316],
        [98.336436, 13.073879],
        [98.295665, 13.084662]
    ],
    [
        [93.052745, 13.283881],
        [93.011729, 13.578111],
        [92.737478, 12.807196],
        [92.792654, 12.207668],
        [92.524913, 11.857489],
        [92.716970, 11.494452],
        [92.846690, 12.433539],
        [92.990571, 12.519232],
        [92.876313, 12.916653],
        [93.052745, 13.283881]
    ],
    [
        [93.039073, 13.667467],
        [93.033214, 13.680243],
        [92.990571, 13.667467],
        [93.052745, 13.640204],
        [93.039073, 13.667467]
    ],
    [
        [97.931895, 13.859280],
        [97.918712, 13.853258],
        [97.917735, 13.783596],
        [97.938162, 13.851793],
        [97.931895, 13.859280]
    ],
    [
        [93.396007, 14.140448],
        [93.390310, 14.153754],
        [93.374848, 14.064683],
        [93.394786, 14.076361],
        [93.396007, 14.140448]
    ],
    [
        [93.675792, 14.859198],
        [93.704438, 14.870998],
        [93.724376, 14.913804],
        [93.703868, 14.904446],
        [93.675792, 14.859198]
    ],
    [
        [97.664399, 15.565579],
        [97.650890, 15.592231],
        [97.664399, 15.504096],
        [97.672374, 15.533352],
        [97.664399, 15.565579]
    ],
    [
        [94.827973, 15.932034],
        [94.806814, 15.931098],
        [94.724864, 15.811957],
        [94.803722, 15.796576],
        [94.827973, 15.932034]
    ],
    [
        [94.662120, 16.221869],
        [94.389659, 16.000922],
        [94.402680, 15.839260],
        [94.629649, 16.075181],
        [94.662120, 16.221869]
    ],
    [
        [97.589366, 16.415269],
        [97.459646, 16.477362],
        [97.547461, 16.199928],
        [97.571364, 16.222693],
        [97.589366, 16.415269]
    ],
    [
        [93.745372, 18.799994],
        [93.621755, 18.910346],
        [93.484141, 18.874986],
        [93.645274, 18.679348],
        [93.745372, 18.799994]
    ],
    [
        [93.970714, 19.416938],
        [93.723643, 19.556383],
        [93.641775, 19.492011],
        [93.802745, 19.276679],
        [93.970714, 19.416938]
    ],
    [
        [93.505219, 19.807318],
        [93.498790, 19.887030],
        [93.402843, 19.953070],
        [93.511974, 19.745836],
        [93.505219, 19.807318]
    ],
    [
        [92.964041, 20.036689],
        [92.911957, 20.084703],
        [93.024913, 19.827826],
        [93.014659, 19.905585],
        [92.964041, 20.036689]
    ],
    [
        [-154.899622, 19.567016],
        [-155.168043, 19.946827],
        [-155.880483, 20.252021],
        [-155.835458, 19.975703],
        [-156.060164, 19.731221],
        [-155.878130, 19.029072],
        [-155.674756, 18.906117],
        [-155.502797, 19.137681],
        [-154.874736, 19.412884],
        [-154.899622, 19.567016]
    ],
    [
        [-156.561774, 20.598008],
        [-156.608815, 20.591046],
        [-156.700562, 20.525427],
        [-156.544555, 20.513217],
        [-156.561774, 20.598008]
    ],
    [
        [107.080333, 20.800442],
        [107.107677, 20.800442],
        [106.957367, 20.876776],
        [106.912852, 20.836900],
        [107.046153, 20.704250],
        [107.080333, 20.800442]
    ],
    [
        [-156.848378, 20.876817],
        [-156.990414, 20.927509],
        [-157.063136, 20.890387],
        [-156.962280, 20.732388],
        [-156.848378, 20.876817]
    ],
    [
        [106.840099, 20.879869],
        [106.785411, 20.930813],
        [106.873546, 20.789537],
        [106.881602, 20.821519],
        [106.840099, 20.879869]
    ],
    [
        [110.595876, 20.958726],
        [110.547537, 20.917711],
        [110.589203, 20.883490],
        [110.632498, 20.936672],
        [110.595876, 20.958726]
    ],
    [
        [107.525401, 20.910305],
        [107.470714, 20.883002],
        [107.463878, 20.814114],
        [107.545177, 20.919135],
        [107.553233, 20.972357],
        [107.525401, 20.910305]
    ],
    [
        [107.745128, 21.020168],
        [107.758800, 20.982611],
        [107.738292, 20.937649],
        [107.792817, 20.986029],
        [107.745128, 21.020168]
    ],
    [
        [-156.001698, 20.800442],
        [-156.597929, 21.032653],
        [-156.696009, 20.915802],
        [-156.407653, 20.587207],
        [-156.048423, 20.650888],
        [-156.001698, 20.800442]
    ],
    [
        [107.532725, 21.020168],
        [107.532725, 21.040595],
        [107.395030, 20.897284],
        [107.511729, 20.923977],
        [107.532725, 21.020168]
    ],
    [
        [110.547537, 21.037258],
        [110.389822, 21.095893],
        [110.245860, 20.986029],
        [110.516938, 20.937649],
        [110.547537, 21.037258]
    ],
    [
        [107.621267, 21.116034],
        [107.594249, 21.089057],
        [107.559418, 20.986029],
        [107.579600, 20.983140],
        [107.621267, 21.116034]
    ],
    [
        [110.616954, 21.191474],
        [110.554942, 21.156724],
        [110.543224, 21.204169],
        [110.417735, 21.178453],
        [110.543224, 21.104967],
        [110.616954, 21.191474]
    ],
    [
        [-156.749013, 21.170966],
        [-157.259759, 21.221880],
        [-157.303944, 21.109565],
        [-156.869578, 21.053371],
        [-156.749013, 21.170966]
    ],
    [
        [107.580577, 21.211982],
        [107.455333, 21.275702],
        [107.372895, 21.059556],
        [107.470714, 21.095893],
        [107.580577, 21.211982]
    ],
    [
        [107.813487, 21.360500],
        [107.783946, 21.356350],
        [107.711436, 21.307563],
        [107.817068, 21.348538],
        [107.813487, 21.360500]
    ],
    [
        [107.868663, 21.390082],
        [107.841156, 21.348538],
        [107.998302, 21.403754],
        [107.868663, 21.390082]
    ],
    [
        [88.872895, 21.595526],
        [88.838715, 21.531928],
        [88.907970, 21.530707],
        [88.911306, 21.566881],
        [88.872895, 21.595526]
    ],
    [
        [-157.706824, 21.351995],
        [-157.969655, 21.709061],
        [-158.278933, 21.575265],
        [-158.094309, 21.293606],
        [-157.706824, 21.351995]
    ],
    [
        [91.935557, 21.759996],
        [91.853526, 21.725816],
        [91.877126, 21.481024],
        [91.970225, 21.523586],
        [91.935557, 21.759996]
    ],
    [
        [88.050548, 21.705390],
        [88.139415, 21.630316],
        [88.146739, 21.869859],
        [88.119314, 21.859524],
        [88.050548, 21.705390]
    ],
    [
        [89.115733, 21.781155],
        [89.092784, 21.793402],
        [89.045665, 21.917060],
        [89.051524, 21.793199],
        [89.132498, 21.721625],
        [89.115733, 21.781155]
    ],
    [
        [88.636241, 21.921373],
        [88.584972, 21.826606],
        [88.646332, 21.787909],
        [88.670584, 21.907416],
        [88.636241, 21.921373]
    ],
    [
        [91.887706, 21.866156],
        [91.867198, 21.931952],
        [91.832530, 21.725816],
        [91.862804, 21.789984],
        [91.887706, 21.866156]
    ],
    [
        [88.080903, 21.849351],
        [88.125011, 21.888658],
        [88.118907, 21.945014],
        [88.077322, 21.904608],
        [88.080903, 21.849351]
    ],
    [
        [90.593516, 21.986558],
        [90.521983, 21.938788],
        [90.503591, 21.862454],
        [90.606619, 21.938788],
        [90.593516, 21.986558]
    ],
    [
        [90.332205, 21.938788],
        [90.318614, 21.892808],
        [90.322927, 21.843899],
        [90.394298, 22.000230],
        [90.332205, 21.938788]
    ],
    [
        [-160.113759, 22.000271],
        [-160.245463, 21.850839],
        [-160.211285, 21.780209],
        [-160.072214, 21.910834],
        [-160.113759, 22.000271]
    ],
    [
        [90.387462, 22.048041],
        [90.358653, 22.022691],
        [90.339610, 21.972317],
        [90.381114, 22.023098],
        [90.387462, 22.048041]
    ],
    [
        [90.435232, 22.041205],
        [90.394298, 21.938788],
        [90.415538, 21.900539],
        [90.486176, 21.976793],
        [90.435232, 22.041205]
    ],
    [
        [121.563487, 22.044623],
        [121.566580, 22.082180],
        [121.492035, 22.082180],
        [121.587657, 22.013861],
        [121.563487, 22.044623]
    ],
    [
        [90.544444, 22.061672],
        [90.613455, 22.164049],
        [90.483653, 22.034980],
        [90.544444, 22.061672]
    ],
    [
        [90.941742, 22.205024],
        [90.920258, 22.160061],
        [90.929373, 22.116889],
        [90.956716, 22.144843],
        [90.941742, 22.205024]
    ],
    [
        [-159.301259, 22.151028],
        [-159.558543, 22.232995],
        [-159.787211, 22.019270],
        [-159.437315, 21.868769],
        [-159.301259, 22.151028]
    ],
    [
        [90.976410, 22.185777],
        [90.997813, 22.235093],
        [90.982921, 22.259182],
        [90.977061, 22.239203],
        [90.976410, 22.185777]
    ],
    [
        [90.952891, 22.226752],
        [90.994395, 22.302069],
        [90.976410, 22.363349],
        [90.937185, 22.232733],
        [90.952891, 22.226752]
    ],
    [
        [91.148847, 22.357057],
        [91.074801, 22.388590],
        [91.022472, 22.094875],
        [91.186785, 22.227757],
        [91.148847, 22.357057]
    ],
    [
        [90.619640, 22.424750],
        [90.640147, 22.349677],
        [90.640147, 22.308743],
        [90.658702, 22.379543],
        [90.619640, 22.424750]
    ],
    [
        [90.647472, 22.424750],
        [90.667328, 22.439032],
        [90.653494, 22.483466],
        [90.647472, 22.424750]
    ],
    [
        [91.158619, 22.503423],
        [91.123562, 22.489146],
        [91.113710, 22.461415],
        [91.210830, 22.495521],
        [91.158619, 22.503423]
    ],
    [
        [91.467557, 22.586310],
        [91.446517, 22.453242],
        [91.555179, 22.402031],
        [91.556361, 22.478210],
        [91.467557, 22.586310]
    ],
    [
        [90.790553, 22.495333],
        [90.585460, 22.768052],
        [90.647472, 21.994045],
        [90.836192, 22.178168],
        [90.790553, 22.495333]
    ],
    [
        [90.645254, 22.849289],
        [90.473399, 22.865139],
        [90.455740, 22.767401],
        [90.520993, 22.711765],
        [90.645254, 22.849289]
    ],
    [
        [90.667328, 22.953030],
        [90.586192, 23.034898],
        [90.508067, 22.975775],
        [90.636241, 22.921332],
        [90.667328, 22.953030]
    ],
    [
        [90.510427, 23.069037],
        [90.455740, 23.062812],
        [90.469493, 23.007636],
        [90.515636, 23.051947],
        [90.510427, 23.069037]
    ],
    [
        [90.524099, 23.322252],
        [90.429698, 23.385159],
        [90.487071, 23.319037],
        [90.524099, 23.322252]
    ],
    [
        [123.814708, 24.391750],
        [123.769867, 24.418362],
        [123.668224, 24.296617],
        [123.873057, 24.258246],
        [123.814708, 24.391750]
    ],
    [
        [123.002615, 24.474311],
        [122.955577, 24.473131],
        [122.938650, 24.444241],
        [122.998383, 24.439521],
        [123.002615, 24.474311]
    ],
    [
        [118.394216, 24.522691],
        [118.282074, 24.477362],
        [118.283946, 24.401272],
        [118.463356, 24.431523],
        [118.394216, 24.522691]
    ],
    [
        [118.092540, 24.556220],
        [118.069998, 24.460273],
        [118.136485, 24.429267],
        [118.181407, 24.535102],
        [118.092540, 24.556220]
    ],
    [
        [124.329112, 24.583564],
        [124.078380, 24.435492],
        [124.140310, 24.341986],
        [124.241873, 24.363715],
        [124.329112, 24.583564]
    ],
    [
        [141.357758, 24.789618],
        [141.299490, 24.785875],
        [141.289561, 24.726955],
        [141.365489, 24.777737],
        [141.357758, 24.789618]
    ],
    [
        [125.387218, 24.782172],
        [125.358246, 24.782620],
        [125.260265, 24.885199],
        [125.258800, 24.733385],
        [125.387218, 24.782172]
    ],
    [
        [119.846528, 25.536322],
        [119.763520, 25.659491],
        [119.668468, 25.487860],
        [119.757335, 25.404934],
        [119.846528, 25.536322]
    ],
    [
        [131.255138, 25.874986],
        [131.236095, 25.872056],
        [131.212087, 25.829047],
        [131.252452, 25.819037],
        [131.255138, 25.874986]
    ],
    [
        [126.810069, 26.351874],
        [126.769867, 26.388007],
        [126.697765, 26.369045],
        [126.788910, 26.303453],
        [126.810069, 26.351874]
    ],
    [
        [142.193207, 26.646064],
        [142.165863, 26.701321],
        [142.111339, 26.721177],
        [142.159923, 26.632025],
        [142.193207, 26.646064]
    ],
    [
        [128.337657, 26.796942],
        [128.255056, 26.886298],
        [128.057384, 26.644761],
        [127.878266, 26.694525],
        [127.960216, 26.564114],
        [127.722504, 26.429918],
        [127.651703, 26.084377],
        [127.919932, 26.309638],
        [127.851736, 26.441230],
        [128.337657, 26.796942]
    ],
    [
        [142.193207, 27.091742],
        [142.198578, 27.051093],
        [142.234630, 27.050035],
        [142.233246, 27.094306],
        [142.193207, 27.091742]
    ],
    [
        [128.700694, 27.454820],
        [128.538422, 27.417629],
        [128.526866, 27.371894],
        [128.613129, 27.364325],
        [128.700694, 27.454820]
    ],
    [
        [128.988780, 27.811103],
        [128.894542, 27.891303],
        [128.929454, 27.686713],
        [129.024262, 27.756578],
        [128.988780, 27.811103]
    ],
    [
        [129.296641, 28.119574],
        [129.269298, 28.174872],
        [129.180837, 28.190253],
        [129.296641, 28.119574]
    ],
    [
        [130.030284, 28.373481],
        [129.975597, 28.343248],
        [129.913585, 28.297105],
        [129.995453, 28.290920],
        [130.030284, 28.373481]
    ],
    [
        [129.707530, 28.462144],
        [129.673106, 28.509833],
        [129.145763, 28.249945],
        [129.375987, 28.119574],
        [129.707530, 28.462144]
    ],
    [
        [121.957530, 29.119534],
        [121.926606, 29.166734],
        [121.868175, 29.147406],
        [121.888682, 29.072333],
        [121.957530, 29.119534]
    ],
    [
        [129.714854, 29.654527],
        [129.712901, 29.629299],
        [129.721039, 29.606147],
        [129.753754, 29.645413],
        [129.714854, 29.654527]
    ],
    [
        [122.143240, 29.733385],
        [122.107432, 29.789618],
        [122.032888, 29.730943],
        [122.162934, 29.654527],
        [122.143240, 29.733385]
    ],
    [
        [129.893565, 29.874742],
        [129.832772, 29.873078],
        [129.920421, 29.819648],
        [129.927257, 29.825873],
        [129.893565, 29.874742]
    ],
    [
        [122.395193, 29.883612],
        [122.406749, 29.952704],
        [122.325450, 29.953925],
        [122.395193, 29.833319],
        [122.395193, 29.883612]
    ],
    [
        [121.881847, 30.076361],
        [121.834727, 30.044989],
        [121.860118, 29.978095],
        [121.910492, 30.024115],
        [121.881847, 30.076361]
    ],
    [
        [122.327485, 30.024482],
        [122.103282, 30.143704],
        [121.963145, 30.142401],
        [122.019054, 29.997219],
        [122.327485, 30.024482]
    ],
    [
        [130.674571, 30.374579],
        [130.498951, 30.467962],
        [130.376247, 30.394436],
        [130.485977, 30.225777],
        [130.674571, 30.374579]
    ],
    [
        [131.052013, 30.840237],
        [130.851495, 30.470144],
        [130.870381, 30.343904],
        [131.057615, 30.611269],
        [131.052013, 30.840237]
    ],
    [
        [121.844075, 31.607947],
        [121.322564, 31.829331],
        [121.176288, 31.784323],
        [121.977851, 31.477771],
        [121.844075, 31.607947]
    ],
    [
        [130.153087, 32.203762],
        [130.111095, 32.193305],
        [130.149262, 32.110500],
        [130.194102, 32.176418],
        [130.153087, 32.203762]
    ],
    [
        [130.410004, 32.511623],
        [130.363048, 32.527086],
        [130.213064, 32.436510],
        [130.362315, 32.374986],
        [130.410004, 32.511623]
    ],
    [
        [130.160492, 32.546332],
        [130.002940, 32.533352],
        [129.995453, 32.190660],
        [130.203380, 32.338853],
        [130.160492, 32.546332]
    ],
    [
        [128.878427, 32.673925],
        [128.660818, 32.782782],
        [128.600439, 32.614178],
        [128.773110, 32.571666],
        [128.878427, 32.673925]
    ],
    [
        [139.791026, 33.135321],
        [139.739757, 33.133246],
        [139.835785, 33.039781],
        [139.877452, 33.087592],
        [139.791026, 33.135321]
    ],
    [
        [129.097992, 32.988267],
        [129.123911, 33.109173],
        [129.108180, 33.166688],
        [129.097992, 32.988267]
    ],
    [
        [129.555684, 33.410805],
        [129.442663, 33.348066],
        [129.342501, 33.179620],
        [129.493095, 33.245163],
        [129.555684, 33.410805]
    ],
    [
        [126.946056, 33.478013],
        [126.484935, 33.520758],
        [126.161143, 33.300767],
        [126.606919, 33.240610],
        [126.946056, 33.478013]
    ],
    [
        [132.243663, 33.793280],
        [132.208751, 33.800116],
        [132.188324, 33.779690],
        [132.272960, 33.768541],
        [132.243663, 33.793280]
    ],
    [
        [129.776378, 33.773424],
        [129.767263, 33.844550],
        [129.688648, 33.871146],
        [129.657127, 33.742555],
        [129.776378, 33.773424]
    ],
    [
        [132.236176, 33.869045],
        [132.374034, 33.841702],
        [132.469493, 33.937934],
        [132.201915, 33.944770],
        [132.236176, 33.869045]
    ],
    [
        [139.487071, 34.060777],
        [139.534516, 34.037543],
        [139.575043, 34.090033],
        [139.523448, 34.112372],
        [139.487071, 34.060777]
    ],
    [
        [132.555186, 34.071357],
        [132.577647, 34.118883],
        [132.519298, 34.174384],
        [132.455333, 34.088121],
        [132.555186, 34.071357]
    ],
    [
        [132.999475, 34.208377],
        [133.051768, 34.222317],
        [133.030040, 34.295315],
        [132.954845, 34.198188],
        [132.999475, 34.208377]
    ],
    [
        [129.312528, 34.279756],
        [129.207361, 34.329277],
        [129.171634, 34.106807],
        [129.276587, 34.129111],
        [129.312528, 34.279756]
    ],
    [
        [139.270356, 34.395982],
        [139.253673, 34.341376],
        [139.267833, 34.322699],
        [139.300955, 34.417914],
        [139.270356, 34.395982]
    ],
    [
        [127.173025, 34.483710],
        [127.117361, 34.437567],
        [127.241873, 34.445461],
        [127.234223, 34.480292],
        [127.173025, 34.483710]
    ],
    [
        [126.380056, 34.498440],
        [126.247732, 34.574774],
        [126.103282, 34.402777],
        [126.209972, 34.358791],
        [126.380056, 34.498440]
    ],
    [
        [135.002682, 34.608423],
        [134.683260, 34.328226],
        [134.728677, 34.190939],
        [134.958254, 34.270356],
        [135.002682, 34.608423]
    ],
    [
        [129.452647, 34.619452],
        [129.323300, 34.648072],
        [129.228913, 34.355601],
        [129.400756, 34.337924],
        [129.452647, 34.619452]
    ],
    [
        [127.782074, 34.684556],
        [127.735850, 34.625230],
        [127.797862, 34.579739],
        [127.817231, 34.630764],
        [127.782074, 34.684556]
    ],
    [
        [125.989024, 34.713324],
        [125.976736, 34.728258],
        [125.916026, 34.687649],
        [125.976899, 34.656399],
        [125.989024, 34.713324]
    ],
    [
        [126.007172, 34.780951],
        [125.912852, 34.776923],
        [125.892589, 34.736640],
        [125.930024, 34.722602],
        [126.007172, 34.780951]
    ],
    [
        [139.418224, 34.780829],
        [139.351195, 34.720034],
        [139.453787, 34.678941],
        [139.450043, 34.756781],
        [139.418224, 34.780829]
    ],
    [
        [126.056000, 34.913642],
        [126.028005, 34.909898],
        [125.986501, 34.862738],
        [126.080740, 34.870998],
        [126.056000, 34.913642]
    ],
    [
        [128.069591, 34.815009],
        [127.902110, 34.940009],
        [127.829356, 34.868964],
        [127.892100, 34.712714],
        [128.069591, 34.815009]
    ],
    [
        [128.748546, 34.868964],
        [128.702891, 35.032945],
        [128.488455, 34.868964],
        [128.583995, 34.705146],
        [128.748546, 34.868964]
    ],
    [
        [126.110606, 35.051174],
        [126.127778, 35.120551],
        [126.069102, 35.102362],
        [126.110606, 35.051174]
    ],
    [
        [133.012462, 36.014797],
        [133.027843, 35.993638],
        [133.079112, 35.993638],
        [133.045177, 36.020006],
        [133.012462, 36.014797]
    ],
    [
        [133.367035, 36.274237],
        [133.292003, 36.342475],
        [133.187755, 36.216132],
        [133.326020, 36.158149],
        [133.367035, 36.274237]
    ],
    [
        [126.563303, 37.514443],
        [126.514830, 37.534347],
        [126.355511, 37.466223],
        [126.443413, 37.420625],
        [126.563303, 37.514443]
    ],
    [
        [130.903575, 37.545844],
        [130.814301, 37.522610],
        [130.811046, 37.487006],
        [130.896739, 37.463121],
        [130.903575, 37.545844]
    ],
    [
        [126.356700, 37.695136],
        [126.319998, 37.747219],
        [126.281993, 37.699286],
        [126.370128, 37.658352],
        [126.356700, 37.695136]
    ],
    [
        [126.507823, 37.596869],
        [126.516368, 37.767239],
        [126.407074, 37.820705],
        [126.370128, 37.631049],
        [126.507823, 37.596869]
    ],
    [
        [124.732677, 37.980455],
        [124.624034, 37.980455],
        [124.613617, 37.945054],
        [124.684906, 37.919989],
        [124.732677, 37.980455]
    ],
    [
        [138.459239, 38.069892],
        [138.514171, 38.323065],
        [138.242198, 38.071479],
        [138.342540, 37.966864],
        [138.222667, 37.802232],
        [138.500499, 37.906684],
        [138.575206, 38.074286],
        [138.459239, 38.069892]
    ],
    [
        [124.883474, 38.528551],
        [124.844249, 38.555162],
        [124.790294, 38.517401],
        [124.903982, 38.494371],
        [124.883474, 38.528551]
    ],
    [
        [139.548513, 42.243354],
        [139.423839, 42.191596],
        [139.445649, 42.054836],
        [139.508962, 42.100816],
        [139.548513, 42.243354]
    ],
    [
        [146.175059, 43.538153],
        [146.131684, 43.540839],
        [146.079356, 43.517646],
        [146.151866, 43.462795],
        [146.175059, 43.538153]
    ],
    [
        [145.311534, 43.593329],
        [145.286957, 43.601020],
        [145.202403, 43.613837],
        [145.283539, 43.517890],
        [145.311534, 43.593329]
    ],
    [
        [146.881684, 43.859198],
        [146.604666, 43.808580],
        [146.602224, 43.736070],
        [146.914561, 43.802720],
        [146.881684, 43.859198]
    ],
    [
        [144.448253, 43.942206],
        [144.448985, 43.942043],
        [144.448253, 43.942206]
    ],
    [
        [146.469249, 44.428778],
        [146.119314, 44.506049],
        [145.443126, 43.724514],
        [145.556163, 43.652655],
        [145.588715, 43.847561],
        [146.572113, 44.449897],
        [146.469249, 44.428778]
    ],
    [
        [141.327159, 45.172349],
        [141.202647, 45.249091],
        [141.131847, 45.210273],
        [141.251231, 45.099189],
        [141.327159, 45.172349]
    ],
    [
        [141.052745, 45.450426],
        [140.966807, 45.463446],
        [141.035655, 45.264879],
        [141.073578, 45.424709],
        [141.052745, 45.450426]
    ],
    [
        [148.799164, 45.415676],
        [148.726573, 45.525214],
        [148.069591, 45.251166],
        [147.939952, 45.426256],
        [147.894867, 45.223944],
        [147.109199, 44.827148],
        [147.196580, 44.713682],
        [147.653801, 44.994851],
        [147.913024, 44.963002],
        [148.799164, 45.415676]
    ],
    [
        [29.918712, 45.690660],
        [29.908051, 45.666449],
        [29.918712, 45.690660]
    ],
    [
        [32.989268, 46.042629],
        [32.978689, 46.053290],
        [32.989268, 46.042629]
    ],
    [
        [150.334239, 46.210842],
        [149.667328, 45.853217],
        [149.436697, 45.586982],
        [150.569350, 46.231758],
        [150.334239, 46.210842]
    ],
    [
        [31.940278, 46.204576],
        [31.618175, 46.259223],
        [31.504405, 46.373358],
        [31.580333, 46.262763],
        [31.940278, 46.204576]
    ],
    [
        [152.205577, 47.128811],
        [152.225434, 47.176581],
        [152.294932, 47.142483],
        [152.205577, 47.128811]
    ],
    [
        [152.503429, 47.383246],
        [152.426280, 47.383490],
        [152.413154, 47.340671],
        [152.524444, 47.298646],
        [152.503429, 47.383246]
    ],
    [
        [153.021271, 47.799597],
        [152.970189, 47.751570],
        [152.978254, 47.684333],
        [153.068819, 47.743296],
        [153.021271, 47.799597]
    ],
    [
        [153.288422, 48.077460],
        [153.214727, 48.125725],
        [153.164556, 48.121415],
        [153.233301, 48.039809],
        [153.288422, 48.077460]
    ],
    [
        [154.212901, 48.917670],
        [154.119477, 48.899604],
        [153.973318, 48.739488],
        [154.056407, 48.737779],
        [154.212901, 48.917670]
    ],
    [
        [153.986990, 48.965399],
        [153.915050, 48.982489],
        [153.902110, 48.956488],
        [153.960704, 48.926703],
        [153.986990, 48.965399]
    ],
    [
        [154.562999, 49.157172],
        [154.457042, 49.171454],
        [154.439464, 49.157172],
        [154.511729, 49.080227],
        [154.562999, 49.157172]
    ],
    [
        [154.447558, 49.816984],
        [154.373904, 49.778467],
        [154.411917, 49.733096],
        [154.491338, 49.783252],
        [154.447558, 49.816984]
    ],
    [
        [156.125255, 50.637519],
        [156.041189, 50.772773],
        [155.689626, 50.403713],
        [155.201915, 50.293524],
        [155.216563, 50.067084],
        [155.395763, 49.995795],
        [155.884939, 50.253730],
        [156.125255, 50.637519]
    ],
    [
        [156.460460, 50.873725],
        [156.199392, 50.780504],
        [156.180024, 50.688422],
        [156.405772, 50.630113],
        [156.460460, 50.873725]
    ],
    [
        [155.563487, 50.808254],
        [155.672862, 50.870307],
        [155.474132, 50.921820],
        [155.467621, 50.852484],
        [155.563487, 50.808254]
    ],
    [
        [179.400076, 51.408433],
        [178.920177, 51.611802],
        [178.636404, 51.637437],
        [179.243012, 51.353827],
        [179.400076, 51.408433]
    ],
    [
        [178.252208, 51.829901],
        [178.396169, 51.768500],
        [178.333995, 51.816230],
        [178.252208, 51.829901]
    ],
    [
        [178.533946, 51.987494],
        [178.459972, 51.944403],
        [178.516775, 51.896186],
        [178.604259, 51.937690],
        [178.533946, 51.987494]
    ],
    [
        [179.780935, 51.967027],
        [179.636974, 52.035346],
        [179.486095, 51.973863],
        [179.642100, 51.874172],
        [179.780935, 51.967027]
    ],
    [
        [177.642589, 52.124701],
        [177.508474, 51.994574],
        [177.224294, 51.891995],
        [177.612071, 51.927924],
        [177.642589, 52.124701]
    ],
    [
        [175.881847, 52.377997],
        [175.928884, 52.339260],
        [175.990977, 52.358100],
        [175.915863, 52.377997],
        [175.881847, 52.377997]
    ],
    [
        [173.791270, 52.501532],
        [173.624522, 52.500718],
        [173.388927, 52.403795],
        [173.743419, 52.361233],
        [173.791270, 52.501532]
    ],
    [
        [174.096690, 52.713772],
        [174.182302, 52.706936],
        [174.113943, 52.741034],
        [174.096690, 52.713772]
    ],
    [
        [173.376638, 52.830471],
        [173.127208, 52.994940],
        [172.476085, 52.926663],
        [172.944347, 52.749823],
        [173.376638, 52.830471]
    ],
    [
        [-164.972524, 54.125190],
        [-165.133005, 54.132636],
        [-165.225779, 54.091051],
        [-164.976023, 54.075751],
        [-164.972524, 54.125190]
    ],
    [
        [142.549653, 54.302232],
        [142.587169, 54.313300],
        [142.604177, 54.310207],
        [142.540701, 54.297797],
        [142.549653, 54.302232]
    ],
    [
        [-162.409128, 54.406399],
        [-162.472239, 54.422105],
        [-162.485422, 54.413886],
        [-162.435414, 54.372016],
        [-162.368113, 54.385891],
        [-162.409128, 54.406399]
    ],
    [
        [-162.587188, 54.441107],
        [-162.813832, 54.504340],
        [-162.841135, 54.461005],
        [-162.632680, 54.371894],
        [-162.587188, 54.441107]
    ],
    [
        [137.821788, 54.457831],
        [137.716482, 54.392157],
        [137.715099, 54.367174],
        [137.821788, 54.457831]
    ],
    [
        [137.622569, 54.570787],
        [137.546723, 54.516262],
        [137.568126, 54.396633],
        [137.641124, 54.400458],
        [137.622569, 54.570787]
    ],
    [
        [168.059255, 54.546617],
        [167.734060, 54.762641],
        [168.059255, 54.546617]
    ],
    [
        [-162.374949, 54.954413],
        [-162.342152, 54.839545],
        [-162.230946, 54.907294],
        [-162.262685, 54.989203],
        [-162.374949, 54.954413]
    ],
    [
        [-163.073842, 54.687567],
        [-163.756540, 55.060370],
        [-164.477528, 54.918891],
        [-164.958241, 54.585150],
        [-164.652577, 54.391995],
        [-164.132680, 54.623236],
        [-163.073842, 54.687567]
    ],
    [
        [137.171235, 55.119534],
        [136.809255, 55.018052],
        [136.670421, 54.907294],
        [137.074962, 54.933173],
        [137.171235, 55.119534]
    ],
    [
        [-161.730662, 55.160549],
        [-161.843821, 55.171332],
        [-161.908193, 55.143459],
        [-161.751169, 55.058051],
        [-161.730662, 55.160549]
    ],
    [
        [138.046723, 55.058051],
        [137.567882, 55.194648],
        [137.225922, 54.777818],
        [137.485362, 54.879340],
        [137.718923, 54.624335],
        [138.212169, 55.036363],
        [138.046723, 55.058051]
    ],
    [
        [166.664399, 54.756415],
        [166.250255, 55.152289],
        [166.253673, 55.331855],
        [165.746430, 55.297065],
        [166.664399, 54.756415]
    ],
    [
        [-160.325429, 55.358547],
        [-160.486928, 55.353217],
        [-160.531484, 55.325019],
        [-160.336293, 55.248684],
        [-160.325429, 55.358547]
    ],
    [
        [-160.497385, 55.194648],
        [-160.559275, 55.393134],
        [-160.853627, 55.331855],
        [-160.818918, 55.119534],
        [-160.497385, 55.194648]
    ],
    [
        [-160.147939, 55.386420],
        [-160.171132, 55.453762],
        [-160.259470, 55.422309],
        [-160.147939, 55.386420]
    ],
    [
        [-158.708567, 55.831488],
        [-158.828114, 55.896715],
        [-158.908681, 55.841295],
        [-158.883778, 55.805243],
        [-158.708567, 55.831488]
    ],
    [
        [-169.580881, 56.609524],
        [-169.608022, 56.603339],
        [-169.789052, 56.620347],
        [-169.632680, 56.544664],
        [-169.474355, 56.593004],
        [-169.580881, 56.609524]
    ],
    [
        [-170.241567, 57.216254],
        [-170.323801, 57.216254],
        [-170.412099, 57.184801],
        [-170.289988, 57.106391],
        [-170.104441, 57.250393],
        [-170.241567, 57.216254]
    ],
    [
        [23.943370, 58.113186],
        [24.002452, 58.108547],
        [24.013357, 58.153510],
        [23.955333, 58.151801],
        [23.943370, 58.113186]
    ],
    [
        [23.230642, 58.504828],
        [22.550304, 58.629584],
        [22.089366, 58.422187],
        [21.832367, 58.510972],
        [22.011241, 58.353949],
        [21.843761, 58.293606],
        [22.202973, 58.147895],
        [21.963390, 57.984036],
        [22.048350, 57.915107],
        [22.295095, 58.192857],
        [23.333263, 58.456366],
        [23.230642, 58.504828]
    ],
    [
        [23.381602, 58.579901],
        [23.197765, 58.680609],
        [23.059337, 58.603461],
        [23.234874, 58.534654],
        [23.381602, 58.579901]
    ],
    [
        [23.364024, 59.028957],
        [23.170177, 59.045885],
        [23.114106, 59.021796],
        [23.299083, 58.970893],
        [23.364024, 59.028957]
    ],
    [
        [22.291759, 58.895209],
        [22.555675, 58.686998],
        [23.040538, 58.840766],
        [22.666677, 59.084906],
        [22.044688, 58.936184],
        [22.291759, 58.895209]
    ],
    [
        [18.485362, 59.097561],
        [18.374766, 59.078355],
        [18.344412, 59.025702],
        [18.413585, 59.011664],
        [18.485362, 59.097561]
    ],
    [
        [150.725271, 59.127997],
        [150.698530, 59.140446],
        [150.472076, 59.004153],
        [150.782800, 59.090864],
        [150.725271, 59.127997]
    ],
    [
        [18.715831, 59.208808],
        [18.690929, 59.208808],
        [18.659679, 59.176907],
        [18.750011, 59.205146],
        [18.715831, 59.208808]
    ],
    [
        [164.706900, 58.976828],
        [164.558116, 59.239691],
        [163.749283, 59.018960],
        [163.913191, 58.994291],
        [163.412854, 58.535369],
        [163.490019, 58.444503],
        [164.706900, 58.976828]
    ],
    [
        [18.797048, 59.294867],
        [18.757660, 59.294582],
        [18.722667, 59.262397],
        [18.775157, 59.252183],
        [18.797048, 59.294867]
    ],
    [
        [155.507711, 59.328127],
        [155.509036, 59.320148],
        [155.600049, 59.319429],
        [155.566932, 59.340424],
        [155.507711, 59.328127]
    ],
    [
        [18.676036, 59.340277],
        [18.677501, 59.299547],
        [18.747081, 59.331855],
        [18.638031, 59.367987],
        [18.676036, 59.340277]
    ],
    [
        [18.106700, 59.384955],
        [18.165538, 59.340644],
        [18.249278, 59.366685],
        [18.122732, 59.389106],
        [18.106700, 59.384955]
    ],
    [
        [18.854259, 59.402533],
        [18.847667, 59.389350],
        [18.869477, 59.393459],
        [18.865082, 59.399848],
        [18.854259, 59.402533]
    ],
    [
        [18.942393, 59.393622],
        [18.921560, 59.405911],
        [18.899425, 59.400702],
        [18.937673, 59.373236],
        [18.942393, 59.393622]
    ],
    [
        [18.925792, 59.434027],
        [18.898611, 59.445705],
        [18.860606, 59.424506],
        [18.893891, 59.407172],
        [18.925792, 59.434027]
    ],
    [
        [18.656586, 59.506741],
        [18.510509, 59.483140],
        [18.556407, 59.422309],
        [18.656586, 59.506741]
    ],
    [
        [24.515880, 59.598090],
        [24.489106, 59.559638],
        [24.542817, 59.547797],
        [24.550059, 59.557766],
        [24.515880, 59.598090]
    ],
    [
        [18.977712, 59.633857],
        [18.937755, 59.649075],
        [18.858572, 59.595771],
        [18.905284, 59.583238],
        [18.977712, 59.633857]
    ],
    [
        [18.854259, 59.601142],
        [18.924327, 59.656928],
        [18.756847, 59.572659],
        [18.823904, 59.583889],
        [18.854259, 59.601142]
    ],
    [
        [18.996349, 59.809760],
        [18.959158, 59.863715],
        [18.885753, 59.793931],
        [18.972016, 59.786607],
        [18.996349, 59.809760]
    ],
    [
        [20.875255, 59.914130],
        [20.912364, 59.904486],
        [20.920177, 59.909247],
        [20.897472, 59.940131],
        [20.875255, 59.914130]
    ],
    [
        [20.983572, 59.942776],
        [20.995860, 59.949897],
        [20.913259, 59.948432],
        [20.982758, 59.921536],
        [20.983572, 59.942776]
    ],
    [
        [23.915212, 59.973456],
        [23.870291, 59.972805],
        [23.847423, 59.954657],
        [23.894216, 59.949693],
        [23.915212, 59.973456]
    ],
    [
        [29.791352, 59.994859],
        [29.713552, 60.021877],
        [29.657400, 60.025458],
        [29.786876, 59.975084],
        [29.791352, 59.994859]
    ],
    [
        [27.885020, 60.011054],
        [27.820079, 60.030829],
        [27.802582, 59.999335],
        [27.820486, 59.982733],
        [27.885020, 60.011054]
    ],
    [
        [20.610118, 60.044989],
        [20.544932, 60.056098],
        [20.500824, 60.012681],
        [20.587169, 60.008124],
        [20.610118, 60.044989]
    ],
    [
        [20.424083, 60.055243],
        [20.403494, 60.040513],
        [20.390147, 60.028225],
        [20.462576, 60.066799],
        [20.424083, 60.055243]
    ],
    [
        [22.887380, 60.067776],
        [22.855154, 60.055569],
        [22.872244, 60.006049],
        [22.926606, 60.065375],
        [22.887380, 60.067776]
    ],
    [
        [20.521169, 60.048041],
        [20.541840, 60.070990],
        [20.469737, 60.057359],
        [20.471365, 60.041327],
        [20.521169, 60.048041]
    ],
    [
        [27.022227, 60.042182],
        [26.964122, 60.099433],
        [26.950043, 60.099555],
        [26.984711, 60.017727],
        [27.022227, 60.042182]
    ],
    [
        [22.957530, 60.110785],
        [22.891612, 60.119086],
        [22.845470, 60.082221],
        [22.946788, 60.084703],
        [22.957530, 60.110785]
    ],
    [
        [21.991547, 60.129950],
        [21.962087, 60.137885],
        [21.929942, 60.124579],
        [22.012380, 60.122748],
        [21.991547, 60.129950]
    ],
    [
        [20.683360, 60.130520],
        [20.659923, 60.149726],
        [20.635509, 60.143948],
        [20.671560, 60.109198],
        [20.683360, 60.130520]
    ],
    [
        [22.313162, 60.191962],
        [22.288341, 60.149848],
        [22.385590, 60.195258],
        [22.375011, 60.204047],
        [22.313162, 60.191962]
    ],
    [
        [18.723969, 60.196601],
        [18.724376, 60.155463],
        [18.806895, 60.160590],
        [18.753103, 60.209174],
        [18.723969, 60.196601]
    ],
    [
        [20.683767, 60.229397],
        [20.670665, 60.199205],
        [20.716319, 60.209296],
        [20.705903, 60.218248],
        [20.683767, 60.229397]
    ],
    [
        [21.983165, 60.284980],
        [22.006033, 60.292141],
        [22.008311, 60.297309],
        [21.972911, 60.285346],
        [21.983165, 60.284980]
    ],
    [
        [21.956879, 60.281399],
        [21.973806, 60.309312],
        [21.875336, 60.304877],
        [21.909679, 60.280097],
        [21.956879, 60.281399]
    ],
    [
        [28.711762, 60.294989],
        [28.580333, 60.348944],
        [28.541352, 60.347357],
        [28.624197, 60.270209],
        [28.711762, 60.294989]
    ],
    [
        [28.516856, 60.337714],
        [28.484874, 60.361884],
        [28.425548, 60.360785],
        [28.503673, 60.311021],
        [28.516856, 60.337714]
    ],
    [
        [20.777354, 60.326483],
        [20.757172, 60.366116],
        [20.732677, 60.314358],
        [20.740001, 60.312405],
        [20.777354, 60.326483]
    ],
    [
        [22.299653, 60.367580],
        [22.255707, 60.374172],
        [22.157237, 60.351874],
        [22.191091, 60.341742],
        [22.299653, 60.367580]
    ],
    [
        [22.206228, 60.382554],
        [22.137869, 60.379096],
        [22.104259, 60.354153],
        [22.207530, 60.375556],
        [22.206228, 60.382554]
    ],
    [
        [21.338064, 60.383368],
        [21.307791, 60.389594],
        [21.294444, 60.370510],
        [21.355317, 60.351793],
        [21.338064, 60.383368]
    ],
    [
        [-165.582102, 59.950995],
        [-165.726064, 60.066474],
        [-165.684438, 60.299791],
        [-166.157419, 60.436957],
        [-166.820424, 60.217597],
        [-167.452830, 60.217231],
        [-166.182078, 59.756293],
        [-166.081736, 59.779039],
        [-166.246693, 59.853909],
        [-165.582102, 59.950995]
    ],
    [
        [26.602061, 60.446519],
        [26.574718, 60.421780],
        [26.652599, 60.426907],
        [26.602061, 60.446519]
    ],
    [
        [-172.297312, 60.351345],
        [-172.925038, 60.606676],
        [-173.057607, 60.498440],
        [-172.208567, 60.313463],
        [-172.297312, 60.351345]
    ],
    [
        [-169.809967, 63.064643],
        [-169.868845, 63.106147],
        [-169.809967, 63.064643]
    ],
    [
        [-169.440943, 63.363540],
        [-169.508127, 63.373358],
        [-169.489329, 63.367825],
        [-169.440943, 63.363540]
    ],
    [
        [-170.296213, 63.239407],
        [-170.381825, 63.301418],
        [-170.485463, 63.344672],
        [-170.296213, 63.239407]
    ],
    [
        [-170.975209, 63.431220],
        [-171.029246, 63.438666],
        [-170.975209, 63.431220]
    ],
    [
        [-171.089996, 63.603909],
        [-171.074900, 63.602240],
        [-171.089996, 63.603909]
    ],
    [
        [-171.157656, 63.609737],
        [-171.157656, 63.609737]
    ],
    [
        [-168.740712, 63.280992],
        [-170.084543, 63.485826],
        [-170.310048, 63.698676],
        [-171.487172, 63.608954],
        [-171.728017, 63.796129],
        [-171.852895, 63.521186],
        [-171.439320, 63.319770],
        [-170.856150, 63.460354],
        [-170.444325, 63.359198],
        [-169.666208, 62.945217],
        [-169.351145, 63.176215],
        [-168.740712, 63.280992]
    ],
    [
        [35.943126, 64.405097],
        [35.856781, 64.387356],
        [36.044932, 64.360338],
        [36.031261, 64.373114],
        [35.943126, 64.405097]
    ],
    [
        [35.866873, 65.031317],
        [35.786450, 65.165106],
        [35.506113, 65.121288],
        [35.744660, 64.961551],
        [35.866873, 65.031317]
    ],
    [
        [-169.083363, 65.815863],
        [-169.076527, 65.755072],
        [-168.994618, 65.815863],
        [-169.063222, 65.828192],
        [-169.083363, 65.815863]
    ],
    [
        [12.875336, 66.285631],
        [12.793793, 66.311225],
        [12.700206, 66.243232],
        [12.824962, 66.215888],
        [12.875336, 66.285631]
    ],
    [
        [12.940766, 66.460191],
        [12.817231, 66.442572],
        [12.800792, 66.384711],
        [12.898936, 66.355048],
        [12.940766, 66.460191]
    ],
    [
        [42.645838, 66.742345],
        [42.504491, 66.777906],
        [42.426500, 66.752009],
        [42.668029, 66.666691],
        [42.645838, 66.742345]
    ],
    [
        [32.385997, 67.132310],
        [32.356130, 67.139065],
        [32.337657, 67.124905],
        [32.393728, 67.100328],
        [32.385997, 67.132310]
    ],
    [
        [15.295665, 67.945258],
        [15.105724, 68.000718],
        [14.961192, 67.941596],
        [15.163097, 67.910712],
        [15.295665, 67.945258]
    ],
    [
        [15.930186, 68.008246],
        [15.574067, 68.025580],
        [15.482432, 68.002631],
        [15.883962, 67.984117],
        [15.930186, 68.008246]
    ],
    [
        [15.166189, 67.986762],
        [15.184825, 67.966783],
        [15.286632, 67.976996],
        [15.230317, 68.036689],
        [15.166189, 67.986762]
    ],
    [
        [14.996593, 68.901597],
        [14.899669, 68.930854],
        [14.840099, 68.891669],
        [14.958344, 68.875312],
        [14.996593, 68.901597]
    ],
    [
        [59.241954, 69.177558],
        [59.150727, 69.254625],
        [59.244640, 69.145697],
        [59.241954, 69.177558]
    ],
    [
        [34.030121, 69.393541],
        [33.975597, 69.369615],
        [34.406912, 69.352525],
        [34.215831, 69.407782],
        [34.030121, 69.393541]
    ],
    [
        [50.323009, 69.150539],
        [48.906261, 69.507961],
        [48.304210, 69.276801],
        [48.219412, 68.895657],
        [48.592052, 68.730862],
        [49.248546, 68.779975],
        [50.323009, 69.150539]
    ],
    [
        [20.702891, 69.888821],
        [20.562755, 69.895982],
        [20.526703, 69.821112],
        [20.706716, 69.817288],
        [20.702891, 69.888821]
    ],
    [
        [30.021169, 69.832343],
        [29.842459, 69.908922],
        [29.713227, 69.763414],
        [30.107432, 69.828599],
        [30.021169, 69.832343]
    ],
    [
        [19.813324, 70.002590],
        [19.546886, 69.925482],
        [19.434255, 69.840522],
        [19.720551, 69.864691],
        [19.813324, 70.002590]
    ],
    [
        [169.446462, 69.849107],
        [168.264659, 70.024115],
        [167.753754, 69.832343],
        [168.874522, 69.567857],
        [169.234711, 69.592108],
        [169.446462, 69.849107]
    ],
    [
        [18.666759, 70.027574],
        [18.701671, 69.984687],
        [18.975597, 70.073635],
        [18.721365, 70.116034],
        [18.666759, 70.027574]
    ],
    [
        [20.894216, 70.079576],
        [20.856944, 70.144924],
        [20.792979, 70.119045],
        [20.825531, 70.073065],
        [20.894216, 70.079576]
    ],
    [
        [19.538748, 70.093695],
        [19.407970, 70.162055],
        [19.334972, 70.127916],
        [19.358653, 70.113105],
        [19.538748, 70.093695]
    ],
    [
        [19.242361, 70.200873],
        [19.168305, 70.254869],
        [18.995860, 70.152086],
        [19.174164, 70.115139],
        [19.242361, 70.200873]
    ],
    [
        [21.738129, 70.378241],
        [21.684581, 70.363837],
        [21.703136, 70.261786],
        [21.793712, 70.323432],
        [21.738129, 70.378241]
    ],
    [
        [60.539806, 69.818671],
        [59.023611, 70.479804],
        [58.494640, 70.331977],
        [58.824229, 70.215888],
        [58.412120, 70.260321],
        [58.695567, 70.002834],
        [59.431488, 69.889472],
        [59.623709, 69.804348],
        [59.563487, 69.715033],
        [60.539806, 69.818671]
    ],
    [
        [57.117361, 70.558539],
        [57.072113, 70.554918],
        [56.843028, 70.606350],
        [57.063650, 70.502427],
        [57.221690, 70.526068],
        [57.117361, 70.558539]
    ],
    [
        [162.381684, 70.681464],
        [162.345551, 70.662055],
        [162.484141, 70.654120],
        [162.381684, 70.681464]
    ],
    [
        [161.662283, 70.791327],
        [161.530528, 70.841620],
        [161.463145, 70.804999],
        [161.694591, 70.750434],
        [161.662283, 70.791327]
    ],
    [
        [160.723481, 70.838446],
        [160.674385, 70.914211],
        [160.407970, 70.914252],
        [160.504066, 70.805012],
        [160.723481, 70.838446]
    ],
    [
        [-7.962554, 71.174872],
        [-8.325673, 71.147610],
        [-9.117421, 70.874905],
        [-8.005971, 71.032538],
        [-7.962554, 71.174872]
    ],
    [
        [53.231781, 71.215888],
        [52.741059, 71.405829],
        [52.211762, 71.308092],
        [53.009776, 70.968207],
        [53.231781, 71.215888]
    ],
    [
        [137.914236, 71.558498],
        [137.218272, 71.576239],
        [136.991873, 71.517524],
        [137.693370, 71.419379],
        [137.914236, 71.558498]
    ],
    [
        [78.279063, 72.552191],
        [77.610199, 72.634711],
        [76.852712, 72.333075],
        [77.770763, 72.304999],
        [78.394542, 72.491400],
        [78.279063, 72.552191]
    ],
    [
        [128.831065, 72.655219],
        [128.652517, 72.675767],
        [128.831065, 72.655219]
    ],
    [
        [128.317149, 72.812323],
        [129.207043, 72.761895],
        [129.417139, 72.812596],
        [128.994083, 72.932471],
        [128.317149, 72.812323]
    ],
    [
        [79.562999, 72.768256],
        [79.541352, 72.925523],
        [79.173106, 73.101386],
        [78.584646, 72.841864],
        [79.562999, 72.768256]
    ],
    [
        [74.725352, 73.107123],
        [74.211681, 73.114569],
        [74.093272, 73.027777],
        [74.656261, 72.858629],
        [74.702647, 73.078762],
        [74.725352, 73.107123]
    ],
    [
        [120.278575, 73.100898],
        [120.021983, 73.168118],
        [119.634451, 73.128160],
        [119.720714, 73.033840],
        [120.278575, 73.100898]
    ],
    [
        [76.695079, 73.186225],
        [76.184581, 73.216986],
        [76.133311, 73.208319],
        [76.632579, 73.131252],
        [76.695079, 73.186225]
    ],
    [
        [71.669119, 73.227484],
        [71.435720, 73.352973],
        [70.980317, 73.265367],
        [71.229177, 73.464748],
        [70.469574, 73.499213],
        [69.959321, 73.398830],
        [70.064952, 73.237128],
        [69.874848, 73.038275],
        [71.374501, 73.178934],
        [71.730236, 73.034409],
        [71.669119, 73.227484]
    ],
    [
        [76.756602, 73.449693],
        [76.250743, 73.554185],
        [76.071951, 73.525458],
        [76.754405, 73.429877],
        [76.756602, 73.449693]
    ],
    [
        [75.922618, 73.523668],
        [76.079356, 73.559556],
        [75.619395, 73.553412],
        [75.420909, 73.498114],
        [75.304210, 73.408759],
        [75.922618, 73.523668]
    ],
    [
        [143.474946, 73.320624],
        [143.407237, 73.542792],
        [142.045177, 73.916571],
        [141.127208, 73.881659],
        [140.493302, 73.485044],
        [143.174945, 73.176580],
        [143.565113, 73.231150],
        [143.474946, 73.320624]
    ],
    [
        [124.585948, 73.915839],
        [124.381033, 73.939399],
        [124.287852, 73.880927],
        [124.660655, 73.891995],
        [124.585948, 73.915839]
    ],
    [
        [84.355235, 74.018866],
        [84.418305, 74.039984],
        [84.418305, 73.970445],
        [84.355235, 74.018866]
    ],
    [
        [83.513438, 74.121283],
        [83.180024, 74.155178],
        [83.513438, 74.121283]
    ],
    [
        [82.568044, 74.162909],
        [82.398692, 74.152899],
        [82.317556, 74.116848],
        [82.740001, 74.101386],
        [82.568044, 74.162909]
    ],
    [
        [136.258962, 73.957465],
        [136.010753, 74.103461],
        [135.354015, 74.259101],
        [136.135265, 73.879218],
        [136.258962, 73.957465]
    ],
    [
        [141.097830, 74.149237],
        [140.349900, 74.254216],
        [140.164716, 74.070638],
        [140.545095, 73.915839],
        [141.037771, 74.003852],
        [141.097830, 74.149237]
    ],
    [
        [116.098318, 74.354682],
        [115.980724, 74.377509],
        [115.885753, 74.323635],
        [116.052989, 74.285224],
        [116.098318, 74.354682]
    ],
    [
        [84.870860, 74.505561],
        [84.591807, 74.498928],
        [84.386567, 74.457668],
        [84.541840, 74.457099],
        [84.870860, 74.505561]
    ],
    [
        [19.160330, 74.526028],
        [18.874848, 74.516181],
        [18.789806, 74.478217],
        [19.073741, 74.347357],
        [19.283376, 74.444037],
        [19.160330, 74.526028]
    ],
    [
        [113.405772, 74.444037],
        [112.110118, 74.551215],
        [111.951345, 74.370795],
        [111.459239, 74.313707],
        [112.774913, 74.088080],
        [113.405772, 74.444037]
    ],
    [
        [85.538910, 74.574408],
        [85.237478, 74.575263],
        [85.148123, 74.537177],
        [85.630707, 74.511298],
        [85.538910, 74.574408]
    ],
    [
        [86.078461, 74.555243],
        [85.802989, 74.574408],
        [85.658458, 74.471381],
        [86.207205, 74.512356],
        [86.078461, 74.555243]
    ],
    [
        [79.614106, 74.601752],
        [79.244314, 74.658637],
        [79.148692, 74.607896],
        [79.490001, 74.516913],
        [79.614106, 74.601752]
    ],
    [
        [85.227061, 74.745103],
        [85.506033, 74.716254],
        [85.227061, 74.745103]
    ],
    [
        [87.028982, 74.991523],
        [86.523936, 74.986965],
        [86.597504, 74.917060],
        [86.686860, 74.895941],
        [87.138845, 74.936916],
        [87.028982, 74.991523]
    ],
    [
        [82.136567, 75.142320],
        [82.082530, 75.158026],
        [82.026703, 75.128730],
        [82.150401, 75.095160],
        [82.136567, 75.142320]
    ],
    [
        [82.239594, 75.375678],
        [82.013031, 75.444037],
        [82.170746, 75.519721],
        [81.492442, 75.362047],
        [82.013031, 75.177151],
        [82.041189, 75.337836],
        [82.239594, 75.375678]
    ],
    [
        [150.827647, 75.163398],
        [148.610362, 75.215522],
        [148.407725, 75.421088],
        [146.796723, 75.366360],
        [146.634288, 75.437730],
        [146.770763, 75.506741],
        [146.436209, 75.596747],
        [146.071788, 75.240302],
        [148.172130, 74.803534],
        [149.208995, 74.758002],
        [150.609223, 74.893500],
        [150.958018, 75.142320],
        [150.827647, 75.163398]
    ],
    [
        [136.975108, 75.591742],
        [137.025157, 75.571601],
        [137.081309, 75.568183],
        [136.969819, 75.609036],
        [136.975108, 75.591742]
    ],
    [
        [137.059906, 75.640774],
        [136.984630, 75.621649],
        [136.970225, 75.609687],
        [137.059906, 75.640774]
    ],
    [
        [135.991384, 75.527167],
        [136.184337, 75.615912],
        [135.693126, 75.869330],
        [135.450043, 75.375678],
        [135.983409, 75.417182],
        [135.991384, 75.527167]
    ],
    [
        [82.109548, 75.888983],
        [81.627615, 75.936754],
        [82.109548, 75.888983]
    ],
    [
        [83.279470, 75.956285],
        [82.657481, 75.998847],
        [82.862315, 75.917182],
        [83.279470, 75.956285]
    ],
    [
        [145.366222, 75.540229],
        [143.947113, 75.834784],
        [142.546886, 75.862982],
        [141.310069, 76.184475],
        [141.624685, 76.013129],
        [141.000987, 76.047431],
        [140.864431, 75.738837],
        [141.062266, 75.650092],
        [140.475841, 75.640326],
        [140.509532, 75.790473],
        [138.897309, 76.218736],
        [138.532725, 76.186103],
        [138.432140, 76.063381],
        [137.432953, 75.953192],
        [137.742686, 75.749091],
        [137.067638, 75.725775],
        [137.293630, 75.601630],
        [137.143321, 75.410224],
        [136.862153, 75.362047],
        [137.895274, 74.846177],
        [139.127208, 74.652289],
        [139.652029, 74.980780],
        [140.068696, 74.827948],
        [141.843761, 74.998969],
        [142.514008, 74.817369],
        [143.707774, 74.947455],
        [142.439464, 75.203111],
        [142.008311, 75.622748],
        [142.434093, 75.677965],
        [142.337901, 75.725653],
        [143.001150, 75.707953],
        [142.494314, 75.375678],
        [142.884451, 75.146796],
        [143.998546, 75.024970],
        [144.941091, 75.273342],
        [144.677745, 75.327826],
        [144.729340, 75.431586],
        [145.366222, 75.540229]
    ],
    [
        [96.644054, 76.267035],
        [95.812266, 76.302924],
        [95.570160, 76.238186],
        [95.349946, 76.288764],
        [95.266124, 76.218573],
        [96.344737, 76.105048],
        [96.246104, 76.204983],
        [96.595551, 76.157172],
        [96.644054, 76.267035]
    ],
    [
        [113.292491, 76.363227],
        [113.117686, 76.376899],
        [113.137543, 76.369452],
        [113.292491, 76.363227]
    ],
    [
        [111.958832, 76.602200],
        [112.567882, 76.443508],
        [112.714122, 76.520453],
        [112.367198, 76.658149],
        [111.958832, 76.602200]
    ],
    [
        [96.472016, 76.691596],
        [96.232432, 76.712063],
        [95.889903, 76.616441],
        [96.313487, 76.622545],
        [96.472016, 76.691596]
    ],
    [
        [25.478363, 76.712063],
        [25.094737, 76.544135],
        [24.943370, 76.445136],
        [25.580821, 76.698432],
        [25.478363, 76.712063]
    ],
    [
        [95.650238, 76.677924],
        [95.520844, 76.716783],
        [95.417003, 76.705268],
        [95.528656, 76.648749],
        [95.650238, 76.677924]
    ],
    [
        [97.476329, 76.650336],
        [97.446300, 76.714748],
        [97.288259, 76.691596],
        [97.343110, 76.599311],
        [97.596202, 76.602200],
        [97.476329, 76.650336]
    ],
    [
        [149.374713, 76.738202],
        [149.453497, 76.768779],
        [149.374713, 76.738202]
    ],
    [
        [96.527354, 77.205512],
        [95.420665, 77.055487],
        [95.231944, 77.006293],
        [96.235037, 76.990465],
        [96.527354, 77.205512]
    ],
    [
        [105.784923, 77.280585],
        [105.861827, 77.254869],
        [106.011485, 77.287421],
        [105.902680, 77.304023],
        [105.784923, 77.280585]
    ],
    [
        [89.689220, 77.280585],
        [89.304373, 77.307929],
        [89.134613, 77.217719],
        [89.817020, 77.210590],
        [89.689220, 77.280585]
    ],
    [
        [106.361176, 77.321926],
        [106.456554, 77.321601],
        [106.408458, 77.331000],
        [106.361176, 77.321926]
    ],
    [
        [107.745128, 77.329047],
        [107.395356, 77.360256],
        [107.279552, 77.301703],
        [107.457042, 77.280585],
        [107.745128, 77.329047]
    ],
    [
        [106.861176, 77.445746],
        [106.943126, 77.458726],
        [106.730317, 77.470445],
        [106.524750, 77.390448],
        [106.861176, 77.445746]
    ],
    [
        [107.704112, 78.137152],
        [107.337901, 78.190741],
        [107.451020, 78.053168],
        [107.704112, 78.137152]
    ],
    [
        [24.424765, 77.825936],
        [23.120453, 77.985907],
        [23.470470, 78.158271],
        [22.966075, 78.256293],
        [21.696788, 78.211086],
        [20.876964, 78.098578],
        [21.661794, 77.918036],
        [20.831798, 77.540717],
        [21.092540, 77.439154],
        [22.778331, 77.554918],
        [22.422130, 77.431464],
        [22.401622, 77.284003],
        [23.234541, 77.263683],
        [24.424765, 77.825936]
    ],
    [
        [106.532237, 78.253852],
        [105.990977, 78.219143],
        [106.193858, 78.193061],
        [106.532237, 78.253852]
    ],
    [
        [21.024262, 78.219143],
        [21.061209, 78.200344],
        [22.271251, 78.267524],
        [22.064789, 78.597113],
        [20.153575, 78.475409],
        [20.661143, 78.391059],
        [20.468761, 78.315334],
        [20.791515, 78.274359],
        [20.647227, 78.194037],
        [21.024262, 78.219143]
    ],
    [
        [27.020763, 78.698920],
        [26.615489, 78.808783],
        [26.396332, 78.775214],
        [26.737559, 78.626451],
        [27.020763, 78.698920]
    ],
    [
        [12.142833, 78.237047],
        [11.872244, 78.447943],
        [11.259044, 78.528225],
        [10.999848, 78.834174],
        [10.484386, 78.890692],
        [11.121837, 78.438870],
        [12.142833, 78.237047]
    ],
    [
        [29.438975, 78.904975],
        [28.418630, 78.966986],
        [27.841970, 78.843492],
        [29.438975, 78.904975]
    ],
    [
        [30.069591, 79.008002],
        [30.136241, 78.968940],
        [30.337087, 78.994330],
        [30.309255, 79.008002],
        [30.069591, 79.008002]
    ],
    [
        [20.098888, 79.124091],
        [20.358246, 78.994696],
        [20.831798, 79.055162],
        [20.467784, 79.125800],
        [20.098888, 79.124091]
    ],
    [
        [20.057872, 79.377265],
        [19.804535, 79.405219],
        [20.057872, 79.377265]
    ],
    [
        [105.415538, 78.583441],
        [105.175059, 78.809272],
        [104.578868, 78.775214],
        [104.366710, 78.857123],
        [104.524913, 78.885077],
        [104.455333, 78.966742],
        [103.624278, 79.171210],
        [102.379161, 78.822455],
        [102.825450, 79.227118],
        [103.153168, 79.309638],
        [102.302908, 79.432807],
        [102.139659, 79.356838],
        [102.246267, 79.241645],
        [101.817556, 79.371039],
        [101.194184, 79.202867],
        [100.988129, 79.062649],
        [100.907237, 78.985093],
        [100.823741, 78.808783],
        [100.385265, 78.751614],
        [100.049653, 78.343207],
        [99.268321, 78.041571],
        [99.871267, 77.952216],
        [101.209809, 78.193508],
        [104.787364, 78.336371],
        [105.415538, 78.583441]
    ],
    [
        [77.613617, 79.521918],
        [76.482270, 79.643744],
        [76.051443, 79.648505],
        [76.696056, 79.477607],
        [77.613617, 79.521918]
    ],
    [
        [11.032481, 79.706936],
        [10.871755, 79.727362],
        [10.710948, 79.721177],
        [10.821544, 79.650539],
        [11.032481, 79.706936]
    ],
    [
        [10.717459, 79.741645],
        [10.984223, 79.731391],
        [11.011974, 79.741645],
        [10.645763, 79.761135],
        [10.717459, 79.741645]
    ],
    [
        [20.208751, 78.638088],
        [21.383311, 78.658596],
        [21.545421, 78.834052],
        [19.906423, 79.014228],
        [19.786306, 79.165107],
        [18.945079, 79.156968],
        [18.591807, 79.261217],
        [18.879161, 79.315863],
        [18.881847, 79.441107],
        [18.346934, 79.629950],
        [17.653168, 79.369371],
        [17.782970, 79.494045],
        [17.590668, 79.548570],
        [18.098399, 79.727362],
        [16.294688, 80.067369],
        [15.955740, 79.945299],
        [16.137706, 79.870754],
        [15.644786, 79.768297],
        [16.435232, 78.911444],
        [15.682140, 79.112209],
        [15.772716, 79.242174],
        [15.295258, 79.603827],
        [14.548595, 79.811469],
        [13.883149, 79.542426],
        [14.158214, 79.343166],
        [14.041677, 79.265815],
        [13.259532, 79.473538],
        [13.451671, 79.592434],
        [13.972667, 79.775214],
        [13.797048, 79.881903],
        [12.163341, 79.809272],
        [12.297048, 79.664984],
        [11.822276, 79.845038],
        [11.227306, 79.788031],
        [11.457693, 79.631781],
        [10.676768, 79.542426],
        [11.228282, 79.100653],
        [11.722667, 79.187567],
        [11.594737, 79.309638],
        [12.115001, 79.302191],
        [11.683604, 79.069403],
        [11.334158, 78.973212],
        [11.901703, 78.844306],
        [11.643240, 78.747260],
        [11.903575, 78.638088],
        [12.362559, 78.487250],
        [13.009613, 78.203843],
        [14.733653, 78.391059],
        [14.383556, 78.500922],
        [14.589610, 78.555487],
        [14.445567, 78.678412],
        [14.814952, 78.733629],
        [14.982677, 78.597398],
        [15.381521, 78.851386],
        [15.465099, 78.654608],
        [15.192882, 78.589586],
        [15.439464, 78.458401],
        [16.001964, 78.482733],
        [16.554210, 78.719306],
        [16.827159, 78.648017],
        [16.329926, 78.452460],
        [14.232758, 78.093451],
        [14.330089, 77.964423],
        [13.589122, 78.055854],
        [13.737315, 77.749945],
        [13.957042, 77.719916],
        [17.007823, 77.938544],
        [16.789317, 77.877143],
        [17.124522, 77.781480],
        [15.845876, 77.578803],
        [16.309581, 77.466213],
        [16.221365, 77.440863],
        [13.910655, 77.534491],
        [14.447765, 77.181383],
        [16.528575, 77.000067],
        [15.501475, 76.876532],
        [16.284028, 76.707913],
        [16.343761, 76.572414],
        [17.192068, 76.696845],
        [16.919119, 76.793931],
        [17.323741, 76.978949],
        [17.097179, 77.054674],
        [17.337413, 77.047268],
        [17.624766, 77.445746],
        [18.299815, 77.520209],
        [18.454600, 77.774075],
        [18.330414, 77.904975],
        [18.502452, 77.980170],
        [18.406261, 78.021145],
        [19.098318, 78.103013],
        [18.920584, 78.178534],
        [19.085216, 78.229926],
        [18.961762, 78.452460],
        [20.208751, 78.638088]
    ],
    [
        [93.628184, 79.933417],
        [91.782074, 80.063788],
        [90.866547, 80.062567],
        [91.298595, 79.919135],
        [91.072520, 79.850979],
        [92.353282, 79.734198],
        [93.813731, 79.898668],
        [93.628184, 79.933417]
    ],
    [
        [51.346853, 79.953315],
        [51.000987, 80.102525],
        [51.505138, 79.933417],
        [51.346853, 79.953315]
    ],
    [
        [36.593598, 80.158759],
        [36.785899, 80.139838],
        [36.853689, 80.151923],
        [36.652599, 80.174872],
        [36.593598, 80.158759]
    ],
    [
        [99.885997, 79.041490],
        [99.034923, 79.295966],
        [99.666677, 79.312242],
        [99.817068, 79.741645],
        [100.022472, 79.823554],
        [98.556977, 80.058539],
        [98.377208, 79.877875],
        [97.191580, 79.706936],
        [98.089610, 80.056342],
        [97.592133, 80.174872],
        [94.951996, 80.104478],
        [94.224620, 79.898668],
        [94.690115, 79.816107],
        [92.854177, 79.556098],
        [93.320160, 79.501451],
        [93.114106, 79.467271],
        [93.235850, 79.438951],
        [93.690196, 79.542426],
        [93.991222, 79.494045],
        [94.312266, 79.479193],
        [94.333995, 79.248603],
        [94.826671, 79.066636],
        [97.603038, 78.843492],
        [99.405610, 78.822455],
        [99.925548, 78.945990],
        [99.885997, 79.041490]
    ],
    [
        [50.081309, 80.068061],
        [50.335623, 80.181586],
        [49.531261, 80.158759],
        [49.883149, 80.069892],
        [50.081309, 80.068061]
    ],
    [
        [33.098643, 80.227688],
        [31.496349, 80.115709],
        [31.477061, 80.103949],
        [33.098643, 80.227688]
    ],
    [
        [18.296397, 80.276068],
        [18.491384, 80.238837],
        [18.755626, 80.302720],
        [18.296397, 80.276068]
    ],
    [
        [24.169281, 80.446112],
        [24.167166, 80.383368],
        [24.381602, 80.391547],
        [24.242849, 80.454047],
        [24.169281, 80.446112]
    ],
    [
        [24.292247, 80.488349],
        [24.174815, 80.511623],
        [23.977550, 80.494574],
        [24.216970, 80.469550],
        [24.292247, 80.488349]
    ],
    [
        [27.171072, 80.073432],
        [24.259776, 80.375800],
        [24.148774, 80.350531],
        [24.402110, 80.323188],
        [23.122325, 80.117580],
        [23.055024, 80.248358],
        [23.353770, 80.337551],
        [23.120942, 80.391547],
        [23.360606, 80.433051],
        [22.781586, 80.517279],
        [22.750336, 80.330024],
        [22.337738, 80.383857],
        [22.576020, 80.299018],
        [22.346934, 80.070014],
        [22.477306, 80.015367],
        [22.283214, 79.983059],
        [21.599620, 80.125230],
        [21.846690, 80.272121],
        [20.852875, 80.213935],
        [19.656749, 80.505032],
        [19.468761, 80.408881],
        [19.913829, 80.385240],
        [19.715180, 80.248114],
        [19.033458, 80.357978],
        [19.584809, 80.151923],
        [18.933767, 80.056342],
        [18.111990, 79.905504],
        [18.783865, 79.723090],
        [20.475597, 79.686428],
        [19.633311, 79.611314],
        [20.816905, 79.378079],
        [22.895030, 79.419501],
        [22.644705, 79.309638],
        [24.053071, 79.188870],
        [25.829112, 79.442206],
        [25.968761, 79.515448],
        [25.826020, 79.626044],
        [27.207367, 79.873684],
        [27.171072, 80.073432]
    ],
    [
        [19.906993, 80.488349],
        [19.987315, 80.489407],
        [19.852224, 80.505032],
        [19.906993, 80.488349]
    ],
    [
        [20.757498, 80.624905],
        [20.791515, 80.659613],
        [20.666515, 80.642157],
        [20.757498, 80.624905]
    ],
    [
        [21.174490, 80.659613],
        [21.174490, 80.659613]
    ],
    [
        [20.633311, 80.734768],
        [20.821544, 80.680121],
        [21.003184, 80.714260],
        [20.517833, 80.769477],
        [20.633311, 80.734768]
    ],
    [
        [55.794932, 80.642279],
        [56.329112, 80.624905],
        [55.794932, 80.642279]
    ],
    [
        [46.687266, 80.529283],
        [47.430675, 80.593817],
        [47.304210, 80.652777],
        [47.748790, 80.770494],
        [47.536306, 80.856676],
        [46.043712, 80.573554],
        [46.083995, 80.439887],
        [46.687266, 80.529283]
    ],
    [
        [62.221934, 80.813218],
        [59.693858, 80.837144],
        [59.221446, 80.652777],
        [59.636404, 80.431220],
        [61.044607, 80.405178],
        [62.115977, 80.622382],
        [62.221934, 80.813218]
    ],
    [
        [58.130056, 80.780748],
        [58.542735, 80.754299],
        [58.130056, 80.780748]
    ],
    [
        [55.765880, 80.783677],
        [55.765880, 80.783677]
    ],
    [
        [51.689301, 80.727281],
        [51.045177, 80.851467],
        [50.855968, 80.918524],
        [50.443044, 80.906073],
        [50.237153, 80.933498],
        [49.681977, 80.721137],
        [49.188243, 80.521430],
        [48.375499, 80.571112],
        [48.235850, 80.426907],
        [47.619477, 80.405178],
        [48.085134, 80.207180],
        [47.627696, 80.072211],
        [48.372406, 80.091783],
        [49.107188, 80.189521],
        [48.626964, 80.295315],
        [48.839529, 80.387844],
        [49.816173, 80.401028],
        [49.675304, 80.481513],
        [51.689301, 80.727281]
    ],
    [
        [79.806651, 80.974311],
        [79.210704, 80.961330],
        [78.974620, 80.842597],
        [79.806651, 80.974311]
    ],
    [
        [58.653656, 81.043769],
        [58.069509, 81.111518],
        [57.840994, 81.047675],
        [58.366954, 80.945950],
        [58.653656, 81.043769]
    ],
    [
        [57.336436, 80.891791],
        [56.702891, 81.113105],
        [56.095551, 81.091010],
        [57.336436, 80.891791]
    ],
    [
        [54.564138, 80.995429],
        [57.058767, 80.691840],
        [57.716075, 80.793158],
        [56.019216, 81.043606],
        [54.670909, 81.125190],
        [54.417328, 81.008450],
        [54.564138, 80.995429]
    ],
    [
        [50.476573, 81.069973],
        [50.374278, 81.022773],
        [50.347423, 81.091010],
        [50.476573, 81.069973]
    ],
    [
        [91.547211, 81.153795],
        [90.071544, 81.214545],
        [89.893891, 81.173570],
        [91.186209, 81.056830],
        [91.547211, 81.153795]
    ],
    [
        [97.747081, 80.741604],
        [97.883556, 80.769477],
        [95.776622, 81.288804],
        [95.547211, 81.220771],
        [93.052745, 80.995429],
        [93.162608, 80.946967],
        [92.497244, 80.775702],
        [93.270274, 80.797105],
        [92.769298, 80.516750],
        [92.627615, 80.391547],
        [92.107432, 80.289740],
        [92.065766, 80.172431],
        [93.749848, 79.996772],
        [97.187999, 80.233588],
        [97.422862, 80.326972],
        [97.020763, 80.525865],
        [97.130626, 80.665839],
        [97.747081, 80.741604]
    ],
    [
        [57.266124, 81.426825],
        [57.797618, 81.378892],
        [58.570486, 81.413153],
        [57.784028, 81.564765],
        [57.266124, 81.426825]
    ],
    [
        [62.503673, 81.652777],
        [63.467459, 81.589057],
        [63.805919, 81.660142],
        [62.503673, 81.652777]
    ],
    [
        [58.295421, 81.714179],
        [59.355642, 81.753323],
        [59.439952, 81.817816],
        [58.156098, 81.830268],
        [57.891287, 81.707953],
        [58.295421, 81.714179]
    ],
    [
        [158.893403, -54.510837],
        [158.852550, -54.613214],
        [158.838227, -54.750421],
        [158.962413, -54.469334],
        [158.893403, -54.510837]
    ],
    [
        [169.250421, -52.520257],
        [169.186255, -52.469199],
        [169.015391, -52.542657],
        [169.195296, -52.600313],
        [169.250421, -52.520257]
    ],
    [
        [166.243419, -50.600763],
        [166.095876, -50.535903],
        [165.896739, -50.851251],
        [166.240082, -50.851007],
        [166.122732, -50.700372],
        [166.243419, -50.600763]
    ],
    [
        [178.839041, -49.629164],
        [178.770763, -49.627211],
        [178.719005, -49.700128],
        [178.822113, -49.719822],
        [178.839041, -49.629164]
    ],
    [
        [-176.145253, -44.248142],
        [-176.236073, -44.241957],
        [-176.218984, -44.341241],
        [-176.113881, -44.265069],
        [-176.145253, -44.248142]
    ],
    [
        [-176.381988, -43.898614],
        [-176.169138, -43.731378],
        [-176.580637, -43.703383],
        [-176.854970, -43.820082],
        [-176.566151, -43.837823],
        [-176.581492, -44.123142],
        [-176.300038, -44.042576],
        [-176.535390, -43.755629],
        [-176.372263, -43.765883],
        [-176.381988, -43.898614]
    ],
    [
        [147.336599, -43.340265],
        [147.304454, -43.261814],
        [147.086192, -43.429620],
        [147.303884, -43.508884],
        [147.336599, -43.340265]
    ],
    [
        [147.402110, -43.131117],
        [147.291759, -43.153009],
        [147.360850, -43.257908],
        [147.437511, -43.238946],
        [147.402110, -43.131117]
    ],
    [
        [148.141856, -42.603774],
        [148.024587, -42.613458],
        [148.011567, -42.751235],
        [148.176036, -42.648207],
        [148.141856, -42.603774]
    ],
    [
        [148.299001, -42.305597],
        [148.265636, -42.296482],
        [148.230724, -42.299412],
        [148.340587, -42.354099],
        [148.299001, -42.305597]
    ],
    [
        [145.013682, -40.668227],
        [144.930512, -40.615330],
        [144.872813, -40.715997],
        [145.065196, -40.709161],
        [145.013682, -40.668227]
    ],
    [
        [148.114024, -40.524184],
        [148.194184, -40.596287],
        [148.251150, -40.489435],
        [148.131114, -40.513767],
        [148.114024, -40.524184]
    ],
    [
        [144.790863, -40.421157],
        [144.708263, -40.489435],
        [144.742442, -40.592462],
        [144.790538, -40.502130],
        [144.790863, -40.421157]
    ],
    [
        [144.900727, -40.469496],
        [144.950206, -40.453383],
        [144.960460, -40.397882],
        [144.831228, -40.427992],
        [144.900727, -40.469496]
    ],
    [
        [148.429942, -40.373305],
        [148.323497, -40.304457],
        [147.998546, -40.417739],
        [148.340587, -40.503676],
        [148.429942, -40.373305]
    ],
    [
        [148.014903, -40.150567],
        [148.326915, -40.222589],
        [148.299001, -39.961847],
        [147.953298, -39.711684],
        [147.757660, -39.879327],
        [148.014903, -40.150567]
    ],
    [
        [144.105479, -39.892999],
        [144.109223, -39.665785],
        [143.944591, -39.578871],
        [143.902843, -40.126153],
        [144.105479, -39.892999]
    ],
    [
        [146.626801, -38.755955],
        [146.602306, -38.746840],
        [146.471365, -38.747247],
        [146.538910, -38.797052],
        [146.626801, -38.755955]
    ],
    [
        [145.335216, -38.509454],
        [145.279307, -38.451593],
        [145.112966, -38.530532],
        [145.352550, -38.570977],
        [145.335216, -38.509454]
    ],
    [
        [145.441905, -38.316502],
        [145.297862, -38.296563],
        [145.283702, -38.402602],
        [145.494395, -38.365167],
        [145.441905, -38.316502]
    ],
    [
        [138.129649, -35.816339],
        [137.335134, -35.582940],
        [136.597830, -35.757501],
        [136.532563, -35.911879],
        [136.715587, -36.062758],
        [137.459239, -36.082696],
        [138.129649, -35.816339]
    ],
    [
        [136.447276, -35.148126],
        [136.447520, -35.169366],
        [136.498546, -35.172052],
        [136.476329, -35.144708],
        [136.447276, -35.148126]
    ],
    [
        [136.173595, -35.011326],
        [136.126964, -34.948419],
        [136.086111, -34.948175],
        [136.201345, -35.075372],
        [136.173595, -35.011326]
    ],
    [
        [137.369151, -34.472426],
        [137.336192, -34.515313],
        [137.354828, -34.538018],
        [137.373790, -34.498224],
        [137.369151, -34.472426]
    ],
    [
        [134.546397, -33.712172],
        [134.486339, -33.711684],
        [134.479015, -33.783624],
        [134.550629, -33.733657],
        [134.546397, -33.712172]
    ],
    [
        [133.565684, -32.321222],
        [133.620372, -32.259698],
        [133.579356, -32.259698],
        [133.565684, -32.321222]
    ],
    [
        [159.044444, -31.519220],
        [159.064789, -31.588149],
        [159.089610, -31.589044],
        [159.106456, -31.567641],
        [159.044444, -31.519220]
    ],
    [
        [-177.909535, -29.278578],
        [-177.924875, -29.284356],
        [-177.957997, -29.222752],
        [-177.848134, -29.278578],
        [-177.909535, -29.278578]
    ],
    [
        [167.984141, -29.017836],
        [167.926524, -28.997491],
        [167.926443, -29.066339],
        [167.966645, -29.080011],
        [167.984141, -29.017836]
    ],
    [
        [153.487315, -27.415216],
        [153.397960, -27.493097],
        [153.403331, -27.726251],
        [153.548839, -27.415216],
        [153.487315, -27.415216]
    ],
    [
        [153.411469, -27.339532],
        [153.429210, -27.354425],
        [153.451345, -27.017022],
        [153.360525, -27.066013],
        [153.411469, -27.339532]
    ],
    [
        [113.216645, -26.068048],
        [113.115571, -25.963311],
        [112.959483, -25.482517],
        [112.953868, -25.773045],
        [113.207042, -26.139744],
        [113.216645, -26.068048]
    ],
    [
        [152.962413, -25.269627],
        [152.953624, -25.278497],
        [152.993907, -25.338474],
        [153.006358, -25.327732],
        [152.962413, -25.269627]
    ],
    [
        [113.055675, -25.262791],
        [113.069347, -25.276462],
        [113.117686, -25.009454],
        [113.079112, -25.062433],
        [113.055675, -25.262791]
    ],
    [
        [113.151866, -24.926935],
        [113.134939, -24.892022],
        [113.117686, -24.995212],
        [113.151866, -24.926935]
    ],
    [
        [153.369965, -24.989028],
        [153.281261, -24.693536],
        [153.137218, -24.817071],
        [153.226085, -25.027520],
        [153.014415, -25.211521],
        [153.055349, -25.797133],
        [153.369965, -24.989028]
    ],
    [
        [-128.330190, -24.324314],
        [-128.342193, -24.371759],
        [-128.300120, -24.413670],
        [-128.290842, -24.365655],
        [-128.330190, -24.324314]
    ],
    [
        [-147.724233, -23.871759],
        [-147.668935, -23.871759],
        [-147.647857, -23.851821],
        [-147.705881, -23.858575],
        [-147.724233, -23.871759]
    ],
    [
        [151.372325, -23.820245],
        [151.351817, -23.796482],
        [151.383067, -23.879571],
        [151.372325, -23.820245]
    ],
    [
        [151.269867, -23.666274],
        [151.239106, -23.488865],
        [150.979607, -23.487386],
        [151.213878, -23.778090],
        [151.269867, -23.666274]
    ],
    [
        [-149.481679, -23.357843],
        [-149.521433, -23.362726],
        [-149.518748, -23.394952],
        [-149.463246, -23.395766],
        [-149.481679, -23.357843]
    ],
    [
        [-135.019358, -23.117608],
        [-134.984527, -23.138767],
        [-134.942983, -23.083591],
        [-134.997955, -23.116306],
        [-135.019358, -23.117608]
    ],
    [
        [-151.386871, -22.422459],
        [-151.397043, -22.442153],
        [-151.371775, -22.514418],
        [-151.355906, -22.456638],
        [-151.386871, -22.422459]
    ],
    [
        [149.727794, -22.340509],
        [149.710297, -22.385186],
        [149.724783, -22.439874],
        [149.766287, -22.364679],
        [149.727794, -22.340509]
    ],
    [
        [150.536632, -22.275323],
        [150.478363, -22.216241],
        [150.482270, -22.344985],
        [150.555837, -22.306329],
        [150.536632, -22.275323]
    ],
    [
        [149.916515, -22.041925],
        [149.869395, -22.142267],
        [149.888520, -22.226821],
        [149.928233, -22.160089],
        [149.916515, -22.041925]
    ],
    [
        [-157.934560, -21.877537],
        [-157.961049, -21.923923],
        [-157.887074, -21.926365],
        [-157.910349, -21.891697],
        [-157.934560, -21.877537]
    ],
    [
        [150.293224, -21.740899],
        [150.342784, -21.771742],
        [150.368907, -21.726739],
        [150.341075, -21.740899],
        [150.293224, -21.740899]
    ],
    [
        [-140.671946, -21.658949],
        [-140.658274, -21.712660],
        [-140.603668, -21.706801],
        [-140.653188, -21.647068],
        [-140.671946, -21.658949]
    ],
    [
        [150.300059, -21.678888],
        [150.305349, -21.659763],
        [150.246104, -21.623630],
        [150.246104, -21.678888],
        [150.300059, -21.678888]
    ],
    [
        [115.464529, -20.730157],
        [115.428966, -20.669122],
        [115.306977, -20.870538],
        [115.408051, -20.853692],
        [115.464529, -20.730157]
    ],
    [
        [149.094086, -20.418227],
        [149.039399, -20.500746],
        [149.053071, -20.528090],
        [149.115082, -20.479669],
        [149.094086, -20.418227]
    ],
    [
        [149.067393, -20.315199],
        [149.004080, -20.229262],
        [148.984874, -20.151462],
        [148.927013, -20.287286],
        [149.067393, -20.315199]
    ],
    [
        [148.957530, -20.143813],
        [148.980235, -20.056899],
        [148.963715, -20.041599],
        [148.881847, -20.137628],
        [148.957530, -20.143813]
    ],
    [
        [148.450450, -19.965753],
        [148.450450, -20.041599],
        [148.470225, -20.047621],
        [148.480968, -20.004571],
        [148.450450, -19.965753]
    ],
    [
        [-157.707997, -19.767185],
        [-157.742136, -19.804620],
        [-157.721669, -19.855890],
        [-157.708241, -19.841241],
        [-157.707997, -19.767185]
    ],
    [
        [-178.588572, -19.122817],
        [-178.553822, -19.109145],
        [-178.581654, -19.111505],
        [-178.597117, -19.128513],
        [-178.600331, -19.147719],
        [-178.536977, -19.177179],
        [-178.588572, -19.122817]
    ],
    [
        [146.860199, -19.115981],
        [146.832856, -19.102309],
        [146.780284, -19.132013],
        [146.820079, -19.175063],
        [146.860199, -19.115981]
    ],
    [
        [-178.972157, -18.965102],
        [-178.930979, -18.971368],
        [-178.943593, -18.926365],
        [-178.969065, -18.942641],
        [-178.972157, -18.965102]
    ],
    [
        [-179.863067, -18.965834],
        [-179.858266, -19.005955],
        [-179.787180, -18.955336],
        [-179.849680, -18.923435],
        [-179.863067, -18.965834]
    ],
    [
        [-173.956370, -18.567315],
        [-174.072499, -18.633966],
        [-173.990549, -18.705173],
        [-173.915151, -18.626886],
        [-173.956370, -18.567315]
    ],
    [
        [146.319021, -18.382989],
        [146.302094, -18.237237],
        [146.097341, -18.245212],
        [146.223399, -18.465509],
        [146.319021, -18.382989]
    ],
    [
        [-178.766713, -18.191257],
        [-178.789784, -18.172133],
        [-178.845408, -18.217380],
        [-178.763295, -18.245864],
        [-178.766713, -18.191257]
    ],
    [
        [-179.050294, -17.955952],
        [-179.069336, -17.989319],
        [-179.027865, -18.003014],
        [-179.031831, -17.966329],
        [-179.050294, -17.955952]
    ],
    [
        [-178.293162, -17.882745],
        [-178.337880, -17.886000],
        [-178.352284, -17.945733],
        [-178.248647, -17.952569],
        [-178.293162, -17.882745]
    ],
    [
        [-140.678782, -17.780369],
        [-140.624664, -17.687270],
        [-140.837026, -17.854750],
        [-140.785227, -17.858575],
        [-140.678782, -17.780369]
    ],
    [
        [-149.183461, -17.731215],
        [-149.387644, -17.517999],
        [-149.632761, -17.553399],
        [-149.576121, -17.737563],
        [-149.190297, -17.869073],
        [-149.183461, -17.731215]
    ],
    [
        [-149.796702, -17.464451],
        [-149.834584, -17.484959],
        [-149.944407, -17.492364],
        [-149.842763, -17.567560],
        [-149.796702, -17.464451]
    ],
    [
        [-178.964711, -17.176935],
        [-179.019968, -17.149102],
        [-178.985829, -17.313572],
        [-178.910715, -17.214532],
        [-178.964711, -17.176935]
    ],
    [
        [139.562185, -17.039239],
        [139.493907, -16.985121],
        [139.403982, -17.100681],
        [139.425059, -17.142836],
        [139.562185, -17.039239]
    ],
    [
        [139.089203, -16.827569],
        [139.107677, -16.862481],
        [139.158051, -16.827569],
        [139.155040, -16.812921],
        [139.089203, -16.827569]
    ],
    [
        [-151.005808, -16.769220],
        [-151.039906, -16.789972],
        [-151.013254, -16.820733],
        [-150.979563, -16.800388],
        [-151.005808, -16.769220]
    ],
    [
        [-151.478749, -16.738214],
        [-151.477895, -16.889581],
        [-151.352488, -16.858575],
        [-151.430776, -16.747817],
        [-151.478749, -16.738214]
    ],
    [
        [-151.026275, -16.708103],
        [-151.035146, -16.694268],
        [-151.047434, -16.766046],
        [-151.007558, -16.740492],
        [-151.026275, -16.708103]
    ],
    [
        [-151.458241, -16.629002],
        [-151.472605, -16.580499],
        [-151.536122, -16.594903],
        [-151.463246, -16.674086],
        [-151.458241, -16.629002]
    ],
    [
        [-151.780426, -16.478123],
        [-151.776845, -16.511814],
        [-151.746938, -16.525974],
        [-151.753611, -16.483819],
        [-151.780426, -16.478123]
    ],
    [
        [139.734141, -16.443292],
        [139.287852, -16.470636],
        [139.164317, -16.616306],
        [139.144867, -16.756036],
        [139.734141, -16.443292]
    ],
    [
        [-146.387278, -16.108168],
        [-146.391754, -16.147231],
        [-146.338857, -16.162774],
        [-146.337717, -16.113377],
        [-146.387278, -16.108168]
    ],
    [
        [136.670421, -15.663181],
        [136.615733, -15.714044],
        [136.663585, -15.778578],
        [136.711925, -15.703546],
        [136.670421, -15.663181]
    ],
    [
        [136.800629, -15.642022],
        [136.731781, -15.648858],
        [136.731781, -15.744399],
        [136.834972, -15.682387],
        [136.800629, -15.642022]
    ],
    [
        [137.077891, -15.751235],
        [137.083193, -15.652196],
        [136.994756, -15.592776],
        [136.934725, -15.721324],
        [137.077891, -15.751235]
    ],
    [
        [136.615733, -15.538995],
        [136.524913, -15.534275],
        [136.498546, -15.627699],
        [136.587901, -15.635186],
        [136.615733, -15.538995]
    ],
    [
        [136.895681, -15.587498],
        [136.877696, -15.544122],
        [136.848481, -15.635186],
        [136.895681, -15.587498]
    ],
    [
        [124.417979, -15.254083],
        [124.407970, -15.272068],
        [124.336192, -15.300063],
        [124.431651, -15.308689],
        [124.417979, -15.254083]
    ],
    [
        [124.575694, -15.332940],
        [124.568696, -15.244236],
        [124.458832, -15.360935],
        [124.650157, -15.395115],
        [124.575694, -15.332940]
    ],
    [
        [124.928233, -14.973565],
        [124.924571, -14.936293],
        [124.863780, -14.972589],
        [124.927013, -15.029229],
        [124.928233, -14.973565]
    ],
    [
        [135.766754, -14.868210],
        [135.727829, -14.834527],
        [135.687246, -14.902892],
        [135.762679, -14.900902],
        [135.766754, -14.868210]
    ],
    [
        [125.195079, -14.470147],
        [125.096446, -14.549005],
        [125.137462, -14.647638],
        [125.204926, -14.593032],
        [125.195079, -14.470147]
    ],
    [
        [-178.142323, -14.243585],
        [-178.156606, -14.305108],
        [-178.046742, -14.319431],
        [-178.105092, -14.285252],
        [-178.142323, -14.243585]
    ],
    [
        [136.807465, -13.818536],
        [136.811697, -13.808852],
        [136.810313, -13.808282],
        [136.807465, -13.818536]
    ],
    [
        [136.286876, -13.705824],
        [136.195323, -13.669610],
        [136.116710, -13.816664],
        [136.236095, -13.847263],
        [136.286876, -13.705824]
    ],
    [
        [136.951508, -14.181573],
        [136.704600, -14.126886],
        [136.903087, -13.757582],
        [136.731781, -13.839532],
        [136.718272, -13.647719],
        [136.409679, -13.818536],
        [136.324067, -14.229587],
        [136.903087, -14.298923],
        [136.951508, -14.181573]
    ],
    [
        [-172.201039, -13.592543],
        [-172.344431, -13.462986],
        [-172.782582, -13.520278],
        [-172.523183, -13.805352],
        [-172.219065, -13.805352],
        [-172.201039, -13.592543]
    ],
    [
        [136.135916, -13.434828],
        [136.124107, -13.472084],
        [136.094981, -13.360447],
        [136.135916, -13.434828]
    ],
    [
        [96.902192, -12.199965],
        [96.888520, -12.187433],
        [96.916189, -12.161798],
        [96.920177, -12.184991],
        [96.902192, -12.199965]
    ],
    [
        [136.816956, -12.076077],
        [136.797069, -12.108355],
        [136.820974, -12.137953],
        [136.829356, -12.132257],
        [136.816956, -12.076077]
    ],
    [
        [132.387543, -12.071873],
        [132.339854, -12.098565],
        [132.405772, -12.132989],
        [132.411876, -12.083673],
        [132.387543, -12.071873]
    ],
    [
        [136.290212, -11.975681],
        [136.129161, -12.016697],
        [136.129161, -12.057550],
        [136.269298, -12.038995],
        [136.290212, -11.975681]
    ],
    [
        [136.464203, -11.893731],
        [136.483246, -11.889418],
        [136.498546, -11.798110],
        [136.477794, -11.814223],
        [136.464203, -11.893731]
    ],
    [
        [136.605235, -11.746026],
        [136.528982, -11.776544],
        [136.519542, -11.790704],
        [136.581554, -11.798110],
        [136.605235, -11.746026]
    ],
    [
        [135.955906, -11.707165],
        [136.006045, -11.708678],
        [136.055205, -11.650048],
        [135.980865, -11.661368],
        [135.955906, -11.707165]
    ],
    [
        [132.619802, -11.646661],
        [132.545177, -11.631606],
        [132.508800, -11.649591],
        [132.583832, -11.720147],
        [132.619802, -11.646661]
    ],
    [
        [136.423350, -11.509535],
        [136.266856, -11.572931],
        [136.177013, -11.688246],
        [136.375662, -11.592055],
        [136.474864, -11.505955],
        [136.478038, -11.461114],
        [136.423350, -11.509535]
    ],
    [
        [160.503673, -11.736017],
        [160.087169, -11.494806],
        [159.969249, -11.503188],
        [160.483165, -11.844985],
        [160.503673, -11.736017]
    ],
    [
        [-151.807729, -11.385919],
        [-151.819529, -11.420994],
        [-151.800893, -11.461114],
        [-151.780955, -11.454685],
        [-151.807729, -11.385919]
    ],
    [
        [130.536794, -11.705011],
        [130.344981, -11.317071],
        [130.016612, -11.777032],
        [130.628184, -11.804620],
        [130.536794, -11.705011]
    ],
    [
        [153.761567, -11.585870],
        [153.695649, -11.521254],
        [153.205577, -11.317071],
        [153.288097, -11.523126],
        [153.761567, -11.585870]
    ],
    [
        [154.281749, -11.348240],
        [154.090017, -11.310805],
        [154.007498, -11.385919],
        [154.268077, -11.420668],
        [154.281749, -11.348240]
    ],
    [
        [159.804698, -11.290460],
        [159.777354, -11.283624],
        [159.853201, -11.324477],
        [159.839366, -11.297621],
        [159.804698, -11.290460]
    ],
    [
        [153.185069, -11.277439],
        [153.253917, -11.242608],
        [153.104503, -11.185479],
        [153.199229, -11.263116],
        [153.185069, -11.277439]
    ],
    [
        [131.537364, -11.413263],
        [131.274425, -11.189630],
        [131.219249, -11.399672],
        [131.153087, -11.249282],
        [131.023285, -11.413263],
        [130.920909, -11.309340],
        [130.695567, -11.434340],
        [130.367442, -11.204278],
        [130.496593, -11.649509],
        [130.961192, -11.933852],
        [131.537364, -11.413263]
    ],
    [
        [136.763685, -11.040070],
        [136.718667, -11.050836],
        [136.478019, -11.447934],
        [136.716482, -11.206231],
        [136.763685, -11.040070]
    ],
    [
        [132.489431, -11.160089],
        [132.599294, -11.344985],
        [132.599294, -10.968357],
        [132.468110, -11.029962],
        [132.489431, -11.160089]
    ],
    [
        [152.808279, -10.632501],
        [152.684825, -10.660333],
        [152.753673, -10.708185],
        [152.808279, -10.632501]
    ],
    [
        [142.255382, -10.666681],
        [142.193207, -10.591485],
        [142.112315, -10.684340],
        [142.187022, -10.769627],
        [142.255382, -10.666681]
    ],
    [
        [151.074718, -10.605727],
        [150.934093, -10.599867],
        [150.924490, -10.680271],
        [151.046397, -10.669692],
        [151.074718, -10.605727]
    ],
    [
        [142.262218, -10.577813],
        [142.274425, -10.640802],
        [142.325206, -10.612400],
        [142.294281, -10.573175],
        [142.262218, -10.577813]
    ],
    [
        [150.875499, -10.536310],
        [150.790375, -10.539972],
        [150.793468, -10.639907],
        [150.891938, -10.647149],
        [150.875499, -10.536310]
    ],
    [
        [123.390147, -10.591485],
        [123.386485, -10.433038],
        [122.820974, -10.893243],
        [123.209158, -10.813084],
        [123.390147, -10.591485]
    ],
    [
        [-138.698801, -10.426446],
        [-138.685618, -10.542087],
        [-138.636952, -10.542169],
        [-138.636708, -10.440606],
        [-138.698801, -10.426446]
    ],
    [
        [121.940196, -10.430108],
        [121.879649, -10.428888],
        [121.690115, -10.564223],
        [121.881847, -10.598321],
        [121.940196, -10.430108]
    ],
    [
        [161.740977, -10.272556],
        [161.768809, -10.252211],
        [161.730642, -10.206720],
        [161.717296, -10.231378],
        [161.740977, -10.272556]
    ],
    [
        [162.374848, -10.823663],
        [162.113617, -10.456476],
        [161.300059, -10.207127],
        [161.792166, -10.734959],
        [162.374848, -10.823663]
    ],
    [
        [123.465831, -10.149835],
        [123.389415, -10.175226],
        [123.321788, -10.338962],
        [123.413422, -10.332615],
        [123.465831, -10.149835]
    ],
    [
        [142.293468, -10.138930],
        [142.214366, -10.153253],
        [142.221202, -10.242120],
        [142.334239, -10.200453],
        [142.293468, -10.138930]
    ],
    [
        [142.190115, -10.080987],
        [142.097016, -10.118585],
        [142.142914, -10.185642],
        [142.190115, -10.143731],
        [142.190115, -10.080987]
    ],
    [
        [-139.082387, -9.899509],
        [-139.144439, -9.940362],
        [-139.130767, -10.014907],
        [-139.047760, -9.922540],
        [-139.082387, -9.899509]
    ],
    [
        [167.173350, -9.886407],
        [167.165782, -9.868341],
        [167.170177, -9.859145],
        [167.195974, -9.885919],
        [167.173350, -9.886407]
    ],
    [
        [167.091807, -9.803318],
        [167.104503, -9.801853],
        [167.108246, -9.804620],
        [167.104015, -9.806573],
        [167.091807, -9.803318]
    ],
    [
        [151.177013, -9.954685],
        [151.089692, -10.027927],
        [150.763927, -9.702813],
        [150.958018, -10.104913],
        [151.232270, -10.200453],
        [151.300629, -9.967706],
        [151.177013, -9.954685]
    ],
    [
        [-138.836578, -9.741143],
        [-139.015370, -9.694431],
        [-139.173248, -9.774184],
        [-139.061920, -9.853936],
        [-138.836578, -9.741143]
    ],
    [
        [161.977794, -9.851007],
        [161.963552, -9.720636],
        [161.977794, -9.686619],
        [161.928477, -9.720147],
        [161.977794, -9.851007]
    ],
    [
        [161.394786, -9.412774],
        [161.400727, -9.670017],
        [161.558604, -9.788995],
        [161.545177, -9.604669],
        [161.394786, -9.412774]
    ],
    [
        [150.800955, -9.652439],
        [150.930919, -9.652439],
        [150.798350, -9.425714],
        [150.432140, -9.365330],
        [150.433604, -9.631280],
        [150.800955, -9.652439]
    ],
    [
        [-140.076731, -9.323419],
        [-140.158599, -9.371840],
        [-140.092844, -9.447524],
        [-140.027699, -9.343927],
        [-140.076731, -9.323419]
    ],
    [
        [160.826345, -9.837335],
        [160.366384, -9.412774],
        [159.609548, -9.309828],
        [159.835623, -9.793878],
        [160.644786, -9.937107],
        [160.826345, -9.837335]
    ],
    [
        [150.368907, -9.371840],
        [150.214529, -9.205824],
        [150.112804, -9.299412],
        [150.312266, -9.519464],
        [150.368907, -9.371840]
    ],
    [
        [159.828868, -9.172621],
        [159.844737, -9.145440],
        [159.832693, -9.103692],
        [159.804454, -9.130141],
        [159.828868, -9.172621]
    ],
    [
        [160.254080, -9.158949],
        [160.366384, -9.186212],
        [160.414236, -9.131606],
        [160.314952, -9.061700],
        [160.254080, -9.158949]
    ],
    [
        [159.195160, -9.056573],
        [159.178396, -9.092706],
        [159.174083, -9.138442],
        [159.236095, -9.023045],
        [159.195160, -9.056573]
    ],
    [
        [160.096690, -9.056573],
        [160.264496, -9.131606],
        [160.301443, -9.061619],
        [160.147716, -8.989679],
        [160.096690, -9.056573]
    ],
    [
        [159.167166, -9.017999],
        [159.092133, -8.994399],
        [159.039317, -9.068536],
        [159.147309, -9.103692],
        [159.167166, -9.017999]
    ],
    [
        [-157.940745, -8.980727],
        [-158.002878, -8.946710],
        [-158.008290, -8.952895],
        [-157.978627, -8.976007],
        [-157.940745, -8.980727]
    ],
    [
        [152.995469, -9.141299],
        [152.794171, -9.003497],
        [152.452304, -8.944990],
        [152.388623, -8.991155],
        [152.735896, -9.260400],
        [152.995469, -9.141299]
    ],
    [
        [160.079112, -9.023045],
        [160.113129, -8.994399],
        [160.092621, -8.940525],
        [160.074392, -8.951349],
        [160.079112, -9.023045]
    ],
    [
        [-139.514394, -8.883966],
        [-139.596913, -8.858005],
        [-139.616770, -8.954197],
        [-139.508412, -8.912042],
        [-139.514394, -8.883966]
    ],
    [
        [-140.049428, -8.823175],
        [-140.216705, -8.781020],
        [-140.261057, -8.823175],
        [-140.183217, -8.953709],
        [-140.049428, -8.823175]
    ],
    [
        [157.615489, -8.734470],
        [157.549653, -8.692153],
        [157.452403, -8.721856],
        [157.622325, -8.795831],
        [157.615489, -8.734470]
    ],
    [
        [158.228770, -8.774672],
        [158.230235, -8.737970],
        [158.208263, -8.679132],
        [158.153656, -8.796563],
        [158.228770, -8.774672]
    ],
    [
        [158.056895, -8.528253],
        [157.899750, -8.562433],
        [157.957042, -8.755955],
        [158.105724, -8.691095],
        [158.056895, -8.528253]
    ],
    [
        [179.191254, -8.542087],
        [179.217540, -8.520603],
        [179.199392, -8.460626],
        [179.204112, -8.518976],
        [179.191254, -8.542087]
    ],
    [
        [151.112559, -8.768650],
        [151.138357, -8.590590],
        [151.129242, -8.419122],
        [150.999034, -8.518162],
        [151.112559, -8.768650]
    ],
    [
        [143.608409, -8.638116],
        [143.474864, -8.525323],
        [143.178884, -8.419122],
        [143.628917, -8.730401],
        [143.608409, -8.638116]
    ],
    [
        [157.358653, -8.576755],
        [157.413829, -8.497979],
        [157.347504, -8.412530],
        [157.200938, -8.565851],
        [157.312266, -8.696222],
        [157.413829, -8.726983],
        [157.358653, -8.576755]
    ],
    [
        [159.688650, -8.507908],
        [159.635916, -8.384210],
        [159.558279, -8.389418],
        [159.549815, -8.470798],
        [159.688650, -8.507908]
    ],
    [
        [162.738617, -8.388360],
        [162.734874, -8.373793],
        [162.757579, -8.378513],
        [162.749848, -8.385186],
        [162.738617, -8.388360]
    ],
    [
        [143.379405, -8.425958],
        [143.530121, -8.485528],
        [143.610606, -8.475030],
        [143.573741, -8.373712],
        [143.379405, -8.425958]
    ],
    [
        [124.465831, -9.179376],
        [123.688813, -9.611423],
        [123.577403, -10.034356],
        [123.764659, -10.074965],
        [123.472016, -10.364923],
        [124.418468, -10.163832],
        [125.378754, -9.281020],
        [126.472423, -8.942804],
        [127.313243, -8.415216],
        [126.967052, -8.309015],
        [126.548839, -8.486749],
        [125.164317, -8.624770],
        [124.953787, -8.942641],
        [124.465831, -9.179376]
    ],
    [
        [161.360688, -9.617608],
        [161.284923, -9.186212],
        [160.946625, -8.813735],
        [160.996837, -8.603774],
        [160.601329, -8.325453],
        [160.867931, -9.152114],
        [161.360688, -9.617608]
    ],
    [
        [157.125173, -8.275079],
        [157.100841, -8.203546],
        [157.022634, -8.192804],
        [157.090587, -8.249119],
        [157.123546, -8.320408],
        [157.152517, -8.337172],
        [157.125173, -8.275079]
    ],
    [
        [123.927989, -8.227309],
        [123.641612, -8.223077],
        [123.589122, -8.373630],
        [123.414236, -8.267185],
        [123.485688, -8.350763],
        [123.227306, -8.526056],
        [123.583018, -8.565525],
        [123.927989, -8.227309]
    ],
    [
        [124.308116, -8.220473],
        [124.023285, -8.313409],
        [123.907237, -8.454848],
        [124.149587, -8.539321],
        [124.308116, -8.220473]
    ],
    [
        [138.897309, -8.337172],
        [138.785330, -8.158949],
        [138.548025, -8.347101],
        [138.894054, -8.405450],
        [138.897309, -8.337172]
    ],
    [
        [157.207693, -8.288751],
        [157.187266, -8.185724],
        [157.097830, -8.158949],
        [157.173025, -8.268813],
        [157.207693, -8.288751]
    ],
    [
        [125.569347, -8.196384],
        [125.503673, -8.270766],
        [125.573578, -8.317315],
        [125.650645, -8.142836],
        [125.569347, -8.196384]
    ],
    [
        [125.134044, -8.217055],
        [124.475271, -8.132582],
        [124.392426, -8.265232],
        [124.547618, -8.230727],
        [124.333507, -8.413018],
        [125.123302, -8.352309],
        [125.134044, -8.217055]
    ],
    [
        [128.090587, -8.131036],
        [127.832530, -8.098565],
        [127.761567, -8.117446],
        [128.025645, -8.261407],
        [128.090587, -8.131036]
    ],
    [
        [131.109386, -8.131036],
        [130.926443, -8.132501],
        [130.763357, -8.350763],
        [131.181651, -8.124933],
        [131.109386, -8.131036]
    ],
    [
        [156.810557, -8.055352],
        [156.785655, -8.086196],
        [156.841319, -8.112970],
        [156.824718, -8.069594],
        [156.810557, -8.055352]
    ],
    [
        [178.380544, -8.070001],
        [178.390636, -8.026544],
        [178.375499, -8.056085],
        [178.380544, -8.070001]
    ],
    [
        [157.797374, -8.562433],
        [157.838390, -8.337172],
        [157.441091, -7.979669],
        [157.228201, -8.316664],
        [157.549653, -8.261407],
        [157.797374, -8.562433]
    ],
    [
        [-140.692454, -8.015069],
        [-140.675649, -7.976739],
        [-140.638417, -7.959731],
        [-140.706370, -7.963067],
        [-140.692454, -8.015069]
    ],
    [
        [156.611176, -8.072686],
        [156.577159, -7.966567],
        [156.549815, -7.939223],
        [156.587413, -8.199395],
        [156.611176, -8.072686]
    ],
    [
        [157.104666, -8.124933],
        [157.200938, -8.000746],
        [157.091075, -7.850518],
        [156.947032, -7.979669],
        [157.104666, -8.124933]
    ],
    [
        [129.841156, -7.877862],
        [129.632498, -7.795994],
        [129.585216, -7.902032],
        [129.776378, -8.055352],
        [129.841156, -7.877862]
    ],
    [
        [156.807140, -7.720147],
        [156.611176, -7.569431],
        [156.504161, -7.630060],
        [156.659679, -7.939223],
        [156.807140, -7.720147]
    ],
    [
        [126.836762, -7.726332],
        [126.626964, -7.559991],
        [125.968923, -7.660089],
        [125.774181, -8.007582],
        [126.053966, -7.884698],
        [126.466156, -7.966567],
        [126.836762, -7.726332]
    ],
    [
        [127.470225, -7.527765],
        [127.372732, -7.506117],
        [127.357677, -7.655694],
        [127.481700, -7.590102],
        [127.470225, -7.527765]
    ],
    [
        [138.938975, -7.542087],
        [138.717052, -7.359552],
        [138.088634, -7.559828],
        [137.638194, -8.425877],
        [138.375987, -8.409601],
        [138.904145, -8.075860],
        [139.075531, -7.576267],
        [138.938975, -7.542087]
    ],
    [
        [155.570323, -7.322931],
        [155.542328, -7.322931],
        [155.507986, -7.375746],
        [155.597423, -7.382908],
        [155.570323, -7.322931]
    ],
    [
        [177.152599, -7.197361],
        [177.152354, -7.195082],
        [177.152599, -7.197361]
    ],
    [
        [131.698578, -7.226739],
        [131.568614, -7.130955],
        [131.241547, -7.487726],
        [131.116222, -8.000746],
        [131.316742, -8.017999],
        [131.633067, -7.620050],
        [131.698578, -7.226739]
    ],
    [
        [131.982188, -7.188897],
        [131.918468, -7.103611],
        [131.732188, -7.141209],
        [131.965587, -7.254653],
        [131.982188, -7.188897]
    ],
    [
        [128.669688, -7.137384],
        [128.619640, -7.063165],
        [128.528819, -7.130548],
        [128.638682, -7.219903],
        [128.669688, -7.137384]
    ],
    [
        [52.741873, -6.994317],
        [52.747244, -7.005060],
        [52.742198, -7.001723],
        [52.741873, -6.994317]
    ],
    [
        [155.816742, -7.020685],
        [155.734874, -6.966078],
        [155.672862, -7.089532],
        [155.850922, -7.099298],
        [155.816742, -7.020685]
    ],
    [
        [114.045665, -6.914646],
        [112.915294, -6.891697],
        [112.692638, -7.058526],
        [113.513425, -7.247782],
        [114.124801, -6.981610],
        [114.045665, -6.914646]
    ],
    [
        [156.118419, -6.918227],
        [156.063731, -6.859633],
        [156.076834, -6.815199],
        [156.046886, -6.851658],
        [156.087169, -6.901625],
        [156.042735, -6.980401],
        [156.118419, -6.918227]
    ],
    [
        [71.350352, -6.652520],
        [71.362071, -6.652927],
        [71.355235, -6.656345],
        [71.350352, -6.652520]
    ],
    [
        [105.264171, -6.527927],
        [105.188487, -6.547621],
        [105.120128, -6.630955],
        [105.203868, -6.673272],
        [105.264171, -6.527927]
    ],
    [
        [71.261404, -6.388604],
        [71.260997, -6.378025],
        [71.267345, -6.370050],
        [71.267589, -6.382745],
        [71.261404, -6.388604]
    ],
    [
        [176.314301, -6.302341],
        [176.319184, -6.289239],
        [176.322927, -6.288832],
        [176.322439, -6.295099],
        [176.314301, -6.302341]
    ],
    [
        [71.338390, -6.195896],
        [71.347016, -6.182224],
        [71.360525, -6.177341],
        [71.351085, -6.200291],
        [71.338390, -6.195896]
    ],
    [
        [134.484386, -6.575616],
        [134.457042, -6.445245],
        [134.102712, -6.180108],
        [134.209972, -6.507420],
        [134.110606, -6.459161],
        [134.073416, -6.826755],
        [134.310720, -6.859470],
        [134.484386, -6.575616]
    ],
    [
        [177.344086, -6.121026],
        [177.339854, -6.114516],
        [177.337169, -6.108168],
        [177.356619, -6.114516],
        [177.344086, -6.121026]
    ],
    [
        [55.382823, -5.853936],
        [55.381847, -5.865492],
        [55.380056, -5.869073],
        [55.379893, -5.864923],
        [55.382823, -5.853936]
    ],
    [
        [120.546153, -5.938165],
        [120.470470, -5.766860],
        [120.481293, -6.477309],
        [120.558604, -6.066339],
        [120.546153, -5.938165]
    ],
    [
        [104.832774, -5.760024],
        [104.786794, -5.742120],
        [104.770356, -5.752048],
        [104.838390, -5.820408],
        [104.832774, -5.760024]
    ],
    [
        [176.135265, -5.692804],
        [176.135265, -5.692804]
    ],
    [
        [-155.899322, -5.616795],
        [-155.933461, -5.609145],
        [-155.906443, -5.635349],
        [-155.859812, -5.625095],
        [-155.899322, -5.616795]
    ],
    [
        [132.802013, -5.787367],
        [132.697520, -5.597426],
        [132.619802, -5.602960],
        [132.691905, -5.928806],
        [132.802013, -5.787367]
    ],
    [
        [148.049164, -5.606134],
        [147.847179, -5.486423],
        [147.771332, -5.506931],
        [147.991059, -5.856215],
        [148.049164, -5.606134]
    ],
    [
        [71.773204, -5.440199],
        [71.764659, -5.433852],
        [71.762380, -5.431736],
        [71.771739, -5.433364],
        [71.773204, -5.440199]
    ],
    [
        [155.933442, -6.640802],
        [155.064952, -5.547784],
        [154.700206, -5.431085],
        [154.755870, -5.947849],
        [155.214854, -6.317071],
        [155.330089, -6.719659],
        [155.697032, -6.876642],
        [155.930186, -6.793634],
        [155.933442, -6.640802]
    ],
    [
        [134.758067, -6.157892],
        [134.601085, -5.951837],
        [134.736095, -5.969496],
        [134.758067, -5.671319],
        [134.508311, -5.429376],
        [134.351817, -5.714451],
        [134.201996, -5.712498],
        [134.378266, -5.793715],
        [134.276622, -6.119317],
        [134.607758, -6.369561],
        [134.758067, -6.157892]
    ],
    [
        [148.100352, -5.376560],
        [148.076345, -5.428643],
        [148.120860, -5.465265],
        [148.146495, -5.419610],
        [148.100352, -5.376560]
    ],
    [
        [72.221446, -5.327813],
        [72.230968, -5.319268],
        [72.228282, -5.324802],
        [72.221446, -5.327813]
    ],
    [
        [133.184337, -5.310317],
        [133.110118, -5.310968],
        [132.842296, -5.996840],
        [133.113292, -5.595636],
        [133.184337, -5.310317]
    ],
    [
        [147.606944, -5.287205],
        [147.562022, -5.307794],
        [147.600108, -5.362888],
        [147.647797, -5.321222],
        [147.606944, -5.287205]
    ],
    [
        [71.737071, -5.285252],
        [71.747081, -5.269952],
        [71.745453, -5.278741],
        [71.737071, -5.285252]
    ],
    [
        [71.760265, -5.236586],
        [71.768565, -5.234145],
        [71.766449, -5.239190],
        [71.760265, -5.236586]
    ],
    [
        [71.966156, -5.234796],
        [71.961681, -5.230076],
        [71.962738, -5.226983],
        [71.966482, -5.227472],
        [71.966156, -5.234796]
    ],
    [
        [147.209646, -5.269952],
        [147.112559, -5.191827],
        [147.005138, -5.319431],
        [147.161876, -5.444757],
        [147.209646, -5.269952]
    ],
    [
        [122.067393, -5.215020],
        [121.853852, -5.102146],
        [121.968272, -5.467950],
        [122.046886, -5.451593],
        [122.067393, -5.215020]
    ],
    [
        [154.727387, -5.211358],
        [154.624360, -5.013360],
        [154.631847, -5.459080],
        [154.688731, -5.427341],
        [154.727387, -5.211358]
    ],
    [
        [149.121918, -4.883071],
        [149.156098, -4.924005],
        [149.180431, -4.879164],
        [149.169200, -4.862481],
        [149.121918, -4.883071]
    ],
    [
        [146.202891, -4.824640],
        [146.232270, -4.853285],
        [146.263845, -4.835219],
        [146.243337, -4.787367],
        [146.202891, -4.824640]
    ],
    [
        [131.733084, -4.693048],
        [131.725108, -4.731703],
        [131.736501, -4.766290],
        [131.754405, -4.736505],
        [131.733084, -4.693048]
    ],
    [
        [149.519298, -4.643487],
        [149.454600, -4.692478],
        [149.560232, -4.717950],
        [149.561778, -4.672784],
        [149.519298, -4.643487]
    ],
    [
        [122.780040, -4.916599],
        [122.711111, -4.615492],
        [122.382660, -4.745864],
        [122.279633, -5.369724],
        [122.511485, -5.286716],
        [122.598399, -5.420099],
        [122.780040, -4.916599]
    ],
    [
        [145.996837, -4.534275],
        [145.880707, -4.649591],
        [145.939220, -4.760919],
        [146.055186, -4.659926],
        [145.996837, -4.534275]
    ],
    [
        [131.606212, -4.430434],
        [131.660899, -4.534275],
        [131.680431, -4.524021],
        [131.633474, -4.430434],
        [131.606212, -4.430434]
    ],
    [
        [123.149913, -5.225030],
        [122.949880, -5.190199],
        [123.052094, -4.740330],
        [123.219737, -4.816664],
        [123.041352, -4.384373],
        [122.854991, -4.609552],
        [122.814708, -5.211358],
        [122.567149, -5.506931],
        [122.638357, -5.662205],
        [122.827647, -5.676202],
        [123.149913, -5.225030]
    ],
    [
        [152.417979, -4.345310],
        [152.185720, -4.308526],
        [152.185069, -4.142511],
        [151.964692, -4.331231],
        [151.540294, -4.176690],
        [151.678966, -4.900160],
        [151.368907, -4.903497],
        [150.917003, -5.486423],
        [150.161306, -5.546645],
        [150.032074, -5.295180],
        [150.202403, -5.062107],
        [150.112559, -5.007745],
        [149.911469, -5.515069],
        [149.224376, -5.599298],
        [148.429942, -5.444757],
        [148.328949, -5.683770],
        [149.053071, -6.006524],
        [149.052908, -6.161716],
        [149.320567, -6.054864],
        [149.635427, -6.308201],
        [150.465099, -6.274021],
        [151.182791, -5.964288],
        [151.532563, -5.664727],
        [151.464122, -5.534275],
        [151.834239, -5.592950],
        [152.098888, -5.455743],
        [151.974376, -4.984145],
        [152.291840, -4.935479],
        [152.417979, -4.345310]
    ],
    [
        [133.558360, -4.232029],
        [133.456065, -4.202407],
        [133.324229, -4.108331],
        [133.388194, -4.204685],
        [133.627696, -4.300226],
        [133.558360, -4.232029]
    ],
    [
        [131.365977, -4.122166],
        [131.294607, -4.063165],
        [131.281505, -4.070001],
        [131.391856, -4.153497],
        [131.365977, -4.122166]
    ],
    [
        [145.078868, -4.047052],
        [145.027110, -4.058201],
        [145.038341, -4.122817],
        [145.100108, -4.116306],
        [145.078868, -4.047052]
    ],
    [
        [-155.011708, -4.047052],
        [-155.010813, -4.060642],
        [-154.953359, -4.094822],
        [-154.940297, -4.031996],
        [-155.011708, -4.047052]
    ],
    [
        [131.235037, -3.987563],
        [131.209158, -3.978936],
        [131.239594, -4.047052],
        [131.249848, -4.009698],
        [131.235037, -3.987563]
    ],
    [
        [123.204438, -3.992934],
        [122.950694, -4.047052],
        [123.044770, -4.209649],
        [123.196300, -4.187677],
        [123.204438, -3.992934]
    ],
    [
        [131.444835, -4.036716],
        [131.416026, -3.958591],
        [131.369640, -3.962172],
        [131.400645, -4.047052],
        [131.444835, -4.036716]
    ],
    [
        [128.796235, -3.642836],
        [128.746349, -3.659763],
        [128.761729, -3.699640],
        [128.810557, -3.676446],
        [128.796235, -3.642836]
    ],
    [
        [123.177257, -3.573989],
        [123.140636, -3.539158],
        [123.061046, -3.570896],
        [123.119884, -3.629164],
        [123.177257, -3.573989]
    ],
    [
        [128.528819, -3.532973],
        [128.427094, -3.522719],
        [128.392914, -3.642836],
        [128.563813, -3.591892],
        [128.528819, -3.532973]
    ],
    [
        [128.330821, -3.511895],
        [127.984141, -3.620538],
        [127.933442, -3.763442],
        [128.236501, -3.722263],
        [128.330821, -3.511895]
    ],
    [
        [128.720551, -3.525567],
        [128.672862, -3.539809],
        [128.561046, -3.493748],
        [128.636241, -3.622817],
        [128.720551, -3.525567]
    ],
    [
        [153.191742, -3.470961],
        [153.247081, -3.498956],
        [153.260102, -3.498956],
        [153.233409, -3.444268],
        [153.191742, -3.470961]
    ],
    [
        [153.301606, -3.368585],
        [153.267589, -3.403253],
        [153.343272, -3.416274],
        [153.342784, -3.378676],
        [153.301606, -3.368585]
    ],
    [
        [154.641971, -3.262332],
        [154.627763, -3.226888],
        [154.553180, -3.206315],
        [154.731779, -3.460814],
        [154.641971, -3.262332]
    ],
    [
        [127.240896, -3.470961],
        [126.840017, -3.073663],
        [126.090921, -3.112098],
        [125.991742, -3.248191],
        [126.203021, -3.630994],
        [126.696573, -3.863792],
        [127.205740, -3.659601],
        [127.240896, -3.470961]
    ],
    [
        [152.650645, -3.114679],
        [152.650645, -3.046482],
        [152.531557, -3.075272],
        [152.643809, -3.224542],
        [152.650645, -3.114679]
    ],
    [
        [150.992198, -2.957696],
        [150.882335, -2.903009],
        [150.769786, -2.979587],
        [151.026215, -2.970636],
        [150.992198, -2.957696]
    ],
    [
        [106.908946, -2.929783],
        [106.812511, -2.892185],
        [106.722667, -2.966078],
        [106.861176, -3.028985],
        [106.908946, -2.929783]
    ],
    [
        [152.071544, -2.916681],
        [152.023774, -2.896742],
        [151.971934, -2.847833],
        [152.025356, -2.996072],
        [152.071544, -2.916681]
    ],
    [
        [107.099232, -2.859058],
        [107.064626, -2.822524],
        [107.017076, -2.880206],
        [107.083751, -2.909845],
        [107.099232, -2.859058]
    ],
    [
        [107.395030, -2.868910],
        [107.410147, -2.947565],
        [107.504731, -2.854669],
        [107.484386, -2.820489],
        [107.395030, -2.868910]
    ],
    [
        [130.873220, -3.573989],
        [130.389334, -2.993829],
        [129.541026, -2.780043],
        [129.177094, -2.957696],
        [129.052908, -2.804457],
        [128.175466, -2.857029],
        [128.103689, -3.066990],
        [127.842296, -3.173272],
        [127.926036, -3.553481],
        [128.165782, -3.066990],
        [128.484141, -3.462498],
        [128.877452, -3.202569],
        [128.960785, -3.355564],
        [129.485606, -3.463474],
        [129.509613, -3.302504],
        [129.890473, -3.333103],
        [130.817882, -3.868829],
        [130.873220, -3.573989]
    ],
    [
        [-171.677805, -2.833185],
        [-171.625722, -2.868910],
        [-171.624460, -2.856134],
        [-171.629628, -2.827244],
        [-171.649851, -2.797296],
        [-171.715077, -2.759047],
        [-171.677805, -2.833185]
    ],
    [
        [152.013194, -2.806817],
        [152.009776, -2.744806],
        [151.913038, -2.705389],
        [151.915840, -2.844290],
        [152.013194, -2.806817]
    ],
    [
        [131.599376, -2.634861],
        [131.654633, -2.613214],
        [131.639903, -2.613702],
        [131.599376, -2.634861]
    ],
    [
        [176.786143, -2.608168],
        [176.827322, -2.656183],
        [176.850922, -2.654067],
        [176.813162, -2.614435],
        [176.786143, -2.608168]
    ],
    [
        [151.982432, -2.662774],
        [152.037364, -2.642348],
        [151.999522, -2.594496],
        [151.960297, -2.626723],
        [151.982432, -2.662774]
    ],
    [
        [153.137218, -4.269464],
        [152.052501, -3.246677],
        [150.812673, -2.555841],
        [150.892426, -2.697524],
        [150.759776, -2.768813],
        [152.288585, -3.569757],
        [152.687836, -4.163832],
        [152.689789, -4.547784],
        [152.897716, -4.848321],
        [153.137218, -4.269464]
    ],
    [
        [108.293712, -2.848403],
        [108.097911, -2.608168],
        [107.670258, -2.561456],
        [107.602794, -3.228858],
        [107.870453, -3.051690],
        [108.073985, -3.226007],
        [108.293712, -2.848403]
    ],
    [
        [175.981700, -2.505955],
        [175.976817, -2.497817],
        [175.973155, -2.489679],
        [175.993175, -2.510349],
        [175.981700, -2.505955]
    ],
    [
        [150.465099, -2.532485],
        [150.207856, -2.374770],
        [149.958751, -2.462986],
        [150.186778, -2.679457],
        [150.451345, -2.658380],
        [150.465099, -2.532485]
    ],
    [
        [134.581228, -2.416436],
        [134.581309, -2.307875],
        [134.566905, -2.292901],
        [134.521495, -2.406671],
        [134.581228, -2.416436]
    ],
    [
        [147.826671, -2.237563],
        [147.787120, -2.311700],
        [147.730479, -2.326430],
        [147.858165, -2.324477],
        [147.826671, -2.237563]
    ],
    [
        [134.385020, -2.003595],
        [134.333263, -2.083266],
        [134.359874, -2.153253],
        [134.426280, -2.039727],
        [134.385020, -2.003595]
    ],
    [
        [126.069102, -2.384454],
        [125.998790, -2.015232],
        [125.933360, -1.964532],
        [125.904552, -2.231378],
        [126.069102, -2.384454]
    ],
    [
        [147.432791, -1.983819],
        [146.657888, -1.963311],
        [146.520193, -2.149591],
        [147.205740, -2.186130],
        [147.432791, -1.983819]
    ],
    [
        [123.857432, -1.950372],
        [123.844737, -1.928643],
        [123.787364, -1.873956],
        [123.794200, -1.992120],
        [123.857432, -1.950372]
    ],
    [
        [175.591482, -1.874200],
        [175.559581, -1.826104],
        [175.552257, -1.819268],
        [175.586274, -1.922459],
        [175.591482, -1.874200]
    ],
    [
        [126.329112, -1.819268],
        [125.402110, -1.774672],
        [125.335297, -1.850681],
        [125.432140, -1.949640],
        [126.329112, -1.819268]
    ],
    [
        [123.132823, -1.765313],
        [123.094574, -1.755060],
        [123.072765, -1.901625],
        [123.152843, -1.823826],
        [123.132823, -1.765313]
    ],
    [
        [134.235850, -1.738539],
        [134.168956, -1.829848],
        [134.175141, -1.943455],
        [134.244802, -1.796075],
        [134.235850, -1.738539]
    ],
    [
        [130.386485, -1.888279],
        [130.342947, -1.676690],
        [129.714854, -1.881443],
        [130.126475, -2.066990],
        [130.436860, -1.976332],
        [130.386485, -1.888279]
    ],
    [
        [125.314789, -1.778985],
        [124.518077, -1.626235],
        [124.329112, -1.870782],
        [124.543224, -2.006524],
        [125.318370, -1.882582],
        [125.314789, -1.778985]
    ],
    [
        [136.848481, -1.765313],
        [136.191254, -1.653904],
        [135.422211, -1.610772],
        [136.266368, -1.909356],
        [136.848481, -1.765313]
    ],
    [
        [106.769054, -2.560317],
        [106.318858, -2.431329],
        [105.913748, -1.494236],
        [105.695567, -1.531915],
        [105.812755, -1.792657],
        [105.565766, -1.531915],
        [105.135916, -1.965509],
        [105.306407, -2.135024],
        [105.780447, -2.150811],
        [105.986501, -2.821222],
        [106.532237, -3.105645],
        [106.751964, -3.073663],
        [106.603770, -2.910252],
        [106.769054, -2.560317]
    ],
    [
        [135.285655, -1.476739],
        [135.109060, -1.473810],
        [135.096853, -1.508559],
        [135.275401, -1.522231],
        [135.333995, -1.484145],
        [135.285655, -1.476739]
    ],
    [
        [175.058767, -1.436293],
        [175.058279, -1.506768],
        [175.012543, -1.549249],
        [175.060557, -1.531671],
        [175.058767, -1.436293]
    ],
    [
        [149.735037, -1.473565],
        [149.618663, -1.353774],
        [149.539806, -1.425470],
        [149.792979, -1.580336],
        [149.735037, -1.473565]
    ],
    [
        [128.145193, -1.594008],
        [127.634288, -1.328709],
        [127.428396, -1.415134],
        [127.378673, -1.632257],
        [128.051524, -1.714532],
        [128.145193, -1.594008]
    ],
    [
        [176.409353, -1.332696],
        [176.395681, -1.319594],
        [176.464041, -1.436293],
        [176.444835, -1.373793],
        [176.409353, -1.332696]
    ],
    [
        [176.009288, -1.334242],
        [175.977306, -1.284845],
        [175.958018, -1.280206],
        [175.942149, -1.284845],
        [176.009288, -1.334242]
    ],
    [
        [127.689952, -1.213800],
        [127.547211, -1.171075],
        [127.460704, -1.235772],
        [127.666026, -1.271905],
        [127.689952, -1.213800]
    ],
    [
        [123.503103, -1.264418],
        [123.231944, -1.394708],
        [123.189464, -1.145278],
        [122.913829, -1.176365],
        [122.812022, -1.443617],
        [122.895844, -1.589532],
        [123.152354, -1.300551],
        [123.110688, -1.576918],
        [123.243337, -1.632420],
        [123.288585, -1.421563],
        [123.528575, -1.433038],
        [123.503103, -1.264418]
    ],
    [
        [129.954438, -1.162693],
        [129.858653, -1.142022],
        [129.743907, -1.199884],
        [129.859223, -1.233168],
        [129.954438, -1.162693]
    ],
    [
        [174.765147, -1.202895],
        [174.743988, -1.148370],
        [174.716645, -1.134698],
        [174.778819, -1.264418],
        [174.765147, -1.202895]
    ],
    [
        [134.998220, -1.018650],
        [134.877778, -0.936130],
        [134.800059, -1.027765],
        [134.925792, -1.135512],
        [134.998220, -1.018650]
    ],
    [
        [131.057384, -1.000665],
        [130.891856, -0.889907],
        [130.649750, -0.973810],
        [130.961925, -1.353774],
        [131.057384, -1.000665]
    ],
    [
        [130.917247, -0.778416],
        [130.478526, -0.799900],
        [130.400157, -0.929295],
        [130.819347, -0.870294],
        [130.917247, -0.778416]
    ],
    [
        [73.163097, -0.681817],
        [73.172537, -0.688572],
        [73.165863, -0.688409],
        [73.163097, -0.681817]
    ],
    [
        [73.204112, -0.671157],
        [73.196462, -0.681329],
        [73.191417, -0.682794],
        [73.195160, -0.674493],
        [73.204112, -0.671157]
    ],
    [
        [73.124278, -0.656183],
        [73.126964, -0.666274],
        [73.123871, -0.664727],
        [73.124278, -0.656183]
    ],
    [
        [174.476573, -0.709568],
        [174.483409, -0.819431],
        [174.498383, -0.789158],
        [174.476573, -0.709568]
    ],
    [
        [136.375662, -1.093683],
        [135.869314, -0.703790],
        [135.370372, -0.635919],
        [135.765391, -0.839288],
        [135.885020, -1.183038],
        [136.375662, -1.093683]
    ],
    [
        [73.240001, -0.625584],
        [73.227306, -0.642836],
        [73.229991, -0.623305],
        [73.240001, -0.625584]
    ],
    [
        [127.296153, -0.743748],
        [127.261241, -0.620212],
        [127.200857, -0.622817],
        [127.155528, -0.772393],
        [127.296153, -0.743748]
    ],
    [
        [174.438731, -0.627618],
        [174.393891, -0.592869],
        [174.380870, -0.592869],
        [174.438731, -0.627618]
    ],
    [
        [73.246755, -0.588637],
        [73.246755, -0.588637]
    ],
    [
        [166.938813, -0.490411],
        [166.906993, -0.524835],
        [166.938813, -0.551853],
        [166.958263, -0.517673],
        [166.938813, -0.490411]
    ],
    [
        [130.677582, -0.435805],
        [130.505056, -0.441339],
        [130.461681, -0.525160],
        [130.641124, -0.527520],
        [130.677582, -0.435805]
    ],
    [
        [121.853852, -0.401056],
        [121.752126, -0.401056],
        [121.642263, -0.545587],
        [121.894786, -0.507908],
        [121.853852, -0.401056]
    ],
    [
        [104.548513, -0.398045],
        [104.284028, -0.401056],
        [104.356293, -0.661716],
        [104.511241, -0.613946],
        [104.548513, -0.398045]
    ],
    [
        [122.029552, -0.332127],
        [121.926524, -0.312270],
        [121.860850, -0.377862],
        [122.026622, -0.406915],
        [122.029552, -0.332127]
    ],
    [
        [127.888927, -0.764744],
        [127.652680, -0.707208],
        [127.578624, -0.324965],
        [127.316661, -0.339614],
        [127.457693, -0.815606],
        [127.625743, -0.752374],
        [127.754893, -0.887628],
        [127.888927, -0.764744]
    ],
    [
        [73.435069, -0.283624],
        [73.443044, -0.292739],
        [73.444509, -0.304295],
        [73.435232, -0.293634],
        [73.435069, -0.283624]
    ],
    [
        [127.234630, -0.490411],
        [127.297130, -0.281915],
        [127.174815, -0.255548],
        [127.108572, -0.501072],
        [127.234630, -0.490411]
    ],
    [
        [103.712738, -0.269708],
        [103.557872, -0.223403],
        [103.461681, -0.366876],
        [103.756521, -0.346449],
        [103.712738, -0.269708]
    ],
    [
        [122.217621, -0.247166],
        [122.177094, -0.196384],
        [122.144379, -0.233005],
        [122.236501, -0.273370],
        [122.217621, -0.247166]
    ],
    [
        [122.369151, -0.263849],
        [122.327810, -0.230564],
        [122.225841, -0.199395],
        [122.375987, -0.346449],
        [122.369151, -0.263849]
    ],
    [
        [121.574555, -0.182550],
        [121.624522, -0.198419],
        [121.649669, -0.147393],
        [121.597423, -0.124688],
        [121.574555, -0.182550]
    ],
    [
        [131.297618, -0.237237],
        [130.824718, -0.003839],
        [130.217052, -0.200860],
        [130.523692, -0.257582],
        [130.547374, -0.436130],
        [130.688243, -0.291192],
        [130.756033, -0.445977],
        [130.948253, -0.366876],
        [130.750987, -0.287530],
        [130.625255, -0.084975],
        [130.979015, -0.360040],
        [131.252940, -0.384373],
        [131.297618, -0.237237]
    ],
    [
        [104.928966, -0.237237],
        [104.564626, 0.030341],
        [104.435557, -0.192153],
        [104.935232, -0.332127],
        [104.928966, -0.237237]
    ],
    [
        [129.536876, -0.134210],
        [129.309255, 0.048041],
        [129.293468, 0.047675],
        [129.540294, -0.216729],
        [129.536876, -0.134210]
    ],
    [
        [127.459972, -0.003839],
        [127.452485, 0.140204],
        [127.408865, 0.147040],
        [127.398611, 0.003079],
        [127.459972, -0.003839]
    ],
    [
        [104.497081, 0.071275],
        [104.428396, 0.163764],
        [104.413910, 0.175849],
        [104.411388, 0.091702],
        [104.497081, 0.071275]
    ],
    [
        [173.620616, 0.133368],
        [173.640798, 0.192125],
        [173.628673, 0.219143],
        [173.606212, 0.215969],
        [173.620616, 0.133368]
    ],
    [
        [73.095470, 0.228013],
        [73.104340, 0.219672],
        [73.102875, 0.213446],
        [73.098888, 0.216376],
        [73.095470, 0.228013]
    ],
    [
        [73.208995, 0.239976],
        [73.217459, 0.237738],
        [73.210948, 0.232164],
        [73.208995, 0.239976]
    ],
    [
        [104.688731, 0.071275],
        [104.548106, 0.224311],
        [104.490245, 0.242621],
        [104.702891, 0.032782],
        [104.688731, 0.071275]
    ],
    [
        [73.036794, 0.269924],
        [73.036794, 0.269680],
        [73.040375, 0.259345],
        [73.036143, 0.260932],
        [73.036794, 0.269924]
    ],
    [
        [73.379161, 0.285224],
        [73.379080, 0.285183],
        [73.369640, 0.280015],
        [73.371104, 0.285956],
        [73.379161, 0.285224]
    ],
    [
        [72.983653, 0.305243],
        [72.988129, 0.301907],
        [72.986013, 0.299547],
        [72.981212, 0.302069],
        [72.983653, 0.305243]
    ],
    [
        [104.405528, 0.338813],
        [104.358165, 0.368883],
        [104.339366, 0.365465],
        [104.405121, 0.292141],
        [104.405528, 0.338813]
    ],
    [
        [127.398692, 0.379584],
        [127.337087, 0.348782],
        [127.358165, 0.283515],
        [127.417166, 0.312934],
        [127.398692, 0.379584]
    ],
    [
        [73.513438, 0.387763],
        [73.513357, 0.387681],
        [73.508556, 0.380561],
        [73.506602, 0.387763],
        [73.513438, 0.387763]
    ],
    [
        [72.958344, 0.403306],
        [72.958425, 0.403144],
        [72.961192, 0.394029],
        [72.957774, 0.396796],
        [72.958344, 0.403306]
    ],
    [
        [173.832286, 0.448676],
        [173.804942, 0.434394],
        [173.921641, 0.379788],
        [173.917247, 0.399482],
        [173.832286, 0.448676]
    ],
    [
        [72.940929, 0.496324],
        [72.940929, 0.496283],
        [72.940603, 0.487291],
        [72.937022, 0.493638],
        [72.940929, 0.496324]
    ],
    [
        [73.491954, 0.508002],
        [73.492035, 0.507799],
        [73.494640, 0.498969],
        [73.489757, 0.502590],
        [73.491954, 0.508002]
    ],
    [
        [73.387869, 0.641750],
        [73.386729, 0.635403],
        [73.384776, 0.635565],
        [73.383556, 0.638902],
        [73.387869, 0.641750]
    ],
    [
        [104.215831, 0.708157],
        [104.266449, 0.633002],
        [104.277354, 0.626166],
        [104.270518, 0.675035],
        [104.215831, 0.708157]
    ],
    [
        [127.378673, 0.623033],
        [127.446300, 0.667182],
        [127.418468, 0.757148],
        [127.384939, 0.757148],
        [127.378673, 0.623033]
    ],
    [
        [73.373057, 0.763088],
        [73.371837, 0.756578],
        [73.369965, 0.757025],
        [73.368826, 0.760443],
        [73.373057, 0.763088]
    ],
    [
        [104.284028, 0.708157],
        [104.272960, 0.796536],
        [104.195811, 0.779975],
        [104.205577, 0.726060],
        [104.284028, 0.708157]
    ],
    [
        [172.987153, 0.832343],
        [172.983409, 0.831285],
        [172.990001, 0.825426],
        [172.990245, 0.833970],
        [172.987153, 0.832343]
    ],
    [
        [172.977794, 0.836330],
        [172.975759, 0.839667],
        [172.969412, 0.839667],
        [172.982432, 0.831163],
        [172.977794, 0.836330]
    ],
    [
        [73.353852, 0.847724],
        [73.352875, 0.841539],
        [73.351085, 0.840644],
        [73.349783, 0.844062],
        [73.353852, 0.847724]
    ],
    [
        [127.371104, 0.784491],
        [127.363455, 0.840969],
        [127.288829, 0.836900],
        [127.312836, 0.757148],
        [127.371104, 0.784491]
    ],
    [
        [104.226085, 0.880072],
        [104.172130, 0.883490],
        [104.099132, 0.948920],
        [104.176443, 0.798489],
        [104.226085, 0.880072]
    ],
    [
        [173.075938, 0.965888],
        [173.003673, 1.024075],
        [172.990001, 1.024075],
        [172.990977, 0.834418],
        [173.075938, 0.965888]
    ],
    [
        [97.928477, 0.996080],
        [97.416759, 1.519232],
        [97.063650, 1.415229],
        [97.704112, 0.572740],
        [97.874278, 0.622016],
        [97.928477, 0.996080]
    ],
    [
        [125.295095, 1.551663],
        [125.174653, 1.415473],
        [125.185313, 1.390692],
        [125.267100, 1.413804],
        [125.295095, 1.551663]
    ],
    [
        [172.983165, 1.531195],
        [172.962901, 1.620592],
        [172.948985, 1.627346],
        [172.969412, 1.537991],
        [172.983165, 1.531195]
    ],
    [
        [173.036143, 1.777167],
        [173.027354, 1.810452],
        [172.993175, 1.712063],
        [173.029307, 1.716295],
        [173.036143, 1.777167]
    ],
    [
        [172.980317, 1.882025],
        [172.969412, 1.907050],
        [172.980317, 1.882025]
    ],
    [
        [-157.190989, 1.763902],
        [-157.310129, 1.973090],
        [-157.423818, 2.020453],
        [-157.428538, 1.838568],
        [-157.246409, 1.713324],
        [-157.190989, 1.763902]
    ],
    [
        [127.666026, -0.209242],
        [127.715587, 0.312567],
        [127.526866, 0.560614],
        [127.624522, 0.832221],
        [127.398611, 1.209052],
        [127.629731, 1.835395],
        [128.047374, 2.203843],
        [127.846446, 1.851467],
        [128.014903, 1.719224],
        [128.014903, 1.305243],
        [127.627615, 0.937405],
        [127.851736, 0.811754],
        [128.179454, 1.154446],
        [128.204600, 1.389960],
        [128.719493, 1.570624],
        [128.701182, 1.070868],
        [128.213552, 0.773912],
        [128.680837, 0.554511],
        [128.690115, 0.346991],
        [128.824229, 0.310858],
        [128.899587, 0.207790],
        [127.910492, 0.437690],
        [127.980724, -0.263849],
        [128.440684, -0.908787],
        [128.032237, -0.699314],
        [127.666026, -0.209242]
    ],
    [
        [125.432140, 2.387681],
        [125.369477, 2.374091],
        [125.392345, 2.325670],
        [125.452647, 2.333075],
        [125.432140, 2.387681]
    ],
    [
        [128.686371, 2.483954],
        [128.566417, 2.633612],
        [128.321137, 2.458645],
        [128.197113, 2.266181],
        [128.269054, 1.995347],
        [128.566661, 2.109931],
        [128.686371, 2.483954]
    ],
    [
        [125.443614, 2.793036],
        [125.360118, 2.753323],
        [125.392589, 2.628892],
        [125.421072, 2.633938],
        [125.443614, 2.793036]
    ],
    [
        [172.750336, 3.031968],
        [172.770274, 3.011461],
        [172.771495, 3.023871],
        [172.750336, 3.031968]
    ],
    [
        [172.962087, 3.141832],
        [172.944184, 3.127387],
        [172.969412, 3.128160],
        [172.962087, 3.141832]
    ],
    [
        [72.831391, 3.510565],
        [72.835134, 3.505439],
        [72.831065, 3.503567],
        [72.827973, 3.505439],
        [72.831391, 3.510565]
    ],
    [
        [72.793712, 3.516913],
        [72.795177, 3.514635],
        [72.798839, 3.511949],
        [72.791189, 3.510891],
        [72.793712, 3.516913]
    ],
    [
        [72.928396, 3.551907],
        [72.911794, 3.541734],
        [72.911632, 3.541653],
        [72.919932, 3.552151],
        [72.928396, 3.551907]
    ],
    [
        [72.941905, 3.618842],
        [72.945567, 3.613715],
        [72.941580, 3.611884],
        [72.938487, 3.613715],
        [72.941905, 3.618842]
    ],
    [
        [72.692556, 3.726955],
        [72.697439, 3.718817],
        [72.694591, 3.714993],
        [72.689708, 3.717963],
        [72.692556, 3.726955]
    ],
    [
        [125.652517, 3.469631],
        [125.534516, 3.683051],
        [125.442068, 3.736558],
        [125.507335, 3.463324],
        [125.652517, 3.469631]
    ],
    [
        [126.743993, 3.853385],
        [126.811530, 3.731862],
        [126.856057, 3.758195],
        [126.811588, 3.823866],
        [126.743993, 3.853385]
    ],
    [
        [-159.284535, 3.874823],
        [-159.376820, 3.933295],
        [-159.410024, 3.862047],
        [-159.308705, 3.784654],
        [-159.284535, 3.874823]
    ],
    [
        [73.477306, 3.942125],
        [73.469981, 3.935126],
        [73.467540, 3.933661],
        [73.469249, 3.936957],
        [73.477306, 3.942125]
    ],
    [
        [72.703136, 4.003323],
        [72.706716, 3.997952],
        [72.704600, 3.996405],
        [72.699067, 3.999457],
        [72.703136, 4.003323]
    ],
    [
        [126.656547, 3.981478],
        [126.615108, 4.043915],
        [126.696089, 3.812256],
        [126.712629, 3.920714],
        [126.656547, 3.981478]
    ],
    [
        [73.508149, 4.103583],
        [73.508311, 4.093411],
        [73.508311, 4.093329],
        [73.502289, 4.100775],
        [73.508149, 4.103583]
    ],
    [
        [72.970470, 4.265937],
        [72.975597, 4.262356],
        [72.975759, 4.260403],
        [72.972504, 4.260403],
        [72.970470, 4.265937]
    ],
    [
        [73.702810, 4.434719],
        [73.700857, 4.432278],
        [73.697439, 4.431383],
        [73.702810, 4.434719]
    ],
    [
        [73.702810, 4.453030],
        [73.699962, 4.451646],
        [73.699880, 4.449164],
        [73.702647, 4.452908],
        [73.702810, 4.453030]
    ],
    [
        [73.376720, 4.474433],
        [73.377289, 4.465277],
        [73.373871, 4.466986],
        [73.376720, 4.474433]
    ],
    [
        [126.870709, 4.331393],
        [126.744395, 4.545600],
        [126.676420, 4.004483],
        [126.798438, 4.017644],
        [126.870709, 4.331393]
    ],
    [
        [168.685395, 4.573798],
        [168.741384, 4.585842],
        [168.735037, 4.590522],
        [168.685395, 4.573798]
    ],
    [
        [73.404959, 4.634996],
        [73.405284, 4.628404],
        [73.403005, 4.627427],
        [73.401215, 4.629828],
        [73.404959, 4.634996]
    ],
    [
        [73.490489, 4.723375],
        [73.490733, 4.716742],
        [73.488455, 4.715969],
        [73.486664, 4.718207],
        [73.490489, 4.723375]
    ],
    [
        [72.979340, 4.895453],
        [72.979340, 4.895372],
        [72.969493, 4.880520],
        [72.972667, 4.894355],
        [72.979340, 4.895453]
    ],
    [
        [72.917491, 4.898586],
        [72.920909, 4.897854],
        [72.922862, 4.899075],
        [72.917491, 4.898586]
    ],
    [
        [73.447276, 4.971340],
        [73.436534, 4.969875],
        [73.441173, 4.974921],
        [73.447276, 4.971340]
    ],
    [
        [72.912852, 5.034084],
        [72.910167, 5.032701],
        [72.909190, 5.030585],
        [72.909434, 5.030788],
        [72.912852, 5.034084]
    ],
    [
        [72.927745, 5.036526],
        [72.927094, 5.033922],
        [72.924327, 5.033026],
        [72.927745, 5.036526]
    ],
    [
        [73.044770, 5.121812],
        [73.043468, 5.118842],
        [73.041270, 5.118394],
        [73.044770, 5.121812]
    ],
    [
        [73.049083, 5.133287],
        [73.051443, 5.126654],
        [73.047618, 5.126370],
        [73.045258, 5.128892],
        [73.049083, 5.133287]
    ],
    [
        [73.091319, 5.161363],
        [73.090994, 5.158515],
        [73.087738, 5.157945],
        [73.091319, 5.161363]
    ],
    [
        [73.103852, 5.173041],
        [73.107107, 5.170966],
        [73.110525, 5.170315],
        [73.104177, 5.172919],
        [73.103852, 5.173041]
    ],
    [
        [72.860118, 5.237942],
        [72.859223, 5.235500],
        [72.856619, 5.234442],
        [72.860118, 5.237942]
    ],
    [
        [73.131847, 5.244574],
        [73.131847, 5.242499],
        [73.128429, 5.241156],
        [73.131847, 5.244574]
    ],
    [
        [73.499766, 5.246894],
        [73.497244, 5.245022],
        [73.493826, 5.245998],
        [73.499766, 5.246894]
    ],
    [
        [73.593598, 5.282701],
        [73.582856, 5.275580],
        [73.569998, 5.276760],
        [73.582042, 5.281806],
        [73.593598, 5.282701]
    ],
    [
        [73.112804, 5.298570],
        [73.109223, 5.296698],
        [73.109223, 5.295152],
        [73.112641, 5.298448],
        [73.112804, 5.298570]
    ],
    [
        [73.470225, 5.307766],
        [73.467052, 5.308336],
        [73.464203, 5.306830],
        [73.470144, 5.307725],
        [73.470225, 5.307766]
    ],
    [
        [73.629568, 5.332831],
        [73.627208, 5.331122],
        [73.623302, 5.331855],
        [73.629568, 5.332831]
    ],
    [
        [73.646658, 5.343248],
        [73.643403, 5.343940],
        [73.639903, 5.342190],
        [73.646495, 5.343248],
        [73.646658, 5.343248]
    ],
    [
        [120.251964, 5.266506],
        [120.187836, 5.345120],
        [119.819347, 5.059801],
        [120.120942, 5.218004],
        [120.216563, 5.114976],
        [120.251964, 5.266506]
    ],
    [
        [72.953136, 5.352769],
        [72.952403, 5.350084],
        [72.949555, 5.349311],
        [72.953136, 5.352769]
    ],
    [
        [73.397472, 5.362209],
        [73.398692, 5.359605],
        [73.401215, 5.356147],
        [73.396169, 5.357123],
        [73.397472, 5.362209]
    ],
    [
        [73.323253, 5.368232],
        [73.324880, 5.366767],
        [73.330089, 5.366848],
        [73.319184, 5.362942],
        [73.323253, 5.368232]
    ],
    [
        [163.026052, 5.340888],
        [162.990733, 5.374823],
        [162.916189, 5.286933],
        [163.019216, 5.272691],
        [163.026052, 5.340888]
    ],
    [
        [73.350759, 5.427680],
        [73.347504, 5.428778],
        [73.344574, 5.426744],
        [73.344900, 5.426825],
        [73.350759, 5.427680]
    ],
    [
        [73.537446, 5.451402],
        [73.534923, 5.449856],
        [73.531261, 5.450426],
        [73.537446, 5.451402]
    ],
    [
        [73.362966, 5.463080],
        [73.363129, 5.459377],
        [73.360688, 5.457831],
        [73.362966, 5.463080]
    ],
    [
        [72.943126, 5.467597],
        [72.940278, 5.462144],
        [72.938243, 5.461493],
        [72.937022, 5.465562],
        [72.943126, 5.467597]
    ],
    [
        [73.015880, 5.492865],
        [73.013031, 5.487454],
        [73.010997, 5.486802],
        [73.009776, 5.490912],
        [73.015880, 5.492865]
    ],
    [
        [73.462413, 5.543606],
        [73.459321, 5.541734],
        [73.456309, 5.542670],
        [73.462413, 5.543606]
    ],
    [
        [73.005626, 5.713324],
        [73.002289, 5.707099],
        [72.999766, 5.706977],
        [72.998790, 5.711982],
        [73.005626, 5.713324]
    ],
    [
        [169.590343, 5.800930],
        [169.615245, 5.798774],
        [169.734548, 6.013129],
        [169.655528, 5.942857],
        [169.590343, 5.800930]
    ],
    [
        [172.029796, 6.054145],
        [171.962413, 6.051825],
        [171.948416, 6.067776],
        [171.966482, 6.061998],
        [172.029796, 6.054145]
    ],
    [
        [72.949392, 6.349799],
        [72.953949, 6.345608],
        [72.953136, 6.343492],
        [72.948497, 6.344428],
        [72.949392, 6.349799]
    ],
    [
        [120.588145, 6.380764],
        [120.492035, 6.267401],
        [120.494640, 6.249335],
        [120.577322, 6.251532],
        [120.588145, 6.380764]
    ],
    [
        [72.892589, 6.452094],
        [72.897227, 6.447903],
        [72.896332, 6.445787],
        [72.890880, 6.448228],
        [72.892589, 6.452094]
    ],
    [
        [122.296723, 6.633246],
        [122.066661, 6.740709],
        [121.806814, 6.619289],
        [121.962250, 6.404853],
        [122.296723, 6.633246]
    ],
    [
        [158.290782, 6.937974],
        [158.132498, 6.941352],
        [158.180186, 6.802476],
        [158.313813, 6.808661],
        [158.290782, 6.937974]
    ],
    [
        [118.537608, 7.006293],
        [118.510265, 7.047187],
        [118.427257, 7.018215],
        [118.503103, 6.971422],
        [118.537608, 7.006293]
    ],
    [
        [171.756684, 6.972113],
        [171.613943, 7.006090],
        [171.592621, 7.015286],
        [171.577322, 7.047187],
        [171.756684, 6.972113]
    ],
    [
        [171.393565, 7.109931],
        [171.235199, 7.067694],
        [171.202159, 7.072455],
        [171.060883, 7.135403],
        [171.035655, 7.155097],
        [171.393565, 7.109931]
    ],
    [
        [168.757823, 7.307929],
        [168.679210, 7.335191],
        [168.675059, 7.320868],
        [168.791515, 7.293402],
        [168.830089, 7.307929],
        [168.757823, 7.307929]
    ],
    [
        [151.588634, 7.383612],
        [151.568126, 7.342678],
        [151.644542, 7.336086],
        [151.636404, 7.387112],
        [151.588634, 7.383612]
    ],
    [
        [168.576834, 7.404120],
        [168.572520, 7.417792],
        [168.562511, 7.464342],
        [168.555186, 7.430325],
        [168.576834, 7.404120]
    ],
    [
        [151.876720, 7.458726],
        [151.856212, 7.424628],
        [151.917654, 7.458726],
        [151.883800, 7.463568],
        [151.876720, 7.458726]
    ],
    [
        [117.084972, 8.057847],
        [116.961681, 8.061998],
        [117.009939, 7.800279],
        [117.086762, 7.872138],
        [117.084972, 8.057847]
    ],
    [
        [117.030528, 8.068264],
        [117.068126, 8.086249],
        [117.045421, 8.135810],
        [116.995860, 8.103013],
        [117.030528, 8.068264]
    ],
    [
        [117.167735, 8.178127],
        [117.161794, 8.156724],
        [117.205740, 8.155504],
        [117.189708, 8.176744],
        [117.167735, 8.178127]
    ],
    [
        [117.325450, 8.322740],
        [117.279633, 8.311103],
        [117.289724, 8.184312],
        [117.359548, 8.219062],
        [117.325450, 8.322740]
    ],
    [
        [117.242849, 8.315253],
        [117.242849, 8.343207],
        [117.190115, 8.262030],
        [117.263927, 8.301011],
        [117.242849, 8.315253]
    ],
    [
        [124.784190, 9.199774],
        [124.708507, 9.250190],
        [124.636485, 9.182359],
        [124.770193, 9.077379],
        [124.784190, 9.199774]
    ],
    [
        [123.698009, 9.165025],
        [123.642100, 9.293647],
        [123.471202, 9.185452],
        [123.632335, 9.098334],
        [123.698009, 9.165025]
    ],
    [
        [126.165863, 9.829169],
        [126.110606, 9.857082],
        [126.071462, 10.059068],
        [125.965994, 9.850246],
        [126.165863, 9.829169]
    ],
    [
        [124.565278, 9.870754],
        [124.577647, 10.033922],
        [124.222667, 10.151923],
        [123.801036, 9.757758],
        [124.294200, 9.606757],
        [124.596202, 9.737291],
        [124.565278, 9.870754]
    ],
    [
        [125.719574, 9.911689],
        [125.684825, 10.399888],
        [125.637706, 10.460395],
        [125.495291, 10.108710],
        [125.719574, 9.911689]
    ],
    [
        [119.950206, 10.603746],
        [119.837901, 10.637519],
        [119.788585, 10.456977],
        [119.984141, 10.531317],
        [119.950206, 10.603746]
    ],
    [
        [122.711111, 10.734687],
        [122.536632, 10.607489],
        [122.536632, 10.419420],
        [122.686860, 10.506008],
        [122.711111, 10.734687]
    ],
    [
        [123.574474, 10.830959],
        [123.259776, 10.994818],
        [122.993826, 10.906724],
        [122.814708, 10.515041],
        [122.872813, 10.100409],
        [122.395193, 9.842841],
        [123.033214, 9.035305],
        [123.317638, 9.256903],
        [123.135509, 9.552680],
        [123.156749, 9.867621],
        [123.574474, 10.830959]
    ],
    [
        [166.904145, 11.172919],
        [166.871837, 11.162299],
        [166.835785, 11.159247],
        [166.875255, 11.144965],
        [166.904145, 11.172919]
    ],
    [
        [124.047374, 10.834052],
        [124.045665, 11.277167],
        [123.387055, 9.973782],
        [123.327647, 9.408149],
        [123.652599, 10.063625],
        [124.014903, 10.372463],
        [124.047374, 10.834052]
    ],
    [
        [123.801036, 11.179145],
        [123.760916, 11.278876],
        [123.745779, 11.292467],
        [123.733653, 11.154283],
        [123.801036, 11.179145]
    ],
    [
        [119.671886, 10.552558],
        [119.504568, 10.884955],
        [119.501964, 11.423326],
        [119.319998, 11.000881],
        [119.467540, 10.732652],
        [119.291677, 10.932685],
        [119.222504, 10.941718],
        [119.278087, 10.508205],
        [119.001964, 10.397528],
        [118.133556, 9.343166],
        [117.655528, 9.057929],
        [117.190766, 8.338324],
        [118.365001, 9.193061],
        [118.756358, 9.667670],
        [118.774181, 9.934149],
        [119.196300, 10.056342],
        [119.671886, 10.552558]
    ],
    [
        [119.867198, 11.515570],
        [119.832856, 11.460354],
        [119.716156, 11.460354],
        [119.832856, 11.378363],
        [119.867198, 11.515570]
    ],
    [
        [125.273936, 10.323188],
        [125.013845, 10.754584],
        [124.976329, 11.392035],
        [124.629893, 11.304429],
        [124.300629, 11.542873],
        [124.396007, 10.934068],
        [124.622325, 11.002021],
        [124.778819, 10.821438],
        [124.780447, 10.151923],
        [125.031749, 10.020250],
        [124.990977, 10.381334],
        [125.151052, 10.185452],
        [125.273936, 10.323188]
    ],
    [
        [123.170421, 11.480780],
        [123.163585, 11.598090],
        [122.900727, 11.437934],
        [122.830333, 11.605292],
        [122.622325, 11.508734],
        [121.896821, 11.893785],
        [121.853852, 11.769436],
        [122.107188, 11.657945],
        [121.949718, 10.433173],
        [122.744802, 10.795640],
        [123.131358, 11.182685],
        [123.170421, 11.480780]
    ],
    [
        [120.024750, 11.892971],
        [119.854015, 11.954413],
        [119.966970, 11.664374],
        [120.079926, 11.789252],
        [120.024750, 11.892971]
    ],
    [
        [120.347504, 12.029486],
        [120.229747, 12.218655],
        [120.196056, 12.112006],
        [119.885020, 12.322699],
        [120.001150, 12.011176],
        [120.347504, 12.029486]
    ],
    [
        [122.687511, 12.402818],
        [122.632091, 12.484524],
        [122.423025, 12.462877],
        [122.611827, 12.276516],
        [122.687511, 12.402818]
    ],
    [
        [125.712738, 11.148749],
        [125.555024, 11.211859],
        [125.637706, 11.368476],
        [125.466319, 11.611762],
        [125.538259, 12.183498],
        [125.272146, 12.499010],
        [124.283458, 12.570624],
        [124.493175, 12.097805],
        [125.043712, 11.757758],
        [124.828298, 11.508734],
        [125.000987, 11.289781],
        [125.246837, 11.092190],
        [125.651541, 11.149400],
        [125.760509, 11.022773],
        [125.712738, 11.148749]
    ],
    [
        [124.054942, 11.799791],
        [123.889659, 12.207668],
        [123.234711, 12.592760],
        [123.294607, 12.217231],
        [123.159679, 11.917792],
        [123.485362, 12.218085],
        [124.054942, 11.799791]
    ],
    [
        [122.279633, 12.605455],
        [122.245616, 12.570746],
        [122.279633, 12.474514],
        [122.311290, 12.536689],
        [122.279633, 12.605455]
    ],
    [
        [122.115245, 12.666327],
        [121.924083, 12.339342],
        [122.012218, 12.104560],
        [122.156261, 12.632148],
        [122.115245, 12.666327]
    ],
    [
        [123.787364, 12.375556],
        [123.732677, 12.591254],
        [123.609223, 12.687445],
        [123.583181, 12.623928],
        [123.787364, 12.375556]
    ],
    [
        [123.280284, 12.864936],
        [123.039806, 13.128079],
        [122.944509, 13.111314],
        [123.375824, 12.693590],
        [123.280284, 12.864936]
    ],
    [
        [121.526134, 12.704495],
        [121.552989, 13.111314],
        [121.197113, 13.440904],
        [120.321544, 13.487779],
        [120.664887, 13.155911],
        [121.113617, 12.251288],
        [121.395763, 12.289537],
        [121.526134, 12.704495]
    ],
    [
        [122.101573, 13.416693],
        [121.858653, 13.565497],
        [121.813731, 13.352240],
        [122.008800, 13.204779],
        [122.101573, 13.416693]
    ],
    [
        [120.260916, 13.711575],
        [120.237641, 13.804633],
        [120.085704, 13.860785],
        [120.108246, 13.776842],
        [120.260916, 13.711575]
    ],
    [
        [124.417979, 13.872952],
        [124.136892, 14.078355],
        [124.047374, 13.606024],
        [124.334727, 13.557603],
        [124.417979, 13.872952]
    ],
    [
        [122.104747, 14.102607],
        [121.964041, 14.226142],
        [121.926606, 14.221259],
        [122.177013, 14.007066],
        [122.104747, 14.102607]
    ],
    [
        [122.235362, 14.797756],
        [122.203868, 14.838772],
        [122.105724, 14.843940],
        [122.242198, 14.736314],
        [122.235362, 14.797756]
    ],
    [
        [122.005382, 15.010688],
        [121.826427, 15.012152],
        [121.940196, 14.640082],
        [122.023692, 14.722602],
        [122.005382, 15.010688]
    ],
    [
        [121.388438, 18.902981],
        [121.280040, 18.880561],
        [121.279145, 18.862006],
        [121.477794, 18.881903],
        [121.388438, 18.902981]
    ],
    [
        [121.971202, 18.984931],
        [121.892589, 18.996487],
        [121.834158, 18.834296],
        [121.989106, 18.949123],
        [121.971202, 18.984931]
    ],
    [
        [121.210948, 19.176703],
        [121.190278, 19.087348],
        [121.244965, 19.018459],
        [121.252208, 19.081285],
        [121.210948, 19.176703]
    ],
    [
        [121.526134, 19.320705],
        [121.516612, 19.393541],
        [121.350841, 19.375922],
        [121.498302, 19.259263],
        [121.526134, 19.320705]
    ],
    [
        [121.977306, 19.577379],
        [121.900238, 19.559231],
        [121.898204, 19.536770],
        [121.978038, 19.498847],
        [121.977306, 19.577379]
    ],
    [
        [121.841645, 20.346015],
        [121.850841, 20.273424],
        [121.869314, 20.276190],
        [121.893240, 20.313666],
        [121.841645, 20.346015]
    ],
    [
        [122.009776, 20.488471],
        [121.965994, 20.460639],
        [121.922130, 20.354153],
        [121.971202, 20.368476],
        [122.009776, 20.488471]
    ],
    [
        [121.877208, 20.770331],
        [121.855805, 20.838324],
        [121.786388, 20.703070],
        [121.829845, 20.698961],
        [121.877208, 20.770331]
    ],
    [
        [140.869965, 27.218248],
        [140.867931, 27.233954],
        [140.874197, 27.238227],
        [140.878184, 27.232611],
        [140.869965, 27.218248]
    ],
    [
        [53.029959, 39.061347],
        [53.086599, 39.091295],
        [53.102061, 38.755072],
        [53.040212, 38.906684],
        [53.029959, 39.061347]
    ],
    [
        [53.468516, 39.584947],
        [53.512950, 39.591213],
        [53.534434, 39.527655],
        [53.491873, 39.508612],
        [53.468516, 39.584947]
    ],
    [
        [50.618907, 40.299994],
        [50.572765, 40.310045],
        [50.565278, 40.337836],
        [50.606944, 40.337836],
        [50.618907, 40.299994]
    ],
    [
        [50.388438, 40.401679],
        [50.353689, 40.399888],
        [50.326427, 40.481879],
        [50.360525, 40.474433],
        [50.388438, 40.401679]
    ],
    [
        [50.170258, 44.830146],
        [50.079356, 44.833482],
        [49.986095, 44.946763],
        [50.052013, 45.065619],
        [50.170258, 44.830146]
    ],
    [
        [-79.841379, 53.145738],
        [-79.916575, 53.170315],
        [-79.929840, 53.094387],
        [-79.795074, 53.105414],
        [-79.841379, 53.145738]
    ],
    [
        [-79.950022, 53.351793],
        [-80.042795, 53.366197],
        [-80.086049, 53.330390],
        [-79.947133, 53.265937],
        [-79.950022, 53.351793]
    ],
    [
        [-79.861887, 53.912909],
        [-79.861887, 53.920356],
        [-79.930084, 53.940863],
        [-79.906890, 53.917711],
        [-79.861887, 53.912909]
    ],
    [
        [-79.977935, 56.202053],
        [-79.678782, 56.331285],
        [-79.545888, 56.530341],
        [-80.059885, 56.304429],
        [-80.104970, 56.200507],
        [-79.977935, 56.202053]
    ],
    [
        [-79.593739, 56.771186],
        [-79.547597, 56.727525],
        [-79.564931, 56.620551],
        [-79.483266, 56.739447],
        [-79.593739, 56.771186]
    ],
    [
        [-79.902821, 56.894110],
        [-79.812489, 56.896674],
        [-79.730865, 56.801907],
        [-79.795033, 56.951606],
        [-79.902821, 56.894110]
    ],
    [
        [-79.792958, 57.428534],
        [-79.696401, 57.529486],
        [-79.737172, 57.622016],
        [-79.850982, 57.486518],
        [-79.792958, 57.428534]
    ],
    [
        [-80.470774, 59.491034],
        [-80.553293, 59.450100],
        [-80.542226, 59.371324],
        [-80.467152, 59.464667],
        [-80.470774, 59.491034]
    ],
    [
        [-80.224965, 59.731269],
        [-80.245432, 59.676663],
        [-80.342193, 59.619574],
        [-80.156077, 59.682847],
        [-80.224965, 59.731269]
    ],
    [
        [-80.108266, 59.764797],
        [-80.018910, 59.772203],
        [-79.881703, 59.861029],
        [-80.042958, 59.877753],
        [-80.108266, 59.764797]
    ],
    [
        [-23.439687, 69.742987],
        [-23.593373, 69.715033],
        [-23.224029, 69.670966],
        [-23.298573, 69.742906],
        [-23.439687, 69.742987]
    ],
    [
        [-26.208323, 70.565375],
        [-26.382680, 70.523830],
        [-26.382680, 70.489651],
        [-26.074208, 70.523830],
        [-26.208323, 70.565375]
    ],
    [
        [-27.719065, 70.739814],
        [-27.369618, 70.818020],
        [-27.239858, 70.894355],
        [-27.722768, 70.888577],
        [-27.719065, 70.739814]
    ],
    [
        [-25.317250, 70.746975],
        [-25.703765, 71.085842],
        [-27.149648, 70.877834],
        [-28.137359, 70.459540],
        [-25.999745, 70.535102],
        [-25.317250, 70.746975]
    ],
    [
        [-25.561920, 71.107164],
        [-25.413971, 71.027411],
        [-25.307688, 71.017279],
        [-25.341176, 71.078681],
        [-25.561920, 71.107164]
    ],
    [
        [-21.949086, 72.428697],
        [-23.137034, 72.840033],
        [-24.485260, 72.826565],
        [-24.063547, 72.445258],
        [-22.524892, 72.134833],
        [-22.045318, 72.271674],
        [-22.760121, 72.441067],
        [-21.949086, 72.428697]
    ],
    [
        [-24.799916, 72.915961],
        [-25.128285, 72.892279],
        [-25.320668, 72.846991],
        [-24.901438, 72.782050],
        [-24.799916, 72.915961]
    ],
    [
        [-21.928619, 72.737779],
        [-22.188710, 72.812323],
        [-21.969594, 72.943834],
        [-23.238271, 73.075263],
        [-21.928619, 72.737779]
    ],
    [
        [-21.325917, 73.148098],
        [-21.168324, 73.134426],
        [-21.203521, 73.146064],
        [-21.325917, 73.148098]
    ],
    [
        [-24.524281, 73.047919],
        [-22.980702, 73.107123],
        [-22.892445, 73.158026],
        [-23.209788, 73.231269],
        [-24.460072, 73.425035],
        [-25.243520, 73.411119],
        [-25.710805, 73.194892],
        [-24.524281, 73.047919]
    ],
    [
        [-20.352691, 74.251654],
        [-20.533355, 74.406724],
        [-21.247060, 74.457099],
        [-21.986969, 74.248236],
        [-21.268666, 74.087795],
        [-20.132965, 74.190172],
        [-20.352691, 74.251654]
    ],
    [
        [-18.735219, 74.632473],
        [-18.904897, 74.675482],
        [-19.221832, 74.587470],
        [-18.823354, 74.547309],
        [-18.735219, 74.632473]
    ],
    [
        [-18.371490, 74.711615],
        [-18.471425, 74.711615],
        [-18.591176, 74.725287],
        [-18.482574, 74.629218],
        [-18.371490, 74.711615]
    ],
    [
        [-19.809967, 74.890855],
        [-20.339101, 75.054185],
        [-20.599721, 74.998969],
        [-20.680735, 74.820950],
        [-20.138254, 74.699286],
        [-19.809967, 74.890855]
    ],
    [
        [-17.316965, 75.136135],
        [-18.209218, 75.222357],
        [-17.802887, 75.314276],
        [-18.051340, 75.420111],
        [-18.948069, 75.334174],
        [-18.892649, 74.999213],
        [-17.618398, 74.935736],
        [-17.316965, 75.136135]
    ],
    [
        [-18.550282, 76.054145],
        [-18.673411, 76.655463],
        [-19.072743, 76.734320],
        [-18.763173, 76.588568],
        [-19.106435, 76.473456],
        [-18.653310, 75.903266],
        [-18.550282, 76.054145]
    ],
    [
        [-18.006500, 77.636908],
        [-17.808909, 77.655463],
        [-17.617299, 77.806586],
        [-17.890126, 77.868354],
        [-18.267201, 77.656724],
        [-18.006500, 77.636908]
    ],
    [
        [-21.381500, 77.864325],
        [-21.243398, 77.875678],
        [-21.086415, 77.984524],
        [-21.332997, 77.945950],
        [-21.381500, 77.864325]
    ],
    [
        [-19.318023, 77.883287],
        [-19.995717, 77.999945],
        [-20.489858, 77.959662],
        [-19.235463, 77.828681],
        [-19.318023, 77.883287]
    ],
    [
        [-19.171376, 77.995307],
        [-19.111562, 77.932278],
        [-18.859853, 78.144477],
        [-19.320424, 78.144477],
        [-19.171376, 77.995307]
    ],
    [
        [-20.379506, 78.136054],
        [-20.467641, 78.249457],
        [-20.814605, 78.174994],
        [-20.600331, 78.133246],
        [-20.379506, 78.136054]
    ],
    [
        [-19.445058, 78.200019],
        [-19.352406, 78.214830],
        [-19.646392, 78.350816],
        [-19.647572, 78.264797],
        [-19.445058, 78.200019]
    ],
    [
        [-18.917836, 78.443549],
        [-19.289215, 78.368109],
        [-19.271108, 78.230658],
        [-18.893666, 78.210395],
        [-19.063385, 78.308824],
        [-18.917836, 78.443549]
    ],
    [
        [-18.234934, 78.616929],
        [-18.391998, 78.636420],
        [-18.652699, 78.555487],
        [-18.509755, 78.525580],
        [-18.234934, 78.616929]
    ],
    [
        [-18.205190, 78.736762],
        [-18.205190, 78.695787],
        [-18.000315, 78.765815],
        [-18.161773, 78.829291],
        [-18.205190, 78.736762]
    ],
    [
        [-19.124379, 78.710679],
        [-19.020741, 78.745429],
        [-19.041819, 78.778998],
        [-19.213206, 78.792629],
        [-19.048004, 78.923570],
        [-19.610666, 78.770006],
        [-19.124379, 78.710679]
    ],
    [
        [-17.532948, 79.032213],
        [-17.405914, 79.123277],
        [-17.605540, 79.193834],
        [-17.964955, 78.955878],
        [-17.532948, 79.032213]
    ],
    [
        [-18.764272, 79.973293],
        [-19.414174, 79.848131],
        [-18.173940, 79.693671],
        [-17.260976, 80.003607],
        [-18.764272, 79.973293]
    ],
    [
        [-19.522857, 80.030260],
        [-18.771840, 80.112250],
        [-18.702992, 80.126451],
        [-19.349924, 80.213202],
        [-19.704091, 80.057563],
        [-19.522857, 80.030260]
    ],
    [
        [-17.732818, 81.595649],
        [-17.732818, 81.595649]
    ],
    [
        [-19.459584, 81.953192],
        [-19.045033, 81.825100],
        [-18.630930, 81.819729],
        [-19.658193, 82.094062],
        [-19.459584, 81.953192]
    ],
    [
        [-59.286773, -80.209649],
        [-59.961334, -80.083917],
        [-59.625559, -79.906345],
        [-59.862782, -79.903253],
        [-59.656402, -79.850356],
        [-59.799143, -79.774347],
        [-60.486562, -79.737726],
        [-61.522694, -79.892999],
        [-61.235585, -79.979669],
        [-61.807851, -80.057550],
        [-61.184560, -80.252618],
        [-61.750356, -80.368341],
        [-65.918446, -80.394952],
        [-66.203481, -80.343683],
        [-66.239898, -80.194431],
        [-66.804758, -80.328546],
        [-64.284779, -80.751153],
        [-63.141103, -80.592462],
        [-62.522084, -80.864923],
        [-60.652659, -80.960382],
        [-59.819000, -80.744887],
        [-59.665924, -80.646417],
        [-59.859242, -80.594985],
        [-59.846832, -80.528253],
        [-59.757436, -80.335707],
        [-59.286773, -80.209649]
    ],
    [
        [-66.149078, -79.628188],
        [-67.707346, -79.525649],
        [-67.839833, -79.558770],
        [-66.811838, -79.791925],
        [-67.025746, -79.898370],
        [-66.310455, -80.080743],
        [-65.450103, -79.952407],
        [-65.901275, -79.839532],
        [-65.565785, -79.812677],
        [-65.554067, -79.777439],
        [-65.788564, -79.624607],
        [-66.149078, -79.628188]
    ],
    [
        [-32.143300, -79.661065],
        [-31.913482, -79.572849],
        [-32.601226, -79.661065],
        [-32.496653, -79.673272],
        [-32.143300, -79.661065]
    ],
    [
        [-68.233022, -79.285903],
        [-68.572133, -79.436619],
        [-67.467885, -79.506036],
        [-67.242177, -79.455824],
        [-67.511057, -79.397231],
        [-67.048207, -79.264825],
        [-68.233022, -79.285903]
    ],
    [
        [-67.712229, -79.136814],
        [-67.688140, -79.125177],
        [-67.712229, -79.136814]
    ],
    [
        [-33.916493, -79.312595],
        [-35.503407, -79.090102],
        [-36.590077, -79.275567],
        [-36.938466, -79.181248],
        [-36.726389, -79.298110],
        [-33.916493, -79.312595]
    ],
    [
        [-75.588368, -78.757908],
        [-75.512359, -78.866795],
        [-75.393666, -78.740981],
        [-75.505849, -78.735121],
        [-75.588368, -78.757908]
    ],
    [
        [-66.734364, -78.441827],
        [-66.872548, -78.427992],
        [-66.605540, -78.363702],
        [-67.577626, -78.371840],
        [-70.592763, -78.885919],
        [-71.599599, -79.199965],
        [-71.815663, -79.479181],
        [-71.444163, -79.652927],
        [-69.646555, -79.603774],
        [-69.491567, -79.532647],
        [-69.822011, -79.458429],
        [-69.296010, -79.217706],
        [-66.734364, -78.441827]
    ],
    [
        [-52.518788, -80.200128],
        [-52.279897, -80.078302],
        [-53.407053, -80.107680],
        [-54.096506, -80.558364],
        [-54.377594, -80.577407],
        [-54.407826, -80.740004],
        [-54.161610, -80.877130],
        [-49.798004, -80.790948],
        [-43.531565, -80.199965],
        [-43.437978, -80.109470],
        [-43.856679, -79.996026],
        [-43.137441, -79.951755],
        [-42.936431, -79.522068],
        [-43.348459, -79.239190],
        [-43.133534, -79.181899],
        [-43.452545, -79.110772],
        [-43.739003, -78.800551],
        [-43.920277, -78.596287],
        [-43.725087, -78.394952],
        [-43.818837, -78.248305],
        [-45.934071, -77.817071],
        [-47.222524, -77.772638],
        [-49.110992, -78.052911],
        [-50.367421, -78.690525],
        [-50.267323, -78.723240],
        [-50.430531, -78.812595],
        [-50.214426, -78.832940],
        [-50.561350, -78.959568],
        [-50.484364, -79.129327],
        [-50.739735, -79.284438],
        [-50.389231, -79.330824],
        [-50.263661, -79.535740],
        [-52.518788, -80.200128]
    ],
    [
        [-49.258656, -77.872491],
        [-49.245473, -77.865655],
        [-49.258656, -77.872491]
    ],
    [
        [-20.366567, -74.425388],
        [-20.692860, -74.101983],
        [-20.495839, -73.793715],
        [-20.515859, -73.659763],
        [-20.640248, -73.587498],
        [-21.145375, -73.950128],
        [-21.299469, -74.105890],
        [-20.981191, -74.211033],
        [-20.843007, -74.462823],
        [-20.366567, -74.425388]
    ],
    [
        [-73.823842, -73.387465],
        [-73.787587, -73.396417],
        [-73.735097, -73.370050],
        [-73.779368, -73.359145],
        [-73.823842, -73.387465]
    ],
    [
        [-71.796539, -73.219822],
        [-71.980824, -73.181085],
        [-72.096181, -73.214532],
        [-71.987375, -73.258396],
        [-71.796539, -73.219822]
    ],
    [
        [-73.886830, -73.120050],
        [-74.159169, -73.308038],
        [-74.014719, -73.406345],
        [-73.522532, -73.130141],
        [-73.886830, -73.120050]
    ],
    [
        [-104.687123, -73.096531],
        [-104.958608, -72.942641],
        [-105.155385, -73.005304],
        [-104.945668, -73.186212],
        [-104.532704, -73.174493],
        [-104.687123, -73.096531]
    ],
    [
        [-89.892445, -72.884617],
        [-90.336293, -72.987400],
        [-89.689117, -73.090590],
        [-89.330678, -72.927992],
        [-89.892445, -72.884617]
    ],
    [
        [-74.846791, -72.866632],
        [-75.775746, -72.893650],
        [-75.036448, -73.038995],
        [-76.126129, -73.158787],
        [-75.874582, -73.346612],
        [-74.465321, -73.582940],
        [-74.360911, -73.460382],
        [-74.758046, -73.303155],
        [-74.218577, -72.990818],
        [-74.846791, -72.866632]
    ],
    [
        [-93.750803, -72.888604],
        [-93.982900, -72.819024],
        [-94.128163, -72.872979],
        [-93.862050, -72.928155],
        [-93.750803, -72.888604]
    ],
    [
        [-98.130767, -72.692315],
        [-97.941233, -72.725030],
        [-97.748687, -72.683282],
        [-97.940256, -72.657403],
        [-98.130767, -72.692315]
    ],
    [
        [-90.901601, -72.819757],
        [-90.757965, -72.697442],
        [-90.915191, -72.562188],
        [-91.686513, -72.609959],
        [-91.333404, -72.897556],
        [-91.506337, -73.197849],
        [-90.917714, -73.101251],
        [-90.724477, -72.912774],
        [-90.901601, -72.819757]
    ],
    [
        [-93.359364, -72.579767],
        [-93.236318, -72.635512],
        [-93.110585, -72.559828],
        [-93.276519, -72.545587],
        [-93.359364, -72.579767]
    ],
    [
        [-60.775136, -72.562433],
        [-60.909291, -72.541111],
        [-60.968861, -72.591974],
        [-60.827016, -72.584405],
        [-60.775136, -72.562433]
    ],
    [
        [-94.491444, -72.522393],
        [-94.580881, -72.468927],
        [-95.274281, -72.651788],
        [-94.399810, -72.607354],
        [-94.491444, -72.522393]
    ],
    [
        [-16.186147, -72.590509],
        [-16.338002, -72.460626],
        [-16.516347, -72.519138],
        [-16.381581, -72.690037],
        [-16.102773, -72.687433],
        [-16.186147, -72.590509]
    ],
    [
        [-70.550282, -72.221856],
        [-70.653554, -72.250746],
        [-70.417633, -72.238377],
        [-70.446523, -72.228123],
        [-70.550282, -72.221856]
    ],
    [
        [-60.258453, -72.204034],
        [-60.181386, -72.255792],
        [-60.106557, -72.224054],
        [-60.188059, -72.175958],
        [-60.258453, -72.204034]
    ],
    [
        [-12.659413, -72.059503],
        [-12.810211, -72.000665],
        [-12.967356, -72.056329],
        [-12.489654, -72.167087],
        [-12.659413, -72.059503]
    ],
    [
        [-95.499216, -72.315606],
        [-96.415761, -72.289809],
        [-95.502919, -72.151625],
        [-95.658111, -72.047621],
        [-96.999989, -72.214288],
        [-96.065338, -71.913832],
        [-96.360463, -71.835056],
        [-96.990102, -71.847345],
        [-97.394114, -72.208429],
        [-97.618316, -72.096124],
        [-97.364980, -71.979913],
        [-97.602773, -71.888116],
        [-97.892079, -71.910740],
        [-97.764312, -72.142511],
        [-98.352610, -72.156427],
        [-98.290883, -71.974216],
        [-97.982411, -71.859633],
        [-98.531646, -71.756768],
        [-99.152577, -71.916192],
        [-99.499013, -71.930434],
        [-99.944407, -71.893813],
        [-100.132558, -71.821873],
        [-102.323720, -72.064060],
        [-99.186431, -72.375421],
        [-99.396555, -72.498224],
        [-98.535471, -72.464125],
        [-98.580149, -72.572849],
        [-96.054758, -72.583673],
        [-95.944407, -72.501560],
        [-96.096791, -72.461114],
        [-95.499216, -72.315606]
    ],
    [
        [-60.530670, -71.051039],
        [-60.587026, -70.925063],
        [-60.957346, -70.977309],
        [-60.756581, -71.049981],
        [-60.530670, -71.051039]
    ],
    [
        [-74.912668, -71.023370],
        [-73.547475, -70.716241],
        [-74.463368, -70.576837],
        [-74.596099, -70.794122],
        [-74.954457, -70.584568],
        [-75.199818, -70.776625],
        [-76.542551, -70.965590],
        [-76.130442, -71.137872],
        [-74.912668, -71.023370]
    ],
    [
        [-60.435292, -70.596775],
        [-60.834543, -70.512384],
        [-60.982249, -70.620864],
        [-60.716542, -70.710626],
        [-60.435292, -70.596775]
    ],
    [
        [-3.430409, -70.538507],
        [-2.747060, -70.511814],
        [-2.680572, -70.388360],
        [-3.144154, -70.300714],
        [-3.430409, -70.538507]
    ],
    [
        [-71.711008, -70.429783],
        [-71.534535, -70.436212],
        [-71.318593, -70.298761],
        [-71.816518, -70.295831],
        [-71.711008, -70.429783]
    ],
    [
        [-70.768910, -70.303481],
        [-70.667104, -70.326837],
        [-70.632436, -70.254978],
        [-70.722279, -70.240818],
        [-70.768910, -70.303481]
    ],
    [
        [-61.105377, -69.963800],
        [-61.268219, -69.851983],
        [-61.405995, -69.942804],
        [-61.288482, -69.984308],
        [-61.105377, -69.963800]
    ],
    [
        [-75.483510, -70.133722],
        [-74.776112, -70.170994],
        [-74.397084, -69.961847],
        [-74.962799, -69.716892],
        [-75.435536, -69.768813],
        [-75.230133, -69.841729],
        [-75.831695, -70.016371],
        [-75.483510, -70.133722]
    ],
    [
        [-72.845530, -69.585626],
        [-72.205312, -69.734470],
        [-71.949696, -69.682794],
        [-72.661855, -69.416111],
        [-72.968007, -69.485447],
        [-72.845530, -69.585626]
    ],
    [
        [-61.755483, -69.454278],
        [-62.192047, -69.186212],
        [-62.579172, -69.189142],
        [-62.095123, -69.729669],
        [-61.755483, -69.454278]
    ],
    [
        [-71.460032, -72.629164],
        [-69.218170, -72.542901],
        [-69.227447, -72.426690],
        [-68.762766, -72.223403],
        [-68.436106, -72.240818],
        [-68.341868, -72.057061],
        [-68.483144, -71.896905],
        [-68.208648, -71.821059],
        [-68.299184, -70.869073],
        [-68.481191, -70.809503],
        [-68.330190, -70.799737],
        [-69.284779, -69.923110],
        [-69.317128, -69.625909],
        [-69.739003, -69.293715],
        [-70.108266, -69.300958],
        [-69.994293, -69.093683],
        [-70.096669, -68.902520],
        [-70.402089, -68.786798],
        [-72.012685, -68.955499],
        [-72.198883, -69.097752],
        [-72.097971, -69.312677],
        [-71.615875, -69.454848],
        [-71.911610, -69.708266],
        [-71.927642, -69.954197],
        [-71.784495, -70.042250],
        [-71.059193, -70.224054],
        [-70.195668, -70.140069],
        [-70.231801, -70.235121],
        [-69.588490, -70.393487],
        [-70.998606, -70.465753],
        [-71.266510, -70.680108],
        [-69.786692, -70.853448],
        [-69.838002, -71.151951],
        [-70.411204, -70.945408],
        [-71.343577, -70.966078],
        [-71.690053, -71.158868],
        [-72.786122, -71.062758],
        [-73.124582, -71.143976],
        [-72.188954, -71.373142],
        [-73.585317, -71.322931],
        [-73.660064, -71.410577],
        [-73.336415, -71.536798],
        [-73.525217, -71.606215],
        [-74.222483, -71.381931],
        [-74.436635, -71.450942],
        [-74.289540, -71.657892],
        [-75.016428, -71.526544],
        [-75.414133, -71.660903],
        [-75.177154, -71.752618],
        [-75.402415, -71.801039],
        [-75.356028, -71.923598],
        [-74.004750, -72.173517],
        [-73.501332, -72.012465],
        [-73.878896, -71.864190],
        [-72.859364, -71.920994],
        [-72.338938, -71.613458],
        [-71.829742, -71.898614],
        [-70.719716, -71.905694],
        [-72.055247, -72.158136],
        [-71.367177, -72.287856],
        [-70.457672, -72.140232],
        [-70.116322, -72.238539],
        [-70.709706, -72.396417],
        [-72.676747, -72.271254],
        [-73.164174, -72.431248],
        [-72.799713, -72.594171],
        [-72.432118, -72.553481],
        [-72.408274, -72.674493],
        [-71.460032, -72.629164]
    ],
    [
        [-60.894114, -68.759942],
        [-60.746083, -68.798923],
        [-60.652008, -68.775811],
        [-61.021148, -68.706720],
        [-60.894114, -68.759942]
    ],
    [
        [-67.134999, -68.138116],
        [-67.240102, -68.133071],
        [-67.254954, -68.144789],
        [-67.200754, -68.172621],
        [-67.134999, -68.138116]
    ],
    [
        [-67.040028, -67.861423],
        [-66.901112, -67.888360],
        [-66.855377, -67.872247],
        [-66.945546, -67.848891],
        [-67.040028, -67.861423]
    ],
    [
        [-67.083079, -67.832696],
        [-67.185943, -67.794122],
        [-67.336781, -67.818292],
        [-67.246409, -67.893976],
        [-67.083079, -67.832696]
    ],
    [
        [-64.954335, -67.661391],
        [-64.707143, -67.674249],
        [-64.563710, -67.620375],
        [-64.940500, -67.598810],
        [-64.954335, -67.661391]
    ],
    [
        [-67.288197, -67.730076],
        [-67.122182, -67.642511],
        [-67.774770, -67.685805],
        [-67.510487, -67.789483],
        [-67.288197, -67.730076]
    ],
    [
        [-66.810536, -67.523533],
        [-66.971181, -67.517022],
        [-67.160268, -67.588067],
        [-66.999379, -67.591485],
        [-66.810536, -67.523533]
    ],
    [
        [-67.744456, -67.360772],
        [-67.668691, -67.357110],
        [-67.604156, -67.314630],
        [-67.690541, -67.318780],
        [-67.744456, -67.360772]
    ],
    [
        [-67.575795, -67.214451],
        [-67.670888, -67.205011],
        [-67.810211, -67.263442],
        [-67.693349, -67.284275],
        [-67.575795, -67.214451]
    ],
    [
        [-67.656606, -67.088800],
        [-67.633412, -67.141534],
        [-67.540354, -67.098891],
        [-67.572743, -67.046808],
        [-67.656606, -67.088800]
    ],
    [
        [-67.381215, -66.902439],
        [-67.240712, -66.830824],
        [-67.406646, -66.736505],
        [-67.603139, -66.879978],
        [-67.381215, -66.902439]
    ],
    [
        [-69.109283, -67.626153],
        [-68.575185, -67.743910],
        [-68.413686, -67.559177],
        [-67.973785, -67.468438],
        [-68.250966, -67.369317],
        [-67.676829, -67.148045],
        [-68.026235, -66.940606],
        [-67.659413, -66.648614],
        [-68.377838, -66.820733],
        [-69.116444, -67.430434],
        [-69.109283, -67.626153]
    ],
    [
        [-67.161041, -66.388767],
        [-67.056386, -66.378351],
        [-67.027089, -66.341892],
        [-67.147450, -66.325291],
        [-67.161041, -66.388767]
    ],
    [
        [-67.101755, -66.261733],
        [-66.977366, -66.288018],
        [-66.876820, -66.263767],
        [-67.071604, -66.234959],
        [-67.101755, -66.261733]
    ],
    [
        [-66.772532, -66.137791],
        [-66.888661, -66.325779],
        [-66.555572, -66.087009],
        [-66.640289, -66.068536],
        [-66.772532, -66.137791]
    ],
    [
        [-65.740793, -65.968438],
        [-65.779856, -65.948012],
        [-65.801991, -65.992608],
        [-65.727691, -65.989353],
        [-65.740793, -65.968438]
    ],
    [
        [-65.900095, -65.876723],
        [-65.970693, -65.888116],
        [-66.033844, -65.924574],
        [-65.914377, -65.916925],
        [-65.900095, -65.876723]
    ],
    [
        [-65.317779, -65.865899],
        [-65.254018, -65.900160],
        [-65.194000, -65.883884],
        [-65.344350, -65.839532],
        [-65.317779, -65.865899]
    ],
    [
        [-66.190175, -65.823744],
        [-65.813547, -65.839939],
        [-65.912953, -65.705824],
        [-65.624827, -65.534926],
        [-65.960032, -65.553318],
        [-66.190175, -65.823744]
    ],
    [
        [-65.527008, -65.472914],
        [-65.722239, -65.470880],
        [-65.732249, -65.485284],
        [-65.659983, -65.511489],
        [-65.527008, -65.472914]
    ],
    [
        [-59.435455, -65.233819],
        [-59.771392, -65.086114],
        [-59.841542, -65.127374],
        [-59.648752, -65.219903],
        [-59.435455, -65.233819]
    ],
    [
        [-62.921457, -64.877130],
        [-63.069936, -64.841404],
        [-63.129547, -64.869399],
        [-62.987945, -64.896742],
        [-62.921457, -64.877130]
    ],
    [
        [-62.846750, -64.809015],
        [-62.957102, -64.794854],
        [-63.030995, -64.806410],
        [-62.900461, -64.823907],
        [-62.846750, -64.809015]
    ],
    [
        [-63.277699, -64.806248],
        [-63.157135, -64.724542],
        [-63.594472, -64.907403],
        [-63.324941, -64.866388],
        [-63.277699, -64.806248]
    ],
    [
        [-62.637522, -64.726170],
        [-62.667795, -64.669854],
        [-62.764312, -64.709649],
        [-62.704823, -64.747654],
        [-62.637522, -64.726170]
    ],
    [
        [-62.022817, -64.624933],
        [-62.068918, -64.632501],
        [-62.076975, -64.651056],
        [-62.036692, -64.661228],
        [-62.022817, -64.624933]
    ],
    [
        [-62.148997, -64.580255],
        [-62.093007, -64.620864],
        [-62.014638, -64.552911],
        [-62.053782, -64.538018],
        [-62.148997, -64.580255]
    ],
    [
        [-57.652455, -64.450291],
        [-57.587514, -64.470961],
        [-57.563954, -64.442315],
        [-57.584584, -64.417657],
        [-57.652455, -64.450291]
    ],
    [
        [-61.626536, -64.359552],
        [-61.565826, -64.395603],
        [-61.489247, -64.384535],
        [-61.546254, -64.350274],
        [-61.626536, -64.359552]
    ],
    [
        [-57.314524, -64.436456],
        [-57.447581, -64.534356],
        [-57.219106, -64.565362],
        [-56.878407, -64.335707],
        [-57.314524, -64.436456]
    ],
    [
        [-62.906443, -64.521173],
        [-63.270375, -64.581231],
        [-63.111195, -64.398045],
        [-63.359934, -64.436212],
        [-63.153432, -64.291599],
        [-63.574941, -64.265232],
        [-64.301096, -64.699884],
        [-63.682118, -64.853204],
        [-62.906443, -64.521173]
    ],
    [
        [-56.849477, -64.279962],
        [-56.898549, -64.317315],
        [-56.582509, -64.235121],
        [-56.635243, -64.221612],
        [-56.849477, -64.279962]
    ],
    [
        [-61.659088, -64.171563],
        [-61.689565, -64.102716],
        [-61.753733, -64.114190],
        [-61.749135, -64.157322],
        [-61.659088, -64.171563]
    ],
    [
        [-62.656565, -64.503025],
        [-62.167470, -64.362074],
        [-62.048980, -64.214451],
        [-62.211497, -64.178399],
        [-62.008941, -64.141697],
        [-62.572092, -64.052423],
        [-62.463775, -64.236749],
        [-62.788482, -64.483819],
        [-62.656565, -64.503025]
    ],
    [
        [-61.936269, -63.991306],
        [-62.064036, -64.070977],
        [-61.784291, -63.969496],
        [-61.829213, -63.959731],
        [-61.936269, -63.991306]
    ],
    [
        [-57.513336, -64.340997],
        [-57.564565, -64.287205],
        [-57.070221, -64.159601],
        [-57.400380, -64.145603],
        [-57.155385, -64.085138],
        [-57.532582, -64.021417],
        [-57.493520, -63.926202],
        [-57.717681, -64.075372],
        [-57.864369, -64.066583],
        [-57.794667, -63.791436],
        [-58.460357, -64.085707],
        [-58.012685, -64.239028],
        [-58.313303, -64.321384],
        [-58.214996, -64.384535],
        [-57.513336, -64.340997]
    ],
    [
        [-57.643056, -63.849379],
        [-57.243967, -63.902276],
        [-57.089101, -63.839451],
        [-57.695180, -63.816664],
        [-57.643056, -63.849379]
    ],
    [
        [-61.726064, -63.750909],
        [-61.684193, -63.807875],
        [-61.613759, -63.763604],
        [-61.726064, -63.750909]
    ],
    [
        [-60.886586, -63.858575],
        [-60.627919, -63.858575],
        [-60.552846, -63.699314],
        [-60.802235, -63.665785],
        [-60.665151, -63.722263],
        [-60.886586, -63.858575]
    ],
    [
        [-57.538930, -63.683119],
        [-57.463857, -63.688653],
        [-57.402089, -63.628025],
        [-57.572133, -63.642755],
        [-57.538930, -63.683119]
    ],
    [
        [-56.689198, -63.592869],
        [-56.648020, -63.623305],
        [-56.467926, -63.565688],
        [-56.602691, -63.557306],
        [-56.689198, -63.592869]
    ],
    [
        [-59.837514, -63.554620],
        [-59.871571, -63.583754],
        [-59.777943, -63.594822],
        [-59.797353, -63.553399],
        [-59.837514, -63.554620]
    ],
    [
        [-55.719594, -63.475356],
        [-55.806386, -63.407403],
        [-56.240468, -63.478692],
        [-55.964915, -63.581476],
        [-55.719594, -63.475356]
    ],
    [
        [-61.951731, -63.311782],
        [-62.202707, -63.237074],
        [-62.277496, -63.352309],
        [-62.011790, -63.345147],
        [-61.951731, -63.311782]
    ],
    [
        [-56.698557, -63.206231],
        [-56.591868, -63.208591],
        [-56.565989, -63.162856],
        [-56.654856, -63.158298],
        [-56.698557, -63.206231]
    ],
    [
        [-55.159373, -63.203871],
        [-55.974517, -63.146905],
        [-56.553782, -63.367283],
        [-55.172719, -63.357599],
        [-55.042836, -63.282973],
        [-55.159373, -63.203871]
    ],
    [
        [-56.545969, -63.099298],
        [-56.273508, -63.178481],
        [-56.035024, -63.057550],
        [-56.476796, -62.976658],
        [-56.545969, -63.099298]
    ],
    [
        [-60.497874, -62.964288],
        [-60.619252, -62.896661],
        [-60.746978, -62.940606],
        [-60.618804, -63.016534],
        [-60.685292, -62.926202],
        [-60.497874, -62.964288]
    ],
    [
        [-62.601267, -63.065606],
        [-62.429799, -62.985772],
        [-62.306264, -62.875177],
        [-62.712310, -63.089288],
        [-62.601267, -63.065606]
    ],
    [
        [-61.507314, -62.813572],
        [-61.409250, -62.823337],
        [-61.198883, -62.727716],
        [-61.460683, -62.737237],
        [-61.507314, -62.813572]
    ],
    [
        [-61.160390, -62.663344],
        [-60.379221, -62.610121],
        [-60.433665, -62.716241],
        [-60.290598, -62.757582],
        [-59.802968, -62.611261],
        [-60.024526, -62.627048],
        [-60.129465, -62.460056],
        [-60.491078, -62.577081],
        [-60.801829, -62.468927],
        [-61.160390, -62.663344]
    ],
    [
        [-59.745676, -62.545017],
        [-59.553700, -62.501235],
        [-59.799062, -62.509535],
        [-59.745676, -62.545017]
    ],
    [
        [-59.694163, -62.378513],
        [-59.508778, -62.456964],
        [-59.347401, -62.406508],
        [-59.436757, -62.355076],
        [-59.694163, -62.378513]
    ],
    [
        [-58.983144, -62.265395],
        [-59.032948, -62.233494],
        [-59.217763, -62.292087],
        [-58.834340, -62.309340],
        [-58.983144, -62.265395]
    ],
    [
        [-58.466908, -62.160414],
        [-57.589833, -62.025486],
        [-57.669911, -61.913507],
        [-58.414052, -61.933282],
        [-59.010732, -62.219659],
        [-58.466908, -62.160414]
    ],
    [
        [-54.036041, -61.245701],
        [-54.057362, -61.127048],
        [-54.227406, -61.270115],
        [-54.098012, -61.312107],
        [-54.036041, -61.245701]
    ],
    [
        [-55.077952, -61.093194],
        [-55.449045, -61.115004],
        [-55.211415, -61.267267],
        [-54.651519, -61.106541],
        [-55.077952, -61.093194]
    ],
    [
        [-44.518544, -60.718438],
        [-44.451650, -60.703302],
        [-44.847320, -60.715509],
        [-44.717844, -60.772719],
        [-44.518544, -60.718438]
    ],
    [
        [-46.006988, -60.612726],
        [-45.789296, -60.584080],
        [-45.141021, -60.736098],
        [-45.477162, -60.545587],
        [-45.935129, -60.524672],
        [-46.006988, -60.612726]
    ],
    [
        [-27.252919, -59.458266],
        [-27.152943, -59.470798],
        [-27.136830, -59.437188],
        [-27.231313, -59.438246],
        [-27.252919, -59.458266]
    ],
    [
        [-27.328603, -59.437188],
        [-27.330922, -59.424574],
        [-27.407216, -59.431736],
        [-27.371409, -59.455824],
        [-27.301340, -59.471938],
        [-27.328603, -59.437188]
    ],
    [
        [-26.629750, -59.005955],
        [-26.629791, -59.062758],
        [-26.499379, -59.033136],
        [-26.562652, -59.007908],
        [-26.629750, -59.005955]
    ],
    [
        [-26.259836, -58.436700],
        [-26.312367, -58.382094],
        [-26.457834, -58.426690],
        [-26.246205, -58.498712],
        [-26.259836, -58.436700]
    ],
    [
        [-26.424306, -57.812758],
        [-26.356028, -57.786228],
        [-26.513051, -57.772556],
        [-26.478749, -57.802667],
        [-26.424306, -57.812758]
    ],
    [
        [-26.732818, -57.059340],
        [-26.663889, -57.086684],
        [-26.650258, -57.079767],
        [-26.690338, -57.050551],
        [-26.732818, -57.059340]
    ],
    [
        [-27.150502, -56.675714],
        [-27.204579, -56.690199],
        [-27.207590, -56.713149],
        [-27.092437, -56.706476],
        [-27.150502, -56.675714]
    ],
    [
        [-27.609771, -56.292169],
        [-27.569000, -56.320571],
        [-27.527903, -56.284763],
        [-27.572499, -56.272556],
        [-27.609771, -56.292169]
    ],
    [
        [-67.245107, -55.839614],
        [-67.358551, -55.810479],
        [-67.417063, -55.833591],
        [-67.224110, -55.897556],
        [-67.245107, -55.839614]
    ],
    [
        [-67.094309, -55.826104],
        [-67.140370, -55.817315],
        [-67.170033, -55.873793],
        [-67.078440, -55.910089],
        [-67.094309, -55.826104]
    ],
    [
        [-67.501617, -55.821059],
        [-67.589075, -55.802070],
        [-67.913945, -55.836566],
        [-67.621843, -55.918504],
        [-67.501617, -55.821059]
    ],
    [
        [-67.232086, -55.771417],
        [-67.228505, -55.798435],
        [-67.156972, -55.778253],
        [-67.187815, -55.756931],
        [-67.232086, -55.771417]
    ],
    [
        [-67.376088, -55.750909],
        [-67.252553, -55.763930],
        [-67.348704, -55.575616],
        [-67.581532, -55.709405],
        [-67.376088, -55.750909]
    ],
    [
        [-67.643137, -55.497328],
        [-67.699371, -55.505466],
        [-67.738596, -55.616876],
        [-67.587758, -55.585870],
        [-67.643137, -55.497328]
    ],
    [
        [-69.714508, -55.344985],
        [-69.801747, -55.332615],
        [-69.801747, -55.407810],
        [-69.637318, -55.388360],
        [-69.714508, -55.344985]
    ],
    [
        [-70.014027, -55.305922],
        [-70.055002, -55.284845],
        [-70.110219, -55.292250],
        [-70.006459, -55.374444],
        [-69.947825, -55.283868],
        [-70.014027, -55.305922]
    ],
    [
        [-66.855336, -55.271173],
        [-66.992258, -55.228692],
        [-67.074452, -55.278009],
        [-66.938059, -55.334568],
        [-66.855336, -55.271173]
    ],
    [
        [-66.426747, -55.185479],
        [-66.534820, -55.162774],
        [-66.643056, -55.264337],
        [-66.515492, -55.264337],
        [-66.426747, -55.185479]
    ],
    [
        [-66.869008, -55.024102],
        [-67.023915, -54.992446],
        [-67.070912, -55.009454],
        [-66.806874, -55.112888],
        [-66.869008, -55.024102]
    ],
    [
        [-67.999257, -55.627537],
        [-68.146474, -55.404392],
        [-68.602528, -55.359959],
        [-68.745961, -55.271173],
        [-68.209218, -55.262872],
        [-68.786610, -55.165216],
        [-69.061879, -55.044610],
        [-68.616078, -55.152276],
        [-68.334828, -55.062433],
        [-68.441151, -54.939711],
        [-70.031077, -55.147638],
        [-69.848053, -55.257908],
        [-69.500071, -55.174981],
        [-69.788075, -55.305922],
        [-69.161610, -55.514337],
        [-69.459096, -55.305922],
        [-69.287831, -55.168145],
        [-69.122670, -55.147638],
        [-68.986684, -55.265232],
        [-68.801137, -55.188653],
        [-68.971303, -55.377130],
        [-68.965688, -55.407810],
        [-68.865346, -55.505304],
        [-68.616811, -55.407810],
        [-68.098297, -55.712091],
        [-67.999257, -55.627537]
    ],
    [
        [-67.883168, -55.243829],
        [-67.647369, -55.261489],
        [-67.502919, -55.172133],
        [-67.270619, -55.306899],
        [-67.053375, -55.093683],
        [-67.301829, -54.928888],
        [-68.360504, -54.930922],
        [-68.186350, -54.978204],
        [-68.135081, -55.218845],
        [-67.883168, -55.243829]
    ],
    [
        [-70.295155, -55.082452],
        [-70.729848, -55.013360],
        [-70.524526, -54.996759],
        [-70.350453, -54.893731],
        [-71.012847, -54.965020],
        [-70.590077, -55.050470],
        [-70.548085, -55.213556],
        [-70.295155, -55.082452]
    ],
    [
        [-69.904164, -54.996759],
        [-69.776438, -55.034601],
        [-69.164296, -54.955824],
        [-69.728342, -54.864516],
        [-69.904164, -54.996759]
    ],
    [
        [-70.421783, -54.845961],
        [-70.607086, -54.832289],
        [-70.747670, -54.873305],
        [-70.580881, -54.897882],
        [-70.421783, -54.845961]
    ],
    [
        [-70.983795, -54.928481],
        [-71.165395, -54.832289],
        [-71.459584, -54.879490],
        [-71.350982, -54.954360],
        [-70.983795, -54.928481]
    ],
    [
        [-63.888417, -54.729913],
        [-64.542348, -54.715590],
        [-64.758656, -54.832289],
        [-64.624420, -54.903741],
        [-63.888417, -54.729913]
    ],
    [
        [-71.946848, -54.702569],
        [-72.028188, -54.629327],
        [-72.104319, -54.644789],
        [-71.997467, -54.753106],
        [-71.946848, -54.702569]
    ],
    [
        [-37.083079, -54.465916],
        [-37.086497, -54.510837],
        [-37.018178, -54.503351],
        [-37.048736, -54.474542],
        [-37.083079, -54.465916]
    ],
    [
        [3.457286, -54.390069],
        [3.377208, -54.391371],
        [3.350841, -54.455662],
        [3.467540, -54.441339],
        [3.457286, -54.390069]
    ],
    [
        [-72.339833, -54.331476],
        [-72.415883, -54.304132],
        [-72.541737, -54.343032],
        [-72.470693, -54.427667],
        [-72.339833, -54.331476]
    ],
    [
        [-70.384592, -54.188084],
        [-70.218658, -54.234633],
        [-70.287750, -54.188084],
        [-70.384592, -54.188084]
    ],
    [
        [-72.296946, -54.078790],
        [-72.393137, -54.094496],
        [-72.501698, -54.242771],
        [-72.301503, -54.251397],
        [-72.296946, -54.078790]
    ],
    [
        [-73.180084, -54.071954],
        [-73.358266, -54.023614],
        [-73.474355, -54.071954],
        [-73.178456, -54.127211],
        [-73.180084, -54.071954]
    ],
    [
        [-38.087026, -54.003676],
        [-38.065785, -54.002374],
        [-38.026194, -53.989435],
        [-38.062367, -53.988051],
        [-38.087026, -54.003676]
    ],
    [
        [-35.908803, -54.687270],
        [-35.887318, -54.551202],
        [-36.069814, -54.566664],
        [-36.260610, -54.285414],
        [-36.675649, -54.277439],
        [-36.491119, -54.184991],
        [-36.655100, -54.106134],
        [-37.381947, -53.982599],
        [-37.738271, -53.973240],
        [-38.032379, -54.009942],
        [-37.614654, -54.037856],
        [-37.689809, -54.174412],
        [-37.237294, -54.147719],
        [-37.413686, -54.255304],
        [-36.499013, -54.510512],
        [-36.115956, -54.884535],
        [-35.922027, -54.852227],
        [-36.106435, -54.764744],
        [-35.784291, -54.764744],
        [-35.908803, -54.687270]
    ],
    [
        [-71.630930, -54.078790],
        [-71.651519, -54.232029],
        [-71.416615, -54.110040],
        [-71.207509, -54.369236],
        [-70.990142, -54.265802],
        [-71.016225, -54.095392],
        [-71.221059, -54.184666],
        [-71.337961, -53.976251],
        [-71.612172, -53.948012],
        [-71.630930, -54.078790]
    ],
    [
        [-72.015126, -54.202325],
        [-71.905263, -54.229099],
        [-71.987864, -54.317804],
        [-71.830149, -54.331476],
        [-71.744456, -54.231052],
        [-71.766103, -54.163995],
        [-71.652903, -53.926365],
        [-72.259104, -53.929864],
        [-72.015126, -54.202325]
    ],
    [
        [-70.455036, -53.611598],
        [-70.712880, -53.701430],
        [-70.606114, -53.865125],
        [-70.881505, -53.842264],
        [-70.822743, -54.113539],
        [-70.540435, -54.221612],
        [-70.669962, -53.950342],
        [-70.342795, -54.028069],
        [-70.455036, -53.611598]
    ],
    [
        [-73.824452, -53.472101],
        [-73.848541, -53.588311],
        [-73.687856, -53.523207],
        [-73.706451, -53.508233],
        [-73.824452, -53.472101]
    ],
    [
        [-73.392445, -53.413995],
        [-73.592600, -53.385837],
        [-73.574941, -53.491143],
        [-73.481801, -53.571710],
        [-73.392445, -53.413995]
    ],
    [
        [-72.529652, -54.075372],
        [-72.329905, -54.034601],
        [-72.391835, -53.845392],
        [-72.138661, -53.797621],
        [-72.453277, -53.742364],
        [-72.464182, -53.575128],
        [-72.673004, -53.536879],
        [-72.630483, -53.659926],
        [-72.678578, -53.673272],
        [-72.858469, -53.452732],
        [-72.884145, -53.681329],
        [-73.037709, -53.385512],
        [-73.175160, -53.420831],
        [-73.077138, -53.530694],
        [-73.420318, -53.478936],
        [-72.952870, -53.664483],
        [-73.615346, -53.614028],
        [-73.484853, -53.700860],
        [-73.591664, -53.756036],
        [-73.245351, -53.715753],
        [-73.308949, -53.973810],
        [-73.098256, -54.037856],
        [-73.056020, -53.812758],
        [-72.801666, -53.817478],
        [-72.645131, -53.859633],
        [-73.008860, -54.092462],
        [-72.529652, -54.075372]
    ],
    [
        [-74.145904, -53.242771],
        [-74.223622, -53.281020],
        [-74.242177, -53.310968],
        [-74.058095, -53.250258],
        [-74.145904, -53.242771]
    ],
    [
        [-73.433420, -52.865411],
        [-73.611724, -52.821710],
        [-73.810780, -52.913751],
        [-73.419301, -52.957696],
        [-73.433420, -52.865411]
    ],
    [
        [-73.207428, -53.317804],
        [-73.459543, -53.132908],
        [-73.516347, -53.261407],
        [-73.623280, -53.059828],
        [-74.749867, -52.755548],
        [-74.318349, -53.097345],
        [-73.880442, -53.057712],
        [-73.584218, -53.317804],
        [-73.090810, -53.355727],
        [-73.207428, -53.317804]
    ],
    [
        [-73.330963, -52.694024],
        [-73.371938, -52.707696],
        [-73.399810, -52.728204],
        [-73.369211, -52.728611],
        [-73.330963, -52.694024]
    ],
    [
        [-65.155588, -54.640558],
        [-65.854807, -54.644708],
        [-67.297760, -54.053806],
        [-67.983632, -53.601332],
        [-68.111402, -53.343802],
        [-68.550751, -53.238537],
        [-68.349569, -53.016162],
        [-68.225819, -53.102472],
        [-68.594879, -52.654229],
        [-68.779026, -52.548254],
        [-69.140248, -52.683770],
        [-69.417565, -52.451472],
        [-69.911400, -52.847904],
        [-70.416127, -52.758071],
        [-70.089175, -52.911063],
        [-70.418993, -53.011716],
        [-70.473541, -53.309259],
        [-70.202707, -53.468683],
        [-69.352651, -53.355727],
        [-69.360842, -53.521675],
        [-70.178212, -53.833429],
        [-70.014027, -54.113539],
        [-68.994944, -54.468438],
        [-69.377187, -54.681573],
        [-69.239980, -54.441339],
        [-69.859120, -54.280369],
        [-69.741322, -54.477960],
        [-69.775380, -54.554864],
        [-70.034495, -54.256931],
        [-70.199045, -54.320571],
        [-70.136871, -54.427667],
        [-70.130727, -54.545017],
        [-70.585194, -54.390558],
        [-70.764394, -54.599542],
        [-70.610463, -54.338800],
        [-70.800649, -54.315851],
        [-71.090240, -54.510837],
        [-71.364613, -54.372979],
        [-71.614125, -54.410903],
        [-71.563222, -54.510837],
        [-71.850657, -54.414646],
        [-71.671864, -54.571710],
        [-72.007721, -54.505304],
        [-71.944325, -54.654555],
        [-71.487864, -54.687433],
        [-71.233632, -54.531345],
        [-71.289662, -54.676446],
        [-70.951568, -54.616388],
        [-71.027577, -54.777032],
        [-70.452870, -54.633722],
        [-70.758778, -54.840590],
        [-69.627065, -54.692071],
        [-69.648305, -54.822524],
        [-69.130116, -54.942153],
        [-68.737864, -54.896091],
        [-68.928578, -54.778497],
        [-68.568227, -54.878351],
        [-68.700063, -54.767836],
        [-66.540508, -55.051046],
        [-65.358957, -54.926690],
        [-65.155588, -54.640558]
    ],
    [
        [-73.837392, -52.700860],
        [-73.725168, -52.404718],
        [-74.184368, -52.586801],
        [-74.123419, -52.706617],
        [-73.872182, -52.550063],
        [-73.982045, -52.653009],
        [-73.837392, -52.700860]
    ],
    [
        [-74.672566, -52.390549],
        [-74.544422, -52.246159],
        [-74.911610, -52.202813],
        [-74.815413, -52.350447],
        [-74.672566, -52.390549]
    ],
    [
        [-73.769846, -52.379327],
        [-73.815338, -52.241143],
        [-74.092763, -52.166599],
        [-73.872670, -52.376153],
        [-73.769846, -52.379327]
    ],
    [
        [-59.694447, -52.208103],
        [-59.695180, -52.166274],
        [-59.792144, -52.130548],
        [-59.756012, -52.273614],
        [-59.694447, -52.208103]
    ],
    [
        [-74.122548, -52.397719],
        [-73.935699, -52.324884],
        [-74.286773, -52.088637],
        [-74.416860, -52.129002],
        [-74.145904, -52.193780],
        [-74.245351, -52.316583],
        [-74.122548, -52.397719]
    ],
    [
        [-74.790842, -52.179457],
        [-74.671946, -52.163018],
        [-74.601796, -52.064060],
        [-74.793853, -52.123956],
        [-74.790842, -52.179457]
    ],
    [
        [-74.344553, -52.064060],
        [-74.359731, -52.056817],
        [-74.407216, -52.043064],
        [-74.387807, -52.077244],
        [-74.344553, -52.064060]
    ],
    [
        [-74.492299, -51.978692],
        [-74.543813, -51.920668],
        [-74.735585, -52.084568],
        [-74.514068, -52.005304],
        [-74.492299, -51.978692]
    ],
    [
        [-73.707672, -52.186944],
        [-73.784006, -52.059666],
        [-74.094390, -51.927016],
        [-74.090240, -52.010024],
        [-73.707672, -52.186944]
    ],
    [
        [-74.749867, -52.043064],
        [-74.727935, -51.968845],
        [-74.598459, -51.837498],
        [-74.750885, -51.833917],
        [-74.896352, -52.113051],
        [-74.749867, -52.043064]
    ],
    [
        [-61.194000, -51.817071],
        [-61.222279, -51.796563],
        [-61.318186, -51.824477],
        [-61.217519, -51.862074],
        [-61.194000, -51.817071]
    ],
    [
        [-60.947621, -51.947361],
        [-60.865712, -51.899591],
        [-60.862864, -51.760919],
        [-61.153066, -51.844903],
        [-60.947621, -51.947361]
    ],
    [
        [-75.061147, -51.882257],
        [-75.000885, -51.843845],
        [-74.982655, -51.721449],
        [-75.095367, -51.776462],
        [-75.061147, -51.882257]
    ],
    [
        [-74.434560, -51.844903],
        [-74.194732, -51.950291],
        [-74.096303, -51.877374],
        [-74.502838, -51.707208],
        [-74.434560, -51.844903]
    ],
    [
        [-61.270375, -51.680434],
        [-61.318186, -51.728204],
        [-61.277211, -51.755548],
        [-61.194000, -51.693536],
        [-61.270375, -51.680434]
    ],
    [
        [-73.789662, -51.735040],
        [-73.851715, -51.728204],
        [-73.940500, -51.663181],
        [-73.838775, -51.812595],
        [-73.789662, -51.735040]
    ],
    [
        [-74.889801, -52.002048],
        [-74.762929, -51.782892],
        [-74.865346, -51.618341],
        [-74.831858, -51.837498],
        [-75.071401, -51.982110],
        [-74.964223, -52.117608],
        [-74.889801, -52.002048]
    ],
    [
        [-73.943918, -51.741306],
        [-74.082143, -51.538181],
        [-74.240631, -51.698500],
        [-74.014556, -51.799737],
        [-73.943918, -51.741306]
    ],
    [
        [-59.632395, -51.741306],
        [-59.214019, -51.413507],
        [-60.017486, -51.375177],
        [-60.153147, -51.487481],
        [-60.645985, -51.351495],
        [-60.077382, -51.693536],
        [-60.624989, -51.669610],
        [-60.550649, -51.789809],
        [-60.338450, -51.709161],
        [-60.184071, -51.761163],
        [-60.444488, -51.782892],
        [-60.532053, -51.999933],
        [-61.036936, -52.046563],
        [-60.592763, -52.236749],
        [-59.632395, -51.741306]
    ],
    [
        [-59.899281, -51.303643],
        [-59.961334, -51.344008],
        [-60.022817, -51.296157],
        [-59.960317, -51.286798],
        [-59.899281, -51.303643]
    ],
    [
        [-74.197133, -51.426690],
        [-74.112416, -51.378839],
        [-74.254628, -51.290785],
        [-74.238596, -51.409601],
        [-74.197133, -51.426690]
    ],
    [
        [-75.023590, -51.330987],
        [-75.219838, -51.305434],
        [-75.312896, -51.629164],
        [-75.141754, -51.565037],
        [-75.023590, -51.330987]
    ],
    [
        [-60.169911, -51.392511],
        [-60.288686, -51.385186],
        [-60.111562, -51.358331],
        [-60.300893, -51.268243],
        [-60.074290, -51.299981],
        [-60.049143, -51.346449],
        [-60.169911, -51.392511]
    ],
    [
        [-57.816233, -51.693536],
        [-58.145172, -51.542657],
        [-57.777943, -51.543064],
        [-57.906402, -51.376642],
        [-58.291249, -51.422540],
        [-58.230865, -51.652520],
        [-58.521962, -51.491143],
        [-58.333811, -51.427504],
        [-58.406606, -51.323826],
        [-58.953969, -51.248468],
        [-58.864613, -51.358331],
        [-59.167836, -51.573663],
        [-58.991200, -51.646580],
        [-58.990102, -51.803643],
        [-59.207183, -51.707208],
        [-59.721547, -52.107599],
        [-59.338938, -52.341729],
        [-59.456044, -52.142185],
        [-59.048980, -52.212498],
        [-59.269602, -51.990492],
        [-58.641225, -52.107843],
        [-58.632314, -51.967950],
        [-58.810414, -51.951918],
        [-58.969106, -51.853774],
        [-58.940297, -51.796563],
        [-58.419057, -51.892185],
        [-57.816233, -51.693536]
    ],
    [
        [-73.793080, -51.258722],
        [-73.864735, -51.258722],
        [-73.920644, -51.303643],
        [-73.793691, -51.371026],
        [-73.793080, -51.258722]
    ],
    [
        [-59.748402, -51.283298],
        [-59.553212, -51.337823],
        [-59.447377, -51.324151],
        [-59.808746, -51.255955],
        [-59.748402, -51.283298]
    ],
    [
        [-74.739003, -51.368585],
        [-74.594228, -51.399509],
        [-74.555735, -51.250421],
        [-74.793080, -51.211196],
        [-75.024159, -51.456231],
        [-74.739003, -51.368585]
    ],
    [
        [-74.865346, -51.121515],
        [-74.968984, -51.104425],
        [-75.020497, -51.172784],
        [-74.876943, -51.158461],
        [-74.865346, -51.121515]
    ],
    [
        [-74.420277, -51.111261],
        [-74.486073, -51.021254],
        [-74.605214, -51.080255],
        [-74.434153, -51.205824],
        [-74.420277, -51.111261]
    ],
    [
        [-74.248931, -51.234796],
        [-74.196929, -51.175388],
        [-74.301340, -50.939223],
        [-74.351959, -50.925714],
        [-74.248931, -51.234796]
    ],
    [
        [-74.385569, -50.981052],
        [-74.399770, -50.844415],
        [-74.660471, -50.727716],
        [-74.625478, -50.924900],
        [-74.966420, -50.949884],
        [-74.680979, -51.008233],
        [-74.725453, -51.105076],
        [-74.385569, -50.981052]
    ],
    [
        [-74.906321, -50.796563],
        [-74.781972, -50.882013],
        [-74.693023, -50.890069],
        [-74.660471, -50.823907],
        [-74.804514, -50.666274],
        [-74.906321, -50.796563]
    ],
    [
        [-74.981516, -50.797784],
        [-74.985422, -50.657159],
        [-75.081695, -50.654880],
        [-75.083892, -50.783624],
        [-74.981516, -50.797784]
    ],
    [
        [-74.608713, -50.514825],
        [-74.680979, -50.514825],
        [-74.673492, -50.576918],
        [-74.602651, -50.563084],
        [-74.608713, -50.514825]
    ],
    [
        [-75.126047, -50.494317],
        [-75.468617, -50.494317],
        [-75.359364, -50.590509],
        [-75.513824, -50.649102],
        [-75.461822, -50.762465],
        [-75.290598, -50.781834],
        [-75.345570, -50.560724],
        [-75.126047, -50.494317]
    ],
    [
        [-74.310414, -50.834161],
        [-74.181304, -50.782322],
        [-74.427113, -50.652602],
        [-74.239003, -50.676202],
        [-74.383127, -50.455987],
        [-74.673492, -50.473810],
        [-74.420277, -50.528497],
        [-74.581207, -50.633559],
        [-74.310414, -50.834161]
    ],
    [
        [-74.783355, -50.480645],
        [-74.720286, -50.489353],
        [-74.544586, -50.382094],
        [-74.736724, -50.371840],
        [-74.783355, -50.480645]
    ],
    [
        [-75.040639, -50.289483],
        [-74.799713, -50.125421],
        [-75.400380, -50.039158],
        [-75.119781, -50.138767],
        [-75.179311, -50.255792],
        [-75.390452, -50.162286],
        [-75.454945, -50.363946],
        [-75.194895, -50.302504],
        [-75.323232, -50.400323],
        [-75.222890, -50.436456],
        [-75.040639, -50.289483]
    ],
    [
        [-75.448110, -49.774998],
        [-75.366200, -49.720310],
        [-75.504352, -49.556973],
        [-75.634854, -49.827943],
        [-75.448110, -49.774998]
    ],
    [
        [-75.521308, -49.379099],
        [-75.544299, -49.452866],
        [-75.440420, -49.517811],
        [-75.429433, -49.466365],
        [-75.521308, -49.379099]
    ],
    [
        [-74.903188, -49.076755],
        [-75.126047, -49.021417],
        [-75.235585, -49.144952],
        [-74.935699, -49.280450],
        [-74.903188, -49.076755]
    ],
    [
        [-75.557973, -49.247328],
        [-75.315907, -49.133477],
        [-75.337270, -48.989353],
        [-75.661041, -49.205743],
        [-75.557973, -49.247328]
    ],
    [
        [-75.215403, -49.014581],
        [-75.394154, -48.829034],
        [-75.654856, -48.911065],
        [-75.499338, -49.039158],
        [-75.215403, -49.014581]
    ],
    [
        [-75.105824, -48.969903],
        [-75.223012, -48.978936],
        [-75.308176, -48.794854],
        [-75.091420, -48.870701],
        [-75.105824, -48.969903]
    ],
    [
        [-75.198313, -49.771173],
        [-75.009918, -49.898533],
        [-74.987701, -49.479262],
        [-74.646230, -49.349786],
        [-74.886952, -49.534601],
        [-74.708323, -49.638360],
        [-74.891957, -49.614435],
        [-74.728749, -49.843194],
        [-74.913686, -49.925877],
        [-74.881215, -49.958917],
        [-74.734609, -49.899102],
        [-74.680531, -49.928399],
        [-74.856272, -49.991306],
        [-74.768422, -50.053318],
        [-74.474233, -49.944513],
        [-74.430084, -49.657892],
        [-74.605214, -49.713556],
        [-74.445790, -49.302341],
        [-74.543813, -48.706150],
        [-74.634836, -48.855239],
        [-74.696645, -48.679864],
        [-75.057973, -48.816664],
        [-74.872792, -48.842706],
        [-74.968984, -48.986586],
        [-74.954701, -49.007094],
        [-74.804514, -49.103936],
        [-74.893219, -49.364028],
        [-75.092437, -49.199640],
        [-75.092437, -49.370294],
        [-75.323354, -49.263604],
        [-75.166982, -49.501153],
        [-75.461985, -49.306573],
        [-75.198313, -49.771173]
    ],
    [
        [-75.085032, -48.637302],
        [-75.249135, -48.766778],
        [-75.246083, -48.784763],
        [-75.109446, -48.809177],
        [-75.085032, -48.637302]
    ],
    [
        [-75.023590, -48.688735],
        [-74.988271, -48.740492],
        [-74.824941, -48.658380],
        [-75.009918, -48.637302],
        [-75.023590, -48.688735]
    ],
    [
        [-75.338938, -48.624200],
        [-75.641835, -48.701349],
        [-75.647857, -48.778904],
        [-75.296986, -48.727146],
        [-75.338938, -48.624200]
    ],
    [
        [-75.328359, -48.552179],
        [-75.344350, -48.427423],
        [-75.606435, -48.439223],
        [-75.675364, -48.583185],
        [-75.440663, -48.610528],
        [-75.328359, -48.552179]
    ],
    [
        [-74.472076, -48.455987],
        [-74.429026, -48.525811],
        [-74.303131, -48.479913],
        [-74.510243, -48.408298],
        [-74.472076, -48.455987]
    ],
    [
        [-74.090688, -48.479587],
        [-74.057200, -48.425551],
        [-74.250803, -48.378025],
        [-74.179067, -48.443129],
        [-74.090688, -48.479587]
    ],
    [
        [-74.495432, -48.349867],
        [-74.271718, -48.462660],
        [-74.223297, -48.444920],
        [-74.314117, -48.280938],
        [-74.495432, -48.349867]
    ],
    [
        [-74.499135, -48.583185],
        [-74.737660, -48.125746],
        [-74.717152, -48.453546],
        [-75.033070, -48.504490],
        [-74.607330, -48.693943],
        [-74.499135, -48.583185]
    ],
    [
        [-74.543813, -48.321954],
        [-74.372629, -48.253188],
        [-74.558176, -48.122328],
        [-74.603749, -48.235447],
        [-74.543813, -48.321954]
    ],
    [
        [-75.160756, -48.298435],
        [-75.031117, -48.443780],
        [-74.804514, -48.174493],
        [-75.256337, -48.068617],
        [-75.160756, -48.298435]
    ],
    [
        [-75.149892, -48.658380],
        [-75.282826, -48.630548],
        [-75.317942, -48.348891],
        [-75.554189, -48.397149],
        [-75.345774, -48.301446],
        [-75.543772, -48.321954],
        [-75.433909, -48.198989],
        [-75.551137, -48.055759],
        [-75.338938, -48.017511],
        [-75.083404, -48.507745],
        [-75.149892, -48.658380]
    ],
    [
        [-75.270619, -48.027765],
        [-75.052358, -47.986261],
        [-74.727379, -48.105892],
        [-74.788324, -47.812324],
        [-75.270619, -48.027765]
    ],
    [
        [-74.413726, -47.938246],
        [-73.923004, -47.963637],
        [-73.808909, -47.887384],
        [-74.289906, -47.807387],
        [-74.413726, -47.938246]
    ],
    [
        [-75.182362, -47.831476],
        [-75.023682, -47.803325],
        [-75.091638, -47.680492],
        [-75.355913, -47.736140],
        [-75.182362, -47.831476]
    ],
    [
        [-74.885229, -47.712063],
        [-75.000384, -47.662200],
        [-75.054421, -47.689572],
        [-74.957723, -47.774795],
        [-74.885229, -47.712063]
    ],
    [
        [-74.468658, -47.074965],
        [-74.454701, -47.167739],
        [-74.315785, -47.078058],
        [-74.356679, -47.045017],
        [-74.468658, -47.074965]
    ],
    [
        [-74.074574, -47.020278],
        [-74.177358, -47.016534],
        [-74.226471, -47.122003],
        [-73.975250, -47.047621],
        [-74.074574, -47.020278]
    ],
    [
        [-73.725087, -46.050470],
        [-73.896474, -46.011489],
        [-73.940500, -46.068129],
        [-73.775461, -46.199477],
        [-73.725087, -46.050470]
    ],
    [
        [-73.707672, -45.923598],
        [-73.772125, -45.898696],
        [-73.819488, -45.998712],
        [-73.683176, -46.017673],
        [-73.707672, -45.923598]
    ],
    [
        [-74.752919, -45.807550],
        [-75.108266, -45.874200],
        [-74.859120, -45.998712],
        [-74.780751, -46.011489],
        [-74.752919, -45.807550]
    ],
    [
        [-73.741851, -45.793878],
        [-73.911448, -45.875258],
        [-73.934316, -45.971938],
        [-73.694081, -45.888849],
        [-73.741851, -45.793878]
    ],
    [
        [-73.926829, -45.745375],
        [-74.094594, -45.763930],
        [-74.015614, -45.913995],
        [-73.975250, -45.780206],
        [-73.926829, -45.745375]
    ],
    [
        [-74.790842, -45.632501],
        [-74.839101, -45.601821],
        [-74.879262, -45.624607],
        [-74.752431, -45.699640],
        [-74.790842, -45.632501]
    ],
    [
        [-74.554351, -45.574802],
        [-74.679677, -45.620701],
        [-74.685699, -45.743341],
        [-74.583892, -45.735284],
        [-74.554351, -45.574802]
    ],
    [
        [-74.071441, -45.690851],
        [-73.920644, -45.697686],
        [-73.910227, -45.590997],
        [-74.050445, -45.544610],
        [-74.071441, -45.690851]
    ],
    [
        [-74.502838, -45.732354],
        [-74.241811, -45.675958],
        [-74.273549, -45.495294],
        [-74.421254, -45.454278],
        [-74.502838, -45.732354]
    ],
    [
        [-73.666168, -45.436944],
        [-73.818267, -45.642511],
        [-73.680409, -45.752862],
        [-73.584218, -45.512628],
        [-73.666168, -45.436944]
    ],
    [
        [-73.885894, -45.471124],
        [-74.064036, -45.423272],
        [-74.142649, -45.574965],
        [-73.870473, -45.561700],
        [-73.885894, -45.471124]
    ],
    [
        [-74.554351, -45.546808],
        [-74.501332, -45.588067],
        [-74.445668, -45.428155],
        [-74.519765, -45.444106],
        [-74.554351, -45.546808]
    ],
    [
        [-73.824452, -45.395929],
        [-73.941029, -45.366306],
        [-74.023020, -45.392673],
        [-73.921742, -45.430434],
        [-73.824452, -45.395929]
    ],
    [
        [-74.341420, -45.337660],
        [-74.389272, -45.281671],
        [-74.525787, -45.295017],
        [-74.378041, -45.400974],
        [-74.341420, -45.337660]
    ],
    [
        [-73.824452, -45.266290],
        [-74.070383, -45.204278],
        [-74.167063, -45.252618],
        [-74.012278, -45.353611],
        [-73.824452, -45.266290]
    ],
    [
        [-74.273549, -45.207940],
        [-74.387563, -45.155206],
        [-74.420277, -45.232110],
        [-74.325347, -45.302341],
        [-74.273549, -45.207940]
    ],
    [
        [-73.731923, -45.214776],
        [-73.866078, -44.994561],
        [-74.250111, -45.109633],
        [-73.989573, -45.245782],
        [-73.731923, -45.214776]
    ],
    [
        [-74.270090, -44.944106],
        [-74.356923, -45.011489],
        [-73.913197, -44.950372],
        [-74.163726, -44.864679],
        [-74.270090, -44.944106]
    ],
    [
        [-73.961578, -44.810154],
        [-73.995717, -44.772149],
        [-74.187489, -44.806329],
        [-74.071441, -44.854181],
        [-73.961578, -44.810154]
    ],
    [
        [-73.930531, -44.789239],
        [-73.883209, -44.928155],
        [-73.762318, -44.929864],
        [-73.854482, -44.768731],
        [-73.930531, -44.789239]
    ],
    [
        [-75.091473, -44.796056],
        [-75.198322, -44.807232],
        [-75.152358, -44.921214],
        [-75.031272, -44.903969],
        [-75.091473, -44.796056]
    ],
    [
        [-73.604726, -44.744887],
        [-73.741689, -44.754653],
        [-73.749257, -44.802830],
        [-73.627309, -44.829767],
        [-73.604726, -44.744887]
    ],
    [
        [-74.341420, -44.806329],
        [-74.427113, -44.718194],
        [-74.527740, -44.743259],
        [-74.393544, -44.857029],
        [-74.341420, -44.806329]
    ],
    [
        [-74.482330, -44.636326],
        [-74.622670, -44.622003],
        [-74.669504, -44.670180],
        [-74.468984, -44.697198],
        [-74.482330, -44.636326]
    ],
    [
        [-73.926829, -44.628839],
        [-74.267161, -44.603123],
        [-74.413808, -44.685968],
        [-74.258697, -44.804457],
        [-73.926829, -44.628839]
    ],
    [
        [-74.777211, -44.581150],
        [-74.824941, -44.581150],
        [-74.803863, -44.673761],
        [-74.747792, -44.665623],
        [-74.777211, -44.581150]
    ],
    [
        [-73.659983, -44.676528],
        [-73.679921, -44.544854],
        [-73.821401, -44.578709],
        [-73.752512, -44.741388],
        [-73.659983, -44.676528]
    ],
    [
        [-74.193715, -44.492283],
        [-74.294342, -44.499444],
        [-74.368886, -44.541111],
        [-74.132883, -44.546970],
        [-74.193715, -44.492283]
    ],
    [
        [-74.036041, -44.498468],
        [-73.947336, -44.543552],
        [-73.971547, -44.471287],
        [-74.167063, -44.430271],
        [-74.036041, -44.498468]
    ],
    [
        [-74.392974, -44.546970],
        [-74.223053, -44.467380],
        [-74.259511, -44.412856],
        [-74.541127, -44.453790],
        [-74.392974, -44.546970]
    ],
    [
        [-73.789662, -44.422784],
        [-73.887685, -44.369236],
        [-73.910959, -44.396742],
        [-73.867014, -44.466078],
        [-73.789662, -44.422784]
    ],
    [
        [-73.382476, -44.587823],
        [-73.393422, -44.788670],
        [-73.299631, -44.758559],
        [-73.207428, -44.800063],
        [-73.407582, -44.822442],
        [-73.256988, -44.940037],
        [-72.837636, -44.710138],
        [-72.980946, -44.601495],
        [-72.721181, -44.528009],
        [-72.980946, -44.512140],
        [-73.002024, -44.361261],
        [-73.036204, -44.484796],
        [-73.246246, -44.437188],
        [-73.131581, -44.545180],
        [-73.241200, -44.639337],
        [-73.382476, -44.587823]
    ],
    [
        [-73.726471, -44.425063],
        [-73.678700, -44.434503],
        [-73.654124, -44.350844],
        [-73.789662, -44.382420],
        [-73.726471, -44.425063]
    ],
    [
        [-74.029897, -44.354587],
        [-74.112416, -44.327244],
        [-73.940500, -44.450616],
        [-73.926829, -44.354587],
        [-74.029897, -44.354587]
    ],
    [
        [-73.262807, -44.388442],
        [-73.176747, -44.374933],
        [-73.177154, -44.367771],
        [-73.249013, -44.306736],
        [-73.262807, -44.388442]
    ],
    [
        [-73.865387, -44.334080],
        [-73.805653, -44.266371],
        [-73.975250, -44.289646],
        [-73.932485, -44.328546],
        [-73.865387, -44.334080]
    ],
    [
        [-74.386627, -44.249933],
        [-74.409901, -44.284438],
        [-74.290028, -44.297296],
        [-74.303578, -44.258233],
        [-74.386627, -44.249933]
    ],
    [
        [-73.741851, -44.265069],
        [-73.722035, -44.302830],
        [-73.666168, -44.265069],
        [-73.675689, -44.241306],
        [-73.741851, -44.265069]
    ],
    [
        [-74.108713, -44.227472],
        [-74.017934, -44.327732],
        [-73.893625, -44.239353],
        [-74.064320, -44.149021],
        [-74.108713, -44.227472]
    ],
    [
        [-74.276967, -44.149021],
        [-74.357818, -44.145603],
        [-74.385569, -44.159601],
        [-74.337392, -44.189874],
        [-74.276967, -44.149021]
    ],
    [
        [-73.882802, -44.118341],
        [-73.952707, -44.104750],
        [-74.016225, -44.142836],
        [-73.846262, -44.190199],
        [-73.882802, -44.118341]
    ],
    [
        [-74.297353, -44.011895],
        [-74.298329, -44.031915],
        [-74.207997, -44.019301],
        [-74.277415, -44.011895],
        [-74.297353, -44.011895]
    ],
    [
        [-73.744985, -43.953546],
        [-73.728831, -44.046563],
        [-73.633412, -44.123793],
        [-73.638824, -44.005060],
        [-73.744985, -43.953546]
    ],
    [
        [-73.227935, -44.011895],
        [-73.151601, -44.015802],
        [-73.159657, -43.881524],
        [-73.284169, -43.935724],
        [-73.227935, -44.011895]
    ],
    [
        [-74.143938, -43.827551],
        [-73.995717, -43.936700],
        [-73.762318, -43.888930],
        [-73.865102, -43.762628],
        [-74.143938, -43.827551]
    ],
    [
        [-74.818186, -43.635024],
        [-74.758455, -43.676949],
        [-74.557486, -43.627410],
        [-74.737900, -43.530177],
        [-74.818186, -43.635024]
    ],
    [
        [-73.611480, -42.936212],
        [-73.450063, -42.993748],
        [-73.365102, -42.990818],
        [-73.552805, -42.918634],
        [-73.611480, -42.936212]
    ],
    [
        [-73.604726, -42.579278],
        [-73.620961, -42.568048],
        [-73.755035, -42.598810],
        [-73.616770, -42.638767],
        [-73.604726, -42.579278]
    ],
    [
        [-73.412343, -42.525649],
        [-73.543202, -42.379164],
        [-73.646311, -42.373793],
        [-73.612660, -42.451837],
        [-73.412343, -42.525649]
    ],
    [
        [-73.087636, -42.247491],
        [-73.145375, -42.278253],
        [-73.193918, -42.249119],
        [-73.141591, -42.313735],
        [-73.087636, -42.247491]
    ],
    [
        [-72.542714, -42.141046],
        [-72.509267, -42.073337],
        [-72.559722, -42.051690],
        [-72.617787, -42.103611],
        [-72.542714, -42.141046]
    ],
    [
        [-74.334625, -43.281671],
        [-73.847491, -43.423483],
        [-73.669014, -43.363847],
        [-73.775746, -43.118097],
        [-73.502309, -43.128025],
        [-73.707672, -42.867364],
        [-73.491933, -42.818617],
        [-73.824452, -42.514418],
        [-73.378774, -42.278253],
        [-73.564931, -41.804946],
        [-74.064036, -41.805922],
        [-74.334625, -43.281671]
    ],
    [
        [-73.087636, -41.843438],
        [-73.003000, -41.844334],
        [-73.066884, -41.736993],
        [-73.085805, -41.747817],
        [-73.087636, -41.843438]
    ],
    [
        [-61.907216, -39.136651],
        [-61.919260, -39.152520],
        [-62.098012, -39.087823],
        [-61.868276, -39.239435],
        [-61.907216, -39.136651]
    ],
    [
        [-62.085927, -39.023370],
        [-62.010243, -39.064386],
        [-61.967275, -39.046970],
        [-62.040191, -39.005466],
        [-62.130767, -39.020603],
        [-62.085927, -39.023370]
    ],
    [
        [77.503754, -37.823500],
        [77.504649, -37.882420],
        [77.585216, -37.874200],
        [77.543956, -37.820245],
        [77.503754, -37.823500]
    ],
    [
        [115.660004, -32.149835],
        [115.660004, -32.232517],
        [115.680512, -32.239353],
        [115.678477, -32.216485],
        [115.660004, -32.149835]
    ],
    [
        [-144.283762, -27.579197],
        [-144.339426, -27.559259],
        [-144.338368, -27.633722],
        [-144.304433, -27.632420],
        [-144.283762, -27.579197]
    ],
    [
        [167.521007, -22.569594],
        [167.432302, -22.542250],
        [167.418712, -22.645278],
        [167.555186, -22.638442],
        [167.521007, -22.569594]
    ],
    [
        [166.801768, -22.398858],
        [166.770763, -22.450616],
        [166.801768, -22.463067],
        [166.843435, -22.424412],
        [166.801768, -22.398858]
    ],
    [
        [-138.849599, -21.871270],
        [-138.911855, -21.863946],
        [-138.932200, -21.871270],
        [-138.849599, -21.871270]
    ],
    [
        [-135.457509, -21.528009],
        [-135.484934, -21.496840],
        [-135.525787, -21.487074],
        [-135.457509, -21.528009]
    ],
    [
        [168.137462, -21.431817],
        [167.987804, -21.335626],
        [167.808442, -21.383966],
        [167.992931, -21.654962],
        [168.137462, -21.431817]
    ],
    [
        [-174.914744, -21.292169],
        [-174.983632, -21.390883],
        [-174.920277, -21.454197],
        [-174.908518, -21.329360],
        [-174.914744, -21.292169]
    ],
    [
        [-159.797841, -21.186130],
        [-159.846262, -21.233819],
        [-159.743235, -21.254327],
        [-159.742747, -21.201593],
        [-159.797841, -21.186130]
    ],
    [
        [-175.065541, -21.123956],
        [-175.223582, -21.172540],
        [-175.364817, -21.113946],
        [-175.148752, -21.267999],
        [-175.065541, -21.123956]
    ],
    [
        [-138.534901, -20.876886],
        [-138.512847, -20.857680],
        [-138.519765, -20.814548],
        [-138.542633, -20.780369],
        [-138.548899, -20.779962],
        [-138.534901, -20.876886]
    ],
    [
        [166.424978, -20.719903],
        [166.406423, -20.719659],
        [166.390880, -20.726739],
        [166.424978, -20.719903]
    ],
    [
        [167.432302, -21.027765],
        [167.301280, -20.713067],
        [167.058849, -20.715997],
        [167.190929, -20.809991],
        [167.020844, -20.911716],
        [167.120128, -21.051935],
        [167.390798, -21.178643],
        [167.432302, -21.027765]
    ],
    [
        [166.637218, -20.425063],
        [166.563731, -20.401951],
        [166.493907, -20.713067],
        [166.629731, -20.596368],
        [166.637218, -20.425063]
    ],
    [
        [169.840343, -20.140802],
        [169.755544, -20.143813],
        [169.737966, -20.208917],
        [169.871593, -20.239435],
        [169.840343, -20.140802]
    ],
    [
        [167.034434, -22.237481],
        [166.370372, -21.658949],
        [165.623057, -21.267999],
        [165.217540, -20.764418],
        [163.991954, -20.083103],
        [164.375499, -20.774021],
        [164.951427, -21.353774],
        [166.061209, -21.891209],
        [166.436697, -22.308038],
        [166.915701, -22.395603],
        [167.034434, -22.237481]
    ],
    [
        [164.224620, -20.137628],
        [164.170584, -20.061944],
        [164.163748, -20.061944],
        [164.169200, -20.123305],
        [164.224620, -20.137628]
    ],
    [
        [-174.361073, -19.801365],
        [-174.320180, -19.819268],
        [-174.305857, -19.767185],
        [-174.325673, -19.759698],
        [-174.361073, -19.801365]
    ],
    [
        [-175.069285, -19.712009],
        [-175.099477, -19.749770],
        [-175.059316, -19.801365],
        [-175.046010, -19.751153],
        [-175.069285, -19.712009]
    ],
    [
        [-174.305816, -19.733005],
        [-174.271677, -19.749119],
        [-174.257436, -19.684666],
        [-174.288197, -19.723728],
        [-174.305816, -19.733005]
    ],
    [
        [63.476248, -19.677830],
        [63.389171, -19.684747],
        [63.332286, -19.736423],
        [63.366384, -19.767185],
        [63.476248, -19.677830]
    ],
    [
        [163.682791, -19.739841],
        [163.649669, -19.646254],
        [163.621837, -19.623712],
        [163.669688, -19.787693],
        [163.682791, -19.739841]
    ],
    [
        [-174.260854, -19.630548],
        [-174.277903, -19.595880],
        [-174.293040, -19.592706],
        [-174.260854, -19.630548]
    ],
    [
        [169.432791, -19.492852],
        [169.336599, -19.314630],
        [169.243419, -19.341974],
        [169.436209, -19.657322],
        [169.432791, -19.492852]
    ],
    [
        [179.777517, -19.122817],
        [179.774099, -19.170668],
        [179.745942, -19.190118],
        [179.802013, -19.184259],
        [179.777517, -19.122817]
    ],
    [
        [-169.851145, -18.965102],
        [-169.933705, -19.013604],
        [-169.933705, -19.129653],
        [-169.782908, -19.068943],
        [-169.851145, -18.965102]
    ],
    [
        [178.430349, -18.955255],
        [178.226085, -18.964125],
        [177.951182, -19.129653],
        [178.178966, -19.157485],
        [178.430349, -18.955255]
    ],
    [
        [178.526541, -18.876560],
        [178.495860, -18.862970],
        [178.471934, -18.907159],
        [178.508311, -18.926446],
        [178.526541, -18.876560]
    ],
    [
        [169.336599, -18.934828],
        [169.152354, -18.636326],
        [169.008149, -18.649998],
        [168.987315, -18.876560],
        [169.336599, -18.934828]
    ],
    [
        [179.943427, -18.556346],
        [179.830666, -18.589302],
        [179.882754, -18.662524],
        [179.891831, -18.609644],
        [179.943427, -18.556346]
    ],
    [
        [177.648774, -18.492852],
        [177.618988, -18.511895],
        [177.663097, -18.588474],
        [177.654063, -18.504083],
        [177.648774, -18.492852]
    ],
    [
        [-136.314076, -18.567315],
        [-136.304758, -18.545668],
        [-136.330434, -18.527602],
        [-136.426137, -18.475356],
        [-136.458730, -18.464288],
        [-136.478586, -18.471856],
        [-136.314076, -18.567315]
    ],
    [
        [178.122325, -18.369317],
        [178.108735, -18.403497],
        [178.142345, -18.411879],
        [178.150076, -18.357843],
        [178.122325, -18.369317]
    ],
    [
        [-140.671946, -18.417169],
        [-140.687082, -18.390558],
        [-140.695139, -18.390395],
        [-140.671946, -18.417169]
    ],
    [
        [-136.971425, -18.361912],
        [-137.010243, -18.304376],
        [-137.067616, -18.266290],
        [-136.971425, -18.361912]
    ],
    [
        [-140.822743, -18.217950],
        [-140.829945, -18.190362],
        [-140.925160, -18.084731],
        [-140.973622, -18.060235],
        [-140.822743, -18.217950]
    ],
    [
        [179.345470, -17.998793],
        [179.297374, -17.937921],
        [179.232758, -17.944757],
        [179.350271, -18.118829],
        [179.345470, -17.998793]
    ],
    [
        [179.430837, -17.794041],
        [179.391775, -17.793064],
        [179.422618, -17.850518],
        [179.432302, -17.832778],
        [179.430837, -17.794041]
    ],
    [
        [178.725762, -17.724710],
        [178.734685, -17.767566],
        [178.772716, -17.780369],
        [178.779552, -17.766046],
        [178.725762, -17.724710]
    ],
    [
        [178.776378, -17.628839],
        [178.739355, -17.673330],
        [178.768077, -17.747166],
        [178.835544, -17.693159],
        [178.776378, -17.628839]
    ],
    [
        [179.005382, -17.621352],
        [179.033376, -17.656183],
        [179.040782, -17.656183],
        [179.006847, -17.593194],
        [179.005382, -17.621352]
    ],
    [
        [-142.577463, -17.621352],
        [-142.558176, -17.599216],
        [-142.565175, -17.601658],
        [-142.577463, -17.621352]
    ],
    [
        [168.549571, -17.691013],
        [168.323009, -17.532647],
        [168.151134, -17.718194],
        [168.484141, -17.820733],
        [168.549571, -17.691013]
    ],
    [
        [168.205414, -17.581150],
        [168.247081, -17.546319],
        [168.295421, -17.526462],
        [168.238943, -17.521905],
        [168.205414, -17.581150]
    ],
    [
        [-143.413564, -17.456964],
        [-143.437652, -17.433201],
        [-143.437856, -17.438897],
        [-143.413564, -17.456964]
    ],
    [
        [-145.380483, -17.484959],
        [-145.405588, -17.442966],
        [-145.380483, -17.484959]
    ],
    [
        [168.322765, -17.447361],
        [168.334158, -17.469985],
        [168.372081, -17.479099],
        [168.338552, -17.414483],
        [168.322765, -17.447361]
    ],
    [
        [-145.578481, -17.383071],
        [-145.591379, -17.357680],
        [-145.592885, -17.324802],
        [-145.578481, -17.383071]
    ],
    [
        [178.711436, -17.991957],
        [178.590831, -17.630955],
        [178.190115, -17.300551],
        [177.515147, -17.505060],
        [177.251638, -17.952244],
        [177.894054, -18.273126],
        [178.711436, -17.991957]
    ],
    [
        [177.093923, -17.245294],
        [177.111827, -17.310317],
        [177.162852, -17.265802],
        [177.149181, -17.245294],
        [177.093923, -17.245294]
    ],
    [
        [179.451915, -17.290297],
        [179.371349, -17.259861],
        [179.390880, -17.396254],
        [179.432872, -17.358331],
        [179.451915, -17.290297]
    ],
    [
        [177.272146, -17.080824],
        [177.218272, -17.073826],
        [177.175955, -17.163344],
        [177.238048, -17.149102],
        [177.287852, -17.085219],
        [177.285818, -17.046645],
        [177.272146, -17.080824]
    ],
    [
        [168.391124, -17.067153],
        [168.322765, -17.089451],
        [168.376475, -17.085382],
        [168.391124, -17.067153]
    ],
    [
        [168.559255, -16.943617],
        [168.597016, -16.895196],
        [168.578380, -16.876886],
        [168.533946, -16.894464],
        [168.559255, -16.943617]
    ],
    [
        [177.443696, -16.867852],
        [177.395763, -16.866143],
        [177.395356, -16.936782],
        [177.403656, -16.902602],
        [177.443696, -16.867852]
    ],
    [
        [178.333995, -16.793390],
        [178.280040, -16.786716],
        [178.290212, -16.834405],
        [178.333669, -16.828871],
        [178.333995, -16.793390]
    ],
    [
        [-180.000000, -16.964144],
        [-179.815663, -16.772231],
        [-179.999989, -16.786716]
    ],
    [
        [177.560720, -16.676853],
        [177.558604, -16.721449],
        [177.580333, -16.728448],
        [177.560720, -16.676853]
    ],
    [
        [-143.386220, -16.669854],
        [-143.440582, -16.620782],
        [-143.454010, -16.624607],
        [-143.386220, -16.669854]
    ],
    [
        [179.917491, -16.655532],
        [179.883311, -16.655532],
        [179.951671, -16.607843],
        [179.947439, -16.644464],
        [179.917491, -16.655532]
    ],
    [
        [-143.571156, -16.635837],
        [-143.609527, -16.629978],
        [-143.666249, -16.588474],
        [-143.701527, -16.580499],
        [-143.620351, -16.632013],
        [-143.571156, -16.635837]
    ],
    [
        [168.192068, -16.813897],
        [168.473888, -16.848077],
        [168.480724, -16.800226],
        [168.144216, -16.573012],
        [168.192068, -16.813897]
    ],
    [
        [178.588227, -16.573012],
        [178.560395, -16.587335],
        [178.592459, -16.595636],
        [178.622569, -16.573012],
        [178.588227, -16.573012]
    ],
    [
        [168.329600, -16.539646],
        [168.349376, -16.497979],
        [168.295421, -16.497979],
        [168.315929, -16.535821],
        [168.329600, -16.539646]
    ],
    [
        [-143.817616, -16.539646],
        [-143.861969, -16.467218],
        [-143.934234, -16.450291],
        [-143.848744, -16.492934],
        [-143.817616, -16.539646]
    ],
    [
        [-180.000000, -16.489939],
        [-179.897654, -16.429783],
        [-180.000000, -16.541115]
    ],
    [
        [168.213145, -16.478123],
        [168.243826, -16.494561],
        [168.260997, -16.429783],
        [168.222667, -16.440606],
        [168.213145, -16.478123]
    ],
    [
        [-144.256459, -16.478123],
        [-144.260121, -16.442315],
        [-144.260854, -16.450860],
        [-144.256459, -16.478123]
    ],
    [
        [179.362315, -16.326593],
        [179.328136, -16.326593],
        [179.328136, -16.333591],
        [179.389659, -16.333591],
        [179.362315, -16.326593]
    ],
    [
        [-144.373118, -16.340427],
        [-144.396148, -16.324477],
        [-144.434560, -16.319920],
        [-144.426015, -16.332778],
        [-144.373118, -16.340427]
    ],
    [
        [-180.000000, -16.149111],
        [-180.000000, -16.169614]
    ],
    [
        [-145.482289, -16.347833],
        [-145.559193, -16.233005],
        [-145.553131, -16.252130],
        [-145.482289, -16.347833]
    ],
    [
        [168.182384, -16.347833],
        [168.329845, -16.306248],
        [168.171641, -16.080255],
        [167.912852, -16.233087],
        [168.182384, -16.347833]
    ],
    [
        [-145.613881, -16.052911],
        [-145.631256, -16.038344],
        [-145.708852, -16.060479],
        [-145.613881, -16.052911]
    ],
    [
        [-142.529652, -16.108168],
        [-142.509755, -16.059015],
        [-142.529652, -16.108168]
    ],
    [
        [-140.110219, -15.977227],
        [-140.107086, -15.960626],
        [-140.125478, -15.953302],
        [-140.151682, -15.957696],
        [-140.172271, -15.977227],
        [-140.110219, -15.977227]
    ],
    [
        [-145.167592, -15.950453],
        [-145.219960, -15.898370],
        [-145.235911, -15.888442],
        [-145.167592, -15.950453]
    ],
    [
        [167.812511, -16.419529],
        [167.336111, -15.908949],
        [167.185313, -15.890720],
        [167.147472, -16.082940],
        [167.374848, -16.192966],
        [167.458751, -16.567966],
        [167.812511, -16.419529]
    ],
    [
        [-145.057729, -15.902114],
        [-145.067006, -15.856378],
        [-145.117543, -15.780694],
        [-145.160756, -15.758071],
        [-145.057729, -15.902114]
    ],
    [
        [167.205740, -15.751235],
        [167.233572, -15.641534],
        [167.075694, -15.649591],
        [167.089122, -15.703546],
        [167.205740, -15.751235]
    ],
    [
        [-175.631337, -15.559503],
        [-175.683339, -15.582127],
        [-175.668894, -15.621515],
        [-175.617787, -15.601495],
        [-175.631337, -15.559503]
    ],
    [
        [167.157400, -15.538995],
        [167.109548, -15.587498],
        [167.194835, -15.607517],
        [167.192719, -15.535414],
        [167.157400, -15.538995]
    ],
    [
        [168.185802, -15.517836],
        [168.119640, -15.662774],
        [168.204275, -15.992446],
        [168.270356, -15.914239],
        [168.185802, -15.517836]
    ],
    [
        [167.939464, -15.391860],
        [168.002452, -15.281834],
        [167.672862, -15.449802],
        [167.838552, -15.484796],
        [167.939464, -15.391860]
    ],
    [
        [167.123220, -14.963637],
        [167.157400, -14.956231],
        [167.096446, -14.928888],
        [167.101085, -14.939630],
        [167.123220, -14.963637]
    ],
    [
        [-148.045766, -14.997735],
        [-148.055002, -14.959893],
        [-148.089060, -14.936782],
        [-148.176096, -14.922052],
        [-148.045766, -14.997735]
    ],
    [
        [168.096446, -14.980401],
        [168.131114, -15.395115],
        [168.178966, -15.395115],
        [168.110688, -14.915785],
        [168.096446, -14.980401]
    ],
    [
        [-148.628000, -14.894708],
        [-148.640574, -14.864923],
        [-148.690663, -14.853774],
        [-148.647939, -14.871759],
        [-148.628000, -14.894708]
    ],
    [
        [167.140636, -15.535577],
        [167.247244, -15.498224],
        [167.082856, -14.928888],
        [166.813162, -15.160414],
        [166.556163, -14.645929],
        [166.753917, -15.627699],
        [167.140636, -15.535577]
    ],
    [
        [-145.194936, -14.662042],
        [-145.222971, -14.688409],
        [-145.260406, -14.702325],
        [-145.263905, -14.690118],
        [-145.229644, -14.620375],
        [-145.194936, -14.662042]
    ],
    [
        [-146.256907, -14.497491],
        [-146.231760, -14.456801],
        [-146.239491, -14.455824],
        [-146.256907, -14.497491]
    ],
    [
        [-145.003082, -14.511163],
        [-144.883290, -14.427423],
        [-144.879628, -14.411798],
        [-144.888051, -14.418145],
        [-145.003082, -14.511163]
    ],
    [
        [-145.846588, -14.367120],
        [-145.835439, -14.342706],
        [-145.842600, -14.346612],
        [-145.846588, -14.367120]
    ],
    [
        [-170.591013, -14.264825],
        [-170.698476, -14.260512],
        [-170.831248, -14.319431],
        [-170.748647, -14.374688],
        [-170.591013, -14.264825]
    ],
    [
        [-169.463857, -14.223240],
        [-169.506459, -14.222263],
        [-169.542673, -14.236749],
        [-169.504262, -14.270603],
        [-169.463857, -14.223240]
    ],
    [
        [167.514903, -14.140558],
        [167.407481, -14.194920],
        [167.401215, -14.305108],
        [167.562022, -14.298923],
        [167.514903, -14.140558]
    ],
    [
        [-171.564280, -13.949395],
        [-171.834543, -13.807387],
        [-172.063669, -13.885024],
        [-171.440745, -14.051853],
        [-171.564280, -13.949395]
    ],
    [
        [167.452810, -13.918634],
        [167.590017, -13.856622],
        [167.488943, -13.708185],
        [167.390798, -13.777520],
        [167.452810, -13.918634]
    ],
    [
        [167.702647, -13.619806],
        [167.669932, -13.636489],
        [167.635020, -13.693536],
        [167.712901, -13.668227],
        [167.702647, -13.619806]
    ],
    [
        [167.329275, -13.510512],
        [167.315603, -13.551528],
        [167.368663, -13.543390],
        [167.370860, -13.517348],
        [167.329275, -13.510512]
    ],
    [
        [166.575206, -13.236261],
        [166.613048, -13.268243],
        [166.644054, -13.230076],
        [166.611583, -13.215265],
        [166.575206, -13.236261]
    ],
    [
        [-176.155466, -13.208917],
        [-176.199574, -13.290623],
        [-176.159495, -13.350274],
        [-176.125600, -13.264093],
        [-176.155466, -13.208917]
    ],
    [
        [166.575206, -13.154392],
        [166.561371, -13.078709],
        [166.520518, -13.064874],
        [166.529633, -13.169854],
        [166.575206, -13.154392]
    ],
    [
        [177.124766, -12.486098],
        [177.059744, -12.475274],
        [177.005870, -12.489516],
        [177.091075, -12.516371],
        [177.124766, -12.486098]
    ],
    [
        [166.923920, -11.640972],
        [166.869884, -11.588962],
        [166.767203, -11.617120],
        [166.984149, -11.709863],
        [166.923920, -11.640972]
    ],
    [
        [166.557252, -11.283644],
        [166.540424, -11.214564],
        [166.479760, -11.247422],
        [166.508827, -11.309319],
        [166.557252, -11.283644]
    ],
    [
        [166.147905, -10.694046],
        [165.878062, -10.656847],
        [165.756474, -10.812161],
        [165.861965, -10.868540],
        [166.147905, -10.694046]
    ],
    [
        [122.360850, -8.432875],
        [122.352224, -8.480157],
        [122.409190, -8.486749],
        [122.410167, -8.443943],
        [122.360850, -8.432875]
    ],
    [
        [121.710297, -8.288751],
        [121.676117, -8.309259],
        [121.708995, -8.354750],
        [121.745291, -8.311700],
        [121.710297, -8.288751]
    ],
    [
        [158.486095, -7.610284],
        [158.378754, -7.562677],
        [158.316905, -7.579360],
        [158.523611, -7.658136],
        [158.486095, -7.610284]
    ],
    [
        [159.859386, -8.511326],
        [159.842052, -8.325616],
        [159.402599, -7.982354],
        [158.451996, -7.531996],
        [158.948090, -8.049086],
        [159.859386, -8.511326]
    ],
    [
        [158.365245, -7.548272],
        [158.434825, -7.527765],
        [158.268565, -7.466974],
        [158.265798, -7.488214],
        [158.365245, -7.548272]
    ],
    [
        [157.611583, -7.404229],
        [157.509125, -7.390558],
        [157.475597, -7.411798],
        [157.618988, -7.452081],
        [157.611583, -7.404229]
    ],
    [
        [158.283214, -7.411798],
        [158.250255, -7.394952],
        [158.194347, -7.438409],
        [158.249034, -7.473240],
        [158.283214, -7.411798]
    ],
    [
        [157.776215, -7.407973],
        [157.721690, -7.383884],
        [157.678559, -7.448175],
        [157.797374, -7.473240],
        [157.776215, -7.407973]
    ],
    [
        [121.779796, -7.343438],
        [121.754080, -7.379083],
        [121.759044, -7.415785],
        [121.834809, -7.388279],
        [121.779796, -7.343438]
    ],
    [
        [114.593761, -7.130548],
        [114.541026, -7.118585],
        [114.495372, -7.154718],
        [114.618826, -7.167250],
        [114.593761, -7.130548]
    ],
    [
        [114.369255, -7.089583],
        [114.322255, -7.050031],
        [114.269762, -7.080835],
        [114.391856, -7.178888],
        [114.369255, -7.089583]
    ],
    [
        [157.529796, -7.333185],
        [157.187266, -7.178888],
        [157.042654, -6.897149],
        [156.454438, -6.630792],
        [157.014659, -7.282647],
        [157.447927, -7.432224],
        [157.529796, -7.333185]
    ],
    [
        [-172.222768, -4.506280],
        [-172.200470, -4.493422],
        [-172.229604, -4.497328],
        [-172.227162, -4.518731],
        [-172.203440, -4.532159],
        [-172.174387, -4.513116],
        [-172.222768, -4.506280]
    ],
    [
        [154.192149, -4.464614],
        [154.185313, -4.546075],
        [154.232270, -4.580662],
        [154.254080, -4.526544],
        [154.192149, -4.464614]
    ],
    [
        [154.151378, -4.438084],
        [154.155528, -4.397556],
        [154.144705, -4.369073],
        [154.134532, -4.377211],
        [154.151378, -4.438084]
    ],
    [
        [152.486583, -4.136326],
        [152.431326, -4.163018],
        [152.492686, -4.210870],
        [152.506196, -4.171970],
        [152.486583, -4.136326]
    ],
    [
        [153.664806, -4.040704],
        [153.589854, -4.088067],
        [153.629649, -4.129978],
        [153.670584, -4.090265],
        [153.664806, -4.040704]
    ],
    [
        [153.719249, -3.999200],
        [153.686534, -4.016371],
        [153.678884, -4.026462],
        [153.732921, -4.040704],
        [153.719249, -3.999200]
    ],
    [
        [123.365733, -1.673110],
        [123.378184, -1.712823],
        [123.280284, -1.785821],
        [123.279796, -1.748224],
        [123.365733, -1.673110]
    ],
    [
        [122.139415, -0.384210],
        [122.070567, -0.398045],
        [122.076671, -0.269138],
        [122.094737, -0.263849],
        [122.139415, -0.384210]
    ],
    [
        [119.483246, 4.850898],
        [119.435395, 4.902777],
        [119.456554, 4.655707],
        [119.503591, 4.764228],
        [119.483246, 4.850898]
    ],
    [
        [121.217459, 5.820746],
        [121.162852, 5.848049],
        [121.135020, 5.807074],
        [121.231130, 5.800930],
        [121.217459, 5.820746]
    ],
    [
        [121.381602, 6.005683],
        [121.042247, 6.097113],
        [120.871837, 5.961005],
        [121.292491, 5.858832],
        [121.381602, 6.005683]
    ],
    [
        [121.628917, 6.657416],
        [121.582530, 6.631659],
        [121.616384, 6.561428],
        [121.628917, 6.588568],
        [121.628917, 6.657416]
    ],
    [
        [134.271495, 7.074530],
        [134.235688, 7.008490],
        [134.234386, 6.984320],
        [134.279959, 7.020494],
        [134.271495, 7.074530]
    ],
    [
        [134.463878, 7.294257],
        [134.441091, 7.316718],
        [134.349132, 7.237779],
        [134.392914, 7.224514],
        [134.463878, 7.294257]
    ],
    [
        [134.471365, 7.362494],
        [134.449474, 7.328355],
        [134.522227, 7.311347],
        [134.511892, 7.347317],
        [134.471365, 7.362494]
    ],
    [
        [134.648204, 7.719428],
        [134.487559, 7.469916],
        [134.528005, 7.357571],
        [134.601085, 7.383612],
        [134.648204, 7.719428]
    ],
    [
        [-78.892244, 8.458047],
        [-78.834476, 8.342811],
        [-78.903985, 8.219222],
        [-78.974712, 8.444368],
        [-78.892244, 8.458047]
    ],
    [
        [138.192393, 9.575873],
        [138.126231, 9.565985],
        [138.068126, 9.412055],
        [138.202403, 9.521186],
        [138.192393, 9.575873]
    ],
    [
        [72.172699, 10.809231],
        [72.200043, 10.864447],
        [72.200043, 10.878119],
        [72.179047, 10.848700],
        [72.172699, 10.809231]
    ],
    [
        [121.094493, 10.895819],
        [121.032074, 10.870510],
        [121.017589, 10.834133],
        [121.087169, 10.823472],
        [121.094493, 10.895819]
    ],
    [
        [72.789073, 11.261664],
        [72.770356, 11.203681],
        [72.775401, 11.186591],
        [72.795584, 11.257229],
        [72.789073, 11.261664]
    ],
    [
        [120.285167, 11.930162],
        [120.203298, 11.947577],
        [120.267914, 11.816230],
        [120.263438, 11.916164],
        [120.285167, 11.930162]
    ],
    [
        [121.406423, 12.062445],
        [121.367686, 12.110419],
        [121.358653, 12.114691],
        [121.384288, 12.000922],
        [121.406423, 12.062445]
    ],
    [
        [53.248326, 12.121302],
        [53.263076, 12.114869],
        [53.310267, 12.111444],
        [53.286884, 12.127337],
        [53.248326, 12.121302]
    ],
    [
        [53.053068, 12.174920],
        [53.003953, 12.176942],
        [52.985265, 12.162727],
        [53.086378, 12.134344],
        [53.053068, 12.174920]
    ],
    [
        [52.289199, 12.200815],
        [52.118435, 12.241549],
        [52.064118, 12.235473],
        [52.388464, 12.148868],
        [52.289199, 12.200815]
    ],
    [
        [43.428966, 12.673774],
        [43.390147, 12.666327],
        [43.435802, 12.632148],
        [43.448985, 12.652981],
        [43.428966, 12.673774]
    ],
    [
        [54.470662, 12.543566],
        [53.518946, 12.714351],
        [53.306895, 12.543402],
        [53.731165, 12.300414],
        [54.470662, 12.543566]
    ],
    [
        [144.886404, 13.640204],
        [144.624197, 13.431220],
        [144.680675, 13.246772],
        [144.952159, 13.586859],
        [144.886404, 13.640204]
    ],
    [
        [42.719249, 13.742621],
        [42.693533, 13.699205],
        [42.688487, 13.663764],
        [42.794932, 13.769924],
        [42.719249, 13.742621]
    ],
    [
        [42.760265, 14.064683],
        [42.691905, 14.013170],
        [42.781749, 13.919989],
        [42.801768, 14.023139],
        [42.760265, 14.064683]
    ],
    [
        [145.205740, 14.181383],
        [145.157237, 14.163764],
        [145.119314, 14.129584],
        [145.290538, 14.181383],
        [145.205740, 14.181383]
    ],
    [
        [145.647309, 15.072089],
        [145.578461, 15.017483],
        [145.625824, 14.915269],
        [145.667817, 14.982733],
        [145.647309, 15.072089]
    ],
    [
        [145.787852, 15.267279],
        [145.698253, 15.203192],
        [145.685557, 15.102484],
        [145.752615, 15.096015],
        [145.787852, 15.267279]
    ],
    [
        [111.196544, 15.775377],
        [111.196300, 15.785712],
        [111.207530, 15.789293],
        [111.207530, 15.782172],
        [111.196544, 15.775377]
    ],
    [
        [40.386404, 15.641262],
        [40.163829, 15.644355],
        [40.136485, 15.806220],
        [40.095714, 15.784613],
        [40.091563, 15.849840],
        [39.950938, 15.893948],
        [40.081309, 15.661119],
        [39.937348, 15.702094],
        [39.978852, 15.606513],
        [40.386404, 15.641262]
    ],
    [
        [111.763357, 16.043443],
        [111.753103, 16.044664],
        [111.753429, 16.047431],
        [111.761404, 16.048651],
        [111.763357, 16.043443]
    ],
    [
        [145.709483, 16.367499],
        [145.654145, 16.381171],
        [145.628184, 16.364081],
        [145.669119, 16.339179],
        [145.709483, 16.367499]
    ],
    [
        [42.186438, 16.705528],
        [41.905143, 16.747581],
        [41.955457, 16.670115],
        [42.178559, 16.583482],
        [42.186438, 16.705528]
    ],
    [
        [41.918893, 16.791155],
        [42.001845, 16.760987],
        [41.938162, 16.972886],
        [41.860850, 17.013617],
        [41.918893, 16.791155]
    ],
    [
        [55.836192, 17.490912],
        [55.875824, 17.495917],
        [55.890880, 17.504584],
        [55.862966, 17.518866],
        [55.836192, 17.490912]
    ],
    [
        [56.055349, 17.559801],
        [55.964203, 17.519924],
        [55.972830, 17.498358],
        [56.095551, 17.518866],
        [56.055349, 17.559801]
    ],
    [
        [145.771118, 18.175209],
        [145.713067, 18.077465],
        [145.719493, 18.054185],
        [145.835623, 18.128323],
        [145.771118, 18.175209]
    ],
    [
        [145.661632, 18.724270],
        [145.709483, 18.748440],
        [145.688324, 18.807359],
        [145.632555, 18.786914],
        [145.661632, 18.724270]
    ],
    [
        [58.906261, 20.626044],
        [58.648204, 20.368842],
        [58.652192, 20.170478],
        [58.950043, 20.508938],
        [58.906261, 20.626044]
    ],
    [
        [37.265310, 20.855048],
        [37.243419, 20.804023],
        [37.254405, 20.749823],
        [37.283539, 20.832750],
        [37.265310, 20.855048]
    ],
    [
        [-74.159657, 20.273424],
        [-74.998362, 20.700751],
        [-75.724517, 20.695502],
        [-75.770253, 20.835842],
        [-75.573150, 20.797675],
        [-75.551137, 20.821519],
        [-75.743398, 20.889350],
        [-75.578481, 21.013373],
        [-75.704010, 21.118964],
        [-76.887278, 21.307359],
        [-76.811757, 21.397528],
        [-77.088287, 21.606187],
        [-77.161855, 21.480129],
        [-77.258046, 21.476386],
        [-77.364247, 21.611762],
        [-77.154408, 21.554592],
        [-77.133941, 21.664455],
        [-77.556020, 21.928534],
        [-77.614329, 21.884182],
        [-77.448801, 21.801907],
        [-77.347157, 21.638617],
        [-78.708079, 22.386908],
        [-79.341786, 22.413153],
        [-79.792958, 22.897773],
        [-80.431508, 22.949937],
        [-80.609853, 23.158189],
        [-81.149159, 23.034898],
        [-81.286285, 23.124254],
        [-81.528798, 23.047187],
        [-82.219350, 23.194241],
        [-83.226186, 23.001858],
        [-84.212880, 22.583075],
        [-84.445668, 22.205024],
        [-84.288564, 22.020697],
        [-84.496165, 21.933783],
        [-84.508372, 21.766832],
        [-84.029408, 21.919867],
        [-83.925445, 22.171536],
        [-83.415472, 22.186093],
        [-82.759877, 22.705959],
        [-81.877501, 22.679730],
        [-81.651563, 22.487827],
        [-82.163971, 22.396877],
        [-81.824452, 22.188910],
        [-81.204701, 22.060289],
        [-81.193959, 22.281562],
        [-81.088450, 22.085842],
        [-80.470774, 22.041205],
        [-80.484446, 22.192043],
        [-80.003245, 21.720893],
        [-79.208892, 21.548489],
        [-78.744618, 21.636542],
        [-78.487904, 21.038560],
        [-78.065541, 20.711656],
        [-77.195424, 20.636542],
        [-77.113433, 20.368476],
        [-77.586415, 20.088528],
        [-77.706044, 19.830024],
        [-76.202260, 19.992336],
        [-75.284657, 19.888251],
        [-75.092437, 20.061225],
        [-75.091780, 19.897133],
        [-74.267405, 20.068305],
        [-74.159657, 20.273424]
    ],
    [
        [119.647960, 23.603461],
        [119.552419, 23.590399],
        [119.527110, 23.539984],
        [119.668468, 23.548814],
        [119.647960, 23.603461]
    ],
    [
        [119.477061, 23.603461],
        [119.474457, 23.579739],
        [119.442393, 23.562486],
        [119.491710, 23.571031],
        [119.501313, 23.650377],
        [119.477061, 23.603461]
    ],
    [
        [119.572602, 23.627672],
        [119.596202, 23.653266],
        [119.566417, 23.679185],
        [119.545258, 23.664944],
        [119.572602, 23.627672]
    ],
    [
        [67.375499, 24.062730],
        [67.426931, 24.007514],
        [67.485362, 24.048529],
        [67.390391, 24.049262],
        [67.375499, 24.062730]
    ],
    [
        [53.656993, 24.158393],
        [53.774669, 24.130113],
        [53.964854, 24.172593],
        [53.848155, 24.275051],
        [53.656993, 24.158393]
    ],
    [
        [54.190766, 24.227240],
        [54.188324, 24.277493],
        [54.115245, 24.318508],
        [54.112559, 24.271674],
        [54.190766, 24.227240]
    ],
    [
        [52.574474, 24.343940],
        [52.556104, 24.306946],
        [52.592154, 24.253368],
        [52.650855, 24.324899],
        [52.574474, 24.343940]
    ],
    [
        [53.322759, 24.262691],
        [53.440440, 24.341254],
        [53.416759, 24.412828],
        [53.184581, 24.287014],
        [53.322759, 24.262691]
    ],
    [
        [54.382579, 24.439521],
        [54.456716, 24.420803],
        [54.470551, 24.425035],
        [54.396251, 24.522691],
        [54.382579, 24.439521]
    ],
    [
        [50.551606, 26.194241],
        [50.448904, 26.161607],
        [50.565278, 25.789537],
        [50.645660, 26.145750],
        [50.551606, 26.194241]
    ],
    [
        [54.526378, 26.309638],
        [54.488129, 26.298082],
        [54.521007, 26.250963],
        [54.547374, 26.290432],
        [54.526378, 26.309638]
    ],
    [
        [54.036876, 26.488430],
        [54.018809, 26.555569],
        [53.902843, 26.536200],
        [53.955414, 26.492580],
        [54.036876, 26.488430]
    ],
    [
        [127.809825, 26.735419],
        [127.754649, 26.728583],
        [127.758556, 26.712877],
        [127.811209, 26.706977],
        [127.809825, 26.735419]
    ],
    [
        [53.317149, 26.799994],
        [53.382009, 26.803127],
        [53.149425, 26.847886],
        [53.222830, 26.799547],
        [53.317149, 26.799994]
    ],
    [
        [56.322276, 26.834418],
        [56.379161, 26.838690],
        [56.404145, 26.893052],
        [56.341156, 26.879340],
        [56.322276, 26.834418]
    ],
    [
        [56.212413, 27.002997],
        [55.757986, 26.954047],
        [55.774181, 26.796942],
        [55.284679, 26.660224],
        [55.290538, 26.548489],
        [55.947032, 26.696275],
        [56.212413, 27.002997]
    ],
    [
        [127.995372, 27.091742],
        [127.935720, 27.025092],
        [127.925792, 27.009752],
        [127.975759, 27.039740],
        [127.995372, 27.091742]
    ],
    [
        [56.472992, 27.106024],
        [56.436860, 27.080024],
        [56.434581, 27.054836],
        [56.504731, 27.061672],
        [56.472992, 27.106024]
    ],
    [
        [49.565440, 27.351752],
        [49.501231, 27.360541],
        [49.453624, 27.316392],
        [49.456228, 27.290351],
        [49.688813, 27.317694],
        [49.565440, 27.351752]
    ],
    [
        [50.305817, 29.271275],
        [50.283267, 29.268939],
        [50.326427, 29.208930],
        [50.334651, 29.258661],
        [50.305817, 29.271275]
    ],
    [
        [48.338227, 29.462795],
        [48.269242, 29.429685],
        [48.397356, 29.387497],
        [48.389008, 29.424872],
        [48.338227, 29.462795]
    ],
    [
        [48.352712, 29.709784],
        [48.188731, 29.983547],
        [48.120860, 29.981391],
        [48.161632, 29.629706],
        [48.352712, 29.709784]
    ],
    [
        [48.078868, 30.004055],
        [48.109223, 30.027981],
        [48.010753, 29.980455],
        [48.031098, 29.971015],
        [48.078868, 30.004055]
    ],
    [
        [130.220063, 30.471584],
        [130.202306, 30.481901],
        [130.141766, 30.489301],
        [130.262157, 30.435024],
        [130.220063, 30.471584]
    ],
    [
        [134.367361, 34.554267],
        [134.175059, 34.520087],
        [134.161388, 34.479193],
        [134.346934, 34.430813],
        [134.367361, 34.554267]
    ],
    [
        [-65.607777, 43.483466],
        [-65.656117, 43.463039],
        [-65.628814, 43.422065],
        [-65.559926, 43.510810],
        [-65.607777, 43.483466]
    ],
    [
        [-59.793511, 43.964571],
        [-59.997814, 43.937868],
        [-60.130161, 43.960473],
        [-59.707184, 44.014416],
        [-59.793511, 43.964571]
    ],
    [
        [-68.848134, 44.095526],
        [-68.910186, 44.095526],
        [-68.774648, 44.061876],
        [-68.772979, 44.081895],
        [-68.848134, 44.095526]
    ],
    [
        [-68.642079, 44.260037],
        [-68.724599, 44.219062],
        [-68.716339, 44.167344],
        [-68.622792, 44.171332],
        [-68.642079, 44.260037]
    ],
    [
        [-66.231557, 44.387193],
        [-66.285797, 44.324774],
        [-66.327748, 44.258124],
        [-66.203440, 44.392239],
        [-66.231557, 44.387193]
    ],
    [
        [-68.244822, 44.424506],
        [-68.375762, 44.404079],
        [-68.414052, 44.258612],
        [-68.176544, 44.328315],
        [-68.244822, 44.424506]
    ],
    [
        [-66.861480, 44.726752],
        [-66.905986, 44.606169],
        [-66.690391, 44.620002],
        [-66.743160, 44.782047],
        [-66.861480, 44.726752]
    ],
    [
        [-73.995188, 45.320136],
        [-74.128407, 45.307563],
        [-74.165028, 45.269721],
        [-73.995188, 45.320136]
    ],
    [
        [-73.889027, 45.396715],
        [-73.917307, 45.409980],
        [-73.984527, 45.406399],
        [-73.858062, 45.381781],
        [-73.889027, 45.396715]
    ],
    [
        [-73.931793, 45.488837],
        [-73.899281, 45.500922],
        [-73.886464, 45.523383],
        [-73.943186, 45.507554],
        [-73.931793, 45.488837]
    ],
    [
        [-60.914133, 45.566555],
        [-61.009674, 45.580797],
        [-61.111724, 45.548774],
        [-61.003529, 45.460761],
        [-60.914133, 45.566555]
    ],
    [
        [-73.857289, 45.549384],
        [-73.718332, 45.562445],
        [-73.564849, 45.698676],
        [-73.740875, 45.664252],
        [-73.857289, 45.549384]
    ],
    [
        [-73.499257, 45.709947],
        [-73.694000, 45.555325],
        [-73.973622, 45.444648],
        [-73.588735, 45.447943],
        [-73.499257, 45.709947]
    ],
    [
        [150.843331, 46.448224],
        [150.808481, 46.486438],
        [150.780077, 46.457159],
        [150.832856, 46.440863],
        [150.843331, 46.448224]
    ],
    [
        [-70.843251, 47.033189],
        [-70.885406, 47.026557],
        [-71.124745, 46.877021],
        [-70.874257, 46.936998],
        [-70.843251, 47.033189]
    ],
    [
        [-60.080881, 45.792426],
        [-59.805287, 45.935533],
        [-59.957916, 46.027493],
        [-59.810536, 46.169867],
        [-60.290273, 46.156195],
        [-60.283518, 46.327541],
        [-60.781646, 45.954291],
        [-60.399526, 45.997952],
        [-60.732493, 45.684394],
        [-61.147613, 45.707913],
        [-60.735951, 46.056586],
        [-61.009918, 45.941392],
        [-61.118642, 45.949408],
        [-60.632232, 46.117987],
        [-60.426910, 46.284003],
        [-60.605784, 46.211330],
        [-60.351796, 46.601264],
        [-60.310780, 46.854438],
        [-60.495758, 46.895453],
        [-60.396108, 47.026353],
        [-60.642079, 47.003730],
        [-61.551503, 46.021796],
        [-61.284576, 45.547675],
        [-60.080881, 45.792426]
    ],
    [
        [-62.004018, 46.464057],
        [-63.935618, 46.478339],
        [-63.833648, 46.612372],
        [-64.093251, 46.779975],
        [-63.997060, 47.067328],
        [-64.416819, 46.682766],
        [-64.072743, 46.642157],
        [-64.134267, 46.415595],
        [-63.736928, 46.396430],
        [-63.602122, 46.216864],
        [-63.233388, 46.145453],
        [-63.195709, 46.272284],
        [-62.963002, 46.320014],
        [-63.116811, 46.215766],
        [-62.750722, 45.950751],
        [-62.455922, 46.025214],
        [-62.576405, 46.239000],
        [-62.004018, 46.464057]
    ],
    [
        [-61.671010, 47.546536],
        [-61.382192, 47.636664],
        [-61.562123, 47.627143],
        [-61.925526, 47.413153],
        [-62.010569, 47.224799],
        [-61.793040, 47.240302],
        [-61.965566, 47.283026],
        [-61.671010, 47.546536]
    ],
    [
        [-64.504750, 47.889797],
        [-64.668691, 47.871283],
        [-64.696604, 47.759426],
        [-64.538930, 47.807196],
        [-64.504750, 47.889797]
    ],
    [
        [-64.545766, 47.971666],
        [-64.594106, 47.914374],
        [-64.590443, 47.903469],
        [-64.545766, 47.971666]
    ],
    [
        [154.836681, 49.650051],
        [154.638357, 49.424262],
        [154.605968, 49.292670],
        [154.815115, 49.310207],
        [154.836681, 49.650051]
    ],
    [
        [-64.319203, 49.791246],
        [-63.093332, 49.232896],
        [-62.248199, 49.067939],
        [-61.660756, 49.151028],
        [-63.124094, 49.783881],
        [-64.132802, 49.950141],
        [-64.510569, 49.868069],
        [-64.319203, 49.791246]
    ],
    [
        [-63.884674, 50.199368],
        [-63.857533, 50.217434],
        [-63.901479, 50.253974],
        [-63.926991, 50.221422],
        [-63.884674, 50.199368]
    ],
    [
        [-79.395090, 52.083726],
        [-79.635325, 52.021674],
        [-79.620432, 51.920478],
        [-79.251698, 52.076890],
        [-79.395090, 52.083726]
    ],
    [
        [-80.759348, 52.919176],
        [-81.174224, 53.212348],
        [-81.857777, 53.185248],
        [-82.062652, 53.022773],
        [-80.717681, 52.694973],
        [-80.759348, 52.919176]
    ],
    [
        [-79.758168, 53.522528],
        [-79.724721, 53.508857],
        [-79.703603, 53.516303],
        [-79.765614, 53.546698],
        [-79.758168, 53.522528]
    ],
    [
        [-79.285878, 54.913520],
        [-79.653920, 54.854438],
        [-79.779937, 54.783759],
        [-79.285878, 54.913520]
    ],
    [
        [-77.312082, 55.619208],
        [-77.366689, 55.578274],
        [-77.312082, 55.619208]
    ],
    [
        [-79.005279, 56.017035],
        [-78.950673, 56.078518],
        [-79.013295, 56.059068],
        [-79.005279, 56.017035]
    ],
    [
        [-78.757639, 56.167914],
        [-78.655263, 56.236151],
        [-78.670766, 56.443061],
        [-78.936391, 56.119452],
        [-78.757639, 56.167914]
    ],
    [
        [-79.545888, 56.043769],
        [-79.786122, 55.790473],
        [-79.469350, 55.879381],
        [-79.155588, 56.236151],
        [-79.285878, 55.866278],
        [-78.980214, 56.392035],
        [-78.990102, 56.262600],
        [-79.111073, 56.086982],
        [-79.210113, 55.892890],
        [-79.203277, 55.859442],
        [-78.881825, 56.325588],
        [-78.936147, 56.430243],
        [-79.246991, 56.562066],
        [-79.409332, 56.222480],
        [-79.607330, 56.134467],
        [-79.435170, 56.414211],
        [-79.453725, 56.559516],
        [-79.525380, 56.293647],
        [-80.025706, 55.900336],
        [-79.909047, 55.825263],
        [-79.470815, 56.121039],
        [-79.545888, 56.043769]
    ],
    [
        [-79.905914, 56.866848],
        [-79.951731, 56.785224],
        [-79.888051, 56.749091],
        [-79.817372, 56.831610],
        [-79.905914, 56.866848]
    ],
    [
        [-77.921620, 58.332831],
        [-77.949452, 58.326606],
        [-77.921620, 58.332831]
    ],
    [
        [-78.641591, 58.628323],
        [-78.696197, 58.696601],
        [-78.683176, 58.620836],
        [-78.641591, 58.628323]
    ],
    [
        [-180.000000, 70.992010],
        [-177.930491, 71.041449],
        [-177.443430, 71.237006],
        [-178.394846, 71.540717],
        [-179.999989, 71.536689]
    ],
    [
        [59.034353, 75.959866],
        [58.693207, 75.903266],
        [58.731700, 75.916897],
        [59.034353, 75.959866]
    ],
    [
        [59.001720, 79.980618],
        [58.768728, 80.021064],
        [59.529145, 80.120917],
        [59.927257, 79.994859],
        [59.001720, 79.980618]
    ],
    [
        [55.712087, 80.103461],
        [56.129893, 80.351223],
        [57.021983, 80.364000],
        [57.153575, 80.198961],
        [56.956798, 80.066311],
        [55.712087, 80.103461]
    ],
    [
        [52.622895, 80.183295],
        [52.182872, 80.276068],
        [53.149587, 80.412584],
        [53.869477, 80.270941],
        [52.622895, 80.183295]
    ],
    [
        [57.528819, 80.131415],
        [56.946056, 80.481513],
        [58.390961, 80.320217],
        [58.076915, 80.261786],
        [58.406505, 80.165595],
        [57.528819, 80.131415]
    ],
    [
        [53.798025, 80.472886],
        [53.972911, 80.529283],
        [53.883311, 80.610745],
        [54.465099, 80.481513],
        [53.798025, 80.472886]
    ],
    [
        [60.256196, 81.036363],
        [60.612804, 81.092475],
        [61.701671, 81.105292],
        [60.987804, 80.922024],
        [60.022716, 80.995429],
        [60.256196, 81.036363]
    ],
    [
        [62.770518, 80.885565],
        [64.036469, 80.986884],
        [64.704845, 81.205268],
        [65.229828, 81.136705],
        [65.465668, 80.934882],
        [63.130707, 80.683092],
        [62.503673, 80.824123],
        [62.770518, 80.885565]
    ],
    [
        [57.336192, 81.205268],
        [57.887869, 81.245551],
        [58.083751, 81.214545],
        [57.336192, 81.205268]
    ],
    [
        [55.646821, 81.200263],
        [55.431651, 81.283433],
        [56.544770, 81.254788],
        [56.335948, 81.385199],
        [56.726248, 81.397162],
        [55.646821, 81.200263]
    ],
    [
        [58.563487, 81.324408],
        [58.563487, 81.324408]
    ],
    [
        [61.903656, 81.604926],
        [62.141124, 81.586086],
        [62.196300, 81.564846],
        [61.903656, 81.604926]
    ],
    [
        [-162.339792, -82.923761],
        [-162.481516, -82.876642],
        [-163.811391, -82.846938],
        [-163.261301, -83.080987],
        [-162.339792, -82.923761]
    ],
    [
        [-169.030344, -83.154229],
        [-171.820505, -82.824640],
        [-171.901357, -82.842055],
        [-169.030344, -83.154229]
    ],
    [
        [-158.346832, -81.901462],
        [-158.892201, -81.781834],
        [-159.019154, -81.787693],
        [-158.098500, -82.095798],
        [-157.808583, -82.039158],
        [-158.346832, -81.901462]
    ],
    [
        [-160.571116, -81.598891],
        [-160.413889, -81.573663],
        [-162.983876, -81.270278],
        [-163.990061, -81.403497],
        [-160.571116, -81.598891]
    ],
    [
        [-154.114247, -80.037042],
        [-153.894602, -80.020929],
        [-154.114247, -80.037042]
    ],
    [
        [-155.719350, -79.769138],
        [-155.790476, -79.770115],
        [-155.855417, -79.797459],
        [-155.719350, -79.769138]
    ],
    [
        [-163.099721, -79.745294],
        [-162.687367, -79.814874],
        [-162.734242, -79.793878],
        [-163.099721, -79.745294]
    ],
    [
        [-29.618316, -79.911228],
        [-30.797353, -79.650079],
        [-30.928944, -79.684259],
        [-31.644765, -79.636895],
        [-32.161773, -79.709649],
        [-30.366444, -80.017755],
        [-29.989084, -79.965590],
        [-30.252349, -79.886163],
        [-30.095448, -79.856215],
        [-29.618316, -79.911228]
    ],
    [
        [-159.842152, -79.348565],
        [-162.353220, -78.752618],
        [-163.242991, -78.706313],
        [-164.177805, -79.003513],
        [-164.326527, -79.287367],
        [-160.712880, -79.854587],
        [-158.953074, -79.769708],
        [-159.842152, -79.348565]
    ],
    [
        [-149.018666, -77.480076],
        [-148.832021, -77.448337],
        [-149.208852, -77.439874],
        [-149.207712, -77.456720],
        [-149.018666, -77.480076]
    ],
    [
        [-148.918853, -77.384861],
        [-149.336415, -77.283461],
        [-149.669789, -77.304376],
        [-149.391672, -77.382257],
        [-148.918853, -77.384861]
    ],
    [
        [-150.483795, -77.343194],
        [-150.985178, -77.222345],
        [-151.511464, -77.270766],
        [-150.498484, -77.375584],
        [-150.349965, -77.345473],
        [-150.483795, -77.343194]
    ],
    [
        [-153.047231, -77.240004],
        [-153.116282, -77.206150],
        [-153.108754, -77.264907],
        [-153.047231, -77.240004]
    ],
    [
        [-147.249582, -77.188572],
        [-147.515248, -77.161310],
        [-147.601633, -77.184340],
        [-147.383372, -77.259047],
        [-147.249582, -77.188572]
    ],
    [
        [169.273448, -77.454522],
        [167.568126, -77.413263],
        [166.679454, -77.163344],
        [166.400076, -77.266534],
        [166.676117, -77.359959],
        [166.165538, -77.534845],
        [166.895681, -77.675714],
        [166.890636, -77.712498],
        [166.677257, -77.859959],
        [167.408051, -77.643976],
        [168.872569, -77.640395],
        [169.364431, -77.522068],
        [169.273448, -77.454522]
    ],
    [
        [-154.561879, -77.113539],
        [-154.187123, -77.154392],
        [-154.035756, -77.130060],
        [-154.284006, -77.064142],
        [-154.561879, -77.113539]
    ],
    [
        [166.915050, -76.931329],
        [166.853282, -76.936212],
        [166.977306, -76.962660],
        [166.956554, -76.938409],
        [166.915050, -76.931329]
    ],
    [
        [-148.533559, -76.949640],
        [-149.215891, -76.897638],
        [-149.304799, -76.912042],
        [-148.533559, -76.949640]
    ],
    [
        [-149.728749, -77.129490],
        [-149.224355, -77.118097],
        [-149.840037, -76.878025],
        [-150.801137, -76.990004],
        [-149.728749, -77.129490]
    ],
    [
        [-146.164784, -76.931329],
        [-146.249745, -76.880955],
        [-147.072133, -76.823907],
        [-147.130198, -76.881768],
        [-147.031484, -77.005304],
        [-146.164784, -76.931329]
    ],
    [
        [-148.529530, -76.796563],
        [-148.529530, -76.796563]
    ],
    [
        [-150.232615, -76.777520],
        [-150.078074, -76.738458],
        [-150.875478, -76.740492],
        [-150.601796, -76.796645],
        [-150.232615, -76.777520]
    ],
    [
        [-148.717478, -76.707208],
        [-148.467885, -76.677179],
        [-148.717478, -76.707208]
    ],
    [
        [-147.729766, -76.654474],
        [-148.006174, -76.573663],
        [-147.992340, -76.599054],
        [-147.729766, -76.654474]
    ],
    [
        [-146.810333, -76.595961],
        [-147.240631, -76.505466],
        [-147.365468, -76.617446],
        [-146.951283, -76.716974],
        [-146.839711, -76.701104],
        [-147.063832, -76.628106],
        [-146.810333, -76.595961]
    ],
    [
        [-147.460479, -76.097752],
        [-147.062001, -76.246759],
        [-146.661285, -76.275567],
        [-146.908315, -76.107029],
        [-147.460479, -76.097752]
    ],
    [
        [162.917166, -75.558282],
        [162.767833, -75.576104],
        [162.576508, -75.662774],
        [162.813487, -75.693292],
        [162.917166, -75.558282]
    ],
    [
        [-145.440378, -75.580011],
        [-145.870758, -75.504571],
        [-146.159779, -75.569757],
        [-145.200795, -75.685805],
        [-145.440378, -75.580011]
    ],
    [
        [162.487966, -75.457208],
        [162.533702, -75.484063],
        [162.617849, -75.459161],
        [162.570811, -75.422947],
        [162.487966, -75.457208]
    ],
    [
        [-132.571156, -74.388442],
        [-132.837026, -74.426365],
        [-132.898508, -74.426365],
        [-132.531850, -74.498956],
        [-132.342275, -74.404474],
        [-132.571156, -74.388442]
    ],
    [
        [-130.920481, -74.444268],
        [-131.683705, -74.320489],
        [-132.181264, -74.423761],
        [-131.205922, -74.607110],
        [-130.920481, -74.444268]
    ],
    [
        [-127.128489, -74.469415],
        [-127.758046, -74.342706],
        [-128.189198, -74.316095],
        [-128.088246, -74.488539],
        [-127.551747, -74.643650],
        [-127.128489, -74.469415]
    ],
    [
        [-117.168528, -74.356378],
        [-117.168528, -74.356378]
    ],
    [
        [-132.121897, -74.149591],
        [-132.184885, -74.129327],
        [-132.300526, -74.134942],
        [-132.174672, -74.173110],
        [-132.121897, -74.149591]
    ],
    [
        [-116.140696, -73.902520],
        [-116.403391, -73.867283],
        [-117.400258, -74.132501],
        [-116.599355, -74.141778],
        [-116.140696, -73.902520]
    ],
    [
        [-119.821034, -74.120782],
        [-119.223134, -74.044122],
        [-118.870839, -73.885675],
        [-119.903554, -73.824965],
        [-119.636098, -74.001235],
        [-119.929555, -74.084649],
        [-119.821034, -74.120782]
    ],
    [
        [-120.261220, -73.927830],
        [-120.735178, -73.879490],
        [-120.378041, -73.830987],
        [-120.540151, -73.753351],
        [-122.272369, -73.682224],
        [-123.120229, -73.682794],
        [-123.349762, -73.838800],
        [-122.327382, -73.915704],
        [-123.028188, -74.248305],
        [-122.243479, -74.413263],
        [-121.099029, -74.348077],
        [-120.944244, -74.308689],
        [-121.027211, -74.155857],
        [-120.261220, -73.927830]
    ],
    [
        [169.961681, -73.514418],
        [169.751638, -73.320082],
        [169.458751, -73.554946],
        [169.666189, -73.631036],
        [169.961681, -73.514418]
    ],
    [
        [-127.473175, -73.549574],
        [-127.166005, -73.602634],
        [-127.251210, -73.728936],
        [-126.546539, -73.670343],
        [-126.475453, -73.842218],
        [-124.784250, -74.226007],
        [-123.928293, -74.261814],
        [-123.754384, -74.072524],
        [-124.534291, -73.727634],
        [-124.992421, -73.882257],
        [-125.865305, -73.781020],
        [-125.212799, -73.639825],
        [-126.104075, -73.296157],
        [-127.148997, -73.277276],
        [-127.495432, -73.429620],
        [-127.473175, -73.549574]
    ],
    [
        [68.778738, -72.116469],
        [68.647472, -72.109308],
        [68.394705, -72.297052],
        [68.809093, -72.239841],
        [68.778738, -72.116469]
    ],
    [
        [69.924490, -71.908949],
        [69.774099, -71.896580],
        [69.682791, -71.975030],
        [69.787364, -72.055434],
        [69.924490, -71.908949]
    ],
    [
        [-3.228098, -71.052830],
        [-3.415028, -71.129978],
        [-2.944569, -71.225030],
        [-3.179067, -71.110121],
        [-3.228098, -71.052830]
    ],
    [
        [-2.717681, -70.820082],
        [-2.504628, -70.731541],
        [-3.585561, -70.738377],
        [-2.667307, -70.993748],
        [-2.862172, -71.053481],
        [-2.799957, -71.167739],
        [-2.080719, -70.825616],
        [-2.717681, -70.820082]
    ],
    [
        [1.951345, -70.604262],
        [2.054047, -70.673517],
        [2.145193, -70.650079],
        [2.065278, -70.601007],
        [1.951345, -70.604262]
    ],
    [
        [-5.939849, -70.422621],
        [-6.086903, -70.406345],
        [-6.453765, -70.444431],
        [-6.150054, -70.614841],
        [-5.884918, -70.549412],
        [-5.939849, -70.422621]
    ],
    [
        [3.219900, -70.392348],
        [3.049815, -70.385431],
        [2.580821, -70.524347],
        [3.063243, -70.593438],
        [3.219900, -70.392348]
    ],
    [
        [72.200369, -70.607029],
        [71.808360, -70.265883],
        [71.623302, -70.354750],
        [71.786957, -70.607843],
        [72.200369, -70.607029]
    ],
    [
        [4.048839, -70.302992],
        [4.331391, -70.504490],
        [4.621755, -70.352716],
        [4.468761, -70.244561],
        [4.048839, -70.302992]
    ],
    [
        [5.465587, -70.255304],
        [5.642914, -70.329522],
        [5.825857, -70.303969],
        [5.654633, -70.225681],
        [5.465587, -70.255304]
    ],
    [
        [161.811860, -70.241469],
        [161.855724, -70.261163],
        [161.920421, -70.240655],
        [161.867686, -70.217462],
        [161.811860, -70.241469]
    ],
    [
        [6.272716, -70.122735],
        [6.432465, -70.214532],
        [6.536469, -70.207208],
        [6.451671, -70.136977],
        [6.272716, -70.122735]
    ],
    [
        [26.765636, -70.224298],
        [26.327403, -70.066583],
        [25.912283, -70.284926],
        [26.817882, -70.424086],
        [26.765636, -70.224298]
    ],
    [
        [1.410981, -70.040216],
        [0.979503, -70.065606],
        [0.956798, -70.191664],
        [1.197765, -70.406427],
        [1.465017, -70.150486],
        [1.410981, -70.040216]
    ],
    [
        [10.988048, -70.045994],
        [10.894216, -70.017836],
        [10.539806, -70.011489],
        [10.812022, -70.075860],
        [10.988048, -70.045994]
    ],
    [
        [72.639903, -69.995701],
        [72.637055, -69.969822],
        [72.411957, -70.074802],
        [72.731130, -70.022556],
        [72.639903, -69.995701]
    ],
    [
        [16.246837, -69.705987],
        [15.721853, -69.763930],
        [15.554942, -69.872735],
        [16.171560, -70.072931],
        [16.288748, -69.849867],
        [16.637218, -69.742852],
        [16.246837, -69.705987]
    ],
    [
        [47.875662, -67.564467],
        [47.558849, -67.520929],
        [47.411306, -67.621759],
        [47.923350, -67.586602],
        [47.875662, -67.564467]
    ],
    [
        [120.665050, -66.896580],
        [120.479991, -66.950128],
        [120.531993, -66.969008],
        [120.866384, -66.886814],
        [120.665050, -66.896580]
    ],
    [
        [121.127778, -66.779474],
        [121.048106, -66.788832],
        [121.127778, -66.779474]
    ],
    [
        [85.659272, -66.743666],
        [85.345388, -66.719171],
        [85.258637, -66.766209],
        [85.613048, -66.986586],
        [85.941173, -66.889907],
        [85.659272, -66.743666]
    ],
    [
        [48.773692, -66.720473],
        [48.375255, -66.699151],
        [48.281586, -66.767185],
        [48.763357, -66.783298],
        [48.773692, -66.720473]
    ],
    [
        [86.548595, -66.703058],
        [86.332286, -66.678155],
        [86.230479, -66.730401],
        [86.403168, -66.795994],
        [86.675792, -66.719659],
        [86.548595, -66.703058]
    ],
    [
        [85.202403, -66.567966],
        [85.110688, -66.520685],
        [85.054861, -66.606215],
        [85.342540, -66.604750],
        [85.202403, -66.567966]
    ],
    [
        [98.588552, -66.387953],
        [98.791189, -66.487400],
        [98.953298, -66.418145],
        [98.711681, -66.364028],
        [98.588552, -66.387953]
    ],
    [
        [97.405528, -66.403497],
        [97.167735, -66.325942],
        [97.010509, -66.381036],
        [97.393728, -66.430271],
        [97.405528, -66.403497]
    ],
    [
        [162.626150, -66.462498],
        [162.556326, -66.436619],
        [162.297862, -66.254815],
        [162.290212, -66.397638],
        [162.626150, -66.462498]
    ],
    [
        [100.306488, -66.130141],
        [100.205821, -66.114679],
        [100.064789, -66.204278],
        [100.253673, -66.222833],
        [100.306488, -66.130141]
    ],
    [
        [96.917166, -66.054376],
        [96.467621, -66.050714],
        [96.296560, -66.183526],
        [96.908458, -66.211358],
        [97.030935, -66.140558],
        [96.917166, -66.054376]
    ],
    [
        [100.797699, -65.777276],
        [100.558604, -65.784356],
        [100.399669, -65.854669],
        [101.025564, -65.812595],
        [100.797699, -65.777276]
    ],
    [
        [92.496267, -65.703139],
        [92.350271, -65.694757],
        [92.235850, -65.750665],
        [92.668956, -65.784845],
        [92.496267, -65.703139]
    ],
    [
        [100.565929, -65.403009],
        [100.298025, -65.658624],
        [100.967052, -65.682875],
        [101.261404, -65.540297],
        [100.565929, -65.403009]
    ],
    [
        [103.291270, -65.392022],
        [103.093110, -65.173598],
        [102.752208, -65.178318],
        [103.172211, -65.460626],
        [103.416026, -65.448663],
        [103.291270, -65.392022]
    ],
    [
        [-28.213287, -56.713962],
        [-28.187123, -56.726251],
        [-28.168568, -56.715997],
        [-28.171457, -56.704848],
        [-28.213287, -56.713962]
    ],
    [
        [77.532888, -38.709161],
        [77.510916, -38.705743],
        [77.516368, -38.735447],
        [77.549327, -38.731134],
        [77.532888, -38.709161]
    ],
    [
        [-130.745269, -23.924412],
        [-130.753082, -23.929620],
        [-130.750844, -23.934666],
        [-130.742096, -23.927830],
        [-130.745269, -23.924412]
    ],
    [
        [-176.213490, -22.323907],
        [-176.210194, -22.338800],
        [-176.198110, -22.331964],
        [-176.204213, -22.326918],
        [-176.213490, -22.323907]
    ],
    [
        [40.379731, -22.323907],
        [40.336436, -22.320489],
        [40.339122, -22.359633],
        [40.368663, -22.362563],
        [40.379731, -22.323907]
    ],
    [
        [174.615896, -21.711114],
        [174.596853, -21.698419],
        [174.594005, -21.668715],
        [174.626638, -21.676528],
        [174.615896, -21.711114]
    ],
    [
        [-136.738759, -21.317153],
        [-136.744781, -21.315851],
        [-136.746938, -21.316176],
        [-136.742340, -21.320082],
        [-136.738759, -21.317153]
    ],
    [
        [154.391287, -21.030043],
        [154.391287, -21.028741],
        [154.388520, -21.029067],
        [154.391287, -21.030043]
    ],
    [
        [-139.135365, -20.799737],
        [-139.141469, -20.803155],
        [-139.135813, -20.799737],
        [-139.135365, -20.799737]
    ],
    [
        [-178.719024, -20.670994],
        [-178.731028, -20.657647],
        [-178.724965, -20.642348],
        [-178.708119, -20.671319],
        [-178.719024, -20.670994]
    ],
    [
        [-157.312815, -20.155206],
        [-157.324412, -20.141697],
        [-157.348988, -20.143324],
        [-157.340321, -20.175714],
        [-157.312815, -20.155206]
    ],
    [
        [-158.078318, -19.994236],
        [-158.120310, -19.972833],
        [-158.135203, -19.976495],
        [-158.115102, -20.015720],
        [-158.078318, -19.994236]
    ],
    [
        [-158.268300, -19.832615],
        [-158.281077, -19.821954],
        [-158.276357, -19.823500],
        [-158.268300, -19.832615]
    ],
    [
        [-178.226796, -19.840020],
        [-178.220041, -19.827895],
        [-178.216135, -19.815199],
        [-178.228953, -19.829034],
        [-178.226796, -19.840020]
    ],
    [
        [-158.287668, -19.810642],
        [-158.295969, -19.814548],
        [-158.297353, -19.817315],
        [-158.293772, -19.816583],
        [-158.287668, -19.810642]
    ],
    [
        [-158.925160, -19.269220],
        [-158.950185, -19.254490],
        [-158.955556, -19.245294],
        [-158.918080, -19.261163],
        [-158.925160, -19.269220]
    ],
    [
        [-178.419789, -19.167413],
        [-178.401112, -19.133477],
        [-178.392934, -19.127537],
        [-178.391957, -19.165785],
        [-178.419789, -19.167413]
    ],
    [
        [-178.899648, -18.877130],
        [-178.879872, -18.854262],
        [-178.930613, -18.882094],
        [-178.914866, -18.884047],
        [-178.899648, -18.877130]
    ],
    [
        [-174.653798, -18.817478],
        [-174.664133, -18.801365],
        [-174.649607, -18.779555],
        [-174.626820, -18.797540],
        [-174.653798, -18.817478]
    ],
    [
        [-178.507110, -18.665216],
        [-178.516306, -18.649998],
        [-178.499216, -18.633722],
        [-178.486073, -18.651788],
        [-178.507110, -18.665216]
    ],
    [
        [-179.322581, -17.770196],
        [-179.280751, -17.760186],
        [-179.298085, -17.723240],
        [-179.334218, -17.740004],
        [-179.322581, -17.770196]
    ],
    [
        [-179.156606, -17.471368],
        [-179.175486, -17.439711],
        [-179.145579, -17.424249],
        [-179.130808, -17.453709],
        [-179.156606, -17.471368]
    ],
    [
        [-179.157297, -17.272719],
        [-179.156687, -17.254083],
        [-179.134389, -17.252130],
        [-179.130808, -17.277032],
        [-179.157297, -17.272719]
    ],
    [
        [-144.106842, -16.723891],
        [-144.080068, -16.717218],
        [-144.050893, -16.759454],
        [-144.110707, -16.739679],
        [-144.106842, -16.723891]
    ],
    [
        [-168.161570, -14.532892],
        [-168.173085, -14.523696],
        [-168.160471, -14.520929],
        [-168.161570, -14.532892]
    ],
    [
        [-169.676218, -14.174900],
        [-169.658193, -14.168878],
        [-169.635610, -14.177016],
        [-169.660146, -14.189142],
        [-169.676218, -14.174900]
    ],
    [
        [166.672699, -13.455011],
        [166.658458, -13.415460],
        [166.673839, -13.407647],
        [166.688731, -13.423435],
        [166.672699, -13.455011]
    ],
    [
        [168.812266, -12.266290],
        [168.797862, -12.281915],
        [168.802419, -12.290623],
        [168.825857, -12.281508],
        [168.812266, -12.266290]
    ],
    [
        [-171.072825, -11.052504],
        [-171.085642, -11.051365],
        [-171.081532, -11.066095],
        [-171.073476, -11.062107],
        [-171.072825, -11.052504]
    ],
    [
        [-165.824534, -10.881768],
        [-165.811757, -10.880141],
        [-165.807688, -10.881280],
        [-165.818715, -10.891534],
        [-165.824534, -10.881768]
    ],
    [
        [105.704112, -10.430841],
        [105.594249, -10.454034],
        [105.584972, -10.516371],
        [105.694591, -10.564874],
        [105.704112, -10.430841]
    ],
    [
        [152.094493, -10.402032],
        [152.107677, -10.400567],
        [152.110118, -10.391290],
        [152.099132, -10.390883],
        [152.094493, -10.402032]
    ],
    [
        [165.745291, -10.421645],
        [165.755056, -10.406915],
        [165.732188, -10.389907],
        [165.722911, -10.412856],
        [165.745291, -10.421645]
    ],
    [
        [-160.986236, -10.382094],
        [-160.986195, -10.382094],
        [-160.986236, -10.382094]
    ],
    [
        [151.869640, -10.344822],
        [151.877452, -10.334161],
        [151.868419, -10.337823],
        [151.869640, -10.344822]
    ],
    [
        [151.852712, -10.259535],
        [151.856619, -10.264907],
        [151.862315, -10.250258],
        [151.852712, -10.259535]
    ],
    [
        [-161.088002, -10.035089],
        [-161.088002, -10.035089],
        [-161.070058, -10.027439],
        [-161.087270, -10.044610],
        [-161.088002, -10.035089]
    ],
    [
        [179.906749, -9.399347],
        [179.898611, -9.386814],
        [179.905284, -9.420668],
        [179.906098, -9.418634],
        [179.906749, -9.399347]
    ],
    [
        [179.867849, -9.343194],
        [179.867442, -9.344334],
        [179.876964, -9.362970],
        [179.873302, -9.346856],
        [179.867849, -9.343194]
    ],
    [
        [-171.190663, -9.356378],
        [-171.199696, -9.344334],
        [-171.190663, -9.356378]
    ],
    [
        [-172.486073, -8.565362],
        [-172.494944, -8.554783],
        [-172.483632, -8.586521],
        [-172.486073, -8.565362]
    ],
    [
        [160.635753, -7.891046],
        [160.607595, -7.888849],
        [160.647960, -7.926853],
        [160.635753, -7.891046]
    ],
    [
        [130.066661, -7.762628],
        [130.030935, -7.762628],
        [130.025645, -7.772556],
        [130.080333, -7.787367],
        [130.066661, -7.762628]
    ],
    [
        [130.007823, -7.724867],
        [130.000987, -7.706720],
        [129.982595, -7.704848],
        [129.997244, -7.748224],
        [130.007823, -7.724867]
    ],
    [
        [129.675141, -7.571547],
        [129.694591, -7.577569],
        [129.713878, -7.558201],
        [129.658539, -7.535089],
        [129.675141, -7.571547]
    ],
    [
        [178.682791, -7.491469],
        [178.667979, -7.463637],
        [178.665212, -7.454034],
        [178.691091, -7.475356],
        [178.682791, -7.491469]
    ],
    [
        [129.125011, -6.993259],
        [129.150401, -6.991469],
        [129.144786, -6.962091],
        [129.117442, -6.972752],
        [129.125011, -6.993259]
    ],
    [
        [129.484548, -6.755304],
        [129.511567, -6.769708],
        [129.529063, -6.723077],
        [129.486339, -6.729099],
        [129.484548, -6.755304]
    ],
    [
        [130.013682, -6.328383],
        [130.026052, -6.318455],
        [129.997813, -6.309747],
        [129.998709, -6.317153],
        [130.013682, -6.328383]
    ],
    [
        [127.551280, -5.512384],
        [127.561371, -5.517267],
        [127.555186, -5.506606],
        [127.551280, -5.512384]
    ],
    [
        [127.554861, -5.490492],
        [127.545909, -5.495294],
        [127.556977, -5.499770],
        [127.554861, -5.490492]
    ],
    [
        [127.790050, -5.409601],
        [127.803396, -5.407647],
        [127.798513, -5.400160],
        [127.790050, -5.409601]
    ],
    [
        [127.776866, -5.348810],
        [127.785167, -5.352960],
        [127.779063, -5.342869],
        [127.776866, -5.348810]
    ],
    [
        [131.986501, -5.317641],
        [131.962413, -5.343520],
        [131.965587, -5.388767],
        [132.016287, -5.330824],
        [131.986501, -5.317641]
    ],
    [
        [-174.506418, -4.689142],
        [-174.516713, -4.684259],
        [-174.521555, -4.683852],
        [-174.501536, -4.697361],
        [-174.506418, -4.689142]
    ],
    [
        [-174.529286, -4.682712],
        [-174.540110, -4.672052],
        [-174.541737, -4.672784],
        [-174.533884, -4.680759],
        [-174.529286, -4.682712]
    ],
    [
        [-174.500844, -4.691095],
        [-174.501536, -4.687677],
        [-174.524403, -4.664483],
        [-174.543406, -4.660252],
        [-174.500844, -4.691095]
    ],
    [
        [129.757823, -4.522556],
        [129.770274, -4.539321],
        [129.778331, -4.524509],
        [129.757823, -4.522556]
    ],
    [
        [-171.259958, -4.444106],
        [-171.244985, -4.441339],
        [-171.230051, -4.460545],
        [-171.259633, -4.465265],
        [-171.259958, -4.444106]
    ],
    [
        [144.600271, -3.499770],
        [144.595876, -3.517348],
        [144.619802, -3.516290],
        [144.618663, -3.508722],
        [144.600271, -3.499770]
    ],
    [
        [144.061569, -3.215308],
        [144.115155, -3.247935],
        [144.134499, -3.230088],
        [144.095799, -3.188539],
        [144.061569, -3.215308]
    ],
    [
        [-171.093577, -3.131443],
        [-171.090037, -3.120864],
        [-171.085439, -3.111261],
        [-171.092478, -3.145440],
        [-171.093577, -3.131443]
    ],
    [
        [142.818126, -1.733331],
        [142.833507, -1.697035],
        [142.865489, -1.703302],
        [142.844900, -1.712660],
        [142.818126, -1.733331]
    ],
    [
        [169.538910, -0.874607],
        [169.522634, -0.860528],
        [169.545177, -0.847914],
        [169.555349, -0.866143],
        [169.538910, -0.874607]
    ],
    [
        [73.097504, -0.599705],
        [73.094900, -0.604669],
        [73.097504, -0.599705]
    ],
    [
        [-160.029978, -0.376153],
        [-160.029937, -0.376153],
        [-160.008901, -0.372491],
        [-160.024770, -0.388767],
        [-160.029978, -0.376153]
    ],
    [
        [-176.485829, 0.196519],
        [-176.479319, 0.190334],
        [-176.475290, 0.193101],
        [-176.476877, 0.197455],
        [-176.485829, 0.196519]
    ],
    [
        [-176.459543, 0.225898],
        [-176.463938, 0.221869],
        [-176.459177, 0.219224],
        [-176.459543, 0.225898]
    ],
    [
        [134.310313, 0.756496],
        [134.322520, 0.730536],
        [134.346934, 0.752021],
        [134.342947, 0.765204],
        [134.310313, 0.756496]
    ],
    [
        [-176.636179, 0.790188],
        [-176.640492, 0.801988],
        [-176.639027, 0.806952],
        [-176.636098, 0.803412],
        [-176.636179, 0.790188]
    ],
    [
        [-29.408030, 0.884833],
        [-29.410268, 0.834866],
        [-29.349029, 0.852607],
        [-29.356191, 0.882758],
        [-29.408030, 0.884833]
    ],
    [
        [154.808116, 0.927802],
        [154.798595, 0.924465],
        [154.801768, 0.918199],
        [154.817638, 0.922187],
        [154.808116, 0.927802]
    ],
    [
        [154.714854, 0.965562],
        [154.726817, 0.960639],
        [154.732921, 0.967027],
        [154.721934, 0.969184],
        [154.714854, 0.965562]
    ],
    [
        [154.793142, 0.972113],
        [154.784353, 0.975491],
        [154.778168, 0.968817],
        [154.792328, 0.962877],
        [154.793142, 0.972113]
    ],
    [
        [131.236339, 1.019355],
        [131.244151, 1.029731],
        [131.244884, 1.035346],
        [131.237071, 1.024970],
        [131.236339, 1.019355]
    ],
    [
        [131.255626, 1.068793],
        [131.253591, 1.052639],
        [131.254893, 1.044257],
        [131.271169, 1.072008],
        [131.255626, 1.068793]
    ],
    [
        [126.394867, 1.339342],
        [126.347179, 1.323310],
        [126.380870, 1.283393],
        [126.401622, 1.332017],
        [126.394867, 1.339342]
    ],
    [
        [-91.819163, 1.386420],
        [-91.825307, 1.377021],
        [-91.817738, 1.368069],
        [-91.810943, 1.377183],
        [-91.819163, 1.386420]
    ],
    [
        [-91.822011, 1.394477],
        [-91.820465, 1.391343],
        [-91.817535, 1.394761],
        [-91.822011, 1.394477]
    ],
    [
        [-92.011586, 1.658637],
        [-92.006663, 1.649604],
        [-91.999827, 1.651190],
        [-92.006093, 1.664374],
        [-92.011586, 1.658637]
    ],
    [
        [73.365001, 1.791083],
        [73.365164, 1.791042],
        [73.375824, 1.788560],
        [73.368175, 1.782945],
        [73.365001, 1.791083]
    ],
    [
        [73.400238, 1.806342],
        [73.402110, 1.795600],
        [73.394379, 1.794745],
        [73.394786, 1.798774],
        [73.400238, 1.806342]
    ],
    [
        [73.452647, 1.826809],
        [73.463634, 1.826321],
        [73.456716, 1.820380],
        [73.452647, 1.826809]
    ],
    [
        [73.518077, 1.842719],
        [73.499197, 1.827704],
        [73.498057, 1.828803],
        [73.502289, 1.834906],
        [73.518077, 1.842719]
    ],
    [
        [73.536469, 1.870103],
        [73.532970, 1.861640],
        [73.532400, 1.860093],
        [73.531505, 1.863511],
        [73.536469, 1.870103]
    ],
    [
        [73.251720, 1.892401],
        [73.243663, 1.888739],
        [73.243988, 1.894110],
        [73.251720, 1.892401]
    ],
    [
        [73.553071, 1.932440],
        [73.548839, 1.911363],
        [73.549815, 1.924994],
        [73.553071, 1.932440]
    ],
    [
        [73.550059, 1.976386],
        [73.549815, 1.965684],
        [73.549815, 1.965522],
        [73.547699, 1.968329],
        [73.550059, 1.976386]
    ],
    [
        [73.317231, 1.991400],
        [73.323253, 1.986477],
        [73.318370, 1.983100],
        [73.315440, 1.985053],
        [73.317231, 1.991400]
    ],
    [
        [73.544200, 2.026597],
        [73.542979, 2.022162],
        [73.540294, 2.022528],
        [73.542247, 2.024563],
        [73.544200, 2.026597]
    ],
    [
        [73.386974, 2.033026],
        [73.386241, 2.030341],
        [73.386974, 2.028632],
        [73.386974, 2.033026]
    ],
    [
        [173.289724, 2.033840],
        [173.257823, 1.997016],
        [173.278005, 2.058661],
        [173.318370, 1.976996],
        [173.304454, 1.961575],
        [173.289724, 2.033840]
    ],
    [
        [73.555675, 2.082506],
        [73.551443, 2.072577],
        [73.551280, 2.078070],
        [73.555675, 2.082506]
    ],
    [
        [73.567638, 2.109931],
        [73.585378, 2.109605],
        [73.585460, 2.109605],
        [73.561778, 2.094713],
        [73.567638, 2.109931]
    ],
    [
        [125.393403, 2.118232],
        [125.354259, 2.129869],
        [125.334239, 2.081855],
        [125.403168, 2.102769],
        [125.393403, 2.118232]
    ],
    [
        [73.043712, 2.166449],
        [73.041352, 2.164700],
        [73.038259, 2.164537],
        [73.038422, 2.164618],
        [73.043712, 2.166449]
    ],
    [
        [73.103852, 2.186591],
        [73.102306, 2.180976],
        [73.099457, 2.181952],
        [73.098888, 2.184638],
        [73.103852, 2.186591]
    ],
    [
        [73.115489, 2.199693],
        [73.116873, 2.197659],
        [73.120860, 2.191799],
        [73.115001, 2.191799],
        [73.115489, 2.199693]
    ],
    [
        [72.948416, 2.274888],
        [72.946300, 2.272366],
        [72.943126, 2.273017],
        [72.948416, 2.274888]
    ],
    [
        [72.926117, 2.327460],
        [72.927013, 2.316067],
        [72.922537, 2.319566],
        [72.926117, 2.327460]
    ],
    [
        [73.344005, 2.348049],
        [73.343598, 2.344184],
        [73.342052, 2.342108],
        [73.344005, 2.348049]
    ],
    [
        [73.354259, 2.437201],
        [73.366222, 2.411526],
        [73.362559, 2.384914],
        [73.353852, 2.429023],
        [73.354259, 2.437201]
    ],
    [
        [73.314789, 2.505805],
        [73.315196, 2.494127],
        [73.315196, 2.494045],
        [73.311534, 2.499254],
        [73.314789, 2.505805]
    ],
    [
        [73.145518, 2.553290],
        [73.143809, 2.550360],
        [73.140961, 2.550360],
        [73.145518, 2.553290]
    ],
    [
        [72.900076, 2.682196],
        [72.906423, 2.679674],
        [72.904470, 2.675727],
        [72.901134, 2.676174],
        [72.900076, 2.682196]
    ],
    [
        [72.872569, 2.694159],
        [72.873709, 2.683661],
        [72.873709, 2.683580],
        [72.866954, 2.688951],
        [72.872569, 2.694159]
    ],
    [
        [73.022309, 2.741685],
        [73.032237, 2.745103],
        [73.028005, 2.738227],
        [73.022309, 2.741685]
    ],
    [
        [73.353526, 2.778266],
        [73.353526, 2.771918],
        [73.351410, 2.770697],
        [73.348481, 2.775377],
        [73.353526, 2.778266]
    ],
    [
        [73.399262, 2.785712],
        [73.390636, 2.775377],
        [73.391856, 2.781480],
        [73.399262, 2.785712]
    ],
    [
        [73.548595, 2.892727],
        [73.551036, 2.890611],
        [73.549083, 2.888129],
        [73.549083, 2.888739],
        [73.548595, 2.892727]
    ],
    [
        [73.360362, 2.903876],
        [73.362804, 2.898383],
        [73.360688, 2.897528],
        [73.357270, 2.899807],
        [73.360362, 2.903876]
    ],
    [
        [73.008474, 2.953315],
        [73.014903, 2.947414],
        [73.009044, 2.946438],
        [73.008474, 2.953315]
    ],
    [
        [73.564220, 2.954739],
        [73.564220, 2.954617],
        [73.562022, 2.946112],
        [73.561290, 2.948472],
        [73.564220, 2.954739]
    ],
    [
        [73.585948, 2.961615],
        [73.585867, 2.961534],
        [73.577485, 2.951158],
        [73.578461, 2.957343],
        [73.585948, 2.961615]
    ],
    [
        [72.870128, 2.969184],
        [72.867686, 2.960883],
        [72.865082, 2.958157],
        [72.864919, 2.960883],
        [72.870128, 2.969184]
    ],
    [
        [131.142100, 3.047309],
        [131.138438, 3.018948],
        [131.192068, 3.048814],
        [131.183604, 3.060289],
        [131.142100, 3.047309]
    ],
    [
        [72.901622, 3.083808],
        [72.906016, 3.080390],
        [72.899913, 3.076850],
        [72.899425, 3.078192],
        [72.901622, 3.083808]
    ],
    [
        [73.613048, 3.106757],
        [73.612559, 3.102973],
        [73.608409, 3.100409],
        [73.613048, 3.106757]
    ],
    [
        [72.977875, 3.110175],
        [72.981781, 3.105048],
        [72.978201, 3.102729],
        [72.975108, 3.104193],
        [72.977875, 3.110175]
    ],
    [
        [73.042247, 3.205471],
        [73.046886, 3.202053],
        [73.040701, 3.198472],
        [73.040212, 3.199774],
        [73.042247, 3.205471]
    ],
    [
        [73.031749, 3.252997],
        [73.035655, 3.247789],
        [73.031993, 3.245551],
        [73.028982, 3.246894],
        [73.031749, 3.252997]
    ],
    [
        [72.833263, 3.312486],
        [72.837657, 3.309068],
        [72.831391, 3.305609],
        [72.831228, 3.306830],
        [72.833263, 3.312486]
    ],
    [
        [73.516368, 3.361233],
        [73.518809, 3.359117],
        [73.519216, 3.356391],
        [73.516368, 3.361233]
    ],
    [
        [73.747569, 3.451117],
        [73.748546, 3.448188],
        [73.753184, 3.446357],
        [73.747732, 3.450995],
        [73.747569, 3.451117]
    ],
    [
        [73.505870, 3.501207],
        [73.506114, 3.497707],
        [73.508556, 3.496487],
        [73.508474, 3.496568],
        [73.505870, 3.501207]
    ],
    [
        [72.952403, 3.733832],
        [72.955821, 3.728705],
        [72.951996, 3.726874],
        [72.948985, 3.728583],
        [72.952403, 3.733832]
    ],
    [
        [72.945811, 3.772121],
        [72.949392, 3.766995],
        [72.945323, 3.765204],
        [72.942393, 3.766995],
        [72.945811, 3.772121]
    ],
    [
        [154.879242, 3.751939],
        [154.894298, 3.762844],
        [154.891856, 3.778795],
        [154.876720, 3.767971],
        [154.879242, 3.751939]
    ],
    [
        [154.789317, 3.791815],
        [154.771251, 3.781480],
        [154.773692, 3.766262],
        [154.791759, 3.776557],
        [154.789317, 3.791815]
    ],
    [
        [72.944591, 3.836859],
        [72.948090, 3.831692],
        [72.944102, 3.829901],
        [72.941173, 3.831692],
        [72.944591, 3.836859]
    ],
    [
        [73.437266, 3.846625],
        [73.435232, 3.844916],
        [73.432302, 3.841702],
        [73.432465, 3.846829],
        [73.437266, 3.846625]
    ],
    [
        [73.443533, 3.920559],
        [73.443044, 3.918769],
        [73.438162, 3.916449],
        [73.443533, 3.920559]
    ],
    [
        [73.345063, 3.944729],
        [73.341482, 3.943101],
        [73.341482, 3.942043],
        [73.344900, 3.944566],
        [73.345063, 3.944729]
    ],
    [
        [-81.611724, 3.958970],
        [-81.601430, 3.988349],
        [-81.582265, 3.991523],
        [-81.580312, 3.976020],
        [-81.611724, 3.958970]
    ],
    [
        [73.422618, 4.118354],
        [73.421397, 4.116360],
        [73.418956, 4.115709],
        [73.422618, 4.118354]
    ],
    [
        [73.546197, 4.243039],
        [73.512015, 4.186301],
        [73.431201, 4.184649],
        [73.510891, 4.162087],
        [73.546197, 4.243039]
    ],
    [
        [72.945160, 4.266303],
        [72.958669, 4.262519],
        [72.954356, 4.261461],
        [72.945160, 4.266303]
    ],
    [
        [73.595876, 4.342271],
        [73.592459, 4.340155],
        [73.589122, 4.340562],
        [73.595876, 4.342271]
    ],
    [
        [73.611501, 4.363105],
        [73.611827, 4.356513],
        [73.609548, 4.355618],
        [73.607677, 4.358100],
        [73.611501, 4.363105]
    ],
    [
        [73.637950, 4.370551],
        [73.637055, 4.363959],
        [73.633637, 4.364691],
        [73.631684, 4.368476],
        [73.637950, 4.370551]
    ],
    [
        [73.667979, 4.393500],
        [73.668305, 4.386868],
        [73.666189, 4.385932],
        [73.664317, 4.388332],
        [73.667979, 4.393500]
    ],
    [
        [72.957042, 4.438300],
        [72.956065, 4.422105],
        [72.947113, 4.423082],
        [72.943370, 4.431586],
        [72.957042, 4.438300]
    ],
    [
        [73.553559, 4.620510],
        [73.553884, 4.613918],
        [73.551606, 4.612982],
        [73.549815, 4.615383],
        [73.553559, 4.620510]
    ],
    [
        [-160.410390, 4.709174],
        [-160.395375, 4.704779],
        [-160.378896, 4.713284],
        [-160.401194, 4.723090],
        [-160.410390, 4.709174]
    ],
    [
        [132.220388, 5.292222],
        [132.213878, 5.307115],
        [132.220225, 5.310248],
        [132.226736, 5.304348],
        [132.220388, 5.292222]
    ],
    [
        [153.667735, 5.286038],
        [153.685313, 5.309719],
        [153.710704, 5.314602],
        [153.707693, 5.305365],
        [153.667735, 5.286038]
    ],
    [
        [73.629568, 5.418524],
        [73.636729, 5.402899],
        [73.632498, 5.386054],
        [73.627778, 5.413275],
        [73.629568, 5.418524]
    ],
    [
        [73.005626, 5.463202],
        [73.002615, 5.457587],
        [73.000987, 5.456244],
        [72.999034, 5.461086],
        [73.005626, 5.463202]
    ],
    [
        [72.883962, 5.494086],
        [72.881114, 5.488471],
        [72.879161, 5.487860],
        [72.877696, 5.492133],
        [72.883962, 5.494086]
    ],
    [
        [126.591156, 5.557115],
        [126.595470, 5.548407],
        [126.602875, 5.564032],
        [126.598643, 5.565375],
        [126.591156, 5.557115]
    ],
    [
        [73.019054, 5.617825],
        [73.016124, 5.612250],
        [73.014008, 5.611558],
        [73.012869, 5.615709],
        [73.019054, 5.617825]
    ],
    [
        [169.114513, 5.638129],
        [169.120616, 5.647406],
        [169.116466, 5.649237],
        [169.114513, 5.638129]
    ],
    [
        [73.014659, 5.676988],
        [73.011892, 5.671536],
        [73.009776, 5.670844],
        [73.008556, 5.675035],
        [73.014659, 5.676988]
    ],
    [
        [73.392833, 5.737698],
        [73.380707, 5.714586],
        [73.379568, 5.715155],
        [73.382579, 5.722113],
        [73.392833, 5.737698]
    ],
    [
        [72.986827, 5.770738],
        [72.985850, 5.765570],
        [72.982758, 5.762519],
        [72.986827, 5.770738]
    ],
    [
        [157.161876, 5.773871],
        [157.158946, 5.777899],
        [157.158458, 5.779202],
        [157.163910, 5.778713],
        [157.161876, 5.773871]
    ],
    [
        [73.382335, 5.794989],
        [73.384532, 5.786933],
        [73.380707, 5.784125],
        [73.376801, 5.787340],
        [73.382335, 5.794989]
    ],
    [
        [72.976573, 5.813625],
        [72.975108, 5.804551],
        [72.975108, 5.804429],
        [72.971039, 5.810452],
        [72.976573, 5.813625]
    ],
    [
        [73.449880, 5.840766],
        [73.433767, 5.830878],
        [73.433442, 5.830715],
        [73.443126, 5.841254],
        [73.449880, 5.840766]
    ],
    [
        [72.963634, 5.864325],
        [72.963715, 5.864040],
        [72.966482, 5.850246],
        [72.961925, 5.856676],
        [72.963634, 5.864325]
    ],
    [
        [73.429047, 5.911363],
        [73.428477, 5.904446],
        [73.426280, 5.903266],
        [73.423188, 5.906887],
        [73.429047, 5.911363]
    ],
    [
        [72.931651, 5.969062],
        [72.930186, 5.956936],
        [72.925792, 5.963284],
        [72.931651, 5.969062]
    ],
    [
        [73.389822, 5.970282],
        [73.395333, 5.957802],
        [73.384532, 5.964748],
        [73.389822, 5.970282]
    ],
    [
        [72.915701, 5.981350],
        [72.912852, 5.976304],
        [72.909841, 5.977932],
        [72.909679, 5.982123],
        [72.915701, 5.981350]
    ],
    [
        [73.250743, 6.083401],
        [73.249034, 6.079535],
        [73.245453, 6.079779],
        [73.250743, 6.083401]
    ],
    [
        [73.252126, 6.111233],
        [73.248871, 6.110175],
        [73.246837, 6.107733],
        [73.251964, 6.111151],
        [73.252126, 6.111233]
    ],
    [
        [73.220470, 6.132066],
        [73.219005, 6.129299],
        [73.215180, 6.128567],
        [73.220470, 6.132066]
    ],
    [
        [73.270274, 6.156928],
        [73.267263, 6.150946],
        [73.265147, 6.150621],
        [73.265391, 6.153551],
        [73.270274, 6.156928]
    ],
    [
        [73.219086, 6.172349],
        [73.215831, 6.171210],
        [73.214041, 6.168769],
        [73.218923, 6.172268],
        [73.219086, 6.172349]
    ],
    [
        [73.270844, 6.189439],
        [73.270844, 6.189358],
        [73.268077, 6.178697],
        [73.265961, 6.185004],
        [73.270844, 6.189439]
    ],
    [
        [73.034190, 6.222357],
        [73.030447, 6.221015],
        [73.028982, 6.218817],
        [73.029145, 6.218980],
        [73.034190, 6.222357]
    ],
    [
        [73.241710, 6.239691],
        [73.243907, 6.231635],
        [73.240245, 6.228949],
        [73.236339, 6.232123],
        [73.241710, 6.239691]
    ],
    [
        [73.128429, 6.286851],
        [73.126150, 6.284003],
        [73.122895, 6.283352],
        [73.128429, 6.286851]
    ],
    [
        [73.215180, 6.294827],
        [73.209321, 6.286851],
        [73.213064, 6.289211],
        [73.215180, 6.294827]
    ],
    [
        [73.083344, 6.308580],
        [73.081391, 6.305609],
        [73.078136, 6.305080],
        [73.083344, 6.308580]
    ],
    [
        [73.197032, 6.327460],
        [73.201915, 6.322170],
        [73.201020, 6.318264],
        [73.194184, 6.321601],
        [73.197032, 6.327460]
    ],
    [
        [73.124522, 6.332506],
        [73.120942, 6.331041],
        [73.119314, 6.328925],
        [73.124197, 6.332261],
        [73.124522, 6.332506]
    ],
    [
        [73.187266, 6.350775],
        [73.182140, 6.346340],
        [73.180186, 6.347113],
        [73.181000, 6.349840],
        [73.187266, 6.350775]
    ],
    [
        [73.020518, 6.368964],
        [73.024913, 6.364814],
        [73.024181, 6.362698],
        [73.019298, 6.363593],
        [73.020518, 6.368964]
    ],
    [
        [72.690929, 6.411607],
        [72.687185, 6.407416],
        [72.685883, 6.406480],
        [72.685883, 6.411607],
        [72.690929, 6.411607]
    ],
    [
        [72.902843, 6.440172],
        [72.907481, 6.435940],
        [72.906586, 6.433824],
        [72.902029, 6.434760],
        [72.902843, 6.440172]
    ],
    [
        [73.048813, 6.441342],
        [73.043142, 6.433702],
        [73.046235, 6.436265],
        [73.048813, 6.441342]
    ],
    [
        [72.962087, 6.559027],
        [72.958018, 6.554348],
        [72.955821, 6.555325],
        [72.956798, 6.560004],
        [72.962087, 6.559027]
    ],
    [
        [72.924001, 6.565253],
        [72.928722, 6.561103],
        [72.927745, 6.558905],
        [72.923106, 6.559882],
        [72.924001, 6.565253]
    ],
    [
        [73.029959, 6.582343],
        [73.030447, 6.576077],
        [73.028168, 6.575181],
        [73.025564, 6.579250],
        [73.029959, 6.582343]
    ],
    [
        [73.044770, 6.621894],
        [73.040701, 6.617174],
        [73.038422, 6.618150],
        [73.039399, 6.622870],
        [73.044770, 6.621894]
    ],
    [
        [73.069509, 6.667955],
        [73.061778, 6.660956],
        [73.062266, 6.666897],
        [73.069509, 6.667955]
    ],
    [
        [73.105968, 6.709947],
        [73.100434, 6.699774],
        [73.095876, 6.698432],
        [73.096690, 6.706122],
        [73.105968, 6.709947]
    ],
    [
        [149.315766, 6.696926],
        [149.316905, 6.709906],
        [149.323497, 6.719468],
        [149.324718, 6.707099],
        [149.315766, 6.696926]
    ],
    [
        [157.936371, 6.717190],
        [157.939220, 6.727362],
        [157.948904, 6.731676],
        [157.945811, 6.722602],
        [157.936371, 6.717190]
    ],
    [
        [73.036632, 6.759711],
        [73.036876, 6.753485],
        [73.034679, 6.752590],
        [73.031993, 6.756578],
        [73.036632, 6.759711]
    ],
    [
        [72.918468, 6.763983],
        [72.914317, 6.759223],
        [72.912283, 6.760159],
        [72.913259, 6.764879],
        [72.918468, 6.763983]
    ],
    [
        [73.159516, 6.786526],
        [73.135997, 6.741197],
        [73.131684, 6.725043],
        [73.152843, 6.749213],
        [73.159516, 6.786526]
    ],
    [
        [73.181651, 6.830512],
        [73.197276, 6.828111],
        [73.183767, 6.821112],
        [73.181651, 6.830512]
    ],
    [
        [72.995779, 6.841498],
        [72.991547, 6.836737],
        [72.989431, 6.837633],
        [72.990245, 6.842434],
        [72.995779, 6.841498]
    ],
    [
        [73.144379, 6.843411],
        [73.140310, 6.838690],
        [73.138031, 6.839667],
        [73.139008, 6.844428],
        [73.144379, 6.843411]
    ],
    [
        [72.976085, 6.852851],
        [72.976329, 6.846666],
        [72.974132, 6.845852],
        [72.971528, 6.849758],
        [72.976085, 6.852851]
    ],
    [
        [73.098155, 6.852200],
        [73.094005, 6.847561],
        [73.091807, 6.848334],
        [73.092947, 6.853095],
        [73.098155, 6.852200]
    ],
    [
        [72.964692, 6.860663],
        [72.960623, 6.856024],
        [72.958344, 6.857001],
        [72.959239, 6.861640],
        [72.964692, 6.860663]
    ],
    [
        [73.106212, 6.896715],
        [73.106619, 6.890448],
        [73.104340, 6.889553],
        [73.101736, 6.893541],
        [73.106212, 6.896715]
    ],
    [
        [73.214041, 6.918606],
        [73.213064, 6.904608],
        [73.203949, 6.884955],
        [73.201915, 6.902248],
        [73.214041, 6.918606]
    ],
    [
        [134.159679, 6.884467],
        [134.136729, 6.919094],
        [134.139659, 6.934272],
        [134.173188, 6.924872],
        [134.159679, 6.884467]
    ],
    [
        [72.925955, 6.957424],
        [72.926280, 6.953803],
        [72.924585, 6.951704],
        [72.925955, 6.957424]
    ],
    [
        [73.198497, 6.971340],
        [73.194672, 6.951239],
        [73.193207, 6.950995],
        [73.191905, 6.967597],
        [73.198497, 6.971340]
    ],
    [
        [72.891938, 6.991034],
        [72.891938, 6.987698],
        [72.890473, 6.985419],
        [72.891938, 6.991034]
    ],
    [
        [72.979747, 7.027737],
        [72.979747, 7.027533],
        [72.981456, 7.013983],
        [72.977306, 7.019029],
        [72.979747, 7.027737]
    ],
    [
        [72.949962, 7.056545],
        [72.947765, 7.053900],
        [72.948497, 7.050849],
        [72.949962, 7.056423],
        [72.949962, 7.056545]
    ],
    [
        [171.792247, 7.054999],
        [171.770193, 7.028876],
        [171.792247, 7.054999]
    ],
    [
        [72.912852, 7.092719],
        [72.912852, 7.092597],
        [72.911876, 7.083197],
        [72.906586, 7.091010],
        [72.912852, 7.092719]
    ],
    [
        [72.883800, 7.107245],
        [72.884532, 7.103705],
        [72.882498, 7.101630],
        [72.882498, 7.101630],
        [72.883800, 7.107245]
    ],
    [
        [151.856781, 7.316596],
        [151.853201, 7.353827],
        [151.854503, 7.370063],
        [151.865571, 7.350653],
        [151.856781, 7.316596]
    ],
    [
        [149.185720, 7.371649],
        [149.180837, 7.381171],
        [149.188243, 7.379788],
        [149.185720, 7.371649]
    ],
    [
        [168.965587, 7.574652],
        [168.968598, 7.571234],
        [168.969737, 7.583889],
        [168.965587, 7.595364],
        [168.938487, 7.596381],
        [168.965587, 7.574652]
    ],
    [
        [167.401703, 8.317816],
        [167.399669, 8.310777],
        [167.407725, 8.307278],
        [167.401703, 8.317816]
    ],
    [
        [150.407481, 8.575507],
        [150.404633, 8.586005],
        [150.409353, 8.584662],
        [150.407481, 8.575507]
    ],
    [
        [149.668712, 8.574693],
        [149.667817, 8.604234],
        [149.687266, 8.616034],
        [149.688813, 8.607327],
        [149.668712, 8.574693]
    ],
    [
        [167.731619, 8.724595],
        [167.740001, 8.733222],
        [167.740245, 8.743842],
        [167.730317, 8.735256],
        [167.731619, 8.724595]
    ],
    [
        [119.959727, 8.880601],
        [119.958344, 8.877183],
        [119.960623, 8.877102],
        [119.959727, 8.880601]
    ],
    [
        [119.969249, 8.880927],
        [119.971934, 8.882392],
        [119.968272, 8.884101],
        [119.969249, 8.880927]
    ],
    [
        [119.965343, 8.887193],
        [119.963227, 8.887030],
        [119.964854, 8.884996],
        [119.966075, 8.885688],
        [119.965343, 8.887193]
    ],
    [
        [119.967784, 8.891547],
        [119.965668, 8.891425],
        [119.967296, 8.889350],
        [119.968516, 8.890041],
        [119.967784, 8.891547]
    ],
    [
        [170.851736, 8.897773],
        [170.844737, 8.886501],
        [170.837413, 8.889065],
        [170.844574, 8.900784],
        [170.851736, 8.897773]
    ],
    [
        [150.118175, 8.976304],
        [150.124278, 8.985500],
        [150.132986, 8.986070],
        [150.130544, 8.980943],
        [150.118175, 8.976304]
    ],
    [
        [170.240245, 9.449774],
        [170.247081, 9.457750],
        [170.243907, 9.466376],
        [170.238780, 9.466702],
        [170.240245, 9.449774]
    ],
    [
        [97.869965, 9.425238],
        [97.853282, 9.461371],
        [97.895274, 9.467353],
        [97.894786, 9.438707],
        [97.869965, 9.425238]
    ],
    [
        [140.514171, 9.767808],
        [140.515391, 9.761176],
        [140.532888, 9.771918],
        [140.521739, 9.774726],
        [140.514171, 9.767808]
    ],
    [
        [115.367198, 10.237494],
        [115.367931, 10.239163],
        [115.365977, 10.239163],
        [115.367198, 10.237494]
    ],
    [
        [170.874685, 10.274604],
        [170.878754, 10.275092],
        [170.878591, 10.287177],
        [170.874522, 10.286607],
        [170.874685, 10.274604]
    ],
    [
        [108.942556, 10.551947],
        [108.958995, 10.537543],
        [108.960785, 10.502875],
        [108.930186, 10.514553],
        [108.942556, 10.551947]
    ],
    [
        [165.540212, 11.633775],
        [165.553722, 11.619818],
        [165.546886, 11.631008],
        [165.540212, 11.633775]
    ],
    [
        [165.282237, 11.695787],
        [165.282237, 11.708441],
        [165.286794, 11.710883],
        [165.288910, 11.705959],
        [165.282237, 11.695787]
    ],
    [
        [-66.749989, 11.777574],
        [-66.809560, 11.752956],
        [-66.854604, 11.751370],
        [-66.827789, 11.746243],
        [-66.749989, 11.777574]
    ],
    [
        [-66.733388, 11.869940],
        [-66.814809, 11.873236],
        [-66.817860, 11.871080],
        [-66.733388, 11.869940]
    ],
    [
        [-67.658030, 11.984931],
        [-67.674875, 11.989651],
        [-67.665883, 11.982001],
        [-67.658030, 11.984931]
    ],
    [
        [-67.680409, 12.025051],
        [-67.679067, 12.028144],
        [-67.681549, 12.025784],
        [-67.680409, 12.025051]
    ],
    [
        [-67.677602, 12.027818],
        [-67.676666, 12.026923],
        [-67.677235, 12.030015],
        [-67.677602, 12.027818]
    ],
    [
        [-67.677235, 12.050238],
        [-67.676991, 12.046332],
        [-67.676096, 12.044420],
        [-67.674672, 12.048407],
        [-67.677235, 12.050238]
    ],
    [
        [-67.681386, 12.063707],
        [-67.684438, 12.063463],
        [-67.681020, 12.061835],
        [-67.681386, 12.063707]
    ],
    [
        [-67.687327, 12.065579],
        [-67.687082, 12.067532],
        [-67.688832, 12.068996],
        [-67.687327, 12.065579]
    ],
    [
        [121.723969, 12.913967],
        [121.718272, 12.947333],
        [121.688650, 12.947170],
        [121.699067, 12.905341],
        [121.723969, 12.913967]
    ],
    [
        [121.088634, 13.530341],
        [121.085785, 13.570624],
        [121.043468, 13.567572],
        [121.072113, 13.535834],
        [121.088634, 13.530341]
    ],
    [
        [169.010753, 14.610175],
        [168.998302, 14.599026],
        [169.013682, 14.610500],
        [169.010753, 14.610175]
    ],
    [
        [-63.639882, 15.696031],
        [-63.643625, 15.700588],
        [-63.634592, 15.700588],
        [-63.635487, 15.694037],
        [-63.639882, 15.696031]
    ],
    [
        [145.789236, 16.675482],
        [145.769054, 16.694770],
        [145.804535, 16.693061],
        [145.789236, 16.675482]
    ],
    [
        [145.854991, 17.285793],
        [145.835948, 17.305162],
        [145.868175, 17.301744],
        [145.854991, 17.285793]
    ],
    [
        [145.854259, 17.566881],
        [145.832205, 17.577460],
        [145.834239, 17.605780],
        [145.862966, 17.598538],
        [145.854259, 17.566881]
    ],
    [
        [-63.427968, 18.592841],
        [-63.423573, 18.600043],
        [-63.428822, 18.601264],
        [-63.427968, 18.592841]
    ],
    [
        [166.619395, 19.281643],
        [166.644216, 19.275580],
        [166.652354, 19.284247],
        [166.634776, 19.305732],
        [166.619395, 19.281643]
    ],
    [
        [145.405610, 19.652777],
        [145.382091, 19.672797],
        [145.382091, 19.684149],
        [145.409923, 19.684475],
        [145.405610, 19.652777]
    ],
    [
        [145.250743, 20.009711],
        [145.226736, 20.029771],
        [145.238780, 20.050442],
        [145.272797, 20.032375],
        [145.250743, 20.009711]
    ],
    [
        [144.915701, 20.517157],
        [144.902110, 20.540025],
        [144.919688, 20.555406],
        [144.932465, 20.537502],
        [144.915701, 20.517157]
    ],
    [
        [109.100922, 21.021186],
        [109.127696, 21.032172],
        [109.122732, 21.065416],
        [109.090505, 21.041938],
        [109.100922, 21.021186]
    ],
    [
        [121.936697, 21.065619],
        [121.934825, 21.073228],
        [121.929698, 21.064521],
        [121.936697, 21.065619]
    ],
    [
        [121.947439, 21.116156],
        [121.949067, 21.106879],
        [121.954275, 21.118394],
        [121.947439, 21.116156]
    ],
    [
        [121.460704, 22.659003],
        [121.496104, 22.634670],
        [121.502778, 22.669501],
        [121.457530, 22.675930],
        [121.460704, 22.659003]
    ],
    [
        [-161.947865, 23.038031],
        [-161.944773, 23.046210],
        [-161.940419, 23.045600],
        [-161.940907, 23.041978],
        [-161.947865, 23.038031]
    ],
    [
        [-79.514027, 23.495673],
        [-79.514027, 23.495673]
    ],
    [
        [-79.563344, 23.546698],
        [-79.588694, 23.571357],
        [-79.594350, 23.574652],
        [-79.563344, 23.546698]
    ],
    [
        [-164.704335, 23.579332],
        [-164.704335, 23.579332],
        [-164.699086, 23.570543],
        [-164.708485, 23.574530],
        [-164.704335, 23.579332]
    ],
    [
        [141.452973, 24.222398],
        [141.463145, 24.212104],
        [141.470714, 24.219184],
        [141.469981, 24.226264],
        [141.452973, 24.222398]
    ],
    [
        [153.972992, 24.289700],
        [153.983653, 24.282945],
        [153.985606, 24.291083],
        [153.981212, 24.295356],
        [153.972992, 24.289700]
    ],
    [
        [54.266368, 24.294501],
        [54.222179, 24.284491],
        [54.184581, 24.337063],
        [54.232432, 24.357571],
        [54.266368, 24.294501]
    ],
    [
        [-167.996775, 25.001125],
        [-168.002797, 25.014797],
        [-167.999867, 25.016425],
        [-167.995554, 25.011664],
        [-167.996775, 25.001125]
    ],
    [
        [141.287446, 25.417711],
        [141.274669, 25.427069],
        [141.274750, 25.451117],
        [141.297537, 25.445299],
        [141.287446, 25.417711]
    ],
    [
        [-79.268707, 25.538560],
        [-79.264312, 25.528795],
        [-79.262115, 25.528062],
        [-79.266510, 25.537828],
        [-79.268707, 25.538560]
    ],
    [
        [-79.288930, 25.559149],
        [-79.288930, 25.559149]
    ],
    [
        [-171.722808, 25.773017],
        [-171.729360, 25.751939],
        [-171.739084, 25.756293],
        [-171.740671, 25.769029],
        [-171.722808, 25.773017]
    ],
    [
        [131.289724, 25.951361],
        [131.309581, 25.922756],
        [131.327891, 25.937079],
        [131.321300, 25.947699],
        [131.289724, 25.951361]
    ],
    [
        [-173.964996, 26.071357],
        [-173.965647, 26.058580],
        [-173.959950, 26.055325],
        [-173.959177, 26.059638],
        [-173.964996, 26.071357]
    ],
    [
        [127.222179, 26.598944],
        [127.214854, 26.577460],
        [127.244151, 26.586412],
        [127.242361, 26.596747],
        [127.222179, 26.598944]
    ],
    [
        [-113.244740, 26.724595],
        [-113.264556, 26.708930],
        [-113.138051, 26.665107],
        [-113.174428, 26.720445],
        [-113.244740, 26.724595]
    ],
    [
        [128.454356, 27.047512],
        [128.428966, 27.066474],
        [128.396251, 27.040758],
        [128.448578, 27.020697],
        [128.454356, 27.047512]
    ],
    [
        [142.189220, 27.145494],
        [142.184255, 27.158352],
        [142.190929, 27.185207],
        [142.204112, 27.173896],
        [142.189220, 27.145494]
    ],
    [
        [142.195323, 27.599107],
        [142.179454, 27.612494],
        [142.183116, 27.619452],
        [142.192882, 27.616197],
        [142.195323, 27.599107]
    ],
    [
        [142.080577, 27.716946],
        [142.078624, 27.727240],
        [142.082286, 27.729885],
        [142.085134, 27.726060],
        [142.080577, 27.716946]
    ],
    [
        [128.236583, 27.866523],
        [128.232270, 27.852851],
        [128.241547, 27.845364],
        [128.243419, 27.857245],
        [128.236583, 27.866523]
    ],
    [
        [-177.328928, 28.211086],
        [-177.335276, 28.204291],
        [-177.321156, 28.205878],
        [-177.322865, 28.207668],
        [-177.328928, 28.211086]
    ],
    [
        [-177.357655, 28.214423],
        [-177.378000, 28.212836],
        [-177.389597, 28.197659],
        [-177.372182, 28.202338],
        [-177.357655, 28.214423]
    ],
    [
        [-178.290381, 28.401679],
        [-178.287905, 28.392989],
        [-178.297988, 28.390993],
        [-178.290381, 28.401679]
    ],
    [
        [129.591563, 29.450100],
        [129.612315, 29.443345],
        [129.608084, 29.469224],
        [129.591319, 29.467963],
        [129.591563, 29.450100]
    ],
    [
        [129.527680, 29.902330],
        [129.539887, 29.889879],
        [129.554454, 29.897528],
        [129.535411, 29.909857],
        [129.527680, 29.902330]
    ],
    [
        [129.943696, 29.965277],
        [129.921990, 30.004730],
        [129.909028, 29.999335],
        [129.900645, 29.972561],
        [129.943696, 29.965277]
    ],
    [
        [-16.027984, 30.033596],
        [-16.027252, 30.029608],
        [-16.023020, 30.029242],
        [-16.023101, 30.032294],
        [-16.027984, 30.033596]
    ],
    [
        [-15.864410, 30.152533],
        [-15.874745, 30.137926],
        [-15.859771, 30.133287],
        [-15.855458, 30.146918],
        [-15.864410, 30.152533]
    ],
    [
        [140.307628, 30.491156],
        [140.306488, 30.473619],
        [140.325938, 30.485175],
        [140.317149, 30.491156],
        [140.307628, 30.491156]
    ],
    [
        [129.428233, 30.846422],
        [129.429454, 30.840888],
        [129.433849, 30.844550],
        [129.430919, 30.848212],
        [129.428233, 30.846422]
    ],
    [
        [129.946300, 30.844713],
        [129.932140, 30.851752],
        [129.903982, 30.834418],
        [129.939464, 30.813422],
        [129.946300, 30.844713]
    ],
    [
        [140.043468, 31.443101],
        [140.045665, 31.443305],
        [140.044444, 31.445054],
        [140.043468, 31.443101]
    ],
    [
        [140.041270, 31.444159],
        [140.043142, 31.444566],
        [140.041352, 31.446479],
        [140.041270, 31.444159]
    ],
    [
        [139.756358, 32.452297],
        [139.773774, 32.440985],
        [139.757091, 32.470364],
        [139.756358, 32.452297]
    ],
    [
        [139.299083, 33.650092],
        [139.299083, 33.650702],
        [139.296153, 33.651068],
        [139.299083, 33.650092]
    ],
    [
        [139.622813, 33.885565],
        [139.592459, 33.895819],
        [139.581309, 33.862535],
        [139.622895, 33.856757],
        [139.622813, 33.885565]
    ],
    [
        [127.309093, 34.020087],
        [127.295665, 34.061469],
        [127.280040, 34.057440],
        [127.295665, 34.014106],
        [127.323497, 34.005764],
        [127.309093, 34.020087]
    ],
    [
        [127.531912, 34.450588],
        [127.509939, 34.470038],
        [127.453380, 34.470608],
        [127.494640, 34.414252],
        [127.531912, 34.450588]
    ],
    [
        [127.782970, 34.506985],
        [127.748057, 34.551093],
        [127.707530, 34.533881],
        [127.771169, 34.488186],
        [127.782970, 34.506985]
    ],
    [
        [126.100108, 34.596747],
        [126.060069, 34.620795],
        [126.035167, 34.533922],
        [126.099376, 34.558661],
        [126.100108, 34.596747]
    ],
    [
        [126.038097, 34.569485],
        [126.060395, 34.584296],
        [126.028575, 34.634223],
        [126.020518, 34.571438],
        [126.038097, 34.569485]
    ],
    [
        [125.445811, 34.688463],
        [125.412852, 34.691962],
        [125.398774, 34.631985],
        [125.459239, 34.686835],
        [125.445811, 34.688463]
    ],
    [
        [126.174083, 34.732815],
        [126.163585, 34.754950],
        [126.069591, 34.769680],
        [126.111339, 34.717719],
        [126.174083, 34.732815]
    ],
    [
        [126.168712, 34.792304],
        [126.149425, 34.808092],
        [126.092540, 34.787584],
        [126.146251, 34.761868],
        [126.168712, 34.792304]
    ],
    [
        [126.079438, 34.822659],
        [126.115896, 34.803127],
        [126.152029, 34.871161],
        [126.067149, 34.850531],
        [126.079438, 34.822659]
    ],
    [
        [128.072765, 34.845120],
        [128.017833, 34.916571],
        [127.963634, 34.859768],
        [127.987315, 34.838080],
        [128.072765, 34.845120]
    ],
    [
        [126.246430, 34.916246],
        [126.253184, 34.933498],
        [126.222423, 34.931952],
        [126.225352, 34.913398],
        [126.246430, 34.916246]
    ],
    [
        [126.178396, 35.048489],
        [126.143809, 35.057685],
        [126.127778, 35.048163],
        [126.172374, 35.023627],
        [126.178396, 35.048489]
    ],
    [
        [128.842784, 35.021877],
        [128.836436, 35.059801],
        [128.804373, 35.056342],
        [128.826671, 34.992377],
        [128.842784, 35.021877]
    ],
    [
        [126.258067, 35.570624],
        [126.305675, 35.603217],
        [126.307302, 35.616645],
        [126.258962, 35.598375],
        [126.258067, 35.570624]
    ],
    [
        [12.859874, 35.872219],
        [12.845876, 35.862698],
        [12.872569, 35.852281],
        [12.874034, 35.866441],
        [12.859874, 35.872219]
    ],
    [
        [23.884288, 36.843573],
        [23.876720, 36.843695],
        [23.884288, 36.832343],
        [23.889008, 36.834296],
        [23.884288, 36.843573]
    ],
    [
        [23.459646, 36.921373],
        [23.449718, 36.929145],
        [23.463878, 36.903998],
        [23.467296, 36.906399],
        [23.459646, 36.921373]
    ],
    [
        [126.099864, 37.228013],
        [126.121593, 37.210924],
        [126.159190, 37.231920],
        [126.104747, 37.267524],
        [126.099864, 37.228013]
    ],
    [
        [126.484060, 37.278998],
        [126.443533, 37.273098],
        [126.435720, 37.238430],
        [126.469493, 37.233466],
        [126.484060, 37.278998]
    ],
    [
        [126.613943, 37.255194],
        [126.542979, 37.284980],
        [126.539317, 37.198065],
        [126.613536, 37.232815],
        [126.613943, 37.255194]
    ],
    [
        [125.688243, 37.679267],
        [125.679210, 37.669664],
        [125.687836, 37.651760],
        [125.706228, 37.672309],
        [125.688243, 37.679267]
    ],
    [
        [125.328787, 37.766669],
        [125.279470, 37.749416],
        [125.220551, 37.703762],
        [125.295746, 37.727607],
        [125.328787, 37.766669]
    ],
    [
        [125.147716, 37.785590],
        [125.190278, 37.809027],
        [125.191417, 37.815497],
        [125.141368, 37.799506],
        [125.147716, 37.785590]
    ],
    [
        [125.030447, 37.836168],
        [125.028494, 37.818834],
        [125.041759, 37.817288],
        [125.030447, 37.836168]
    ],
    [
        [124.716482, 37.846910],
        [124.676524, 37.824897],
        [124.684581, 37.799994],
        [124.714203, 37.809556],
        [124.716482, 37.846910]
    ],
    [
        [120.748383, 37.938707],
        [120.722423, 37.919094],
        [120.754568, 37.896674],
        [120.757335, 37.922675],
        [120.748383, 37.938707]
    ],
    [
        [120.606781, 37.979885],
        [120.601899, 37.969306],
        [120.622895, 37.948798],
        [120.625824, 37.972561],
        [120.606781, 37.979885]
    ],
    [
        [120.720063, 37.980943],
        [120.704112, 37.989651],
        [120.688243, 37.985256],
        [120.720470, 37.964016],
        [120.720063, 37.980943]
    ],
    [
        [120.760427, 38.170478],
        [120.742686, 38.187567],
        [120.746593, 38.161851],
        [120.773285, 38.159735],
        [120.760427, 38.170478]
    ],
    [
        [120.806488, 38.288235],
        [120.836192, 38.304267],
        [120.833751, 38.312567],
        [120.807384, 38.304877],
        [120.806488, 38.288235]
    ],
    [
        [120.914236, 38.384101],
        [120.924571, 38.386868],
        [120.917817, 38.395453],
        [120.906912, 38.392564],
        [120.914236, 38.384101]
    ],
    [
        [14.346446, 38.535142],
        [14.360850, 38.539049],
        [14.357188, 38.551215],
        [14.342784, 38.547268],
        [14.346446, 38.535142]
    ],
    [
        [14.576020, 38.576646],
        [14.563975, 38.584540],
        [14.542491, 38.586859],
        [14.551606, 38.561591],
        [14.576020, 38.576646]
    ],
    [
        [13.169281, 38.717271],
        [13.153494, 38.694770],
        [13.197439, 38.708319],
        [13.185720, 38.717515],
        [13.169281, 38.717271]
    ],
    [
        [15.227794, 38.810289],
        [15.212087, 38.810452],
        [15.187022, 38.789008],
        [15.217459, 38.773017],
        [15.227794, 38.810289]
    ],
    [
        [123.180675, 39.091946],
        [123.143565, 39.080878],
        [123.160655, 39.029242],
        [123.195567, 39.052069],
        [123.180675, 39.091946]
    ],
    [
        [124.687673, 39.527167],
        [124.680149, 39.507726],
        [124.697765, 39.502590],
        [124.707779, 39.530399],
        [124.687673, 39.527167]
    ],
    [
        [124.687022, 39.544745],
        [124.673839, 39.570624],
        [124.595876, 39.537909],
        [124.644786, 39.547675],
        [124.687022, 39.544745]
    ],
    [
        [13.418956, 40.795600],
        [13.414724, 40.785875],
        [13.431977, 40.801459],
        [13.424164, 40.800238],
        [13.418956, 40.795600]
    ],
    [
        [139.372895, 41.522162],
        [139.340343, 41.523830],
        [139.340831, 41.497504],
        [139.374278, 41.504340],
        [139.372895, 41.522162]
    ],
    [
        [-122.705393, 47.181952],
        [-122.746409, 47.153713],
        [-122.701080, 47.123969],
        [-122.671376, 47.164984],
        [-122.705393, 47.181952]
    ],
    [
        [-122.868153, 47.268297],
        [-122.848297, 47.193305],
        [-122.873850, 47.167873],
        [-122.921946, 47.237209],
        [-122.868153, 47.268297]
    ],
    [
        [-123.287221, 48.812812],
        [-123.306996, 48.764635],
        [-123.186676, 48.736396],
        [-123.250396, 48.766099],
        [-123.287221, 48.812812]
    ],
    [
        [-123.089019, 48.767524],
        [-123.043772, 48.788764],
        [-123.223500, 48.832668],
        [-123.185292, 48.774604],
        [-123.089019, 48.767524]
    ],
    [
        [-2.363759, 49.446845],
        [-2.375478, 49.435452],
        [-2.378082, 49.412746],
        [-2.354400, 49.427802],
        [-2.363759, 49.446845]
    ],
    [
        [-2.174469, 49.731391],
        [-2.218495, 49.718695],
        [-2.226226, 49.707831],
        [-2.187896, 49.710639],
        [-2.174469, 49.731391]
    ],
    [
        [-6.298818, 49.935492],
        [-6.309153, 49.913642],
        [-6.297271, 49.909613],
        [-6.284169, 49.922756],
        [-6.298818, 49.935492]
    ],
    [
        [-6.333648, 49.959703],
        [-6.348948, 49.964342],
        [-6.332509, 49.941718],
        [-6.326487, 49.949205],
        [-6.333648, 49.959703]
    ],
    [
        [-4.665435, 51.183580],
        [-4.676422, 51.193101],
        [-4.670481, 51.160102],
        [-4.663482, 51.164862],
        [-4.665435, 51.183580]
    ],
    [
        [-9.816965, 51.638861],
        [-9.881663, 51.641059],
        [-9.917877, 51.619371],
        [-9.799306, 51.636786],
        [-9.816965, 51.638861]
    ],
    [
        [-10.312652, 51.925523],
        [-10.351674, 51.931138],
        [-10.429026, 51.889838],
        [-10.322662, 51.903266],
        [-10.312652, 51.925523]
    ],
    [
        [-9.648346, 53.101711],
        [-9.696685, 53.136542],
        [-9.811431, 53.137600],
        [-9.660512, 53.090644],
        [-9.648346, 53.101711]
    ],
    [
        [8.634532, 54.542629],
        [8.618826, 54.492621],
        [8.700938, 54.547756],
        [8.698904, 54.558580],
        [8.634532, 54.542629]
    ],
    [
        [15.705333, 56.116400],
        [15.669119, 56.123928],
        [15.642345, 56.104641],
        [15.696788, 56.074286],
        [15.705333, 56.116400]
    ],
    [
        [-13.690419, 57.596259],
        [-13.690419, 57.597805],
        [-13.687652, 57.597154],
        [-13.688588, 57.596259],
        [-13.690419, 57.596259]
    ],
    [
        [23.260509, 57.813544],
        [23.224294, 57.823717],
        [23.217784, 57.800930],
        [23.270193, 57.785631],
        [23.260509, 57.813544]
    ],
    [
        [16.866710, 58.304592],
        [16.832530, 58.304185],
        [16.847423, 58.275458],
        [16.879080, 58.280585],
        [16.866710, 58.304592]
    ],
    [
        [16.891612, 58.333726],
        [16.859711, 58.400295],
        [16.785167, 58.380072],
        [16.827403, 58.327541],
        [16.891612, 58.333726]
    ],
    [
        [18.321462, 58.969143],
        [18.226410, 58.944729],
        [18.193614, 58.911322],
        [18.321462, 58.969143]
    ],
    [
        [18.198253, 59.009670],
        [18.103526, 59.022650],
        [18.050629, 58.960924],
        [18.144705, 58.969062],
        [18.198253, 59.009670]
    ],
    [
        [17.707286, 58.993354],
        [17.686697, 59.050360],
        [17.652192, 59.071519],
        [17.624278, 58.963935],
        [17.684825, 58.900824],
        [17.707286, 58.993354]
    ],
    [
        [11.070323, 59.079332],
        [11.003266, 59.086493],
        [10.991466, 59.033596],
        [11.046397, 59.026801],
        [11.070323, 59.079332]
    ],
    [
        [10.910492, 59.116441],
        [10.855479, 59.115383],
        [10.829112, 59.099433],
        [10.883800, 59.072170],
        [10.910492, 59.116441]
    ],
    [
        [-1.315094, 60.093736],
        [-1.345693, 60.108954],
        [-1.367909, 60.044827],
        [-1.333567, 60.043606],
        [-1.315094, 60.093736]
    ],
    [
        [5.289724, 60.074286],
        [5.205333, 60.117377],
        [5.171723, 60.049465],
        [5.268809, 59.994859],
        [5.289724, 60.074286]
    ],
    [
        [-2.053212, 60.155504],
        [-2.087880, 60.155463],
        [-2.112294, 60.138007],
        [-2.062978, 60.117987],
        [-2.053212, 60.155504]
    ],
    [
        [-1.062856, 60.164049],
        [-1.079457, 60.188300],
        [-1.134918, 60.178697],
        [-1.083892, 60.105170],
        [-1.062856, 60.164049]
    ],
    [
        [-0.918772, 60.386176],
        [-1.006418, 60.368964],
        [-1.034088, 60.340155],
        [-0.975982, 60.340318],
        [-0.918772, 60.386176]
    ],
    [
        [4.922374, 60.867499],
        [4.882823, 60.929999],
        [4.776866, 60.929999],
        [4.878754, 60.865139],
        [4.922374, 60.867499]
    ],
    [
        [4.721446, 61.040229],
        [4.700043, 61.082221],
        [4.643809, 61.057603],
        [4.706879, 60.988511],
        [4.721446, 61.040229]
    ],
    [
        [5.120291, 62.025784],
        [4.992931, 62.035061],
        [4.984223, 62.009467],
        [5.095225, 61.927436],
        [5.120291, 62.025784]
    ],
    [
        [-7.559722, 62.107733],
        [-7.588043, 62.115139],
        [-7.644154, 62.107001],
        [-7.536733, 62.098782],
        [-7.559722, 62.107733]
    ],
    [
        [-6.321441, 62.308092],
        [-6.384348, 62.280219],
        [-6.358510, 62.245836],
        [-6.276845, 62.296291],
        [-6.321441, 62.308092]
    ],
    [
        [5.635997, 62.319281],
        [5.728526, 62.326646],
        [5.741466, 62.360663],
        [5.603038, 62.328762],
        [5.635997, 62.319281]
    ],
    [
        [5.593923, 62.339789],
        [5.581716, 62.358832],
        [5.509939, 62.364000],
        [5.521332, 62.334866],
        [5.593923, 62.339789]
    ],
    [
        [-6.585276, 62.289862],
        [-6.648061, 62.366523],
        [-6.680816, 62.366116],
        [-6.636383, 62.280097],
        [-6.585276, 62.289862]
    ],
    [
        [-6.654693, 62.264065],
        [-6.765289, 62.373725],
        [-6.789052, 62.375312],
        [-6.691029, 62.252265],
        [-6.654693, 62.264065]
    ],
    [
        [-6.409169, 62.324042],
        [-6.449127, 62.317816],
        [-6.455719, 62.295966],
        [-6.409169, 62.324042]
    ],
    [
        [18.124685, 62.687934],
        [18.159841, 62.747138],
        [18.006114, 62.705552],
        [18.027029, 62.684516],
        [18.124685, 62.687934]
    ],
    [
        [8.314789, 63.181342],
        [8.235118, 63.222235],
        [8.165294, 63.213446],
        [8.209809, 63.161363],
        [8.314789, 63.181342]
    ],
    [
        [22.026215, 63.322211],
        [21.989024, 63.310370],
        [21.978282, 63.280015],
        [22.046641, 63.282172],
        [22.026215, 63.322211]
    ],
    [
        [22.144216, 63.251410],
        [22.114431, 63.284166],
        [22.208669, 63.273261],
        [22.231293, 63.338813],
        [22.069184, 63.318549],
        [22.144216, 63.251410]
    ],
    [
        [21.957205, 63.331610],
        [22.076182, 63.360053],
        [22.096039, 63.383490],
        [21.996430, 63.384711],
        [21.957205, 63.331610]
    ],
    [
        [9.160004, 63.647773],
        [9.057872, 63.661078],
        [9.014008, 63.626695],
        [9.076345, 63.612982],
        [9.160004, 63.647773]
    ],
    [
        [20.870860, 63.669379],
        [20.864594, 63.676744],
        [20.825938, 63.643622],
        [20.856130, 63.650946],
        [20.870860, 63.669379]
    ],
    [
        [-17.751291, 63.717841],
        [-17.790151, 63.713202],
        [-17.823313, 63.691392],
        [-17.764963, 63.681952],
        [-17.751291, 63.717841]
    ],
    [
        [20.898123, 63.754096],
        [20.880870, 63.742377],
        [20.864757, 63.683092],
        [20.948497, 63.774604],
        [20.898123, 63.754096]
    ],
    [
        [22.807953, 63.779527],
        [22.763845, 63.791449],
        [22.681488, 63.763414],
        [22.739594, 63.720526],
        [22.807953, 63.779527]
    ],
    [
        [9.930837, 64.027533],
        [9.888520, 64.049058],
        [9.843761, 64.033189],
        [9.892263, 63.997016],
        [9.930837, 64.027533]
    ],
    [
        [11.465505, 64.587836],
        [11.366466, 64.634426],
        [11.344493, 64.573676],
        [11.432872, 64.542426],
        [11.465505, 64.587836]
    ],
    [
        [11.350759, 64.651557],
        [11.303966, 64.692084],
        [11.167979, 64.659735],
        [11.312266, 64.599677],
        [11.350759, 64.651557]
    ],
    [
        [40.454926, 64.581855],
        [40.188487, 64.708238],
        [39.984223, 64.719224],
        [39.824229, 64.679755],
        [40.454926, 64.581855]
    ],
    [
        [40.001964, 64.737372],
        [39.949718, 64.741929],
        [39.943696, 64.727973],
        [39.980479, 64.729438],
        [40.001964, 64.737372]
    ],
    [
        [40.145193, 64.734280],
        [40.325694, 64.637641],
        [40.406749, 64.642483],
        [40.333507, 64.772406],
        [40.034841, 64.760565],
        [40.145193, 64.734280]
    ],
    [
        [36.012950, 65.051703],
        [35.927419, 65.054104],
        [35.891856, 65.040717],
        [36.005138, 65.026516],
        [36.012950, 65.051703]
    ],
    [
        [11.761729, 65.119371],
        [11.580333, 65.109687],
        [11.518809, 65.054592],
        [11.669444, 65.044908],
        [11.761729, 65.119371]
    ],
    [
        [36.211436, 65.158271],
        [35.990408, 65.191230],
        [35.942231, 65.154608],
        [36.211436, 65.158271]
    ],
    [
        [22.408051, 65.455268],
        [22.306407, 65.455390],
        [22.285167, 65.431627],
        [22.375662, 65.430732],
        [22.408051, 65.455268]
    ],
    [
        [22.153575, 65.430365],
        [22.231700, 65.418118],
        [22.233165, 65.423896],
        [22.174001, 65.474311],
        [22.153575, 65.430365]
    ],
    [
        [22.594900, 65.528266],
        [22.558930, 65.538275],
        [22.552989, 65.530097],
        [22.614268, 65.511908],
        [22.594900, 65.528266]
    ],
    [
        [22.218761, 65.506781],
        [22.280121, 65.478217],
        [22.358735, 65.503974],
        [22.186778, 65.537828],
        [22.218761, 65.506781]
    ],
    [
        [22.577973, 65.582750],
        [22.641449, 65.589097],
        [22.625824, 65.593411],
        [22.577973, 65.582750]
    ],
    [
        [22.570160, 65.594794],
        [22.589122, 65.593736],
        [22.604503, 65.600287],
        [22.554454, 65.605373],
        [22.570160, 65.594794]
    ],
    [
        [22.962657, 65.716295],
        [22.930024, 65.741889],
        [22.882172, 65.720445],
        [22.971934, 65.667060],
        [22.962657, 65.716295]
    ],
    [
        [23.797211, 65.753730],
        [23.689626, 65.748440],
        [23.681488, 65.721666],
        [23.738292, 65.696723],
        [23.797211, 65.753730]
    ],
    [
        [22.741059, 65.713609],
        [22.805431, 65.705227],
        [22.811371, 65.714097],
        [22.746837, 65.770413],
        [22.741059, 65.713609]
    ],
    [
        [-18.008941, 66.564154],
        [-18.017201, 66.544989],
        [-17.980458, 66.539049],
        [-17.976308, 66.548285],
        [-18.008941, 66.564154]
    ],
    [
        [54.329763, 68.311469],
        [54.239431, 68.303778],
        [54.199474, 68.256496],
        [54.316905, 68.259101],
        [54.329763, 68.311469]
    ],
    [
        [53.912283, 68.361965],
        [53.865733, 68.306952],
        [53.957693, 68.293362],
        [53.991466, 68.345852],
        [53.912283, 68.361965]
    ],
    [
        [49.049083, 68.678412],
        [48.812348, 68.696519],
        [49.049083, 68.678412]
    ],
    [
        [49.579275, 68.819281],
        [49.570323, 68.817084],
        [49.579275, 68.819281]
    ],
    [
        [54.266775, 68.816840],
        [54.192719, 68.813707],
        [54.395356, 68.782538],
        [54.374848, 68.790961],
        [54.266775, 68.816840]
    ],
    [
        [49.814301, 68.899482],
        [49.753103, 68.880316],
        [49.751720, 68.877427],
        [49.814301, 68.899482]
    ],
    [
        [54.974294, 68.939887],
        [54.927989, 68.940172],
        [54.911876, 68.930976],
        [55.019542, 68.915432],
        [54.974294, 68.939887]
    ],
    [
        [50.082856, 68.960924],
        [50.050059, 68.945502],
        [50.069835, 68.943061],
        [50.107677, 68.963528],
        [50.082856, 68.960924]
    ],
    [
        [17.547130, 69.092108],
        [17.419688, 69.079169],
        [17.344086, 69.003241],
        [17.418956, 68.996405],
        [17.547130, 69.092108]
    ],
    [
        [67.217296, 69.420559],
        [66.968435, 69.459418],
        [66.938650, 69.439399],
        [67.132172, 69.363918],
        [67.308279, 69.437690],
        [67.217296, 69.420559]
    ],
    [
        [67.327973, 69.572699],
        [67.188243, 69.570990],
        [67.021821, 69.476955],
        [67.258962, 69.438625],
        [67.327973, 69.572699]
    ],
    [
        [66.837087, 70.391913],
        [66.668468, 70.538275],
        [66.590343, 70.473049],
        [66.837087, 70.391913]
    ],
    [
        [66.559255, 70.544257],
        [66.479828, 70.763861],
        [66.427989, 70.799506],
        [66.397309, 70.630316],
        [66.559255, 70.544257]
    ],
    [
        [66.600434, 70.913764],
        [66.599620, 71.004381],
        [66.433930, 70.827135],
        [66.508474, 70.827948],
        [66.600434, 70.913764]
    ],
    [
        [24.836925, 71.094875],
        [24.712576, 71.107571],
        [24.614268, 71.056627],
        [24.770030, 71.026190],
        [24.836925, 71.094875]
    ],
    [
        [53.369802, 71.291734],
        [53.239919, 71.354438],
        [53.161469, 71.354885],
        [53.242198, 71.309475],
        [53.395356, 71.280504],
        [53.369802, 71.291734]
    ],
    [
        [152.875255, 76.151353],
        [152.829275, 76.196194],
        [152.554861, 76.139350],
        [152.773448, 76.083401],
        [152.875255, 76.151353]
    ],
    [
        [156.660981, 77.107611],
        [156.550304, 77.125800],
        [156.491710, 77.098212],
        [156.653331, 77.084174],
        [156.660981, 77.107611]
    ],
    [
        [92.062266, 77.629950],
        [91.943614, 77.643948],
        [91.865977, 77.628648],
        [92.110118, 77.610907],
        [92.062266, 77.629950]
    ],
    [
        [58.814789, 79.916693],
        [58.613943, 79.979438],
        [58.248302, 79.933417],
        [58.870372, 79.901313],
        [58.814789, 79.916693]
    ],
    [
        [60.167247, 80.168524],
        [60.052257, 80.187690],
        [60.210460, 80.149156],
        [60.167247, 80.168524]
    ],
    [
        [54.407725, 80.284817],
        [54.193533, 80.307115],
        [54.101248, 80.272895],
        [54.178071, 80.189276],
        [54.407725, 80.284817]
    ],
    [
        [55.498790, 80.316840],
        [55.296397, 80.332180],
        [54.929698, 80.259589],
        [55.234874, 80.227932],
        [55.498790, 80.316840]
    ],
    [
        [54.987478, 80.414374],
        [55.129893, 80.374335],
        [55.270518, 80.409369],
        [55.244965, 80.438463],
        [54.987478, 80.414374]
    ],
    [
        [54.841807, 80.431342],
        [54.626720, 80.477240],
        [54.390391, 80.386542],
        [54.771495, 80.393012],
        [54.841807, 80.431342]
    ],
    [
        [54.821462, 80.464789],
        [54.981944, 80.448920],
        [55.073009, 80.484076],
        [54.821462, 80.464789]
    ],
    [
        [59.737153, 81.189765],
        [59.097667, 81.213121],
        [58.994640, 81.198188],
        [59.755544, 81.169989],
        [59.737153, 81.189765]
    ],
    [
        [60.562755, 81.273627],
        [60.031993, 81.311103],
        [59.840587, 81.291571],
        [60.432302, 81.244371],
        [60.562755, 81.273627]
    ],
    [
        [58.368907, 81.579657],
        [58.493012, 81.579088],
        [58.368907, 81.579657]
    ],
    [
        [-90.606923, -68.817478],
        [-90.612294, -68.727960],
        [-90.511708, -68.752618],
        [-90.512441, -68.809177],
        [-90.606923, -68.817478]
    ],
    [
        [180.000000, -84.352796],
        [178.406261, -84.155450],
        [178.527599, -84.121352],
        [175.301036, -83.984470],
        [175.161794, -83.957289],
        [175.443126, -83.903253],
        [174.973888, -83.830499],
        [173.409028, -83.878106],
        [173.291270, -83.856378],
        [173.721365, -83.763604],
        [171.576915, -83.500258],
        [171.193126, -83.445571],
        [168.031749, -83.359633],
        [168.415212, -83.266860],
        [168.534190, -83.233657],
        [168.868826, -83.145929],
        [168.592784, -82.998956],
        [167.408458, -82.924981],
        [165.373302, -82.606134],
        [165.559255, -82.493422],
        [165.230154, -82.392836],
        [163.164806, -82.449477],
        [163.439464, -82.545180],
        [163.916759, -82.190118],
        [162.610362, -81.912286],
        [163.102224, -81.873712],
        [162.893728, -81.807224],
        [162.767914, -81.848403],
        [162.237478, -81.824802],
        [162.620372, -81.754327],
        [162.479340, -81.689142],
        [161.011485, -81.548761],
        [161.454112, -81.423517],
        [160.349864, -81.392836],
        [160.626231, -81.316664],
        [160.132009, -81.203709],
        [160.541515, -81.119236],
        [160.824474, -81.098240],
        [160.547374, -81.006768],
        [160.876150, -80.914646],
        [161.346446, -80.784356],
        [161.009288, -80.758559],
        [161.179942, -80.637791],
        [160.260102, -80.678806],
        [159.754161, -80.570733],
        [161.040050, -80.497979],
        [160.774913, -80.383233],
        [161.470551, -79.901625],
        [159.496104, -79.819513],
        [159.875499, -79.662042],
        [159.635020, -79.525649],
        [161.034190, -79.474786],
        [160.386974, -79.168145],
        [161.198090, -78.962172],
        [162.065440, -79.068617],
        [161.335948, -78.581231],
        [161.552908, -78.505548],
        [161.823985, -78.481215],
        [161.760509, -78.610447],
        [162.481944, -78.778985],
        [162.621593, -78.945245],
        [163.064952, -78.736912],
        [164.409679, -78.603936],
        [167.243012, -78.648045],
        [167.058116, -78.509047],
        [165.786876, -78.420668],
        [165.337087, -78.198907],
        [165.604340, -78.122491],
        [165.494395, -78.018650],
        [164.639659, -78.325616],
        [163.842052, -78.226983],
        [164.401134, -78.086033],
        [164.556651, -77.889581],
        [163.728526, -77.879164],
        [164.243337, -77.781915],
        [163.440115, -77.668552],
        [163.718761, -77.614923],
        [163.505138, -77.569431],
        [163.824067, -77.430841],
        [163.162852, -77.043634],
        [162.301768, -76.951349],
        [162.974620, -76.789727],
        [162.423188, -76.639255],
        [162.884288, -76.439060],
        [162.751475, -76.235121],
        [162.092296, -76.202244],
        [162.736095, -76.073907],
        [162.540538, -75.921808],
        [162.900076, -75.822931],
        [162.029552, -75.574151],
        [162.306651, -75.529392],
        [162.191091, -75.387791],
        [162.595225, -75.223728],
        [162.546235, -75.101170],
        [162.786143, -74.990004],
        [162.363780, -74.841567],
        [162.583344, -74.850193],
        [162.812999, -74.603774],
        [163.045258, -74.707778],
        [163.270763, -74.541762],
        [163.098643, -74.418878],
        [163.469900, -74.341974],
        [163.684744, -74.615655],
        [164.340831, -74.502130],
        [165.410981, -74.640313],
        [165.457774, -74.494399],
        [164.859874, -74.209161],
        [164.818207, -74.040216],
        [165.308849, -74.030369],
        [164.714610, -73.781671],
        [164.905935, -73.657159],
        [164.880138, -73.461602],
        [164.443207, -73.368748],
        [164.558849, -73.324395],
        [165.358165, -73.340020],
        [165.031993, -73.410903],
        [165.236664, -73.606622],
        [165.198985, -73.859063],
        [165.651866, -73.913670],
        [165.793142, -73.872491],
        [165.583018, -73.805108],
        [166.294200, -73.725763],
        [165.817068, -73.578220],
        [166.218516, -73.566176],
        [166.139822, -73.482029],
        [166.849132, -73.590509],
        [167.929373, -73.358657],
        [167.095225, -73.252130],
        [166.777599, -73.365330],
        [166.766775, -73.064874],
        [167.171397, -73.153009],
        [168.334158, -73.165460],
        [168.394054, -72.971938],
        [169.214610, -73.276462],
        [169.172211, -73.103123],
        [169.582286, -73.080499],
        [169.932465, -72.735935],
        [170.203949, -72.615411],
        [170.282400, -72.326349],
        [169.885265, -72.429946],
        [170.009939, -72.287774],
        [169.772634, -72.220147],
        [170.016368, -72.170831],
        [170.333995, -71.800877],
        [170.585297, -72.007420],
        [170.966075, -71.834649],
        [170.264659, -71.292250],
        [170.361827, -71.544041],
        [170.075857, -71.656020],
        [168.669770, -71.182794],
        [167.741059, -71.222833],
        [168.101329, -71.108494],
        [167.183279, -71.030938],
        [167.870128, -70.923923],
        [167.460216, -70.763442],
        [166.470714, -70.766290],
        [166.837413, -70.676690],
        [166.369477, -70.583917],
        [165.925792, -70.684259],
        [164.167328, -70.493829],
        [164.027599, -70.532322],
        [164.199880, -70.639337],
        [164.012055, -70.791111],
        [163.866547, -70.626560],
        [162.970876, -70.521905],
        [162.655772, -70.276462],
        [162.094412, -70.314142],
        [162.025564, -70.801365],
        [162.428477, -71.031671],
        [162.340831, -71.109470],
        [161.932953, -70.907322],
        [161.361176, -70.900974],
        [161.451671, -70.685968],
        [160.759776, -70.101983],
        [159.878266, -69.990411],
        [159.761241, -69.885186],
        [160.334483, -69.796075],
        [159.773285, -69.506524],
        [159.100108, -69.512872],
        [158.817149, -69.316339],
        [157.905284, -69.169529],
        [157.533458, -69.232029],
        [157.646169, -69.382420],
        [157.422537, -69.437188],
        [157.139822, -69.161310],
        [156.350108, -69.201918],
        [155.775401, -68.946873],
        [155.536794, -68.983575],
        [155.757091, -69.101170],
        [155.637543, -69.134210],
        [154.794688, -68.710870],
        [154.518321, -68.803969],
        [154.450369, -68.625746],
        [154.769216, -68.621840],
        [154.718516, -68.528253],
        [153.878429, -68.278985],
        [153.681977, -68.376072],
        [153.865245, -68.493748],
        [153.700450, -68.545668],
        [153.844981, -68.760431],
        [153.093028, -68.879164],
        [151.923839, -68.666762],
        [151.573253, -68.692560],
        [151.566905, -68.916762],
        [151.024913, -68.776951],
        [151.114106, -68.456150],
        [150.956554, -68.342950],
        [149.683604, -68.369317],
        [149.883637, -68.463637],
        [149.784923, -68.486912],
        [147.060395, -68.422784],
        [147.107921, -68.294041],
        [146.718028, -68.303399],
        [147.064708, -68.038751],
        [146.602306, -68.178481],
        [146.872813, -67.937595],
        [146.410167, -67.951755],
        [146.528982, -67.770278],
        [146.300955, -67.851332],
        [146.048106, -67.586602],
        [145.615896, -67.737074],
        [145.279796, -67.515720],
        [144.248709, -67.954360],
        [143.880707, -67.933852],
        [143.880138, -67.781020],
        [144.189708, -67.595636],
        [144.085704, -67.424737],
        [144.514171, -67.234552],
        [144.321462, -67.171645],
        [144.662364, -67.116632],
        [144.512462, -67.015720],
        [144.226817, -67.023696],
        [144.114757, -67.177423],
        [143.751475, -67.139418],
        [143.861013, -66.919692],
        [143.508311, -66.844659],
        [142.477061, -67.025974],
        [141.981700, -66.799981],
        [139.822765, -66.796970],
        [139.867035, -66.691827],
        [139.251720, -66.567153],
        [138.133311, -66.623956],
        [138.141612, -66.498712],
        [137.457856, -66.344822],
        [136.736013, -66.348728],
        [136.656749, -66.540785],
        [136.128429, -66.235528],
        [135.629649, -66.347426],
        [135.343028, -66.100681],
        [135.178477, -66.331476],
        [134.350108, -66.519952],
        [134.109386, -66.504571],
        [134.426524, -66.311456],
        [133.792328, -66.105401],
        [131.757823, -66.243341],
        [130.704845, -66.149591],
        [129.721690, -66.438246],
        [129.444509, -66.959242],
        [129.064626, -67.174412],
        [128.763520, -67.025811],
        [128.520518, -67.145766],
        [127.401134, -67.067560],
        [127.363617, -66.931085],
        [127.081391, -67.135431],
        [127.062755, -66.848728],
        [126.682140, -66.845392],
        [126.819184, -66.691339],
        [126.569509, -66.665785],
        [126.854259, -66.449314],
        [126.430431, -66.354669],
        [126.372325, -66.561619],
        [125.940603, -66.302341],
        [124.716807, -66.759210],
        [124.015147, -66.588800],
        [118.956716, -67.422459],
        [118.732188, -67.278904],
        [118.459972, -67.184259],
        [118.253184, -67.147719],
        [118.428071, -67.031834],
        [116.883067, -67.136814],
        [116.942882, -66.948175],
        [116.358897, -67.149672],
        [113.704356, -67.500177],
        [114.030121, -67.190688],
        [115.387380, -67.003839],
        [115.780772, -66.788263],
        [115.649425, -66.614516],
        [115.113455, -66.478123],
        [114.322439, -66.509047],
        [114.483409, -66.415216],
        [114.309418, -66.357029],
        [114.429861, -66.226007],
        [113.203624, -65.765395],
        [110.927094, -66.054620],
        [110.489024, -66.308770],
        [110.724946, -66.405450],
        [110.601899, -66.529474],
        [110.744151, -66.714532],
        [110.417654, -66.655938],
        [108.858653, -66.971368],
        [108.207042, -66.626723],
        [107.709809, -66.847589],
        [107.879161, -66.633071],
        [107.779145, -66.551690],
        [102.713715, -65.861261],
        [101.336436, -65.944024],
        [101.168712, -66.029474],
        [101.476248, -66.058364],
        [100.854991, -66.379653],
        [100.470551, -66.397393],
        [100.643891, -66.457696],
        [100.500011, -66.518731],
        [100.279633, -66.431085],
        [99.560232, -66.672052],
        [99.529552, -66.557387],
        [99.017263, -66.694513],
        [98.826182, -66.909926],
        [98.716482, -66.642755],
        [98.539806, -66.622735],
        [98.537120, -66.454360],
        [98.247813, -66.447931],
        [97.695323, -66.678643],
        [97.080740, -66.492283],
        [95.556163, -66.710626],
        [94.917166, -66.475356],
        [93.739268, -66.747166],
        [93.623546, -66.582615],
        [91.960134, -66.498224],
        [90.398692, -66.819594],
        [87.965668, -66.770278],
        [85.616466, -67.188165],
        [84.438731, -67.115981],
        [83.386729, -67.446547],
        [83.615977, -67.638360],
        [82.586192, -67.603448],
        [79.131358, -68.147719],
        [78.559906, -68.364679],
        [78.458263, -68.650079],
        [78.669932, -68.698500],
        [77.985606, -68.820082],
        [78.043956, -69.002618],
        [77.841645, -69.130060],
        [75.820486, -69.525079],
        [75.916270, -69.782810],
        [75.813975, -69.834893],
        [74.412283, -69.927911],
        [74.074880, -69.712660],
        [73.248871, -69.858575],
        [72.625662, -70.179132],
        [72.852794, -70.444757],
        [72.345958, -70.675470],
        [71.821544, -70.704197],
        [71.827647, -70.866795],
        [71.541759, -70.960138],
        [71.341563, -71.182061],
        [71.535899, -71.245538],
        [71.158214, -71.456150],
        [71.539806, -71.610284],
        [70.446951, -71.830173],
        [70.729503, -71.946059],
        [69.856944, -72.119317],
        [69.950450, -72.258071],
        [69.559255, -72.463962],
        [68.332774, -72.507501],
        [67.921072, -72.693048],
        [68.117361, -72.952732],
        [68.022309, -73.146742],
        [67.223155, -73.312433],
        [66.325938, -73.131443],
        [66.977387, -72.926446],
        [67.315115, -72.327895],
        [67.262218, -72.081231],
        [67.870616, -71.682224],
        [67.832530, -71.538507],
        [68.055024, -71.354669],
        [68.896495, -71.036228],
        [69.257498, -70.431573],
        [68.923513, -70.304620],
        [68.562673, -70.472426],
        [67.976085, -70.454197],
        [67.712738, -70.275486],
        [67.217947, -70.262791],
        [68.177013, -69.719659],
        [68.572602, -70.020929],
        [69.022227, -69.948500],
        [69.206879, -69.797947],
        [68.882660, -69.740899],
        [69.355235, -69.617120],
        [68.733409, -69.550877],
        [68.897716, -69.454685],
        [68.742035, -69.389255],
        [69.740082, -69.296075],
        [69.726410, -69.169692],
        [69.303884, -69.047296],
        [69.857595, -68.872491],
        [69.281261, -68.831313],
        [69.672048, -68.713637],
        [69.631602, -68.588637],
        [70.179698, -68.494806],
        [69.634776, -68.122166],
        [69.639008, -67.763279],
        [68.376720, -67.895196],
        [63.650890, -67.503351],
        [62.617361, -67.660089],
        [59.916026, -67.400486]
    ],
    [
        [-73.037179, -54.456461],
        [-72.972841, -54.445012],
        [-72.953784, -54.456858],
        [-73.098314, -54.485808],
        [-73.037179, -54.456461]
    ],
    [
        [-70.402603, -54.078633],
        [-70.313253, -54.052750],
        [-70.298143, -54.125953],
        [-70.513691, -54.091286],
        [-70.402603, -54.078633]
    ],
    [
        [-70.686814, -52.847390],
        [-70.619252, -52.843384],
        [-70.789740, -52.900541],
        [-70.769452, -52.887803],
        [-70.686814, -52.847390]
    ],
    [
        [-74.427757, -52.503662],
        [-74.481960, -52.570765],
        [-74.349257, -52.622981],
        [-74.394198, -52.519903],
        [-74.427757, -52.503662]
    ],
    [
        [-74.476368, -52.309667],
        [-74.452322, -52.394783],
        [-74.482233, -52.441658],
        [-74.536449, -52.368736],
        [-74.476368, -52.309667]
    ],
    [
        [-59.768428, -52.326961],
        [-59.692321, -52.303713],
        [-59.641989, -52.367790],
        [-59.820694, -52.358357],
        [-59.768428, -52.326961]
    ],
    [
        [-58.415598, -51.994073],
        [-58.480580, -51.992283],
        [-58.546742, -52.025567],
        [-58.427602, -52.100681],
        [-58.415598, -51.994073]
    ],
    [
        [-59.679921, -51.965590],
        [-59.698883, -51.938409],
        [-59.718902, -51.976170],
        [-59.680287, -51.987726],
        [-59.679921, -51.965590]
    ],
    [
        [-73.815143, -51.864059],
        [-73.718330, -51.848860],
        [-73.713451, -51.996007],
        [-73.979358, -51.838544],
        [-73.815143, -51.864059]
    ],
    [
        [-74.359036, -51.337941],
        [-74.296510, -51.395389],
        [-74.306249, -51.417784],
        [-74.396488, -51.413082],
        [-74.359036, -51.337941]
    ],
    [
        [-59.744239, -51.328978],
        [-59.665641, -51.341512],
        [-59.596946, -51.380690],
        [-59.829411, -51.350507],
        [-59.744239, -51.328978]
    ],
    [
        [-60.533437, -51.283380],
        [-60.582875, -51.254978],
        [-60.596669, -51.263360],
        [-60.521108, -51.315037],
        [-60.533437, -51.283380]
    ],
    [
        [-61.055572, -51.070977],
        [-61.092397, -51.038344],
        [-61.119211, -51.027765],
        [-61.125803, -51.065199],
        [-61.055572, -51.070977]
    ],
    [
        [-74.970277, -50.287516],
        [-74.976266, -50.432888],
        [-75.171581, -50.462150],
        [-75.121178, -50.382086],
        [-74.970277, -50.287516]
    ],
    [
        [-74.426015, -49.614923],
        [-74.287994, -49.548435],
        [-74.427032, -49.426528],
        [-74.468617, -49.501153],
        [-74.426015, -49.614923]
    ],
    [
        [-74.649865, -47.797742],
        [-74.526181, -47.812868],
        [-74.524671, -47.868351],
        [-74.644016, -47.923110],
        [-74.649865, -47.797742]
    ],
    [
        [-75.323147, -46.685089],
        [-75.173992, -46.677964],
        [-75.132214, -46.777995],
        [-75.342252, -46.701737],
        [-75.323147, -46.685089]
    ],
    [
        [-74.253361, -43.350392],
        [-74.284026, -43.417838],
        [-74.257307, -43.427452],
        [-74.230726, -43.413370],
        [-74.253361, -43.350392]
    ],
    [
        [-73.691092, -43.188156],
        [-73.718524, -43.215981],
        [-73.661238, -43.244796],
        [-73.656422, -43.196000],
        [-73.691092, -43.188156]
    ],
    [
        [-73.009192, -42.695259],
        [-72.930444, -42.723340],
        [-72.918815, -42.786532],
        [-72.956525, -42.807804],
        [-73.009192, -42.695259]
    ],
    [
        [-73.307341, -42.627343],
        [-73.241038, -42.631371],
        [-73.238951, -42.650826],
        [-73.356927, -42.629037],
        [-73.307341, -42.627343]
    ],
    [
        [-62.155300, -40.374205],
        [-62.237326, -40.509949],
        [-62.108709, -40.564064],
        [-62.028517, -40.454882],
        [-62.155300, -40.374205]
    ],
    [
        [-62.118962, -40.130720],
        [-62.133180, -40.181094],
        [-62.021165, -40.343553],
        [-62.014660, -40.175163],
        [-62.118962, -40.130720]
    ],
    [
        [-73.882436, -38.360772],
        [-73.930776, -38.323826],
        [-73.953440, -38.313572],
        [-73.912099, -38.409926],
        [-73.882436, -38.360772]
    ],
    [
        [-73.540830, -36.989441],
        [-73.523096, -36.975265],
        [-73.446494, -37.059170],
        [-73.518884, -37.079922],
        [-73.540830, -36.989441]
    ],
    [
        [115.492107, -31.995649],
        [115.524607, -31.993807],
        [115.552192, -32.006203],
        [115.440142, -32.021834],
        [115.492107, -31.995649]
    ],
    [
        [113.679618, -28.452241],
        [113.720213, -28.428124],
        [113.749539, -28.427576],
        [113.684598, -28.486277],
        [113.679618, -28.452241]
    ],
    [
        [-48.322324, -25.383708],
        [-48.255379, -25.348212],
        [-48.291107, -25.489117],
        [-48.339525, -25.425535],
        [-48.322324, -25.383708]
    ],
    [
        [-159.785105, -18.830824],
        [-159.772613, -18.828953],
        [-159.761993, -18.837254],
        [-159.761383, -18.845392],
        [-159.793609, -18.887465],
        [-159.785105, -18.830824]
    ],
    [
        [146.651134, -18.745782],
        [146.634125, -18.736505],
        [146.581309, -18.682224],
        [146.570160, -18.760837],
        [146.651134, -18.745782]
    ],
    [
        [180.000000, -16.785349],
        [179.890147, -16.953871],
        [180.000000, -16.962782]
    ],
    [
        [180.000000, -16.489519],
        [180.000000, -16.541275]
    ],
    [
        [39.909537, -16.275827],
        [39.946372, -16.302192],
        [39.878476, -16.416890],
        [39.821337, -16.317412],
        [39.909537, -16.275827]
    ],
    [
        [180.000000, -16.149112],
        [178.533946, -16.629002],
        [178.485606, -16.793390],
        [178.733897, -17.007013],
        [179.266368, -16.689874],
        [179.296886, -16.806817],
        [179.910655, -16.766046],
        [179.939464, -16.463311],
        [179.548106, -16.766046],
        [179.478689, -16.697198],
        [180.000000, -16.168951]
    ],
    [
        [-76.195232, -14.263294],
        [-76.220324, -14.274666],
        [-76.179585, -14.295208],
        [-76.175660, -14.288375],
        [-76.195232, -14.263294]
    ],
    [
        [-76.443669, -13.830488],
        [-76.456831, -13.822912],
        [-76.470250, -13.853856],
        [-76.441441, -13.853906],
        [-76.443669, -13.830488]
    ],
    [
        [-77.232714, -12.065443],
        [-77.236668, -12.093345],
        [-77.181541, -12.115912],
        [-77.193839, -12.100041],
        [-77.232714, -12.065443]
    ],
    [
        [166.984874, -11.614353],
        [166.944347, -11.625421],
        [166.945649, -11.653253],
        [166.979666, -11.638604],
        [166.984874, -11.614353]
    ],
    [
        [121.614106, -10.602472],
        [121.564952, -10.603692],
        [121.527192, -10.629571],
        [121.595225, -10.634535],
        [121.614106, -10.602472]
    ],
    [
        [166.252452, -10.264907],
        [166.242442, -10.268976],
        [166.237315, -10.311130],
        [166.252452, -10.264907]
    ],
    [
        [151.024669, -9.638930],
        [151.022227, -9.591404],
        [150.959809, -9.592380],
        [151.017914, -9.668878],
        [151.024669, -9.638930]
    ],
    [
        [142.754568, -9.369806],
        [142.637462, -9.373956],
        [142.601248, -9.399509],
        [142.713878, -9.428643],
        [142.754568, -9.369806]
    ],
    [
        [142.206879, -9.240167],
        [142.150890, -9.271417],
        [142.279145, -9.287042],
        [142.280121, -9.261651],
        [142.206879, -9.240167]
    ],
    [
        [143.815929, -8.495375],
        [143.780284, -8.513279],
        [143.796072, -8.538263],
        [143.813487, -8.530857],
        [143.815929, -8.495375]
    ],
    [
        [143.674327, -8.390558],
        [143.637950, -8.340590],
        [143.540863, -8.350030],
        [143.648285, -8.425877],
        [143.674327, -8.390558]
    ],
    [
        [143.662934, -8.109308],
        [143.613292, -8.094903],
        [143.599376, -8.110772],
        [143.666677, -8.167413],
        [143.662934, -8.109308]
    ],
    [
        [143.675629, -8.053806],
        [143.612559, -8.020115],
        [143.564220, -8.029962],
        [143.690440, -8.100193],
        [143.675629, -8.053806]
    ],
    [
        [39.742040, -7.994825],
        [39.801492, -8.006587],
        [39.702796, -8.091393],
        [39.702800, -8.049004],
        [39.742040, -7.994825]
    ],
    [
        [156.545421, -7.791681],
        [156.525890, -7.799412],
        [156.516856, -7.818129],
        [156.555431, -7.817315],
        [156.545421, -7.791681]
    ],
    [
        [-34.852750, -7.697379],
        [-34.822331, -7.738797],
        [-34.845373, -7.813504],
        [-34.884229, -7.804026],
        [-34.852750, -7.697379]
    ],
    [
        [115.890880, -7.107110],
        [115.880219, -7.158461],
        [115.743012, -7.150323],
        [115.837738, -7.197198],
        [115.894298, -7.164483],
        [115.890880, -7.107110]
    ],
    [
        [134.727794, -6.504571],
        [134.684337, -6.457778],
        [134.623790, -6.486098],
        [134.674815, -6.563084],
        [134.727794, -6.504571]
    ],
    [
        [-80.842970, -6.381612],
        [-80.853135, -6.374988],
        [-80.875380, -6.433053],
        [-80.863841, -6.475839],
        [-80.842970, -6.381612]
    ],
    [
        [110.431326, -5.837335],
        [110.421641, -5.851332],
        [110.437999, -5.881036],
        [110.465587, -5.839532],
        [110.431326, -5.837335]
    ],
    [
        [39.226104, -5.769169],
        [39.237862, -5.856047],
        [39.214470, -5.858106],
        [39.214412, -5.777380],
        [39.226104, -5.769169]
    ],
    [
        [134.212738, -5.758722],
        [134.169688, -5.768324],
        [134.180512, -5.827325],
        [134.220388, -5.815606],
        [134.212738, -5.758722]
    ],
    [
        [39.575458, -5.394548],
        [39.652181, -5.450943],
        [39.659811, -5.475970],
        [39.615331, -5.463799],
        [39.575458, -5.394548]
    ],
    [
        [151.188487, -4.891534],
        [151.143809, -4.896091],
        [151.119477, -4.925714],
        [151.206798, -4.947524],
        [151.188487, -4.891534]
    ],
    [
        [143.585216, -3.378676],
        [143.593923, -3.348728],
        [143.515880, -3.320408],
        [143.523123, -3.361017],
        [143.585216, -3.378676]
    ],
    [
        [-42.228703, -2.693311],
        [-42.149024, -2.735403],
        [-42.105776, -2.772749],
        [-42.249767, -2.736441],
        [-42.228703, -2.693311]
    ],
    [
        [-79.819640, -2.485911],
        [-79.881801, -2.626940],
        [-79.877239, -2.649678],
        [-79.772571, -2.541987],
        [-79.819640, -2.485911]
    ],
    [
        [133.591807, -2.461521],
        [133.505870, -2.424493],
        [133.490001, -2.431248],
        [133.562999, -2.512872],
        [133.591807, -2.461521]
    ],
    [
        [-43.832879, -2.454079],
        [-43.823499, -2.407710],
        [-43.756834, -2.447669],
        [-43.809175, -2.512778],
        [-43.832879, -2.454079]
    ],
    [
        [-43.564764, -2.361293],
        [-43.542039, -2.371153],
        [-43.573656, -2.423468],
        [-43.611692, -2.385001],
        [-43.564764, -2.361293]
    ],
    [
        [-49.479514, -1.655372],
        [-49.424018, -1.696843],
        [-49.508609, -1.744872],
        [-49.525482, -1.672855],
        [-49.479514, -1.655372]
    ],
    [
        [150.004242, -1.672621],
        [149.964122, -1.630304],
        [149.912120, -1.653741],
        [149.927257, -1.684991],
        [150.004242, -1.672621]
    ],
    [
        [123.600597, -1.603285],
        [123.523285, -1.482680],
        [123.493500, -1.709649],
        [123.601329, -1.702813],
        [123.600597, -1.603285]
    ],
    [
        [128.367361, -0.988377],
        [128.323497, -0.941339],
        [128.306163, -0.943292],
        [128.367361, -0.988377]
    ],
    [
        [129.902354, -0.408461],
        [129.848888, -0.432387],
        [129.864431, -0.498630],
        [129.913829, -0.442560],
        [129.902354, -0.408461]
    ],
    [
        [98.547597, 0.159327],
        [98.805744, 0.160916],
        [98.851685, 0.109621],
        [98.538740, 0.090335],
        [98.547597, 0.159327]
    ],
    [
        [104.724864, 0.749661],
        [104.720714, 0.737860],
        [104.739268, 0.716254],
        [104.754161, 0.737250],
        [104.724864, 0.749661]
    ],
    [
        [104.659434, 0.845893],
        [104.639171, 0.847968],
        [104.630382, 0.806545],
        [104.661388, 0.820136],
        [104.659434, 0.845893]
    ],
    [
        [125.172211, 1.799221],
        [125.129405, 1.828437],
        [125.144705, 1.741848],
        [125.177013, 1.778754],
        [125.172211, 1.799221]
    ],
    [
        [131.791515, 2.977729],
        [131.775401, 2.964057],
        [131.795177, 2.949042],
        [131.812999, 2.960435],
        [131.791515, 2.977729]
    ],
    [
        [-78.186612, 2.990373],
        [-78.167091, 2.959704],
        [-78.220289, 2.933617],
        [-78.204423, 2.945731],
        [-78.186612, 2.990373]
    ],
    [
        [101.271169, 3.046454],
        [101.262869, 3.056342],
        [101.236990, 3.035061],
        [101.259613, 3.030219],
        [101.271169, 3.046454]
    ],
    [
        [101.337657, 3.051825],
        [101.305919, 3.063951],
        [101.268077, 2.965155],
        [101.335297, 3.009019],
        [101.337657, 3.051825]
    ],
    [
        [127.130382, 4.774400],
        [127.123057, 4.752509],
        [127.135997, 4.740383],
        [127.145763, 4.752183],
        [127.130382, 4.774400]
    ],
    [
        [119.830903, 4.820950],
        [119.819347, 4.803860],
        [119.857677, 4.798570],
        [119.853770, 4.808254],
        [119.830903, 4.820950]
    ],
    [
        [119.836925, 4.862860],
        [119.842621, 4.904853],
        [119.793142, 4.921861],
        [119.798595, 4.879788],
        [119.836925, 4.862860]
    ],
    [
        [119.796560, 5.057603],
        [119.812511, 5.069892],
        [119.798350, 5.121039],
        [119.745779, 5.044013],
        [119.796560, 5.057603]
    ],
    [
        [125.418712, 5.425482],
        [125.376801, 5.431220],
        [125.334239, 5.387681],
        [125.418712, 5.368476],
        [125.418712, 5.425482]
    ],
    [
        [-87.099029, 5.516018],
        [-87.117665, 5.515082],
        [-87.064605, 5.557847],
        [-87.065541, 5.534613],
        [-87.099029, 5.516018]
    ],
    [
        [120.860118, 5.703843],
        [120.807384, 5.695705],
        [120.799327, 5.667629],
        [120.882660, 5.685289],
        [120.860118, 5.703843]
    ],
    [
        [120.904307, 5.759101],
        [120.890880, 5.709784],
        [120.909923, 5.700019],
        [120.929373, 5.733222],
        [120.904307, 5.759101]
    ],
    [
        [-61.390271, 8.580581],
        [-61.314603, 8.571314],
        [-61.263688, 8.456088],
        [-61.540116, 8.565411],
        [-61.390271, 8.580581]
    ],
    [
        [-83.896618, 8.706492],
        [-83.878076, 8.698821],
        [-83.869114, 8.713587],
        [-83.883464, 8.712993],
        [-83.896618, 8.706492]
    ],
    [
        [-60.745024, 8.719359],
        [-60.676056, 8.762917],
        [-60.617677, 8.636723],
        [-60.808134, 8.632888],
        [-60.745024, 8.719359]
    ],
    [
        [-79.570393, 8.798576],
        [-79.553827, 8.803426],
        [-79.543381, 8.775545],
        [-79.569154, 8.783117],
        [-79.570393, 8.798576]
    ],
    [
        [-60.951361, 8.827825],
        [-60.686043, 8.789015],
        [-61.169915, 8.595314],
        [-61.126440, 8.756478],
        [-60.951361, 8.827825]
    ],
    [
        [98.288422, 9.004462],
        [98.252208, 8.997016],
        [98.261567, 8.878567],
        [98.306977, 8.957913],
        [98.288422, 9.004462]
    ],
    [
        [-81.568269, 9.108249],
        [-81.547221, 9.102741],
        [-81.534492, 9.085917],
        [-81.571671, 9.089599],
        [-81.568269, 9.108249]
    ],
    [
        [-82.047238, 9.172569],
        [-82.051840, 9.182193],
        [-82.010477, 9.141459],
        [-82.050084, 9.145941],
        [-82.047238, 9.172569]
    ],
    [
        [123.841319, 9.642401],
        [123.781912, 9.623521],
        [123.726329, 9.586982],
        [123.804535, 9.560289],
        [123.841319, 9.642401]
    ],
    [
        [114.373220, 9.687649],
        [114.378673, 9.692694],
        [114.381033, 9.692206],
        [114.376475, 9.680121],
        [114.373220, 9.687649]
    ],
    [
        [-62.331125, 9.920559],
        [-62.349355, 9.872301],
        [-62.325754, 9.844184],
        [-62.316396, 9.885647],
        [-62.331125, 9.920559]
    ],
    [
        [114.029633, 10.011868],
        [114.029307, 10.017401],
        [114.040050, 10.019477],
        [114.033946, 10.012397],
        [114.029633, 10.011868]
    ],
    [
        [-62.403310, 10.006293],
        [-62.426869, 10.049221],
        [-62.436187, 10.046576],
        [-62.408925, 9.972561],
        [-62.403310, 10.006293]
    ],
    [
        [-62.240834, 10.051500],
        [-62.286366, 10.024400],
        [-62.298004, 9.983710],
        [-62.235341, 10.013861],
        [-62.240834, 10.051500]
    ],
    [
        [124.606944, 10.140326],
        [124.521821, 10.112047],
        [124.529552, 10.068549],
        [124.597667, 10.094184],
        [124.606944, 10.140326]
    ],
    [
        [114.365408, 10.175482],
        [114.358653, 10.179348],
        [114.363048, 10.187079],
        [114.371267, 10.180487],
        [114.365408, 10.175482]
    ],
    [
        [-109.212026, 10.302680],
        [-109.225942, 10.311021],
        [-109.234242, 10.307929],
        [-109.218577, 10.281562],
        [-109.212026, 10.302680]
    ],
    [
        [-75.586801, 10.367792],
        [-75.575830, 10.377872],
        [-75.535320, 10.350646],
        [-75.590661, 10.319044],
        [-75.586801, 10.367792]
    ],
    [
        [114.464203, 10.367377],
        [114.461681, 10.372016],
        [114.466970, 10.378363],
        [114.470958, 10.372301],
        [114.464203, 10.367377]
    ],
    [
        [114.363780, 10.367865],
        [114.358897, 10.372545],
        [114.360362, 10.378567],
        [114.367849, 10.370836],
        [114.363780, 10.367865]
    ],
    [
        [114.454845, 10.388332],
        [114.449962, 10.394436],
        [114.454926, 10.397203],
        [114.459809, 10.392727],
        [114.454845, 10.388332]
    ],
    [
        [-62.665151, 10.366360],
        [-62.747182, 10.460273],
        [-62.781117, 10.492906],
        [-62.659820, 10.310004],
        [-62.665151, 10.366360]
    ],
    [
        [103.334158, 10.583930],
        [103.319509, 10.617336],
        [103.289073, 10.612738],
        [103.323497, 10.545152],
        [103.334158, 10.583930]
    ],
    [
        [115.830577, 10.734605],
        [115.832693, 10.727729],
        [115.814626, 10.723334],
        [115.814626, 10.734320],
        [115.830577, 10.734605]
    ],
    [
        [-64.168609, 10.827948],
        [-64.203440, 10.827297],
        [-64.220937, 10.806464],
        [-64.174794, 10.799221],
        [-64.168609, 10.827948]
    ],
    [
        [115.840343, 10.823188],
        [115.833751, 10.824042],
        [115.829600, 10.831773],
        [115.845225, 10.831204],
        [115.840343, 10.823188]
    ],
    [
        [114.278575, 11.040432],
        [114.272227, 11.045844],
        [114.282725, 11.050686],
        [114.286876, 11.046617],
        [114.278575, 11.040432]
    ],
    [
        [115.018403, 11.107123],
        [115.013845, 11.107652],
        [115.010102, 11.115912],
        [115.020763, 11.117987],
        [115.018403, 11.107123]
    ],
    [
        [121.474132, 11.866848],
        [121.425629, 11.861233],
        [121.412608, 11.840277],
        [121.526052, 11.846584],
        [121.474132, 11.866848]
    ],
    [
        [124.206228, 12.081244],
        [124.165375, 12.075426],
        [124.150238, 12.043850],
        [124.229259, 12.063625],
        [124.206228, 12.081244]
    ],
    [
        [121.115977, 12.196763],
        [121.088145, 12.267076],
        [121.059906, 12.278388],
        [121.051606, 12.220933],
        [121.115977, 12.196763]
    ],
    [
        [124.168630, 12.398139],
        [124.176606, 12.432685],
        [124.133556, 12.470771],
        [124.137462, 12.437567],
        [124.168630, 12.398139]
    ],
    [
        [-61.441396, 12.607896],
        [-61.455556, 12.607082],
        [-61.455922, 12.586086],
        [-61.426625, 12.591864],
        [-61.441396, 12.607896]
    ],
    [
        [109.393403, 12.601874],
        [109.368907, 12.627753],
        [109.312022, 12.614325],
        [109.400238, 12.557929],
        [109.393403, 12.601874]
    ],
    [
        [-61.319407, 12.733791],
        [-61.335357, 12.727200],
        [-61.353098, 12.696479],
        [-61.328359, 12.699449],
        [-61.319407, 12.733791]
    ],
    [
        [-61.191762, 12.868232],
        [-61.187611, 12.856391],
        [-61.174957, 12.881781],
        [-61.183176, 12.883490],
        [-61.191762, 12.868232]
    ],
    [
        [-87.726293, 13.198387],
        [-87.706087, 13.211726],
        [-87.693194, 13.167862],
        [-87.723111, 13.164078],
        [-87.726293, 13.198387]
    ],
    [
        [124.148611, 13.185777],
        [124.209646, 13.195787],
        [124.065603, 13.210761],
        [124.097911, 13.192450],
        [124.148611, 13.185777]
    ],
    [
        [-87.765782, 13.248011],
        [-87.780169, 13.241643],
        [-87.763805, 13.214287],
        [-87.751387, 13.228925],
        [-87.765782, 13.248011]
    ],
    [
        [124.086274, 13.260443],
        [124.047699, 13.278957],
        [123.912446, 13.288642],
        [124.025401, 13.221991],
        [124.086274, 13.260443]
    ],
    [
        [123.890310, 13.274075],
        [123.922130, 13.329983],
        [123.848888, 13.354153],
        [123.873546, 13.229641],
        [123.890310, 13.274075]
    ],
    [
        [123.801524, 13.366034],
        [123.845551, 13.367825],
        [123.771658, 13.403510],
        [123.775157, 13.391588],
        [123.801524, 13.366034]
    ],
    [
        [-80.089915, 13.578355],
        [-80.090891, 13.578030],
        [-80.090403, 13.576606],
        [-80.089426, 13.576850],
        [-80.089915, 13.578355]
    ],
    [
        [122.411794, 14.725816],
        [122.341563, 14.712592],
        [122.319347, 14.683498],
        [122.397797, 14.685858],
        [122.411794, 14.725816]
    ],
    [
        [42.635997, 15.445543],
        [42.601899, 15.446275],
        [42.558930, 15.392971],
        [42.568370, 15.268866],
        [42.635997, 15.445543]
    ],
    [
        [-61.624664, 15.871243],
        [-61.638336, 15.853217],
        [-61.627553, 15.846991],
        [-61.616078, 15.860053],
        [-61.624664, 15.871243]
    ],
    [
        [-61.566477, 15.878363],
        [-61.579945, 15.880805],
        [-61.595693, 15.862860],
        [-61.582183, 15.861802],
        [-61.566477, 15.878363]
    ],
    [
        [40.095388, 16.047349],
        [40.050466, 16.107245],
        [39.990001, 16.017727],
        [40.114513, 15.985907],
        [40.095388, 16.047349]
    ],
    [
        [120.005056, 16.268622],
        [119.984060, 16.348700],
        [119.922374, 16.303778],
        [119.992931, 16.230170],
        [120.005056, 16.268622]
    ],
    [
        [111.600108, 16.527289],
        [111.602875, 16.533352],
        [111.609630, 16.528266],
        [111.606293, 16.524237],
        [111.600108, 16.527289]
    ],
    [
        [112.735037, 16.657945],
        [112.725271, 16.666205],
        [112.726248, 16.669013],
        [112.733409, 16.666083],
        [112.735037, 16.657945]
    ],
    [
        [-169.532338, 16.733059],
        [-169.547678, 16.727362],
        [-169.549509, 16.723456],
        [-169.522410, 16.732164],
        [-169.532338, 16.733059]
    ],
    [
        [-169.513661, 16.743964],
        [-169.512766, 16.744330],
        [-169.513661, 16.745592],
        [-169.513661, 16.743964]
    ],
    [
        [112.333181, 16.825019],
        [112.327159, 16.829739],
        [112.327891, 16.837104],
        [112.335460, 16.832587],
        [112.333181, 16.825019]
    ],
    [
        [112.333669, 16.933254],
        [112.341075, 16.926988],
        [112.340505, 16.923570],
        [112.335460, 16.923814],
        [112.333669, 16.933254]
    ],
    [
        [-88.095611, 17.517401],
        [-88.117299, 17.512885],
        [-88.077056, 17.461086],
        [-88.067698, 17.490546],
        [-88.095611, 17.517401]
    ],
    [
        [-63.238433, 17.646918],
        [-63.251332, 17.623765],
        [-63.238393, 17.614691],
        [-63.223704, 17.629218],
        [-63.238433, 17.646918]
    ],
    [
        [-87.969065, 18.090888],
        [-87.984364, 18.077582],
        [-87.981435, 18.071275],
        [-87.962514, 18.079983],
        [-87.969065, 18.090888]
    ],
    [
        [-87.939524, 18.118638],
        [-87.956899, 18.097357],
        [-87.954010, 18.088284],
        [-87.936391, 18.103909],
        [-87.939524, 18.118638]
    ],
    [
        [-87.878407, 18.208238],
        [-87.890777, 18.197455],
        [-87.887807, 18.175605],
        [-87.874745, 18.197333],
        [-87.878407, 18.208238]
    ],
    [
        [-64.569447, 18.357978],
        [-64.578359, 18.360582],
        [-64.603017, 18.355618],
        [-64.570912, 18.334662],
        [-64.569447, 18.357978]
    ],
    [
        [-75.024322, 18.417263],
        [-75.006988, 18.415147],
        [-75.003163, 18.397732],
        [-75.017812, 18.396674],
        [-75.024322, 18.417263]
    ],
    [
        [-64.729807, 18.453437],
        [-64.768422, 18.449652],
        [-64.773997, 18.442288],
        [-64.730336, 18.437893],
        [-64.729807, 18.453437]
    ],
    [
        [-64.532704, 18.494127],
        [-64.539459, 18.482856],
        [-64.536529, 18.462388],
        [-64.529164, 18.476386],
        [-64.532704, 18.494127]
    ],
    [
        [-16.320912, 19.728502],
        [-16.358551, 19.677436],
        [-16.397694, 19.599921],
        [-16.301625, 19.722602],
        [-16.320912, 19.728502]
    ],
    [
        [-16.477162, 19.731513],
        [-16.496897, 19.705512],
        [-16.484242, 19.677720],
        [-16.471547, 19.699652],
        [-16.477162, 19.731513]
    ],
    [
        [-16.459299, 20.614691],
        [-16.474233, 20.594184],
        [-16.454172, 20.571112],
        [-16.446401, 20.607327],
        [-16.459299, 20.614691]
    ],
    [
        [-78.581695, 20.661607],
        [-78.579945, 20.653998],
        [-78.613393, 20.657945],
        [-78.585683, 20.643622],
        [-78.578277, 20.648424],
        [-78.581695, 20.661607]
    ],
    [
        [-78.651519, 20.664944],
        [-78.646474, 20.652289],
        [-78.631174, 20.653144],
        [-78.629750, 20.658840],
        [-78.651519, 20.664944]
    ],
    [
        [110.471365, 20.647366],
        [110.417654, 20.654771],
        [110.457286, 20.586859],
        [110.475841, 20.595933],
        [110.471365, 20.647366]
    ],
    [
        [107.369640, 20.825914],
        [107.357107, 20.829332],
        [107.380219, 20.797553],
        [107.369640, 20.825914]
    ],
    [
        [107.382172, 20.887885],
        [107.339203, 20.890367],
        [107.332530, 20.883287],
        [107.367686, 20.858385],
        [107.382172, 20.887885]
    ],
    [
        [107.825694, 21.024970],
        [107.816580, 21.005845],
        [107.817719, 20.988267],
        [107.856293, 21.033271],
        [107.825694, 21.024970]
    ],
    [
        [-71.687815, 21.299791],
        [-71.687815, 21.299791]
    ],
    [
        [-71.634348, 21.318793],
        [-71.640859, 21.302965],
        [-71.634674, 21.294501],
        [-71.628814, 21.324368],
        [-71.634348, 21.318793]
    ],
    [
        [-71.209828, 21.341376],
        [-71.219228, 21.314358],
        [-71.213694, 21.310614],
        [-71.192494, 21.335028],
        [-71.209828, 21.341376]
    ],
    [
        [-71.498280, 21.569403],
        [-71.539703, 21.516547],
        [-71.520985, 21.489325],
        [-71.496327, 21.507392],
        [-71.498280, 21.569403]
    ],
    [
        [-81.981191, 21.647773],
        [-81.996653, 21.626614],
        [-81.989817, 21.608832],
        [-81.981191, 21.647773]
    ],
    [
        [-81.852528, 21.663560],
        [-81.935699, 21.641913],
        [-81.932362, 21.628485],
        [-81.901357, 21.615627],
        [-81.852528, 21.663560]
    ],
    [
        [-72.124908, 21.854641],
        [-72.133046, 21.847642],
        [-72.116282, 21.853746],
        [-72.124908, 21.854641]
    ],
    [
        [-72.094797, 21.882514],
        [-72.101552, 21.871649],
        [-72.099680, 21.864569],
        [-72.087066, 21.872748],
        [-72.094797, 21.882514]
    ],
    [
        [113.278005, 21.925035],
        [113.247732, 21.943183],
        [113.225841, 21.900824],
        [113.258474, 21.880439],
        [113.278005, 21.925035]
    ],
    [
        [-82.645172, 21.954535],
        [-82.657867, 21.932074],
        [-82.591176, 21.926663],
        [-82.607737, 21.938707],
        [-82.645172, 21.954535]
    ],
    [
        [-83.552846, 21.961371],
        [-83.597808, 21.971747],
        [-83.607818, 21.966498],
        [-83.592600, 21.960110],
        [-83.552846, 21.961371]
    ],
    [
        [113.771747, 22.000343],
        [113.736279, 21.997162],
        [113.748206, 21.972788],
        [113.764477, 21.966818],
        [113.771747, 22.000343]
    ],
    [
        [114.306814, 22.057196],
        [114.304210, 22.069281],
        [114.206716, 22.025784],
        [114.302501, 22.044867],
        [114.306814, 22.057196]
    ],
    [
        [-81.556264, 22.065985],
        [-81.582509, 22.076606],
        [-81.588857, 22.072699],
        [-81.547027, 22.044582],
        [-81.556264, 22.065985]
    ],
    [
        [113.473481, 22.098538],
        [113.484711, 22.071357],
        [113.547618, 22.092597],
        [113.518891, 22.127265],
        [113.473481, 22.098538]
    ],
    [
        [113.558604, 22.163031],
        [113.587494, 22.124864],
        [113.546804, 22.105373],
        [113.532237, 22.152615],
        [113.558604, 22.163031]
    ],
    [
        [113.536469, 22.217068],
        [113.557140, 22.202460],
        [113.524750, 22.173733],
        [113.524343, 22.212551],
        [113.536469, 22.217068]
    ],
    [
        [-75.722076, 22.202582],
        [-75.739491, 22.222846],
        [-75.734364, 22.175035],
        [-75.714711, 22.182929],
        [-75.722076, 22.202582]
    ],
    [
        [114.137380, 22.178778],
        [114.110850, 22.177069],
        [114.106700, 22.235785],
        [114.154633, 22.203599],
        [114.137380, 22.178778]
    ],
    [
        [-75.745961, 22.236029],
        [-75.747548, 22.261461],
        [-75.751861, 22.263251],
        [-75.753407, 22.237372],
        [-75.745961, 22.236029]
    ],
    [
        [114.215587, 22.285631],
        [114.256114, 22.203599],
        [114.207693, 22.189561],
        [114.112559, 22.271511],
        [114.215587, 22.285631]
    ],
    [
        [113.846446, 22.197089],
        [113.892507, 22.292711],
        [114.054861, 22.336330],
        [114.000173, 22.216132],
        [113.846446, 22.197089]
    ],
    [
        [-75.811676, 22.371568],
        [-75.805491, 22.347602],
        [-75.802642, 22.353176],
        [-75.811676, 22.371568]
    ],
    [
        [113.623379, 22.439872],
        [113.610441, 22.413337],
        [113.621187, 22.391419],
        [113.657825, 22.423751],
        [113.623379, 22.439872]
    ],
    [
        [-78.737660, 22.548407],
        [-78.768137, 22.541653],
        [-78.765981, 22.518785],
        [-78.738759, 22.524319],
        [-78.737660, 22.548407]
    ],
    [
        [-89.664188, 22.371069],
        [-89.655165, 22.472001],
        [-89.610152, 22.461081],
        [-89.664188, 22.371069]
    ],
    [
        [-73.618177, 22.601250],
        [-73.625498, 22.574258],
        [-73.593794, 22.601993],
        [-73.618177, 22.601250]
    ],
    [
        [-82.514475, 22.625149],
        [-82.528310, 22.640041],
        [-82.522857, 22.559312],
        [-82.507721, 22.590074],
        [-82.514475, 22.625149]
    ],
    [
        [-79.224517, 22.639716],
        [-79.206410, 22.624416],
        [-79.176869, 22.644680],
        [-79.215728, 22.643012],
        [-79.224517, 22.639716]
    ],
    [
        [113.546759, 22.741884],
        [113.476511, 22.719514],
        [113.641832, 22.601624],
        [113.635687, 22.656475],
        [113.546759, 22.741884]
    ],
    [
        [-79.680084, 22.859442],
        [-79.718332, 22.880032],
        [-79.727528, 22.903957],
        [-79.730865, 22.866116],
        [-79.680084, 22.859442]
    ],
    [
        [-79.826283, 22.964667],
        [-79.871165, 22.947699],
        [-79.846506, 22.910346],
        [-79.827382, 22.919135],
        [-79.826283, 22.964667]
    ],
    [
        [113.529210, 22.960354],
        [113.509960, 22.921216],
        [113.545014, 22.879961],
        [113.553599, 22.911281],
        [113.529210, 22.960354]
    ],
    [
        [-80.061391, 23.049791],
        [-80.076772, 23.069892],
        [-80.094797, 23.048326],
        [-80.056304, 23.026679],
        [-80.061391, 23.049791]
    ],
    [
        [-80.244700, 23.107489],
        [-80.272450, 23.140041],
        [-80.305735, 23.134508],
        [-80.250315, 23.084866],
        [-80.244700, 23.107489]
    ],
    [
        [-80.401438, 23.154608],
        [-80.446116, 23.150621],
        [-80.459788, 23.128607],
        [-80.376291, 23.152167],
        [-80.401438, 23.154608]
    ],
    [
        [-80.668528, 23.212226],
        [-80.694895, 23.203925],
        [-80.704254, 23.180325],
        [-80.674672, 23.186835],
        [-80.668528, 23.212226]
    ],
    [
        [-80.775014, 23.206610],
        [-80.837880, 23.223538],
        [-80.861440, 23.220364],
        [-80.775014, 23.206610]
    ],
    [
        [-80.878774, 23.250434],
        [-80.912994, 23.265570],
        [-80.942698, 23.257270],
        [-80.878570, 23.232123],
        [-80.878774, 23.250434]
    ],
    [
        [120.021861, 23.451644],
        [120.115251, 23.547912],
        [120.124770, 23.550454],
        [120.021861, 23.451644]
    ],
    [
        [116.995616, 23.563544],
        [116.936046, 23.535549],
        [116.937266, 23.526272],
        [116.987804, 23.524115],
        [116.995616, 23.563544]
    ],
    [
        [-75.109039, 23.846910],
        [-75.123647, 23.831000],
        [-75.117421, 23.815131],
        [-75.105784, 23.831448],
        [-75.109039, 23.846910]
    ],
    [
        [153.966238, 24.308661],
        [153.953461, 24.292507],
        [153.940684, 24.311469],
        [153.953705, 24.315823],
        [153.966238, 24.308661]
    ],
    [
        [-77.869211, 24.346829],
        [-77.867299, 24.319485],
        [-77.832834, 24.349555],
        [-77.839752, 24.350084],
        [-77.869211, 24.346829]
    ],
    [
        [54.325857, 24.373033],
        [54.279063, 24.364447],
        [54.308930, 24.313870],
        [54.336111, 24.350328],
        [54.325857, 24.373033]
    ],
    [
        [52.309744, 24.539496],
        [52.283214, 24.497016],
        [52.314228, 24.475651],
        [52.339238, 24.501552],
        [52.309744, 24.539496]
    ],
    [
        [-76.774322, 24.538642],
        [-76.792388, 24.549140],
        [-76.789296, 24.518500],
        [-76.772572, 24.519110],
        [-76.774322, 24.538642]
    ],
    [
        [-82.118398, 24.556464],
        [-82.128285, 24.553697],
        [-82.128774, 24.550849],
        [-82.113759, 24.557318],
        [-82.118398, 24.556464]
    ],
    [
        [-82.119618, 24.585110],
        [-82.110463, 24.565497],
        [-82.145741, 24.592719],
        [-82.134755, 24.592963],
        [-82.119618, 24.585110]
    ],
    [
        [-81.424469, 24.654975],
        [-81.414784, 24.647691],
        [-81.410634, 24.655422],
        [-81.417592, 24.659410],
        [-81.424469, 24.654975]
    ],
    [
        [-81.265207, 24.671291],
        [-81.277496, 24.657620],
        [-81.276031, 24.655585],
        [-81.258372, 24.667629],
        [-81.265207, 24.671291]
    ],
    [
        [-81.448069, 24.680569],
        [-81.460683, 24.664374],
        [-81.441396, 24.650539],
        [-81.439320, 24.660386],
        [-81.448069, 24.680569]
    ],
    [
        [-81.482411, 24.683254],
        [-81.515004, 24.697740],
        [-81.520172, 24.674058],
        [-81.481313, 24.649848],
        [-81.482411, 24.683254]
    ],
    [
        [-81.329457, 24.703315],
        [-81.340891, 24.700100],
        [-81.317779, 24.674954],
        [-81.320668, 24.694485],
        [-81.329457, 24.703315]
    ],
    [
        [-110.586163, 24.832117],
        [-110.569228, 24.843842],
        [-110.561414, 24.815017],
        [-110.580328, 24.821168],
        [-110.586163, 24.832117]
    ],
    [
        [125.202891, 24.846259],
        [125.163585, 24.854641],
        [125.140147, 24.816392],
        [125.205251, 24.804999],
        [125.202891, 24.846259]
    ],
    [
        [-80.700836, 24.881008],
        [-80.729726, 24.862779],
        [-80.738352, 24.850735],
        [-80.710846, 24.864325],
        [-80.700836, 24.881008]
    ],
    [
        [-80.625478, 24.936225],
        [-80.625478, 24.936225]
    ],
    [
        [-115.752797, 24.954779],
        [-115.753774, 24.954413],
        [-115.753285, 24.953030],
        [-115.752309, 24.953274],
        [-115.752797, 24.954779]
    ],
    [
        [119.551036, 25.209459],
        [119.470388, 25.252183],
        [119.444672, 25.229071],
        [119.528982, 25.165351],
        [119.551036, 25.209459]
    ],
    [
        [-81.047475, 25.309394],
        [-81.078359, 25.301703],
        [-81.066884, 25.276760],
        [-81.039784, 25.296698],
        [-81.047475, 25.309394]
    ],
    [
        [-110.714791, 25.305926],
        [-110.689525, 25.308389],
        [-110.728873, 25.259982],
        [-110.732742, 25.287954],
        [-110.714791, 25.305926]
    ],
    [
        [-81.089019, 25.338853],
        [-81.116526, 25.341946],
        [-81.122222, 25.336575],
        [-81.090728, 25.312812],
        [-81.089019, 25.338853]
    ],
    [
        [-77.864125, 25.407904],
        [-77.836822, 25.434516],
        [-77.906728, 25.409084],
        [-77.879506, 25.407864],
        [-77.864125, 25.407904]
    ],
    [
        [37.026866, 25.419623],
        [36.999278, 25.469428],
        [36.951834, 25.467515],
        [36.946544, 25.441881],
        [37.026866, 25.419623]
    ],
    [
        [-112.106306, 25.484113],
        [-112.098136, 25.485822],
        [-112.104347, 25.342348],
        [-112.122754, 25.282136],
        [-112.106306, 25.484113]
    ],
    [
        [36.942149, 25.418362],
        [36.904307, 25.394110],
        [36.899750, 25.361029],
        [36.942149, 25.418362]
    ],
    [
        [36.849376, 25.533026],
        [36.866547, 25.557522],
        [36.841319, 25.570014],
        [36.826996, 25.547187],
        [36.849376, 25.533026]
    ],
    [
        [36.790212, 25.497870],
        [36.725597, 25.565172],
        [36.681407, 25.553453],
        [36.790212, 25.497870]
    ],
    [
        [119.346528, 25.566718],
        [119.281505, 25.482896],
        [119.296886, 25.422919],
        [119.334972, 25.437974],
        [119.346528, 25.566718]
    ],
    [
        [36.900727, 25.549302],
        [36.923188, 25.519436],
        [36.914399, 25.606635],
        [36.898204, 25.595445],
        [36.900727, 25.549302]
    ],
    [
        [36.683116, 25.572333],
        [36.543630, 25.702867],
        [36.491466, 25.645087],
        [36.539399, 25.589179],
        [36.683116, 25.572333]
    ],
    [
        [-111.059148, 25.700978],
        [-111.019226, 25.693887],
        [-111.028510, 25.651793],
        [-111.047703, 25.670636],
        [-111.059148, 25.700978]
    ],
    [
        [-79.250071, 25.774726],
        [-79.280344, 25.757229],
        [-79.301259, 25.716864],
        [-79.300649, 25.697943],
        [-79.250071, 25.774726]
    ],
    [
        [-111.258235, 25.812789],
        [-111.258494, 25.781399],
        [-111.245943, 25.765702],
        [-111.247525, 25.799136],
        [-111.258235, 25.812789]
    ],
    [
        [-81.380483, 25.820950],
        [-81.429514, 25.850898],
        [-81.440500, 25.842434],
        [-81.439565, 25.803900],
        [-81.380483, 25.820950]
    ],
    [
        [36.544281, 25.731350],
        [36.583018, 25.698676],
        [36.611095, 25.709459],
        [36.590831, 25.860541],
        [36.544281, 25.731350]
    ],
    [
        [-81.453359, 25.825507],
        [-81.474355, 25.872463],
        [-81.516916, 25.859768],
        [-81.512034, 25.836127],
        [-81.453359, 25.825507]
    ],
    [
        [-81.676137, 25.901272],
        [-81.708404, 25.898668],
        [-81.696156, 25.865790],
        [-81.660024, 25.886542],
        [-81.676137, 25.901272]
    ],
    [
        [-81.541005, 25.890123],
        [-81.558339, 25.903388],
        [-81.545766, 25.853664],
        [-81.533559, 25.878648],
        [-81.541005, 25.890123]
    ],
    [
        [54.546560, 25.926500],
        [54.509776, 25.913764],
        [54.513682, 25.902655],
        [54.553233, 25.899848],
        [54.546560, 25.926500]
    ],
    [
        [119.626964, 26.107896],
        [119.599376, 26.128119],
        [119.553966, 26.095649],
        [119.620372, 26.064195],
        [119.626964, 26.107896]
    ],
    [
        [-111.286624, 26.125846],
        [-111.286204, 26.103132],
        [-111.264243, 26.105006],
        [-111.263725, 26.135042],
        [-111.286624, 26.125846]
    ],
    [
        [127.369640, 26.214586],
        [127.346202, 26.206366],
        [127.353526, 26.153998],
        [127.361095, 26.164008],
        [127.369640, 26.214586]
    ],
    [
        [-77.244252, 26.478461],
        [-77.278228, 26.465806],
        [-77.254547, 26.438137],
        [-77.241038, 26.442816],
        [-77.244252, 26.478461]
    ],
    [
        [-77.853831, 26.600775],
        [-77.893137, 26.602607],
        [-77.868398, 26.563870],
        [-77.834625, 26.610541],
        [-77.853831, 26.600775]
    ],
    [
        [55.894298, 26.679429],
        [55.868337, 26.666449],
        [55.853201, 26.621039],
        [55.889659, 26.623765],
        [55.894298, 26.679429]
    ],
    [
        [53.639415, 26.688788],
        [53.609223, 26.690497],
        [53.601248, 26.679592],
        [53.646251, 26.657172],
        [53.639415, 26.688788]
    ],
    [
        [120.326834, 26.939683],
        [120.344900, 26.971951],
        [120.385671, 26.935167],
        [120.352550, 26.923774],
        [120.326834, 26.939683]
    ],
    [
        [-112.097003, 27.224523],
        [-112.045253, 27.216644],
        [-112.066279, 27.178965],
        [-112.087448, 27.182942],
        [-112.097003, 27.224523]
    ],
    [
        [-111.892268, 27.429019],
        [-111.901083, 27.449228],
        [-111.856394, 27.437870],
        [-111.859621, 27.430141],
        [-111.892268, 27.429019]
    ],
    [
        [121.074002, 27.479484],
        [121.103365, 27.451880],
        [121.067264, 27.436770],
        [121.046109, 27.465199],
        [121.074002, 27.479484]
    ],
    [
        [142.105154, 27.727037],
        [142.111664, 27.725857],
        [142.107188, 27.716742],
        [142.105154, 27.727037]
    ],
    [
        [121.181651, 27.864651],
        [121.114024, 27.844143],
        [121.097992, 27.817816],
        [121.171235, 27.818793],
        [121.181651, 27.864651]
    ],
    [
        [-115.204156, 27.892496],
        [-115.220367, 27.888640],
        [-115.164596, 27.851296],
        [-115.162365, 27.868343],
        [-115.204156, 27.892496]
    ],
    [
        [34.731882, 27.957141],
        [34.704695, 27.908368],
        [34.661786, 27.930218],
        [34.681773, 27.958703],
        [34.731882, 27.957141]
    ],
    [
        [121.049327, 27.950873],
        [121.103282, 27.946194],
        [121.139659, 27.965766],
        [121.070160, 27.982896],
        [121.049327, 27.950873]
    ],
    [
        [-111.388508, 27.968802],
        [-111.387440, 27.988079],
        [-111.365587, 27.953400],
        [-111.381951, 27.957243],
        [-111.388508, 27.968802]
    ],
    [
        [-115.593807, 28.317167],
        [-115.592321, 28.297501],
        [-115.564667, 28.307373],
        [-115.588265, 28.309779],
        [-115.593807, 28.317167]
    ],
    [
        [-82.666005, 28.734442],
        [-82.683217, 28.737738],
        [-82.696034, 28.725572],
        [-82.673736, 28.714423],
        [-82.666005, 28.734442]
    ],
    [
        [-82.696401, 28.763983],
        [-82.673818, 28.766669],
        [-82.679921, 28.784654],
        [-82.694936, 28.787584],
        [-82.696401, 28.763983]
    ],
    [
        [-90.652089, 29.067206],
        [-90.714101, 29.065416],
        [-90.767161, 29.047065],
        [-90.749420, 29.040961],
        [-90.672760, 29.057278],
        [-90.656321, 29.063218],
        [-90.652089, 29.067206]
    ],
    [
        [-90.417388, 29.055487],
        [-90.452301, 29.069566],
        [-90.413401, 29.048570],
        [-90.417388, 29.055487]
    ],
    [
        [-113.518840, 29.095563],
        [-113.514318, 29.053284],
        [-113.492011, 29.035950],
        [-113.504707, 29.092178],
        [-113.518840, 29.095563]
    ],
    [
        [121.862153, 29.129584],
        [121.789806, 29.149848],
        [121.782725, 29.124661],
        [121.842052, 29.095038],
        [121.862153, 29.129584]
    ],
    [
        [-83.038197, 29.145209],
        [-83.050282, 29.155707],
        [-83.058176, 29.136176],
        [-83.029652, 29.139797],
        [-83.038197, 29.145209]
    ],
    [
        [-90.450022, 29.235093],
        [-90.433827, 29.255113],
        [-90.434560, 29.264472],
        [-90.446278, 29.260321],
        [-90.450022, 29.235093]
    ],
    [
        [-89.927846, 29.288153],
        [-89.933827, 29.284573],
        [-89.938954, 29.277248],
        [-89.913157, 29.290229],
        [-89.927846, 29.288153]
    ],
    [
        [-89.994944, 29.456610],
        [-90.061106, 29.504543],
        [-90.119862, 29.505520],
        [-90.091949, 29.473538],
        [-89.994944, 29.456610]
    ],
    [
        [-89.057037, 29.562079],
        [-89.057037, 29.562079]
    ],
    [
        [-88.979604, 29.632880],
        [-88.978261, 29.631659],
        [-88.964508, 29.642768],
        [-88.970082, 29.639797],
        [-88.979604, 29.632880]
    ],
    [
        [-88.925404, 29.683092],
        [-88.889556, 29.725328],
        [-88.938832, 29.673285],
        [-88.925404, 29.683092]
    ],
    [
        [122.304698, 29.817450],
        [122.271169, 29.846829],
        [122.231700, 29.836249],
        [122.308360, 29.776272],
        [122.304698, 29.817450]
    ],
    [
        [121.972179, 29.944770],
        [121.940929, 29.937690],
        [121.946137, 29.903957],
        [121.992442, 29.908271],
        [121.972179, 29.944770]
    ],
    [
        [-114.418542, 29.986776],
        [-114.422017, 29.966236],
        [-114.394781, 29.960184],
        [-114.401849, 29.986034],
        [-114.418542, 29.986776]
    ],
    [
        [122.345714, 30.241929],
        [122.345714, 30.241929]
    ],
    [
        [-116.114411, 30.496223],
        [-116.122767, 30.485167],
        [-116.104175, 30.482589],
        [-116.109612, 30.495347],
        [-116.114411, 30.496223]
    ],
    [
        [122.529307, 30.720771],
        [122.429942, 30.743069],
        [122.427257, 30.703925],
        [122.524750, 30.701809],
        [122.529307, 30.720771]
    ],
    [
        [121.762380, 31.373765],
        [121.691254, 31.419176],
        [121.584483, 31.441392],
        [121.766368, 31.320624],
        [121.762380, 31.373765]
    ],
    [
        [-81.251289, 31.504578],
        [-81.174650, 31.521421],
        [-81.279611, 31.385481],
        [-81.300320, 31.411516],
        [-81.251289, 31.504578]
    ],
    [
        [-81.160555, 31.669889],
        [-81.136435, 31.698410],
        [-81.160960, 31.567314],
        [-81.179485, 31.635942],
        [-81.160555, 31.669889]
    ],
    [
        [129.933360, 31.867825],
        [129.844981, 31.880601],
        [129.820567, 31.845526],
        [129.889903, 31.810736],
        [129.933360, 31.867825]
    ],
    [
        [130.243907, 32.301825],
        [130.217052, 32.286933],
        [130.210704, 32.255357],
        [130.263031, 32.281317],
        [130.243907, 32.301825]
    ],
    [
        [-117.253693, 32.420802],
        [-117.243205, 32.388743],
        [-117.239321, 32.389118],
        [-117.245032, 32.414627],
        [-117.253693, 32.420802]
    ],
    [
        [130.446788, 32.596829],
        [130.398774, 32.593166],
        [130.427582, 32.537299],
        [130.450938, 32.563422],
        [130.446788, 32.596829]
    ],
    [
        [132.562022, 32.742133],
        [132.539887, 32.733791],
        [132.549653, 32.704291],
        [132.570811, 32.717271],
        [132.562022, 32.742133]
    ],
    [
        [128.899750, 32.818305],
        [128.837250, 32.833808],
        [128.840099, 32.777574],
        [128.882335, 32.765286],
        [128.899750, 32.818305]
    ],
    [
        [128.953136, 32.874213],
        [128.929454, 32.849799],
        [128.880707, 32.862616],
        [128.945079, 32.804348],
        [128.953136, 32.874213]
    ],
    [
        [129.027843, 32.899807],
        [128.984630, 32.929185],
        [128.968028, 32.873684],
        [129.024099, 32.848049],
        [129.027843, 32.899807]
    ],
    [
        [129.135509, 33.299872],
        [129.089122, 33.283271],
        [129.075043, 33.259914],
        [129.127289, 33.247504],
        [129.135509, 33.299872]
    ],
    [
        [129.555919, 33.493964],
        [129.541759, 33.507310],
        [129.503184, 33.473700],
        [129.576427, 33.488349],
        [129.555919, 33.493964]
    ],
    [
        [-118.234676, 33.763153],
        [-118.236346, 33.728046],
        [-118.257629, 33.716554],
        [-118.267506, 33.747029],
        [-118.234676, 33.763153]
    ],
    [
        [132.641368, 34.014065],
        [132.596365, 33.980943],
        [132.589122, 33.956448],
        [132.634451, 33.964830],
        [132.641368, 34.014065]
    ],
    [
        [125.127696, 34.048570],
        [125.136404, 34.059272],
        [125.102224, 34.095933],
        [125.092133, 34.071763],
        [125.127696, 34.048570]
    ],
    [
        [126.598969, 34.168647],
        [126.532888, 34.179104],
        [126.507091, 34.138861],
        [126.613536, 34.152533],
        [126.598969, 34.168647]
    ],
    [
        [133.093516, 34.174302],
        [133.033051, 34.189399],
        [133.017100, 34.118842],
        [133.045177, 34.118394],
        [133.093516, 34.174302]
    ],
    [
        [126.672048, 34.153266],
        [126.670746, 34.189887],
        [126.645274, 34.197170],
        [126.638682, 34.128119],
        [126.672048, 34.153266]
    ],
    [
        [132.738536, 34.196967],
        [132.708995, 34.203315],
        [132.688975, 34.189887],
        [132.740001, 34.159898],
        [132.738536, 34.196967]
    ],
    [
        [126.909353, 34.197699],
        [126.867931, 34.207465],
        [126.853201, 34.159003],
        [126.913585, 34.157660],
        [126.909353, 34.197699]
    ],
    [
        [126.612153, 34.218166],
        [126.559744, 34.234524],
        [126.549815, 34.191230],
        [126.583832, 34.175605],
        [126.612153, 34.218166]
    ],
    [
        [132.921153, 34.277330],
        [132.846446, 34.240220],
        [132.849946, 34.215155],
        [132.916759, 34.221869],
        [132.921153, 34.277330]
    ],
    [
        [132.338390, 34.304429],
        [132.298839, 34.292222],
        [132.267914, 34.244452],
        [132.325531, 34.264716],
        [132.338390, 34.304429]
    ],
    [
        [126.088715, 34.307929],
        [126.033214, 34.314887],
        [126.021658, 34.295640],
        [126.069347, 34.278998],
        [126.088715, 34.307929]
    ],
    [
        [126.853852, 34.308539],
        [126.893321, 34.341254],
        [126.757579, 34.336127],
        [126.840587, 34.303371],
        [126.853852, 34.308539]
    ],
    [
        [127.091563, 34.344916],
        [127.025401, 34.381334],
        [126.991466, 34.356269],
        [127.038829, 34.312893],
        [127.091563, 34.344916]
    ],
    [
        [133.715668, 34.396145],
        [133.691905, 34.378404],
        [133.703136, 34.351752],
        [133.725841, 34.371405],
        [133.715668, 34.396145]
    ],
    [
        [126.763927, 34.309231],
        [126.709972, 34.392890],
        [126.645763, 34.385565],
        [126.688975, 34.301093],
        [126.763927, 34.309231]
    ],
    [
        [126.762462, 34.382961],
        [126.775727, 34.354722],
        [126.861095, 34.392768],
        [126.823009, 34.439846],
        [126.762462, 34.382961]
    ],
    [
        [135.205179, 34.430491],
        [135.240971, 34.454647],
        [135.257054, 34.435778],
        [135.224416, 34.416304],
        [135.205179, 34.430491]
    ],
    [
        [134.049001, 34.474351],
        [134.072032, 34.498481],
        [134.104503, 34.490261],
        [134.083995, 34.459825],
        [134.049001, 34.474351]
    ],
    [
        [136.891968, 34.496692],
        [136.908953, 34.502362],
        [136.883204, 34.475366],
        [136.872599, 34.491139],
        [136.891968, 34.496692]
    ],
    [
        [136.890179, 34.531201],
        [136.890179, 34.531201]
    ],
    [
        [128.294607, 34.639553],
        [128.236257, 34.610460],
        [128.225271, 34.632839],
        [128.239513, 34.652411],
        [128.294607, 34.639553]
    ],
    [
        [128.385830, 34.820125],
        [128.437997, 34.819572],
        [128.423083, 34.763253],
        [128.332049, 34.825702],
        [128.385830, 34.820125]
    ],
    [
        [128.239919, 34.836168],
        [128.227306, 34.838568],
        [128.205821, 34.815619],
        [128.238455, 34.796942],
        [128.239919, 34.836168]
    ],
    [
        [136.798060, 34.876401],
        [136.823503, 34.862037],
        [136.815002, 34.839917],
        [136.807731, 34.839196],
        [136.798060, 34.876401]
    ],
    [
        [126.340668, 34.864081],
        [126.297374, 34.917548],
        [126.230724, 34.854560],
        [126.342052, 34.822496],
        [126.340668, 34.864081]
    ],
    [
        [126.234223, 35.047065],
        [126.261078, 35.024563],
        [126.236013, 35.098375],
        [126.158702, 35.094224],
        [126.234223, 35.047065]
    ],
    [
        [12.621755, 35.509752],
        [12.555675, 35.521226],
        [12.526134, 35.516669],
        [12.611095, 35.489244],
        [12.621755, 35.509752]
    ],
    [
        [27.565684, 36.244940],
        [27.518891, 36.216864],
        [27.618663, 36.228095],
        [27.616466, 36.242621],
        [27.565684, 36.244940]
    ],
    [
        [27.185802, 36.615668],
        [27.137218, 36.600084],
        [27.129731, 36.569525],
        [27.198009, 36.568305],
        [27.185802, 36.615668]
    ],
    [
        [137.048106, 37.152289],
        [136.999034, 37.139472],
        [136.905284, 37.143622],
        [136.947276, 37.096991],
        [137.048106, 37.152289]
    ],
    [
        [26.871837, 37.134101],
        [26.849783, 37.187323],
        [26.772716, 37.182685],
        [26.849946, 37.098456],
        [26.871837, 37.134101]
    ],
    [
        [-75.903773, 37.129214],
        [-75.905420, 37.234426],
        [-75.873971, 37.290380],
        [-75.810779, 37.200169],
        [-75.903773, 37.129214]
    ],
    [
        [26.598806, 37.355414],
        [26.536388, 37.372707],
        [26.548839, 37.326565],
        [26.598806, 37.355414]
    ],
    [
        [24.739431, 37.613837],
        [24.716075, 37.631049],
        [24.659679, 37.606879],
        [24.718110, 37.593573],
        [24.739431, 37.613837]
    ],
    [
        [12.072276, 37.967922],
        [12.053559, 37.992418],
        [12.030447, 37.984361],
        [12.079275, 37.950263],
        [12.072276, 37.967922]
    ],
    [
        [20.945160, 38.652493],
        [20.888357, 38.628974],
        [20.870616, 38.582506],
        [20.941661, 38.627387],
        [20.945160, 38.652493]
    ],
    [
        [20.800955, 38.665269],
        [20.736990, 38.652167],
        [20.751720, 38.626044],
        [20.800059, 38.595445],
        [20.800955, 38.665269]
    ],
    [
        [-9.041127, 38.867621],
        [-9.061391, 38.852240],
        [-9.079661, 38.820136],
        [-9.041412, 38.849189],
        [-9.041127, 38.867621]
    ],
    [
        [118.632743, 39.074581],
        [118.648736, 39.044651],
        [118.594321, 38.972197],
        [118.480276, 38.934820],
        [118.632743, 39.074581]
    ],
    [
        [2.985367, 39.166176],
        [2.962154, 39.116062],
        [2.913614, 39.151963],
        [2.980582, 39.185560],
        [2.985367, 39.166176]
    ],
    [
        [24.081309, 39.352362],
        [24.044932, 39.341498],
        [24.063162, 39.297024],
        [24.094005, 39.330024],
        [24.081309, 39.352362]
    ],
    [
        [124.596039, 39.430243],
        [124.592865, 39.446804],
        [124.612559, 39.457139],
        [124.619070, 39.433010],
        [124.596039, 39.430243]
    ],
    [
        [124.214651, 39.807242],
        [124.230017, 39.821172],
        [124.242751, 39.804633],
        [124.223189, 39.791557],
        [124.214651, 39.807242]
    ],
    [
        [27.645193, 40.459866],
        [27.607270, 40.505439],
        [27.579926, 40.476549],
        [27.656586, 40.449449],
        [27.645193, 40.459866]
    ],
    [
        [-72.341559, 41.090652],
        [-72.280482, 41.078895],
        [-72.275527, 41.031833],
        [-72.371306, 41.054992],
        [-72.341559, 41.090652]
    ],
    [
        [-72.131022, 41.120472],
        [-72.141521, 41.096849],
        [-72.100823, 41.054246],
        [-72.078431, 41.099964],
        [-72.131022, 41.120472]
    ],
    [
        [9.474783, 41.236070],
        [9.437022, 41.185940],
        [9.464366, 41.172675],
        [9.474864, 41.179267],
        [9.474783, 41.236070]
    ],
    [
        [9.430919, 41.224799],
        [9.414236, 41.262437],
        [9.373057, 41.229885],
        [9.395274, 41.210598],
        [9.430919, 41.224799]
    ],
    [
        [-70.830471, 41.260366],
        [-70.814021, 41.263167],
        [-70.801756, 41.248076],
        [-70.823108, 41.250760],
        [-70.830471, 41.260366]
    ],
    [
        [-70.871176, 41.438670],
        [-70.848598, 41.434332],
        [-70.948503, 41.414124],
        [-70.926030, 41.428917],
        [-70.871176, 41.438670]
    ],
    [
        [-70.724354, 41.511100],
        [-70.679194, 41.510450],
        [-70.790816, 41.449199],
        [-70.839861, 41.450531],
        [-70.724354, 41.511100]
    ],
    [
        [10.297048, 42.344875],
        [10.294444, 42.328030],
        [10.313243, 42.323920],
        [10.315929, 42.340766],
        [10.297048, 42.344875]
    ],
    [
        [10.091645, 42.595771],
        [10.079438, 42.613918],
        [10.050304, 42.581936],
        [10.085785, 42.572455],
        [10.091645, 42.595771]
    ],
    [
        [132.449880, 42.828111],
        [132.453624, 42.860907],
        [132.427501, 42.895901],
        [132.401541, 42.831977],
        [132.449880, 42.828111]
    ],
    [
        [6.235037, 43.022406],
        [6.175141, 43.008979],
        [6.166189, 42.999661],
        [6.252209, 43.002632],
        [6.235037, 43.022406]
    ],
    [
        [16.310313, 43.507758],
        [16.264415, 43.512885],
        [16.211436, 43.490058],
        [16.375255, 43.490180],
        [16.310313, 43.507758]
    ],
    [
        [47.851085, 43.999213],
        [47.665701, 43.996283],
        [47.628184, 43.962592],
        [47.762950, 43.928412],
        [47.851085, 43.999213]
    ],
    [
        [14.759776, 44.292060],
        [14.748546, 44.261664],
        [14.789724, 44.266913],
        [14.791677, 44.272528],
        [14.759776, 44.292060]
    ],
    [
        [14.613455, 44.340806],
        [14.595063, 44.347113],
        [14.661388, 44.308661],
        [14.643565, 44.325751],
        [14.613455, 44.340806]
    ],
    [
        [14.797862, 44.377672],
        [14.803233, 44.405504],
        [14.763438, 44.415351],
        [14.756196, 44.364000],
        [14.797862, 44.377672]
    ],
    [
        [14.244151, 44.661444],
        [14.232595, 44.626044],
        [14.271169, 44.612535],
        [14.280447, 44.677558],
        [14.244151, 44.661444]
    ],
    [
        [50.743663, 44.886135],
        [50.713715, 44.953803],
        [50.627940, 44.967027],
        [50.697765, 44.857856],
        [50.743663, 44.886135]
    ],
    [
        [12.329845, 45.458808],
        [12.320649, 45.429836],
        [12.362071, 45.438137],
        [12.363780, 45.449652],
        [12.329845, 45.458808]
    ],
    [
        [52.692882, 45.459703],
        [52.635509, 45.525621],
        [52.552013, 45.478339],
        [52.677094, 45.396959],
        [52.692882, 45.459703]
    ],
    [
        [47.997081, 45.467841],
        [47.997081, 45.520494],
        [47.957042, 45.650458],
        [47.917735, 45.570054],
        [47.997081, 45.467841]
    ],
    [
        [-62.544962, 45.826666],
        [-62.506908, 45.828065],
        [-62.603144, 45.804211],
        [-62.574416, 45.824000],
        [-62.544962, 45.826666]
    ],
    [
        [-59.708079, 45.994696],
        [-59.695180, 46.034003],
        [-59.780995, 46.004381],
        [-59.725901, 46.000434],
        [-59.708079, 45.994696]
    ],
    [
        [-123.417085, 46.204842],
        [-123.405043, 46.200934],
        [-123.315661, 46.148536],
        [-123.411046, 46.175080],
        [-123.417085, 46.204842]
    ],
    [
        [-123.480747, 46.255944],
        [-123.444335, 46.235899],
        [-123.440840, 46.213248],
        [-123.468439, 46.225003],
        [-123.480747, 46.255944]
    ],
    [
        [49.822439, 46.313951],
        [49.750011, 46.357489],
        [49.719981, 46.356757],
        [49.804698, 46.210517],
        [49.822439, 46.313951]
    ],
    [
        [-54.794227, 47.279388],
        [-54.778136, 47.273564],
        [-54.812399, 47.231781],
        [-54.830051, 47.267133],
        [-54.794227, 47.279388]
    ],
    [
        [-54.195604, 47.393208],
        [-54.178042, 47.418193],
        [-54.144589, 47.400445],
        [-54.209626, 47.359903],
        [-54.195604, 47.393208]
    ],
    [
        [-70.369781, 47.426825],
        [-70.425364, 47.404975],
        [-70.435658, 47.377021],
        [-70.323883, 47.427436],
        [-70.369781, 47.426825]
    ],
    [
        [-52.956475, 47.654806],
        [-52.916443, 47.634456],
        [-53.030336, 47.599156],
        [-53.019184, 47.619040],
        [-52.956475, 47.654806]
    ],
    [
        [-68.864333, 48.407598],
        [-68.838064, 48.413809],
        [-68.891065, 48.388033],
        [-68.879785, 48.403460],
        [-68.864333, 48.407598]
    ],
    [
        [-125.861625, 49.237385],
        [-125.797002, 49.227035],
        [-125.801352, 49.143888],
        [-125.914986, 49.176295],
        [-125.861625, 49.237385]
    ],
    [
        [114.229828, 22.555813],
        [114.335134, 22.506415],
        [114.167491, 22.448065],
        [114.209321, 22.398668],
        [114.399750, 22.436143],
        [114.296723, 22.258287],
        [113.914399, 22.376125],
        [114.082367, 22.529364]
    ],
    [
        [107.311046, 21.005276],
        [107.415294, 21.328681],
        [107.590587, 21.293891],
        [107.752208, 21.513617],
        [107.970714, 21.431627],
        [108.238292, 21.643948],
        [108.211029, 21.500637],
        [108.341319, 21.725816],
        [108.518809, 21.595526],
        [108.565440, 21.678534],
        [108.463471, 21.740180],
        [108.505138, 21.787909],
        [108.448741, 21.865790],
        [108.477794, 21.945014],
        [108.745372, 21.602973],
        [108.861420, 21.643948],
        [108.801362, 21.818345],
        [108.927989, 21.615058],
        [109.135753, 21.602973],
        [109.138682, 21.401597],
        [109.530772, 21.491645],
        [109.567719, 21.759996],
        [109.649669, 21.520453],
        [109.944428, 21.493109],
        [109.661225, 20.927558],
        [109.860444, 20.715481],
        [109.822113, 20.516547],
        [110.009776, 20.434231],
        [109.862804, 20.406317],
        [109.917247, 20.239325],
        [110.280284, 20.252997],
        [110.534190, 20.478258],
        [110.300792, 20.657050],
        [110.409434, 20.750963],
        [110.368988, 20.848863],
        [110.156749, 20.848863],
        [110.195567, 21.071275],
        [110.399425, 21.176581],
        [110.431163, 21.191474],
        [111.027599, 21.540920],
        [111.630463, 21.529853],
        [111.787934, 21.616034],
        [111.678071, 21.781155],
        [111.867931, 21.676703],
        [112.000255, 21.774319],
        [111.890391, 21.925116],
        [112.286225, 21.708808],
        [112.402110, 21.801418],
        [112.356537, 21.979722],
        [112.397472, 22.068508],
        [112.550873, 21.772854],
        [112.826020, 21.966132],
        [112.911586, 21.856291],
        [113.085053, 22.207587],
        [113.157467, 22.024700],
        [113.401971, 22.179574],
        [113.160167, 22.487616],
        [113.165294, 22.575588],
        [113.483745, 22.155142],
        [113.599170, 22.575180],
        [113.212983, 22.904527],
        [113.483979, 22.924262],
        [113.417491, 23.096991],
        [113.703136, 23.157782],
        [113.813243, 23.129788],
        [113.830089, 23.117499],
        [113.582123, 23.098456],
        [113.532725, 22.995754],
        [113.638194, 23.034898],
        [113.605561, 22.847235],
        [113.890345, 22.452712],
        [114.082367, 22.529364]
    ],
    [
        [-55.854271, 50.205033],
        [-55.886002, 50.197461],
        [-55.883340, 50.204224],
        [-55.854271, 50.205033]
    ],
    [
        [-55.762971, 50.231935],
        [-55.802679, 50.220174],
        [-55.695802, 50.193721],
        [-55.729933, 50.230170],
        [-55.762971, 50.231935]
    ],
    [
        [-128.639076, 50.804670],
        [-128.603728, 50.819827],
        [-128.572578, 50.795158],
        [-128.615888, 50.782817],
        [-128.639076, 50.804670]
    ],
    [
        [-58.861186, 50.833051],
        [-58.846323, 50.789443],
        [-58.861108, 50.779595],
        [-58.885608, 50.794251],
        [-58.861186, 50.833051]
    ],
    [
        [-128.702140, 50.836559],
        [-128.704444, 50.807223],
        [-128.655007, 50.808795],
        [-128.662177, 50.825032],
        [-128.702140, 50.836559]
    ],
    [
        [-57.250265, 50.840641],
        [-57.209375, 50.841056],
        [-57.186562, 50.823001],
        [-57.252466, 50.796739],
        [-57.250265, 50.840641]
    ],
    [
        [-127.779120, 50.901524],
        [-127.688185, 50.900899],
        [-127.655989, 50.837846],
        [-127.834360, 50.878723],
        [-127.779120, 50.901524]
    ],
    [
        [-58.462634, 51.176264],
        [-58.427357, 51.167123],
        [-58.621209, 51.091776],
        [-58.546952, 51.150419],
        [-58.462634, 51.176264]
    ],
    [
        [-58.307577, 51.252270],
        [-58.362905, 51.202219],
        [-58.411010, 51.201632],
        [-58.388163, 51.238934],
        [-58.307577, 51.252270]
    ],
    [
        [-128.438216, 51.980797],
        [-128.432399, 51.902355],
        [-128.478828, 51.906844],
        [-128.486965, 51.953658],
        [-128.438216, 51.980797]
    ],
    [
        [-79.027455, 52.113593],
        [-79.080149, 52.106513],
        [-79.086659, 52.097480],
        [-79.001861, 52.107571],
        [-79.027455, 52.113593]
    ],
    [
        [-79.405670, 52.260972],
        [-79.484934, 52.253323],
        [-79.501291, 52.233100],
        [-79.381256, 52.244778],
        [-79.405670, 52.260972]
    ],
    [
        [-78.734242, 52.445136],
        [-78.768544, 52.447699],
        [-78.827260, 52.427639],
        [-78.749827, 52.406195],
        [-78.734242, 52.445136]
    ],
    [
        [-79.584625, 52.555162],
        [-79.612416, 52.577338],
        [-79.639394, 52.532620],
        [-79.565297, 52.545356],
        [-79.584625, 52.555162]
    ],
    [
        [-129.432788, 52.683120],
        [-129.400103, 52.679527],
        [-129.402445, 52.646643],
        [-129.449572, 52.643997],
        [-129.432788, 52.683120]
    ],
    [
        [-55.852330, 52.772470],
        [-55.811855, 52.770133],
        [-55.809475, 52.731086],
        [-55.895360, 52.763314],
        [-55.852330, 52.772470]
    ],
    [
        [-129.354662, 52.862510],
        [-129.366192, 52.814500],
        [-129.328924, 52.799611],
        [-129.312018, 52.839333],
        [-129.354662, 52.862510]
    ],
    [
        [-55.808466, 53.006564],
        [-55.767872, 52.988162],
        [-55.802337, 52.944583],
        [-55.850409, 53.003530],
        [-55.808466, 53.006564]
    ],
    [
        [-55.827319, 53.079284],
        [-55.771256, 53.089232],
        [-55.758767, 53.034088],
        [-55.870688, 53.026485],
        [-55.827319, 53.079284]
    ],
    [
        [-55.927587, 53.492236],
        [-55.767163, 53.475739],
        [-55.742891, 53.445437],
        [-55.983500, 53.441652],
        [-55.927587, 53.492236]
    ],
    [
        [-130.592115, 53.496183],
        [-130.586966, 53.466192],
        [-130.636068, 53.498406],
        [-130.616523, 53.506408],
        [-130.592115, 53.496183]
    ],
    [
        [-57.152729, 53.693121],
        [-57.129781, 53.704632],
        [-57.030801, 53.712985],
        [-57.113763, 53.642994],
        [-57.152729, 53.693121]
    ],
    [
        [-56.922484, 53.797559],
        [-56.836105, 53.806480],
        [-56.817715, 53.790041],
        [-56.922484, 53.797559]
    ],
    [
        [-130.609117, 53.797011],
        [-130.569379, 53.836742],
        [-130.419964, 53.783274],
        [-130.437885, 53.756889],
        [-130.609117, 53.797011]
    ],
    [
        [7.904145, 54.180406],
        [7.899181, 54.178168],
        [7.879893, 54.193915],
        [7.894542, 54.194648],
        [7.904145, 54.180406]
    ],
    [
        [7.912364, 54.192288],
        [7.917654, 54.186998],
        [7.933442, 54.189887],
        [7.929861, 54.195299],
        [7.912364, 54.192288]
    ],
    [
        [-57.327952, 54.287564],
        [-57.292498, 54.283742],
        [-57.314419, 54.239731],
        [-57.367639, 54.259035],
        [-57.327952, 54.287564]
    ],
    [
        [-81.105214, 54.332913],
        [-81.086049, 54.348212],
        [-81.101796, 54.374091],
        [-81.108022, 54.366034],
        [-81.105214, 54.332913]
    ],
    [
        [-57.244476, 54.484173],
        [-57.228932, 54.491941],
        [-57.197644, 54.449325],
        [-57.293337, 54.468605],
        [-57.244476, 54.484173]
    ],
    [
        [-130.817562, 54.486324],
        [-130.790006, 54.493734],
        [-130.729567, 54.420801],
        [-130.870027, 54.434751],
        [-130.817562, 54.486324]
    ],
    [
        [-57.303677, 54.574723],
        [-57.268041, 54.503520],
        [-57.362203, 54.507263],
        [-57.347349, 54.555123],
        [-57.303677, 54.574723]
    ],
    [
        [139.225456, 54.589358],
        [139.261462, 54.599234],
        [139.243593, 54.581032],
        [139.225456, 54.589358]
    ],
    [
        [-131.098760, 54.627962],
        [-131.056840, 54.625717],
        [-131.049953, 54.606029],
        [-131.090905, 54.582240],
        [-131.098760, 54.627962]
    ],
    [
        [138.190013, 54.715579],
        [138.226783, 54.715626],
        [138.240995, 54.713712],
        [138.195944, 54.701110],
        [138.190013, 54.715579]
    ],
    [
        [-133.520334, 54.814114],
        [-133.515167, 54.782457],
        [-133.521759, 54.766750],
        [-133.544749, 54.831692],
        [-133.520334, 54.814114]
    ],
    [
        [-131.189150, 55.103431],
        [-131.189992, 55.048337],
        [-131.254895, 55.069237],
        [-131.244148, 55.092744],
        [-131.189150, 55.103431]
    ],
    [
        [-133.307277, 55.432187],
        [-133.269251, 55.443950],
        [-133.236057, 55.440220],
        [-133.274493, 55.404280],
        [-133.307277, 55.432187]
    ],
    [
        [-76.730458, 56.160834],
        [-76.765492, 56.175971],
        [-76.780344, 56.108059],
        [-76.720774, 56.125393],
        [-76.730458, 56.160834]
    ],
    [
        [-77.849843, 56.315253],
        [-77.948964, 56.313381],
        [-77.980092, 56.286607],
        [-77.884633, 56.303534],
        [-77.849843, 56.315253]
    ],
    [
        [-77.487050, 56.442125],
        [-77.537017, 56.397040],
        [-77.535390, 56.379543],
        [-77.502553, 56.386461],
        [-77.487050, 56.442125]
    ],
    [
        [-78.811147, 56.657660],
        [-78.753000, 56.657294],
        [-78.739898, 56.666978],
        [-78.850942, 56.672675],
        [-78.811147, 56.657660]
    ],
    [
        [-76.623443, 56.681464],
        [-76.634185, 56.715277],
        [-76.654693, 56.548896],
        [-76.619049, 56.586900],
        [-76.623443, 56.681464]
    ],
    [
        [-76.651967, 57.071357],
        [-76.655995, 57.139797],
        [-76.725087, 57.190823],
        [-76.700917, 57.082668],
        [-76.651967, 57.071357]
    ],
    [
        [-78.268381, 57.198635],
        [-78.325551, 57.207668],
        [-78.381947, 57.174465],
        [-78.324330, 57.171861],
        [-78.268381, 57.198635]
    ],
    [
        [-78.336497, 57.305162],
        [-78.381012, 57.328803],
        [-78.480784, 57.291449],
        [-78.415395, 57.279283],
        [-78.336497, 57.305162]
    ],
    [
        [-152.288189, 57.396985],
        [-152.255922, 57.384243],
        [-152.315124, 57.363121],
        [-152.299935, 57.374118],
        [-152.288189, 57.396985]
    ],
    [
        [-76.791127, 57.336086],
        [-76.739410, 57.283881],
        [-76.835439, 57.425767],
        [-76.839263, 57.418850],
        [-76.791127, 57.336086]
    ],
    [
        [-136.137573, 58.265089],
        [-136.106984, 58.303409],
        [-136.027939, 58.294969],
        [-136.059997, 58.267785],
        [-136.137573, 58.265089]
    ],
    [
        [-135.718503, 58.346144],
        [-135.654904, 58.379797],
        [-135.543345, 58.334832],
        [-135.670623, 58.330900],
        [-135.718503, 58.346144]
    ],
    [
        [-67.558290, 58.411003],
        [-67.530842, 58.296897],
        [-67.635937, 58.291037],
        [-67.636557, 58.402225],
        [-67.558290, 58.411003]
    ],
    [
        [-78.628814, 58.779527],
        [-78.650868, 58.802069],
        [-78.707631, 58.786038],
        [-78.648264, 58.772162],
        [-78.628814, 58.779527]
    ],
    [
        [-78.901112, 58.832465],
        [-78.927073, 58.865546],
        [-78.937611, 58.864814],
        [-78.886057, 58.808051],
        [-78.901112, 58.832465]
    ],
    [
        [-152.035227, 58.951687],
        [-152.013132, 58.939846],
        [-152.074656, 58.914293],
        [-152.062489, 58.942776],
        [-152.035227, 58.951687]
    ],
    [
        [-68.995487, 59.016345],
        [-69.061197, 59.011175],
        [-69.120279, 58.957302],
        [-68.974561, 58.989633],
        [-68.995487, 59.016345]
    ],
    [
        [-80.552398, 59.110053],
        [-80.569936, 59.105618],
        [-80.582875, 59.098334],
        [-80.538564, 59.094672],
        [-80.552398, 59.110053]
    ],
    [
        [-151.687859, 59.129656],
        [-151.643720, 59.115749],
        [-151.646924, 59.103936],
        [-151.713647, 59.105835],
        [-151.687859, 59.129656]
    ],
    [
        [5.764008, 59.117865],
        [5.607921, 59.134426],
        [5.575206, 59.124010],
        [5.750743, 59.072333],
        [5.764008, 59.117865]
    ],
    [
        [-151.465133, 59.138191],
        [-151.428281, 59.117302],
        [-151.508501, 59.128566],
        [-151.500251, 59.137327],
        [-151.465133, 59.138191]
    ],
    [
        [-151.858987, 59.163867],
        [-151.816822, 59.170664],
        [-151.788782, 59.153053],
        [-151.893190, 59.144364],
        [-151.858987, 59.163867]
    ],
    [
        [149.032789, 59.192178],
        [149.040029, 59.202930],
        [149.141108, 59.207690],
        [149.103481, 59.161529],
        [149.032789, 59.192178]
    ],
    [
        [5.462087, 59.210883],
        [5.403819, 59.242092],
        [5.375336, 59.218817],
        [5.443207, 59.158922],
        [5.462087, 59.210883]
    ],
    [
        [6.016368, 59.292182],
        [5.952485, 59.283922],
        [5.929861, 59.243476],
        [6.099864, 59.276557],
        [6.016368, 59.292182]
    ],
    [
        [-146.323598, 59.452135],
        [-146.358632, 59.422431],
        [-146.358551, 59.410102],
        [-146.322418, 59.425849],
        [-146.323598, 59.452135]
    ],
    [
        [-80.518544, 59.694729],
        [-80.580556, 59.669257],
        [-80.588246, 59.661566],
        [-80.551503, 59.649400],
        [-80.518544, 59.694729]
    ],
    [
        [-80.387278, 59.711737],
        [-80.438710, 59.677436],
        [-80.443674, 59.648179],
        [-80.370269, 59.708726],
        [-80.387278, 59.711737]
    ],
    [
        [22.498546, 59.877631],
        [22.457042, 59.872992],
        [22.413829, 59.861233],
        [22.443696, 59.851467],
        [22.498546, 59.877631]
    ],
    [
        [20.281315, 59.976616],
        [20.339447, 60.020110],
        [20.447059, 59.995181],
        [20.306648, 59.953624],
        [20.281315, 59.976616]
    ],
    [
        [20.033650, 60.063626],
        [20.163259, 60.087845],
        [20.225218, 60.005478],
        [20.175121, 59.971436],
        [20.033650, 60.063626]
    ],
    [
        [-152.563181, 60.149970],
        [-152.604604, 60.178616],
        [-152.638132, 60.167304],
        [-152.580149, 60.107245],
        [-152.563181, 60.149970]
    ],
    [
        [21.600434, 60.254828],
        [21.586925, 60.269355],
        [21.563487, 60.226223],
        [21.626720, 60.252590],
        [21.600434, 60.254828]
    ],
    [
        [-147.360422, 60.300727],
        [-147.493886, 60.263129],
        [-147.491811, 60.228827],
        [-147.347808, 60.273586],
        [-147.360422, 60.300727]
    ],
    [
        [21.088634, 60.480129],
        [21.064301, 60.474351],
        [21.064952, 60.454779],
        [21.088227, 60.452216],
        [21.088634, 60.480129]
    ],
    [
        [4.845876, 60.628119],
        [4.791270, 60.666083],
        [4.779470, 60.598538],
        [4.843923, 60.589748],
        [4.845876, 60.628119]
    ],
    [
        [-173.064320, 60.642524],
        [-173.071726, 60.686225],
        [-173.111399, 60.664211],
        [-173.058420, 60.621283],
        [-173.064320, 60.642524]
    ],
    [
        [21.259532, 60.853095],
        [21.245860, 60.846015],
        [21.263194, 60.830268],
        [21.259532, 60.853095]
    ],
    [
        [-146.820306, 60.841694],
        [-146.761620, 60.879250],
        [-146.704063, 60.839486],
        [-146.765580, 60.801956],
        [-146.820306, 60.841694]
    ],
    [
        [-147.094146, 60.897935],
        [-147.226918, 60.906806],
        [-147.318918, 60.877265],
        [-147.139638, 60.855618],
        [-147.094146, 60.897935]
    ],
    [
        [-69.921941, 61.013124],
        [-70.011946, 60.996764],
        [-70.003856, 60.935066],
        [-69.977643, 60.929860],
        [-69.921941, 61.013124]
    ],
    [
        [21.421886, 61.176744],
        [21.380056, 61.214016],
        [21.342947, 61.190619],
        [21.352387, 61.176011],
        [21.421886, 61.176744]
    ],
    [
        [-71.560975, 61.333436],
        [-71.487818, 61.337112],
        [-71.486495, 61.301894],
        [-71.586396, 61.301991],
        [-71.560975, 61.333436]
    ],
    [
        [21.521251, 61.633979],
        [21.484548, 61.640448],
        [21.459972, 61.629340],
        [21.507823, 61.618069],
        [21.521251, 61.633979]
    ],
    [
        [4.836274, 61.674547],
        [4.892100, 61.662787],
        [4.902843, 61.652493],
        [4.879893, 61.711982],
        [4.836274, 61.674547]
    ],
    [
        [-72.091425, 61.894741],
        [-71.993857, 61.870657],
        [-71.973440, 61.858942],
        [-72.130833, 61.889039],
        [-72.091425, 61.894741]
    ],
    [
        [-92.798413, 61.948019],
        [-92.771875, 61.935055],
        [-92.874966, 61.938678],
        [-92.850661, 61.947699],
        [-92.798413, 61.948019]
    ],
    [
        [-72.412140, 62.039061],
        [-72.384221, 62.032399],
        [-72.412140, 62.039061]
    ],
    [
        [-165.948923, 62.029527],
        [-165.972117, 62.072170],
        [-166.009836, 62.022935],
        [-165.947825, 62.015937],
        [-165.948923, 62.029527]
    ],
    [
        [-92.641700, 62.060656],
        [-92.652846, 62.026539],
        [-92.700898, 62.074635],
        [-92.641700, 62.060656]
    ],
    [
        [-66.438460, 62.895262],
        [-66.569044, 62.914832],
        [-66.561996, 62.931058],
        [-66.438460, 62.895262]
    ],
    [
        [21.208507, 62.946234],
        [21.195649, 62.994371],
        [21.130382, 63.000800],
        [21.146658, 62.953274],
        [21.208507, 62.946234]
    ],
    [
        [-66.924694, 63.065198],
        [-66.807359, 62.985936],
        [-66.770799, 62.944913],
        [-67.074457, 63.097501],
        [-66.924694, 63.065198]
    ],
    [
        [-68.145251, 63.272466],
        [-68.058483, 63.222676],
        [-68.049819, 63.192430],
        [-68.216111, 63.276375],
        [-68.145251, 63.272466]
    ],
    [
        [-68.023387, 63.300869],
        [-67.931728, 63.232875],
        [-67.894994, 63.189448],
        [-68.091999, 63.320381],
        [-68.023387, 63.300869]
    ],
    [
        [-67.852667, 63.345993],
        [-67.818293, 63.291333],
        [-67.964007, 63.409985],
        [-67.912529, 63.393133],
        [-67.852667, 63.345993]
    ],
    [
        [-20.261871, 63.444648],
        [-20.302602, 63.445950],
        [-20.286773, 63.406480],
        [-20.252553, 63.429511],
        [-20.261871, 63.444648]
    ],
    [
        [-64.043430, 63.563147],
        [-64.091172, 63.486470],
        [-64.168668, 63.604577],
        [-64.137308, 63.618040],
        [-64.043430, 63.563147]
    ],
    [
        [-64.217244, 63.842613],
        [-64.261105, 63.723887],
        [-64.342860, 63.769296],
        [-64.333994, 63.844829],
        [-64.217244, 63.842613]
    ],
    [
        [-76.484202, 64.181342],
        [-76.497426, 64.242580],
        [-76.572662, 64.234280],
        [-76.568512, 64.206122],
        [-76.484202, 64.181342]
    ],
    [
        [-76.664418, 64.241685],
        [-76.607411, 64.221015],
        [-76.565256, 64.254096],
        [-76.690053, 64.264065],
        [-76.664418, 64.241685]
    ],
    [
        [-64.965364, 64.309707],
        [-64.878303, 64.229578],
        [-64.991296, 64.193192],
        [-65.075487, 64.306968],
        [-64.965364, 64.309707]
    ],
    [
        [-172.475290, 64.641832],
        [-172.696034, 64.652533],
        [-172.725046, 64.626451],
        [-172.519399, 64.593004],
        [-172.475290, 64.641832]
    ],
    [
        [-168.035512, 64.985297],
        [-168.087595, 64.978827],
        [-168.096750, 64.965399],
        [-168.048411, 64.958930],
        [-168.035512, 64.985297]
    ],
    [
        [-66.934274, 65.317014],
        [-66.967847, 65.283030],
        [-67.016717, 65.319781],
        [-66.924565, 65.364898],
        [-66.934274, 65.317014]
    ],
    [
        [-89.046753, 65.406358],
        [-89.023045, 65.414704],
        [-88.969343, 65.387878],
        [-89.046753, 65.406358]
    ],
    [
        [-88.430800, 65.486990],
        [-88.383063, 65.472481],
        [-88.371277, 65.461990],
        [-88.489101, 65.473111],
        [-88.430800, 65.486990]
    ],
    [
        [-67.432516, 65.742713],
        [-67.389158, 65.736176],
        [-67.432516, 65.742713]
    ],
    [
        [-168.907908, 65.768297],
        [-168.942983, 65.764716],
        [-168.951731, 65.753160],
        [-168.909861, 65.739569],
        [-168.907908, 65.768297]
    ],
    [
        [-167.777008, 65.773017],
        [-167.819407, 65.759345],
        [-167.848704, 65.742825],
        [-167.738271, 65.777167],
        [-167.777008, 65.773017]
    ],
    [
        [-65.786418, 65.701988],
        [-65.837250, 65.678316],
        [-65.865552, 65.781228],
        [-65.770635, 65.763312],
        [-65.786418, 65.701988]
    ],
    [
        [-167.670929, 65.793728],
        [-167.730540, 65.745673],
        [-167.556467, 65.817369],
        [-167.566477, 65.816636],
        [-167.670929, 65.793728]
    ],
    [
        [-66.929467, 65.949834],
        [-67.105664, 65.957690],
        [-67.148557, 65.995890],
        [-66.963871, 65.996973],
        [-66.929467, 65.949834]
    ],
    [
        [-18.380238, 66.012112],
        [-18.414418, 66.023668],
        [-18.356760, 65.981635],
        [-18.356760, 65.993232],
        [-18.380238, 66.012112]
    ],
    [
        [-166.859486, 66.039740],
        [-167.232045, 65.917914],
        [-167.239491, 65.909247],
        [-166.835805, 66.041815],
        [-166.859486, 66.039740]
    ],
    [
        [-85.021725, 66.083070],
        [-84.997474, 66.057324],
        [-85.104005, 66.059024],
        [-85.080648, 66.081428],
        [-85.021725, 66.083070]
    ],
    [
        [-83.595204, 66.040107],
        [-83.558746, 66.045966],
        [-83.570383, 66.083686],
        [-83.622304, 66.049018],
        [-83.595204, 66.040107]
    ],
    [
        [-83.611440, 66.084621],
        [-83.574086, 66.110256],
        [-83.648793, 66.122952],
        [-83.648427, 66.071112],
        [-83.611440, 66.084621]
    ],
    [
        [-166.283477, 66.200629],
        [-166.762766, 66.071194],
        [-166.800526, 66.051500],
        [-166.283477, 66.200629]
    ],
    [
        [-166.088531, 66.256171],
        [-166.147410, 66.235419],
        [-166.156117, 66.226264],
        [-166.041819, 66.259996],
        [-166.088531, 66.256171]
    ],
    [
        [-165.864288, 66.316881],
        [-165.970041, 66.286689],
        [-166.010365, 66.257717],
        [-165.814036, 66.322455],
        [-165.864288, 66.316881]
    ],
    [
        [-165.704579, 66.361721],
        [-165.601389, 66.376654],
        [-165.690867, 66.370754],
        [-165.704579, 66.361721]
    ],
    [
        [-165.484771, 66.410305],
        [-165.484771, 66.410305]
    ],
    [
        [-165.381663, 66.425686],
        [-165.381663, 66.425686]
    ],
    [
        [-165.342628, 66.436715],
        [-165.342628, 66.436715]
    ],
    [
        [-85.955642, 66.463178],
        [-85.911232, 66.461991],
        [-85.896216, 66.453862],
        [-85.955642, 66.463178]
    ],
    [
        [-164.763336, 66.546454],
        [-165.042093, 66.493518],
        [-164.866567, 66.507025],
        [-164.763336, 66.546454]
    ],
    [
        [14.408458, 67.425767],
        [14.371755, 67.441107],
        [14.226736, 67.377346],
        [14.366466, 67.390937],
        [14.408458, 67.425767]
    ],
    [
        [-113.008308, 67.947294],
        [-112.816507, 67.969157],
        [-112.761341, 67.964081],
        [-113.008308, 67.947294]
    ],
    [
        [-112.836925, 68.170250],
        [-112.746130, 68.167627],
        [-112.717801, 68.155920],
        [-112.912256, 68.144884],
        [-112.836925, 68.170250]
    ],
    [
        [67.381196, 68.792263],
        [67.393077, 68.757310],
        [67.115815, 68.798367],
        [67.235606, 68.820380],
        [67.381196, 68.792263]
    ],
    [
        [180.000000, 68.981050],
        [179.261485, 69.272162],
        [179.067719, 69.325263],
        [178.772634, 69.415229],
        [176.734548, 69.674750],
        [176.127615, 69.893785],
        [175.781566, 69.885283],
        [176.157670, 69.821482],
        [175.997177, 69.769363],
        [173.278575, 69.941840],
        [173.175548, 69.914496],
        [173.164073, 69.886664],
        [173.479259, 69.835761],
        [173.198009, 69.783433],
        [172.725352, 69.980862],
        [170.481619, 70.142035],
        [170.591776, 69.764725],
        [170.160733, 69.613367],
        [170.606130, 69.589789],
        [171.159434, 69.044094],
        [170.680431, 68.940375],
        [170.728038, 68.821967],
        [170.449229, 68.863471],
        [170.625173, 68.748603],
        [169.625499, 68.777248],
        [169.371267, 69.076565],
        [168.288259, 69.242662],
        [168.254080, 69.544338],
        [167.802013, 69.775214],
        [166.893809, 69.495917],
        [164.834258, 69.567404],
        [164.027029, 69.773830],
        [162.327159, 69.701972],
        [161.702647, 69.495917],
        [161.415375, 69.331448],
        [161.574067, 68.921129],
        [161.134125, 68.561428],
        [161.106944, 68.605211],
        [161.415375, 68.982001],
        [160.962901, 69.105536],
        [161.006358, 69.577338],
        [159.769054, 69.762030],
        [159.692068, 69.910875],
        [159.914561, 70.098578],
        [159.938243, 70.128485],
        [160.094249, 70.309882],
        [159.843110, 70.581529],
        [159.237804, 70.829291],
        [157.989106, 71.047512],
        [155.936371, 71.099351],
        [152.798350, 70.834621]
    ],
    [
        [153.220788, 59.090295],
        [153.369151, 59.241278],
        [153.768557, 59.246583],
        [154.048676, 59.052802],
        [154.438021, 59.215521],
        [155.194102, 59.175767],
        [155.209713, 59.343880],
        [154.962901, 59.496080],
        [154.138438, 59.456977],
        [154.220074, 59.663976],
        [154.368251, 59.574686],
        [154.220770, 59.869620],
        [154.473481, 59.879340],
        [154.407835, 60.062928],
        [154.563698, 60.093705],
        [154.498975, 60.028848],
        [154.479157, 59.973307],
        [154.487590, 59.946307],
        [154.820995, 60.300232],
        [155.913621, 60.703583],
        [155.943060, 60.922629],
        [156.654971, 61.196760],
        [156.679463, 61.524017],
        [157.464509, 61.782105],
        [159.212289, 61.911855],
        [159.565586, 61.816648],
        [159.577213, 61.652771],
        [160.345714, 61.944729],
        [160.285140, 61.554107],
        [159.775618, 61.242206],
        [160.000141, 61.106118],
        [159.797539, 60.931103],
        [160.444215, 61.036220],
        [160.170095, 60.824897],
        [160.185933, 60.578406],
        [160.431016, 60.749204],
        [160.791624, 60.717700],
        [162.417247, 61.675849],
        [162.774840, 61.593885],
        [162.622667, 61.659069],
        [162.838817, 61.707571],
        [163.017284, 61.516585],
        [163.326549, 61.657856],
        [162.976734, 61.799570],
        [163.193124, 62.066623],
        [163.091487, 62.226638],
        [163.368918, 62.327670],
        [163.167731, 62.432055],
        [163.398934, 62.575902],
        [164.446919, 62.689419],
        [165.650890, 62.459174],
        [165.123782, 62.450614],
        [165.287283, 62.366116],
        [165.296886, 62.322577],
        [164.538313, 62.451110],
        [164.127194, 62.262379],
        [164.044815, 61.683433],
        [163.751475, 61.443305],
        [164.028819, 61.346625],
        [163.487303, 61.001664],
        [163.751040, 60.883058],
        [161.938555, 60.416788],
        [161.897215, 60.202961],
        [160.497325, 59.552476],
        [159.803477, 59.096381],
        [159.236990, 58.467841],
        [158.228770, 58.038642],
        [158.295258, 58.024848],
        [158.338227, 57.953030],
        [157.639659, 58.024970],
        [157.469900, 57.803941],
        [156.981456, 57.857123],
        [156.749034, 57.729560],
        [157.001288, 57.425505],
        [156.683849, 57.048326],
        [156.552094, 57.108954],
        [155.946544, 56.621894],
        [155.551177, 55.284205],
        [156.111196, 52.935420],
        [156.446625, 52.511420],
        [156.282237, 52.529446],
        [156.523611, 51.311510],
        [156.761545, 51.077974],
        [156.669988, 50.863917],
        [158.286876, 51.967515],
        [158.557872, 52.313056],
        [158.421153, 52.659125],
        [158.564708, 52.647366],
        [158.499766, 52.778957],
        [158.647146, 52.899359],
        [158.437836, 53.025336],
        [158.591563, 53.062161],
        [158.708669, 52.891791],
        [159.825043, 53.282945],
        [160.058604, 53.097357],
        [159.791026, 53.516303],
        [159.960460, 53.496772],
        [159.818207, 53.659654],
        [160.052989, 54.175727],
        [160.741222, 54.535224],
        [161.723806, 54.509426],
        [162.127609, 54.760405],
        [161.812981, 55.179184],
        [161.764131, 55.554846],
        [162.056752, 56.069135],
        [162.592540, 56.268490],
        [162.414042, 56.383870],
        [163.020133, 56.537641],
        [163.116052, 56.500504],
        [162.556814, 56.228502],
        [163.051208, 56.005404],
        [163.366069, 56.180659],
        [163.238969, 56.733021],
        [162.783500, 56.763029],
        [162.800196, 57.346434],
        [163.329510, 57.708945],
        [162.689952, 57.969713],
        [162.529796, 57.936510],
        [162.521789, 57.754156],
        [162.354503, 57.688544],
        [162.455539, 57.784351],
        [162.082042, 57.882473],
        [161.993228, 58.087392],
        [162.405294, 58.654445],
        [163.068549, 58.968053],
        [162.882660, 59.132799],
        [163.261869, 59.080830],
        [163.066905, 59.234076],
        [163.312511, 59.287543],
        [163.180186, 59.558254],
        [163.390147, 59.631537],
        [163.361827, 59.827460],
        [163.793793, 59.991360],
        [163.628673, 60.046576],
        [164.204845, 59.997504],
        [164.041677, 59.907538],
        [164.190440, 59.854193],
        [164.117931, 59.941392],
        [164.488536, 60.111029],
        [164.838634, 59.787421],
        [165.212087, 59.991360],
        [164.999278, 60.135321],
        [166.373302, 60.499457],
        [166.102794, 59.909410],
        [166.245128, 59.830634],
        [167.024913, 60.427680],
        [169.214366, 60.628730],
        [170.265147, 59.920356],
        [170.662120, 60.332017],
        [170.515880, 60.450629],
        [171.179454, 60.558905],
        [171.396332, 60.782945],
        [171.632579, 60.744818],
        [171.536876, 60.806952],
        [171.957774, 60.953111],
        [172.047130, 60.860663],
        [172.200857, 60.975775],
        [172.009288, 61.101142],
        [172.372569, 61.012885],
        [172.489594, 61.081244],
        [172.263031, 61.114732],
        [172.434418, 61.142727],
        [172.338227, 61.211005],
        [172.955089, 61.314032],
        [172.715587, 61.430732],
        [173.128429, 61.396959],
        [173.481130, 61.555243],
        [173.544607, 61.749091],
        [173.804942, 61.649848],
        [174.073009, 61.841620],
        [174.726899, 61.886298],
        [174.599946, 61.985012],
        [175.174490, 62.021918],
        [175.258067, 62.168769],
        [175.395193, 62.122748],
        [176.661876, 62.534613],
        [177.265880, 62.588324],
        [176.927908, 62.672919],
        [176.992198, 62.869452],
        [177.188975, 62.709662],
        [177.457774, 62.814846],
        [177.306814, 62.582099],
        [179.089529, 62.289740],
        [179.116059, 62.472235],
        [179.596853, 62.747870],
        [179.249522, 62.984687],
        [179.386485, 63.161200],
        [179.005544, 63.321357],
        [178.777029, 63.595160],
        [178.838390, 63.434882],
        [178.698985, 63.385688],
        [178.595470, 63.411322],
        [178.711274, 63.570014],
        [178.762869, 63.642768],
        [178.698416, 63.897366],
        [178.643240, 64.000963],
        [178.639415, 63.946357],
        [178.382579, 63.973049],
        [178.588634, 64.035102],
        [178.222016, 64.429429],
        [178.074555, 64.254218],
        [178.183849, 64.205797],
        [177.669932, 64.305121],
        [177.387380, 64.491889],
        [177.491873, 64.767524],
        [177.338390, 64.781480],
        [176.114268, 64.541938],
        [176.423676, 64.709621],
        [176.082367, 64.918931],
        [175.711681, 64.774726],
        [174.771739, 64.680650],
        [175.714610, 64.793647],
        [176.045665, 64.962795],
        [176.435802, 64.810940],
        [177.300059, 64.822740],
        [176.958507, 65.046576],
        [176.546153, 65.000922],
        [176.306326, 65.055487],
        [176.936860, 65.082831],
        [177.625011, 64.720160],
        [178.755870, 64.682196],
        [180.000000, 65.066190]
    ],
    [
        [-175.585683, 71.379869],
        [-175.617299, 71.381049],
        [-175.628651, 71.351752],
        [-175.585683, 71.379869]
    ],
    [
        [180.000000, 71.536420],
        [178.622244, 71.051011],
        [178.793305, 70.804999],
        [180.000000, 70.992423]
    ],
    [
        [-34.588938, -55.062839],
        [-34.565907, -55.059340],
        [-34.558420, -55.069838],
        [-34.579661, -55.078139],
        [-34.588938, -55.062839]
    ],
    [
        [-34.665110, -55.019789],
        [-34.630279, -55.015069],
        [-34.624298, -55.030369],
        [-34.651031, -55.054783],
        [-34.665110, -55.019789]
    ],
    [
        [-34.728790, -54.977879],
        [-34.705230, -54.981541],
        [-34.700673, -54.997084],
        [-34.745513, -54.997410],
        [-34.728790, -54.977879]
    ],
    [
        [-41.755157, -53.560561],
        [-41.723134, -53.578546],
        [-41.733713, -53.594415],
        [-41.755320, -53.589532],
        [-41.755157, -53.560561]
    ],
    [
        [-42.111724, -53.458429],
        [-42.078928, -53.475112],
        [-42.079579, -53.494806],
        [-42.113026, -53.487400],
        [-42.111724, -53.458429]
    ],
    [
        [166.637218, -47.993585],
        [166.618826, -47.997979],
        [166.568370, -48.041925],
        [166.637218, -48.062433],
        [166.637218, -47.993585]
    ],
    [
        [167.418712, -47.232599],
        [167.426768, -47.244561],
        [167.486990, -47.218927],
        [167.454275, -47.207452],
        [167.418712, -47.232599]
    ],
    [
        [167.709239, -46.784112],
        [167.693370, -46.757257],
        [167.662852, -46.778497],
        [167.682628, -46.795099],
        [167.709239, -46.784112]
    ],
    [
        [168.590017, -46.732354],
        [168.542166, -46.759698],
        [168.563243, -46.801202],
        [168.605724, -46.754571],
        [168.590017, -46.732354]
    ],
    [
        [168.199474, -47.047621],
        [167.966645, -46.972589],
        [168.179210, -46.864435],
        [167.787446, -46.697198],
        [167.814220, -46.911228],
        [167.521007, -47.273045],
        [168.199474, -47.047621]
    ],
    [
        [166.711436, -45.616306],
        [166.566661, -45.637140],
        [166.506196, -45.724867],
        [166.739268, -45.727960],
        [166.711436, -45.616306]
    ],
    [
        [166.973643, -45.163263],
        [166.893321, -45.243422],
        [167.034434, -45.300470],
        [166.997081, -45.233168],
        [166.973643, -45.163263]
    ],
    [
        [174.380870, -41.106378],
        [174.351248, -41.175470],
        [174.380870, -41.195082],
        [174.380870, -41.106378]
    ],
    [
        [173.784434, -40.907159],
        [173.921641, -40.866795],
        [173.964854, -40.708754],
        [173.832286, -40.757582],
        [173.784434, -40.907159]
    ],
    [
        [172.748694, -43.279694],
        [173.287283, -42.953871],
        [174.215180, -41.856703],
        [174.292166, -41.730157],
        [174.050629, -41.436944],
        [174.325694, -41.216241],
        [174.216482, -41.188897],
        [174.326427, -41.009373],
        [173.998546, -40.968845],
        [173.896332, -41.191664],
        [174.133962, -41.175388],
        [173.774262, -41.283949],
        [173.955740, -41.058689],
        [173.780528, -41.011407],
        [173.917979, -41.001886],
        [173.992035, -40.899998],
        [173.103852, -41.307794],
        [173.017345, -40.797296],
        [172.856456, -40.843683],
        [172.660411, -40.647719],
        [172.996837, -40.524184],
        [172.839610, -40.502130],
        [172.106781, -40.886895],
        [172.070811, -41.414239],
        [171.855235, -41.665460],
        [171.468110, -41.766290],
        [171.225413, -42.450689],
        [170.858409, -42.843357],
        [169.717784, -43.573663],
        [168.803722, -43.997247],
        [168.370860, -44.039158],
        [167.836436, -44.505304],
        [167.932628, -44.697035],
        [167.751964, -44.603204],
        [167.568126, -44.882013],
        [167.457693, -44.789321],
        [167.514171, -44.992608],
        [167.385753, -44.842380],
        [167.198985, -44.964044],
        [167.335704, -45.037205],
        [167.151541, -45.007582],
        [167.274669, -45.094415],
        [167.054942, -45.101739],
        [167.170746, -45.184747],
        [167.012055, -45.132908],
        [167.308849, -45.313409],
        [167.047537, -45.327081],
        [167.200206, -45.445977],
        [167.205740, -45.478611],
        [166.825531, -45.317153],
        [166.952485, -45.436944],
        [166.767589, -45.409601],
        [166.714610, -45.575616],
        [167.054942, -45.491632],
        [166.774262, -45.718845],
        [166.489757, -45.807550],
        [166.474783, -45.996026],
        [166.743907, -45.860935],
        [166.616059, -46.088067],
        [166.952485, -45.944024],
        [166.671235, -46.153578],
        [166.761974, -46.219985],
        [167.590017, -46.159601],
        [167.838634, -46.393243],
        [168.368907, -46.416925],
        [168.267833, -46.526300],
        [168.378103, -46.619806],
        [169.704112, -46.549005],
        [170.333751, -45.981541],
        [170.556814, -45.896254],
        [170.759288, -45.776788],
        [170.626720, -45.706313],
        [171.203136, -44.905532],
        [171.173839, -44.546970],
        [171.346002, -44.278631],
        [172.417328, -43.737481],
        [172.647716, -43.782647],
        [172.422618, -43.854587],
        [172.965587, -43.905450],
        [172.948578, -43.751153],
        [173.092947, -43.854181],
        [173.064952, -43.648126],
        [172.681407, -43.639337],
        [172.832286, -43.601658],
        [172.748694, -43.279694]
    ],
    [
        [175.168630, -36.741143],
        [175.018321, -36.761489],
        [175.011729, -36.802667],
        [175.182628, -36.824965],
        [175.168630, -36.741143]
    ],
    [
        [175.847667, -36.625095],
        [175.799164, -36.569757],
        [175.771983, -36.576593],
        [175.797537, -36.621759],
        [175.847667, -36.625095]
    ],
    [
        [174.853282, -36.391697],
        [174.845470, -36.448500],
        [174.906016, -36.449151],
        [174.895518, -36.401544],
        [174.853282, -36.391697]
    ],
    [
        [175.134532, -36.175958],
        [175.080821, -36.205662],
        [175.100352, -36.227797],
        [175.154959, -36.213556],
        [175.134532, -36.175958]
    ],
    [
        [175.538422, -36.282403],
        [175.530610, -36.176365],
        [175.375499, -36.065851],
        [175.333751, -36.223728],
        [175.538422, -36.282403]
    ],
    [
        [172.145995, -34.144658],
        [172.144776, -34.169046],
        [172.114697, -34.146487],
        [172.138882, -34.149129],
        [172.145995, -34.144658]
    ],
    [
        [176.953712, -39.607513],
        [177.118907, -39.667250],
        [176.861827, -40.140720],
        [175.966807, -41.247003],
        [175.237478, -41.620294],
        [175.181814, -41.417901],
        [174.865571, -41.419529],
        [174.889659, -41.224542],
        [174.609386, -41.291925],
        [175.141287, -40.674412],
        [175.183767, -40.134454],
        [173.759288, -39.301365],
        [174.594005, -38.818617],
        [174.709809, -38.104750],
        [174.846690, -38.153741],
        [174.942638, -38.097345],
        [174.792003, -38.084731],
        [174.791840, -37.872003],
        [174.977061, -37.749933],
        [174.850352, -37.764907],
        [174.717784, -37.411879],
        [174.837901, -37.299005],
        [174.706391, -37.347833],
        [174.558279, -37.062758],
        [174.740001, -37.244399],
        [174.948416, -37.101739],
        [174.832774, -36.942804],
        [174.500336, -37.032159],
        [174.182302, -36.453220],
        [174.431407, -36.665623],
        [174.465994, -36.373224],
        [174.331228, -36.392511],
        [174.271007, -36.337660],
        [174.524913, -36.241469],
        [174.075206, -36.168064],
        [173.900564, -35.959649],
        [173.946788, -35.916436],
        [173.907970, -35.870294],
        [173.880138, -35.959649],
        [174.202810, -36.347589],
        [174.079845, -36.399509],
        [173.407237, -35.571222],
        [173.660899, -35.312921],
        [173.369965, -35.516534],
        [173.318370, -35.302341],
        [173.092947, -35.206801],
        [173.156749, -34.945001],
        [172.702810, -34.411798],
        [173.079275, -34.411716],
        [172.907481, -34.541436],
        [173.266612, -35.007745],
        [173.444102, -34.796319],
        [173.458751, -34.981215],
        [174.127940, -35.136489],
        [174.014985, -35.216974],
        [174.151134, -35.369724],
        [174.353038, -35.199395],
        [174.606781, -35.843520],
        [174.359874, -35.713311],
        [174.352712, -35.841974],
        [174.503754, -35.830011],
        [174.880544, -36.351332],
        [174.716645, -36.411554],
        [174.856944, -36.610935],
        [174.723481, -36.631280],
        [174.819102, -36.823663],
        [174.703624, -36.758477],
        [174.621104, -36.796319],
        [174.680186, -36.907403],
        [175.240977, -36.942315],
        [175.367198, -37.207208],
        [175.609548, -37.251560],
        [175.354259, -36.490981],
        [175.532237, -36.507745],
        [175.628103, -36.763849],
        [175.851736, -36.718357],
        [175.713552, -36.875177],
        [175.850759, -36.840997],
        [175.975434, -37.469903],
        [176.169119, -37.624933],
        [175.943126, -37.521905],
        [175.997244, -37.631768],
        [177.131033, -38.021661],
        [177.556814, -37.913832],
        [177.992035, -37.543064],
        [178.550548, -37.680597],
        [178.348318, -38.012628],
        [178.300141, -38.531671],
        [177.932384, -38.702407],
        [177.911957, -39.255955],
        [177.852061, -39.089288],
        [177.413259, -39.059015],
        [176.937511, -39.348728],
        [176.953712, -39.607513]
    ],
    [
        [155.169932, -22.202732],
        [155.168956, -22.201186],
        [155.170502, -22.200291],
        [155.169932, -22.202732]
    ],
    [
        [155.458995, -22.175877],
        [155.460785, -22.173435],
        [155.462413, -22.175307],
        [155.459890, -22.176609],
        [155.458995, -22.175877]
    ],
    [
        [153.552501, -21.911147],
        [153.551606, -21.911147],
        [153.552501, -21.909194],
        [153.552501, -21.911147]
    ],
    [
        [153.556163, -21.910414],
        [153.556733, -21.908868],
        [153.557058, -21.910577],
        [153.556163, -21.910414]
    ],
    [
        [153.506684, -21.891209],
        [153.507660, -21.890558],
        [153.508637, -21.891860],
        [153.507660, -21.891860],
        [153.506684, -21.891209]
    ],
    [
        [153.641775, -21.858738],
        [153.642426, -21.857192],
        [153.642751, -21.858657],
        [153.641775, -21.858738]
    ],
    [
        [153.761078, -21.636244],
        [153.762299, -21.634617],
        [153.762706, -21.636489],
        [153.761078, -21.636244]
    ],
    [
        [39.693940, -21.499444],
        [39.693940, -21.495212],
        [39.697358, -21.497979],
        [39.693940, -21.499444]
    ],
    [
        [39.733816, -21.448337],
        [39.734548, -21.446059],
        [39.736176, -21.448175],
        [39.733816, -21.448337]
    ],
    [
        [39.728282, -21.444594],
        [39.729096, -21.441908],
        [39.731130, -21.444187],
        [39.728282, -21.444594]
    ],
    [
        [155.730642, -21.284845],
        [155.730642, -21.283298],
        [155.732758, -21.284356],
        [155.730968, -21.285740],
        [155.730642, -21.284845]
    ],
    [
        [155.797944, -21.273370],
        [155.799083, -21.270603],
        [155.801036, -21.272312],
        [155.799490, -21.273289],
        [155.797944, -21.273370]
    ],
    [
        [148.516287, -17.866062],
        [148.516938, -17.867608],
        [148.515717, -17.868178],
        [148.514171, -17.866225],
        [148.516287, -17.866062]
    ],
    [
        [148.440684, -17.735935],
        [148.439464, -17.734063],
        [148.443370, -17.732110],
        [148.440684, -17.735935]
    ],
    [
        [148.429128, -17.656020],
        [148.430431, -17.654229],
        [148.431570, -17.655369],
        [148.430756, -17.656264],
        [148.429128, -17.656020]
    ],
    [
        [149.920095, -16.963474],
        [149.920828, -16.965020],
        [149.919607, -16.965590],
        [149.917979, -16.963637],
        [149.920095, -16.963474]
    ],
    [
        [149.999848, -16.936130],
        [149.999522, -16.939467],
        [149.996267, -16.936700],
        [149.999848, -16.936130]
    ],
    [
        [147.882009, -16.480076],
        [147.882660, -16.481622],
        [147.881440, -16.482273],
        [147.879893, -16.480239],
        [147.882009, -16.480076]
    ],
    [
        [150.000824, -16.230808],
        [149.999848, -16.232110],
        [149.998627, -16.230483],
        [149.999848, -16.230401],
        [150.000824, -16.230808]
    ],
    [
        [150.009044, -16.134373],
        [150.007335, -16.136733],
        [149.998302, -16.135268],
        [150.000987, -16.134373],
        [150.009044, -16.134373]
    ],
    [
        [149.991710, -16.133884],
        [149.991710, -16.132989],
        [149.996755, -16.133884],
        [149.991710, -16.133884]
    ],
    [
        [-173.733388, -15.939711],
        [-173.715240, -15.932061],
        [-173.756866, -15.976576],
        [-173.764719, -15.958591],
        [-173.733388, -15.939711]
    ],
    [
        [54.514496, -15.889581],
        [54.520925, -15.885186],
        [54.521332, -15.894057],
        [54.514496, -15.889581]
    ],
    [
        [-177.981597, -14.343927],
        [-178.024200, -14.378595],
        [-178.067698, -14.360610],
        [-178.025543, -14.330662],
        [-177.981597, -14.343927]
    ],
    [
        [123.597016, -12.428318],
        [123.597748, -12.438572],
        [123.575613, -12.436782],
        [123.575043, -12.426609],
        [123.597016, -12.428318]
    ],
    [
        [47.287934, -11.565525],
        [47.299571, -11.550632],
        [47.306407, -11.569920],
        [47.287934, -11.565525]
    ],
    [
        [55.362700, -4.659323],
        [55.361970, -4.663699],
        [55.372911, -4.667893],
        [55.373822, -4.666434],
        [55.362700, -4.659323]
    ],
    [
        [55.398986, -4.668622],
        [55.397527, -4.673363],
        [55.405368, -4.679927],
        [55.406826, -4.675004],
        [55.398986, -4.668622]
    ],
    [
        [55.501589, -4.628853],
        [55.504069, -4.629729],
        [55.505820, -4.639648],
        [55.491962, -4.634251],
        [55.501589, -4.628853]
    ],
    [
        [55.504215, -4.621414],
        [55.505090, -4.626228],
        [55.511071, -4.629583],
        [55.511509, -4.624769],
        [55.504215, -4.621414]
    ],
    [
        [55.497943, -4.600846],
        [55.496776, -4.614704],
        [55.514426, -4.600554],
        [55.503778, -4.598366],
        [55.497943, -4.600846]
    ],
    [
        [55.712087, -4.280369],
        [55.715063, -4.276841],
        [55.742951, -4.278329],
        [55.732911, -4.292459],
        [55.712087, -4.280369]
    ],
    [
        [55.663004, -4.328157],
        [55.660029, -4.330388],
        [55.660401, -4.334850],
        [55.665607, -4.334106],
        [55.663004, -4.328157]
    ],
    [
        [55.647014, -4.346749],
        [55.643668, -4.349352],
        [55.651105, -4.353442],
        [55.648873, -4.348608],
        [55.647014, -4.346749]
    ],
    [
        [55.666722, -4.209909],
        [55.659285, -4.212883],
        [55.675275, -4.212140],
        [55.670441, -4.210652],
        [55.666722, -4.209909]
    ],
    [
        [55.831823, -4.337453],
        [55.825502, -4.372035],
        [55.841491, -4.382819],
        [55.857109, -4.364970],
        [55.831823, -4.337453]
    ],
    [
        [55.868636, -4.317373],
        [55.873471, -4.332619],
        [55.884626, -4.336709],
        [55.883139, -4.328900],
        [55.868636, -4.317373]
    ],
    [
        [55.866405, -4.283163],
        [55.870124, -4.296549],
        [55.873842, -4.296178],
        [55.869752, -4.283535],
        [55.866405, -4.283163]
    ],
    [
        [55.919952, -4.334106],
        [55.918836, -4.347865],
        [55.922555, -4.349724],
        [55.924786, -4.337081],
        [55.919952, -4.334106]
    ],
    [
        [55.940074, -4.578657],
        [55.933025, -4.586210],
        [55.950144, -4.590993],
        [55.944354, -4.579916],
        [55.940074, -4.578657]
    ],
    [
        [-162.060862, 5.887193],
        [-162.073069, 5.869371],
        [-162.103627, 5.888577],
        [-162.071360, 5.890163],
        [-162.060862, 5.887193]
    ],
    [
        [-162.400177, 6.445136],
        [-162.385284, 6.445136],
        [-162.385284, 6.430243],
        [-162.400177, 6.430243],
        [-162.400177, 6.445136]
    ],
    [
        [134.709676, 8.096618],
        [134.692814, 8.075539],
        [134.701245, 8.050245],
        [134.727343, 8.082879],
        [134.709676, 8.096618]
    ],
    [
        [154.299653, 8.175116],
        [154.313324, 8.137519],
        [154.295909, 8.105943],
        [154.238455, 8.143378],
        [154.299653, 8.175116]
    ],
    [
        [-79.132576, 8.956866],
        [-79.123091, 8.951523],
        [-79.127039, 8.943307],
        [-79.132586, 8.944609],
        [-79.132576, 8.956866]
    ],
    [
        [123.991649, 10.324284],
        [124.043840, 10.324284],
        [123.933196, 10.254348],
        [123.947809, 10.306539],
        [123.991649, 10.324284]
    ],
    [
        [120.909841, 13.658922],
        [120.875499, 13.634833],
        [120.845795, 13.672105],
        [120.909841, 13.658922]
    ],
    [
        [123.663829, 13.964789],
        [123.668224, 13.939439],
        [123.603201, 13.916612],
        [123.602631, 13.959784],
        [123.663829, 13.964789]
    ],
    [
        [-24.592660, 16.624312],
        [-24.601340, 16.609845],
        [-24.575299, 16.605505],
        [-24.569512, 16.619972],
        [-24.592660, 16.624312]
    ],
    [
        [-62.345589, 16.939140],
        [-62.348260, 16.933657],
        [-62.347065, 16.931970],
        [-62.343059, 16.935063],
        [-62.345589, 16.939140]
    ],
    [
        [-24.773500, 16.802259],
        [-24.740225, 16.734263],
        [-24.685250, 16.742944],
        [-24.683803, 16.755964],
        [-24.773500, 16.802259]
    ],
    [
        [-62.958205, 18.289422],
        [-62.956699, 18.274365],
        [-62.925682, 18.289723],
        [-62.947665, 18.297251],
        [-62.958205, 18.289422]
    ],
    [
        [-63.252031, 18.272970],
        [-63.262631, 18.282028],
        [-63.236035, 18.282992],
        [-63.252031, 18.272970]
    ],
    [
        [-63.184504, 18.268047],
        [-63.192213, 18.268818],
        [-63.190093, 18.269204],
        [-63.184504, 18.268047]
    ],
    [
        [-63.174290, 18.264578],
        [-63.174097, 18.262073],
        [-63.168316, 18.261880],
        [-63.169086, 18.265349],
        [-63.174290, 18.264578]
    ],
    [
        [52.004731, 24.252834],
        [52.025401, 24.245714],
        [52.007904, 24.210842],
        [51.994314, 24.219184],
        [52.004731, 24.252834]
    ],
    [
        [51.724132, 24.607408],
        [51.739513, 24.590725],
        [51.730235, 24.565212],
        [51.712820, 24.592597],
        [51.724132, 24.607408]
    ],
    [
        [53.060802, 24.893541],
        [53.079356, 24.891018],
        [53.079356, 24.853502],
        [53.063162, 24.873277],
        [53.060802, 24.893541]
    ],
    [
        [54.211111, 25.249416],
        [54.231130, 25.243476],
        [54.239838, 25.208645],
        [54.197927, 25.232001],
        [54.211111, 25.249416]
    ],
    [
        [-76.770186, 25.551304],
        [-76.758432, 25.548954],
        [-76.745895, 25.545036],
        [-76.787424, 25.541901],
        [-76.770186, 25.551304]
    ],
    [
        [-76.828954, 25.531715],
        [-76.809364, 25.529364],
        [-76.872050, 25.506641],
        [-76.857162, 25.523879],
        [-76.828954, 25.531715]
    ],
    [
        [123.606293, 25.739000],
        [123.600434, 25.739366],
        [123.602794, 25.745469],
        [123.606293, 25.739000]
    ],
    [
        [123.594249, 25.752794],
        [123.593028, 25.744371],
        [123.588634, 25.751532],
        [123.594249, 25.752794]
    ],
    [
        [123.559906, 25.756822],
        [123.558197, 25.754340],
        [123.555593, 25.757554],
        [123.559906, 25.756822]
    ],
    [
        [123.545339, 25.761786],
        [123.528901, 25.761786],
        [123.511485, 25.758083],
        [123.531423, 25.773342],
        [123.545339, 25.761786]
    ],
    [
        [123.620453, 25.774482],
        [123.620453, 25.773586],
        [123.618012, 25.774482],
        [123.620453, 25.774482]
    ],
    [
        [123.595307, 25.801907],
        [123.595470, 25.797268],
        [123.592377, 25.797431],
        [123.595307, 25.801907]
    ],
    [
        [55.048676, 25.885769],
        [55.054373, 25.864610],
        [55.018403, 25.859605],
        [55.012055, 25.881619],
        [55.048676, 25.885769]
    ],
    [
        [124.568858, 25.896226],
        [124.567719, 25.894436],
        [124.565278, 25.895738],
        [124.566824, 25.898424],
        [124.568858, 25.896226]
    ],
    [
        [123.673025, 25.928697],
        [123.672048, 25.927476],
        [123.671723, 25.929755],
        [123.673025, 25.928697]
    ],
    [
        [123.675873, 25.918158],
        [123.672699, 25.926825],
        [123.679210, 25.930772],
        [123.685802, 25.922797],
        [123.675873, 25.918158]
    ],
    [
        [50.397704, 26.174732],
        [50.419172, 26.166144],
        [50.423466, 26.119988],
        [50.385897, 26.123208],
        [50.397704, 26.174732]
    ],
    [
        [50.601650, 26.278852],
        [50.612384, 26.241283],
        [50.678935, 26.208007],
        [50.655320, 26.276705],
        [50.601650, 26.278852]
    ],
    [
        [-64.815454, 32.288774],
        [-64.799951, 32.283347],
        [-64.832508, 32.287223],
        [-64.829407, 32.289161],
        [-64.815454, 32.288774]
    ],
    [
        [50.774310, 25.721648],
        [50.800890, 25.731140],
        [50.756591, 25.579891],
        [50.741403, 25.674185],
        [50.774310, 25.721648]
    ],
    [
        [50.775576, 25.752657],
        [50.780639, 25.745063],
        [50.791397, 25.748860],
        [50.790132, 25.755188],
        [50.775576, 25.752657]
    ],
    [
        [50.804687, 25.679247],
        [50.808484, 25.664059],
        [50.816711, 25.669122],
        [50.819875, 25.678614],
        [50.804687, 25.679247]
    ],
    [
        [50.793296, 25.652035],
        [50.790764, 25.630518],
        [50.811648, 25.631784],
        [50.816711, 25.644441],
        [50.793296, 25.652035]
    ],
    [
        [146.092133, 43.448147],
        [146.080740, 43.416164],
        [146.026459, 43.410753],
        [146.080903, 43.431098],
        [146.092133, 43.448147]
    ],
    [
        [145.934744, 43.439602],
        [145.896007, 43.417344],
        [145.865001, 43.456163],
        [145.938162, 43.455349],
        [145.934744, 43.439602]
    ],
    [
        [146.352387, 43.638170],
        [146.344574, 43.619086],
        [146.269705, 43.628160],
        [146.317719, 43.650580],
        [146.352387, 43.638170]
    ],
    [
        [-4.810374, 54.059760],
        [-4.812205, 54.040432],
        [-4.830596, 54.049628],
        [-4.827789, 54.054755],
        [-4.810374, 54.059760]
    ],
    [
        [-136.211942, 69.179309],
        [-136.066838, 69.128530],
        [-136.006267, 69.090281],
        [-136.221910, 69.105685],
        [-136.211942, 69.179309]
    ],
    [
        [-80.146578, 69.400506],
        [-80.124264, 69.393332],
        [-80.146578, 69.400506]
    ],
    [
        [-81.643279, 69.414378],
        [-81.485631, 69.347180],
        [-81.902723, 69.394146],
        [-81.838869, 69.433788],
        [-81.643279, 69.414378]
    ],
    [
        [-135.705953, 69.508751],
        [-135.595243, 69.448424],
        [-135.840928, 69.481380],
        [-135.841092, 69.495736],
        [-135.705953, 69.508751]
    ],
    [
        [161.893767, 69.653838],
        [161.866936, 69.554554],
        [161.665617, 69.620548],
        [161.667244, 69.636683],
        [161.893767, 69.653838]
    ],
    [
        [170.124871, 69.773378],
        [170.124871, 69.773378]
    ],
    [
        [-82.506235, 69.790626],
        [-82.558868, 69.743349],
        [-82.854681, 69.794354],
        [-82.647722, 69.826096],
        [-82.506235, 69.790626]
    ],
    [
        [83.305109, 70.805515],
        [83.469408, 70.737735],
        [83.304760, 70.644604],
        [83.309572, 70.443100],
        [83.065271, 70.365329],
        [83.305109, 70.805515]
    ],
    [
        [97.645681, 76.756212],
        [97.459809, 76.718451],
        [97.639008, 76.773098],
        [97.645681, 76.756212]
    ],
    [
        [89.047128, 77.140895],
        [88.919571, 76.977101],
        [88.663875, 77.080351],
        [88.785649, 77.123572],
        [89.047128, 77.140895]
    ],
    [
        [-66.775624, 80.598578],
        [-66.912913, 80.619045],
        [-66.982737, 80.671576],
        [-66.587961, 80.619818],
        [-66.775624, 80.598578]
    ],
    [
        [-0.004789, -0.004390],
        [-0.004789, 0.004817],
        [0.004328, 0.004817],
        [0.004328, -0.004390],
        [-0.004789, -0.004390]
    ]
];
